webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.app = undefined;

__webpack_require__(249);

__webpack_require__(171);

__webpack_require__(250);

__webpack_require__(251);

__webpack_require__(252);

__webpack_require__(253);

__webpack_require__(172);

__webpack_require__(173);

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

__webpack_require__(123);

__webpack_require__(254);

__webpack_require__(255);

__webpack_require__(947);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var app = exports.app = angular.module('app', [__webpack_require__(256), __webpack_require__(257), __webpack_require__(258), __webpack_require__(259).default, __webpack_require__(970), __webpack_require__(972), __webpack_require__(123), __webpack_require__(287), __webpack_require__(974), __webpack_require__(975), __webpack_require__(977), __webpack_require__(52)]);

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SmartTable = exports.SmartTable = function () {
    function SmartTable() {
        _classCallCheck(this, SmartTable);

        this.displayedItems = [];
    }

    _createClass(SmartTable, [{
        key: "selectedItems",
        get: function get() {
            return this.displayedItems.filter(function (item) {
                return item.isSelected;
            });
        }
    }, {
        key: "selectedIds",
        get: function get() {
            return this.selectedItems.map(function (item) {
                return item.id;
            });
        }
    }]);

    return SmartTable;
}();

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SpAlert =

/**
 * @param {('success'|'info'|'warning'|'danger')} type
 * @param {string} key - A translation key
 * @param {object} variables - key-value pairs for variable replacement
 *     {@link https://angular-translate.github.io/docs/#/guide/06_variable-replacement}
 * @param {boolean} [autoDismiss=true] - Dismiss after some timeout. Default true.
 *
 * @example
 * // Most common usage. Translate and display an auto-dismissed message
 * new SpAlert('success', 'global.messages.success')
 *
 * @example
 * // Disable auto-dismiss
 * new SpAlert('warning', 'global.messages.warning', {}, false)
 *
 * @example
 * // If translation key contains interpolated variables, pass an object as second parameter
 * new SpAlert('info', 'global.messages.info', {user: 'John'})
 */
exports.SpAlert = function SpAlert(type, key) {
    var variables = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var autoDismiss = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    _classCallCheck(this, SpAlert);

    this.type = type;
    this.key = key;
    this.variables = variables;
    this.autoDismiss = autoDismiss;
};

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ua = exports.os = exports.engine = exports.device = exports.cpu = exports.browser = undefined;

var _uaParserJs = __webpack_require__(182);

var parser = new _uaParserJs.UAParser();
var result = parser.getResult();

var browser = result.browser,
    cpu = result.cpu,
    device = result.device,
    engine = result.engine,
    os = result.os;
exports.browser = browser;
exports.cpu = cpu;
exports.device = device;
exports.engine = engine;
exports.os = os;
var ua = exports.ua = {
    isChrome: function isChrome() {
        return isBrowser('Chrome', 'Chrome WebView', 'Chromium');
    },
    isFirefox: function isFirefox() {
        return isBrowser('Mozilla', 'Firefox');
    },
    isOpera: function isOpera() {
        return isBrowser('Opera', 'Opera Mini', 'Opera Mobi', 'Opera Tablet');
    },
    isSafari: function isSafari() {
        return isBrowser('Safari', 'Mobile Safari');
    },
    isIE: function isIE() {
        return isBrowser('IE', 'IEMobile');
    },
    isEdge: function isEdge() {
        return isBrowser('Edge');
    },
    isMacOS: function isMacOS() {
        return isOs('Mac OS');
    },
    isAndroid: function isAndroid() {
        return isOs('Android');
    },
    isIOS: function isIOS() {
        return isOs('iOS');
    }
};

function isBrowser() {
    for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
        names[_key] = arguments[_key];
    }

    return names.includes(browser.name);
}

function isOs() {
    for (var _len2 = arguments.length, names = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        names[_key2] = arguments[_key2];
    }

    return names.includes(os.name);
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Captcha = exports.Captcha = function () {
    function Captcha() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$isVisible = _ref.isVisible,
            isVisible = _ref$isVisible === undefined ? tooManyLoginFailures : _ref$isVisible;

        _classCallCheck(this, Captcha);

        this.response = undefined;
        this.widget = undefined;
        this.isVisible = isVisible;
    }

    _createClass(Captcha, [{
        key: 'reset',
        value: function reset() {
            this.widget && this.widget.reset();
            this.response = undefined;
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return !this.isVisible() || !!this.response;
        }
    }]);

    return Captcha;
}();

function tooManyLoginFailures() {
    return localStorage.getItem('loginAttempts') >= window.env.captcha.maxFailedAttempts;
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// store frequently used values resolved from states,
// for easy access from child components & modals
var resolve = exports.resolve = {
    companyId: null,
    credentials$: null,
    currentCompany: null
};

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Module = undefined;

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Module = exports.Module = angular.module('reverse-ajax', []);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SESSION_ID = undefined;

var _v = __webpack_require__(190);

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SESSION_ID = exports.SESSION_ID = (0, _v2.default)();

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.accountFromDto = accountFromDto;
function accountFromDto(accountDto) {
    var companyUserDto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var accountType = accountDto.accountType;
    var isAD = accountType === 'AD';
    var isSimpleUsername = accountType === 'SIMPLE_USERNAME';
    var isInternalEmail = accountType === 'INTERNAL_EMAIL';
    var isExternalEmail = accountType === 'EXTERNAL_EMAIL';
    var isPhoneNumber = accountType === 'PHONENUMBER';
    var isSharedEmail = accountType === 'SHARED_EMAIL';
    var isActive = accountDto.status === 'ACTIVE';
    var isBlocked = companyUserDto.blocked !== 'NONE';
    var isEndUser = companyUserDto.roleType === 'END_USER';
    var isAdmin = accountDto.isAdmin || accountDto.username === companyUserDto.userIdentifyingName;

    return _extends({}, accountDto, {
        isDeletable: !isAD && (isEndUser || !isAdmin),
        isDisownable: isActive && !isBlocked && (isAD || isSharedEmail || isSimpleUsername || isInternalEmail && (isEndUser || !isAdmin)),
        isVerifyable: !isExternalEmail && !isPhoneNumber,
        isCopyable: isInternalEmail || isSimpleUsername || isSharedEmail || isAD,
        isAdmin: isAdmin
    });
}

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module = __webpack_require__(21);

// recursively import all scripts and styles
var context = __webpack_require__(95);
context.keys().forEach(context);

module.exports = _module.Module.name;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$sce'];

    /** @ngInject */
    function Controller($sce) {
        _classCallCheck(this, Controller);

        this.$sce = $sce;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            // this.isMacOS = ua.isMacOS();
            // Proximity removed by Faking the user agent check
            this.isMacOS = false;
            // this.setBluetoothUrl();
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {
            // this.setBluetoothUrl();
        }
    }, {
        key: 'setBluetoothUrl',
        value: function setBluetoothUrl() {
            if (this.bluetoothCode && this.isMacOS) {
                var bluetoothUrl = 'saaspass://bluepass?' + this.bluetoothCode;
                this.bluetoothUrl = this.$sce.trustAsResourceUrl(bluetoothUrl);
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.qrEncode = qrEncode;

var _qrImage = __webpack_require__(183);

var qrImage = _interopRequireWildcard(_qrImage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function qrEncode(text) {
    var options = { ec_level: 'L', size: 4, margin: 5 };
    var buffer = qrImage.imageSync(text, options);
    var base64 = buffer.toString('base64');
    return 'data:image/png;base64,' + base64;
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _qrEncode = __webpack_require__(54);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', 'WebSocket'];

    /** @ngInject */
    function Controller($scope, WebSocket) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.WebSocket = WebSocket;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loadQrImage();
            this.WebSocket.connect();
            this.$scope.$on('websocket.disconnected', function () {
                _this.$scope.$on('websocket.connected', function () {
                    return _this.loadQrImage();
                });
            });
        }
    }, {
        key: 'reConnect',
        value: function reConnect() {
            this.WebSocket.connect();
        }
    }, {
        key: 'loadQrImage',
        value: function loadQrImage() {
            var _this2 = this;

            this.isLoading = true;
            this.loadQrData().then(function (data) {
                if (_this2.encoded) {
                    _this2.qrImage = 'data:image/png;base64,' + data;
                } else {
                    _this2.qrImage = (0, _qrEncode.qrEncode)(data);
                }
            }).finally(function () {
                return _this2.isLoading = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getDirectoryTypeName = getDirectoryTypeName;
exports.toDirectoryDTO = toDirectoryDTO;
exports.getDirectoryStatusTextKey = getDirectoryStatusTextKey;
function getDirectoryTypeName(directoryType) {
    return directoryType === 'AD' ? 'Active Directory' : directoryType === 'AZURE' ? 'Azure AD' : directoryType === 'LDAP' ? 'LDAP Directory' : directoryType === 'SCIM' ? 'SCIM Directory' : 'Directory';
}

function toDirectoryDTO(directory) {
    return _extends({}, directory, {
        typeNameShort: directory.type === 'AZURE' ? 'AZURE AD' : directory.type === 'SCIM' && directory.inUseForAppProvisioning ? 'SCIM (App Prov)' : directory.type,
        typeName: directory.type === 'SCIM' && directory.inUseForAppProvisioning ? 'SCIM (App Provisioning)' : getDirectoryTypeName(directory.type),
        isAD: directory.type === 'AD',
        isLDAP: directory.type === 'LDAP',
        isAzure: directory.type === 'AZURE',
        isSCIM: directory.type === 'SCIM'
    });
}

function getDirectoryStatusTextKey(ongoingOperation) {
    var statusKey = ongoingOperation;
    if (!ongoingOperation) {
        statusKey = 'company.directory-integration.manage.ongoing-operation.none';
    } else if (ongoingOperation == 'SYNC') {
        statusKey = 'company.directory-integration.manage.ongoing-operation.sync';
    } else if (ongoingOperation == 'PROV') {
        statusKey = 'company.directory-integration.manage.ongoing-operation.prov';
    }
    return statusKey;
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var roleTypes = exports.roleTypes = ['SUPER_ADMIN', 'DEVELOPER_ADMIN', 'APPLICATION_ADMIN', 'ORGANIZATION_ADMIN', 'READ_ONLY_ADMIN', 'SHARING_CENTER_ADMIN'];

var roleTypeLabel = exports.roleTypeLabel = function roleTypeLabel(roleType) {
    return {
        APPLICATION_ADMIN: 'sp-role-type.application-administrator',
        DEVELOPER_ADMIN: 'sp-role-type.developer-administrator',
        END_USER: 'sp-role-type.end-user',
        ORGANIZATION_ADMIN: 'sp-role-type.organization-admin',
        READ_ONLY_ADMIN: 'sp-role-type.read-only-admin',
        SUPER_ADMIN: 'sp-role-type.super-administrator',
        SHARING_CENTER_ADMIN: 'sp-role-type.sharing-center-admin',
        SAASPASS_ADMIN: 'SAASPASS Admin'
    }[roleType];
};

var roleTypeIconClass = exports.roleTypeIconClass = function roleTypeIconClass(roleType) {
    return {
        APPLICATION_ADMIN: 'fa-list-alt',
        DEVELOPER_ADMIN: 'fa-wrench',
        END_USER: 'fa-user-circle',
        ORGANIZATION_ADMIN: 'fa-sitemap',
        READ_ONLY_ADMIN: 'fa-eye',
        SUPER_ADMIN: 'fa-building',
        SHARING_CENTER_ADMIN: 'fa-share-alt',
        SAASPASS_ADMIN: 'fa-building'
    }[roleType];
};

var roleTypeDescription = exports.roleTypeDescription = function roleTypeDescription(roleType) {
    return {
        APPLICATION_ADMIN: 'company.roles-help.application-administrator.desc1',
        DEVELOPER_ADMIN: 'company.roles-help.developer-administrator.desc',
        ORGANIZATION_ADMIN: 'company.roles-help.organization-administrator.desc1',
        READ_ONLY_ADMIN: 'company.roles-help.read-only-administrator.desc',
        SUPER_ADMIN: 'company.roles-help.super-administrator.desc',
        SHARING_CENTER_ADMIN: 'company.roles-help.sharing-center-admin',
        SAASPASS_ADMIN: 'SAASPASS Admin'
    }[roleType];
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var appTypeId = exports.appTypeId = function appTypeId(slug) {
    return {
        'google-apps': '1',
        'custom': '2',
        'computer-login': '9',
        'slack': '48',
        'enterprise-password-manager': '78',
        'computer-protection-without-ad': '309'
    }[slug];
};

var isRadius = exports.isRadius = function isRadius(slug) {
    return ['radius', 'cisco-asa', 'check-point', 'microsoft-routing-and-remote-access-rras', 'cisco-meraki-radius', 'wi-fi-captive-portal', 'microsoft-radius-remote-desktop-gateway', 'open-vpn', 'dell-sonic-wall-radius', 'citrix-net-scaler-radius', 'v-mware-horizon-view', 'cisco-meraki-client-vpn', 'array-networks-radius', 'sophos-firewall-xg-radius'].includes(slug);
};

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var lazyLoad = exports.lazyLoad = function lazyLoad(loader) {

    var state = {
        isLoading: false,
        promise: null
    };

    var load = function load() {
        state.isLoading = true;

        return state.promise = loader().catch(function (e) {
            state.promise = null;
            throw e;
        }).finally(function () {
            return state.isLoading = false;
        });
    };

    var get = function get() {
        return state.promise || load();
    };

    var map = function map(mapper) {
        return lazyLoad(function () {
            return get().then(mapper);
        });
    };

    return {
        isLoading: function isLoading() {
            return state.isLoading;
        },
        get: get,
        map: map
    };
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.base64urlToBuffer = base64urlToBuffer;
exports.bufferToBase64url = bufferToBase64url;
exports.convertStartRegResponse = convertStartRegResponse;
exports.convertFinishRegRequest = convertFinishRegRequest;
exports.convertFinishAuthRequest = convertFinishAuthRequest;
exports.convertStartAuthResponse = convertStartAuthResponse;
function base64urlToBuffer(baseurl64String) {
	// Base64url to Base64
	var padding = "==".slice(0, (4 - baseurl64String.length % 4) % 4);
	var base64String = baseurl64String.replace(/-/g, "+").replace(/_/g, "/") + padding;

	// Base64 to binary string
	var str = atob(base64String);

	// Binary string to buffer
	var buffer = new ArrayBuffer(str.length);
	var byteView = new Uint8Array(buffer);
	for (var i = 0; i < str.length; i++) {
		byteView[i] = str.charCodeAt(i);
	}
	return buffer;
}

function bufferToBase64url(buffer) {
	// Buffer to binary string
	var byteView = new Uint8Array(buffer);
	var str = "";
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = byteView[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var charCode = _step.value;

			str += String.fromCharCode(charCode);
		}

		// Binary string to base64
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	var base64String = btoa(str);

	// Base64 to base64url
	// We assume that the base64url string is well-formed.
	var base64urlString = base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
	return base64urlString;
}

function convertStartRegResponse(response) {
	console.log(response);
	var credOpts = angular.copy(response);

	credOpts.publicKey.challenge = base64urlToBuffer(response.publicKey.challenge);
	credOpts.publicKey.user.id = base64urlToBuffer(response.publicKey.user.id);
	credOpts.publicKey.excludeCredentials = [];
	response.publicKey.excludeCredentials.forEach(function (item) {
		var itemId = base64urlToBuffer(item.id);
		var newItem = angular.copy(item);
		newItem.id = itemId;
		credOpts.publicKey.excludeCredentials.push(newItem);
	});
	return credOpts;
}

function convertFinishRegRequest(credentials, startResponse) {
	console.log(credentials);
	console.log(credentials.getClientExtensionResults());
	var credResponse = {
		authenticatorAttachment: credentials.authenticatorAttachment,
		id: credentials.id,
		rawId: bufferToBase64url(credentials.rawId),
		response: {
			attestationObject: bufferToBase64url(credentials.response.attestationObject),
			clientDataJSON: bufferToBase64url(credentials.response.clientDataJSON)
		},
		clientExtensionResults: credentials.getClientExtensionResults(), // bufferToBase64url(credentials.getClientExtensionResults()),
		type: credentials.type
	};
	console.log(credResponse);
	var finishRegRequest = { challenge: startResponse.publicKey.challenge, credentialResp: credResponse };
	return finishRegRequest;
}

function convertFinishAuthRequest(credentials, startResponse) {
	//console.log(credentials);
	//console.log(credentials.getClientExtensionResults());
	var credResponse = {
		authenticatorAttachment: credentials.authenticatorAttachment,
		id: credentials.id,
		rawId: bufferToBase64url(credentials.rawId),
		response: {
			authenticatorData: bufferToBase64url(credentials.response.authenticatorData),
			signature: bufferToBase64url(credentials.response.signature),
			clientDataJSON: bufferToBase64url(credentials.response.clientDataJSON),
			userHandle: credentials.response.userHandle
		},
		clientExtensionResults: credentials.getClientExtensionResults(),
		type: credentials.type
	};
	console.log("ready auth resp");
	console.log(credResponse);
	var finishRegRequest = { challenge: startResponse.publicKey.challenge, credentialResp: credResponse };
	console.log(finishRegRequest);
	return finishRegRequest;
}

function convertStartAuthResponse(response) {
	console.log(response);
	var credOpts = angular.copy(response);

	credOpts.publicKey.challenge = base64urlToBuffer(response.publicKey.challenge);
	if (response.publicKey.hasOwnProperty('allowCredentials')) {
		credOpts.publicKey.allowCredentials = [];
		response.publicKey.allowCredentials.forEach(function (item) {
			var itemId = base64urlToBuffer(item.id);
			var newItem = angular.copy(item);
			newItem.id = itemId;
			credOpts.publicKey.allowCredentials.push(newItem);
		});
	}
	console.log("converted test resp");
	console.log(credOpts);
	return credOpts;
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.appProtocolDisplayName = appProtocolDisplayName;
function appProtocolDisplayName(app) {
    if (app.slug == 'enterprise-password-manager') {
        return 'Enterprise Password Manager';
    } else if (app.slug == 'generic-oauth2') {
        return 'OAUTH2';
    } else if (app.slug.endsWith('proxy-sso')) {
        return 'PROXY SSO';
    } else if (app.slug == 'custom') {
        return 'SAASPASS REST API';
    } else if (app.slug == 'computer-login' || app.slug == 'computer-protection-without-ad') {
        return 'COMPUTER LOGIN';
    } else if (app.slug == 'ad-password-manager') {
        return 'AD Password Manager';
    } else if (app.oidc) {
        return 'OIDC';
    } else if (app.vpnRdp) {
        return 'VPN/RDP';
    } else if (app.saml) {
        return 'SAML';
    } else if (app.radius) {
        return 'Radius';
    } else if (app.mfaAdapter) {
        return 'MFA Adapter';
    }
}

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.groupFromDto = groupFromDto;
function groupFromDto(dto) {
    if (dto.type !== 'AD') {
        return dto;
    }

    var groupName = dto.groupName.replace(/^OU:/, '');
    var cname = dto.groupName.replace(/(^OU:|\(Everyone\)$)/g, '');
    var parentName = ((dto.adDistinguishedName || '').split('OU=')[1] || '').split(',')[0];

    var isEveryone = dto.groupName.endsWith('(Everyone)');
    var isOu = dto.groupName.startsWith('OU:');
    var type = !isEveryone ? 'AD_GROUP' : isOu ? 'AD_OU' : 'AD_DOMAIN';

    return _extends({}, dto, { groupName: groupName, cname: cname, parentName: parentName, type: type });
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.passwordGrade = passwordGrade;
var passMustHave = exports.passMustHave = [/[0-9]/, /[a-z]/, /[A-Z]/];

function passwordGrade(password) {
	var pass = password;
	if (!pass) {
		return -1;
	} else {

		if (pass.length < 4) {
			return 0;
		}
		var s = 0;
		for (var i in passMustHave) {
			if (passMustHave[i].test(pass)) s++;
		}
		if (pass.length >= 12) {
			s++;
		}
		return s;
	}
}

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


{}module.exports = (typeof window === 'undefined' ? {} : window).env = {
    captcha: {
        key: '6LcIvgETAAAAAIMCwRem9WxT0UvUPk_3209UrzDJ',
        maxFailedAttempts: 50
    },
    extensionIds: {
        chrome: 'nhhldecdfagpbfggphklkaeiocfnaafm',
        opera: 'jnlcnnodlcecoagnkiplcbmpnemcibnj'
    },
    facebookAppId: '565837326835543',
    publicPath: 'https://storage.googleapis.com/fesetlockone/',
    urls: {
        customAppWidgetIframePrefix: 'https://www.setlockone.com/sd/',
        premiumIconPrefix: 'https://www.setlockone.com/',
        samlAppLogo: function samlAppLogo(slug) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'logo';
            return 'https://www.setlockone.com/apps/' + slug + '/images/' + type + '.png';
        },
        m365ps1: 'https://cdn.saaspass.com/releases/v3/ms365/saaspass_m365_federation.ps1',
        m365txt: 'https://cdn.saaspass.com/releases/v3/ms365/saaspass_m365_federation.txt'
    },
    websocket: {
        url: 'wss://www.setlockone.com/ws',
        username: 'd16b8f79-c6a0-4538-915c-3202bc0e3f66',
        password: 'f2734acc-a0a1-4f32-b265-e1828887197d',
        virtualHost: '/wsmq'
    }
};

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./index.js": 52,
	"./module.js": 21,
	"./sp-proximity/sp-proximity.component.js": 96,
	"./sp-proximity/sp-proximity.controller.js": 53,
	"./sp-proximity/sp-proximity.scss": 98,
	"./sp-qr/qr-encode.js": 54,
	"./sp-qr/sp-qr.component.js": 100,
	"./sp-qr/sp-qr.controller.js": 55,
	"./sp-qr/sp-qr.scss": 102,
	"./web-socket.service.js": 103
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module = __webpack_require__(21);

var _spProximity = __webpack_require__(53);

_module.Module.component('spProximity', {
    bindings: { bluetoothCode: '<' },
    controller: _spProximity.Controller,
    templateUrl: __webpack_require__(97)
});

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "329d0f7b5451e024001f973792edb650.html";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module = __webpack_require__(21);

var _spQr = __webpack_require__(55);

_module.Module.component('spQr', {
    bindings: {
        encoded: '<',
        loadQrData: '&'
    },
    controller: _spQr.Controller,
    templateUrl: __webpack_require__(101)
});

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e4b90f5e58d5c6ce5bb37d4494de4fca.html";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stomp = __webpack_require__(189);

var _sessionId = __webpack_require__(22);

var _module = __webpack_require__(21);

WebSocket.$inject = ['$rootScope'];


_module.Module.service('WebSocket', WebSocket);

/** @ngInject */
function WebSocket($rootScope) {
    var _window$env$websocket = window.env.websocket,
        url = _window$env$websocket.url,
        virtualHost = _window$env$websocket.virtualHost,
        username = _window$env$websocket.username,
        password = _window$env$websocket.password;

    var lastUsedAt = null;
    var client = null;
    var connecting = false;

    return {
        connect: connect,
        isConnected: isConnected,
        isConnecting: isConnecting
    };

    function connect() {
        lastUsedAt = new Date();

        if (isConnected() || isConnecting()) {
            return;
        }

        client = _stomp.Stomp.client(url);
        client.debug = null;
        connecting = true;
        client.connect(username, password, onConnect, onError, virtualHost);
    }

    function isConnected() {
        return client ? client.connected : false;
    }

    function isConnecting() {
        return connecting;
    }

    function onConnect(frame) {
        connecting = false;
        client.subscribe('/exchange/websocket-exchange/' + _sessionId.SESSION_ID, onReceive);
        $rootScope.$apply(function () {
            return $rootScope.$broadcast('websocket.connected');
        });
    }

    function onError(frame) {
        connecting = false;
        console.error(frame);
        $rootScope.$apply(function () {
            return $rootScope.$broadcast('websocket.disconnected');
        });
    }

    function onReceive(frame) {
        var _JSON$parse = JSON.parse(frame.body),
            type = _JSON$parse.type,
            content = _JSON$parse.content;

        $rootScope.$apply(function () {
            return $rootScope.$broadcast('websocket.' + type, content);
        });
    }
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var userFromDto = exports.userFromDto = function userFromDto(dto) {
    return _extends({}, dto, {
        applicationTypeIds: dto.applicationTypeIds.map(function (id) {
            return "" + id;
        }),
        order: {
            SUPER_ADMIN: 10,
            DEVELOPER_ADMIN: 8,
            APPLICATION_ADMIN: 6,
            ORGANIZATION_ADMIN: 4,
            READ_ONLY_ADMIN: 2,
            END_USER: 0
        }[dto.roleType]
    });
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HardTokenIntegrationController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _maxTokenCount = __webpack_require__(106);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HardTokenIntegrationController = exports.HardTokenIntegrationController = function () {
    HardTokenIntegrationController.$inject = ['HardTokenService'];

    /** @ngInject */
    function HardTokenIntegrationController(HardTokenService) {
        _classCallCheck(this, HardTokenIntegrationController);

        this.HardTokenService = HardTokenService;
    }

    _createClass(HardTokenIntegrationController, [{
        key: '$onInit',
        value: function $onInit() {
            this.tokens = [{}];
            this.tokenCount = 1;
            this.editMode = 'table';
            this.saving = false;
            this.algorithm = 'SHA1';
            this.period = 30;
            this.type = null;
            this.otpType = null;
            this.maxTokenCount = _maxTokenCount.maxTokenCount;
        }
    }, {
        key: 'addTokens',
        value: function addTokens() {
            var _this = this;

            var tokens = this.tokens.map(function (token) {
                return Object.assign({}, token, {
                    type: _this.type,
                    otpType: _this.otpType,
                    algorithm: _this.algorithm,
                    period: _this.otpType === 'TOTP' ? _this.period : undefined
                });
            });

            this.saving = true;

            this.HardTokenService.add(tokens).then(function (response) {
                return _this.close({ $value: response });
            }).catch(function (rejection) {
                return _this.dismiss({ $value: 'failed' });
            }).finally(function () {
                return _this.saving = false;
            });
        }
    }, {
        key: 'countChanged',
        value: function countChanged() {
            if (this.tokenCount !== null && this.tokenCount < 1) {
                this.tokenCount = 1;
            } else if (this.tokenCount > this.maxTokenCount) {
                this.tokenCount = this.maxTokenCount;
            }
            this.tokens.length = this.tokenCount || 1;

            var newArray = function newArray(length) {
                return Array.apply(null, { length: length });
            };
            var emptyTokens = newArray(this.tokens.length).map(function (i) {
                return {};
            });
            this.tokens = Object.assign(emptyTokens, this.tokens);
        }
    }, {
        key: 'tokensChanged',
        value: function tokensChanged(tokens, valid) {
            this.tokens = tokens;
            this.tokenCount = tokens.length;
            this.valid = valid;
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return !this.tokens.length || !this.valid || this.saving || this.editMode === 'csv';
        }
    }]);

    return HardTokenIntegrationController;
}();

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var maxTokenCount = exports.maxTokenCount = 1000;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "81255f4ddc1ffefe9ff4535ef4f6a410.html";

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.groupTypeLabel = groupTypeLabel;
function groupTypeLabel(groupType) {
    return {
        AD: 'sp-group-type.ad',
        AZURE_AD: 'sp-group-type.azure-ad',
        SCIM_DIRECTORY: 'sp-group-type.scim-group',
        AD_DOMAIN: 'sp-group-type.ad-domain',
        AD_GROUP: 'sp-group-type.ad-group',
        AZURE_GROUP: 'sp-group-type.azure-group',
        AD_OU: 'sp-group-type.ad-ou',
        APPLICATION: 'sp-group-type.application',
        CUSTOM: 'sp-group-type.custom',
        DOMAIN: 'sp-group-type.domain',
        EVERYONE: 'sp-group-type.everyone',
        EXTERNAL_EMAILS: 'sp-group-type.external-emails',
        PHONE_NUMBERS: 'sp-group-type.phone-numbers',
        UNKNOWN: 'sp-group-type.unknown'
    }[groupType];
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loginPoints = exports.loginPoints = ['SAAASPASS_ON_SLACK', 'SAASPASS_CONNECTOR', 'SAASPASS_EXTENSION', 'SAASPASS_MOBILE_APP', 'SAASPASS_WEB', 'SAAASPASS_HANGOUTS'];

var loginPointLabel = exports.loginPointLabel = function loginPointLabel(loginPoint) {
    return {
        SAAASPASS_ON_SLACK: 'sp-login-point.saaaspass-on-slack',
        SAASPASS_CONNECTOR: 'sp-login-point.saaspass-connector',
        SAASPASS_EXTENSION: 'sp-login-point.saaspass-extension',
        SAASPASS_MOBILE_APP: 'sp-login-point.saaspass-mobile-app',
        SAASPASS_WEB: 'sp-login-point.saaspass-web',
        SAAASPASS_HANGOUTS: 'sp-login-point.saaaspass-hangouts'
    }[loginPoint];
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loginTypes = exports.loginTypes = ['SCAN_BARCODE', 'APP2APP_OPENINAPP', 'APP2APP_OPENINSP', 'PROXIMITY', 'MANUAL', 'REMOTE', 'AUTO_LOGIN', 'SINGLE_SIGN_ON', 'PUSH_LOGIN', 'U2F_LOGIN', 'NO_OTP_LOGIN'];

var loginTypeLabel = exports.loginTypeLabel = function loginTypeLabel(loginType) {
    return {
        APP2APP_OPENINAPP: 'sp-login-type.app2app-open-in-app',
        APP2APP_OPENINSP: 'sp-login-type.app2app-open-in-sp',
        AUTO_LOGIN: 'sp-login-type.auto-login',
        MANUAL: 'sp-login-type.manual',
        NO_OTP_LOGIN: 'sp-login-type.no-otp-login',
        PROXIMITY: 'sp-login-type.proximity',
        PUSH_LOGIN: 'sp-login-type.push-login',
        REMOTE: 'sp-login-type.remote',
        SCAN_BARCODE: 'sp-login-type.scan-barcode',
        SINGLE_SIGN_ON: 'sp-login-type.single-sign-on',
        U2F_LOGIN: 'sp-login-type.u2f-login'
    }[loginType];
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright 2014 Google Inc. All rights reserved
//
// Use of this source code is governed by a BSD-style
// license that can be found in the LICENSE file or at
// https://developers.google.com/open-source/licenses/bsd

/**
 * @fileoverview The U2F api.
 */



/** Namespace for the U2F api.
 * @type {Object}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var u2f = exports.u2f = u2f || {};

/**
 * The U2F extension id
 * @type {string}
 * @const
 */
u2f.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd';

/**
 * Message types for messsages to/from the extension
 * @const
 * @enum {string}
 */
u2f.MessageTypes = {
  'U2F_REGISTER_REQUEST': 'u2f_register_request',
  'U2F_SIGN_REQUEST': 'u2f_sign_request',
  'U2F_REGISTER_RESPONSE': 'u2f_register_response',
  'U2F_SIGN_RESPONSE': 'u2f_sign_response'
};

/**
 * Response status codes
 * @const
 * @enum {number}
 */
u2f.ErrorCodes = {
  'OK': 0,
  'OTHER_ERROR': 1,
  'BAD_REQUEST': 2,
  'CONFIGURATION_UNSUPPORTED': 3,
  'DEVICE_INELIGIBLE': 4,
  'TIMEOUT': 5
};

/**
 * A message type for registration requests
 * @typedef {{
 *   type: u2f.MessageTypes,
 *   signRequests: Array.<u2f.SignRequest>,
 *   registerRequests: ?Array.<u2f.RegisterRequest>,
 *   timeoutSeconds: ?number,
 *   requestId: ?number
 * }}
 */
u2f.Request;

/**
 * A message for registration responses
 * @typedef {{
 *   type: u2f.MessageTypes,
 *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
 *   requestId: ?number
 * }}
 */
u2f.Response;

/**
 * An error object for responses
 * @typedef {{
 *   errorCode: u2f.ErrorCodes,
 *   errorMessage: ?string
 * }}
 */
u2f.Error;

/**
 * Data object for a single sign request.
 * @typedef {{
 *   version: string,
 *   challenge: string,
 *   keyHandle: string,
 *   appId: string
 * }}
 */
u2f.SignRequest;

/**
 * Data object for a sign response.
 * @typedef {{
 *   keyHandle: string,
 *   signatureData: string,
 *   clientData: string
 * }}
 */
u2f.SignResponse;

/**
 * Data object for a registration request.
 * @typedef {{
 *   version: string,
 *   challenge: string,
 *   appId: string
 * }}
 */
u2f.RegisterRequest;

/**
 * Data object for a registration response.
 * @typedef {{
 *   registrationData: string,
 *   clientData: string
 * }}
 */
u2f.RegisterResponse;

// Low level MessagePort API support

/**
 * Sets up a MessagePort to the U2F extension using the
 * available mechanisms.
 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
 */
u2f.getMessagePort = function (callback) {
  if (typeof chrome != 'undefined' && chrome.runtime) {
    // The actual message here does not matter, but we need to get a reply
    // for the callback to run. Thus, send an empty signature request
    // in order to get a failure response.
    var msg = {
      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
      signRequests: []
    };
    chrome.runtime.sendMessage(u2f.EXTENSION_ID, msg, function () {
      if (!chrome.runtime.lastError) {
        // We are on a whitelisted origin and can talk directly
        // with the extension.
        u2f.getChromeRuntimePort_(callback);
      } else {
        // chrome.runtime was available, but we couldn't message
        // the extension directly, use iframe
        u2f.getIframePort_(callback);
      }
    });
  } else {
    // chrome.runtime was not available at all, which is normal
    // when this origin doesn't have access to any extensions.
    u2f.getIframePort_(callback);
  }
};

/**
 * Connects directly to the extension via chrome.runtime.connect
 * @param {function(u2f.WrappedChromeRuntimePort_)} callback
 * @private
 */
u2f.getChromeRuntimePort_ = function (callback) {
  var port = chrome.runtime.connect(u2f.EXTENSION_ID, { 'includeTlsChannelId': true });
  setTimeout(function () {
    callback(new u2f.WrappedChromeRuntimePort_(port));
  }, 0);
};

/**
 * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
 * @param {Port} port
 * @constructor
 * @private
 */
u2f.WrappedChromeRuntimePort_ = function (port) {
  this.port_ = port;
};

/**
 * Posts a message on the underlying channel.
 * @param {Object} message
 */
u2f.WrappedChromeRuntimePort_.prototype.postMessage = function (message) {
  this.port_.postMessage(message);
};

/**
 * Emulates the HTML 5 addEventListener interface. Works only for the
 * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
 * @param {string} eventName
 * @param {function({data: Object})} handler
 */
u2f.WrappedChromeRuntimePort_.prototype.addEventListener = function (eventName, handler) {
  var name = eventName.toLowerCase();
  if (name == 'message' || name == 'onmessage') {
    this.port_.onMessage.addListener(function (message) {
      // Emulate a minimal MessageEvent object
      handler({ 'data': message });
    });
  } else {
    console.error('WrappedChromeRuntimePort only supports onMessage');
  }
};

/**
 * Sets up an embedded trampoline iframe, sourced from the extension.
 * @param {function(MessagePort)} callback
 * @private
 */
u2f.getIframePort_ = function (callback) {
  // Create the iframe
  var iframeOrigin = 'chrome-extension://' + u2f.EXTENSION_ID;
  var iframe = document.createElement('iframe');
  iframe.src = iframeOrigin + '/u2f-comms.html';
  iframe.setAttribute('style', 'display:none');
  document.body.appendChild(iframe);

  var channel = new MessageChannel();
  var ready = function ready(message) {
    if (message.data == 'ready') {
      channel.port1.removeEventListener('message', ready);
      callback(channel.port1);
    } else {
      console.error('First event on iframe port was not "ready"');
    }
  };
  channel.port1.addEventListener('message', ready);
  channel.port1.start();

  iframe.addEventListener('load', function () {
    // Deliver the port to the iframe and initialize
    iframe.contentWindow.postMessage('init', iframeOrigin, [channel.port2]);
  });
};

// High-level JS API

/**
 * Default extension response timeout in seconds.
 * @const
 */
u2f.EXTENSION_TIMEOUT_SEC = 30;

/**
 * A singleton instance for a MessagePort to the extension.
 * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
 * @private
 */
u2f.port_ = null;

/**
 * Callbacks waiting for a port
 * @type {Array.<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
 * @private
 */
u2f.waitingForPort_ = [];

/**
 * A counter for requestIds.
 * @type {number}
 * @private
 */
u2f.reqCounter_ = 0;

/**
 * A map from requestIds to client callbacks
 * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
 *                       |function((u2f.Error|u2f.SignResponse)))>}
 * @private
 */
u2f.callbackMap_ = {};

/**
 * Creates or retrieves the MessagePort singleton to use.
 * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
 * @private
 */
u2f.getPortSingleton_ = function (callback) {
  if (u2f.port_) {
    callback(u2f.port_);
  } else {
    if (u2f.waitingForPort_.length == 0) {
      u2f.getMessagePort(function (port) {
        u2f.port_ = port;
        u2f.port_.addEventListener('message',
        /** @type {function(Event)} */u2f.responseHandler_);

        // Careful, here be async callbacks. Maybe.
        while (u2f.waitingForPort_.length) {
          u2f.waitingForPort_.shift()(u2f.port_);
        }
      });
    }
    u2f.waitingForPort_.push(callback);
  }
};

/**
 * Handles response messages from the extension.
 * @param {MessageEvent.<u2f.Response>} message
 * @private
 */
u2f.responseHandler_ = function (message) {
  var response = message.data;
  var reqId = response['requestId'];
  if (!reqId || !u2f.callbackMap_[reqId]) {
    console.error('Unknown or missing requestId in response.');
    return;
  }
  var cb = u2f.callbackMap_[reqId];
  delete u2f.callbackMap_[reqId];
  cb(response['responseData']);
};

/**
 * Dispatches an array of sign requests to available U2F tokens.
 * @param {Array.<u2f.SignRequest>} signRequests
 * @param {function((u2f.Error|u2f.SignResponse))} callback
 * @param {number=} opt_timeoutSeconds
 */
u2f.sign = function (signRequests, callback, opt_timeoutSeconds) {
  u2f.getPortSingleton_(function (port) {
    var reqId = ++u2f.reqCounter_;
    u2f.callbackMap_[reqId] = callback;
    var req = {
      type: u2f.MessageTypes.U2F_SIGN_REQUEST,
      signRequests: signRequests,
      timeoutSeconds: typeof opt_timeoutSeconds !== 'undefined' ? opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC,
      requestId: reqId
    };
    port.postMessage(req);
  });
};

/**
 * Dispatches register requests to available U2F tokens. An array of sign
 * requests identifies already registered tokens.
 * @param {Array.<u2f.RegisterRequest>} registerRequests
 * @param {Array.<u2f.SignRequest>} signRequests
 * @param {function((u2f.Error|u2f.RegisterResponse))} callback
 * @param {number=} opt_timeoutSeconds
 */
u2f.register = function (registerRequests, signRequests, callback, opt_timeoutSeconds) {
  u2f.getPortSingleton_(function (port) {
    var reqId = ++u2f.reqCounter_;
    u2f.callbackMap_[reqId] = callback;
    var req = {
      type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
      signRequests: signRequests,
      registerRequests: registerRequests,
      timeoutSeconds: typeof opt_timeoutSeconds !== 'undefined' ? opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC,
      requestId: reqId
    };
    port.postMessage(req);
  });
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var makeSelectables = exports.makeSelectables = function makeSelectables(selectedIds, allItems) {

    var allSelected = selectedIds.includes('-1');

    var selectedById = {};
    if (!allSelected) {
        selectedIds.forEach(function (id) {
            return selectedById[id] = true;
        });
    }

    return {
        all: function all() {
            return allItems;
        },

        getSelectedIds: function getSelectedIds() {
            return allSelected ? ['-1'] : Object.keys(selectedById).filter(function (id) {
                return selectedById[id];
            });
        },

        getSelectedNames: function getSelectedNames() {
            return allItems.filter(function (_ref) {
                var id = _ref.id;
                return selectedById[id];
            }).map(function (g) {
                return g.name;
            }).join(',');
        },

        isAllSelected: function isAllSelected() {
            return allSelected;
        },

        isSelected: function isSelected(id) {
            return allSelected || !!selectedById[id];
        },

        toggle: function toggle(id) {
            if (allSelected) {
                allItems.forEach(function (_ref2) {
                    var id = _ref2.id;
                    return selectedById[id] = true;
                });
                allSelected = false;
            }
            selectedById[id] = !selectedById[id];
        },

        toggleAll: function toggleAll() {
            allSelected = !allSelected;
            selectedById = {};
        }
    };
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var context = __webpack_require__(1235);

var templateUrl = exports.templateUrl = function templateUrl(appType) {
    var slug = appType.slug;
    if (appType.oidcConfigSupported && slug != 'generic-oauth2' && !slug.endsWith('proxy-sso')) {
        slug = 'generic-oidc';
    }
    var key = './' + slug + '/index.html';
    if (context.keys().includes(key)) {
        return context(key);
    }
};

var instructionsExist = exports.instructionsExist = function instructionsExist(appType) {
    return !!templateUrl(appType);
};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HardTokenAddController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _maxTokenCount = __webpack_require__(106);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HardTokenAddController = exports.HardTokenAddController = function () {
    HardTokenAddController.$inject = ['$state', 'HardTokenService', 'Alert'];

    /** @ngInject */
    function HardTokenAddController($state, HardTokenService, Alert) {
        _classCallCheck(this, HardTokenAddController);

        this.HardTokenService = HardTokenService;
        this.Alert = Alert;
        this.$state = $state;
    }

    _createClass(HardTokenAddController, [{
        key: '$onInit',
        value: function $onInit() {
            this.tokens = [{}];
            this.tokenCount = 1;
            this.editMode = 'table';
            this.saving = false;
            this.algorithm = 'SHA1';
            this.period = 30;
            this.type = null;
            this.otpType = null;
            this.maxTokenCount = _maxTokenCount.maxTokenCount;
        }
    }, {
        key: 'addTokens',
        value: function addTokens() {
            var _this = this;

            var tokens = this.tokens.map(function (token) {
                return Object.assign({}, token, {
                    type: _this.type,
                    otpType: _this.otpType,
                    algorithm: _this.algorithm,
                    period: _this.otpType === 'TOTP' ? _this.period : undefined
                });
            });

            this.saving = true;

            this.HardTokenService.add(tokens).then(function (response) {
                _this.$state.go('^', {}, { reload: '^' });
                _this.Alert('success', 'company.hard-token-management.add-tokens.success');
            }).catch(function (rejection) {
                return _this.Alert('danger', rejection.message);
            }).finally(function () {
                return _this.saving = false;
            });
        }
    }, {
        key: 'countChanged',
        value: function countChanged() {
            if (this.tokenCount !== null && this.tokenCount < 1) {
                this.tokenCount = 1;
            } else if (this.tokenCount > this.maxTokenCount) {
                this.tokenCount = this.maxTokenCount;
            }
            this.tokens.length = this.tokenCount || 1;

            var newArray = function newArray(length) {
                return Array.apply(null, { length: length });
            };
            var emptyTokens = newArray(this.tokens.length).map(function (i) {
                return {};
            });
            this.tokens = Object.assign(emptyTokens, this.tokens);
        }
    }, {
        key: 'tokensChanged',
        value: function tokensChanged(tokens, valid) {
            this.tokens = tokens;
            this.tokenCount = tokens.length;
            this.valid = valid;
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return !this.tokens.length || !this.valid || this.saving || this.editMode === 'csv';
        }
    }]);

    return HardTokenAddController;
}();

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var updates = exports.updates = [{
    id: '2026-02-04',
    date: '2026-02-04 14:30:00+00:00',
    label: 'Update - 4 February 2026'
}, {
    id: '2024-10-31',
    date: '2024-10-31 12:30 GMT',
    label: 'Update - 31 October 2024'
}, {
    id: '2023-06-14',
    date: '2023-06-14 12:30 GMT',
    label: 'Update - 14 June 2023'
}, {
    id: '2023-01-01',
    date: '2023-01-01 12:30 GMT',
    label: 'Update - 01 January 2023'
}, {
    id: '2022-09-08',
    date: '2022-09-08 12:30 GMT',
    label: 'Update - 08 September 2022'
}, {
    id: '2022-06-03',
    date: '2022-06-03 22:30 GMT',
    label: 'Update - 03 June 2022'
}, {
    id: '2021-12-07',
    date: '2021-12-07 17:30 GMT',
    label: 'Update - 07 December 2021'
}, {
    id: '2021-08-26',
    date: '2021-08-26 17:30 GMT',
    label: 'Update - 26 August 2021'
}, {
    id: '2021-07-26',
    date: '2021-07-26 17:30 GMT',
    label: 'Update - 26 July 2021'
}, {
    id: '2021-06-10',
    date: '2021-06-10 17:30 GMT',
    label: 'Update - 10 June 2021'
}, {
    id: '2020-07-18',
    date: '2020-07-18 17:30 GMT',
    label: 'Update - 18 July 2020'
},
//     id: '2020-02-14',
//     date: '2020-02-214 17:30 GMT',
//     label: 'Update - 14 February 2020',
// },
{
    id: '2019-04-04',
    date: '2019-04-04 12:30 GMT',
    label: 'Update - 4 April 2019'
}, {
    id: '2018-11-20',
    date: '2018-11-20 15:30 GMT',
    label: 'Update - 20 November 2018'
}, {
    id: '2018-07-19',
    date: '2018-07-19 13:30 GMT',
    label: 'Update - 19 July 2018'
}, {
    id: '2018-07-04',
    date: '2018-07-04 12:00 GMT',
    label: 'Update - 4 July 2018'
}, {
    id: '2018-05-31',
    date: '2018-05-31 15:00 GMT',
    label: 'Update - 31 May 2018'
}, {
    id: '2018-05-23',
    date: '2018-05-23 15:30 GMT',
    label: 'Update - 23 May 2018'
}, {
    id: '2018-04-24',
    date: '2018-03-04 14:30 GMT',
    label: 'Update - 24 April 2018'
}, {
    id: '2018-04-12',
    date: '2018-04-12 15:00 GMT',
    label: 'Update - 12 April 2018'
}, {
    id: '2018-03-04',
    date: '2018-03-04 12:30 GMT',
    label: 'Update - 4 March 2018'
}];

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 187 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var languages = exports.languages = [{ key: 'en', name: 'English' }, { key: 'es', name: 'Español' }, { key: 'de', name: 'Deutsch' }, { key: 'ja', name: '日本人' }, { key: 'fr', name: 'Français' }, { key: 'zh', name: '中文' }, { key: 'pt', name: 'Português' }];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _countries;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var countries = exports.countries = (_countries = {
	AX: 'Åland Islands',
	AF: 'Afghanistan',
	AL: 'Albania',
	DZ: 'Algeria',
	AS: 'American Samoa',
	AD: 'Andorra',
	AO: 'Angola',
	AI: 'Anguilla',
	AQ: 'Antarctica',
	AG: 'Antigua & Barbuda',
	AR: 'Argentina',
	AM: 'Armenia',
	AW: 'Aruba',
	AT: 'Ashmore & Cartier Islands',
	AU: 'Australia'
}, _defineProperty(_countries, 'AT', 'Austria'), _defineProperty(_countries, 'AZ', 'Azerbaijan'), _defineProperty(_countries, 'BS', 'Bahamas, The'), _defineProperty(_countries, 'BH', 'Bahrain'), _defineProperty(_countries, 'BD', 'Bangladesh'), _defineProperty(_countries, 'BB', 'Barbados'), _defineProperty(_countries, 'TF', 'Bassas da India'), _defineProperty(_countries, 'BY', 'Belarus'), _defineProperty(_countries, 'BE', 'Belgium'), _defineProperty(_countries, 'BZ', 'Belize'), _defineProperty(_countries, 'BJ', 'Benin'), _defineProperty(_countries, 'BM', 'Bermuda'), _defineProperty(_countries, 'BT', 'Bhutan'), _defineProperty(_countries, 'BO', 'Bolivia'), _defineProperty(_countries, 'BQ', 'Bonaire'), _defineProperty(_countries, 'BA', 'Bosnia & Herzegovina'), _defineProperty(_countries, 'BW', 'Botswana'), _defineProperty(_countries, 'BV', 'Bouvet Island'), _defineProperty(_countries, 'BR', 'Brazil'), _defineProperty(_countries, 'IO', 'British Indian Ocean Territory'), _defineProperty(_countries, 'VG', 'British Virgin Islands'), _defineProperty(_countries, 'BN', 'Brunei'), _defineProperty(_countries, 'BG', 'Bulgaria'), _defineProperty(_countries, 'BF', 'Burkina Faso'), _defineProperty(_countries, 'BI', 'Burundi'), _defineProperty(_countries, 'KH', 'Cambodia'), _defineProperty(_countries, 'CM', 'Cameroon'), _defineProperty(_countries, 'CA', 'Canada'), _defineProperty(_countries, 'CV', 'Cape Verde'), _defineProperty(_countries, 'KY', 'Cayman Islands'), _defineProperty(_countries, 'CF', 'Central African Republic'), _defineProperty(_countries, 'TD', 'Chad'), _defineProperty(_countries, 'CL', 'Chile'), _defineProperty(_countries, 'CN', 'China'), _defineProperty(_countries, 'CX', 'Christmas Island'), _defineProperty(_countries, 'PF', 'Clipperton Island'), _defineProperty(_countries, 'CC', 'Cocos (Keeling) Islands'), _defineProperty(_countries, 'CO', 'Colombia'), _defineProperty(_countries, 'KM', 'Comoros'), _defineProperty(_countries, 'CD', 'Congo, Democratic Republic of the'), _defineProperty(_countries, 'CG', 'Congo, Republic of the'), _defineProperty(_countries, 'CK', 'Cook Islands'), _defineProperty(_countries, 'CR', 'Coral Sea Islands'), _defineProperty(_countries, 'CR', 'Costa Rica'), _defineProperty(_countries, 'CI', 'Cote d`Ivoire'), _defineProperty(_countries, 'HR', 'Croatia'), _defineProperty(_countries, 'CU', 'Cuba'), _defineProperty(_countries, 'CW', 'Curacao'), _defineProperty(_countries, 'CY', 'Cyprus'), _defineProperty(_countries, 'CZ', 'Czech Republic'), _defineProperty(_countries, 'DK', 'Denmark'), _defineProperty(_countries, 'DX', 'Dhekelia Sovereign Base Area'), _defineProperty(_countries, 'DJ', 'Djibouti'), _defineProperty(_countries, 'DM', 'Dominica'), _defineProperty(_countries, 'DO', 'Dominican Republic'), _defineProperty(_countries, 'TL', 'East Timor'), _defineProperty(_countries, 'EC', 'Ecuador'), _defineProperty(_countries, 'EG', 'Egypt'), _defineProperty(_countries, 'SV', 'El Salvador'), _defineProperty(_countries, 'GQ', 'Equatorial Guinea'), _defineProperty(_countries, 'ER', 'Eritrea'), _defineProperty(_countries, 'EE', 'Estonia'), _defineProperty(_countries, 'ET', 'Ethiopia'), _defineProperty(_countries, 'TF', 'Europa Island'), _defineProperty(_countries, 'FK', 'Falkland Islands (Islas Malvinas)'), _defineProperty(_countries, 'FO', 'Faroe Islands'), _defineProperty(_countries, 'FJ', 'Fiji'), _defineProperty(_countries, 'FI', 'Finland'), _defineProperty(_countries, 'FR', 'France'), _defineProperty(_countries, 'GF', 'French Guiana'), _defineProperty(_countries, 'PF', 'French Polynesia'), _defineProperty(_countries, 'TF', 'French Southern & Antarctic Lands'), _defineProperty(_countries, 'GA', 'Gabon'), _defineProperty(_countries, 'GM', 'Gambia, The'), _defineProperty(_countries, 'GZ', 'Gaza Strip'), _defineProperty(_countries, 'GE', 'Georgia'), _defineProperty(_countries, 'DE', 'Germany'), _defineProperty(_countries, 'GH', 'Ghana'), _defineProperty(_countries, 'GI', 'Gibraltar'), _defineProperty(_countries, 'GO', 'Glorioso Islands'), _defineProperty(_countries, 'GR', 'Greece'), _defineProperty(_countries, 'GL', 'Greenland'), _defineProperty(_countries, 'GD', 'Grenada'), _defineProperty(_countries, 'GP', 'Guadeloupe'), _defineProperty(_countries, 'GU', 'Guam'), _defineProperty(_countries, 'GT', 'Guatemala'), _defineProperty(_countries, 'GG', 'Guernsey'), _defineProperty(_countries, 'GN', 'Guinea'), _defineProperty(_countries, 'GW', 'Guinea-Bissau'), _defineProperty(_countries, 'GY', 'Guyana'), _defineProperty(_countries, 'HT', 'Haiti'), _defineProperty(_countries, 'HM', 'Heard Island & McDonald Islands'), _defineProperty(_countries, 'VA', 'Holy See (Vatican City)'), _defineProperty(_countries, 'HN', 'Honduras'), _defineProperty(_countries, 'HK', 'Hong Kong'), _defineProperty(_countries, 'HU', 'Hungary'), _defineProperty(_countries, 'IS', 'Iceland'), _defineProperty(_countries, 'IN', 'India'), _defineProperty(_countries, 'ID', 'Indonesia'), _defineProperty(_countries, 'IR', 'Iran'), _defineProperty(_countries, 'IQ', 'Iraq'), _defineProperty(_countries, 'IE', 'Ireland'), _defineProperty(_countries, 'IM', 'Isle of Man'), _defineProperty(_countries, 'IL', 'Israel'), _defineProperty(_countries, 'IT', 'Italy'), _defineProperty(_countries, 'JM', 'Jamaica'), _defineProperty(_countries, 'SJ', 'Jan Mayen'), _defineProperty(_countries, 'JP', 'Japan'), _defineProperty(_countries, 'JE', 'Jersey'), _defineProperty(_countries, 'JO', 'Jordan'), _defineProperty(_countries, 'TF', 'Juan de Nova Island'), _defineProperty(_countries, 'KZ', 'Kazakhstan'), _defineProperty(_countries, 'KE', 'Kenya'), _defineProperty(_countries, 'KI', 'Kiribati'), _defineProperty(_countries, 'KP', 'Korea, North'), _defineProperty(_countries, 'KR', 'Korea, South'), _defineProperty(_countries, 'XK', 'Kosovo'), _defineProperty(_countries, 'KW', 'Kuwait'), _defineProperty(_countries, 'KG', 'Kyrgyzstan'), _defineProperty(_countries, 'LA', 'Laos'), _defineProperty(_countries, 'LV', 'Latvia'), _defineProperty(_countries, 'LB', 'Lebanon'), _defineProperty(_countries, 'LS', 'Lesotho'), _defineProperty(_countries, 'LR', 'Liberia'), _defineProperty(_countries, 'LY', 'Libya'), _defineProperty(_countries, 'LI', 'Liechtenstein'), _defineProperty(_countries, 'LT', 'Lithuania'), _defineProperty(_countries, 'LU', 'Luxembourg'), _defineProperty(_countries, 'MO', 'Macau'), _defineProperty(_countries, 'MK', 'Macedonia'), _defineProperty(_countries, 'MG', 'Madagascar'), _defineProperty(_countries, 'MW', 'Malawi'), _defineProperty(_countries, 'MY', 'Malaysia'), _defineProperty(_countries, 'MV', 'Maldives'), _defineProperty(_countries, 'ML', 'Mali'), _defineProperty(_countries, 'MT', 'Malta'), _defineProperty(_countries, 'MH', 'Marshall Islands'), _defineProperty(_countries, 'MQ', 'Martinique'), _defineProperty(_countries, 'MR', 'Mauritania'), _defineProperty(_countries, 'MU', 'Mauritius'), _defineProperty(_countries, 'YT', 'Mayotte'), _defineProperty(_countries, 'MX', 'Mexico'), _defineProperty(_countries, 'FM', 'Micronesia, Federated States of'), _defineProperty(_countries, 'MD', 'Moldova'), _defineProperty(_countries, 'MC', 'Monaco'), _defineProperty(_countries, 'MN', 'Mongolia'), _defineProperty(_countries, 'ME', 'Montenegro'), _defineProperty(_countries, 'MS', 'Montserrat'), _defineProperty(_countries, 'MA', 'Morocco'), _defineProperty(_countries, 'MZ', 'Mozambique'), _defineProperty(_countries, 'MM', 'Myanmar'), _defineProperty(_countries, 'NA', 'Namibia'), _defineProperty(_countries, 'NR', 'Nauru'), _defineProperty(_countries, 'UM', 'Navassa Island'), _defineProperty(_countries, 'NP', 'Nepal'), _defineProperty(_countries, 'NL', 'Netherlands'), _defineProperty(_countries, 'NC', 'New Caledonia'), _defineProperty(_countries, 'NZ', 'New Zealand'), _defineProperty(_countries, 'NI', 'Nicaragua'), _defineProperty(_countries, 'NE', 'Niger'), _defineProperty(_countries, 'NG', 'Nigeria'), _defineProperty(_countries, 'NU', 'Niue'), _defineProperty(_countries, 'NF', 'Norfolk Island'), _defineProperty(_countries, 'MP', 'Northern Mariana Islands'), _defineProperty(_countries, 'NO', 'Norway'), _defineProperty(_countries, 'OM', 'Oman'), _defineProperty(_countries, 'PK', 'Pakistan'), _defineProperty(_countries, 'PW', 'Palau'), _defineProperty(_countries, 'PA', 'Panama'), _defineProperty(_countries, 'PG', 'Papua New Guinea'), _defineProperty(_countries, 'PF', 'Paracel Islands'), _defineProperty(_countries, 'PY', 'Paraguay'), _defineProperty(_countries, 'PE', 'Peru'), _defineProperty(_countries, 'PH', 'Philippines'), _defineProperty(_countries, 'PN', 'Pitcairn Islands'), _defineProperty(_countries, 'PL', 'Poland'), _defineProperty(_countries, 'PT', 'Portugal'), _defineProperty(_countries, 'PR', 'Puerto Rico'), _defineProperty(_countries, 'QA', 'Qatar'), _defineProperty(_countries, 'RE', 'Reunion'), _defineProperty(_countries, 'RO', 'Romania'), _defineProperty(_countries, 'RU', 'Russia'), _defineProperty(_countries, 'RW', 'Rwanda'), _defineProperty(_countries, 'ST', 'Sao Tome and Principe'), _defineProperty(_countries, 'BL', 'Saint Barthelemy'), _defineProperty(_countries, 'SH', 'Saint Helena'), _defineProperty(_countries, 'KN', 'Saint Kitts & Nevis'), _defineProperty(_countries, 'LC', 'Saint Lucia'), _defineProperty(_countries, 'MF', 'Saint Martin'), _defineProperty(_countries, 'PM', 'Saint Pierre & Miquelon'), _defineProperty(_countries, 'VC', 'Saint Vincent & the Grenadines'), _defineProperty(_countries, 'WS', 'Samoa'), _defineProperty(_countries, 'SM', 'San Marino'), _defineProperty(_countries, 'SA', 'Saudi Arabia'), _defineProperty(_countries, 'SN', 'Senegal'), _defineProperty(_countries, 'RS', 'Serbia'), _defineProperty(_countries, 'SC', 'Seychelles'), _defineProperty(_countries, 'SL', 'Sierra Leone'), _defineProperty(_countries, 'SG', 'Singapore'), _defineProperty(_countries, 'SX', 'Sint Maarten'), _defineProperty(_countries, 'SK', 'Slovakia'), _defineProperty(_countries, 'SI', 'Slovenia'), _defineProperty(_countries, 'SB', 'Solomon Islands'), _defineProperty(_countries, 'SO', 'Somalia'), _defineProperty(_countries, 'ZA', 'South Africa'), _defineProperty(_countries, 'GS', 'South Georgia & South Sandwich Islands'), _defineProperty(_countries, 'SS', 'South Sudan'), _defineProperty(_countries, 'ES', 'Spain'), _defineProperty(_countries, 'LK', 'Sri Lanka'), _defineProperty(_countries, 'PS', 'State of Palestine'), _defineProperty(_countries, 'SD', 'Sudan'), _defineProperty(_countries, 'SR', 'Suriname'), _defineProperty(_countries, 'SJ', 'Svalbard'), _defineProperty(_countries, 'SZ', 'Swaziland'), _defineProperty(_countries, 'SE', 'Sweden'), _defineProperty(_countries, 'CH', 'Switzerland'), _defineProperty(_countries, 'SY', 'Syria'), _defineProperty(_countries, 'TW', 'Taiwan'), _defineProperty(_countries, 'TJ', 'Tajikistan'), _defineProperty(_countries, 'TZ', 'Tanzania, United Republic of'), _defineProperty(_countries, 'TH', 'Thailand'), _defineProperty(_countries, 'TG', 'Togo'), _defineProperty(_countries, 'TK', 'Tokelau'), _defineProperty(_countries, 'TO', 'Tonga'), _defineProperty(_countries, 'TT', 'Trinidad & Tobago'), _defineProperty(_countries, 'TF', 'Tromelin Island'), _defineProperty(_countries, 'TN', 'Tunisia'), _defineProperty(_countries, 'TR', 'Turkey'), _defineProperty(_countries, 'TM', 'Turkmenistan'), _defineProperty(_countries, 'TC', 'Turks & Caicos Islands'), _defineProperty(_countries, 'TV', 'Tuvalu'), _defineProperty(_countries, 'UG', 'Uganda'), _defineProperty(_countries, 'UA', 'Ukraine'), _defineProperty(_countries, 'AE', 'United Arab Emirates'), _defineProperty(_countries, 'GB', 'United Kingdom'), _defineProperty(_countries, 'US', 'United States'), _defineProperty(_countries, 'UM', 'United States Minor Outlying Islands'), _defineProperty(_countries, 'UY', 'Uruguay'), _defineProperty(_countries, 'UZ', 'Uzbekistan'), _defineProperty(_countries, 'VU', 'Vanuatu'), _defineProperty(_countries, 'VE', 'Venezuela'), _defineProperty(_countries, 'VN', 'Vietnam'), _defineProperty(_countries, 'VI', 'Virgin Islands (US)'), _defineProperty(_countries, 'WF', 'Wallis & Futuna'), _defineProperty(_countries, 'EH', 'Western Sahara'), _defineProperty(_countries, 'YE', 'Yemen'), _defineProperty(_countries, 'ZM', 'Zambia'), _defineProperty(_countries, 'ZW', 'Zimbabwe'), _countries);

/***/ }),
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HardToken = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HardToken = exports.HardToken = function () {
    function HardToken(dto) {
        _classCallCheck(this, HardToken);

        angular.extend(this, dto);
    }

    _createClass(HardToken, [{
        key: 'toDto',
        value: function toDto() {
            var dto = angular.extend({}, this);

            // do not send secrets if they're empty
            dto.secret = dto.secret || undefined;
            dto.privateIdentity = dto.privateIdentity || undefined;

            return dto;
        }
    }, {
        key: 'effectiveStatus',
        get: function get() {
            return this.hasAccounts ? this.status : 'NOT_ASSIGNED';
        }
    }]);

    return HardToken;
}();

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var U2F = [{ name: 'serial', placeholder: 'Device Name' }, { name: 'registrationEmail', placeholder: 'Email Address' }];

var YOTP = [{ name: 'serial', placeholder: 'Decimal' }, { name: 'publicIdentity', placeholder: '1-16 Bytes Modhex', charSet: '0-9a-zA-Z', pattern: '[0-9a-zA-Z]{12}', maxLength: 120 }, { name: 'privateIdentity', placeholder: '6 Bytes Hex', charSet: '0-9a-fA-F', pattern: '[0-9a-fA-F]{12}', maxLength: 120 }, { name: 'secret', placeholder: '16 Bytes Hex', charSet: '0-9a-fA-F', pattern: '[0-9a-fA-F]{32}', maxLength: 320 }];

var HOTP = [{ name: 'serial', placeholder: 'Decimal' }, { name: 'secret', placeholder: '20 Bytes Hex', charSet: '0-9a-fA-F', pattern: '[0-9a-fA-F]{16,256}', maxLength: 512 }];

var THIRD_PARTY = [{ name: 'serial', placeholder: 'Hexadecimal' }, { name: 'secret', placeholder: 'Hexadecimal', charSet: '0-9a-fA-F', pattern: '[0-9a-fA-F]{16,256}', maxLength: 512 }];

var props = exports.props = {
    YUBIKey_USB_KEY: {
        U2F: U2F,
        YOTP: YOTP,
        HOTP: HOTP
    },
    THIRD_PARTY: {
        TOTP: THIRD_PARTY,
        HOTP: THIRD_PARTY
    }
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var mobileApplicationSettingsFromDto = exports.mobileApplicationSettingsFromDto = function mobileApplicationSettingsFromDto(settings) {
    return {
        iosEnabled: settings && settings.iosEnabled || false,
        iosBundleId: settings && settings.iosBundleId || '',
        iosSuffix: settings && settings.iosSuffix || '',
        androidEnabled: settings && settings.androidEnabled || false,
        androidNamespace: settings && settings.androidNamespace || '',
        androidHashkey: settings && settings.androidHashkey || ''
    };
};

var mobileApplicationSettingsToDto = exports.mobileApplicationSettingsToDto = function mobileApplicationSettingsToDto(settings) {
    return {
        iosEnabled: settings.iosEnabled || undefined,
        iosBundleId: settings.iosEnabled && settings.iosBundleId || undefined,
        iosSuffix: settings.iosEnabled && settings.iosSuffix || undefined,
        androidEnabled: settings.androidEnabled || undefined,
        androidNamespace: settings.androidEnabled && settings.androidNamespace || undefined,
        androidHashkey: settings.androidEnabled && settings.androidHashkey || undefined
    };
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.modelFromDto = modelFromDto;
exports.modelToDto = modelToDto;
function modelFromDto(roleDto, applicationGroupsDto) {
    return {
        id: roleDto.loginRole.id,
        roleName: roleDto.loginRole.roleName,
        roleValue: roleDto.loginRole.roleValue,
        groups: applicationGroupsDto.map(function (applicationGroup) {
            return {
                id: applicationGroup.group.id,
                type: applicationGroup.group.type,
                groupName: applicationGroup.group.groupName,
                applicationGroupId: applicationGroup.id,
                isSelected: roleDto.groupIds.includes(applicationGroup.id)
            };
        })
    };
}

function modelToDto(model) {
    return {
        loginRole: {
            id: model.id,
            roleName: model.roleName,
            roleValue: model.roleValue
        },
        groupIds: model.groups.filter(function (group) {
            return group.isSelected;
        }).map(function (group) {
            return group.applicationGroupId;
        })
    };
}

/***/ }),
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$http"];

    /** @ngInject */
    function Controller($http) {
        _classCallCheck(this, Controller);

        this.$http = $http;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            this.youtubeData();
        }
    }, {
        key: "youtubeData",
        value: function youtubeData() {
            var _this = this;

            var url = "https://www.googleapis.com/youtube/v3/search?key=AIzaSyAcFtiyieqEPiLCSJh1Kt6fPRjCtksSalo&channelId=UC7rOgFOnh9aLx4wSsuAasDQ&part=snippet,id&order=date&maxResults=50";
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;

                _this.youtubeJson = data;
                return data;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getUrlParam = exports.getUrlParam = function getUrlParam(url, name) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var query = url.split('?')[1] || '';
    var params = query.split('&');
    var param = params.find(function (p) {
        return p.startsWith(name + '=');
    });
    return (param || name + '=' + defaultValue).split('=')[1];
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.azureDomainsFromDto = azureDomainsFromDto;
exports.scimDomainsFromDto = scimDomainsFromDto;
exports.domainsFromDto = domainsFromDto;
exports.isAzure = isAzure;
exports.isSCIM = isSCIM;
exports.emptyDomainListCheck = emptyDomainListCheck;

var _group = __webpack_require__(84);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function azureDomainsFromDto(domains) {
    return domains.map(function (domain) {
        return _extends({}, domain, { groups: domain.groups.map(function (group) {
                return _extends({}, group, { type: 'AZURE_GROUP' });
            }) });
    });
}

function scimDomainsFromDto(domains) {
    return domains.map(function (domain) {
        return _extends({}, domain, { groups: domain.groups });
    });
}

function domainsFromDto(domains) {
    return domains.map(function (domain) {
        return _extends({}, domain, { groups: groupsFromDto(domain.groups) });
    });
}

function groupsFromDto(dto) {
    var groups = dto.map(_group.groupFromDto).sort(function (a, b) {
        return a.cname.localeCompare(b.cname);
    });
    var domains = groups.filter(function (_ref) {
        var type = _ref.type;
        return type === 'AD_DOMAIN';
    });
    var ous = groups.filter(function (_ref2) {
        var type = _ref2.type;
        return type === 'AD_OU';
    });
    var children = function children(ou) {
        return groups.filter(function (g) {
            return g.parentName === ou.cname;
        });
    };
    return domains.concat.apply(domains, _toConsumableArray(ous.map(function (ou) {
        return [ou].concat(_toConsumableArray(children(ou)));
    })));
}

function isAzure(directory) {
    return directory.type === 'AZURE';
}

function isSCIM(directory) {
    return directory.type === 'SCIM';
}

function emptyDomainListCheck(directory, domains) {
    if (domains == null || domains.length == 0) {
        return [{
            domainName: directory.name,
            isRoot: false,
            groups: []
        }];
    } else {
        return domains;
    }
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5d05e9dbdab09eed0d31ab564af18cc5.html";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _sessionId = __webpack_require__(22);

var _userAgent = __webpack_require__(13);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$http', '$rootScope', '$scope', '$state', '$timeout', 'AuthenticationSharedService', 'BarcodeGeneratonService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($http, $rootScope, $scope, $state, $timeout, AuthenticationSharedService, BarcodeGeneratonService) {
    var vm = $scope.vm = {};
    $scope.username = localStorage.getItem('username');
    $scope.rememberMe = !!$scope.username;
    var sendingPushLoginNotification = false;
    var captcha = $scope.captcha = new _captcha.Captcha();
    if (AuthenticationSharedService.getGmpLoginSession()) {
        $state.go('gmp-config');
    } else if ($rootScope.account) {
        $state.go('user');
    }

    var $ctrl = this;

    $ctrl.loadQrData = function () {
        return BarcodeGeneratonService.get({ uuid: _sessionId.SESSION_ID, appKey: $rootScope.oauthClientId }).$promise.then(function (barcode) {
            $rootScope.passwordMode = $ctrl.passwordMode = barcode.passwordMode;
            $ctrl.mobileLoginUrl = 'saaspass-wa://login?barcode=' + barcode.bluetoothcode;
            if (!$state.params.domain) {
                $ctrl.bluetoothCode = barcode.bluetoothcode;
            }
            return barcode.barcodeimage;
        });
    };

    if ($scope.rememberMe && captcha.isValid() && $rootScope.plEnabled) {
        // send push login only if not authenticated
        if (!localStorage.getItem('token')) {
            pushLogin($scope.username);
        } else {
            $http.get('app/rest/account', { ignoreAuthModule: true }).catch(function () {
                return pushLogin($scope.username);
            });
        }
    }

    $scope.$on('websocket.LOGIN', function (event, data) {
        var username = data.username,
            password = data.password;

        AuthenticationSharedService.login({
            username: username,
            password: password,
            oauthClientId: $rootScope.oauthClientId
        });
    });

    function onPushLoginSuccess(username) {
        vm.pushLoginPopoverIsOpen = true;
        $timeout(2000).then(function () {
            return vm.pushLoginPopoverIsOpen = false;
        });
        if ($scope.rememberMe) {
            localStorage.setItem('username', $scope.username);
        }
    }

    $scope.pushLogin = pushLogin;
    function pushLogin(username) {
        if (!username) {
            username = $scope.username;
        }

        sendingPushLoginNotification = true;
        AuthenticationSharedService.sendPushLoginNotification(captcha.response, username, $rootScope.oauthClientId).then(onPushLoginSuccess).finally(function () {
            captcha.reset();
            sendingPushLoginNotification = false;
        });
    }

    $scope.pulssing = "";

    $scope.pulse = function () {
        $scope.pulssing = "pulseAnimate";
        $("html, body").animate({ scrollTop: $(document).height() }, 2000);

        $timeout(function () {
            $scope.pulssing = "";
        }, 2000);
    };

    $scope.login = function () {
        AuthenticationSharedService.login({
            username: $scope.username,
            password: $scope.password,
            oauthClientId: $rootScope.oauthClientId,
            captchaResponse: captcha.response
        }).then(function () {
            return $scope.rememberMe && localStorage.setItem('username', $scope.username);
        }).finally(function () {
            return captcha.reset();
        });
    };

    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem('username');
        }
    };

    $scope.newLoginButton = _userAgent.ua.isAndroid() || _userAgent.ua.isIOS();

    $scope.pushLoginDisabled = pushLoginDisabled;

    function pushLoginDisabled() {
        return !$scope.username || sendingPushLoginNotification || vm.pushLoginPopoverIsOpen || !captcha.isValid();
    }

    if ($state.params.domain) {
        var code = $state.params.code;
        $scope.username = $state.params.domain;
        AuthenticationSharedService.login({
            username: '@' + $state.params.domain,
            password: null,
            captchaResponse: captcha.response,
            googleAppsLogin: true,
            code: code
        }).finally(function () {
            return captcha.reset();
        });
    }
}

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(247);

__webpack_require__(248);

// recursively import all scripts and styles
var context = __webpack_require__(933);
context.keys().forEach(context);

/***/ }),
/* 247 */,
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!window.localStorage) {
    var memoryStorage = function memoryStorage() {

        var storage = {};

        return {
            length: 0,
            key: function key(index) {
                return '';
            },
            getItem: function getItem(key) {
                return storage[key];
            },
            setItem: function setItem(key, value) {
                return storage[key] = value;
            },
            removeItem: function removeItem(key) {
                return delete storage[key];
            },
            clear: function clear() {
                return storage = {};
            }
        };
    };

    Object.defineProperty(window, 'localStorage', {
        value: memoryStorage()
    });
}

/*
 * WHY DO WE NEED THIS POLYFILL?
 * - On Android devices, when you try to add a new google-app account,
 *   android opens saml-login page of saaspass in an internal browser.
 *   In that browser, localStorage is null.
 * - Some browsers disable localStorage in private browsing mode.
 * - Some users disable it in browser's privacy settings.
 */

/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _loadGoogleVisualizationApi = __webpack_require__(299);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$timeout', '$translate', 'Alert', 'CompanyApplicationOverviewService', 'UserAccountsService'];

    /** @ngInject */
    function Controller($state, $timeout, $translate, Alert, CompanyApplicationOverviewService, UserAccountsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.Alert = Alert;
        this.UserAccountsService = UserAccountsService;
        this.CompanyApplicationOverviewService = CompanyApplicationOverviewService;
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            var _this = this;

            var companyId = this.companyId = this.$state.params.companyId;

            this.applicationId = this.application.id;
            this.displayChartSpinner = false;
            this.displaySeparator = false;
            this.displayCharts = false;
            this.startDate = new Date();
            this.endDate = new Date();
            this.userFilter = -1;
            this.periodFilter = 'TODAY';
            this.dataFilter = 'DAY';
            this.saaspassId = "";
            this.oneTimePassword = true;
            this.instatntLogin = true;
            this.proximity = true;
            this.remoteLogin = true;
            this.ssoLogin = true;
            this.app2appLogin = true;
            this.showSelectors = false;
            var chart;
            var chart2;
            var realData;
            var realData2;
            var colors = ['#FE2E2E', '#F5A9A9', '#0040FF', '#5882FA', '#DBA901', '#F3E2A9'];
            var options = {
                curveType: 'none',
                legend: {
                    position: 'top',
                    maxLines: 2,
                    alignment: 'center'
                },
                colors: colors,
                height: 400,
                pointSize: 3,
                chartArea: {
                    width: '90%'
                },
                hAxis: {
                    showTextEvery: 4,
                    slantedText: true,
                    slantedTextAngle: 60,
                    textStyle: {
                        fontSize: 10
                    }
                },
                vAxis: {
                    maxValue: 4,
                    format: 'short'
                },
                animation: {
                    startup: true,
                    duration: 700,
                    easing: 'linear'
                }
            };

            this.UserAccountsService.assignedGroups.get({
                companyId: companyId,
                appId: this.applicationId
            }).$promise.then(function (data) {
                _this.assignedGroups = data.assignedGroups;
            });

            this.datepickerOptions = { maxDate: new Date() };
            this.open = function ($event, type) {
                $event.preventDefault();
                $event.stopPropagation();
                if (type == 1) {
                    _this.opened = true;
                    _this.opened1 = false;
                } else {
                    _this.opened1 = true;
                    _this.opened = false;
                }
            };

            this.generateReport = function () {
                _this.displayCharts = true;
                if (_this.periodFilter === 'CUSTOM' && _this.endDate < _this.startDate) {
                    _this.Alert('danger', 'corporate.sms.date_message_warning');
                    return;
                }

                _this.displayChartSpinner = true;
                clearChekboxs();

                var chart_data = [[_this.$translate.instant('configure_application.year'), _this.$translate.instant('configure_application.application_usage.generate_report.otp_successful'), _this.$translate.instant('configure_application.application_usage.generate_report.otp_total'), _this.$translate.instant('configure_application.application_usage.generate_report.scan_barcode_successful'), _this.$translate.instant('configure_application.application_usage.generate_report.scan_barcode_total'), _this.$translate.instant('configure_application.application_usage.generate_report.proximity_successful'), _this.$translate.instant('configure_application.application_usage.generate_report.proximity_total')]];
                var chart_data2 = [[_this.$translate.instant('configure_application.year'), _this.$translate.instant('configure_application.application_usage.generate_report.remote_successful'), _this.$translate.instant('configure_application.application_usage.generate_report.remote_total'), _this.$translate.instant('configure_application.application_usage.generate_report.sso_successful'), _this.$translate.instant('configure_application.application_usage.generate_report.sso_total'), _this.$translate.instant('configure_application.application_usage.generate_report.mobile_successful'), _this.$translate.instant('configure_application.application_usage.generate_report.mobile_login')]];
                var dateVar = new Date();
                var timeZone = dateVar.getTimezoneOffset() / 60 * -1;
                _this.CompanyApplicationOverviewService.drawChart.query({
                    companyId: companyId,
                    appId: _this.applicationId,
                    filterUser: _this.userFilter,
                    periodFilter: _this.periodFilter,
                    displayData: _this.dataFilter,
                    saaspassId: _this.saaspassId,
                    startDate: +_this.startDate,
                    endDate: +_this.endDate,
                    timeZone: timeZone
                }).$promise.then(function (data) {
                    for (var i = 0; i < data.length; i++) {
                        var row = data[i];
                        var points = [row[0], row[1], row[2], row[3], row[4], row[5], row[6]];
                        chart_data.push(points);
                        var points2 = [row[0], row[7], row[8], row[9], row[10], row[11], row[12]];
                        chart_data2.push(points2);
                    }
                    chart = createChart(chart_data, 'curve_chart');
                    chart2 = createChart(chart_data2, 'curve_chart2');
                }, function (error) {
                    _this.displayChartSpinner = false;
                });
            };

            var createChart = function createChart(chartData, chartName) {
                return (0, _loadGoogleVisualizationApi.loadGoogleVisualizationApi)().then(function (google) {

                    var data_graph = google.visualization.arrayToDataTable(chartData);

                    var max = 4;
                    var max2 = data_graph.getColumnRange(2).max;
                    var max4 = data_graph.getColumnRange(4).max;
                    var max6 = data_graph.getColumnRange(6).max;
                    max = Math.max(max, max2, max4, max6);
                    while (max % 4 != 0) {
                        max++;
                    }
                    options.vAxis.maxValue = max;
                    var vGrid = max;
                    if (max > 256) {
                        vGrid = 4;
                    } else if (max > 128) {
                        vGrid = 6;
                    } else if (max > 64) {
                        vGrid = 8;
                    } else if (max > 32) {
                        vGrid = 10;
                    } else if (max > 16) {
                        vGrid = 8;
                    } else if (max > 8) {
                        vGrid = 6;
                    } else if (max > 4) {
                        vGrid = 4;
                    }
                    options.vAxis.gridlines = { count: vGrid };
                    var showEvery = parseInt(data_graph.getNumberOfRows() / 10);
                    options.hAxis.showTextEvery = showEvery;
                    //copyData = angular.copy(data_graph);
                    if (chartName == "curve_chart") {
                        realData = angular.copy(data_graph);
                    } else {
                        if (_this.application.applicationType.slug !== 'custom') {
                            var data_colors = angular.copy(colors);
                            data_colors.splice(0, 2);
                            data_graph.removeColumn(5);
                            data_graph.removeColumn(5);
                            _this.app2appLogin = false;
                            $('#app2appDiv').hide();
                            options.colors = data_colors;
                        }
                        realData2 = angular.copy(data_graph);
                    }
                    var newChart = new google.visualization.LineChart(document.getElementById(chartName));
                    _this.selectHandler = function () {
                        _this.displayChartSpinner = false;
                        _this.showSelectors = true;
                        _this.displaySeparator = true;
                    };
                    google.visualization.events.addListener(newChart, 'ready', _this.selectHandler);
                    newChart.draw(data_graph, options);
                    return newChart;
                });
            };

            var clearChekboxs = function clearChekboxs() {
                _this.oneTimePassword = true;
                _this.instatntLogin = true;
                _this.proximity = true;
                $('#proximity').prop('disabled', false);
                $('#instatntLogin').prop('disabled', false);
                $('#oneTimePassword').prop('disabled', false);

                _this.remoteLogin = true;
                _this.ssoLogin = true;
                _this.app2appLogin = true;
                $('#remoteLogin').prop('disabled', false);
                $('#ssoLogin').prop('disabled', false);
                $('#app2appLogin').prop('disabled', false);

                options.colors = colors;
            };

            this.removeColumnInChart = function () {

                var n = 0;
                var k = 0;
                var data_graph = angular.copy(realData);
                var data_colors = angular.copy(colors);
                if (!_this.oneTimePassword) {
                    data_colors.splice(0, 2);
                    data_graph.removeColumn(1);
                    data_graph.removeColumn(1);
                    n = 2;
                }

                if (!_this.instatntLogin) {
                    data_colors.splice(2 - n, 2);
                    data_graph.removeColumn(3 - n);
                    data_graph.removeColumn(3 - n);
                    k = 2;
                }

                if (!_this.proximity) {
                    data_colors.splice(4 - n - k, 2);
                    data_graph.removeColumn(5 - n - k);
                    data_graph.removeColumn(5 - n - k);
                }
                options.colors = data_colors;
                chart.then(function (chart) {
                    return chart.draw(data_graph, options);
                });

                $('#proximity').prop('disabled', false);
                $('#instatntLogin').prop('disabled', false);
                $('#oneTimePassword').prop('disabled', false);
                if (!_this.oneTimePassword && !_this.instatntLogin) {
                    $('#proximity').prop('disabled', true);
                } else if (!_this.oneTimePassword && !_this.proximity) {
                    $('#instatntLogin').prop('disabled', true);
                }if (!_this.instatntLogin && !_this.proximity) {
                    $('#oneTimePassword').prop('disabled', true);
                }
            };

            this.removeColumnInChart2 = function () {

                var n = 0;
                var k = 0;
                var data_graph = angular.copy(realData2);
                var data_colors = angular.copy(colors);
                if (!_this.remoteLogin) {
                    data_colors.splice(0, 2);
                    data_graph.removeColumn(1);
                    data_graph.removeColumn(1);
                    n = 2;
                }

                if (!_this.ssoLogin) {
                    data_colors.splice(2 - n, 2);
                    data_graph.removeColumn(3 - n);
                    data_graph.removeColumn(3 - n);
                    k = 2;
                }

                if (_this.app2appLogin && _this.application.applicationType.slug !== 'custom') {
                    data_colors.splice(4 - n - k, 2);
                    data_graph.removeColumn(5 - n - k);
                    data_graph.removeColumn(5 - n - k);
                }
                options.colors = data_colors;
                chart2.then(function (chart) {
                    return chart.draw(data_graph, options);
                });

                $('#remoteLogin').prop('disabled', false);
                $('#ssoLogin').prop('disabled', false);
                $('#app2appLogin').prop('disabled', false);
                if (!_this.remoteLogin && !_this.ssoLogin) {
                    $('#app2appLogin').prop('disabled', true);
                } else if (!_this.remoteLogin && !_this.app2appLogin) {
                    $('#ssoLogin').prop('disabled', true);
                }if (!_this.ssoLogin && !_this.app2appLogin) {
                    $('#remoteLogin').prop('disabled', true);
                }
            };
        }
    }]);

    return Controller;
}();

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadGoogleVisualizationApi = loadGoogleVisualizationApi;

var _scriptjs = __webpack_require__(191);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promise = void 0;

function loadGoogleVisualizationApi() {
    return promise ? promise : promise = new Promise(function (resolve) {
        (0, _scriptjs2.default)('https://www.google.com/jsapi', function () {
            window.google.load('visualization', '1', {
                packages: ['corechart'],
                callback: function callback() {
                    return resolve(window.google);
                }
            });
        });
    });
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadGrecaptchaApi = loadGrecaptchaApi;

var _scriptjs = __webpack_require__(191);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promise = void 0;

function loadGrecaptchaApi() {
    return promise ? promise : promise = new Promise(function (resolve) {
        window.grecaptchaLoaded = function () {
            return resolve(window.grecaptcha);
        };
        (0, _scriptjs2.default)('https://www.google.com/recaptcha/api.js?onload=grecaptchaLoaded&render=explicit');
    });
}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _loadGrecaptchaApi = __webpack_require__(300);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$element', '$scope'];

    /** @ngInject */
    function Controller($element, $scope) {
        _classCallCheck(this, Controller);

        this.$element = $element;
        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var parameters = {
                sitekey: window.env.captcha.key,
                callback: this.onResponse.bind(this),
                'expired-callback': this.onExpire.bind(this)
            };

            (0, _loadGrecaptchaApi.loadGrecaptchaApi)().then(function (grecaptcha) {
                var widgetId = grecaptcha.render(_this.$element[0], parameters);
                _this.state.widget = { reset: function reset() {
                        return grecaptcha.reset(widgetId);
                    } };
            });
        }

        /** @private */

    }, {
        key: 'onResponse',
        value: function onResponse(response) {
            var _this2 = this;

            this.$scope.$apply(function () {
                return _this2.state.response = response;
            });
        }

        /** @private */

    }, {
        key: 'onExpire',
        value: function onExpire() {
            var _this3 = this;

            this.$scope.$apply(function () {
                return _this3.state.response = undefined;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$translate"];

    /** @ngInject */
    function Controller($translate) {
        _classCallCheck(this, Controller);

        this.$translate = $translate;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "templateUrl",
        value: function templateUrl() {
            return __webpack_require__(1024)("./info-sharing-accounts-" + this.$translate.use() + ".html");
        }
    }]);

    return Controller;
}();

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$translate"];

    /** @ngInject */
    function Controller($translate) {
        _classCallCheck(this, Controller);

        this.$translate = $translate;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "templateUrl",
        value: function templateUrl() {
            return __webpack_require__(1034)("./info-sharing-center-" + this.$translate.use() + ".html");
        }
    }]);

    return Controller;
}();

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = __webpack_require__(192);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$translate'];

    /** @ngInject */
    function Controller($translate) {
        _classCallCheck(this, Controller);

        this.$translate = $translate;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.languages = _constants.languages;
        }
    }, {
        key: 'flag',
        value: function flag(langKey) {
            return __webpack_require__(1044)("./" + langKey + '.png');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _spAlert = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope'];

    /** @ngInject */
    function Controller($scope) {
        _classCallCheck(this, Controller);

        // this.Alert = Alert;
        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.$scope.spAlert = new _spAlert.SpAlert('success', 'global.data_copied');
                });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _spAlert = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope'];

    /** @ngInject */
    function Controller($scope) {
        _classCallCheck(this, Controller);

        // this.Alert = Alert;
        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.$scope.spAlert = new _spAlert.SpAlert('success', 'global.data_copied');
                });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$http', '$window'];

	/** @ngInject */
	function Controller($http, $window) {
		_classCallCheck(this, Controller);

		this.$http = $http;
		this.$window = $window;
	}

	_createClass(Controller, [{
		key: 'exportAs',
		value: function exportAs(format) {
			var _this = this;

			//const form = document.forms.ff2;
			//console.log(form);
			//form.submit();
			var exportList = this.items().map(function (item) {
				return select(item, _this.fields);
			});

			// FIXME: Workaround. Remove when back-end is fixed.
			if (this.template === 'applications') {
				exportList.unshift({});
			}

			var req = {
				method: 'POST',
				url: 'app/rest/reports/' + format + '/' + this.template,
				headers: {
					'Content-Type': 'application/json',
					'timeZone': new Date().getTimezoneOffset(),
					'exportName': this.name
				},
				data: exportList,
				responseType: 'blob'
			};
			var a = document.createElement("a");
			document.body.appendChild(a);
			this.$http(req).then(function (response) {
				//var disposition = headers('Content-Disposition');

				var filename = getFileNameFromHttpResponse(response);
				//this.$window.navigator.msSaveOrOpenBlob(response.data, filename);
				var fileURL = _this.$window.URL.createObjectURL(response.data);
				a.href = fileURL;
				a.download = filename;
				a.click();
				setTimeout(function () {
					this.$window.URL.revokeObjectURL(fileURL);
				}, 100);
			});
		}
	}, {
		key: 'items',
		value: function items() {
			return this.stTable.getFilteredCollection();
		}
	}, {
		key: 'onSubmitted',
		value: function onSubmitted() {
			//console.log("F@@@@@2222222");

		}
	}]);

	return Controller;
}();

function select(obj, props) {
	return props.reduce(function (acc, path) {
		var parts = path.split('.');
		var prop = parts.slice(-1)[0];
		return _extends({}, acc, _defineProperty({}, prop, parts.reduce(function (o, p) {
			return o[p];
		}, obj)));
	}, {});
}

function submit(target, data, exportList) {

	var form = document.forms.exportForm;
	Object.keys(data).forEach(function (key) {
		return form.elements[key].value = data[key];
	});
	form.data = exportList;
	form.action = target;
	//form.$http(req).
	//console.log(form);
	form.submit();
}

function getFileNameFromHttpResponse(httpResponse) {
	var contentDispositionHeader = httpResponse.headers('Content-Disposition');
	var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
	return result.replace(/"/g, '');
}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.itemsPerPageMax100Allowed()) {
                this.options = [{ value: 10, label: 10 }, { value: 50, label: 50 }, { value: 100, label: 100 }];
            } else if (this.itemsPerPageMax500Allowed()) {
                this.options = [{ value: 10, label: 10 }, { value: 50, label: 50 }, { value: 100, label: 100 }, { value: 500, label: 500 }];
            } else {
                this.options = [{ value: 10, label: 10 }, { value: 50, label: 50 }, { value: 100, label: 100 }, { value: 500, label: 500 }, { value: 1000, label: 1000 }, { value: 1000000, label: 'global.filter.all' }];
            }
        }
    }, {
        key: 'itemsPerPageMax100Allowed',
        value: function itemsPerPageMax100Allowed() {
            return this.$state.current.name == 'company.spadmin.companies';
        }
    }, {
        key: 'itemsPerPageMax500Allowed',
        value: function itemsPerPageMax500Allowed() {
            return this.$state.current.name == 'company.user-directories.directory-groups.all-accounts' || this.$state.current.name == 'company.user-directories.manage-group.accounts' || this.$state.current.name == 'company.user-directories.manage-group.accounts.add';
        }
    }, {
        key: 'deselectAllItems',
        value: function deselectAllItems() {
            this.items.forEach(function (item) {
                return item.isSelected = false;
            });
        }
    }, {
        key: 'totalItemCount',
        get: function get() {
            return this.stTable.tableState().pagination.totalItemCount;
        }
    }, {
        key: 'items',
        get: function get() {
            return this.stTable.getFilteredCollection();
        }
    }, {
        key: 'itemsPerPage',
        get: function get() {
            var itemsPerPage = +localStorage.getItem('items-per-page:' + this.$state.current.name) || +localStorage.getItem('items-per-page') || 100;
            if (itemsPerPage > 500) {
                return this.itemsPerPageMax500Allowed() ? 500 : itemsPerPage;
            }
            if (itemsPerPage > 100) {
                return this.itemsPerPageMax100Allowed() ? 100 : itemsPerPage;
            }
            return itemsPerPage < 10 ? 10 : itemsPerPage;
        },
        set: function set(value) {
            value = value < 10 ? 10 : value;
            this.deselectAllItems();
            if (!this.hasCustomItemsPerPage || !localStorage.getItem('items-per-page')) {
                localStorage.setItem('items-per-page', value);
            }
            if (this.hasCustomItemsPerPage) {
                localStorage.setItem('items-per-page:' + this.$state.current.name, value);
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "isChecked",
        value: function isChecked() {
            return this.selectables().every(function (item) {
                return item.isSelected;
            });
        }
    }, {
        key: "isVisible",
        value: function isVisible() {
            return !!this.selectables().length;
        }
    }, {
        key: "toggle",
        value: function toggle() {
            var checked = this.isChecked();
            this.selectables().forEach(function (item) {
                return item.isSelected = !checked;
            });
        }
    }, {
        key: "isSelectable",
        value: function isSelectable(item) {
            return !this.itemSelectable || this.itemSelectable(item);
        }
    }, {
        key: "selectables",
        value: function selectables() {
            var _this = this;

            return this.items.filter(function (item) {
                return _this.isSelectable(item);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.tooltipKey = {
                ACTIVE: 'sp-account-status.active',
                EXPIRED: 'sp-account-status.expired',
                IR_PENDING: 'sp-account-status.ir-pending',
                PENDING: 'sp-account-status.pending',
                UNKNOWN: 'sp-account-status.unknown'
            }[this.accountStatus];

            this.iconClass = {
                ACTIVE: 'fa fa-lg fa-check',
                EXPIRED: 'fa fa-lg fa-history',
                IR_PENDING: 'far fa-lg fa-clock',
                PENDING: 'far fa-lg fa-clock',
                UNKNOWN: 'far fa-lg fa-question-circle'
            }[this.accountStatus];

            this.textClass = {
                ACTIVE: 'text-success',
                EXPIRED: 'text-danger',
                IR_PENDING: 'text-warning',
                PENDING: 'text-warning',
                UNKNOWN: 'text-muted'
            }[this.accountStatus];
        }
    }]);

    return Controller;
}();

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.tooltipKey = {
                AD: 'sp-account-type.active-directory',
                EXTERNAL_EMAIL: 'sp-account-type.external-email',
                INTERNAL_EMAIL: 'sp-account-type.internal-email',
                PHONENUMBER: 'sp-account-type.phone-number',
                SHARED_EMAIL: 'sp-account-type.shared-email',
                SIMPLE_USERNAME: 'sp-account-type.simple-username'
            }[this.accountType];

            this.iconClass = {
                AD: 'text-primary fa fa-database',
                EXTERNAL_EMAIL: 'text-primary fa-lg fas fa-envelope',
                INTERNAL_EMAIL: 'text-primary fa-lg far fa-envelope',
                PHONENUMBER: 'text-primary fa-lg fas fa-phone',
                SHARED_EMAIL: 'text-primary fa-lg fas fa-share-alt',
                SIMPLE_USERNAME: 'text-primary fa-lg far fa-address-card'
            }[this.accountType];
        }
    }]);

    return Controller;
}();

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.tooltipKey = {
                ADMIN: 'sp-addition-source.admin',
                THIRD_PARTY_FACEBOOK: 'sp-addition-source.third-party-facebook',
                USER: 'sp-addition-source.user',
                AZURE_DIRECTORY: 'sp-addition-source.azure-directory',
                SCIM_DIRECTORY: 'sp-addition-source.scim-directory'
            }[this.additionSource];

            this.iconClass = {
                ADMIN: 'text-primary fa fa-lg fa-user',
                THIRD_PARTY_FACEBOOK: 'text-primary fa fa-lg fa-facebook-official',
                USER: 'text-primary far fa-lg fa-user-circle',
                AZURE_DIRECTORY: 'text-primary fa-solid fa-diamond',
                SCIM_DIRECTORY: 'text-primary fa-solid fa-rotate'
            }[this.additionSource];
        }
    }]);

    return Controller;
}();

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$timeout"];

    /** @ngInject */
    function Controller($timeout) {
        _classCallCheck(this, Controller);

        this.$timeout = $timeout;
    }

    _createClass(Controller, [{
        key: "$onChanges",
        value: function $onChanges(_ref) {
            var options = _ref.options;

            if (options && !options.isFirstChange()) {
                this.update(options.currentValue || {});
            }
        }
    }, {
        key: "update",
        value: function update(_ref2) {
            var _this = this;

            var key = _ref2.key,
                autoDismiss = _ref2.autoDismiss;

            this.visible = !!key;

            if (autoDismiss) {
                this.$timeout(4000).then(function () {
                    return _this.visible = false;
                });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ["$rootScope", "$state"];

	/** @ngInject */
	function Controller($rootScope, $state) {
		_classCallCheck(this, Controller);

		this.$rootScope = $rootScope;
		this.$state = $state;
	}

	_createClass(Controller, [{
		key: "$onInit",
		value: function $onInit() {
			var _this = this;

			this.goToState = this.$rootScope.transition.from();
			this.goToStateParams = this.$rootScope.transition.params('from');
			this.theState = this.goToState.name;
			if (this.theState === "") {
				if (this.defaultBack) {
					this.theState = this.defaultBack;
				} else {
					this.theState = this.goToState.url;
				}
				this.simpleBack = this.theState;
			} else {
				this.breadcrumb = this.$rootScope.breadcrumbHistory.reverse().find(function (breadcrumb) {
					return breadcrumb.name == _this.theState;
				});
			}
		}
	}, {
		key: "goBack",
		value: function goBack() {
			if (this.simpleBack && this.reloadSimpleBack) {
				this.$state.go(this.theState, this.goToStateParams, { reload: this.theState });
			} else {
				this.$state.go(this.theState, this.goToStateParams);
			}
		}
	}]);

	return Controller;
}();

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            if (this.companyUserId) {
                this.href = this.$state.href('company.user-directories.manage-user', { companyUserId: this.companyUserId });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _directoryIntegration = __webpack_require__(56);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.iconClass = {
                'saaspass-cloud-directory': 'fa fa-database',
                AD: 'fa-solid fa-audio-description',
                AZURE: 'fa-solid fa-diamond',
                LDAP: 'fa-solid fa-sharp fa-l',
                SCIM: 'fa-solid fa-rotate'
            }[this.directoryDto ? this.directoryDto.type || 'AD' : 'saaspass-cloud-directory'];
        }
    }, {
        key: 'getStatusKey',
        value: function getStatusKey() {
            return (0, _directoryIntegration.getDirectoryStatusTextKey)(this.directoryDto.statusDto.ongoingOperation);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', 'Alert'];

    /** @ngInject */
    function Controller($q, Alert) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.imageMaxSize == null) {
                this.imageMaxSize = 1000000;
            }
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.isEditing = false;
        }
    }, {
        key: 'edit',
        value: function edit() {
            this.imageFile = null;
            this.isEditing = true;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.$q.resolve(this.onSave({ $value: this.imageFile })).finally(function () {
                return _this.isEditing = _this.isSaving = false;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            var _this2 = this;

            this.isSaving = true;
            this.$q.resolve(this.onReset()).finally(function () {
                return _this2.isEditing = _this2.isSaving = false;
            });
        }
    }, {
        key: 'fileNameChanged',
        value: function fileNameChanged() {
            if (this.imageFile.size > this.imageMaxSize) {
                this.Alert('danger', 'Photo should be smaller than ' + this.imageMaxSize / 1000000 + 'MB');
                this.imageFile = null;
            }
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return this.imageFile == null;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$q"];

    /** @ngInject */
    function Controller($q) {
        _classCallCheck(this, Controller);

        this.$q = $q;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "cancel",
        value: function cancel() {
            this.isEditing = false;
        }
    }, {
        key: "edit",
        value: function edit() {
            this.$value = this.initialValue;
            this.isEditing = true;
        }
    }, {
        key: "save",
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.$q.resolve(this.onSave({ $value: this.$value })).finally(function () {
                return _this.isEditing = _this.isSaving = false;
            });
        }
    }, {
        key: "notModified",
        value: function notModified() {
            return this.$value === this.initialValue;
        }
    }, {
        key: "onKeyUp",
        value: function onKeyUp($event, form) {
            if ($event.keyCode === 13) {
                form.$valid && !this.notModified() && this.save();
            } else if ($event.keyCode === 27) {
                this.cancel();
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$scope', 'Alert'];

    /** @ngInject */
    function Controller($q, $scope, Alert) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$scope = $scope;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.isEditing = false;
        }
    }, {
        key: 'edit',
        value: function edit() {
            this.$value = this.initialValue;
            if (this.isPasswordHidden) {
                this.$value = "V1kU94U33i";
            }
            this.isEditing = true;
        }
    }, {
        key: 'generate',
        value: function generate() {
            var _this2 = this;

            this.isSaving = true;
            this.onGenerate().then(function (password) {
                return _this2.$value = password;
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this3 = this;

            this.isSaving = true;
            this.$q.resolve(this.onSave({ $value: this.$value })).finally(function () {
                return _this3.isEditing = _this3.isSaving = _this3.showPassword = false;
            });
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return this.$value === this.initialValue;
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp($event) {
            if ($event.keyCode === 13) {
                this.form.$valid && !this.notModified() && this.save();
            } else if ($event.keyCode === 27) {
                this.cancel();
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var escapeRegExp = exports.escapeRegExp = function escapeRegExp(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

var regExp = exports.regExp = function regExp(s) {
    var p = s.split(/\s+/).filter(Boolean).map(escapeRegExp).join('|');
    return p ? new RegExp('(' + p + ')', 'gi') : /.*/gi;
};

var highlight = exports.highlight = function highlight(regexp) {
    return function (text) {
        return text.replace(regexp, '<mark>$1</mark>');
    };
};

var matchLength = exports.matchLength = function matchLength(regexp) {
    return function (text) {
        return (text.match(regexp) || []).map(function (m) {
            return m.length;
        }).reduce(function (a, b) {
            return a + b;
        }, 0);
    };
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _store = __webpack_require__(19);

var _states = __webpack_require__(322);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function () {
    return _store.resolve.currentCompany.companyType === 'RESELLER' ? [].concat(_toConsumableArray(_states2.default)) : _states2.default.filter(function (name) {
        return !name.startsWith('company.reseller');
    });
};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['company.administrators', 'company.administrators.add', 'company.applications', 'company.computer-protection', 'company.corporate-settings', 'company.custom-app-integration', 'company.directory-integration', 'company.directory-integration.add-active-directory', 'company.domains', 'company.google-hangouts-bot', 'company.google-marketplace-instructions', 'company.hard-token-management', 'company.landing-page', 'company.recovery', 'company.reports-administrator-audit', 'company.reports-application-usage', 'company.reports-computers', 'company.reports-main', 'company.reseller', 'company.reseller.add-new-company', 'company.resources', 'company.roles-help',
// 'company.saaspass-vpn',
'company.saaspass-connect', 'company.sharing-center', 'company.sharing-center.shared-accounts', 'company.sharing-center.shared-authenticators', 'company.sharing-center.shared-passwords', 'company.slack-info', 'company.sms-services', 'company.sms-services.help', 'company.sms-services.help.how-to-add-sms-user', 'company.sms-services.help.sms-credit', 'company.sms-services.help.sms-settings', 'company.sms-services.help.what-is-sms-service', 'company.supported-application-types', 'company.supported-epm-types', 'company.user-directories.directory-groups', 'company.user-directories.directory-groups.all-accounts', 'company.user-directories.directory-groups.all-accounts.verify', 'company.user-directories.directory-groups.directory.add-new-group', 'company.user-directories.directory-groups.directory.add-user', 'company.user-directories.directory-groups.directory.import-users', 'company.user-directories.saaspass-users', 'company.user-directories.saaspass-users.administrators-developers', 'company.user-directories.saaspass-users.all-users', 'company.user-directories.saaspass-users.blocked-users', 'company.user-directories.saaspass-users.hard-token-users', 'company.user-directories.saaspass-users.regular-saaspass-app-users', 'company.user-directories.saaspass-users.sms-users', 'company.user-directories.saaspass-users.sms-users.add', 'company.user-directories.saaspass-users.user-settings', 'company.whats-new', 'gmp-config', 'public.company-registration', 'public.contact', 'public.email-verification', 'public.extension-alert', 'public.google-info', 'public.hard-token-login', 'public.hard-token-sync', 'public.login', 'public.logout', 'public.pin-reset', 'public.sms-user-otp', 'public.sms-user-registration', 'user', 'user.applications', 'user.connectors', 'user.device-management', 'user.emails', 'user.mobile-numbers', 'user.mobile-numbers.add', 'user.mobile-numbers.recovery-settings', 'user.public.user-accounts', 'user.public.user-accounts.import', 'user.profiles', 'user.shared-accounts', 'user.statistics'];

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _functions = __webpack_require__(320);

var _searchableStates = __webpack_require__(321);

var _searchableStates2 = _interopRequireDefault(_searchableStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$state', '$translate'];

    /** @ngInject */
    function Controller($scope, $state, $translate) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
        this.$translate = $translate;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$on('breadcrumb-data-changed', function () {
                return _this.init();
            });
            this.$scope.$on('language-loaded', function () {
                return _this.init();
            });
            this.init();
        }
    }, {
        key: 'init',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this2 = this;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Promise.all((0, _searchableStates2.default)().map(function (name) {
                                    return Promise.all(name.split('.').map(function (token, index, tokens) {
                                        return tokens.slice(0, index + 1).join('.');
                                    }).map(function (breadcrumb) {
                                        return _this2.$translate(breadcrumb + '.$title').catch(function () {
                                            return '';
                                        });
                                    })).then(function (breadcrumbs) {
                                        return breadcrumbs.filter(Boolean);
                                    }).then(function (breadcrumbs) {
                                        return breadcrumbs.reverse();
                                    }).then(function (breadcrumbs) {
                                        return { name: name, breadcrumbs: breadcrumbs };
                                    });
                                }));

                            case 2:
                                this.allItems = _context.sent;


                                this.searchText = '';
                                this.filter();

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function init() {
                return _ref.apply(this, arguments);
            }

            return init;
        }()
    }, {
        key: 'filter',
        value: function filter() {
            var input = this.searchText;

            if (!input) {
                this.filteredItems = [];
                return;
            }

            var regexp = (0, _functions.regExp)(input);

            this.filteredItems = this.allItems.filter(function (_ref2) {
                var breadcrumbs = _ref2.breadcrumbs,
                    name = _ref2.name;
                return [name].concat(_toConsumableArray(breadcrumbs)).some(function (b) {
                    return regexp.test(b);
                });
            }).map(function (_ref3) {
                var breadcrumbs = _ref3.breadcrumbs,
                    name = _ref3.name;
                return {
                    name: name,
                    breadcrumbs: breadcrumbs.map((0, _functions.highlight)(regexp)),
                    score: [name].concat(_toConsumableArray(breadcrumbs)).map((0, _functions.matchLength)(regexp)).reduce(function (a, b) {
                        return a + b;
                    }, 0)
                };
            });
        }
    }, {
        key: 'handleSearchChange',
        value: function handleSearchChange() {
            this.filter();
            this.openDropdown();
        }
    }, {
        key: 'handleSelect',
        value: function handleSelect(state) {
            var _this3 = this;

            this.$state.go(state.name).then(function () {
                return _this3.init();
            });
        }
    }, {
        key: 'openDropdown',
        value: function openDropdown() {
            this.dropdownIsOpen = !!this.searchText && !!this.filteredItems.length;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spGroupType = __webpack_require__(132);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.groupTypeLabel = (0, _spGroupType.groupTypeLabel)(this.groupType);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spGroupType = __webpack_require__(132);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.tooltipKey = (0, _spGroupType.groupTypeLabel)(this.groupType);

            this.iconClass = {
                AD: 'text-primary fa-solid fa-audio-description',
                AZURE_AD: 'text-primary fa-solid fa-diamond',
                SCIM_DIRECTORY: 'text-primary fa fa-lg fa-users',
                AD_DOMAIN: 'text-primary fa-solid fa-audio-description',
                AD_GROUP: 'text-primary fa fa-lg fa-users',
                AZURE_GROUP: 'text-primary fa fa-lg fa-users',
                AD_OU: 'text-primary fa fa-lg fa-sitemap',
                APPLICATION: 'text-primary fa fa-lg fa-list-alt',
                CUSTOM: 'text-primary fa fa-lg fa-wrench',
                DOMAIN: 'text-primary fa fa-lg fa-database',
                EVERYONE: 'text-primary fa fa-lg fa-users',
                EXTERNAL_EMAILS: 'text-primary fa fa-lg fa-envelope',
                PHONE_NUMBERS: 'text-primary fa fa-lg fa-phone',
                UNKNOWN: 'text-primary fa fa-lg fa-ban'
            }[this.groupType];
        }
    }]);

    return Controller;
}();

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var hiddenBreadcrumbs = exports.hiddenBreadcrumbs = ['company.administrators.list', 'company.directory-integration.add-active-directory', 'company.directory-integration.manage.connection', 'company.directory-integration.manage.connection.ou-imported', 'company.directory-integration.manage.domains', 'company.directory-integration.manage.domains.add-domain', 'company.directory-integration.manage.domains.delete-domain', 'company.directory-integration.manage.domains.edit-domain', 'company.directory-integration.manage.main', 'company.directory-integration.manage.main.remove', 'company.manage-application.configuration', 'company.manage-application.dropbox-provisioning', 'company.manage-application.integration-developers', 'company.manage-application.integration-developers.app-key-password', 'company.manage-application.integration-developers.configure-sso', 'company.manage-application.integration-developers.help', 'company.manage-application.integration-developers.integration', 'company.manage-application.integration-developers.integration-office-365', 'company.manage-application.integration-developers.manual-integration', 'company.manage-application.integration-developers.non-domain-protection-key', 'company.manage-application.integration-developers.remove-configuration', 'company.manage-application.integration-developers.simulators', 'company.manage-application.integration-developers.widgets', 'company.manage-application.mobile-app-support', 'company.manage-application.remove', 'company.manage-application.roles', 'company.manage-application.roles.add', 'company.manage-application.roles.edit', 'company.manage-application.usage-data', 'company.manage-application.user-provisioning', 'company.manage-application.users', 'company.manage-application.users.assign-groups', 'company.sms-services.help.how-to-add-sms-user', 'company.sms-services.help.sms-credit', 'company.sms-services.help.sms-settings', 'company.sms-services.help.what-is-sms-service', 'company.sms-services.invoice', 'company.sms-services.paypal-cancelled', 'company.sms-services.paypal-confirmed', 'company.user-directories', 'company.user-directories.directory-groups.all-accounts.copy', 'company.user-directories.directory-groups.all-accounts.delete', 'company.user-directories.directory-groups.all-accounts.export', 'company.user-directories.directory-groups.all-accounts.verify', 'company.user-directories.directory-groups.directory.add-new-group', 'company.user-directories.directory-groups.directory.add-user', 'company.user-directories.directory-groups.directory.import-users.upload-result', 'company.user-directories.manage-account.change-owner', 'company.user-directories.manage-account.details', 'company.user-directories.manage-account.groups-apps', 'company.user-directories.manage-account.groups-apps.add-to-groups', 'company.user-directories.manage-account.profile-attributes', 'company.user-directories.manage-account.profile-attributes.edit', 'company.user-directories.manage-account.send-verification-email', 'company.user-directories.manage-account.verify', 'company.user-directories.manage-group.accounts', 'company.user-directories.manage-group.accounts.add', 'company.user-directories.manage-group.accounts.copy', 'company.user-directories.manage-group.accounts.delete', 'company.user-directories.manage-group.accounts.export', 'company.user-directories.manage-group.accounts.import', 'company.user-directories.manage-group.accounts.import.result', 'company.user-directories.manage-group.accounts.move', 'company.user-directories.manage-group.accounts.verify', 'company.user-directories.manage-group.applications', 'company.user-directories.manage-group.applications.assign', 'company.user-directories.manage-group.settings', 'company.user-directories.manage-user.add-account', 'company.user-directories.manage-user.copy-accounts', 'company.user-directories.manage-user.copy-shared-accounts', 'company.user-directories.manage-user.delete-accounts', 'company.user-directories.manage-user.details', 'company.user-directories.manage-user.edit-display-name', 'company.user-directories.manage-user.move-accounts', 'company.user-directories.manage-user.move-shared-accounts', 'company.user-directories.manage-user.remove-accounts'];

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(19);

var _hiddenBreadcrumbs = __webpack_require__(326);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope'];

    /** @ngInject */
    function Controller($rootScope) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {

            this.accountRole = _store.resolve.currentCompany;
            this.companyStatus = this.accountRole.companyStatus;
            this.colorClass = this.companyStatus === 'ACTIVE' ? '' : 'sp_colorRedTex';
        }
    }, {
        key: 'visibleBreadcrumbs',
        value: function visibleBreadcrumbs() {
            return (this.$rootScope.breadcrumbs || []).filter(function (b) {
                return !_hiddenBreadcrumbs.hiddenBreadcrumbs.includes(b.name);
            });
        }
    }, {
        key: 'child',
        value: function child() {
            return this.visibleBreadcrumbs().slice(-1)[0];
        }
    }, {
        key: 'parents',
        value: function parents() {
            return this.visibleBreadcrumbs().slice(0, -1);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$stateParams', '$window', 'LicenseManagementService'];

    /** @ngInject */
    function Controller($stateParams, $window, LicenseManagementService) {
        _classCallCheck(this, Controller);

        this.$stateParams = $stateParams;
        this.$window = $window;
        this.LicenseManagementService = LicenseManagementService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.licenseInfo.licenseStatus == 'LICENSED') {
                this.licenseManagementSref = 'company.license-management';
            } else {
                this.licenseManagementSref = 'company.license-management.purchase-license';
            }
        }
    }, {
        key: '$onChanges',
        value: function $onChanges() {}
    }, {
        key: 'setPaymentMethod',
        value: function setPaymentMethod() {
            var _this = this;

            this.LicenseManagementService.setPaymentMethod(this.$stateParams.companyId).then(function (url) {
                _this.$window.open(url, '_blank');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spRoleType = __webpack_require__(57);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.tooltipKey = (0, _spRoleType.roleTypeLabel)(this.roleType);
            this.tooltipDesc = (0, _spRoleType.roleTypeDescription)(this.roleType);
            this.iconClass = 'text-primary fa fa-lg ' + (0, _spRoleType.roleTypeIconClass)(this.roleType);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sessionRecordingTypes = exports.sessionRecordingTypes = ['NONE', 'VIDEO', 'TEXT', 'BOTH'];

var sessionRecordingTypeLabel = exports.sessionRecordingTypeLabel = function sessionRecordingTypeLabel(sessionRecordingType) {
    return {
        NONE: 'company.manage-application.configuration.session-recording.recording-type.none',
        VIDEO: 'company.manage-application.configuration.session-recording.recording-type.video',
        TEXT: 'company.manage-application.configuration.session-recording.recording-type.text',
        BOTH: 'company.manage-application.configuration.session-recording.recording-type.both'
    }[sessionRecordingType];
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spUserStatus = __webpack_require__(332);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.tooltipKey = (0, _spUserStatus.companyUserStatusLabel)(this.status, this.blockedStatus);
            this.iconClass = (0, _spUserStatus.companyUserStatusIconClass)(this.status, this.blockedStatus);
            this.textClass = (0, _spUserStatus.companyUserStatusTextClass)(this.status, this.blockedStatus);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.companyUserStatusLabel = companyUserStatusLabel;
exports.companyUserStatusIconClass = companyUserStatusIconClass;
exports.companyUserStatusTextClass = companyUserStatusTextClass;
function companyUserStatusLabel(status, blockedStatus) {
    var statusLabel = void 0;
    if (blockedStatus && blockedStatus != 'NONE') {
        statusLabel = 'company.user-status.blocked';
    } else {
        statusLabel = {
            UNKNOWN: 'company.user-status.unkonwn',
            ACTIVE: 'company.user-status.active',
            PENDING: 'company.user-status.pending',
            PAUSED: 'company.user-status.paused'
        }[status];
    }
    return statusLabel;
}

function companyUserStatusIconClass(status, blockedStatus) {
    var statusIconClass = void 0;
    if (blockedStatus && blockedStatus != 'NONE') {
        statusIconClass = 'fa fa-lg fa-ban';
    } else {
        statusIconClass = {
            UNKNOWN: 'far fa-lg fa-question-circle',
            ACTIVE: 'far fa-lg fa-check-circle',
            PENDING: 'far fa-lg fa-clock',
            PAUSED: 'far fa-lg fa-circle-pause'
        }[status];
    }
    return statusIconClass;
}

function companyUserStatusTextClass(status, blockedStatus) {
    var statusTextClass = void 0;
    if (blockedStatus && blockedStatus != 'NONE') {
        statusTextClass = 'text-ban';
    } else {
        statusTextClass = {
            UNKNOWN: 'text-muted',
            ACTIVE: 'text-success',
            PENDING: 'text-warning',
            PAUSED: 'text-warning'
        }[status];
    }
    return statusTextClass;
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.tooltipKey = {
                HARD_TOKEN_USER: 'sp-user-type.hard-token-user',
                REGULAR_USER: 'sp-user-type.regular-user',
                SMS_USER: 'sp-user-type.sms-user'
            }[this.userType];

            this.iconClass = {
                HARD_TOKEN_USER: 'text-primary fas fa-lg fa-calculator',
                REGULAR_USER: 'text-primary fa fa-lg fa-mobile-alt',
                SMS_USER: 'text-primary fa fa-lg fa-comment'
            }[this.userType];
        }
    }]);

    return Controller;
}();

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.tooltipKey = {
                ADMIN: 'sp-verification-source.admin',
                ADMIN_BY_AD_ACCOUNT: 'sp-verification-source.admin-by-ad-account',
                ADMIN_BY_FACEBOOK_VERIFIED_EMAIL: 'sp-verification-source.admin-by-facebook-verified-email',
                ADMIN_BY_MOBILE_NUMBER: 'sp-verification-source.admin-by-mobile-number',
                ADMIN_BY_SPID: 'sp-verification-source.admin-by-spid',
                ADMIN_BY_USER_VERIFIED_EMAIL: 'sp-verification-source.admin-by-user-verified-email',
                ADMIN_BY_VERIFIED_EMAIL: 'sp-verification-source.admin-by-verified-email',
                ANOTHER_COMPANY: 'sp-verification-source.another-company',
                THIRD_PARTY_FACEBOOK: 'sp-verification-source.third-party-facebook',
                USER: 'sp-verification-source.user'
            }[this.verificationSource];

            this.iconClass = {
                ADMIN: 'text-primary fa fa-lg fa-user',
                ADMIN_BY_AD_ACCOUNT: 'text-primary fa-solid fa-audio-description',
                ADMIN_BY_FACEBOOK_VERIFIED_EMAIL: 'text-primary fa fa-lg fa-facebook',
                ADMIN_BY_MOBILE_NUMBER: 'text-primary fa fa-lg fa-phone',
                ADMIN_BY_SPID: 'text-primary fa fa-lg fa-user',
                ADMIN_BY_USER_VERIFIED_EMAIL: 'text-primary fa fa-lg fa-envelope',
                ADMIN_BY_VERIFIED_EMAIL: 'text-primary fa fa-lg fa-envelope',
                ANOTHER_COMPANY: 'text-primary fa fa-lg fa-building',
                THIRD_PARTY_FACEBOOK: 'text-primary fa fa-lg fa-facebook-official',
                USER: 'text-primary fa fa-lg fa-user-circle'
            }[this.verificationSource];
        }
    }]);

    return Controller;
}();

/***/ }),
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var timezones = exports.timezones = [{
    name: "(UTC-12:00) International Date Line West",
    offsetHour: -12,
    offsetMin: 0
}, {
    name: "(UTC-10:00) Aleutian Islands, Hawaii",
    offsetHour: -10,
    offsetMin: 0
}, {
    name: "(UTC-09:30) Marquesas Islands",
    offsetHour: -9,
    offsetMin: 30
}, {
    name: "(UTC-09:00) Alaska",
    offsetHour: -9,
    offsetMin: 0
}, {
    name: "(UTC-08:00) Baja California, Pacific Time (US & Canada)",
    offsetHour: -8,
    offsetMin: 0
}, {
    name: "(UTC-07:00) Arizona, Chihuahua, La Paz, Mazatlan, Mountain Time (US & Canada)",
    offsetHour: -7,
    offsetMin: 0
}, {
    name: "(UTC-06:00) Central America, Central Time (US & Canada) Easter Island, Guadalajara, Mexico City, Monterrey, Saskatchewan",
    offsetHour: -6,
    offsetMin: 0
}, {
    name: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco, Chetumal, Eastern Time (US & Canada), Haiti, Havana, Indiana (East), Turks and Caicos",
    offsetHour: -5,
    offsetMin: 0
}, {
    name: "(UTC-04:00) Asuncion, Atlantic Time (Canada), Caracas, Cuiaba, Georgetown, La Paz, Manaus, San Juan, Santiago",
    offsetHour: -4,
    offsetMin: 0
}, {
    name: "(UTC-03:30) Newfoundland",
    offsetHour: -3,
    offsetMin: 30
}, {
    name: "(UTC-03:00) Araguaina, Brasilia, Cayenne, Fortaleza, City of Buenos Aires, Greenland, Montevideo, Punta Arenas, Saint Pierre and Miquelon, Salvador",
    offsetHour: -3,
    offsetMin: 0
}, {
    name: "(UTC-02:00) Mid-Atlantic - Old",
    offsetHour: -2,
    offsetMin: 0
}, {
    name: "(UTC-01:00) Azores, Cabo Verde Is",
    offsetHour: -1,
    offsetMin: 0
}, {
    name: "(UTC 00:00) Coordinated Universal Time, Casablanca, Dublin, Edinburgh, Lisbon, London, Monrovia, Reykjavik",
    offsetHour: 0,
    offsetMin: 0
}, {
    name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna, Belgrade, Bratislava, Budapest, Ljubljana, Prague, Brussels, Copenhagen, Madrid, Paris, Sao Tome, Sarajevo, Skopje, Warsaw, Zagreb, West Central Africa",
    offsetHour: 1,
    offsetMin: 0
}, {
    name: "(UTC+02:00) Amman, Athens, Bucharest, Beirut, Cairo, Chisinau, Damascus, Gaza, Hebron, Harare, Pretoria, Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius, Jerusalem, Kaliningrad, Khartoum, Tripoli, Windhoek",
    offsetHour: 2,
    offsetMin: 0
}, {
    name: "(UTC+03:00) Baghdad, Istanbul, Kuwait, Riyadh, Minsk, Moscow, St. Petersburg, Volgograd, Nairobi",
    offsetHour: 3,
    offsetMin: 0
}, {
    name: "(UTC+03:30) Tehran",
    offsetHour: 3,
    offsetMin: 30
}, {
    name: "(UTC+04:00) Abu Dhabi, Muscat, Astrakhan, Ulyanovsk, Baku, Izhevsk, Samara, Port Louis, Saratov, Tbilisi, Yerevan",
    offsetHour: 4,
    offsetMin: 0
}, {
    name: "(UTC+04:30) Kabul",
    offsetHour: 4,
    offsetMin: 30
}, {
    name: "(UTC+05:00) Ashgabat, Tashkent, Ekaterinburg, Islamabad, Karachi",
    offsetHour: 5,
    offsetMin: 0
}, {
    name: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi, Sri Jayawardenepura",
    offsetHour: 5,
    offsetMin: 30
}, {
    name: "(UTC+05:45) Kathmandu",
    offsetHour: 5,
    offsetMin: 45
}, {
    name: "(UTC+06:00) Astana, Dhaka, Omsk",
    offsetHour: 6,
    offsetMin: 0
}, {
    name: "(UTC+06:30) Yangon (Rangoon)",
    offsetHour: 6,
    offsetMin: 30
}, {
    name: "(UTC+07:00) Bangkok, Hanoi, Jakarta, Barnaul, Gorno-Altaysk, Hovd, Krasnoyarsk, Novosibirsk, Tomsk",
    offsetHour: 7,
    offsetMin: 0
}, {
    name: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi, Irkutsk, Kuala Lumpur, Singapore, Perth, Taipei, Ulaanbaatar",
    offsetHour: 8,
    offsetMin: 0
}, {
    name: "(UTC+08:45) Eucla",
    offsetHour: 8,
    offsetMin: 45
}, {
    name: "(UTC+09:00) Chita, Osaka, Sapporo, Tokyo, Pyongyang, Seoul, Yakutsk",
    offsetHour: 9,
    offsetMin: 0
}, {
    name: "(UTC+09:30) Adelaide, Darwin",
    offsetHour: 9,
    offsetMin: 30
}, {
    name: "(UTC+10:00) Brisbane, Canberra, Melbourne, Sydney, Guam, Port Moresby, Hobart, Vladivostok",
    offsetHour: 10,
    offsetMin: 0
}, {
    name: "(UTC+10:30) Lord Howe Island",
    offsetHour: 10,
    offsetMin: 30
}, {
    name: "(UTC+11:00) Bougainville Island, Chokurdakh, Magadan, Norfolk Island, Sakhalin, Solomon Is., New Caledonia",
    offsetHour: 11,
    offsetMin: 0
}, {
    name: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky, Auckland, Wellington, Fiji, Petropavlovsk-Kamchatsky - Old",
    offsetHour: 12,
    offsetMin: 0
}, {
    name: "(UTC+12:45) Chatham Islands",
    offsetHour: 12,
    offsetMin: 45
}, {
    name: "(UTC+13:00) Nuku'alofa, Samoa",
    offsetHour: 13,
    offsetMin: 0
}];

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sessionId = __webpack_require__(22);

var _userAgent = __webpack_require__(13);

var _u2fApi = __webpack_require__(135);

var _yubicoWebauthn = __webpack_require__(72);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$http', '$rootScope', '$scope', '$timeout', '$window', 'Alert', 'BarcodeGeneratonService', 'HardTokenResource'];

    /** @ngInject */
    function Controller($http, $rootScope, $scope, $timeout, $window, Alert, BarcodeGeneratonService, HardTokenResource) {
        _classCallCheck(this, Controller);

        this.$http = $http;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$window = $window;
        this.Alert = Alert;
        this.BarcodeGeneratonService = BarcodeGeneratonService;
        this.HardTokenResource = HardTokenResource;
    }

    _createClass(Controller, [{
        key: '$onDestroy',
        value: function $onDestroy() {
            this.isModalOpen = false;
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isModalOpen = true;
            var _resolve$config = this.resolve.config,
                titleKey = _resolve$config.titleKey,
                textKey = _resolve$config.textKey,
                http = _resolve$config.http;

            this.titleKey = titleKey || 'destructive_operation.enter_onetime_password';
            this.textKey = textKey;
            this.http = http;
            this.otp = '';
            this.isSmsUser = this.$rootScope.account.roles.includes('ROLE_SMS_USER');

            this.$scope.$on('websocket.LOGIN', function (event, data) {
                _this.sendRequest('tracker', data.password);
            });

            // this.isMacOS = ua.isMacOS();
            // Proximity removed by Faking the user agent check
            this.isMacOS = false;

            this.initializeHardTokens();
        }
    }, {
        key: 'activateProximity',
        value: function activateProximity() {
            var _this2 = this;

            this.proximityActivated = true;
            this.$timeout(3000).then(function () {
                return _this2.proximityActivated = false;
            });
        }
    }, {
        key: 'initializeHardTokens',
        value: function initializeHardTokens() {
            var _this3 = this;

            var _$rootScope$account = this.$rootScope.account,
                roles = _$rootScope$account.roles,
                isSecondaryDeviceSession = _$rootScope$account.isSecondaryDeviceSession;

            this.isHardTokenUser = roles.includes('ROLE_HARD_TOKEN_USER') || isSecondaryDeviceSession;

            if (!this.isHardTokenUser) {
                return;
            }

            this.isLoading = true;
            this.HardTokenResource.u2fLoginStart(this.$rootScope.account.login).then(function (data) {
                _this3.isU2fAvailable = true;
                _this3.selectTab('u2f');
                var credOpts = (0, _yubicoWebauthn.convertStartAuthResponse)(data);
                _this3.$window.navigator.credentials.get(credOpts).then(function (credentials) {
                    var finishRegRequest = (0, _yubicoWebauthn.convertFinishAuthRequest)(credentials, data);
                    _this3.sendRequest('u2f', JSON.stringify(finishRegRequest));
                }).catch(function (error) {
                    console.log(error);
                });
            }).catch(function () {
                _this3.isU2fAvailable = false;
                _this3.selectTab('usb');
            }).finally(function () {
                return _this3.isLoading = false;
            });
        }
    }, {
        key: 'loadQrData',
        value: function loadQrData() {
            var _this4 = this;

            return this.BarcodeGeneratonService.get({ uuid: '#V#' + _sessionId.SESSION_ID }).$promise.then(function (_ref) {
                var bluetoothcode = _ref.bluetoothcode,
                    barcodeimage = _ref.barcodeimage;

                _this4.bluetoothCode = bluetoothcode;
                return barcodeimage;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isLoading || this.isSaving || this.selectedTab === 'u2f';
        }
    }, {
        key: 'selectTab',
        value: function selectTab(tabName) {
            this.otp = '';
            this.selectedTab = tabName;
        }
    }, {
        key: 'sendRequest',
        value: function sendRequest(passwordType, password) {
            var _this5 = this;

            this.isSaving = true;
            if (this.resolve.config.onSubmit) {
                return this.resolve.config.onSubmit(_defineProperty({}, passwordType, password)).then(function (response) {
                    return _this5.close({ $value: response });
                }).finally(function () {
                    return _this5.isSaving = false;
                });
            }
            this.$http(_extends({}, this.http, { params: _extends({}, this.http.params, _defineProperty({}, passwordType, password)) })).then(function (_ref2) {
                var data = _ref2.data;
                return _this5.close({ $value: data });
            }).finally(function () {
                return _this5.isSaving = false;
            });
        }
    }, {
        key: 'signU2f',
        value: function signU2f() {
            var _this6 = this;

            _u2fApi.u2f.sign(this.u2fSignRequests, function (_ref3) {
                var errorCode = _ref3.errorCode,
                    signResponse = _objectWithoutProperties(_ref3, ['errorCode']);

                if (!_this6.isModalOpen) {
                    return;
                }
                _this6.$scope.$apply(function () {
                    if (errorCode) {
                        if (_this6.selectedTab === 'u2f') {
                            _this6.Alert('danger', 'hard_token_login.messages.error.ERROR_' + errorCode);
                        }
                        _this6.u2fSignatureTimedOut = errorCode === 5;
                    } else {
                        _this6.sendRequest('u2f', JSON.stringify(signResponse));
                    }
                });
            });
            this.u2fSignatureTimedOut = false;
        }
    }, {
        key: 'submit',
        value: function submit() {
            this.sendRequest(this.isSmsUser ? 'pin' : 'otp', this.otp);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spRoleType = __webpack_require__(57);

var _administrators = __webpack_require__(104);

var _makeSelectables = __webpack_require__(136);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$filter', '$state', '$translate', 'Alert', 'Groups', 'RoleResource'];

    /** @ngInject */
    function Controller($filter, $state, $translate, Alert, Groups, RoleResource) {
        _classCallCheck(this, Controller);

        this.$filter = $filter;
        this.$state = $state;
        this.$translate = $translate;
        this.Alert = Alert;
        this.Groups = Groups;
        this.RoleResource = RoleResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.email = this.email || '';
            this.roleType = 'SUPER_ADMIN';
            this.userNotFound = false;
            this.applications = (0, _makeSelectables.makeSelectables)([], []);
            this.appTypes = (0, _makeSelectables.makeSelectables)([], []);
            this.groups = (0, _makeSelectables.makeSelectables)([], []);

            this.roleTypes = ['SUPER_ADMIN', 'DEVELOPER_ADMIN', 'APPLICATION_ADMIN', 'ORGANIZATION_ADMIN', 'SHARING_CENTER_ADMIN', 'READ_ONLY_ADMIN'];

            this.applications$.get().then(function (applications) {
                return _this.applications = (0, _makeSelectables.makeSelectables)([], applications);
            });
            this.appTypes$.get().then(function (types) {
                return _this.appTypes = (0, _makeSelectables.makeSelectables)([], types);
            });
            this.groups$.get().then(function (groups) {
                return _this.groups = (0, _makeSelectables.makeSelectables)([], groups);
            });
        }
    }, {
        key: 'roleTypeChanged',
        value: function roleTypeChanged() {
            if (this.roleType !== 'APPLICATION_ADMIN') {
                this.applications = (0, _makeSelectables.makeSelectables)([], this.applications.all());
                this.appTypes = (0, _makeSelectables.makeSelectables)([], this.appTypes.all());
            }
            if (this.roleType !== 'ORGANIZATION_ADMIN') {
                this.groups = (0, _makeSelectables.makeSelectables)([], this.groups.all());
            }
        }
    }, {
        key: 'roleTypeLabel',
        value: function roleTypeLabel(roleType) {
            return (0, _spRoleType.roleTypeLabel)(roleType);
        }
    }, {
        key: 'getNewConfig',
        value: function getNewConfig() {
            return {
                email: this.email,
                roleType: this.roleType,
                applicationIds: this.applications.getSelectedIds(),
                applicationTypeIds: this.appTypes.getSelectedIds(),
                groupIds: this.groups.getSelectedIds()
            };
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.isSaving = true;
            this.RoleResource.addNewRole(this.companyId, this.getNewConfig()).then(_administrators.userFromDto).then(function (user) {
                // replace existing user or append new one
                var i = _this2.administrators.findIndex(function (u) {
                    return u.email === _this2.email;
                });
                _this2.administrators.splice(i > -1 ? i : _this2.administrators.length, 1, user);
                _this2.Alert('success', 'company.administrators.add.added');
                _this2.$state.go('^');
            }).catch(function (response) {
                if (response.data.serviceErrorCode === "ERR_100802") {
                    _this2.userNotFound = true;
                }
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _spRoleType = __webpack_require__(57);

var _makeSelectables = __webpack_require__(136);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$filter', '$state', '$translate', 'Alert', 'DestructiveOperationModal', 'Groups', 'RoleResource'];

    /** @ngInject */
    function Controller($filter, $state, $translate, Alert, DestructiveOperationModal, Groups, RoleResource) {
        _classCallCheck(this, Controller);

        this.$filter = $filter;
        this.$state = $state;
        this.$translate = $translate;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.Groups = Groups;
        this.RoleResource = RoleResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.email = this.administrator.email;
            this.roleType = this.administrator.roleType;
            this.applications = (0, _makeSelectables.makeSelectables)(this.administrator.applicationIds, []);
            this.appTypes = (0, _makeSelectables.makeSelectables)(this.administrator.applicationTypeIds, []);
            this.groups = (0, _makeSelectables.makeSelectables)(this.administrator.groupIds, []);

            this.roleTypes = ['SUPER_ADMIN', 'DEVELOPER_ADMIN', 'APPLICATION_ADMIN', 'ORGANIZATION_ADMIN', 'SHARING_CENTER_ADMIN', 'READ_ONLY_ADMIN'];

            this.applications$.get().then(function (applications) {
                return _this.applications = (0, _makeSelectables.makeSelectables)(_this.administrator.applicationIds, applications);
            });
            this.appTypes$.get().then(function (types) {
                return _this.appTypes = (0, _makeSelectables.makeSelectables)(_this.administrator.applicationTypeIds, types);
            });
            this.groups$.get().then(function (groups) {
                return _this.groups = (0, _makeSelectables.makeSelectables)(_this.administrator.groupIds, groups);
            });
        }
    }, {
        key: 'roleTypeChanged',
        value: function roleTypeChanged() {
            if (this.roleType !== 'APPLICATION_ADMIN') {
                this.applications = (0, _makeSelectables.makeSelectables)([], this.applications.all());
                this.appTypes = (0, _makeSelectables.makeSelectables)([], this.appTypes.all());
            }
            if (this.roleType !== 'ORGANIZATION_ADMIN') {
                this.groups = (0, _makeSelectables.makeSelectables)([], this.groups.all());
            }
        }
    }, {
        key: 'roleTypeLabel',
        value: function roleTypeLabel(roleType) {
            return (0, _spRoleType.roleTypeLabel)(roleType);
        }
    }, {
        key: 'getOldConfig',
        value: function getOldConfig() {
            var _administrator = this.administrator,
                id = _administrator.id,
                email = _administrator.email,
                roleType = _administrator.roleType,
                applicationIds = _administrator.applicationIds,
                applicationTypeIds = _administrator.applicationTypeIds,
                groupIds = _administrator.groupIds;

            return { id: id, email: email, roleType: roleType, applicationIds: applicationIds, applicationTypeIds: applicationTypeIds, groupIds: groupIds };
        }
    }, {
        key: 'getNewConfig',
        value: function getNewConfig() {
            return {
                id: this.administrator.id,
                email: this.email,
                roleType: this.roleType,
                applicationIds: this.applications.getSelectedIds(),
                applicationTypeIds: this.appTypes.getSelectedIds(),
                groupIds: this.groups.getSelectedIds()
            };
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.getOldConfig(), this.getNewConfig());
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            var id = this.administrator.id;

            var index = this.administrators.findIndex(function (u) {
                return u.id === id;
            });

            var oldConfig = this.getOldConfig();
            var newConfig = this.getNewConfig();

            var onSuccess = function onSuccess() {
                _this2.Alert('success', 'company.administrators.edit.saved');
                _this2.$state.go('^', {}, { reload: '^' });
            };

            this.isSaving = true;
            if (oldConfig.email === newConfig.email && oldConfig.roleType === newConfig.roleType) {
                if (newConfig.roleType === 'APPLICATION_ADMIN') {
                    this.RoleResource.editApplicationAdminRole(this.companyId, newConfig).then(onSuccess).finally(function () {
                        return _this2.isSaving = false;
                    });
                } else if (newConfig.roleType === 'ORGANIZATION_ADMIN') {
                    this.RoleResource.editOrganizationAdminRole(this.companyId, newConfig).then(onSuccess).finally(function () {
                        return _this2.isSaving = false;
                    });
                }
            } else {
                this.DestructiveOperationModal({
                    titleKey: 'company.administrators.edit.title',
                    textKey: 'company.administrators.edit.are-you-sure',
                    onSubmit: function onSubmit(params) {
                        return _this2.RoleResource.removeRoleInCompany(_this2.companyId, id, params).then(function () {
                            return _this2.administrators.splice(index, 1);
                        }).then(function () {
                            return _this2.RoleResource.addNewRole(_this2.companyId, newConfig);
                        }).then(onSuccess);
                    }
                }).finally(function () {
                    return _this2.isSaving = false;
                });
            }
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving || this.notModified();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.


var _smartTable = __webpack_require__(2);

var _spRoleType = __webpack_require__(57);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$filter', 'Alert', 'DestructiveOperationModal', 'RoleResource'];

    /** @ngInject */
    function Controller($filter, Alert, DestructiveOperationModal, RoleResource) {
        _classCallCheck(this, Controller);

        this.$filter = $filter;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.RoleResource = RoleResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.filter = {
                roleType: undefined
            };
            this.roleTypes = [undefined].concat(_toConsumableArray(_spRoleType.roleTypes));
            this.fiterByRoleType();
        }
    }, {
        key: 'fiterByRoleType',
        value: function fiterByRoleType(roleType) {
            this.filter.roleType = roleType;
            this.filteredAdministrators = this.$filter('filter')(this.administrators, this.filter);
        }
    }, {
        key: 'removeAdministrator',
        value: function removeAdministrator(_ref) {
            var _this = this;

            var id = _ref.id;

            this.DestructiveOperationModal({
                titleKey: 'company.administrators.remove.title',
                textKey: 'company.administrators.remove.are-you-sure',
                onSubmit: function onSubmit(params) {
                    return _this.RoleResource.removeRoleInCompany(_this.companyId, id, params);
                }
            }).then(function () {
                _this.Alert('success', 'company.administrators.remove.removed');
                var index = _this.administrators.findIndex(function (a) {
                    return a.id === id;
                });
                _this.administrators.splice(index, 1);
                _this.$onInit();
            });
        }
    }, {
        key: 'roleTypeLabel',
        value: function roleTypeLabel(roleType) {
            return roleType ? (0, _spRoleType.roleTypeLabel)(roleType) : 'global.filter.all';
        }
    }, {
        key: 'unblockAdministrator',
        value: function unblockAdministrator(_ref2) {
            var _this2 = this;

            var id = _ref2.id;

            this.DestructiveOperationModal({
                titleKey: 'company.administrators.unblock.title',
                onSubmit: function onSubmit(params) {
                    return _this2.RoleResource.unblockUserInCompany(_this2.companyId, id, params);
                }
            }).then(function () {
                _this2.Alert('success', 'company.administrators.unblock.unblocked');
                _this2.administrators.find(function (a) {
                    return a.id === id;
                }).blockedType = 'NONE';
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(19);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.application) {
                this.key = 'configure_application.radius.configure_later';
            } else if (!this.application.applicationApiKey) {
                this.key = 'configure_application.radius.load-credentials';
            }
        }
    }, {
        key: 'loadCredentials',
        value: function loadCredentials() {
            if (this.application && !this.application.applicationApiKey) {
                _store.resolve.credentials$.get();
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _paths = __webpack_require__(137);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.application) {
                this.radiusProxyUrl = 'rest/applications/' + this.application.id + '/radiusproxy';
            }
        }
    }, {
        key: 'templateUrl',
        value: function templateUrl() {
            return (0, _paths.templateUrl)(this.appType);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', 'Alert'];

    /** @ngInject */
    function Controller($scope, Alert) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
            var baseURI = document.baseURI;
            this.endpoints = {
                'discovery': baseURI + '.well-known/oauth-authorization-server',
                'introspection': '' + baseURI + this.clientId + '/oauth/introspection',
                'authorization': baseURI + 'oauth/authorize',
                'token': baseURI + 'oauth/token'
            };
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials() {
            var _this2 = this;

            this.credentials$.get().then(function (data) {
                _this2.credentials = data;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', 'Alert'];

    /** @ngInject */
    function Controller($scope, Alert) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
            var baseURI = document.baseURI;
            this.endpoints = {
                'discovery': baseURI + '.well-known/openid-configuration',
                'jwks': '' + baseURI + this.clientId + '/.well-known/jwks.json',
                'authorization': baseURI + 'oauth/authorize',
                'token': baseURI + 'oauth/token',
                'userinfo': baseURI + 'oauth/userinfo',
                'logout': baseURI + 'oauth/logout'
            };
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials() {
            var _this2 = this;

            this.credentials$.get().then(function (data) {
                _this2.credentials = data;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', 'Alert'];

    /** @ngInject */
    function Controller($scope, Alert) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
        }
    }, {
        key: 'openUrl',
        value: function openUrl(url) {
            window.location.href = url;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['CompanyUserResource', '$rootScope', '$state', 'LicenseManagementService'];

    /** @ngInject */
    function Controller(CompanyUserResource, $rootScope, $state, LicenseManagementService) {
        _classCallCheck(this, Controller);

        this.CompanyUserResource = CompanyUserResource;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.LicenseManagementService = LicenseManagementService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.initCompanyRoles();
            this.initUserRoles();
            this.previousState = this.$state.current.name;
        }
    }, {
        key: 'companyRoleIconClass',
        value: function companyRoleIconClass(role) {
            return {
                'APPLICATION_ADMIN': 'fa fa-list-alt',
                'DEVELOPER_ADMIN': 'fa fa-wrench',
                'ORGANIZATION_ADMIN': 'fa fa-sitemap',
                'READ_ONLY_ADMIN': 'fa fa-eye',
                'SUPER_ADMIN': 'fa fa-building',
                'SAASPASS_ADMIN': 'fa fa-building'
            }[role];
        }
    }, {
        key: 'onUserCompaniesDropdownToggle',
        value: function onUserCompaniesDropdownToggle() {
            this.userCompaniesDropdownSearchKey = '';
        }
    }, {
        key: 'logAdminDevSwitchToCompany',
        value: function logAdminDevSwitchToCompany(companyId) {
            this.$rootScope.logCompanyAccessed$ = this.CompanyUserResource.logCompanyAccessed(companyId);
        }

        /** @private */

    }, {
        key: 'initCompanyRoles',
        value: function initCompanyRoles() {

            var role = this.currentCompany.authoritiesConstants;
            var hasRole = function hasRole() {
                for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
                    roles[_key] = arguments[_key];
                }

                return ['SAASPASS_ADMIN', 'SUPER_ADMIN', 'READ_ONLY_ADMIN'].concat(roles).includes(role);
            };

            this.canView = {
                'reseller': hasRole(),

                'saaspass-admin': role === 'SAASPASS_ADMIN',
                'directory-services': hasRole('ORGANIZATION_ADMIN'),
                'directory-groups': hasRole('ORGANIZATION_ADMIN'),
                'saaspass-users': hasRole(),
                'directory-integration': hasRole(),

                'applications-group': hasRole('APPLICATION_ADMIN', 'DEVELOPER_ADMIN'),
                'applications': hasRole('APPLICATION_ADMIN'),
                'sharing-center': hasRole(),
                'hard-token-management': hasRole(),
                'software-license-management': hasRole('APPLICATION_ADMIN'),
                'computer-protection': hasRole('APPLICATION_ADMIN'),
                'slack-info': hasRole(),
                'google-marketplace-instructions': hasRole(),
                'custom-app-integration': hasRole('DEVELOPER_ADMIN'),
                'idp-authenticators': hasRole('DEVELOPER_ADMIN'),
                'saaspass-connect': hasRole('DEVELOPER_ADMIN'),

                // 'saaspass-vpn': hasRole('DEVELOPER_ADMIN'),
                'saaspass-vpn': false,

                'sms-services': hasRole(),
                'policies': hasRole(),

                'recovery': hasRole(),
                'administrators': hasRole(),
                'reports-main': hasRole(),
                'corporate-settings': hasRole(),
                'license-management': this.licenseInfo && hasRole(),
                'domains': hasRole()
            };
        }

        /** @private */

    }, {
        key: 'initUserRoles',
        value: function initUserRoles() {
            this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
        }
    }, {
        key: 'isReseller',
        value: function isReseller() {
            return this.currentCompany.companyType === 'RESELLER';
        }
    }, {
        key: 'portalActionsRestricted',
        value: function portalActionsRestricted() {
            return this.licenseInfo.licenseStatus == 'UNLICENSED' && this.licenseInfo.portalActionsRestricted;
        }
    }, {
        key: 'showLicenseInfoBar',
        value: function showLicenseInfoBar() {
            var _this = this;

            var currentState = this.$state.current.name;
            if (!currentState.startsWith('company.license-management')) {
                if (this.previousState !== currentState) {
                    this.LicenseManagementService.licenseCheck(this.companyId).then(function (licenseInfo) {
                        _this.licenseInfo = licenseInfo;
                    });
                }
                this.previousState = currentState;
                if (!this.licenseInfo || this.licenseInfo.licenseStatus == 'LICENSED' && !this.licenseInfo.appsLoginRestricted && !this.licenseInfo.thereUnhandledViolation && !this.licenseInfo.showPaymentMethodWarning) {
                    return false;
                }
                return true;
            } else {
                return false;
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _applicationTypes = __webpack_require__(58);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AddApplicationModal', 'AddNewApplicationResource'];

    /** @ngInject */
    function Controller($state, AddApplicationModal, AddNewApplicationResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AddApplicationModal = AddApplicationModal;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    _createClass(Controller, [{
        key: 'addDomainBoundComputerProtection',
        value: function addDomainBoundComputerProtection() {
            var _this = this;

            this.appType$((0, _applicationTypes.appTypeId)('computer-login')).get().then(function (appType) {
                return _this.AddApplicationModal(appType);
            });
        }
    }, {
        key: 'addByodComputerProtection',
        value: function addByodComputerProtection() {
            var _this2 = this;

            this.AddNewApplicationResource.createSecureApp(this.companyId, (0, _applicationTypes.appTypeId)('computer-protection-without-ad')).then(function (app) {
                return _this2.$state.go('company.manage-application', { appId: app.id });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$state', '$uibModal', 'Account', 'Alert', 'CorporateSettingsService', 'DestructiveOperationModal', 'ConfirmModal'];

    /** @ngInject */
    function Controller($scope, $state, $uibModal, Account, Alert, CorporateSettingsService, DestructiveOperationModal, ConfirmModal) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.CorporateSettingsService = CorporateSettingsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.ConfirmModal = ConfirmModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.newSettings = angular.copy(this.settings);
            this.companyId = this.$state.params.companyId;
            this.credentialsInitialized = false;

            this.credentials = { key: null, secret: null, ipFilter: this.newSettings.ipFilter };
            this.setIpFilterVar();

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });

            this.href = this.$state.href('company.supported-application-types', { protocolstr: 'oauthoidc' });

            if (this.newSettings.accessPolicyId) {
                this.selectedPolicyId = this.newSettings.accessPolicyId;
            } else {
                this.selectedPolicyId = '-1';
            }
        }
    }, {
        key: 'accessPolicyChanged',
        value: function accessPolicyChanged() {
            var _this2 = this;

            this.CorporateSettingsService.setAdminAccessPolicy(this.companyId, this.selectedPolicyId).then(function () {
                _this2.Alert('success', 'global.messages.operation-successful');
            });
        }
    }, {
        key: 'setIpFilterVar',
        value: function setIpFilterVar() {
            this.ipFilters = this.credentials && this.credentials.ipFilter ? this.credentials.ipFilter.split(";") : null;
        }
    }, {
        key: 'clearNewSettings',
        value: function clearNewSettings() {
            this.newSettings = angular.copy(this.settings);
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials() {
            var _this3 = this;

            if (this.settings.hasCredentials) {
                var url = 'app/rest/company/' + this.companyId + '/getCredentials';
                this.DestructiveOperationModal({
                    titleKey: 'corporate.destructive_op.get_credentials.title',
                    textKey: 'corporate.destructive_op.get_credentials.text',
                    http: { method: 'GET', url: url }
                }).then(function (data) {
                    _this3.getCredentialsCallback(data);
                });
            }
        }
    }, {
        key: 'getCredentialsCallback',
        value: function getCredentialsCallback(data) {
            this.credentials = data;
            this.setIpFilterVar();
            this.credentialsInitialized = true;
            this.settings.hasCredentials = true;
            this.clearNewSettings();
        }
    }, {
        key: 'setIpFilterAndOrGenerateCredentialsDestructiveCallback',
        value: function setIpFilterAndOrGenerateCredentialsDestructiveCallback(data, message) {
            this.credentials = data;
            this.setIpFilterVar();
            this.credentialsInitialized = true;
            this.settings.hasCredentials = true;
            this.clearNewSettings();
            this.Alert('success', message);
        }
    }, {
        key: 'editCorporateProfile',
        value: function editCorporateProfile() {
            var _this4 = this;

            this.$uibModal.open({
                component: 'editCorporateProfile',
                resolve: { settings: function settings() {
                        return _this4.settings;
                    } }
            }).result.then(function (settings) {
                return _this4.save(settings);
            });
        }
    }, {
        key: 'editRecoverySettings',
        value: function editRecoverySettings() {
            var _this5 = this;

            this.CorporateSettingsService.save(this.companyId, this.settings).then(function (settings) {
                _this5.settings = settings;
                _this5.newSettings = angular.copy(_this5.settings);
                _this5.Alert('success', 'corporate.message.updated');
            });
        }
    }, {
        key: 'editIpAddressFilter',
        value: function editIpAddressFilter() {
            var _this6 = this;

            this.$uibModal.open({
                component: 'editCorporateIpAddressFilter',
                resolve: { credentials: function credentials() {
                        return _this6.credentials;
                    } }
            }).result.then(function (result) {
                _this6.credentials = result;
                _this6.setIpFilterVar();
                _this6.clearNewSettings();
                _this6.Alert('success', 'corporate.message.updated');
            });
        }
    }, {
        key: 'generateCredentials',
        value: function generateCredentials() {
            var _this7 = this;

            this.$uibModal.open({ component: 'generateCorporateCredentials' }).result.then(function () {
                return _this7.DestructiveOperationModal({
                    titleKey: 'corporate.destructive_op.generate_credentials.title',
                    textKey: 'corporate.destructive_op.generate_credentials.text',
                    http: {
                        method: 'GET',
                        url: 'app/rest/company/' + _this7.companyId + '/generateCredentials'
                    }
                });
            }).then(function (credentials) {
                _this7.setIpFilterAndOrGenerateCredentialsDestructiveCallback(credentials, 'corporate.message.credentials_updated');
            });
        }
    }, {
        key: 'save',
        value: function save(settings) {
            var _this8 = this;

            var numbers = [settings.phoneNumber, settings.phoneNumber2].filter(function (v) {
                return v;
            });

            var _ref = [].concat(_toConsumableArray(new Set(numbers)));

            settings.phoneNumber = _ref[0];
            settings.phoneNumber2 = _ref[1];


            this.CorporateSettingsService.save(this.companyId, settings).then(function () {
                _this8.settings = settings;
                _this8.Alert('success', 'corporate.message.updated');
                _this8.Account.reload();
            });
        }
    }, {
        key: 'openDynamicClientRegistrationInfoModal',
        value: function openDynamicClientRegistrationInfoModal() {
            console.log('openDynamicClientRegistrationInfoModal');
        }
    }, {
        key: 'dynamicClientRegistrationSwitchValueChanged',
        value: function dynamicClientRegistrationSwitchValueChanged(enable) {
            var _this9 = this;

            if (enable == this.settings.dynamicClientRegistrationEnabled) {
                return;
            }

            var messageKey = enable ? 'corporate.panel.dynamic_client_registration.enable.confirm' : 'corporate.panel.dynamic_client_registration.disable.confirm';
            this.newSettings.dynamicClientRegistrationEnabled = !enable;
            this.ConfirmModal({
                messageKey: messageKey,
                titleKey: 'sp-confirm.title'
            }).then(function () {
                if (enable) {
                    _this9.enableDynamicClientRegistration();
                } else {
                    _this9.disableDynamicClientRegistration();
                }
            }).finally(function () {
                return _this9.isSending = false;
            });
        }
    }, {
        key: 'enableDynamicClientRegistration',
        value: function enableDynamicClientRegistration() {
            var _this10 = this;

            this.CorporateSettingsService.enableDynamicClientRegistration(this.companyId).then(function (data) {
                _this10.settings.dynamicClientRegistrationEnabled = true;
                _this10.settings.registrationToken = data;
                _this10.clearNewSettings();
                _this10.Alert('success', 'corporate.message.updated');
            });
        }
    }, {
        key: 'disableDynamicClientRegistration',
        value: function disableDynamicClientRegistration() {
            var _this11 = this;

            this.CorporateSettingsService.disableDynamicClientRegistration(this.companyId).then(function () {
                _this11.settings.dynamicClientRegistrationEnabled = false;
                _this11.settings.registrationToken = null;
                _this11.clearNewSettings();
                _this11.Alert('success', 'corporate.message.updated');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _spAlert = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'CorporateSettingsService', 'DestructiveOperationModal'];

    /** @ngInject */
    function Controller($state, CorporateSettingsService, DestructiveOperationModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.CorporateSettingsService = CorporateSettingsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.credentials = angular.copy(this.resolve.credentials);
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            var ipFilter = this.credentials.ipFilter.trim();
            var companyId = this.$state.params.companyId;

            this.CorporateSettingsService.setIpFilter(companyId, ipFilter).then(function () {
                return _this.close({ $value: _this.credentials });
            }).catch(function () {
                var key = 'ip_address_filter.message.invalid';
                _this.spAlert = new _spAlert.SpAlert('danger', key);
            });
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return this.credentials.ipFilter === this.resolve.credentials.ipFilter;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.settings = angular.copy(this.resolve.settings);
        }
    }, {
        key: 'save',
        value: function save() {
            this.close({ $value: this.settings });
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            var neu = this.settings;
            var old = this.resolve.settings;
            return ['companyName', 'website', 'phoneNumber', 'phoneNumber2'].every(function (prop) {
                return !neu[prop] && !old[prop] || neu[prop] === old[prop];
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$state', '$uibModal', 'Account', 'Alert', 'CorporateSettingsService', 'DestructiveOperationModal'];

    /** @ngInject */
    function Controller($scope, $state, $uibModal, Account, Alert, CorporateSettingsService, DestructiveOperationModal) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.CorporateSettingsService = CorporateSettingsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.newSettings = angular.copy(this.settings);
            var companyId = this.companyId = this.$state.params.companyId;
            this.credentialsInitialized = false;
            this.credentials = { key: null, secret: null, ipFilter: null };
        }
    }, {
        key: 'setIpFilterVar',
        value: function setIpFilterVar() {
            this.ipFilters = this.credentials && this.credentials.ipFilter ? this.credentials.ipFilter.split(";") : null;
        }
    }, {
        key: 'clearNewSettings',
        value: function clearNewSettings() {
            this.newSettings = angular.copy(this.settings);
        }
    }, {
        key: 'getCredentials',
        value: function getCredentials() {
            var _this = this;

            if (this.settings.hasCredentials) {
                var url = 'app/rest/company/' + this.companyId + '/getCredentials';
                this.DestructiveOperationModal({
                    titleKey: 'corporate.destructive_op.get_credentials.title',
                    textKey: 'corporate.destructive_op.get_credentials.text',
                    http: { method: 'GET', url: url }
                }).then(function (data) {
                    _this.getCredentialsCallback(data);
                });
            }
        }
    }, {
        key: 'getCredentialsCallback',
        value: function getCredentialsCallback(data) {
            this.credentials = data;
            this.setIpFilterVar();
            this.credentialsInitialized = true;
            this.settings.hasCredentials = true;
            this.clearNewSettings();
        }
    }, {
        key: 'setIpFilterAndOrGenerateCredentialsDestructiveCallback',
        value: function setIpFilterAndOrGenerateCredentialsDestructiveCallback(data) {
            this.credentials = data;
            this.setIpFilterVar();
            this.credentialsInitialized = true;
            this.settings.hasCredentials = true;
            this.clearNewSettings();
            this.Alert('success', 'corporate.message.credentials_updated');
        }
    }, {
        key: 'editCorporateProfile',
        value: function editCorporateProfile() {
            var _this2 = this;

            this.$uibModal.open({
                component: 'editCorporateProfile',
                resolve: { settings: function settings() {
                        return _this2.settings;
                    } }
            }).result.then(function (settings) {
                return _this2.save(settings);
            });
        }
    }, {
        key: 'editRecoverySettings',
        value: function editRecoverySettings() {
            var _this3 = this;

            this.CorporateSettingsService.save(this.companyId, this.settings).then(function (settings) {
                _this3.settings = settings;
                _this3.newSettings = angular.copy(_this3.settings);
                _this3.Alert('success', 'corporate.message.updated');
            });
        }
    }, {
        key: 'editIpAddressFilter',
        value: function editIpAddressFilter() {
            var _this4 = this;

            this.$uibModal.open({
                component: 'editCorporateIpAddressFilter',
                resolve: { credentials: function credentials() {
                        return _this4.credentials;
                    } }
            }).result.then(function (credentials) {
                _this4.setIpFilterAndOrGenerateCredentialsDestructiveCallback(credentials);
            });
        }
    }, {
        key: 'generateCredentials',
        value: function generateCredentials() {
            var _this5 = this;

            this.$uibModal.open({ component: 'generateCorporateCredentials' }).result.then(function () {
                return _this5.DestructiveOperationModal({
                    titleKey: 'corporate.destructive_op.generate_credentials.title',
                    textKey: 'corporate.destructive_op.generate_credentials.text',
                    http: {
                        method: 'GET',
                        url: 'app/rest/company/' + _this5.companyId + '/generateCredentials'
                    }
                });
            }).then(function (credentials) {
                _this5.setIpFilterAndOrGenerateCredentialsDestructiveCallback(credentials);
            });
        }
    }, {
        key: 'save',
        value: function save(settings) {
            var _this6 = this;

            var numbers = [settings.phoneNumber, settings.phoneNumber2].filter(function (v) {
                return v;
            });

            var _ref = [].concat(_toConsumableArray(new Set(numbers)));

            settings.phoneNumber = _ref[0];
            settings.phoneNumber2 = _ref[1];


            this.CorporateSettingsService.save(this.companyId, settings).then(function () {
                _this6.settings = settings;
                _this6.Alert('success', 'corporate.message.updated');
                _this6.Account.reload();
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _applicationTypes = __webpack_require__(58);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AddNewApplicationResource'];

    /** @ngInject */
    function Controller($state, AddNewApplicationResource) {
        _classCallCheck(this, Controller);

        this.state = $state;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    _createClass(Controller, [{
        key: 'addCustomApplication',
        value: function addCustomApplication() {
            var _this = this;

            this.appType$((0, _applicationTypes.appTypeId)('custom')).get().then(function (appType) {
                return _this.AddNewApplicationResource.createSecureApp(_this.companyId, appType.id).then(function (app) {
                    return _this.state.go('company.manage-application.integration-developers.integration', { appId: app.id });
                });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _directoryIntegration = __webpack_require__(56);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.name = '';
            this.directoryTypeName = (0, _directoryIntegration.getDirectoryTypeName)(this.directoryType);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.createDirectory(this.companyId, this.name, this.directoryType, this.tenantId).then(function (directory) {
                directory = (0, _directoryIntegration.toDirectoryDTO)(directory);
                _this.directories.push(directory);
                _this.Alert('success', 'company.directory-integration.add-directory.added', { directoryTypeName: _this.directoryTypeName });
                if (directory.isAzure) {
                    return _this.$state.go('company.directory-integration.manage.connection-azure', { directoryId: directory.id });
                } else if (directory.isSCIM) {
                    return _this.$state.go('company.directory-integration.manage.connection-scim', { directoryId: directory.id });
                } else {
                    return _this.$state.go('company.directory-integration.manage.domains', { directoryId: directory.id });
                }
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'requiresTenantId',
        value: function requiresTenantId() {
            return this.directoryType == 'AZURE' || this.directoryType == 'SCIM';
        }
    }]);

    return Controller;
}();

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.$tenantParameters = angular.copy(this.tenantParameters);
        }
    }, {
        key: 'saveTenantParameters',
        value: function saveTenantParameters() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.updateAzureTenantParameters(this.companyId, this.directoryId, this.tenantParameters).then(function () {
                _this.$tenantParameters = angular.copy(_this.tenantParameters);
                _this.Alert('success', 'company.directory-integration.manage.connection.tenant-parameters.updated');
            }).catch(function (error) {
                _this.Alert('danger', error.data.message);
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'testConnectionEnabled',
        value: function testConnectionEnabled() {
            var tenPrms = this.$tenantParameters;
            return tenPrms.tenantId && tenPrms.clientId && tenPrms.clientSecret;
        }
    }, {
        key: 'testConnection',
        value: function testConnection() {
            var _this2 = this;

            this.isTestingConnection = true;
            this.DirectoriesResource.testAzureConnection(this.companyId, this.directoryId).then(function (data) {
                _this2.Alert('success', 'company.directory-integration.manage.connection.test.success');
            }).catch(function (error) {
                _this2.Alert('danger', 'company.directory-integration.manage.connection.test.failed');
            }).finally(function () {
                return _this2.isTestingConnection = false;
            });
        }
    }, {
        key: 'tenantParametersIsNotModified',
        value: function tenantParametersIsNotModified() {
            return angular.equals(this.$tenantParameters, this.tenantParameters);
        }
    }, {
        key: 'resetTenantParameters',
        value: function resetTenantParameters() {
            this.tenantParameters = angular.copy(this.$tenantParameters);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["DirectoriesResource"];

    /** @ngInject */
    function Controller(DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "deactivate",
        value: function deactivate() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.deactivateActiveDirectoryAgent(this.resolve.companyId, this.resolve.directoryId).then(function (directory) {
                return _this.close({ $value: directory });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: 'onPremisesFormSaved',
        value: function onPremisesFormSaved() {
            return this.$state.reload('company.directory-integration');
        }
    }, {
        key: 'showDeactivateAgentModal',
        value: function showDeactivateAgentModal() {
            var _this = this;

            this.$uibModal.open({
                component: 'companyDirectoryIntegrationManageConnectionDeactivateAgent',
                resolve: {
                    companyId: function companyId() {
                        return _this.companyId;
                    },
                    directoryId: function directoryId() {
                        return _this.directory.id;
                    }
                }
            }).result.then(function (directory) {
                Object.assign(_this.directory, directory);
                _this.Alert('success', 'company.directory-integration.manage.connection.deactivate-agent.deactivated');
            });
        }
    }, {
        key: 'showDownloadAgentModal',
        value: function showDownloadAgentModal() {
            var _this2 = this;

            this.$uibModal.open({
                component: 'companyDirectoryIntegrationManageConnectionDownloadAgent',
                resolve: {
                    companyId: function companyId() {
                        return _this2.companyId;
                    },
                    directoryId: function directoryId() {
                        return _this2.directory.id;
                    }
                }
            }).result.then(function (directory) {
                Object.assign(_this2.directory, directory);
                _this2.Alert('success', 'company.directory-integration.manage.connection.deactivate-agent.deactivated');
            });
        }
    }, {
        key: 'updateActiveDirectoryActivationCode',
        value: function updateActiveDirectoryActivationCode() {
            var _this3 = this;

            this.isUpdating = true;
            this.DirectoriesResource.updateActiveDirectoryActivationCode(this.companyId, this.directory.id).then(function (directory) {
                return Object.assign(_this3.directory, directory);
            }).then(function () {
                return _this3.Alert('success', 'company.directory-integration.manage.connection.activation-code-updated');
            }).finally(function () {
                return _this3.isUpdating = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["DirectoriesResource"];

    /** @ngInject */
    function Controller(DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "deactivate",
        value: function deactivate() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.deactivateActiveDirectoryAgent(this.resolve.companyId, this.resolve.directoryId).then(function (directory) {
                return _this.close({ $value: directory });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var newOnPremConnection = { onPremisesConnectionEnabled: false, adAgentUrl: '', adAgentPublicCertificate: '' };

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.onPremConnection = _extends({}, this.initialValue || newOnPremConnection);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.onPremConnection, this.initialValue || newOnPremConnection);
        }
    }, {
        key: 'updateOnPremisesConnectionSettings',
        value: function updateOnPremisesConnectionSettings() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.updateOnPremisesConnectionSettings(this.companyId, this.directoryId, this.onPremConnection).then(function () {
                return _this.onSave();
            }).then(function () {
                return _this.Alert('success', 'company.directory-integration.on-premises-form.saved');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.form.$invalid || this.isSaving || this.notModified();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$state', 'DirectoriesResource', 'Alert'];

    /** @ngInject */
    function Controller($scope, $state, DirectoriesResource, Alert) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
        this.DirectoriesResource = DirectoriesResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'updateAzureDomains',
        value: function updateAzureDomains() {
            var _this = this;

            this.DirectoriesResource.updateAzureDomains(this.companyId, this.directory.id).then(function (azureDomains) {
                _this.Alert('success', 'company.directory-integration.manage.domains-azure.update-azure-domains-list.updated');
                return _this.$state.go('company.directory-integration.manage.domains-azure', {}, { reload: 'company.directory-integration.manage.domains-azure' });
            }).catch(function (error) {
                _this.Alert('danger', error.data.message);
            });
        }
    }, {
        key: 'azureSync',
        value: function azureSync() {
            var _this2 = this;

            this.DirectoriesResource.azureSync(this.companyId, this.directory.id).then(function () {
                _this2.Alert('success', 'company.directory-integration.manage.domains-azure.sync.success');
                return _this2.$state.go('company.directory-integration.manage.domains-azure', {}, { reload: 'company.directory-integration.manage.domains-azure' });
            }).catch(function (error) {
                _this2.Alert('danger', error.data.message);
            });
        }
    }, {
        key: 'azureProvisioning',
        value: function azureProvisioning() {
            var _this3 = this;

            this.DirectoriesResource.azureProvisioning(this.companyId, this.directory.id).then(function () {
                _this3.Alert('success', 'company.directory-integration.manage.domains-azure.provisioning.success');
                return _this3.$state.go('company.directory-integration.manage.domains-azure', {}, { reload: 'company.directory-integration.manage.domains-azure' });
            }).catch(function (error) {
                _this3.Alert('danger', error.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _directoryIntegration = __webpack_require__(56);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'DirectoriesResource', 'Alert'];

    /** @ngInject */
    function Controller($state, DirectoriesResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.DirectoriesResource = DirectoriesResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'getAzureStatus',
        value: function getAzureStatus() {
            var _this = this;

            this.DirectoriesResource.getDirectoryStatus(this.companyId, this.directory).then(function (azureStatus) {
                _this.azureStatus = azureStatus;
                _this.Alert('success', 'company.directory-integration.manage.sync-and-prov.refresh-status.success');
            }).catch(function (error) {
                _this.Alert('danger', error.data.message);
            });
        }
    }, {
        key: 'azureSync',
        value: function azureSync() {
            var _this2 = this;

            this.DirectoriesResource.azureSync(this.companyId, this.directory.id).then(function () {
                _this2.$state.go('.', {}, { reload: '.' });
                _this2.Alert('success', 'company.directory-integration.manage.sync-and-prov.sync.success');
            }).catch(function (error) {
                _this2.Alert('danger', error.data.message);
            });
        }
    }, {
        key: 'azureProvisioning',
        value: function azureProvisioning() {
            var _this3 = this;

            this.DirectoriesResource.azureProvisioning(this.companyId, this.directory.id).then(function () {
                _this3.$state.go('.', {}, { reload: '.' });
                _this3.Alert('success', 'company.directory-integration.manage.sync-and-prov.provisioning.success');
            }).catch(function (error) {
                _this3.Alert('danger', error.data.message);
            });
        }
    }, {
        key: 'getStatusKey',
        value: function getStatusKey() {
            return (0, _directoryIntegration.getDirectoryStatusTextKey)(this.azureStatus.ongoingOperation);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.domain = { domainName: '', netbiosName: '' };
            this.computerLoginHelpImage = __webpack_require__(1329);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.createDomain(this.companyId, this.directory.id, this.domain).then(function () {
                if (_this.domains.length || _this.directory.agentConnected === 'ACTIVE') {
                    return _this.$state.go('^', {}, { reload: '^' });
                } else {
                    return _this.$state.go('company.directory-integration.manage.connection');
                }
            }).then(function () {
                return _this.Alert('success', 'company.directory-integration.manage.domains.add-domain.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$state', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($rootScope, $state, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.$model = this.modelFromDto();
            this.model = this.modelFromDto();
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.$onInit();
        }
    }, {
        key: 'modelFromDto',
        value: function modelFromDto() {
            return {
                upnSuffixes: this.directory.upnSuffixes
            };
        }
    }, {
        key: 'modelToDto',
        value: function modelToDto() {
            return _extends({}, this.directory, this.model);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.updateDirectory(this.companyId, this.modelToDto()).then(function () {
                _this.Alert('success', 'company.directory-integration.manage.configuration.updated');
                Object.assign(_this.directory, _this.model);
                _this.$onInit();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'validUpnSuffixes',
        value: function validUpnSuffixes() {
            var pattern = this.$rootScope.activeDirectoryDomainPattern;
            return this.model.upnSuffixes.every(function (domain) {
                return pattern.test(domain);
            });
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$model, this.model);
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving || !this.validUpnSuffixes() || this.notModified();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.keepAccounts = true;
        }
    }, {
        key: 'deleteDomain',
        value: function deleteDomain() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.deleteDomain(this.companyId, this.directory.id, this.domain.id, this.keepAccounts).then(function () {
                return _this.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this.Alert('success', 'company.directory-integration.manage.domains.delete-domain.deleted');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.domain = _extends({}, this.domain);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.DirectoriesResource.editDomain(this.companyId, this.directory.id, this.domain).then(function () {
                return _this.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this.Alert('success', 'company.directory-integration.manage.domains.edit-domain.updated');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'save',
        value: function save(name) {
            var _this = this;

            return this.DirectoriesResource.updateDirectory(this.companyId, _extends({}, this.directory, { name: name })).then(function () {
                _this.Alert('success', 'company.directory-integration.manage.main.updated', { directoryTypeName: _this.directory.typeName });
                _this.$state.reload('company.directory-integration');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$state", "Alert", "DestructiveOperationModal"];

    /** @ngInject */
    function Controller($state, Alert, DestructiveOperationModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            this.keepAccountsAndGroups = "keepAccountsAndGroups"; // possible values are "keepAccountsAndGroups" | "keepAccountsOnly" | "keepGroupsOnly" | "deleteAccountsAndGroups";
        }
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            // DirectoriesResource.deleteDirectory()
            var keepAccounts = ["keepAccountsAndGroups", "keepAccountsOnly"].indexOf(this.keepAccountsAndGroups) >= 0;
            var keepGroups = ["keepAccountsAndGroups", "keepGroupsOnly"].indexOf(this.keepAccountsAndGroups) >= 0;
            var url = "app/rest/v2/company/" + this.companyId + "/directories/" + this.directory.id + "?keepAccounts=" + keepAccounts + "&keepGroups=" + keepGroups + "&type=" + this.directory.type;
            this.DestructiveOperationModal({
                titleKey: 'company.directory-integration.manage.main.remove.$title',
                textKey: 'company.directory-integration.manage.main.remove.are-you-sure',
                http: { method: 'DELETE', url: url }
            }).then(function () {
                _this.Alert('success', 'company.directory-integration.manage.main.remove.removed', { directoryTypeName: _this.directory.typeName });
                _this.$state.go('company.directory-integration', {}, { reload: true });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'DirectoriesResource'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, DirectoriesResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.DirectoriesResource = DirectoriesResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.$conConfig = angular.copy(this.conConfig);
        }
    }, {
        key: 'saveConfig',
        value: function saveConfig() {
            var _this = this;

            console.log('save config');
            this.isSaving = true;
            this.DirectoriesResource.updateScimConfig(this.companyId, this.directoryId, this.conConfig).then(function () {
                _this.$conConfig = angular.copy(_this.conConfig);
                _this.Alert('success', 'company.directory-integration.manage.connection.tenant-parameters.updated');
                _this.$state.go('.', {}, { reload: '.' });
            }).catch(function (error) {
                _this.Alert('danger', error.data.message);
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'testConnectionEnabled',
        value: function testConnectionEnabled() {
            var config = this.$conConfig;
            return config.tenantId && config.baseUrl && config.connectionType && (config.accessToken || config.connectionType != 'BEARER_TOKEN') && (config.tokenEndpoint && config.clientId && config.clientSecret || config.connectionType != 'OAUTH2_CLIENT_CREDENTIALS') && (config.clientId && config.clientSecret || config.connectionType != 'BASIC_AUTHENTICATION');
        }
    }, {
        key: 'testConnection',
        value: function testConnection() {
            var _this2 = this;

            this.isTestingConnection = true;
            this.DirectoriesResource.testScimConnection(this.companyId, this.directoryId).then(function (data) {
                _this2.Alert('success', 'company.directory-integration.manage.connection.test.success');
            }).catch(function (error) {
                _this2.Alert('danger', 'company.directory-integration.manage.connection.test.failed');
            }).finally(function () {
                return _this2.isTestingConnection = false;
            });
        }
    }, {
        key: 'configIsNotModified',
        value: function configIsNotModified() {
            return angular.equals(this.$conConfig, this.conConfig);
        }
    }, {
        key: 'resetConfig',
        value: function resetConfig() {
            this.conConfig = angular.copy(this.$conConfig);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _directoryIntegration = __webpack_require__(56);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'DirectoriesResource', 'Alert'];

    /** @ngInject */
    function Controller($state, DirectoriesResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.DirectoriesResource = DirectoriesResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'getDirectoryStatus',
        value: function getDirectoryStatus() {
            var _this = this;

            this.DirectoriesResource.getDirectoryStatus(this.companyId, this.directory).then(function (directoryStatus) {
                _this.directoryStatus = directoryStatus;
                _this.Alert('success', 'company.directory-integration.manage.sync-and-prov.refresh-status.success');
            }).catch(function (error) {
                _this.Alert('danger', error.data.message);
            });
        }
    }, {
        key: 'directorySync',
        value: function directorySync() {
            var _this2 = this;

            this.DirectoriesResource.scimSync(this.companyId, this.directory.id).then(function () {
                _this2.$state.go('.', {}, { reload: '.' });
                _this2.Alert('success', 'company.directory-integration.manage.sync-and-prov.sync.success');
            }).catch(function (error) {
                _this2.Alert('danger', error.data.message);
            });
        }
    }, {
        key: 'directoryProvisioning',
        value: function directoryProvisioning() {
            var _this3 = this;

            this.DirectoriesResource.scimProvisioning(this.companyId, this.directory.id).then(function () {
                _this3.$state.go('.', {}, { reload: '.' });
                _this3.Alert('success', 'company.directory-integration.manage.sync-and-prov.provisioning.success');
            }).catch(function (error) {
                _this3.Alert('danger', error.data.message);
            });
        }
    }, {
        key: 'getStatusKey',
        value: function getStatusKey() {
            return (0, _directoryIntegration.getDirectoryStatusTextKey)(this.directoryStatus.ongoingOperation);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _smartTable = __webpack_require__(2);

var _spAlert = __webpack_require__(4);

Controller.$inject = ['$scope', '$state', 'Alert', 'DestructiveOperationModal', 'DomainsService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, Alert, DestructiveOperationModal, DomainsService) {
    var _this = this;

    $scope.st = new _smartTable.SmartTable();
    var companyId = $state.params.companyId;
    this.$onInit = function () {
        return $scope.domains = _this.domains;
    };

    $scope.setChoosenDomain = function (object) {
        $scope.chosenDomain = object;
    };

    $scope.showRemoveDomainDestructiveOp = function (keepAccounts) {
        var domainObject = $scope.chosenDomain;
        var url = 'app/rest/' + companyId + '/domains/' + domainObject.id + '?keepAccounts=' + keepAccounts;
        DestructiveOperationModal({
            titleKey: 'domains.delete_modal.header',
            textKey: 'domains.delete_modal.content',
            http: { method: 'DELETE', url: url }
        }).then(function () {
            Alert('success', 'domains.message.removed');
            $scope.domains.splice($scope.domains.indexOf(domainObject), 1);
        });
    };

    $scope.clearAddNewDomain = function () {
        $scope.domain = {
            "email": null
        };
    };

    $scope.createNewDomain = function () {
        DomainsService.save({
            companyId: companyId,
            emailAddress: $scope.domain.email
        }, {}, function (data) {

            Alert('success', 'domains.message.added');
            $scope.domains.push(data);
            $('#addNewDomainModal').modal('hide');
            $scope.clearAddNewDomain();
        }, function (error) {
            $scope.domainInputMessage = new _spAlert.SpAlert('danger', error.data.message);
        });
    };

    $scope.clearAddNewDomain();
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _smartTable = __webpack_require__(2);

Controller.$inject = ['$scope', '$state', 'Account', 'GoogleSharedService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, Account, GoogleSharedService) {
    $scope.samlImage = window.env.urls.samlAppLogo('google-apps');

    $scope.displaySpinner = false;
    $scope.companyApplicationDto = [];
    $scope.st = new _smartTable.SmartTable();

    $scope.entityName = '';

    $scope.newCompanyName;

    $scope.displayApplicationStep = false;

    $scope.company;

    $scope.googleAppsApplicationType;

    $scope.displayCreateCompany = false;

    $scope.selectedCompany = 0;

    $scope.showEmailChangeOwner = false;

    $scope.displayErrorEmailChange = false;
    $scope.showChangeEmailOwnerNoDomain = false;
    $scope.emailBelongToUser = false;
    $scope.emailExistsInSystem = false;
    $scope.domainVerified = false;
    $scope.userIsAdminOfDomainInSaaspass = false;
    $scope.userisAdminInSaaspass = false;
    $scope.companiesOfUser = [];

    Account.get().then(function (account) {
        if (account.userEmailAddress) {
            $scope.emailAddress = account.userEmailAddress;
            $scope.domain = account.userEmailAddress.split('@')[1];
            $scope.executeInitPage();
        }
    });

    $scope.userIsAdminOfDomainInSaaspass = false;

    $scope.executeInitPage = function () {
        if ($scope.domain && $scope.emailAddress) {

            $scope.domainVerified = false;

            $scope.emailBelongToAnotherUser = false;

            $scope.showGoogleAppsForAdmin = true;

            GoogleSharedService.getGoogleAppsInfo.get({
                emailAddress: $scope.emailAddress,
                domainName: $scope.domain
            }, function (data) {
                $scope.domainVerified = data.domainVerified;
                $scope.userIsAdminOfDomainInSaaspass = data.userIsAdminOfDomainInSaaspass;
                $scope.userisAdminInSaaspass = data.userisAdminInSaaspass;
                $scope.companyApplicationDto = data.googleAppsInCompany;
                $scope.company = data.domainOwnerCompany;
                $scope.googleAppsApplicationType = data.googleAppsApplicationType;
                $scope.emailBelongToUser = data.emailBelongToUser;
                $scope.emailExistsInSystem = data.emailExistsInSystem;
                $scope.companiesOfUser = data.companiesOfUser;

                $scope.createEmailForUser();
            });
        }
    };

    $scope.createEmailForUser = function () {
        if (!$scope.showErrorOnStart()) {
            if (!$scope.emailBelongToUser && !$scope.emailExistsInSystem) {
                GoogleSharedService.createUserEmail.get({
                    emailAddress: $scope.emailAddress
                }, function (data) {
                    $scope.domainVerified = data.domainVerified;
                    $scope.userIsAdminOfDomainInSaaspass = data.userIsAdminOfDomainInSaaspass;
                    $scope.userisAdminInSaaspass = data.userisAdminInSaaspass;
                    $scope.companyApplicationDto = data.googleAppsInCompany;
                    $scope.company = data.domainOwnerCompany;
                    $scope.googleAppsApplicationType = data.googleAppsApplicationType;
                    $scope.emailBelongToUser = data.emailBelongToUser;
                    $scope.emailExistsInSystem = data.emailExistsInSystem;
                    $scope.companiesOfUser = data.companiesOfUser;

                    $scope.createEmailForUser();
                }, function (error) {
                    console.log(error);
                });
            } else if (!$scope.emailBelongToUser && $scope.emailExistsInSystem && !$scope.domainVerified) {
                $scope.showChangeEmailOwnerNoDomain = true;
            } else if ($scope.userIsAdminOfDomainInSaaspass) {
                $scope.displayCreateCompany = false;
                $scope.displayApplicationStep = true;
                $scope.showEmailChangeOwner = false;
                $scope.showChangeEmailOwnerNoDomain = false;
            }
        }
    };

    $scope.showErrorOnStart = function () {
        return $scope.domainVerified && !$scope.userIsAdminOfDomainInSaaspass;
    };

    //show createEmailDomain when domain is not verifyed in saaspass and email don't exists in saaspass.
    $scope.showCreateEmail = function () {
        if (!$scope.showErrorOnStart()) {
            return !$scope.domainVerified && $scope.emailBelongToUser && $scope.emailExistsInSystem;
        } else {
            return false;
        }
    };

    $scope.showSelectComapnyOrCreateNew = function () {
        return !$scope.displayCreateCompany && $scope.showCreateEmail() && $scope.userisAdminInSaaspass;
    };

    //show create new company form
    $scope.showCreateNewCompany = function () {
        if (!$scope.displayCreateCompany) {
            return $scope.showCreateEmail() && !$scope.userisAdminInSaaspass;
        } else {
            return $scope.displayCreateCompany;
        }
    };

    //show transfer email when no domain is not veifyed in saaspass for this email and email exists in saaspass but not for this saaspaas user.
    $scope.showTransferEmailNonAdmin = function () {
        if (!$scope.showErrorOnStart()) {
            return !$scope.domainVerified && !$scope.emailBelongToUser && $scope.emailExistsInSystem;
        } else {
            return false;
        }
    };

    $scope.companySelectionChange = function (selectedCompany) {
        $scope.selectedCompany = selectedCompany;
        if ($scope.selectedCompany > 0) {
            GoogleSharedService.updateCompanyWithDomain.get({
                domain: $scope.domain,
                email: $scope.emailAddress,
                companyId: $scope.selectedCompany
            }, function (data) {
                $scope.domainVerified = data.domainVerified;
                $scope.userIsAdminOfDomainInSaaspass = data.userIsAdminOfDomainInSaaspass;
                $scope.userisAdminInSaaspass = data.userisAdminInSaaspass;
                $scope.companyApplicationDto = data.googleAppsInCompany;
                $scope.company = data.domainOwnerCompany;
                $scope.googleAppsApplicationType = data.googleAppsApplicationType;
                $scope.emailBelongToUser = data.emailBelongToUser;
                $scope.emailExistsInSystem = data.emailExistsInSystem;
                $scope.companiesOfUser = data.companiesOfUser;

                $scope.createEmailForUser();
            }, function (error) {
                console.log(error);
            });
        }
    };

    $scope.goToCreateNewCompany = function () {
        $scope.newCompanyName = "";
        $scope.displayCreateCompany = true;
    };

    $scope.createCompany = function (newCompanyName) {
        $scope.newCompanyName = newCompanyName;
        console.log("New Comapny" + $scope.newCompanyName);
        GoogleSharedService.createCompanyWithDomain.get({
            email: $scope.emailAddress,
            companyName: $scope.newCompanyName
        }, function (data) {
            $scope.domainVerified = data.domainVerified;
            $scope.userIsAdminOfDomainInSaaspass = data.userIsAdminOfDomainInSaaspass;
            $scope.userisAdminInSaaspass = data.userisAdminInSaaspass;
            $scope.companyApplicationDto = data.googleAppsInCompany;
            $scope.company = data.domainOwnerCompany;
            $scope.googleAppsApplicationType = data.googleAppsApplicationType;
            $scope.emailBelongToUser = data.emailBelongToUser;
            $scope.emailExistsInSystem = data.emailExistsInSystem;
            $scope.companiesOfUser = data.companiesOfUser;

            $scope.redirectToApplicationAfterCreateNewCompany();
        }, function (error) {
            console.log(error);
        });
    };

    $scope.redirectToApplicationAfterCreateNewCompany = function () {
        if ($scope.companyApplicationDto && $scope.companyApplicationDto.length > 0) {
            var app = $scope.companyApplicationDto[0];
            $scope.manageApplication(app);
        }
    };

    $scope.changeOwnerOfEmailYes = function () {
        GoogleSharedService.updateUserEmailOwner.get({
            email: $scope.emailAddress,
            companyId: $scope.company.id
        }, function (data) {
            $scope.displayApplicationStep = true;
            $scope.showEmailChangeOwner = false;
            $scope.showChangeEmailOwnerNoDomain = false;
        }, function (error) {
            console.log(error);
        });
    };

    $scope.changeOwnerOfEmailNo = function () {
        if ($scope.domainVerified) {
            $scope.displayApplicationStep = true;
            $scope.showEmailChangeOwner = false;
            $scope.showChangeEmailOwnerNoDomain = false;
        } else {
            //error
        }
    };

    $scope.changeOwnerOfEmailNoDomainYes = function () {
        GoogleSharedService.changeUserEmailOwnerNoDomain.get({
            emailAddress: $scope.emailAddress
        }, function (data) {
            $scope.emailBelongToUser = true;
            $scope.emailExistsInSystem = true;
            $scope.showEmailChangeOwner = false;
            $scope.showChangeEmailOwnerNoDomain = false;
        }, function (error) {
            console.log(error);
        });
    };

    $scope.changeOwnerOfEmailNoDomainNo = function () {
        if (!$scope.domainVerified) {
            $scope.displayErrorEmailChange = true;
            $scope.showEmailChangeOwner = false;
            $scope.showChangeEmailOwnerNoDomain = false;
        } else {
            //error
        }
    };

    $scope.manageApplication = function (app) {
        if (app.hasDomainGrouop) {
            var companyId = $scope.company.id;
            var appId = app.application.id;
            $state.go('company.manage-application', { companyId: companyId, appId: appId });
        } else {
            GoogleSharedService.updateGoogleApplicationWithDomain.get({
                domainName: $scope.domain,
                appId: app.application.id
            }, function (data) {
                var companyId = $scope.company.id;
                var appId = data.application.id;
                $state.go('company.manage-application', { companyId: companyId, appId: appId });
            }, function (error) {
                console.log(error);
            });
        }
    };

    $scope.addNewApplication = function () {
        GoogleSharedService.saveGoogleApplication.get({
            domainName: $scope.domain
        }, function (data) {
            var companyId = $scope.company.id;
            var appId = data.application.id;
            $state.go('company.manage-application', { companyId: companyId, appId: appId });
        }, function (error) {
            console.log(error);
        });
    };
}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _applicationTypes = __webpack_require__(58);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AddNewApplicationResource'];

    /** @ngInject */
    function Controller($state, AddNewApplicationResource) {
        _classCallCheck(this, Controller);

        this.state = $state;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    _createClass(Controller, [{
        key: 'showAddApplicationModal',
        value: function showAddApplicationModal() {
            var _this = this;

            this.AddNewApplicationResource.createSecureApp(this.companyId, (0, _applicationTypes.appTypeId)('google-apps')).then(function (app) {
                return _this.state.go('company.manage-application', { appId: app.id });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _hardTokenIntegration = __webpack_require__(105);

var _hardTokenAdd = __webpack_require__(138);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Controller = exports.Controller = function (_HardTokenAddControll) {
    Controller.$inject = ['$state', 'HardTokenService', 'Alert'];

    _inherits(Controller, _HardTokenAddControll);

    /** @ngInject */
    function Controller($state, HardTokenService, Alert) {
        _classCallCheck(this, Controller);

        return _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, $state, HardTokenService, Alert));
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            _get(Controller.prototype.__proto__ || Object.getPrototypeOf(Controller.prototype), '$onInit', this).call(this);
            this.type = 'YUBIKey_USB_KEY';
            this.otpType = 'U2F';
            console.log(this);
        }
    }]);

    return Controller;
}(_hardTokenAdd.HardTokenAddController);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _hardTokenAdd = __webpack_require__(138);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Controller = exports.Controller = function (_HardTokenAddControll) {
    Controller.$inject = ['$state', 'HardTokenService', 'Alert'];

    _inherits(Controller, _HardTokenAddControll);

    /** @ngInject */
    function Controller($state, HardTokenService, Alert) {
        _classCallCheck(this, Controller);

        return _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, $state, HardTokenService, Alert));
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            _get(Controller.prototype.__proto__ || Object.getPrototypeOf(Controller.prototype), '$onInit', this).call(this);
            this.type = 'THIRD_PARTY';
            this.otpType = 'TOTP';
        }
    }]);

    return Controller;
}(_hardTokenAdd.HardTokenAddController);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _hardTokenAdd = __webpack_require__(138);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Controller = exports.Controller = function (_HardTokenAddControll) {
    Controller.$inject = ['$state', 'HardTokenService', 'Alert'];

    _inherits(Controller, _HardTokenAddControll);

    /** @ngInject */
    function Controller($state, HardTokenService, Alert) {
        _classCallCheck(this, Controller);

        return _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, $state, HardTokenService, Alert));
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            _get(Controller.prototype.__proto__ || Object.getPrototypeOf(Controller.prototype), '$onInit', this).call(this);
            this.type = 'YUBIKey_USB_KEY';
            this.otpType = 'YOTP';
            this.htUsbAnimHotp = __webpack_require__(385);
            this.htUsbAnim = __webpack_require__(386);
            this.tooltipTemplate = __webpack_require__(1384);
            this.tooltipHotpTemplate = __webpack_require__(1385);
        }
    }]);

    return Controller;
}(_hardTokenAdd.HardTokenAddController);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1d29ac048da0c6d5871447a3e4d479a.gif";

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "64074f1fd20eebc2781c1d6417c60eff.gif";

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _yubicoWebauthn = __webpack_require__(72);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$window', '$state', 'HardTokenService', 'Alert', 'ConfirmModal'];

	/** @ngInject */
	function Controller($window, $state, HardTokenService, Alert, ConfirmModal) {
		_classCallCheck(this, Controller);

		this.HardTokenService = HardTokenService;
		this.Alert = Alert;
		this.$state = $state;
		this.$window = $window;
		this.ConfirmModal = ConfirmModal;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			this.registrationEmail = angular.copy(this.regEmailData.emailAddress);
			this.unregisteredEmailProvided = !this.token.u2fRegistered && this.regEmailData.hasInvitationLink;
			this.unregisteredNoEmail = !this.token.u2fRegistered && !this.regEmailData.hasInvitationLink;
			this.regFlag = this.token.u2fRegistered ? 'REGISTERED' : this.unregisteredEmailProvided ? 'PENDING' : 'NO_REGISTRATION';
			console.log(this);
		}
	}, {
		key: 'isEmailNotModified',
		value: function isEmailNotModified() {
			return !this.registrationEmail || this.registrationEmail == this.regEmailData.emailAddress;
		}
	}, {
		key: 'u2fRegistrationStart',
		value: function u2fRegistrationStart(reset) {
			var _this = this;

			if (reset) {
				this.HardTokenService.u2fResetRegistrationStart(this.token).then(function (response) {
					return _this.successReg(response);
				}).catch(function (error) {
					return _this.errorReg(error);
				});
			} else {
				this.HardTokenService.u2fRegistrationStart(this.token).then(function (response) {
					return _this.successReg(response);
				}).catch(function (error) {
					return _this.errorReg(error);
				});
			}
		}

		/** @private */

	}, {
		key: 'successReg',
		value: function successReg(response) {
			var _this2 = this;

			var credOpts = (0, _yubicoWebauthn.convertStartRegResponse)(response);
			this.$window.navigator.credentials.create(credOpts).then(function (credentials) {
				var finishRegRequest = (0, _yubicoWebauthn.convertFinishRegRequest)(credentials, response);
				_this2.u2fRegistrationFinish(finishRegRequest);
			}).catch(function (error) {
				return console.log(error);
			});
		}

		/** @private */

	}, {
		key: 'errorReg',
		value: function errorReg() {
			this.Alert('danger', 'hard_tokens.edit.U2F_failed');
		}
	}, {
		key: 'replaceData',
		value: function replaceData(data) {
			angular.copy(data.hardToken, this.token);
			angular.copy(data.registrationData, this.regEmailData);
			this.$onInit();
		}
	}, {
		key: 'u2fRegistrationFinish',
		value: function u2fRegistrationFinish(data) {
			var _this3 = this;

			this.HardTokenService.u2fRegistrationFinish(this.token, data).then(function (response) {
				_this3.replaceData(response);
				//this.$state.reload('company.hard-token-management.edit.registration');
				var key = 'hard_tokens.edit.U2F_registration_successfully';
				_this3.Alert('success', key);
			}).catch(function (error) {
				return _this3.Alert('danger', 'hard_tokens.edit.U2F_failed');
			});
		}
	}, {
		key: 'u2fAuthenticationStart',
		value: function u2fAuthenticationStart() {
			var _this4 = this;

			this.HardTokenService.u2fAuthenticationStart(this.token).then(function (response) {
				var credOpts = (0, _yubicoWebauthn.convertStartAuthResponse)(response);
				_this4.$window.navigator.credentials.get(credOpts).then(function (credentials) {
					var finishRegRequest = (0, _yubicoWebauthn.convertFinishAuthRequest)(credentials, response);
					_this4.u2fAuthenticationFinish(finishRegRequest);
				});
			}).catch(function (error) {
				console.log(error);
				var key = 'hard_tokens.edit.authentication_test_failed';
				_this4.Alert('danger', key);
			});
		}
	}, {
		key: 'u2fAuthenticationFinish',
		value: function u2fAuthenticationFinish(authdata) {
			var _this5 = this;

			this.HardTokenService.u2fAuthenticationFinish(this.token, authdata).then(function () {
				var key = 'hard_tokens.edit.authentication_test_successfully';
				_this5.Alert('success', key);
			}).catch(function (error) {
				console.log(error);
				var key = 'hard_tokens.edit.authentication_test_failed';
				_this5.Alert('danger', key);
			});
		}
	}, {
		key: 'sendReregistrationEmail',
		value: function sendReregistrationEmail() {
			var _this6 = this;

			this.isSending = true;
			this.HardTokenService.putRegEmailData(this.token, this.registrationEmail).then(function (response) {
				_this6.replaceData(response);
				var key = 'company.hard-token-management.edit.registration.send-email.success';
				_this6.Alert('success', key);
			}).catch(function (error) {
				console.log(error);
				_this6.Alert('danger', error.message);
			}).finally(function () {
				return _this6.isSending = false;
			});
		}
	}, {
		key: 'resendReregistrationEmail',
		value: function resendReregistrationEmail() {
			var _this7 = this;

			this.isSending = true;
			this.HardTokenService.resendRegEmail(this.token).then(function (response) {
				angular.copy(response, _this7.regEmailData);
				var key = 'company.hard-token-management.edit.registration.resend-email.success';
				_this7.Alert('success', key);
			}).catch(function (error) {
				console.log(error);
				_this7.Alert('danger', error.message);
			}).finally(function () {
				return _this7.isSending = false;
			});
		}
	}, {
		key: 'clearAndSend',
		value: function clearAndSend() {
			var _this8 = this;

			this.isSending = true;
			this.ConfirmModal({
				messageKey: 'company.hard-token-management.edit.registration.confirm.text',
				titleKey: 'company.hard-token-management.edit.registration.confirm.title'
			}).then(function () {
				return _this8.sendReregistrationEmail();
			}).finally(function () {
				return _this8.isSending = false;
			});
		}
	}]);

	return Controller;
}();

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$state', 'HardTokenService', 'Alert', 'DestructiveOperationModal'];

	/** @ngInject */
	function Controller($state, HardTokenService, Alert, DestructiveOperationModal) {
		_classCallCheck(this, Controller);

		this.HardTokenService = HardTokenService;
		this.Alert = Alert;
		this.$state = $state;
		this.DestructiveOperationModal = DestructiveOperationModal;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			this.initInputs();
			this.hardToken = angular.copy(this.token);
			console.log(this);
		}
	}, {
		key: 'getState',
		value: function getState() {
			if (this.hardToken.isSecondaryDeviceOfUser) {
				return this.hardToken.status === 'ACTIVE' ? 'secondary_device_of_user' : 'secondary_device_of_user_blocked';
			}
			if (this.hardToken.hasAccounts) {
				return this.hardToken.status === 'ACTIVE' ? 'has_assigned_accounts' : 'has_assigned_accounts_blocked';
			}
			return this.hardToken.status === 'ACTIVE' ? 'no_account_assigned' : 'no_account_assigned_blocked';
		}
	}, {
		key: 'isNotModified',
		value: function isNotModified() {
			return angular.equals(this.hardToken, this.token);
		}

		/** @private */

	}, {
		key: 'initInputs',
		value: function initInputs() {
			this.edit = {};
			this.show = {};
		}

		/** @private */

	}, {
		key: 'updateToken',
		value: function updateToken(value) {
			this.initInputs();
			angular.extend(this.token, value);
			angular.extend(this.hardToken, value);
		}
		/** @private */

	}, {
		key: 'replaceToken',
		value: function replaceToken(value) {
			this.initInputs();
			angular.copy(value, this.token);
			angular.copy(value, this.hardToken);
		}
	}, {
		key: 'restoreToken',
		value: function restoreToken() {
			this.initInputs();
			angular.copy(this.token, this.hardToken);
		}
	}, {
		key: 'save',
		value: function save() {
			var _this = this;

			this.isSaving = true;
			this.HardTokenService.save(this.hardToken).then(function (response) {
				_this.replaceToken(response);
				_this.Alert('success', 'hard_tokens.edit.saved_successfully');
			}).catch(function (error) {
				console.log(error);
				_this.restoreToken();
				_this.Alert('danger', 'hard_tokens.edit.failed_save');
			}).finally(function () {
				return _this.isSaving = false;
			});
		}
	}, {
		key: 'showDeleteModal',
		value: function showDeleteModal() {
			var _this2 = this;

			var companyId = this.companyId;
			var url = 'app/rest/admin/company/' + companyId + '/hardtoken/' + this.hardToken.id;
			this.DestructiveOperationModal({
				titleKey: 'hard_tokens.management.delete',
				textKey: this.hardToken.isSecondaryDeviceOfUser, 'hard_tokens.management.info_secondarydevice': 'hard_tokens.management.info',
				http: { method: 'DELETE', url: url }
			}).then(function () {
				_this2.$state.go('company.hard-token-management', {}, { reload: 'company.hard-token-management' });
				_this2.Alert('success', 'hard_tokens.management.delete.success');
			});
		}
	}, {
		key: 'enable',
		value: function enable() {
			var _this3 = this;

			this.HardTokenService.enable(this.hardToken).then(function () {
				_this3.updateToken({ status: 'ACTIVE' });
				//this.$state.reload($state.current);
				_this3.Alert('success', 'hard_tokens.edit.enabled_successfully');
			}).catch(function (error) {
				console.log(error);
				_this3.restoreToken();
				_this3.Alert('danger', 'hard_tokens.edit.failed_to_enable');
			});
		}
	}, {
		key: 'disable',
		value: function disable() {
			var _this4 = this;

			this.HardTokenService.disable(this.hardToken).then(function () {
				_this4.updateToken({ status: 'INACTIVE' });
				//this.$state.reload($state.current);
				_this4.Alert('success', 'hard_tokens.edit.disabled_successfully');
			}).catch(function (error) {
				console.log(error);
				_this4.restoreToken();
				_this4.Alert('danger', 'hard_tokens.edit.failed_to_disable');
			});
		}
	}]);

	return Controller;
}();

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$location', 'Alert', 'HardTokenService'];

    /** @ngInject */
    function Controller($location, Alert, HardTokenService) {
        _classCallCheck(this, Controller);

        this.$location = $location;
        this.Alert = Alert;
        this.HardTokenService = HardTokenService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.generatedUrl = '';
            this.otps = { otp1: '', otp2: '', otp3: '' };
        }
    }, {
        key: 'generateUrl',
        value: function generateUrl() {
            var _this = this;

            this.isGeneratingUrl = true;
            this.HardTokenService.generateSyncUrl(this.token).then(function (_ref) {
                var trackerId = _ref.trackerId;
                return _this.generatedUrl = _this.$location.absUrl().replace(/#.*/, '#/htsync/' + trackerId);
            }).finally(function () {
                return _this.isGeneratingUrl = false;
            });
        }
    }, {
        key: 'sync',
        value: function sync() {
            var _this2 = this;

            this.isSyncing = true;
            this.HardTokenService.sync(this.token, this.otps).then(function () {
                return _this2.Alert('success', 'company.hard-token-management.sync.synced');
            }).catch(function () {
                return _this2.Alert('danger', 'company.hard-token-management.sync.failed');
            }).finally(function () {
                return _this2.isSyncing = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hardTokenIntegrationProperties = __webpack_require__(197);

var _hardTokenIntegrationSamples = __webpack_require__(391);

var _maxTokenCount = __webpack_require__(106);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.csv = tokens2csv(this.tokens, this.props);
        }
    }, {
        key: 'csvChanged',
        value: function csvChanged() {
            var tokens = csv2tokens(this.csv, this.props);
            if (tokens.length > _maxTokenCount.maxTokenCount) {
                tokens.length = _maxTokenCount.maxTokenCount;
                this.csv = tokens2csv(tokens, this.props);
            }
            this.onChange({ tokens: tokens });
        }
    }, {
        key: 'props',
        get: function get() {
            return _hardTokenIntegrationProperties.props[this.type][this.otpType];
        }
    }, {
        key: 'propKeys',
        get: function get() {
            return this.props.map(function (prop) {
                return 'hard_tokens.integrate.props.' + prop.name;
            });
        }
    }, {
        key: 'csvPlaceholder',
        get: function get() {
            var csv = tokens2csv(_hardTokenIntegrationSamples.samples[this.type][this.otpType], this.props);
            // multi-line placeholder hack. stackoverflow.com/a/8843665
            return ' '.repeat(1000) + csv.split('\n').join(' '.repeat(1000));
        }
    }]);

    return Controller;
}();

function csv2tokens(csv, props) {
    return csv.trim().split('\n').map(function (line) {
        return line.trim().split(',').slice(0, props.length).map(function (s) {
            return s.trim();
        }).reduce(function (acc, val, idx) {
            return Object.assign(acc, _defineProperty({}, props[idx].name, val));
        }, {});
    });
}

function tokens2csv(tokens, props) {
    var values = function values(token) {
        return props.map(function (prop) {
            return token[prop.name];
        });
    };
    var nonEmpty = function nonEmpty(line) {
        return line.replace(/[\s,]*/, '');
    };
    return tokens.map(function (token) {
        return values(token).join(',');
    }).filter(nonEmpty).join('\n');
}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var U2F = [{ serial: 'Device Name', registrationEmail: 'Email Address (optional)' }, { serial: 'Example: \n 7827875', registrationEmail: 'smith@mail.com' }, { serial: '5234878', registrationEmail: 'anna@domain.com' }, { serial: '5295256' }, { serial: '4694559', registrationEmail: 'sandra.li@company.com' }, { serial: '7799795' }];

var YOTP = [{
    serial: 'Decimal',
    secret: '16 bytes Hex',
    publicIdentity: '1-16 Bytes Modhex',
    privateIdentity: '6 bytes Hex'
}, {
    serial: 'Example: \n 7826735',
    secret: '964f1a713b3546f8931e04b4d6647322',
    publicIdentity: '95c8fe2cf746',
    privateIdentity: 'ebb6f9762c28'
}, {
    serial: '5888878',
    secret: 'ae03d762f1af43b5a6d0769c0d47f8d6',
    publicIdentity: 'c223fda7a644',
    privateIdentity: 'bd5b6c27de98'
}, {
    serial: '4215256',
    secret: 'b37b365c0a8b452d9ad3adf1055d8e9b',
    publicIdentity: 'd2c9e7c81ff1',
    privateIdentity: 'b6320a610806'
}, {
    serial: '4655459',
    secret: '5b436a31f4534ded99e6940d3fc1127e',
    publicIdentity: 'dc5aa377be86',
    privateIdentity: '374d6741b42f'
}, {
    serial: '7799793',
    secret: '1ae76c959ece4216bd2af1b47754f2d0',
    publicIdentity: 'e1ac784d2341',
    privateIdentity: 'b80e4c693938'
}];

var USB_HOTP = [{ serial: 'Decimal', secret: '20 bytes hexadecimal' }, { serial: 'Example: \n 7823765', secret: '964f1a713b3546f8' }, { serial: '5665878', secret: 'ae03d762f1af43b5' }, { serial: '9255256', secret: 'b37b365c0a8b452d' }, { serial: '4678959', secret: '5b436a31f4534ded' }, { serial: '7799344', secret: '1ae76c959ece4216' }];

var HOTP = [{ serial: 'Hexadecimal', secret: 'Hexadecimal' }, { serial: 'Example: \n 782d7b5', secret: '964f1a713b3546f8' }, { serial: '5bfe878', secret: 'ae03d762f1af43b5' }, { serial: 'b2b5256', secret: 'b37b365c0a8b452d' }, { serial: '46bee59', secret: '5b436a31f4534ded' }, { serial: '7799d9e', secret: '1ae76c959ece4216' }];

var samples = exports.samples = {
    YUBIKey_USB_KEY: {
        U2F: U2F,
        YOTP: YOTP,
        HOTP: USB_HOTP
    },
    THIRD_PARTY: {
        TOTP: HOTP,
        HOTP: HOTP
    }
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hardTokenIntegrationProperties = __webpack_require__(197);

var _maxTokenCount = __webpack_require__(106);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$rootScope'];

    /** @ngInject */
    function Controller($scope, $rootScope) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$watch('form.$valid', function (valid) {
                _this.valid = valid;
                _this.changed();
            });
        }
    }, {
        key: 'getPattern',
        value: function getPattern(prop) {
            if (prop.name == 'registrationEmail') {
                return this.$rootScope.emailPattern;
            } else {
                return prop.pattern;
            }
        }
    }, {
        key: 'addToken',
        value: function addToken() {
            var newToken = {};
            /*
            if(this.otpType='U2F'){
            	var serialAuto="FIDO Token "+(this.tokens.length+1);
            	newToken={serial: serialAuto}
            }*/
            this.tokens = [].concat(_toConsumableArray(this.tokens), [newToken]);
            this.changed();
        }
    }, {
        key: 'addTokenDisabled',
        value: function addTokenDisabled() {
            return this.tokens.length >= _maxTokenCount.maxTokenCount;
        }
    }, {
        key: 'remove',
        value: function remove(token) {
            this.tokens = this.tokens.filter(function (t) {
                return t !== token;
            });
            this.changed();
        }
    }, {
        key: 'changed',
        value: function changed() {
            this.onChange({ tokens: this.tokens, valid: this.valid });
        }
    }, {
        key: 'getErrorMessage',
        value: function getErrorMessage(form) {
            if (form.$error.pattern) {
                var propName = form.$error.pattern[0].$name;
                return 'hard_tokens.integrate.validation.' + this.type + '.' + this.otpType + '.' + propName;
            }
        }
    }, {
        key: 'props',
        get: function get() {
            return _hardTokenIntegrationProperties.props[this.type][this.otpType];
        }
    }]);

    return Controller;
}();

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _hardTokenIntegration = __webpack_require__(105);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Controller = exports.Controller = function (_HardTokenIntegration) {
    Controller.$inject = ['HardTokenService'];

    _inherits(Controller, _HardTokenIntegration);

    /** @ngInject */
    function Controller(HardTokenService) {
        _classCallCheck(this, Controller);

        return _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, HardTokenService));
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            _get(Controller.prototype.__proto__ || Object.getPrototypeOf(Controller.prototype), '$onInit', this).call(this);
            this.type = 'YUBIKey_USB_KEY';
            this.otpType = 'U2F';
        }
    }]);

    return Controller;
}(_hardTokenIntegration.HardTokenIntegrationController);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _hardTokenIntegration = __webpack_require__(105);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Controller = exports.Controller = function (_HardTokenIntegration) {
    Controller.$inject = ['HardTokenService'];

    _inherits(Controller, _HardTokenIntegration);

    /** @ngInject */
    function Controller(HardTokenService) {
        _classCallCheck(this, Controller);

        return _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, HardTokenService));
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            _get(Controller.prototype.__proto__ || Object.getPrototypeOf(Controller.prototype), '$onInit', this).call(this);
            this.type = 'THIRD_PARTY';
            this.otpType = 'TOTP';
        }
    }]);

    return Controller;
}(_hardTokenIntegration.HardTokenIntegrationController);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _hardTokenIntegration = __webpack_require__(105);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Controller = exports.Controller = function (_HardTokenIntegration) {
    Controller.$inject = ['HardTokenService'];

    _inherits(Controller, _HardTokenIntegration);

    /** @ngInject */
    function Controller(HardTokenService) {
        _classCallCheck(this, Controller);

        return _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, HardTokenService));
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            _get(Controller.prototype.__proto__ || Object.getPrototypeOf(Controller.prototype), '$onInit', this).call(this);
            this.type = 'YUBIKey_USB_KEY';
            this.otpType = 'YOTP';
            this.htUsbAnimHotp = __webpack_require__(396);
            this.htUsbAnim = __webpack_require__(397);
            this.tooltipTemplate = __webpack_require__(1411);
            this.tooltipHotpTemplate = __webpack_require__(1412);
        }
    }]);

    return Controller;
}(_hardTokenIntegration.HardTokenIntegrationController);

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1d29ac048da0c6d5871447a3e4d479a.gif";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "64074f1fd20eebc2781c1d6417c60eff.gif";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$filter', '$state', '$timeout', '$uibModal', 'Alert', 'DestructiveOperationModal', 'HardTokenEditModal', 'HardTokenService', 'HardTokenResource'];

    /** @ngInject */
    function Controller($filter, $state, $timeout, $uibModal, Alert, DestructiveOperationModal, HardTokenEditModal, HardTokenService, HardTokenResource) {
        _classCallCheck(this, Controller);

        this.$filter = $filter;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.HardTokenEditModal = HardTokenEditModal;
        this.HardTokenService = HardTokenService;
        this.HardTokenResource = HardTokenResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.filteredTokens = this.hardTokens;
            this.st = new _smartTable.SmartTable();
            this.filter = { type: undefined, otpType: undefined, state: undefined, effectiveStatus: undefined };
            // this.tokenStates = ['ACTIVE', 'INACTIVE', 'NOT_ASSIGNED'];
            this.tokenStates = ['secondary_device_of_user', 'secondary_device_of_user_blocked', 'has_assigned_accounts', 'has_assigned_accounts_blocked', 'no_account_assigned', 'no_account_assigned_blocked'];
            this.hardTokens.forEach(function (token) {
                return token.state = _this.getState(token);
            });
        }
    }, {
        key: 'filterBy',
        value: function filterBy(filter) {
            Object.assign(this.filter, filter);
            this.filteredTokens = this.$filter('filter')(this.hardTokens, this.filter, true);
        }
    }, {
        key: 'showDeleteModal',
        value: function showDeleteModal(token) {
            var _this2 = this;

            var companyId = this.companyId;
            var url = 'app/rest/admin/company/' + companyId + '/hardtoken/' + token.id;
            this.DestructiveOperationModal({
                titleKey: 'hard_tokens.management.delete',
                textKey: token.isSecondaryDeviceOfUser ? 'hard_tokens.management.info_secondarydevice' : 'hard_tokens.management.info',
                http: { method: 'DELETE', url: url }
            }).then(function () {
                _this2.$state.reload(_this2.$state.current);
                _this2.Alert('success', 'hard_tokens.management.delete.success');
            });
        }
    }, {
        key: 'showEdit',
        value: function showEdit(token) {
            var _this3 = this;

            this.HardTokenService.getDetail(token.id).then(function (data) {
                token.secret = data.secret;
                token.privateIdentity = data.privateIdentity;
                _this3.$state.go('company.hard-token-management.edit', { token: token, hardTokenId: token.id });
            });
        }
    }, {
        key: 'showEditModal',
        value: function showEditModal(token) {
            var _this4 = this;

            this.editingToken = token;
            this.HardTokenService.getDetail(token.id).then(function (data) {
                token.secret = data.secret;
                token.privateIdentity = data.privateIdentity;
                _this4.HardTokenEditModal(token);
            }).finally(function () {
                _this4.editingToken = null;
            });
        }
    }, {
        key: 'getState',
        value: function getState(token) {
            if (token.isSecondaryDeviceOfUser) {
                return token.status === 'ACTIVE' ? 'secondary_device_of_user' : 'secondary_device_of_user_blocked';
            }
            if (token.hasAccounts) {
                return token.status === 'ACTIVE' ? 'has_assigned_accounts' : 'has_assigned_accounts_blocked';
            }
            return token.status === 'ACTIVE' ? 'no_account_assigned' : 'no_account_assigned_blocked';
        }

        /*showHardTokenIntegrationModal() {
            this.$uibModal
                .open({component: 'integrateHardToken', size: 'xl'}).result
                .then(this.success.bind(this))
                .catch(this.dismissed.bind(this))
        }
        showFidoU2fIntegrationModal() {
            this.$uibModal
                .open({component: 'integrateFidoU2f', size: 'xl'}).result
                .then(this.success.bind(this))
                .catch(this.dismissed.bind(this))
        }*/

        /* showSyncModal(token) {
             this.$uibModal.open({
                 component: 'companyHardTokenManagementSync',
                 resolve: {token: () => token},
             })
         }*/
        /*showUsbTokenIntegrationModal() {
            this.$uibModal
                .open({component: 'integrateUsbToken', size: 'xl'}).result
                .then(this.success.bind(this))
                .catch(this.dismissed.bind(this))
        }*/

        /** @private */

    }, {
        key: 'dismissed',
        value: function dismissed(reason) {
            if (reason === 'failed') {
                this.Alert('danger', 'hard_tokens.integrate.add_error');
            }
        }

        /** @private */

    }, {
        key: 'success',
        value: function success() {
            this.$state.reload(this.$state.current);
            this.Alert('success', 'hard_tokens.integrate.add_success');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$location', 'Alert', 'HardTokenService'];

    /** @ngInject */
    function Controller($location, Alert, HardTokenService) {
        _classCallCheck(this, Controller);

        this.$location = $location;
        this.Alert = Alert;
        this.HardTokenService = HardTokenService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.generatedUrl = '';
            this.otps = { otp1: '', otp2: '', otp3: '' };
        }
    }, {
        key: 'generateUrl',
        value: function generateUrl() {
            var _this = this;

            this.isGeneratingUrl = true;
            this.HardTokenService.generateSyncUrl(this.resolve.token).then(function (_ref) {
                var trackerId = _ref.trackerId;
                return _this.generatedUrl = _this.$location.absUrl().replace(/#.*/, '#/htsync/' + trackerId);
            }).finally(function () {
                return _this.isGeneratingUrl = false;
            });
        }
    }, {
        key: 'sync',
        value: function sync() {
            var _this2 = this;

            this.isSyncing = true;
            this.HardTokenService.sync(this.resolve.token, this.otps).then(function () {
                return _this2.Alert('success', 'company.hard-token-management.sync.synced');
            }).catch(function () {
                return _this2.Alert('danger', 'company.hard-token-management.sync.failed');
            }).finally(function () {
                return _this2.isSyncing = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'IdpAuthenticatorsService'];

    /** @ngInject */
    function Controller($state, Alert, IdpAuthenticatorsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.type = 'OIDC';
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.IdpAuthenticatorsService.createIdpAuthenticator(this.companyId, this.name, this.type).then(function (idpAuthenticator) {
                _this.Alert('success', 'company.idp-authenticators.add-new.added');
                return _this.$state.go('^.manage', { idpAuthenticatorId: idpAuthenticator.id }, { reload: 'company.idp-authenticators' });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'IdpAuthenticatorsService'];

    /** @ngInject */
    function Controller($state, Alert, IdpAuthenticatorsService) {
        _classCallCheck(this, Controller);

        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
        this.Alert = Alert;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'addNewIdpAuthenticator',
        value: function addNewIdpAuthenticator() {
            return this.$state.go('company.idp-authenticators.add');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'IdpAuthenticatorsService'];

    /** @ngInject */
    function Controller($state, Alert, IdpAuthenticatorsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.idpAuthenticator == null) {
                this.$state.go('company.idp-authenticators.list');
                return;
            }
            this.st = new _smartTable.SmartTable();
            this.samlAppLogo = window.env.urls.samlAppLogo;
        }
    }, {
        key: 'assign',
        value: function assign() {
            var _this = this;

            this.isSaving = true;
            this.IdpAuthenticatorsService.assignApplications(this.companyId, this.idpAuthenticator.id, this.st.selectedIds).then(function () {
                return _this.$state.go('^', {}, { reload: 'company.idp-authenticators' });
            }).then(function () {
                return _this.Alert('success', 'company.idp-authenticators.manage.applications.updated');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'IdpAuthenticatorsService'];

    /** @ngInject */
    function Controller($state, Alert, IdpAuthenticatorsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.idpAuthenticator == null) {
                this.$state.go('company.idp-authenticators.list');
                return;
            }
            this.st = new _smartTable.SmartTable();
            this.samlAppLogo = window.env.urls.samlAppLogo;
        }
    }, {
        key: 'unassign',
        value: function unassign() {
            var _this = this;

            this.isSaving = true;
            this.IdpAuthenticatorsService.unassignApplications(this.companyId, this.idpAuthenticator.id, this.st.selectedIds).then(function () {
                _this.Alert('success', 'company.idp-authenticators.manage.applications.updated');
                _this.$state.go('.', {}, { reload: 'company.idp-authenticators' });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$scope', '$state', '$http', '$translate', 'Alert', 'IdpAuthenticatorsService', 'DestructiveOperationModal', 'ConfirmModal'];

    /** @ngInject */
    function Controller($rootScope, $scope, $state, $http, $translate, Alert, IdpAuthenticatorsService, DestructiveOperationModal, ConfirmModal) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$http = $http;
        this.$translate = $translate;
        this.Alert = Alert;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.ConfirmModal = ConfirmModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.idpAuthenticator == null) {
                this.$state.go('company.idp-authenticators.list');
                return;
            }
            this.$idpAuthenticator = angular.copy(this.idpAuthenticator);
            this.isOidc = this.idpAuthenticator.type === 'OIDC';
            this.isSaml = this.idpAuthenticator.type === 'SAML';

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
        }
    }, {
        key: 'isMetadataUrlValid',
        value: function isMetadataUrlValid() {
            var metadataUrl = this.metadataUrl;
            return metadataUrl && this.$rootScope.webPattern.test(metadataUrl);
        }
    }, {
        key: 'metadataFileChanged',
        value: function metadataFileChanged() {
            if (this.metadataFile.size > 500000) {
                this.Alert('danger', 'Metadata XML file should be smaller than 500 KB');
                this.metadataFile = null;
            }
        }
    }, {
        key: 'saveMetadataUrl',
        value: function saveMetadataUrl() {
            var _this2 = this;

            this.isSaving = true;
            var messageKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.message', { metadataXml: 'METADATA URL' });
            var titleKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.title', { metadataXml: 'METADATA URL' });
            this.ConfirmModal({
                messageKey: messageKey,
                titleKey: titleKey
            }).then(function () {
                return _this2.saveMetadata(_this2.metadataUrl, null);
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'saveMetadataFile',
        value: function saveMetadataFile() {
            var _this3 = this;

            this.isSaving = true;
            var messageKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.message', { metadataXml: 'METADATA XML' });
            var titleKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.title', { metadataXml: 'METADATA XML' });
            this.ConfirmModal({
                messageKey: messageKey,
                titleKey: titleKey
            }).then(function () {
                return _this3.saveMetadata(null, _this3.metadataFile);
            }).finally(function () {
                return _this3.isSaving = false;
            });
        }
    }, {
        key: 'saveMetadata',
        value: function saveMetadata(metadataUrl, metadataFile) {
            var ctrl = this;
            if (metadataUrl != null && metadataUrl.length > 0) {
                this.uploadMetadataUrl(metadataUrl);
            } else if (metadataFile != null) {
                var reader = new FileReader();
                reader.onload = function () {
                    ctrl.uploadMetadataXml(reader.result);
                };
                if (metadataFile) {
                    reader.readAsText(metadataFile);
                }
            }
        }
    }, {
        key: 'uploadMetadataXml',
        value: function uploadMetadataXml(metadataStr) {
            var _this4 = this;

            this.IdpAuthenticatorsService.uploadMetadataXml(this.companyId, this.idpAuthenticator.id, metadataStr).then(function () {
                _this4.Alert('success', 'company.idp-authenticators.manage.config.updated');
                _this4.$state.reload('company.idp-authenticators');
            });
        }
    }, {
        key: 'uploadMetadataUrl',
        value: function uploadMetadataUrl(metadataUrl) {
            var _this5 = this;

            this.IdpAuthenticatorsService.uploadMetadataUrl(this.companyId, this.idpAuthenticator.id, metadataUrl).then(function () {
                _this5.Alert('success', 'company.idp-authenticators.manage.config.updated');
                _this5.$state.reload('company.idp-authenticators');
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this6 = this;

            this.isSaving = true;
            this.IdpAuthenticatorsService.updateIdpAuthenticator(this.companyId, this.idpAuthenticator).then(function (idpAuthenticator) {
                _this6.idpAuthenticator = angular.copy(idpAuthenticator);
                _this6.$idpAuthenticator = angular.copy(idpAuthenticator);
                _this6.Alert('success', 'company.idp-authenticators.manage.config.updated');
            }).finally(function () {
                return _this6.isSaving = false;
            });
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$idpAuthenticator, this.idpAuthenticator);
        }
    }, {
        key: 'discardChanges',
        value: function discardChanges() {
            this.idpAuthenticator = angular.copy(this.$idpAuthenticator);
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _this7 = this;

            this.isSaving = true;
            this.DestructiveOperationModal({
                titleKey: 'global.confirm_delete',
                textKey: 'company.idp-authenticators.confirm_delete.text',
                onSubmit: function onSubmit(params) {
                    return _this7.IdpAuthenticatorsService.deleteIdpAuthenticator(_this7.companyId, _this7.idpAuthenticator.id, params).then(function () {
                        _this7.Alert('success', 'company.idp-authenticators.removed');
                        _this7.$state.go('company.idp-authenticators.list', {}, { reload: true });
                    });
                }
            }).finally(function () {
                return _this7.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.idpAuthenticator == null) {
                this.$state.go('company.idp-authenticators.list');
                return;
            }
        }
    }, {
        key: 'showAssignApplicationButton',
        value: function showAssignApplicationButton() {
            return this.$state.is('company.idp-authenticators.manage.applications');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _updates = __webpack_require__(139);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$state', '$uibModal', 'Alert'];

    /** @ngInject */
    function Controller($rootScope, $state, $uibModal, Alert) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.initRegistration();
            this.initRoles();
            this.initWhatsNew();
        }

        /** @private */

    }, {
        key: 'initRegistration',
        value: function initRegistration() {
            if (this.reg) {
                this.Alert('success', 'registration.company.created_success');
                this.$state.go('.', { reg: null });
            }
        }

        /** @private */

    }, {
        key: 'initRoles',
        value: function initRoles() {
            var _canView;

            var role = this.currentCompany.authoritiesConstants;
            this.isActiveCompany = this.currentCompany.companyStatus === 'ACTIVE';
            var roleActive = this.isActiveCompany || role === 'READ_ONLY_ADMIN';
            var hasRole = function hasRole() {
                for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
                    roles[_key] = arguments[_key];
                }

                return ['SAASPASS_ADMIN', 'SUPER_ADMIN', 'READ_ONLY_ADMIN'].concat(roles).includes(role);
            };
            var hasRoleView = function hasRoleView() {
                return hasRole.apply(undefined, arguments) && roleActive;
            };
            this.canView = (_canView = {
                'reseller': hasRole(),
                'saaspass-admin': role === 'SAASPASS_ADMIN',
                'directory-services': hasRoleView('ORGANIZATION_ADMIN', 'SHARING_CENTER_ADMIN'),
                'directory-groups': hasRoleView('ORGANIZATION_ADMIN'),
                'saaspass-users': hasRoleView('SHARING_CENTER_ADMIN'),
                'directory-integration': hasRoleView(),

                'applications-group': hasRoleView('APPLICATION_ADMIN', 'DEVELOPER_ADMIN', 'SHARING_CENTER_ADMIN'),
                'applications': hasRoleView('APPLICATION_ADMIN'),
                'sharing-center': hasRoleView('SHARING_CENTER_ADMIN'),
                'enterprise-password-manager': hasRoleView(),
                'hard-token-management': hasRoleView(),
                'software-license-management': hasRole('APPLICATION_ADMIN'),

                'computer-protection': hasRoleView('APPLICATION_ADMIN'),
                'slack-info': hasRoleView(),
                'google-marketplace-instructions': hasRoleView(),
                'google-hangouts-bot': hasRoleView(),
                'custom-app-integration': hasRoleView('DEVELOPER_ADMIN'),
                'idp-authenticators': hasRoleView('DEVELOPER_ADMIN'),
                'saaspass-connect': hasRoleView('DEVELOPER_ADMIN'),

                // 'saaspass-vpn': hasRoleView('DEVELOPER_ADMIN'),
                'saaspass-vpn': false,

                'sms-services': hasRoleView(),
                'policies': hasRoleView(),

                'recovery': hasRoleView(),
                'administrators': hasRoleView(),
                'reports-main': hasRoleView(),
                'corporate-settings': hasRoleView(),
                'license-management': this.licenseInfo && hasRoleView()
            }, _defineProperty(_canView, 'reports-main', hasRoleView()), _defineProperty(_canView, 'corporate-settings', hasRoleView()), _defineProperty(_canView, 'domains', hasRoleView()), _canView);
        }

        /** @private */

    }, {
        key: 'initWhatsNew',
        value: function initWhatsNew() {
            var _this = this;

            var lastUpdateToWhatsNewSection = new Date(_updates.updates[0].date);

            if (this.$rootScope.logCompanyAccessed$) {
                this.$rootScope.logCompanyAccessed$.then(function (lastSwitchToCompanyMode) {
                    if (new Date(lastSwitchToCompanyMode) < lastUpdateToWhatsNewSection) {
                        _this.$uibModal.open({ component: 'whatsNewAlertModal' }).result.finally(function () {
                            return _this.$rootScope.logCompanyAccessed$ = null;
                        });
                    }
                });
            }
        }
    }, {
        key: 'isReseller',
        value: function isReseller() {
            return this.currentCompany.companyType === 'RESELLER';
        }
    }, {
        key: 'portalActionsRestricted',
        value: function portalActionsRestricted() {
            return this.licenseInfo.licenseStatus == 'UNLICENSED' && this.licenseInfo.portalActionsRestricted;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$window'];

    /** @ngInject */
    function Controller($window) {
        _classCallCheck(this, Controller);

        this.$window = $window;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'viewInvoice',
        value: function viewInvoice(url) {
            this.$window.open(url, '_blank');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$stateParams', '$window', '$state', '$rootScope', 'Alert', 'ConfirmModal', 'LicenseManagementService', 'LicenseTierDetails'];

    /** @ngInject */
    function Controller($stateParams, $window, $state, $rootScope, Alert, ConfirmModal, LicenseManagementService, LicenseTierDetails) {
        _classCallCheck(this, Controller);

        this.$stateParams = $stateParams;
        this.$window = $window;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.Alert = Alert;
        this.ConfirmModal = ConfirmModal;
        this.LicenseManagementService = LicenseManagementService;
        this.LicenseTierDetails = LicenseTierDetails;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.emailPattern = this.$rootScope.emailPattern;
            this.licenseInfo = this.licenseDetails.licenseInfo;
            this.licenseInfo.autoRenewalEnabled = true;
            this.currentPlan = this.licenseDetails.companyLicensePlan;
            this.featureUsages = [];
            if (this.licenseDetails.featureUsages.length > 0) {
                this.featureUsages = JSON.parse(this.licenseDetails.featureUsages);
                if (!this.licenseInfo.portalActionsRestricted) {
                    this.featureUsages.forEach(function (usage) {
                        if (usage.feature === 'Number of user licenses') {
                            usage.sref = 'company.user-directories.saaspass-users';
                        } else if (usage.feature === 'Number of Active Directories') {
                            usage.sref = 'company.directory-integration';
                        } else if (usage.feature === 'Number of LDAP Directories') {
                            usage.sref = 'company.directory-integration';
                        } else if (usage.feature === 'Number of admins') {
                            usage.sref = 'company.administrators';
                        } else if (usage.feature === 'Number of Sms users') {
                            usage.sref = 'company.user-directories.saaspass-users.sms-users';
                        } else if (usage.feature === 'Number of Custom apps') {
                            usage.sref = 'company.custom-app-integration';
                        } else if (usage.feature === 'Number of prebuilt SAML apps') {
                            usage.sref = 'company.applications';
                        } else if (usage.feature === 'Number of Custom SAML apps') {
                            usage.sref = 'company.applications';
                        } else if (usage.feature === 'Number of VPN apps') {
                            usage.sref = 'company.applications';
                        } else if (usage.feature === 'Number of Computer login apps') {
                            usage.sref = 'company.computer-protection';
                        } else if (usage.feature === 'Number of EPM apps') {
                            usage.sref = 'company.applications';
                        } else if (usage.feature === 'Number of Sharing Center apps') {
                            usage.sref = 'company.applications';
                        }
                    });
                }
            }
        }
    }, {
        key: 'autoRenewalEnabled',
        value: function autoRenewalEnabled() {
            return !this.currentPlan.cancelAtSubscriptionEnd;
        }
    }, {
        key: 'cancelAutoRenewal',
        value: function cancelAutoRenewal() {
            var _this = this;

            this.ConfirmModal({
                messageKey: 'Subscription will be cancelled at the end of the subscription period. Do you want to continue?',
                titleKey: 'sp-confirm.title'
            }).then(function () {
                _this.LicenseManagementService.cancelAutoRenewal(_this.$stateParams.companyId).then(function () {
                    _this.Alert('success', 'global.messages.operation-successful');
                    _this.currentPlan.cancelAtSubscriptionEnd = true;
                });
            });
        }
    }, {
        key: 'viewTierDetails',
        value: function viewTierDetails() {
            this.LicenseTierDetails(this.licenseTiers);
        }
    }, {
        key: 'cancelWaitingActivity',
        value: function cancelWaitingActivity() {
            var _this2 = this;

            this.LicenseManagementService.cancelWaitingActivity(this.$stateParams.companyId).then(function () {
                _this2.Alert('success', 'global.messages.operation-successful');
                _this2.$state.reload('company.license-management');
            });
        }
    }, {
        key: 'setPaymentMethod',
        value: function setPaymentMethod() {
            var _this3 = this;

            this.LicenseManagementService.setPaymentMethod(this.$stateParams.companyId).then(function (url) {
                _this3.$window.open(url, '_blank');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['LicenseManagementService', 'LicenseTierDetails', 'Alert', '$stateParams'];

    /** @ngInject */
    function Controller(LicenseManagementService, LicenseTierDetails, Alert, $stateParams) {
        _classCallCheck(this, Controller);

        this.LicenseManagementService = LicenseManagementService;
        this.LicenseTierDetails = LicenseTierDetails;
        this.Alert = Alert;
        this.$stateParams = $stateParams;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: '$onChanges',
        value: function $onChanges() {}
    }, {
        key: 'viewTierDetails',
        value: function viewTierDetails() {
            this.LicenseTierDetails(this.licenseTiers);
        }
    }, {
        key: 'saveEmail',
        value: function saveEmail(email) {
            var _this = this;

            this.LicenseManagementService.changeLicenseEmail(this.$stateParams.companyId, email).then(function () {
                _this.Alert('success', 'global.messages.operation-successful');
                _this.currentPlan.licensingActivitiesEmailAddress = email;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$window'];

    /** @ngInject */
    function Controller($window) {
        _classCallCheck(this, Controller);

        this.$window = $window;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'viewInvoice',
        value: function viewInvoice(url) {
            this.$window.open(url, '_blank');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.licenseDetails) {
                this.$state.go('company');
            }
        }
    }, {
        key: 'isLicensed',
        value: function isLicensed() {
            return this.licenseDetails.licenseInfo.licenseStatus == 'LICENSED';
        }
    }]);

    return Controller;
}();

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$stateParams', '$rootScope', '$window', 'LicenseTierDetails', 'LicenseManagementService'];

    /** @ngInject */
    function Controller($state, $stateParams, $rootScope, $window, LicenseTierDetails, LicenseManagementService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.LicenseTierDetails = LicenseTierDetails;
        this.LicenseManagementService = LicenseManagementService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.licenseInfo = this.licenseDetails.licenseInfo;
            this.selectedTier = this.licenseTiers[0];
            this.selectedPrice = this.selectedTier.prices[0];
            this.seats = 10;

            if (this.licenseInfo.licenseStatus == 'LICENSED' || this.licenseDetails.waitingActivity) {
                this.$state.go('company.license-management.current-plan');
            }
        }
    }, {
        key: 'viewTierDetails',
        value: function viewTierDetails() {
            this.LicenseTierDetails(this.licenseTiers);
        }
    }, {
        key: 'selectedTierChanged',
        value: function selectedTierChanged() {
            this.selectedPrice = this.selectedTier.prices[0];
        }
    }, {
        key: 'processBillingInterval',
        value: function processBillingInterval(interval) {
            if (interval == 1) {
                return 'Monthly';
            } else if (interval == 12) {
                return '1 Year';
            } else if (interval == 24) {
                return '2 Years';
            } else if (interval == 36) {
                return '3 Years';
            }
        }
    }, {
        key: 'getTotalPriceValue',
        value: function getTotalPriceValue() {
            if (this.selectedTier && this.selectedPrice && this.seats > 0) {
                return this.selectedPrice.price * this.seats + ' ' + this.selectedPrice.currency;
            } else {
                return 'NaN';
            }
        }
    }, {
        key: 'startSubscription',
        value: function startSubscription() {
            var _this = this;

            var purchaseDTO = {
                tierId: this.selectedTier.tierId,
                priceId: this.selectedPrice.priceId,
                userSeats: this.seats,
                promotionCode: this.promotionCode,
                email: this.email
            };
            this.LicenseManagementService.licensePurchase(this.$stateParams.companyId, purchaseDTO).then(function (result) {
                if (result.checkoutError) {
                    _this.Alert('danger', result.checkoutError);
                } else {
                    if (result.sessionUrl) {
                        _this.sessionUrl = result.sessionUrl;
                        _this.$window.open(result.sessionUrl, '_blank');
                    }
                    _this.$state.go('^', {}, { reload: '^' });
                }
            });
        }
    }, {
        key: 'subscribeButtonDisabled',
        value: function subscribeButtonDisabled() {
            return !(this.selectedTier && this.selectedPrice && this.seats > 0 && this.$rootScope.emailPattern.test(this.email));
        }
    }]);

    return Controller;
}();

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.tiers = this.resolve.tiers;
        }
    }, {
        key: 'processTierParam',
        value: function processTierParam(param) {
            if (param === false || param === 0) {
                return '<i class="fa fa-minus" />';
            }
            if (param === true) {
                return '<i class="fa fa-check" />';
            }
            return param;
        }
    }, {
        key: 'processBillingInterval',
        value: function processBillingInterval(interval) {
            if (interval == 1) {
                return 'Monthly';
            } else if (interval == 12) {
                return '1 Year';
            } else if (interval == 24) {
                return '2 Years';
            } else if (interval == 36) {
                return '3 Years';
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$stateParams', 'LicenseManagementService', 'OkModal', 'Alert'];

    /** @ngInject */
    function Controller($state, $stateParams, LicenseManagementService, OkModal, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.LicenseManagementService = LicenseManagementService;
        this.OkModal = OkModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.licenseInfo = this.licenseDetails.licenseInfo;
            this.currentPlan = this.licenseDetails.companyLicensePlan;
            this.selectedTier = this.licenseTiers[0];
            this.selectedPrice = this.selectedTier.prices[0];

            // if(this.licenseInfo.licenseStatus != 'LICENSED') {
            //     this.$state.go('company.license-management.current-plan');
            // }
        }
    }, {
        key: 'calculate',
        value: function calculate() {
            var _this = this;

            var purchaseDTO = {
                userSeats: this.seats,
                promotionCode: this.promotionCode
            };
            this.LicenseManagementService.calculateLicenseCharges(this.$stateParams.companyId, purchaseDTO).then(function (data) {
                _this.calculatedCharges = data;
            });
        }
    }, {
        key: 'purchase',
        value: function purchase() {
            var _this2 = this;

            var purchaseDTO = {
                // tierId: this.selectedTier.tierId,
                // priceId: this.selectedPrice.priceId,
                userSeats: this.seats,
                promotionCode: this.promotionCode
                // email: this.email
            };
            this.LicenseManagementService.upgradeLicense(this.$stateParams.companyId, purchaseDTO).then(function (result) {
                if (result.checkoutError) {
                    _this2.Alert('danger', result.checkoutError);
                } else {
                    _this2.$state.reload('company.license-management');
                    var message = 'Your purchase request has been successfully sent. \n                    If your payment method was not saved during your license subscription, \n                    you will receive an open invoice to email: ' + (_this2.currentPlan.licensingActivitiesEmailAddress || '') + '.\n                    <br><br> After the payment is done, subscription update will be applied on the admin portal';
                    _this2.OkModal(message).then(function () {
                        _this2.$state.go('^');
                    });
                }
            }).catch(function (error) {
                if (error.data.serviceErrorCode === 'ERR_111102') {
                    var message = error.data.message + '\n                    <br><br><a class="btn sp_small-primary-button" target="_blank" href="' + error.data.more + '">Add Payment Method</a>';
                    _this2.OkModal(message).then(function () {});
                }
            });
        }
    }, {
        key: 'subscribeButtonDisabled',
        value: function subscribeButtonDisabled() {
            return !this.seats || this.seats <= 0 || this.licenseDetails.waitingActivity;
        }
    }, {
        key: 'cancelWaitingActivity',
        value: function cancelWaitingActivity() {
            var _this3 = this;

            this.LicenseManagementService.cancelWaitingActivity(this.$stateParams.companyId).then(function () {
                _this3.Alert('success', 'global.messages.operation-successful');
                _this3.$state.reload('company.license-management');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$stateParams', 'LicenseManagementService', 'OkModal', 'LicenseTierDetails', 'Alert'];

    /** @ngInject */
    function Controller($state, $stateParams, LicenseManagementService, OkModal, LicenseTierDetails, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$stateParams = $stateParams;
        this.LicenseManagementService = LicenseManagementService;
        this.OkModal = OkModal;
        this.LicenseTierDetails = LicenseTierDetails;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.licenseInfo = this.licenseDetails.licenseInfo;
            this.currentPlan = this.licenseDetails.companyLicensePlan;
            this.selectedTier = this.licenseTiers[0];
            this.selectedPrice = this.selectedTier.prices[0];

            // if(this.licenseInfo.licenseStatus != 'LICENSED') {
            //     this.$state.go('company.license-management.current-plan');
            // }

            this.availableTiers = this.licenseTiers.filter(function (tier) {
                return tier.tierId > _this.currentPlan.currentTier.tierId;
            });
        }
    }, {
        key: 'calculate',
        value: function calculate() {
            var _this2 = this;

            var purchaseDTO = {
                tierId: this.newTierId,
                promotionCode: this.promotionCode
            };
            this.LicenseManagementService.calculateLicenseCharges(this.$stateParams.companyId, purchaseDTO).then(function (data) {
                _this2.calculatedCharges = data;
            });
        }
    }, {
        key: 'purchase',
        value: function purchase() {
            var _this3 = this;

            var purchaseDTO = {
                tierId: this.newTierId,
                promotionCode: this.promotionCode
                // priceId: this.selectedPrice.priceId,
                // userSeats: this.seats,
                // email: this.email
            };
            this.LicenseManagementService.upgradeLicenseTier(this.$stateParams.companyId, purchaseDTO).then(function (result) {
                if (result.checkoutError) {
                    _this3.Alert('danger', result.checkoutError);
                } else {
                    _this3.$state.reload('company.license-management');
                    var message = 'Your purchase request has been successfully sent. \n                    If your payment method was not saved during your license subscription, \n                    you will receive an open invoice to email: ' + (_this3.currentPlan.licensingActivitiesEmailAddress || '') + '.\n                    <br><br> After the payment is done, subscription update will be applied on the admin portal';
                    _this3.OkModal(message).then(function () {
                        _this3.$state.go('^');
                    });
                }
            }).catch(function (error) {
                if (error.data.serviceErrorCode === 'ERR_111102') {
                    console.log(error.data.more);
                    var message = error.data.message + '\n                    <br><br><a class="btn sp_small-primary-button" target="_blank" href="' + error.data.more + '">Add Payment Method</a>';
                    _this3.OkModal(message).then(function () {});
                }
            });
        }
    }, {
        key: 'subscribeButtonDisabled',
        value: function subscribeButtonDisabled() {
            return !this.newTierId || this.licenseDetails.waitingActivity;
        }
    }, {
        key: 'viewTierDetails',
        value: function viewTierDetails() {
            this.LicenseTierDetails(this.licenseTiers);
        }
    }, {
        key: 'cancelWaitingActivity',
        value: function cancelWaitingActivity() {
            var _this4 = this;

            this.LicenseManagementService.cancelWaitingActivity(this.$stateParams.companyId).then(function () {
                _this4.Alert('success', 'global.messages.operation-successful');
                _this4.$state.reload('company.license-management');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['AuthenticationAccessPolicyResource', 'Alert', '$state'];

    /** @ngInject */
    function Controller(AuthenticationAccessPolicyResource, Alert, $state) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$state = $state;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.newAuthAccessSettings = angular.copy(this.authenticationAccessPolicyList);
            if (this.application.accessPolicyId) {
                this.selectedPolicyId = this.application.accessPolicyId;
            } else {
                this.selectedPolicyId = '-1';
            }
        }
    }, {
        key: 'is',
        value: function is() {
            for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
                types[_key] = arguments[_key];
            }

            return types.includes(this.application.applicationType.slug);
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.isSaving || this.notModified();
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return this.application.accessPolicyId === this.selectedPolicyId || this.application.accessPolicyId == null && this.selectedPolicyId == -1;
        }
    }, {
        key: 'saveAuthPolicy',
        value: function saveAuthPolicy() {
            var _this = this;

            this.isSaving = true;
            this.AuthenticationAccessPolicyResource.applyPolicy(this.companyId, this.selectedPolicyId, this.application.id).then(function () {
                _this.Alert('success', 'company.policies.settings_updated');
            }).then(function () {
                return _this.$state.reload('company.manage-application');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["AuthenticationPoliciesService", "AuthenticationAccessPolicyResource", "Alert", "$state"];

    /** @ngInject */
    function Controller(AuthenticationPoliciesService, AuthenticationAccessPolicyResource, Alert, $state) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$state = $state;
        this.AuthenticationPoliciesService = AuthenticationPoliciesService;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            this.newAuthSettings = angular.copy(this.currentPasswordAuthenticationSettings);
            this.newAuthAccessSettings = angular.copy(this.authenticationAccessPolicyList);
            this.selectedPolicy = this.newAuthSettings.passwordPolicyId != null ? this.newAuthSettings.companyPasswordPolicies.find(function (p) {
                return p.passwordPolicyId === _this.newAuthSettings.passwordPolicyId;
            }) : this.newAuthSettings.companyPasswordPolicies.find(function (p) {
                return p.passwordPolicyName === "Default Policy";
            });
            this.pap = this.selectedPolicy;
            this.aap = this.newAuthAccessSettings.find(function (p) {
                return p.id === _this.application.accessPolicyId;
            });
            if (this.aap) {
                this.selectedAuthAccessPolicy = this.aap;
            } else {
                this.selectedAuthAccessPolicy = this.newAuthAccessSettings.find(function (p) {
                    return p.name === "Default Policy";
                });
            }
            if (this.application.applicationType.slug === 'google-apps') {
                //this.newAuthSettings.passwordAuthenticationOnGoogle=true;
            }
            this.settings;
        }
    }, {
        key: "cancel",
        value: function cancel() {
            this.config = _extends({}, this.application);
        }
    }, {
        key: "is",
        value: function is() {
            for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
                types[_key] = arguments[_key];
            }

            return types.includes(this.application.applicationType.slug);
        }

        // notModified() {
        //     return angular.equals(this.application, this.config);
        // }

        // save() {
        //     this.isSaving = true;
        //
        // }

    }, {
        key: "saveDisabled",
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving || this.notModified();
        }
    }, {
        key: "notModified",
        value: function notModified() {
            var _this2 = this;

            var obj1 = this.newAuthSettings.passwordPolicyId != null ? this.newAuthSettings.companyPasswordPolicies.find(function (p) {
                return p.passwordPolicyId === _this2.newAuthSettings.passwordPolicyId;
            }) : this.newAuthSettings.companyPasswordPolicies.find(function (p) {
                return p.passwordPolicyName === "Default Policy";
            });
            return obj1 !== this.selectedPolicy || angular.equals(this.newAuthSettings, this.currentPasswordAuthenticationSettings);
        }
    }, {
        key: "save",
        value: function save() {
            var _this3 = this;

            this.newAuthSettings.passwordPolicyId = this.selectedPolicy.passwordPolicyId;

            if (this.application.applicationType.slug === 'google-apps') {
                this.settings = {
                    "enablePasswordAuthentication": this.newAuthSettings.enablePasswordAuthentication,
                    "passwordAuthenticationOnGoogle": this.newAuthSettings.enablePasswordAuthentication === false ? null : this.newAuthSettings.passwordAuthenticationOnGoogle,
                    "passwordPolicyId": this.newAuthSettings.passwordAuthenticationOnGoogle === false ? this.selectedPolicy.passwordPolicyId : null,
                    "enableOnPremisesAdAuthentication": this.newAuthSettings.enablePasswordAuthentication === false ? false : this.newAuthSettings.enableOnPremisesAdAuthentication,
                    "notAssignedAccountLoginSetting": this.newAuthSettings.notAssignedAccountLoginSetting,
                    "pendingAssignedAccountLoginSetting": this.newAuthSettings.pendingAssignedAccountLoginSetting,
                    "notExistAccountLoginSetting": this.newAuthSettings.notExistAccountLoginSetting
                };
            } else {
                if (this.newAuthSettings.enablePasswordAuthentication === false) {
                    this.settings = {
                        "enableOnPremisesAdAuthentication": false,
                        "enablePasswordAuthentication": false,
                        "notAssignedAccountLoginSetting": null,
                        "notExistAccountLoginSetting": null,
                        "passwordAuthenticationOnGoogle": null,
                        "passwordPolicyId": null,
                        "pendingAssignedAccountLoginSetting": null
                    };
                } else this.settings = this.newAuthSettings;
            }

            this.AuthenticationPoliciesService.UpdateCurrentPasswordAuthenticationSettings(this.companyId, this.application.id, this.settings).then(function () {
                return _this3.Alert('success', 'company.policies.settings_updated');
            }).then(function () {
                return _this3.$state.reload('company.manage-application');
            }).finally(function () {
                return _this3.isSaving = false;
            });
        }
    }, {
        key: "saveAuthPolicy",
        value: function saveAuthPolicy() {
            var _this4 = this;

            this.AuthenticationAccessPolicyResource.applyPolicy(this.companyId, this.selectedAuthAccessPolicy.id, this.application.id).then(function () {
                _this4.Alert('success', 'company.policies.settings_updated');
            }).then(function () {
                return _this4.$state.reload('company.manage-application');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['AuthenticationPoliciesService', 'Alert', '$state'];

    /** @ngInject */
    function Controller(AuthenticationPoliciesService, Alert, $state) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$state = $state;
        this.AuthenticationPoliciesService = AuthenticationPoliciesService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.newAuthSettings = angular.copy(this.currentPasswordAuthenticationSettings);
            this.selectedPolicy = this.newAuthSettings.passwordPolicyId != null ? this.newAuthSettings.companyPasswordPolicies.find(function (p) {
                return p.passwordPolicyId === _this.newAuthSettings.passwordPolicyId;
            }) : this.newAuthSettings.companyPasswordPolicies.find(function (p) {
                return p.passwordPolicyName === "Default Policy";
            });
            this.pap = this.selectedPolicy;
            if (this.application.applicationType.slug === 'google-apps') {
                //this.newAuthSettings.passwordAuthenticationOnGoogle=true;
            }
        }
    }, {
        key: 'is',
        value: function is() {
            for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
                types[_key] = arguments[_key];
            }

            return types.includes(this.application.applicationType.slug);
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.isSaving || this.notModified();
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            var pwPolicyNotModified = this.currentPasswordAuthenticationSettings.passwordPolicyId === this.selectedPolicy.passwordPolicyId || this.currentPasswordAuthenticationSettings.passwordPolicyId == null && !this.newAuthSettings.enablePasswordAuthentication;
            return pwPolicyNotModified && angular.equals(this.newAuthSettings, this.currentPasswordAuthenticationSettings);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.newAuthSettings.passwordPolicyId = this.selectedPolicy.passwordPolicyId;
            this.isSaving = true;
            if (this.application.applicationType.slug === 'google-apps') {
                this.settings = {
                    "enablePasswordAuthentication": this.newAuthSettings.enablePasswordAuthentication,
                    "passwordAuthenticationOnGoogle": this.newAuthSettings.enablePasswordAuthentication === false ? null : this.newAuthSettings.passwordAuthenticationOnGoogle,
                    "passwordPolicyId": this.newAuthSettings.passwordAuthenticationOnGoogle === false ? this.selectedPolicy.passwordPolicyId : null,
                    "enableOnPremisesAdAuthentication": this.newAuthSettings.enablePasswordAuthentication === false ? false : this.newAuthSettings.enableOnPremisesAdAuthentication,
                    "notAssignedAccountLoginSetting": this.newAuthSettings.notAssignedAccountLoginSetting,
                    "pendingAssignedAccountLoginSetting": this.newAuthSettings.pendingAssignedAccountLoginSetting,
                    "notExistAccountLoginSetting": this.newAuthSettings.notExistAccountLoginSetting
                };
            } else {
                if (this.newAuthSettings.enablePasswordAuthentication === false) {
                    this.settings = {
                        "enableOnPremisesAdAuthentication": false,
                        "enablePasswordAuthentication": false,
                        "notAssignedAccountLoginSetting": null,
                        "notExistAccountLoginSetting": null,
                        "passwordAuthenticationOnGoogle": null,
                        "passwordPolicyId": null,
                        "pendingAssignedAccountLoginSetting": null
                    };
                } else this.settings = this.newAuthSettings;
            }

            this.AuthenticationPoliciesService.UpdateCurrentPasswordAuthenticationSettings(this.companyId, this.application.id, this.settings).then(function () {
                return _this2.Alert('success', 'company.policies.settings_updated');
            }).then(function () {
                return _this2.$state.reload('company.manage-application');
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$scope', '$timeout', '$translate', 'ConfirmModal', 'Alert'];

    /** @ngInject */
    function Controller($rootScope, $scope, $timeout, $translate, ConfirmModal, Alert) {
        _classCallCheck(this, Controller);

        this.grantTypesTooltip = __webpack_require__(1498);
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.ConfirmModal = ConfirmModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.init();
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.init();
            this.$timeout(function () {
                return _this.watch();
            });
            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
            var baseURI = document.baseURI;
            this.oidcDiscoveryEndpoint = '' + baseURI + this.$model.apiKey + '/.well-known/openid-configuration';
        }
    }, {
        key: 'init',
        value: function init() {
            this.$model = this.applicationConfiguration;
            this.model = angular.copy(this.$model);
            this.applicationNamePattern = /^[^@]/;
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$model, this.model);
        }
    }, {
        key: 'addNoteAvailable',
        value: function addNoteAvailable() {
            return true;
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp($event) {
            if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
                this.onEnter();
            }
        }
    }, {
        key: 'metadataFileChanged',
        value: function metadataFileChanged() {
            if (this.metadataFile.size > 500000) {
                this.Alert('danger', 'Metadata XML file should be smaller than 500 KB');
                this.metadataFile = null;
            }
        }
    }, {
        key: 'isMetadataUrlValid',
        value: function isMetadataUrlValid() {
            var metadataUrl = this.metadataUrl;
            return metadataUrl && this.$rootScope.webPattern.test(metadataUrl);
        }
    }, {
        key: 'saveMetadataUrl',
        value: function saveMetadataUrl() {
            var _this2 = this;

            this.isSaving = true;
            var messageKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.message', { metadataXml: 'METADATA URL' });
            var titleKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.title', { metadataXml: 'METADATA URL' });
            this.ConfirmModal({
                messageKey: messageKey,
                titleKey: titleKey
            }).then(function () {
                return _this2.onSaveMetadata({ $url: _this2.metadataUrl });
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'saveMetadataFile',
        value: function saveMetadataFile() {
            var _this3 = this;

            this.isSaving = true;
            var messageKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.message', { metadataXml: 'METADATA XML' });
            var titleKey = this.$translate('company.manage-application.configuration.upload-metadata.confirm.title', { metadataXml: 'METADATA XML' });
            this.ConfirmModal({
                messageKey: messageKey,
                titleKey: titleKey
            }).then(function () {
                return _this3.onSaveMetadata({ $file: _this3.metadataFile });
            }).finally(function () {
                return _this3.isSaving = false;
            });
        }
    }, {
        key: 'refreshTokenChecked',
        value: function refreshTokenChecked() {
            var refreshTokenGrant = this.model.oidcGrants.find(function (grant) {
                return grant.value === 'refresh_token';
            });
            return refreshTokenGrant.selected;
        }
    }, {
        key: 'openUrl',
        value: function openUrl(url) {
            window.location.href = url;
        }
    }, {
        key: 'watch',
        value: function watch() {
            var _this4 = this;

            this.$scope.$watch(function () {
                return _this4.model;
            }, function () {
                if (_this4.model.isEPM && _this4.model.epmAppSettings.canUserSetPassword) {
                    _this4.model.epmAppSettings.canUserViewPassword = true;
                }
                _this4.$timeout(function () {
                    return _this4.onChange({ $value: _this4.model, $invalid: _this4.form.$invalid });
                });
            }, true);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.applicationConfigurationModelFromDto = applicationConfigurationModelFromDto;
exports.applicationConfigurationModelToDto = applicationConfigurationModelToDto;
function applicationConfigurationModelFromDto(dto) {
    var slug = dto.applicationType.slug;
    var isComputerLoginWithAD = slug === 'computer-login';
    var isOffice365 = slug === 'office-365';
    var isEPM = slug === 'enterprise-password-manager';
    var isSaaspassDemo = slug === 'saaspass-demo';
    var isSaaspassMySqlConnector = slug === 'saaspass-my-sql-connector';
    var isOidcConfigSupported = dto.applicationType.oidcConfigSupported;
    var isOidc = dto.applicationType.oidcConfigSupported && slug != 'generic-oauth2' && !slug.endsWith('proxy-sso');
    var isProxySso = dto.applicationType.slug.endsWith('proxy-sso');
    var isSaml = dto.applicationType.saml;

    return {
        adDomain: dto.adDomain,
        appDomain: dto.appDomain,
        applicationName: dto.applicationName,
        apiKey: dto.apiKey,
        note: dto.note,
        showNote: dto.showNote,
        applicationTypeId: dto.applicationType.applicationTypeId,
        applicationTypeDisplayName: dto.applicationType.applicationTypeDisplayName,
        companyAdDomains: dto.companyAdDomains,
        configDTO: dto.configDTO,
        configElements: (((dto.configDTO || {}).appConfig || {}).elements || []).map(function (_ref) {
            var name = _ref.name,
                label = _ref.label,
                placeholder = _ref.placeholder,
                value = _ref.value,
                required = _ref.required,
                validations = _ref.validations;

            var type = (validations || []).map(function (v) {
                return v.type;
            }).find(Boolean);
            return { name: name, label: label, placeholder: placeholder, value: value, required: required, type: type };
        }),
        customIconUrl: dto.customIconUrl,
        customLogoUrl: dto.customLogoUrl,
        epmAppSettings: dto.epmAppSettings,
        isComputerLoginWithAD: isComputerLoginWithAD,
        isEPM: isEPM,
        isOffice365: isOffice365,
        isRunning: dto.status === 'RUNNING',
        samlAppLogo: window.env.urls.samlAppLogo(slug, 'thumb'),
        samlAppLogo2: window.env.urls.samlAppLogo(slug, 'logo'),
        isSaaspassDemo: isSaaspassDemo,
        isSaaspassMySqlConnector: isSaaspassMySqlConnector,
        provisioningUrl: dto.provisioningUrl,
        samlConfigSupported: dto.applicationType.samlConfigSupported,
        samlSigAlg: dto.samlSigAlg,
        samlDigAlg: dto.samlDigAlg,
        samlSigningOpt: dto.samlSigningOpt,
        samlAssEncEnabled: dto.samlAssEncEnabled,
        samlEncCert: dto.samlEncCert,
        samlKeyTransAlg: dto.samlKeyTransAlg,
        samlBlockEncAlg: dto.samlBlockEncAlg,
        samlSessionDurationEnabled: dto.samlSessionDurationEnabled,
        samlSessionDuration: dto.samlSessionDuration,
        isOidcConfigSupported: isOidcConfigSupported,
        isOidc: isOidc,
        isSaml: isSaml,
        isProxySso: isProxySso,
        callbackUrl: dto.callbackUrl,
        oidcScopes: dto.oidcScopes,
        oidcGrants: dto.oidcGrants,
        accessTokenLifetime: dto.accessTokenLifetime,
        refreshTokenLifetime: dto.refreshTokenLifetime,
        samlMetadata: dto.samlMetadata
    };
}

function applicationConfigurationModelToDto(model) {
    return {
        adDomain: model.adDomain,
        appDomain: model.appDomain,
        applicationName: model.applicationName,
        apiKey: model.apiKey,
        configDTO: model.configDTO && _extends({}, model.configDTO, {
            appConfig: model.configDTO.appConfig && _extends({}, model.configDTO.appConfig, {
                elements: model.configElements.map(function (_ref2) {
                    var name = _ref2.name,
                        value = _ref2.value;
                    return { name: name, value: value };
                })
            })
        }),
        epmAppSettings: model.epmAppSettings,
        status: model.isRunning ? 'RUNNING' : 'PAUSED',
        note: model.note,
        showNote: model.showNote,
        provisioningUrl: model.provisioningUrl,
        samlSigAlg: model.samlSigAlg,
        samlDigAlg: model.samlDigAlg,
        samlSigningOpt: model.samlSigningOpt,
        samlAssEncEnabled: model.samlAssEncEnabled,
        samlEncCert: model.samlEncCert,
        samlKeyTransAlg: model.samlKeyTransAlg,
        samlBlockEncAlg: model.samlBlockEncAlg,
        samlSessionDurationEnabled: model.samlSessionDurationEnabled,
        samlSessionDuration: model.samlSessionDuration,
        callbackUrl: model.callbackUrl,
        oidcScopes: model.oidcScopes,
        oidcGrants: model.oidcGrants,
        accessTokenLifetime: model.accessTokenLifetime,
        refreshTokenLifetime: model.refreshTokenLifetime
    };
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _applicationConfigurationForm = __webpack_require__(422);

var _loginServicesForm = __webpack_require__(424);

var _registrationServicesForm = __webpack_require__(425);

var _pushApprovalServicesForm = __webpack_require__(426);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$state', 'Alert', 'ApplicationsResource', 'PhotoUploadService', 'ConfirmModal', '$http'];

    /** @ngInject */
    function Controller($rootScope, $state, Alert, ApplicationsResource, PhotoUploadService, ConfirmModal, $http) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
        this.PhotoUploadService = PhotoUploadService;
        this.ConfirmModal = ConfirmModal;
        this.$http = $http;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.resetApplicationConfiguration();
            this.resetLoginServicesConfiguration();
            this.resetRegistrationServicesConfiguration();
            this.resetPushApprovalServicesConfiguration();

            var slug = this.application.applicationType.slug;

            var isOtherEPM = slug == 'enterprise-password-manager' && this.application.epmAppSettings.publicService.slug == 'other';

            this.customIconSupported = slug == 'custom' || slug == 'custom-saml' || slug == 'generic-oidc' || slug == 'generic-oauth2' || isOtherEPM;
            this.customLogoSupported = slug == 'custom-saml';
        }
    }, {
        key: 'applicationConfigurationChanged',
        value: function applicationConfigurationChanged($value, $invalid) {
            this.applicationConfiguration = $value;
            this.invalidApplicationConfiguration = $invalid;
        }
    }, {
        key: 'applicationConfigurationIsNotModified',
        value: function applicationConfigurationIsNotModified() {
            return angular.equals(this.$applicationConfiguration, this.applicationConfiguration);
        }
    }, {
        key: 'loginServicesConfigurationChanged',
        value: function loginServicesConfigurationChanged($value, $invalid) {
            this.loginServicesConfiguration = $value;
            this.invalidLoginServicesConfiguration = $invalid;
        }
    }, {
        key: 'loginServicesConfigurationIsNotModified',
        value: function loginServicesConfigurationIsNotModified() {
            return angular.equals(this.$loginServicesConfiguration, this.loginServicesConfiguration);
        }
    }, {
        key: 'registrationServicesConfigurationChanged',
        value: function registrationServicesConfigurationChanged($value, $invalid) {
            this.registrationServicesConfiguration = $value;
            this.invalidRegistrationServicesConfiguration = $invalid;
        }
    }, {
        key: 'registrationServicesConfigurationIsNotModified',
        value: function registrationServicesConfigurationIsNotModified() {
            return angular.equals(this.$registrationServicesConfiguration, this.registrationServicesConfiguration);
        }
    }, {
        key: 'pushApprovalServicesConfigurationChanged',
        value: function pushApprovalServicesConfigurationChanged($value, $invalid) {
            this.pushApprovalServicesConfiguration = $value;
            this.invalidPushApprovalServicesConfiguration = $invalid;
        }
    }, {
        key: 'pushApprovalServicesConfigurationIsNotModified',
        value: function pushApprovalServicesConfigurationIsNotModified() {
            return angular.equals(this.$pushApprovalServicesConfiguration, this.pushApprovalServicesConfiguration);
        }
    }, {
        key: 'resetApplicationConfiguration',
        value: function resetApplicationConfiguration() {
            this.$applicationConfiguration = (0, _applicationConfigurationForm.applicationConfigurationModelFromDto)(this.application);
            this.applicationConfiguration = (0, _applicationConfigurationForm.applicationConfigurationModelFromDto)(this.application);
        }
    }, {
        key: 'resetLoginServicesConfiguration',
        value: function resetLoginServicesConfiguration() {
            this.$loginServicesConfiguration = (0, _loginServicesForm.loginServicesConfigurationModelFromDto)(this.application);
            this.loginServicesConfiguration = (0, _loginServicesForm.loginServicesConfigurationModelFromDto)(this.application);
        }
    }, {
        key: 'resetRegistrationServicesConfiguration',
        value: function resetRegistrationServicesConfiguration() {
            this.$registrationServicesConfiguration = (0, _registrationServicesForm.registrationServicesConfigurationModelFromDto)(this.application);
            this.registrationServicesConfiguration = (0, _registrationServicesForm.registrationServicesConfigurationModelFromDto)(this.application);
        }
    }, {
        key: 'resetPushApprovalServicesConfiguration',
        value: function resetPushApprovalServicesConfiguration() {
            this.$pushApprovalServicesConfiguration = (0, _pushApprovalServicesForm.pushApprovalServicesConfigurationModelFromDto)(this.application);
            this.pushApprovalServicesConfiguration = (0, _pushApprovalServicesForm.pushApprovalServicesConfigurationModelFromDto)(this.application);
        }
    }, {
        key: 'save',
        value: function save(dto) {
            var _this = this;

            this.isSaving = true;
            return this.ApplicationsResource.updateApplicationConfiguration(this.companyId, this.application.id, dto).then(function () {
                _this.Alert('success', 'company.manage-application.configuration.saved');
                Object.assign(_this.application, dto);
                _this.$onInit();
                _this.$state.reload('company.manage-application');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveIcon',
        value: function saveIcon(iconFile) {
            var _this2 = this;

            return this.ApplicationsResource.uploadCustomIcon(this.companyId, this.application.id, iconFile, null).then(function (data) {
                _this2.application.customIconUrl = data.customIcon;
                _this2.applicationConfiguration.customIconUrl = data.customIcon;
                _this2.Alert('success', 'saaspass_connect.updload_success');
            });
        }
    }, {
        key: 'saveLogo',
        value: function saveLogo(logoFile) {
            var _this3 = this;

            return this.ApplicationsResource.uploadCustomIcon(this.companyId, this.application.id, null, logoFile).then(function (data) {
                _this3.application.customLogoUrl = data.customLogo;
                _this3.applicationConfiguration.customLogoUrl = data.customLogo;
                _this3.Alert('success', 'saaspass_connect.updload_success');
            });
        }
    }, {
        key: 'resetIcon',
        value: function resetIcon() {
            var _this4 = this;

            return this.ConfirmModal({
                messageKey: 'Custom icon will be deleted and default icon will be used. Do you want to continue?',
                titleKey: 'Confirm Delete'
            }).then(function () {
                return _this4.ApplicationsResource.deleteCustomIcon(_this4.companyId, _this4.application.id).then(function (data) {
                    _this4.application.customIconUrl = null;
                    _this4.applicationConfiguration.customIconUrl = null;
                    _this4.Alert('success', 'Custom icon is reset');
                });
            });
        }
    }, {
        key: 'resetLogo',
        value: function resetLogo() {
            var _this5 = this;

            return this.ConfirmModal({
                messageKey: 'Custom logo will be deleted and default logo will be used. Do you want to continue?',
                titleKey: 'Confirm Delete'
            }).then(function () {
                return _this5.ApplicationsResource.deleteCustomLogo(_this5.companyId, _this5.application.id).then(function (data) {
                    _this5.application.customLogoUrl = null;
                    _this5.applicationConfiguration.customLogoUrl = null;
                    _this5.Alert('success', 'Custom logo is reset');
                });
            });
        }
    }, {
        key: 'saveApplicationConfiguration',
        value: function saveApplicationConfiguration() {
            var _this6 = this;

            this.isSavingApplicationConfiguration = true;
            this.save(_extends({}, this.application, (0, _loginServicesForm.loginServicesConfigurationModelToDto)(this.$loginServicesConfiguration), (0, _registrationServicesForm.registrationServicesConfigurationModelToDto)(this.$registrationServicesConfiguration), (0, _applicationConfigurationForm.applicationConfigurationModelToDto)(this.applicationConfiguration), (0, _pushApprovalServicesForm.pushApprovalServicesConfigurationModelToDto)(this.$pushApprovalServicesConfiguration))).finally(function () {
                return _this6.isSavingApplicationConfiguration = false;
            });
        }
    }, {
        key: 'changeApplicationStatus',
        value: function changeApplicationStatus(saveAction) {
            var _this7 = this;

            if (saveAction) {
                this.applicationConfiguration.isRunning = true;
                this.saveApplicationConfiguration();
            } else {
                var isRunning = this.application.status == 'RUNNING';
                var newStatus = !isRunning ? 'RUNNING' : 'PAUSED';
                return this.ApplicationsResource.changeApplicationStatus(this.companyId, this.application.id, newStatus).then(function () {
                    _this7.Alert('success', 'company.manage-application.configuration.saved');
                    _this7.application.status = newStatus;
                    _this7.$rootScope.$broadcast('breadcrumb-data-changed');
                    _this7.$onInit();
                });
            }
        }
    }, {
        key: 'saveLoginServicesConfiguration',
        value: function saveLoginServicesConfiguration() {
            var _this8 = this;

            this.isSavingLoginServicesConfiguration = true;
            this.save(_extends({}, this.application, (0, _applicationConfigurationForm.applicationConfigurationModelToDto)(this.$applicationConfiguration), (0, _registrationServicesForm.registrationServicesConfigurationModelToDto)(this.$registrationServicesConfiguration), (0, _loginServicesForm.loginServicesConfigurationModelToDto)(this.loginServicesConfiguration), (0, _pushApprovalServicesForm.pushApprovalServicesConfigurationModelToDto)(this.$pushApprovalServicesConfiguration))).finally(function () {
                return _this8.isSavingLoginServicesConfiguration = false;
            });
        }
    }, {
        key: 'saveMetadata',
        value: function saveMetadata(metadataUrl, metadataFile) {
            var ctrl = this;
            if (metadataUrl != null && metadataUrl.length > 0) {
                this.uploadMetadataUrl(metadataUrl);
            } else if (metadataFile != null) {
                var reader = new FileReader();
                reader.onload = function () {
                    ctrl.uploadMetadataXml(reader.result);
                };
                if (metadataFile) {
                    reader.readAsText(metadataFile);
                }
            }
        }
    }, {
        key: 'uploadMetadataXml',
        value: function uploadMetadataXml(metadataStr) {
            var _this9 = this;

            this.ApplicationsResource.uploadMetadataXml(this.companyId, this.application.id, this.application.configDTO, metadataStr).then(function () {
                _this9.Alert('success', 'company.manage-application.configuration.saved');
                _this9.$state.reload('company.manage-application');
            });
        }
    }, {
        key: 'uploadMetadataUrl',
        value: function uploadMetadataUrl(metadataUrl) {
            var _this10 = this;

            this.ApplicationsResource.uploadMetadataUrl(this.companyId, this.application.id, this.application.configDTO, metadataUrl).then(function () {
                _this10.Alert('success', 'company.manage-application.configuration.saved');
                _this10.$state.reload('company.manage-application');
            });
        }
    }, {
        key: 'saveName',
        value: function saveName(applicationName) {
            var _this11 = this;

            return this.ApplicationsResource.updateApplicationConfiguration(this.companyId, this.application.id, _extends({}, this.application, (0, _applicationConfigurationForm.applicationConfigurationModelToDto)(this.$applicationConfiguration), (0, _loginServicesForm.loginServicesConfigurationModelToDto)(this.$loginServicesConfiguration), (0, _registrationServicesForm.registrationServicesConfigurationModelToDto)(this.$registrationServicesConfiguration), (0, _pushApprovalServicesForm.pushApprovalServicesConfigurationModelToDto)(this.$pushApprovalServicesConfiguration), {
                applicationName: applicationName
            })).then(function () {
                _this11.Alert('success', 'company.manage-application.configuration.saved-name');
                _this11.application.applicationName = applicationName;
                _this11.$rootScope.$broadcast('breadcrumb-data-changed');
                _this11.$onInit();
            });
        }
    }, {
        key: 'saveRegistrationServicesConfiguration',
        value: function saveRegistrationServicesConfiguration() {
            var _this12 = this;

            this.isSavingRegistrationServicesConfiguration = true;
            this.save(_extends({}, this.application, (0, _applicationConfigurationForm.applicationConfigurationModelToDto)(this.$applicationConfiguration), (0, _loginServicesForm.loginServicesConfigurationModelToDto)(this.$loginServicesConfiguration), (0, _registrationServicesForm.registrationServicesConfigurationModelToDto)(this.registrationServicesConfiguration), (0, _pushApprovalServicesForm.pushApprovalServicesConfigurationModelToDto)(this.$pushApprovalServicesConfiguration))).finally(function () {
                return _this12.isSavingRegistrationServicesConfiguration = false;
            });
        }
    }, {
        key: 'savePushApprovalServicesConfiguration',
        value: function savePushApprovalServicesConfiguration() {
            var _this13 = this;

            this.isSavingPushApprovalServicesConfiguration = true;
            this.save(_extends({}, this.application, (0, _applicationConfigurationForm.applicationConfigurationModelToDto)(this.$applicationConfiguration), (0, _loginServicesForm.loginServicesConfigurationModelToDto)(this.$loginServicesConfiguration), (0, _registrationServicesForm.registrationServicesConfigurationModelToDto)(this.$registrationServicesConfiguration), (0, _pushApprovalServicesForm.pushApprovalServicesConfigurationModelToDto)(this.pushApprovalServicesConfiguration))).finally(function () {
                return _this13.isSavingPushApprovalServicesConfiguration = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loginServicesConfigurationModelFromDto = loginServicesConfigurationModelFromDto;
exports.loginServicesConfigurationModelToDto = loginServicesConfigurationModelToDto;

var _applicationTypes = __webpack_require__(58);

var _mobileAppSupport = __webpack_require__(198);

function loginServicesConfigurationModelFromDto(dto) {
    var slug = dto.applicationType.slug;
    var isCas = slug === 'cas';
    var isComputerLoginWithAD = slug === 'computer-login';
    var isComputerLoginWithoutAD = slug === 'computer-protection-without-ad';
    var isComputerLogin = isComputerLoginWithAD || isComputerLoginWithoutAD;
    var isCustom = slug === 'custom';
    var isTsPlus = slug === 't-splus';
    var isSRA = slug === 'saaspass-secure-remote-access';
    var isEPM = slug === 'enterprise-password-manager';
    var isAdPM = slug === 'ad-password-manager';
    var isExchangeActiveSync = slug === 'exchange-active-sync';
    var isLinuxSsh = slug === 'linux-ssh';
    var isRadius = (0, _applicationTypes.isRadius)(slug);
    var isSaml = dto.applicationType.saml;
    var isOidcConfigSupported = dto.applicationType.oidcConfigSupported;
    var isInstantLoginEditable = isCustom || isComputerLogin || isSaml || isOidcConfigSupported;
    var isInstantLoginMethodsSectionVisible = dto.applicationType.instantLoginSupported || dto.applicationType.proximitySupported || dto.applicationType.pushLoginSupported;
    var isInstantLoginUrlVisible = isInstantLoginMethodsSectionVisible && (isCas || !isComputerLogin && !isLinuxSsh && !isRadius && !isSaml && !isExchangeActiveSync && !isOidcConfigSupported);
    var isIpFilteringVisible = ['cas', 'custom', 'linux-ssh', 'owa', 't-splus', 'thinfinity', 'magento', 'exchange-active-sync'].includes(slug);
    var isProximityEditable = dto.applicationType.proximitySupported && (isComputerLogin || isCustom || isSaml);
    var isPushLoginEditable = dto.applicationType.pushLoginSupported && (isComputerLogin || isCustom || isLinuxSsh || isRadius || isTsPlus || isSRA || isSaml || isOidcConfigSupported);

    return {
        instantLoginEnabled: dto.instantLoginEnabled,
        instantLoginSupported: dto.applicationType.instantLoginSupported,
        instantLoginUrl: dto.instantLoginUrl,
        ipAddressFilter: dto.ipAddressFilter || '0.0.0.0/0',
        isComputerLogin: isComputerLogin,
        isCustom: isCustom,
        isEditable: dto.applicationType.ssoEditable || dto.applicationType.ssoPostUrlEditable || isComputerLogin || isInstantLoginUrlVisible || isIpFilteringVisible || isRadius || isProximityEditable || isPushLoginEditable || isInstantLoginEditable,
        isInstantLoginEditable: isInstantLoginEditable,
        isInstantLoginMethodsSectionVisible: isInstantLoginMethodsSectionVisible,
        isInstantLoginUrlVisible: isInstantLoginUrlVisible,
        isIpFilteringVisible: isIpFilteringVisible,
        isProximityEditable: isProximityEditable,
        isPushLoginEditable: isPushLoginEditable,
        isVisible: !(isEPM || isAdPM),
        isRunning: dto.status === 'RUNNING',
        mobileApplicationSettings: (0, _mobileAppSupport.mobileApplicationSettingsFromDto)(dto.mobileApplicationSettings),
        noIpAddressFilter: !dto.ipAddressFilter || dto.ipAddressFilter === '0.0.0.0/0',
        proximityEnabled: dto.proximityEnabled,
        proximitySupported: dto.applicationType.proximitySupported,
        pushLoginEnabled: dto.pushLoginEnabled,
        pushLoginSupported: dto.applicationType.pushLoginSupported,
        qrCodeBackgroundColor: (dto.ilQrCodeSettings || {}).qrCodeBackgroundColor || '#FFFFFF',
        qrCodeForegroundColor: (dto.ilQrCodeSettings || {}).qrCodeForegroundColor || '#000000',
        qrCodeSize: (dto.ilQrCodeSettings || {}).qrCodeSize || 300,
        rememberMeEnabled: dto.rememberMeEnabled,
        autoLoginEnabled: dto.autoLoginEnabled,
        remoteLockEnabled: dto.remoteLockEnabled,
        remoteLoginEnabled: dto.remoteLoginEnabled,
        ssoEditable: dto.applicationType.ssoEditable,
        ssoPostUrlEditable: dto.applicationType.ssoPostUrlEditable,
        ssoEnabled: dto.ssoEnabled,
        ssoPostUrl: dto.ssoEnabled && dto.ssoPostUrl || '',
        ssoSupported: dto.applicationType.ssoSupported,
        upgradeNotificationEnabled: dto.upgradeNotificationEnabled,
        isOidcConfigSupported: isOidcConfigSupported
    };
}

function loginServicesConfigurationModelToDto(model) {
    return {
        instantLoginEnabled: model.instantLoginEnabled,
        instantLoginUrl: model.instantLoginUrl,
        mobileApplicationSettings: (0, _mobileAppSupport.mobileApplicationSettingsToDto)(model.mobileApplicationSettings),
        ipAddressFilter: model.noIpAddressFilter || !model.ipAddressFilter ? '0.0.0.0/0' : model.ipAddressFilter,
        proximityEnabled: model.proximityEnabled,
        pushLoginEnabled: model.pushLoginEnabled,
        ilQrCodeSettings: {
            qrCodeBackgroundColor: model.qrCodeBackgroundColor,
            qrCodeForegroundColor: model.qrCodeForegroundColor,
            qrCodeSize: model.qrCodeSize,
            qrCodeType: 'IL'
        },
        rememberMeEnabled: model.rememberMeEnabled,
        autoLoginEnabled: model.autoLoginEnabled,
        remoteLockEnabled: model.remoteLockEnabled,
        remoteLoginEnabled: model.remoteLoginEnabled,
        ssoEnabled: model.ssoEnabled,
        ssoPostUrl: model.ssoEnabled && model.ssoPostUrl || undefined,
        upgradeNotificationEnabled: model.upgradeNotificationEnabled
    };
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registrationServicesConfigurationModelFromDto = registrationServicesConfigurationModelFromDto;
exports.registrationServicesConfigurationModelToDto = registrationServicesConfigurationModelToDto;
function registrationServicesConfigurationModelFromDto(dto) {
    var slug = dto.applicationType.slug;
    var isCas = slug === 'cas';
    var isCustom = slug === 'custom';
    var isAutoAddUserVisible = dto.applicationType.instantRegistrationSupported && (isCas || isCustom);

    return {
        autoAddUser: dto.autoAddUser,
        instantRegistrationEnabled: dto.instantRegistrationEnabled,
        instantRegistrationUrl: dto.instantRegistrationEnabled && dto.instantRegistrationUrl || '',
        isAutoAddUserVisible: isAutoAddUserVisible,
        isCustom: isCustom,
        qrCodeBackgroundColor: (dto.irQrCodeSettings || {}).qrCodeBackgroundColor || '#FFFFFF',
        qrCodeForegroundColor: (dto.irQrCodeSettings || {}).qrCodeForegroundColor || '#000000',
        qrCodeSize: (dto.irQrCodeSettings || {}).qrCodeSize || 300
    };
}

function registrationServicesConfigurationModelToDto(model) {
    return {
        autoAddUser: model.autoAddUser,
        instantRegistrationEnabled: model.instantRegistrationEnabled,
        instantRegistrationUrl: model.instantRegistrationEnabled && model.instantRegistrationUrl || undefined,
        irQrCodeSettings: {
            qrCodeBackgroundColor: model.qrCodeBackgroundColor,
            qrCodeForegroundColor: model.qrCodeForegroundColor,
            qrCodeSize: model.qrCodeSize,
            qrCodeType: 'IR'
        }
    };
}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pushApprovalServicesConfigurationModelFromDto = pushApprovalServicesConfigurationModelFromDto;
exports.pushApprovalServicesConfigurationModelToDto = pushApprovalServicesConfigurationModelToDto;
function pushApprovalServicesConfigurationModelFromDto(dto) {
    return {
        pushApprovalSupported: dto.applicationType.pushApprovalSupported,
        pushApprovalEnabled: dto.pushApprovalEnabled,
        pushApprovalPostUrl: dto.pushApprovalPostUrl && dto.pushApprovalPostUrl || '',
        pushApprovalRequiresBiometric: dto.pushApprovalRequiresBiometric
    };
}

function pushApprovalServicesConfigurationModelToDto(model) {
    return {
        pushApprovalEnabled: model.pushApprovalEnabled,
        pushApprovalPostUrl: model.pushApprovalPostUrl && model.pushApprovalPostUrl || undefined,
        pushApprovalRequiresBiometric: model.pushApprovalRequiresBiometric
    };
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope'];

    /** @ngInject */
    function Controller($scope) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.init();
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.init();
            this.watch();
        }
    }, {
        key: 'init',
        value: function init() {
            this.$model = this.loginServicesConfiguration;
            this.model = angular.copy(this.$model);
        }
    }, {
        key: 'instantLoginUrlEnabled',
        value: function instantLoginUrlEnabled() {
            return this.model.instantLoginEnabled || this.model.proximityEnabled || this.model.pushLoginEnabled;
        }
    }, {
        key: 'mobileApplicationSettingsChanged',
        value: function mobileApplicationSettingsChanged($value, $invalid) {
            this.model.mobileApplicationSettings = $value;
            this.onChange({ $value: this.model, $invalid: $invalid || this.form.$invalid });
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$model, this.model);
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp($event) {
            if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
                this.onEnter();
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            var _this = this;

            this.$scope.$watch(function () {
                return _this.model;
            }, function () {
                return _this.onChange({ $value: _this.model, $invalid: _this.form.$invalid });
            }, true);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope'];

    /** @ngInject */
    function Controller($scope) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.init();
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.init();
            this.watch();
        }
    }, {
        key: 'init',
        value: function init() {
            this.$model = this.pushApprovalServicesConfiguration;
            this.model = angular.copy(this.$model);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$model, this.model);
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp($event) {
            if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
                this.onEnter();
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            var _this = this;

            this.$scope.$watch(function () {
                return _this.model;
            }, function () {
                return _this.onChange({ $value: _this.model, $invalid: _this.form.$invalid });
            }, true);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope'];

    /** @ngInject */
    function Controller($scope) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.init();
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.init();
            this.watch();
        }
    }, {
        key: 'init',
        value: function init() {
            this.$model = this.registrationServicesConfiguration;
            this.model = angular.copy(this.$model);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$model, this.model);
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp($event) {
            if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
                this.onEnter();
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            var _this = this;

            this.$scope.$watch(function () {
                return _this.model;
            }, function () {
                return _this.onChange({ $value: _this.model, $invalid: _this.form.$invalid });
            }, true);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _spAlert = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

Controller.$inject = ['$scope', '$state', 'DropboxProvisioningService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, DropboxProvisioningService) {
    var _this = this;

    var $ctrl = this;
    this.$onInit = function () {
        var _resolve = _this.resolve,
            applicationName = _resolve.applicationName,
            dropboxProvMappings = _resolve.dropboxProvMappings,
            dropboxSyncMappings = _resolve.dropboxSyncMappings,
            groupMapping = _resolve.groupMapping,
            saaspassGroups = _resolve.saaspassGroups;

        $scope.groupMapping = groupMapping;
        $scope.saaspassGps = saaspassGroups;
        $scope.dropboxSyncMappings = dropboxSyncMappings;

        $scope.slectedGroups = [];
        $scope.allowedSpGroupTypes = ['CUSTOM', 'AD', 'EXTERNAL_EMAILS', 'DOMAIN'];

        $scope.querySpTypes = function (group) {
            var theIndex = dropboxProvMappings.findIndex(function (obj) {
                return obj.saaspassGroup.id == group.id;
            });
            var groupType = angular.copy(group.type);
            return ($scope.allowedSpGroupTypes.indexOf(groupType) != -1 || groupType == 'APPLICATION' && group.groupName == applicationName) && theIndex == -1;
        };

        $scope.saveMapping = function () {
            DropboxProvisioningService.provMapping.save({
                companyId: $state.params.companyId,
                appId: $state.params.appId
            }, $scope.slectedGroups).$promise.then(function (data) {
                $ctrl.close({ $value: data });
            }, function (error) {
                $scope.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            });
        };
        $scope.slectDropDownValue = null;

        $scope.changeSelection = function (newValue, spGroupId) {
            if (newValue !== undefined) {
                var newPair = {
                    saaspassGroupId: spGroupId,
                    dropboxGroupId: newValue
                };
                var spPairIndex = $scope.slectedGroups.findIndex(function (obj) {
                    return obj.saaspassGroupId == spGroupId;
                });
                if (newValue != null) {
                    if (newValue == 0) {
                        newValue = null;
                        newPair.dropboxGroupId = null;
                    }
                    if (spPairIndex != -1) {
                        $scope.slectedGroups[spPairIndex].dropboxGroupId = newValue;
                    } else {
                        $scope.slectedGroups.push(newPair);
                    }
                } else {
                    if (spPairIndex != -1) {
                        $scope.slectedGroups.splice(spPairIndex, 1);
                    }
                }
            }
        };
    };
}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _spAlert = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

Controller.$inject = ['$scope', '$state', 'DropboxProvisioningService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, DropboxProvisioningService) {
    var _this = this;

    var self = this;
    this.$onInit = function () {
        var groupMapping = _this.resolve.groupMapping;
        $scope.groupMapping = groupMapping;
        $scope.cancel = cancel;
        $scope.autoSetting = angular.copy(groupMapping.isFullSyncEnabled);
        $scope.saveSettings = function () {
            console.log('saved');
            DropboxProvisioningService.mappingSettings.update({
                companyId: $state.params.companyId,
                appId: $state.params.appId
            }, $scope.groupMapping).$promise.then(function (data) {
                self.close('ok');
            }, function (error) {
                $scope.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            });
        };
        function cancel() {
            $scope.groupMapping.isFullSyncEnabled = $scope.autoSetting;
            self.dismiss('cancel');
        }
    };
}

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

Controller.$inject = ['$scope', '$state', '$translate', '$uibModal', 'Alert', 'DropboxProvisioningService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, $translate, $uibModal, Alert, DropboxProvisioningService) {
    var _this = this;

    this.$onInit = function () {
        var companyId = $state.params.companyId;
        var appId = $state.params.appId;

        $scope.useKeyAndSecret = true;

        $scope.application = _this.application;
        $scope.autoSyncOptionsDetails = [];
        $scope.userProvisioningEnabled = false;
        $scope.boolFlag = { autoSyncEnabled: false };
        var provisioningBackupConfiguration;
        $scope.displayedDropboxSyncMappings = [];
        var data = _this.dropboxConfigurationDTO;
        provisioningBackupConfiguration = angular.copy(data.dropboxConfiguration);
        $scope.basicProvisioningConfiguration = angular.copy(data.dropboxConfiguration);
        $scope.smartProvisioningConfiguration = angular.copy(data.dropboxConfiguration);
        $scope.smartSyncConfiguration = angular.copy(data.dropboxConfiguration);
        $scope.accountSettingOptions = data.accountSettingOptions;
        $scope.groupSettingOptions = data.groupSettingOptions;
        $scope.adAttributeOptions = data.adAttributeOptions;
        $scope.autoSyncOptions = data.autoSyncOptions;
        setSyncSettingData();
        setNewTablesData(data);
        if ($scope.basicProvisioningConfiguration.accessToken != null) {
            $scope.useKeyAndSecret = false;
        }

        $scope.enableDisableAutoSync = function (newValue) {
            if (!newValue) {
                angular.forEach($scope.autoSyncOptionsDetails, function (item) {
                    item.detail = null;
                });
                $scope.smartSyncConfiguration.autoSyncSetting = 'NO_AUTOSYNC';
            }
        };
        function setSyncSettingData() {
            $scope.autoSyncOptionsDetails = [];
            angular.forEach($scope.autoSyncOptions, function (value, index) {
                var option = { option: value, detail: null };
                if (value == provisioningBackupConfiguration.autoSyncSetting) {
                    option.detail = Number(angular.copy(provisioningBackupConfiguration.autoSyncTimeValue));
                }
                $scope.autoSyncOptionsDetails.push(option);
            });
            $scope.boolFlag.autoSyncEnabled = provisioningBackupConfiguration.autoSyncSetting != 'NO_AUTOSYNC';
        }
        $scope.syncNow = function () {
            $scope.loadingMessage = $translate.instant('dropbox_provisioning.sync_process_progress');
            $('#loadingModal').modal('show');
            DropboxProvisioningService.syncNow.get({
                companyId: companyId,
                appId: appId
            }).$promise.then(function (data) {
                provisioningBackupConfiguration = angular.copy(data.dropboxConfiguration);
                $scope.basicProvisioningConfiguration = angular.copy(data.dropboxConfiguration);
                $scope.smartProvisioningConfiguration = angular.copy(data.dropboxConfiguration);
                $scope.setNewTablesData(data);
                $('#loadingModal').modal('hide');
                Alert('success', 'dropbox_provisioning.successful_sync');
            }, function (error) {
                $('#loadingModal').modal('hide');
            });
        };

        $scope.provNow = function () {
            $scope.loadingMessage = $translate.instant('dropbox_provisioning.prov_process_progress');
            $('#loadingModal').modal('show');
            DropboxProvisioningService.provisionNow.get({
                companyId: companyId,
                appId: appId
            }).$promise.then(function (data) {
                $('#loadingModal').modal('hide');
                $scope.setNewTablesData(data);
                Alert('success', 'dropbox_provisioning.successful_prov');
            }, function (error) {
                $('#loadingModal').modal('hide');
            });
        };

        $scope.automap = function () {
            $('#loadingModal').modal('show');
            DropboxProvisioningService.automap.get({
                companyId: companyId,
                appId: appId
            }).$promise.then(function (data) {
                $('#loadingModal').modal('hide');
                $scope.setNewTablesData(data);
                Alert('success', 'dropbox_provisioning.sync_map_modal.successful_save');
            }, function (error) {
                $('#loadingModal').modal('hide');
            });
        };

        $scope.cancelEditSmartSyncSettings = function () {
            setSyncSettingData();
            $scope.smartSyncConfiguration = angular.copy(provisioningBackupConfiguration);
            //$scope.$digest();
        };
        $scope.cancelEditSmartProvisioningSettings = function () {
            $scope.smartProvisioningConfiguration = angular.copy(provisioningBackupConfiguration);
        };
        $scope.cancelEditBasicProvisioningSettings = function () {
            $scope.basicProvisioningConfiguration = angular.copy(provisioningBackupConfiguration);
            $scope.useKeyAndSecret = provisioningBackupConfiguration.accessToken == null;
            $scope.form.$setPristine();
        };

        $scope.editBasicProvisioningSettings = function () {
            $scope.editSettings($scope.basicProvisioningConfiguration, 0);
        };
        $scope.editSmartProvisioningSettings = function () {
            $scope.editSettings($scope.smartProvisioningConfiguration, 1);
        };
        $scope.editSmartSyncSettings = function () {
            angular.forEach($scope.autoSyncOptionsDetails, function (item) {
                if (item.option == $scope.smartSyncConfiguration.autoSyncSetting) {
                    $scope.smartSyncConfiguration.autoSyncTimeValue = item.detail;
                }
            });
            $scope.smartSyncConfiguration.scheduledAutoSyncTime = null;
            $scope.editSettings($scope.smartSyncConfiguration, 2);
        };

        var setBasicInSmartProvisioning = function setBasicInSmartProvisioning() {
            $scope.smartProvisioningConfiguration.appKey = angular.copy(provisioningBackupConfiguration.appKey);
            $scope.smartProvisioningConfiguration.appSecret = angular.copy(provisioningBackupConfiguration.appSecret);
            $scope.smartProvisioningConfiguration.accessToken = angular.copy(provisioningBackupConfiguration.accessToken);
            // 
        };
        var setBasicInSmartSync = function setBasicInSmartSync() {
            $scope.smartSyncConfiguration.appKey = angular.copy(provisioningBackupConfiguration.appKey);
            $scope.smartSyncConfiguration.appSecret = angular.copy(provisioningBackupConfiguration.appSecret);
            $scope.smartSyncConfiguration.accessToken = angular.copy(provisioningBackupConfiguration.accessToken);
            // 
        };

        var setSmartPartsInBasic = function setSmartPartsInBasic() {
            $scope.basicProvisioningConfiguration.adPreferredAttribute = angular.copy(provisioningBackupConfiguration.adPreferredAttribute);
            //        $scope.basicProvisioningConfiguration.groupAssignSetting=angular.copy(provisioningBackupConfiguration.groupAssignSetting);
            //        $scope.basicProvisioningConfiguration.accountUnssignSetting=angular.copy(provisioningBackupConfiguration.accountUnssignSetting);
            //        $scope.basicProvisioningConfiguration.accountDeleteSetting=angular.copy(provisioningBackupConfiguration.accountDeleteSetting);
            // 
        };
        $scope.editSettings = function (editedConfiguration, typeOfEdit) {
            DropboxProvisioningService.provisioningConfiguration.updateProvisioningConfiguration({
                companyId: companyId,
                appId: appId
            }, editedConfiguration).$promise.then(function (data) {
                provisioningBackupConfiguration = angular.copy(data);
                if (data.accessToken != null) {
                    $scope.useKeyAndSecret = false;
                }
                if (typeOfEdit == 0) {
                    setBasicInSmartProvisioning();
                    setBasicInSmartSync();
                } else if (typeOfEdit == 1) {
                    setSmartPartsInBasic();
                    $scope.smartSyncConfiguration.adPreferredAttribute = angular.copy(provisioningBackupConfiguration.adPreferredAttribute);
                    //                $scope.smartSyncConfiguration.groupAssignSetting=angular.copy(provisioningBackupConfiguration.groupAssignSetting);
                    //                $scope.smartSyncConfiguration.accountUnssignSetting=angular.copy(provisioningBackupConfiguration.accountUnssignSetting);
                    //                $scope.smartSyncConfiguration.accountDeleteSetting=angular.copy(provisioningBackupConfiguration.accountDeleteSetting);
                } else {
                    $scope.smartSyncConfiguration.autoSyncSetting = angular.copy(provisioningBackupConfiguration.autoSyncSetting);
                    $scope.smartSyncConfiguration.autoSyncTimeValue = angular.copy(provisioningBackupConfiguration.autoSyncTimeValue);
                    $scope.smartSyncConfiguration.scheduledAutoSyncTime = angular.copy(provisioningBackupConfiguration.scheduledAutoSyncTime);

                    $scope.smartProvisioningConfiguration.autoSyncSetting = angular.copy(provisioningBackupConfiguration.autoSyncSetting);
                    $scope.basicProvisioningConfiguration.autoSyncSetting = angular.copy(provisioningBackupConfiguration.autoSyncSetting);
                }
                Alert('success', 'dropbox_provisioning.configuration_save');
            });
        };

        $scope.changeConnectionWay = function () {
            if ($scope.useKeyAndSecret) {
                $scope.basicProvisioningConfiguration.accessToken = null;
            } else {
                $scope.basicProvisioningConfiguration.appKey = null;
                $scope.basicProvisioningConfiguration.appSecret = null;
            }
        };

        $scope.changeAutoSyncSetting = function (newValue) {
            angular.forEach($scope.autoSyncOptionsDetails, function (item) {
                item.detail = null;
            });
            $scope.smartSyncConfiguration.autoSyncSetting = newValue;
        };

        $scope.changeAdAttributeSetting = function (newValue) {
            $scope.smartProvisioningConfiguration.adPreferredAttribute = newValue;
        };

        $scope.changeGroupAssignSetting = function (newValue) {
            $scope.smartProvisioningConfiguration.groupAssignSetting = newValue;
        };
        $scope.changeAccountDeletedSetting = function (newValue) {
            $scope.smartProvisioningConfiguration.accountDeletedSetting = newValue;
        };
        $scope.changeAccountUnassignSetting = function (newValue) {
            $scope.smartProvisioningConfiguration.accountUnassignSetting = newValue;
        };

        $scope.listDropboxGroups = function () {
            DropboxProvisioningService.dropboxSync.get({
                companyId: companyId,
                appId: appId
            }).$promise.then(function (data) {
                $scope.setNewTablesData(data);
            });
        };
        $scope.setNewTablesData = setNewTablesData;
        function setNewTablesData(data) {
            $scope.dropboxSyncMappings = data.syncMappings;
            $scope.dropboxProvisioningMappings = data.provisioningMappings;
            $scope.saaspassGroups = data.companySaaspassGroups;
            $scope.displayedDropboxSyncMappings = [].concat($scope.dropboxSyncMappings);
            $scope.displayedDropboxProvisioningMappings = [].concat($scope.dropboxProvisioningMappings);

            $scope.showAutomap = $scope.displayedDropboxSyncMappings.findIndex(function (obj) {
                return obj.saaspassGroup == null;
            }) != -1;
        }

        $scope.openProvSettings = function (_groupMapping) {
            $uibModal.open({
                component: 'dropboxProvisioningSettings',
                resolve: { groupMapping: function groupMapping() {
                        return _groupMapping;
                    } }
            }).result.then(function () {
                Alert('success', 'dropbox_provisioning.sync_settings_modal.successful_save');
            });
        };

        $scope.openSyncSettings = function (_groupMapping2) {
            $uibModal.open({
                component: 'dropboxSyncSettings',
                resolve: { groupMapping: function groupMapping() {
                        return _groupMapping2;
                    } }
            }).result.then(function (savedGroupMapping) {
                Object.assign(_groupMapping2, savedGroupMapping);
                Alert('success', 'dropbox_provisioning.sync_settings_modal.successful_save');
            });
        };

        $scope.openSyncMap = function (_groupMapping3) {
            $uibModal.open({
                component: 'dropboxSyncMapping',
                resolve: {
                    applicationName: function applicationName() {
                        return $scope.application.applicationName;
                    },
                    dropboxProvisioningMappings: function dropboxProvisioningMappings() {
                        return $scope.dropboxProvisioningMappings;
                    },
                    groupMapping: function groupMapping() {
                        return _groupMapping3;
                    },
                    saaspassGroups: function saaspassGroups() {
                        return $scope.saaspassGroups;
                    }
                }
            }).result.then(function (data) {
                if (data.createProvMapping) {
                    Alert('success', 'dropbox_provisioning.sync_map_modal.successful_save2');
                } else {
                    Alert('success', 'dropbox_provisioning.sync_map_modal.successful_save');
                }
                $scope.setNewTablesData(data.response);
            });
        };

        $scope.openProvMap = function (theMapping) {
            $uibModal.open({
                component: 'dropboxProvisioningMapping',
                resolve: {
                    groupMapping: function groupMapping() {
                        return theMapping;
                    },
                    saaspassGroups: function saaspassGroups() {
                        return $scope.saaspassGroups;
                    },
                    applicationName: function applicationName() {
                        return $scope.application.applicationName;
                    },
                    dropboxProvMappings: function dropboxProvMappings() {
                        return $scope.dropboxProvisioningMappings;
                    },
                    dropboxSyncMappings: function dropboxSyncMappings() {
                        return $scope.displayedDropboxSyncMappings;
                    }
                }
            }).result.then(function (data) {
                $scope.setNewTablesData(data);
                Alert('success', 'dropbox_provisioning.prov_map_modal.successful_save');
            });
        };

        $scope.removeMapping = function (theMapping) {
            $uibModal.open({ component: 'confirmRemoveDropboxProvisioningMapping' }).result.then(function () {
                DropboxProvisioningService.groupMapping.remove({
                    companyId: companyId,
                    appId: appId
                }, theMapping).$promise.then(function (data) {
                    $scope.setNewTablesData(data);
                    Alert('success', 'dropbox_provisioning.remove_mapping.successful_remove');
                });
            });
        };

        $scope.displayExportSpinner = false;
    };
}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'DropboxProvisioningService'];

    /** @ngInject */
    function Controller($state, DropboxProvisioningService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.DropboxProvisioningService = DropboxProvisioningService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.applicationName = this.resolve.applicationName;
            this.dropboxProvisioningMappings = this.resolve.dropboxProvisioningMappings;
            this.groupMapping = this.resolve.groupMapping;
            this.spGroups = this.resolve.saaspassGroups;

            this.createProvisioningMapping = false;
            this.disableCreateProv = false;
            this.isFullSyncEnabled = false;
            this.selectedGroupId = '0';
            this.groupName = this.groupMapping.dropboxGroup.groupName;

            this.queryTypes = this.queryTypes.bind(this);

            this.disableEnableCreateProv();
        }
    }, {
        key: 'disableEnableCreateProv',
        value: function disableEnableCreateProv() {
            var _this = this;

            this.disableCreateProv = this.selectedGroupId !== '0' && !!this.dropboxProvisioningMappings.find(function (mapping) {
                return mapping.saaspassGroup.id === _this.selectedGroupId;
            });

            if (this.disableCreateProv) {
                this.createProvisioningMapping = false;
            }
        }
    }, {
        key: 'queryTypes',
        value: function queryTypes(group) {
            return group.type === 'CUSTOM' || group.type === 'APPLICATION' && group.groupName === this.applicationName;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            var companyId = this.$state.params.companyId;
            var appId = this.$state.params.appId;
            var newMapping = {
                groupId: this.selectedGroupId,
                groupMapping: _extends({}, this.groupMapping, {
                    isFullSyncEnabled: this.isFullSyncEnabled
                }),
                createProvisioning: this.createProvisioningMapping,
                createNewGroup: this.selectedGroupId === '0'
            };

            this.DropboxProvisioningService.syncMapping.save({ companyId: companyId, appId: appId }, newMapping).$promise.then(function (data) {
                _this2.close({
                    $value: {
                        response: data,
                        createProvMapping: _this2.createProvisioningMapping
                    }
                });
            }).catch(function (error) {
                return _this2.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'DropboxProvisioningService'];

    /** @ngInject */
    function Controller($state, DropboxProvisioningService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.DropboxProvisioningService = DropboxProvisioningService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.groupMapping = this.resolve.groupMapping;
            this.isFullSyncEnabled = this.groupMapping.isFullSyncEnabled;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            var companyId = this.$state.params.companyId;
            var appId = this.$state.params.appId;
            var params = { companyId: companyId, appId: appId };
            var data = _extends({}, this.groupMapping, { isFullSyncEnabled: this.isFullSyncEnabled });
            this.DropboxProvisioningService.mappingSettings.update(params, data).$promise.then(function () {
                return _this.close({ $value: data });
            }).catch(function (error) {
                return _this.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            });
        }
    }, {
        key: 'canSave',
        value: function canSave() {
            return this.isFullSyncEnabled !== this.groupMapping.isFullSyncEnabled;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', '$state', 'IdpAuthenticatorsService'];

    /** @ngInject */
    function Controller(Alert, $state, IdpAuthenticatorsService) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$state = $state;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.application.idpAuthenticatorId) {
                this.selectedIdpAuthenticatorId = this.application.idpAuthenticatorId;
            } else {
                this.selectedIdpAuthenticatorId = '-1';
            }
        }
    }, {
        key: 'saveIdpAuthenticatorDisabled',
        value: function saveIdpAuthenticatorDisabled() {
            return this.isSaving || this.idpAuthenticatorNotModified();
        }
    }, {
        key: 'idpAuthenticatorNotModified',
        value: function idpAuthenticatorNotModified() {
            return this.application.idpAuthenticatorId === this.selectedIdpAuthenticatorId || this.application.idpAuthenticatorId == null && this.selectedIdpAuthenticatorId == -1;
        }
    }, {
        key: 'saveIdpAuthenticator',
        value: function saveIdpAuthenticator() {
            var _this = this;

            this.isSaving = true;
            if (this.selectedIdpAuthenticatorId == -1) {
                this.IdpAuthenticatorsService.unassignApplications(this.companyId, this.application.idpAuthenticatorId, [this.application.id]).then(function () {
                    return _this.Alert('success', 'company.idp-authenticators.assign-to-app.updated');
                }).then(function () {
                    return _this.$state.reload('company.manage-application');
                }).finally(function () {
                    return _this.isSaving = false;
                });
            } else {
                this.IdpAuthenticatorsService.assignApplications(this.companyId, this.selectedIdpAuthenticatorId, [this.application.id]).then(function () {
                    return _this.Alert('success', 'company.idp-authenticators.assign-to-app.updated');
                }).then(function () {
                    return _this.$state.reload('company.manage-application');
                }).finally(function () {
                    return _this.isSaving = false;
                });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$uibModal', 'Alert'];

    /** @ngInject */
    function Controller($scope, $uibModal, Alert) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
            this.isOidcConfigSupported = this.application.applicationType.oidcConfigSupported;
        }
    }, {
        key: 'showRegenerateModal',
        value: function showRegenerateModal() {
            var _this2 = this;

            this.$uibModal.open({
                component: 'companyManageApplicationIntegrationDevelopersAppKeyPasswordRegenerate',
                resolve: {
                    companyId: function companyId() {
                        return _this2.companyId;
                    },
                    appId: function appId() {
                        return _this2.application.id;
                    },
                    isOidcConfigSupported: function isOidcConfigSupported() {
                        return _this2.isOidcConfigSupported;
                    }
                }
            }).result.then(function (value) {
                return _this2.application.applicationApiPassword = value;
            }).then(function () {
                return _this2.Alert('success', 'company.manage-application.integration-developers.app-key-password.regenerate.regenerated');
            });
        }
    }, {
        key: 'copyToClipboard',
        value: function copyToClipboard(text) {
            console.log(text);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["ApplicationsResource"];

    /** @ngInject */
    function Controller(ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "regenerate",
        value: function regenerate() {
            var _this = this;

            this.isSaving = true;
            this.ApplicationsResource.regeneratePassword(this.resolve.companyId, this.resolve.appId).then(function (data) {
                return _this.close({ $value: data.applicationPassword });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['FederateSsoResource'];

    /** @ngInject */
    function Controller(FederateSsoResource) {
        _classCallCheck(this, Controller);

        this.FederateSsoResource = FederateSsoResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.credentials = { username: '', password: '' };
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            var _resolve = this.resolve,
                companyId = _resolve.companyId,
                appId = _resolve.appId;


            this.isSaving = true;
            this.FederateSsoResource.federateSso(companyId, appId, this.credentials).then(function () {
                _this.isSaved = true;
                var key = 'company.manage-application.integration-developers.configure-sso.saved';
                _this.spAlert = new _spAlert.SpAlert('success', key, {}, false);
            }).catch(function () {
                var key = 'company.manage-application.integration-developers.configure-sso.failed';
                _this.spAlert = new _spAlert.SpAlert('danger', key);
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$translate', '$uibModal'];

    /** @ngInject */
    function Controller($translate, $uibModal) {
        _classCallCheck(this, Controller);

        this.$translate = $translate;
        this.$uibModal = $uibModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'showAutoConfigureSsoModal',
        value: function showAutoConfigureSsoModal() {
            var _this = this;

            this.$uibModal.open({
                component: 'autoConfigureSsoModal',
                resolve: {
                    appId: function appId() {
                        return _this.application.id;
                    },
                    companyId: function companyId() {
                        return _this.companyId;
                    },
                    domainName: function domainName() {
                        return _this.application.appDomain.domainName;
                    }
                }
            });
        }
    }, {
        key: 'templateUrl',
        value: function templateUrl() {
            return __webpack_require__(1537)("./configure-sso-" + this.$translate.use() + '.html');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** @ngInject */
var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            var type = this.application.applicationType.slug;
            this.templateUrl = __webpack_require__(1548)("./" + type + ".html");
        }
    }]);

    return Controller;
}();

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1e3ca02eb3c3d746d41a75b7cb303b19.html";

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a13cc9cdc598926d91c5093cf6345c07.html";

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "108a660e9dfe56aa3e308a27b3f0ffc5.html";

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20fb676a3e2889ca614996c5b291f42e.html";

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7272c1533c9dfc5402e4463f4321d481.html";

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var type = this.application.applicationType.slug;

            this.isComputerLoginWithAD = type === 'computer-login';
            this.isComputerLoginWithoutAD = type === 'computer-protection-without-ad';
            this.isCustom = type === 'custom';
            this.isOffice365 = type === 'office-365';
            this.isDropbox = type === 'dropbox';

            var context = __webpack_require__(1552);
            this.hasHelp = context.keys().includes('./' + type + '.html');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
Controller.$inject = ['$state', '$timeout'];
/** @ngInject */
function Controller($state, $timeout) {
    var _this = this;

    this.$onInit = function () {

        var initIntegrationOverviewTab = function initIntegrationOverviewTab() {
            $('#federateSsoLink').click(function (event) {
                event.preventDefault();
                $state.go('^.configure-sso');
            });
            $('#manualConfigurationLink').click(function (event) {
                event.preventDefault();
                $state.go('^.manual-integration');
            });
            $('.userProvisioningLink').click(function (event) {
                event.preventDefault();
                $state.go('^.^.o365-provisioning');
            });
            $('#userAccountsLink').click(function (event) {
                event.preventDefault();
                $state.go('^.^.users');
            });

            $('#goToConfiguration').click(function (event) {
                event.preventDefault();
                $state.go('company.manage-application.configuration');
            });
            $('#usersLink').click(function (event) {
                event.preventDefault();
                $state.go($state.current, { '#': 'users' });
            });
            $();
        };

        $timeout(function () {
            initIntegrationOverviewTab();
        }, 200);
        _this.m365txt = window.env.urls.m365txt;
        _this.m365ps1 = window.env.urls.m365ps1;
    };
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _paths = __webpack_require__(137);

Controller.$inject = ['$scope', '$state', '$timeout'];


/** @ngInject */
function Controller($scope, $state, $timeout) {
    var _this = this;

    this.$onInit = function () {
        _this.isSmsUser = _this.account.roles.includes('ROLE_SMS_USER');

        var appType = _this.application.applicationType;
        _this.localInstructionsExist = (0, _paths.instructionsExist)(appType);

        var slug = appType.slug;
        _this.isSaml = appType.saml;
        _this.isOidc = appType.oidcConfigSupported && slug != 'generic-oauth2' && !slug.endsWith('proxy-sso');
        _this.isOauth = slug == 'generic-oauth2';

        var initIntegrationOverviewTab = function initIntegrationOverviewTab() {
            $('.apiKey.redirectDestructive').click(function (event) {
                event.preventDefault();
                $state.go('^.app-key-password');
            });
        };

        $timeout(function () {
            initIntegrationOverviewTab();
        }, 1000);

        $scope.$on('language-loaded', function () {
            $state.reload('company.manage-application');
        });

        $('#configuration').on('click', '#simulator', function (event) {
            event.preventDefault();
            $state.go('company.manage-application.integration-developers.simulators');
        });

        $('#configuration').on('click', '#widget', function (event) {
            event.preventDefault();
            $state.go('company.manage-application.integration-developers.widgets');
        });

        $('#configuration').on('click', '#otp', function (event) {
            event.preventDefault();
            $state.go('company.manage-application.developers.otp');
        });

        $('#configuration').on('click', '#goToConfiguration', function (event) {
            event.preventDefault();
            $state.go('company.manage-application.configuration');
        });
    };
}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$scope', 'Alert', 'ApplicationsResource'];

    /** @ngInject */
    function Controller($state, $scope, Alert, ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$scope = $scope;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            this.isSaving = true;
            this.ApplicationsResource.changeNonDomainComputerProtectionKey(this.companyId, this.application.id).then(function (nonDomainProtectionKey) {
                _this2.Alert('success', 'company.manage-application.integration-developers.non-domain-protection-key.changed');
                _this2.application.nonDomainProtectionKey = nonDomainProtectionKey;
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sessionId = __webpack_require__(22);

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', 'BarcodeGeneratonService', 'RegistrationCodeGeneratonService', 'SimulatorResource'];

    /** @ngInject */
    function Controller($scope, BarcodeGeneratonService, RegistrationCodeGeneratonService, SimulatorResource) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.BarcodeGeneratonService = BarcodeGeneratonService;
        this.RegistrationCodeGeneratonService = RegistrationCodeGeneratonService;
        this.SimulatorResource = SimulatorResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$scope.$on('websocket.SAML_LOGIN', function () {
                _this.irSuccess = false;
                _this.ilSuccess = true;
            });
            this.$scope.$on('websocket.REGISTERED_COMPANY', function () {
                _this.ilSuccess = false;
                _this.irSuccess = true;
            });
        }
    }, {
        key: 'loadQrDataIL',
        value: function loadQrDataIL() {
            return this.BarcodeGeneratonService.simulatorBarcode({
                uuid: _sessionId.SESSION_ID,
                appKey: this.application.applicationApiKey
            }).$promise.then(function (barcode) {
                return barcode.barcodeimage;
            });
        }
    }, {
        key: 'loadQrDataIR',
        value: function loadQrDataIR() {
            return this.RegistrationCodeGeneratonService.simulatorBarcode({
                uuid: _sessionId.SESSION_ID,
                appKey: this.application.applicationApiKey
            }).$promise.then(function (barcode) {
                return barcode.barcodeimage;
            });
        }
    }, {
        key: 'simulateManualLogin',
        value: function simulateManualLogin() {
            var _this2 = this;

            this.isLoading = true;
            this.SimulatorResource.simulateManualLogin(this.companyId, this.application.id, this.username, this.otp).then(function () {
                var key = 'developers.body.simulator.otp_success';
                _this2.spAlert = new _spAlert.SpAlert('success', key);
            }, function () {
                var key = 'developers.body.simulator.otp_error';
                _this2.spAlert = new _spAlert.SpAlert('danger', key);
            }).finally(function () {
                return _this2.isLoading = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.methods = 'otp';
        }
    }, {
        key: 'showWidget',
        value: function showWidget() {
            var params = this.methods.split('&').map(function (method) {
                return method + 'Supported=true';
            }).join('&');
            this.widgetUrl = 'widget.html?' + params + '&applicationID=' + this.appId;
            this.widgetUrlDisplay = '' + window.env.urls.customAppWidgetIframePrefix + this.widgetUrl;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var type = this.application.applicationType.slug;
            this.isAws = type === 'aws';
            this.isSaaspassDemo = type === 'saaspass-demo';
            this.isSaaspassMySqlConnector = type === 'saaspass-my-sql-connector';
            this.isCustom = type === 'custom';
            this.isDropbox = type === 'dropbox';
            this.isEPM = type === 'enterprise-password-manager';
            this.isOffice365 = type === 'office-365';
            this.isSRA = type === 'saaspass-secure-remote-access';
            this.isSaml = this.application.applicationType.saml;
            this.isOidcConfigSupported = this.application.applicationType.oidcConfigSupported;
            this.isComputerLogin = type === 'computer-login' || type === 'computer-protection-without-ad';
            this.isComputerLoginWithAzure = type === 'computer-protection-with-azure';
            this.$state.rolesEdited = false;
        }
    }, {
        key: 'showIdpAuthenticatorsTab',
        value: function showIdpAuthenticatorsTab() {
            return this.isSaml || this.isOidcConfigSupported;
        }
    }, {
        key: 'showSoftwareLicenseManagementTab',
        value: function showSoftwareLicenseManagementTab() {
            return !(this.isComputerLogin || this.isComputerLoginWithAzure || this.isCustom);
        }
    }, {
        key: 'showUserButtons',
        value: function showUserButtons() {
            return this.$state.is('company.manage-application.users');
        }
    }, {
        key: 'showRoleButton',
        value: function showRoleButton() {
            return this.$state.is('company.manage-application.roles');
        }
    }, {
        key: 'showRemoteAppButton',
        value: function showRemoteAppButton() {
            return this.$state.is('company.manage-application.remote-app-access');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope'];

    /** @ngInject */
    function Controller($scope) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.init();
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.init();
            this.watch();
        }
    }, {
        key: 'init',
        value: function init() {
            this.$settings = this.mobileApplicationSettings;
            this.settings = _extends({}, this.$settings);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$settings, this.settings);
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp($event) {
            if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
                this.onEnter();
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            var _this = this;

            this.$scope.$watch(function () {
                return _this.settings;
            }, function () {
                return _this.onChange({ $value: _this.settings, $invalid: _this.form.$invalid });
            }, true);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _mobileAppSupport = __webpack_require__(198);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'ApplicationsResource'];

    /** @ngInject */
    function Controller($state, Alert, ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.$settings = (0, _mobileAppSupport.mobileApplicationSettingsFromDto)(this.application.mobileApplicationSettings);
            this.settings = _extends({}, this.$settings);
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.$onInit();
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$settings, this.settings);
        }
    }, {
        key: 'onChange',
        value: function onChange($value, $invalid) {
            this.settings = $value;
            this.$invalid = $invalid;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            var mobileApplicationSettings = (0, _mobileAppSupport.mobileApplicationSettingsToDto)(this.settings);
            var application = _extends({}, this.application, { mobileApplicationSettings: mobileApplicationSettings });
            this.ApplicationsResource.updateApplicationConfiguration(this.companyId, this.application.id, application).then(function () {
                _this.Alert('success', 'company.manage-application.mobile-app-support.saved');
                Object.assign(_this.application, application);
                _this.$settings = _extends({}, _this.settings);
                _this.$state.reload('company.manage-application');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

Controller.$inject = ['$http', '$scope', '$state', '$timeout', 'Alert', 'UserProvisioningService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($http, $scope, $state, $timeout, Alert, UserProvisioningService) {
    var _this = this;

    this.$onInit = function () {
        var initIntegrationOverviewTab = function initIntegrationOverviewTab() {
            $('#integration365UsersLink').click(function (event) {
                event.preventDefault();
                $state.go('^.integration-developers.integration-office-365', { '#': 'users' });
            });
            $('#integration365Link').click(function (event) {
                event.preventDefault();
                $state.go('^.integration-developers.integration-office-365');
            });
            $();
        };
        $timeout(function () {
            initIntegrationOverviewTab();
        }, 200);
        $scope.selectedCategories = [];
        $scope.msCategories = [];
        $scope.disableSaveLicenses = true;
        $scope.queryLicenses = "";

        var companyId = $state.params.companyId;
        var appId = $state.params.appId;
        $scope.configurationId = null;
        $scope.ongoingProcess = false;
        $scope.ongoingProcessType = null;

        $scope.application = _this.application;
        $scope.userProvisioningEnabled = false;

        loadConfigurationOverviewDTO(_this.configurationOverviewDTO);

        $scope.init = function () {
            UserProvisioningService.provisioningConfiguration.get({ companyId: companyId, appId: appId }).$promise.then(loadConfigurationOverviewDTO);
        };

        function loadConfigurationOverviewDTO(data) {
            $scope.provisioningConfiguration = data.o365Configuration;
            $scope.configurationId = data.o365Configuration.id;
            $scope.ongoingProcess = data.provisioningType != null;
            $scope.ongoingProcessType = data.provisioningType;
            $scope.importReport = data.o365ImportReport;
            $scope.exportReport = data.o365ExportReport;
            if ($scope.configurationId != null) {
                $scope.userProvisioningEnabled = true;
            }
            $scope.sendVerificationEmails = data.o365Configuration.sendVerficationEmail;
            setNewLicenses(data.licenses);
        }

        $scope.cancelDisable = function () {
            $scope.userProvisioningEnabled = true;
        };
        $scope.checkDisableProvisioningModal = function (newValue) {
            if (!newValue && $scope.configurationId != null) {
                $('#disableProvisioningModal').modal('show');
            }
        };
        $scope.refreshLicenses = function () {
            UserProvisioningService.userProvisioningLicenses.query({
                companyId: companyId,
                appId: appId
            }).$promise.then(function (data) {
                setNewLicenses(data);
                Alert('success', 'provisioning.refresh_licenses_success_text');
            });
        };
        $scope.changeSelection = function (member) {
            $scope.disableSaveLicenses = false;
            var index = $scope.selectedCategories.indexOf(member);
            if (index == -1) {
                $scope.selectedCategories.push(member);
            } else {
                $scope.selectedCategories.splice(index, 1);
            }
        };

        $scope.saveConfiguration = function () {
            UserProvisioningService.provisioningConfiguration.save({
                companyId: companyId,
                appId: appId
            }, $scope.provisioningConfiguration).$promise.then(function (data) {
                $scope.provisioningConfiguration = data.o365Configuration;
                $scope.configurationId = data.o365Configuration.id;
                $scope.ongoingProcess = data.provisioningType != null;
                $scope.ongoingProcessType = data.provisioningType;
                $scope.importReport = data.o365ImportReport;
                $scope.exportReport = data.o365ExportReport;

                Alert('success', 'provisioning.user_settings.save_success');
            });
        };

        $scope.saveLicenses = function () {

            var licenses = [];
            if ($scope.selectedCategories.length > 0) {
                licenses = $scope.selectedCategories;
            }
            UserProvisioningService.userProvisioningLicenses.save({
                companyId: companyId,
                appId: appId
            }, licenses).$promise.then(function (data) {
                setNewLicenses(data);
                Alert('success', 'provisioning.license.save_success');
            }, function (error) {
                $scope.disableSaveLicenses = true;
                $scope.selectedCategories = [];
                angular.forEach($scope.msCategories, function (value, index) {
                    if (value.isSelected) {
                        $scope.selectedCategories.push(value.skuPartNumber);
                    }
                });
            });
        };

        $scope.deleteConfiguration = function () {

            UserProvisioningService.userProvisioningAction.save({
                companyId: companyId,
                appId: appId
            }, $scope.provisioningConfiguration).$promise.then(function (data) {
                $scope.provisioningConfiguration = data;
                $scope.configurationId = null;
                $scope.importReport = null;
                $scope.exportReport = null;
                $('#disableProvisioningModal').modal('hide');
                Alert('success', 'provisioning.disable_provisioning_success');
            });
        };

        $scope.testApiConnection = function () {
            UserProvisioningService.userProvisioningTest.testConnection({
                companyId: companyId,
                appId: appId
            }, $scope.provisioningConfiguration).$promise.then(function (data) {
                setNewLicenses(data);
                Alert('success', 'provisioning.test_connection_success');
            }, function (error) {

                if (error.data.serviceErrorCode = 'ERR_103203') {
                    Alert('info', error.data.message);
                }
            });
        };

        function setNewLicenses(data) {
            $scope.disableSaveLicenses = true;
            $scope.msCategories = [];
            $scope.selectedCategories = [];
            angular.forEach(data, function (value, index) {
                $scope.msCategories.push(value.skuPartNumber);
                if (value.isSelected) {
                    $scope.selectedCategories.push(value.skuPartNumber);
                }
            });
        }

        $scope.changeSendVerificationEmailFlag = function () {
            UserProvisioningService.provisioningConfiguration.updateVerificationEmailFlag({
                companyId: companyId,
                appId: appId
            }, !$scope.sendVerificationEmails).$promise.then(function () {
                $scope.sendVerificationEmails = !$scope.sendVerificationEmails;
                if ($scope.sendVerificationEmails) {
                    Alert('success', 'provisioning.import_users.send_verification_email_enabled');
                } else {
                    Alert('success', 'provisioning.import_users.send_verification_email_disabled');
                }
            });
        };

        $scope.importUsersFromO365 = function () {
            UserProvisioningService.userProvisioningImport.save({
                companyId: companyId,
                appId: appId
            }, {}).$promise.then(function (data) {
                $scope.ongoingProcess = true;
                $scope.ongoingProcessType = 'IMPORT';
            }, function (error) {
                if (error.data.serviceErrorCode == 'ERR_103204') {
                    $scope.ongoingProcess = true;
                    scope.ongoingProcessType = 'IMPORT';
                }
            });
        };

        $scope.exportUsersToO365 = function () {
            UserProvisioningService.userProvisioningExport.save({
                companyId: companyId,
                appId: appId
            }, {}).$promise.then(function (data) {
                $scope.ongoingProcess = true;
                $scope.ongoingProcessType = 'EXPORT';
            }, function (error) {
                if (error.data.serviceErrorCode == 'ERR_103204') {
                    $scope.ongoingProcess = true;
                    $scope.ongoingProcessType = 'EXPORT';
                }
            });
        };

        $scope.exportUsersToO365Now = function () {
            $scope.exportUsersToO365();
            $('#enableAutoModal').modal('hide');
        };

        $scope.changeAllouAutoProvisioning = function (newValue) {

            UserProvisioningService.provisioningConfiguration.updateAutoProvisioning({
                companyId: companyId,
                appId: appId
            }, newValue).$promise.then(function (data) {
                $scope.provisioningConfiguration = data.o365Configuration;
                $scope.configurationId = data.o365Configuration.id;
                $scope.ongoingProcess = data.provisioningType != null;
                $scope.ongoingProcessType = data.provisioningType;
                $scope.importReport = data.o365ImportReport;
                $scope.exportReport = data.o365ExportReport;
                if (newValue) {
                    $('#enableAutoModal').modal('show');
                }
            });
        };

        $scope.displayExportSpinner = false;
        $scope.generateReportForO365 = function (type, filter) {
            $scope.displayExportSpinner = type;

            var dateVar = new Date();
            var timeZone = dateVar.getTimezoneOffset() / 60 * -1;

            var url = "app/rest/admin/company/" + companyId + "/application/" + appId + "/manageapp/userprovisioning/report";

            $http.get(url, {
                params: {
                    filter: filter,
                    type: type,
                    timeZone: timeZone
                },
                responseType: 'arraybuffer'
            }).then(function (response) {
                $timeout(function () {
                    var file = new Blob([response.data], {
                        type: 'application/pdf'
                    });
                    var fileURL = URL.createObjectURL(file);
                    var a = document.createElement('a');
                    a.href = fileURL;
                    a.target = '_blank';
                    a.download = 'Office365_' + type + '_Report_' + dateVar.toLocaleDateString() + '.pdf';
                    document.body.appendChild(a);
                    a.click();
                    $scope.displayExportSpinner = false;
                });
            }).catch(function (response) {
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(response.data));
                var obj = JSON.parse(decodedString);
                $scope.displayExportSpinner = false;
                Alert('danger', obj.message);
            });
        };
    };
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'RemoteAppAccessService'];

    /** @ngInject */
    function Controller($state, Alert, RemoteAppAccessService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.RemoteAppAccessService = RemoteAppAccessService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.remoteAppsList = this.remoteApps;
            this.model = { application: this.application, applicationName: "", id: null };
            this.selectedGroups = [];
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.RemoteAppAccessService.save(this.companyId, this.appId, { sraRemoteApp: this.model, groups: this.selectedGroups }).then(function (newRemoteAppsList) {
                return Object.assign(_this.remoteApps, newRemoteAppsList);
            }).then(function () {
                return _this.$state.go('^');
            }).then(function () {
                return _this.Alert('success', 'company.manage-application.remote-appaccess.add.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'RemoteAppAccessService'];

    /** @ngInject */
    function Controller($state, Alert, RemoteAppAccessService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.RemoteAppAccessService = RemoteAppAccessService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.model = this.remoteApp;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.model.groups = this.groupsModel.filter(function (group) {
                return group.isSelected;
            });
            this.RemoteAppAccessService.save(this.companyId, this.appId, this.model).then(function (newRemoteAppsList) {
                return Object.assign(_this.remoteApps, newRemoteAppsList);
            }).then(function () {
                return _this.$state.go('^');
            }).then(function () {
                return _this.Alert('success', 'company.manage-application.remote-appaccess.edit.edited');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var type = this.application.applicationType.slug;
        }
    }, {
        key: 'showRemoveModal',
        value: function showRemoveModal(_remoteAppId) {
            var _this = this;

            this.$uibModal.open({
                component: 'companyManageApplicationRemoteAppRemove',
                resolve: {
                    companyId: function companyId() {
                        return _this.companyId;
                    },
                    appId: function appId() {
                        return _this.appId;
                    },
                    remoteAppId: function remoteAppId() {
                        return _remoteAppId;
                    }
                }
            }).result.then(function () {
                var index = _this.remoteApps.findIndex(function (obj) {
                    return obj.sraRemoteApp.id === _remoteAppId;
                });
                if (index != -1) {
                    _this.remoteApps.splice(index, 1);
                    _this.Alert('success', 'company.manage-application.remote-app-access.remove.removed');
                }
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["RemoteAppAccessService"];

    /** @ngInject */
    function Controller(RemoteAppAccessService) {
        _classCallCheck(this, Controller);

        this.RemoteAppAccessService = RemoteAppAccessService;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            this.RemoteAppAccessService.remove(this.resolve.companyId, this.resolve.appId, this.resolve.remoteAppId).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'DestructiveOperationModal'];

    /** @ngInject */
    function Controller($state, Alert, DestructiveOperationModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            // ApplicationsResource.deleteApplication(this.companyId, this.application.id)
            var url = 'app/rest/v2/company/' + this.companyId + '/applications/' + this.application.id;
            var params = { action: 'delete' };
            this.DestructiveOperationModal({ http: { method: 'DELETE', url: url, params: params } }).then(function () {
                return _this.$state.go({
                    'custom': 'company.custom-app-integration',
                    'computer-login': 'company.computer-protection',
                    'computer-protection-without-ad': 'company.computer-protection'
                }[_this.application.applicationType.slug] || 'company.applications');
            }).then(function () {
                _this.Alert('success', 'company.manage-application.remove.removed', { applicationName: _this.application.applicationName });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'RoleManagementResource'];

    /** @ngInject */
    function Controller($state, Alert, RoleManagementResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.RoleManagementResource = RoleManagementResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.model = {};
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.RoleManagementResource.save(this.companyId, this.appId, { loginRole: this.model, groupIds: [] }).then(function (roles) {
                return Object.assign(_this.roles, roles);
            }).then(function () {
                return _this.$state.rolesEdited = true;
            }).then(function () {
                return _this.$state.go('^');
            }).then(function () {
                return _this.Alert('success', 'company.manage-application.roles.add.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _roles = __webpack_require__(199);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'RoleManagementResource'];

    /** @ngInject */
    function Controller($state, Alert, RoleManagementResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.RoleManagementResource = RoleManagementResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.$model = (0, _roles.modelFromDto)(this.role, this.groups);
            this.model = (0, _roles.modelFromDto)(this.role, this.groups);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.RoleManagementResource.save(this.companyId, this.appId, (0, _roles.modelToDto)(this.model)).then(function (roles) {
                return Object.assign(_this.roles, roles);
            }).then(function () {
                return _this.$state.rolesEdited = true;
            }).then(function () {
                return _this.$state.go('^');
            }).then(function () {
                return _this.Alert('success', 'company.manage-application.roles.edit.saved');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving || angular.equals(this.$model, this.model);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["RoleManagementResource"];

    /** @ngInject */
    function Controller(RoleManagementResource) {
        _classCallCheck(this, Controller);

        this.RoleManagementResource = RoleManagementResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            this.RoleManagementResource.remove(this.resolve.companyId, this.resolve.appId, this.resolve.roleId).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _roles = __webpack_require__(199);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.roles = this.roles.map(function (role) {
                return (0, _roles.modelFromDto)(role, _this.groups);
            }).map(function (role) {
                return _extends({}, role, { groups: role.groups.filter(function (group) {
                        return group.isSelected;
                    }) });
            });
        }
    }, {
        key: 'showRemoveModal',
        value: function showRemoveModal(_roleId) {
            var _this2 = this;

            this.$uibModal.open({
                component: 'companyManageApplicationRolesRemove',
                resolve: {
                    companyId: function companyId() {
                        return _this2.companyId;
                    },
                    appId: function appId() {
                        return _this2.appId;
                    },
                    roleId: function roleId() {
                        return _roleId;
                    }
                }
            }).result.then(function () {
                var index = _this2.roles.findIndex(function (_ref) {
                    var id = _ref.id;
                    return id === _roleId;
                });
                _this2.roles.splice(index, 1);
                _this2.$state.rolesEdited = true;
                _this2.Alert('success', 'company.manage-application.roles.remove.removed');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _directoryIntegration = __webpack_require__(56);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'ConfirmModal', 'ApplicationsResource', 'DirectoriesResource', 'ShowNoteModal'];

    /** @ngInject */
    function Controller($state, Alert, ConfirmModal, ApplicationsResource, DirectoriesResource, ShowNoteModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.ConfirmModal = ConfirmModal;
        this.ApplicationsResource = ApplicationsResource;
        this.DirectoriesResource = DirectoriesResource;
        this.ShowNoteModal = ShowNoteModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.provisioningDirectory == '' || this.provisioningDirectory == 'null') {
                this.provisioningDirectory = null;
            } else {
                this.provisioningDirectory = (0, _directoryIntegration.toDirectoryDTO)(this.provisioningDirectory);
            }
            this.userProvisioningEnabled = this.provisioningDirectory != null;
        }
    }, {
        key: 'provisioningSwitchValueChanged',
        value: function provisioningSwitchValueChanged(newValue) {
            var _this = this;

            if (newValue) {
                if (this.provisioningDirectory == null) {
                    this.addingModeOn = true;
                }
            } else {
                if (this.provisioningDirectory != null) {
                    this.userProvisioningEnabled = !newValue;
                    this.ConfirmModal({
                        messageKey: 'company.manage-application.scim-provisioning.disable.confirm.message',
                        titleKey: 'company.manage-application.scim-provisioning.disable.confirm.title'
                    }).then(function () {
                        _this.userProvisioningEnabled = newValue;
                        _this.disableUserProvisioning();
                    }).finally(function () {
                        return _this.isSending = false;
                    });
                } else {
                    this.addingModeOn = false;
                }
            }
        }
    }, {
        key: 'disableUserProvisioning',
        value: function disableUserProvisioning() {
            var _this2 = this;

            this.ApplicationsResource.removeProvisioningDirectory(this.companyId, this.application.id).then(function (data) {
                _this2.Alert('success', 'company.manage-application.scim-provisioning.disabled');
                _this2.$state.go('.', {}, { reload: '.' });
            });
        }
    }, {
        key: 'pauseScimProvisioning',
        value: function pauseScimProvisioning() {
            var _this3 = this;

            this.DirectoriesResource.pauseScimProvisioning(this.companyId, this.provisioningDirectory.id).then(function () {
                _this3.provisioningDirectory.appProvisioningPaused = true;
                _this3.Alert('success', 'company.directory-integration.manage.main.updated', { directoryTypeName: _this3.directory.typeName });
            });
        }
    }, {
        key: 'resumeScimProvisioning',
        value: function resumeScimProvisioning() {
            var _this4 = this;

            this.DirectoriesResource.resumeScimProvisioning(this.companyId, this.provisioningDirectory.id).then(function () {
                _this4.provisioningDirectory.appProvisioningPaused = false;
                _this4.Alert('success', 'company.directory-integration.manage.main.updated', { directoryTypeName: _this4.directory.typeName });
            });
        }
    }, {
        key: 'addScimDirectory',
        value: function addScimDirectory() {
            var _this5 = this;

            this.DirectoriesResource.createScimDirectory(this.companyId, this.newDirectory.name, this.newDirectory.tenantId, true).then(function (directory) {
                _this5.ApplicationsResource.setProvisioningDirectory(_this5.companyId, _this5.application.id, directory.id).then(function (data) {
                    _this5.Alert('success', 'company.manage-application.scim-provisioning.enabled');
                    _this5.$state.go('.', {}, { reload: '.' });
                });
            }).finally(function () {
                return _this5.isSaving = false;
            });
        }
    }, {
        key: 'showLatestErrors',
        value: function showLatestErrors() {
            this.ShowNoteModal('company.manage-application.scim-provisioning.latest-errors', this.provisioningDirectory.statusDto.lastProvisioningErrorMessage);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope'];

    /** @ngInject */
    function Controller($scope) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onChanges',
        value: function $onChanges() {
            this.init();
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.init();
            this.watch();
        }
    }, {
        key: 'init',
        value: function init() {
            this.$model = this.loginServicesConfiguration;
            this.model = angular.copy(this.$model);
        }
    }, {
        key: 'instantLoginUrlEnabled',
        value: function instantLoginUrlEnabled() {
            return this.model.instantLoginEnabled || this.model.proximityEnabled || this.model.pushLoginEnabled;
        }
    }, {
        key: 'mobileApplicationSettingsChanged',
        value: function mobileApplicationSettingsChanged($value, $invalid) {
            this.model.mobileApplicationSettings = $value;
            this.onChange({ $value: this.model, $invalid: $invalid || this.form.$invalid });
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$model, this.model);
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp($event) {
            if ($event.keyCode === 13 && this.form.$valid && !this.notModified()) {
                this.onEnter();
            }
        }
    }, {
        key: 'watch',
        value: function watch() {
            var _this = this;

            this.$scope.$watch(function () {
                return _this.model;
            }, function () {
                return _this.onChange({ $value: _this.model, $invalid: _this.form.$invalid });
            }, true);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$state', 'Alert', 'ApplicationsResource'];

    /** @ngInject */
    function Controller($rootScope, $state, Alert, ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.resetSessionRecordingSettings();
        }
    }, {
        key: 'sessionRecordingSettingsChanged',
        value: function sessionRecordingSettingsChanged($value, $invalid) {
            this.sessionRecordingSettings = $value;
            this.invalidSessionRecordingSettings = $invalid;
        }
    }, {
        key: 'sessionRecordingSettingsIsNotModified',
        value: function sessionRecordingSettingsIsNotModified() {
            return angular.equals(this.$sessionRecordingSettings, this.sessionRecordingSettings);
        }
    }, {
        key: 'resetSessionRecordingSettings',
        value: function resetSessionRecordingSettings() {
            this.$sessionRecordingSettings = angular.copy(this.application.sessionRecordingSettings);
            this.sessionRecordingSettings = angular.copy(this.application.sessionRecordingSettings);
        }
    }, {
        key: 'save',
        value: function save(dto) {
            var _this = this;

            this.isSaving = true;
            return this.ApplicationsResource.updateApplicationConfiguration(this.companyId, this.application.id, dto).then(function () {
                _this.Alert('success', 'company.manage-application.configuration.saved');
                Object.assign(_this.application, dto);
                _this.$onInit();
                _this.$state.reload('company.manage-application');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveSessionRecordingSettings',
        value: function saveSessionRecordingSettings() {
            var _this2 = this;

            this.isSavingSessionRecordingSettings = true;
            console.log('sessionRecordingSettings is ' + this.sessionRecordingSettings);
            console.log('$sessionRecordingSettings is ' + this.$sessionRecordingSettings);

            this.save(_extends({}, this.application, { sessionRecordingSettings: this.sessionRecordingSettings })).finally(function () {
                return _this2.isSavingSessionRecordingSettings = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.isCustomizeUserAuthenticationVisible = this.is('computer-login', 'linux-ssh', 'radius', 'cisco-asa', 'check-point', 'custom', 'computer-protection-without-ad', 'google-apps', 'owa');
        }
    }, {
        key: 'is',
        value: function is() {
            for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
                types[_key] = arguments[_key];
            }

            return types.includes(this.application.applicationType.slug);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'ApplicationsResource'];

    /** @ngInject */
    function Controller($state, Alert, ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.$state.rolesEdited) {
                this.reloadApp(this.companyId, this.application.id, this.ApplicationsResource);
                this.$state.rolesEdited = false;
            }
            this.st = new _smartTable.SmartTable();
            this.isAws = this.is('aws');
            this.isSaaspassDemo = this.is('saaspass-demo');
            this.isSaaspassMySqlConnector = this.is('saaspass-my-sql-connector');
            this.selectedRoles = this.groups.reduce(function (groupIds, group) {
                return _extends({}, groupIds, _defineProperty({}, group.id, _this.application.loginRoles.reduce(function (roleIds, _ref) {
                    var loginRoleId = _ref.loginRoleId;
                    return _extends({}, roleIds, _defineProperty({}, loginRoleId, false));
                }, {})));
            }, {});
        }
    }, {
        key: 'is',
        value: function is() {
            for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
                types[_key] = arguments[_key];
            }

            return types.includes(this.application.applicationType.slug);
        }
    }, {
        key: 'assign',
        value: function assign() {
            var _this2 = this;

            var data = this.st.selectedIds.map(function (groupId) {
                return {
                    groupId: groupId,
                    roleIds: _this2.selectedRolesForGroup(groupId).map(function (role) {
                        return role.loginRoleId;
                    })
                };
            });

            this.isSaving = true;
            this.ApplicationsResource.assignGroups(this.companyId, this.application.id, data).then(function () {
                return _this2.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this2.Alert('success', 'company.manage-application.users.assign-groups.assigned');
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'selectedRolesForGroup',
        value: function selectedRolesForGroup(groupId) {
            var _this3 = this;

            return this.application.loginRoles.filter(function (role) {
                return _this3.selectedRoles[groupId][role.loginRoleId];
            });
        }
    }, {
        key: 'selectedRoleNamesForGroup',
        value: function selectedRoleNamesForGroup(groupId) {
            return this.selectedRolesForGroup(groupId).map(function (role) {
                return role.loginRoleName;
            }).join(', ');
        }
    }, {
        key: 'reloadApp',
        value: function reloadApp(companyId, appId, ApplicationsResource) {
            var _this4 = this;

            ApplicationsResource.getApplicationConfiguration(companyId, appId).then(function (app) {
                _this4.application = app;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'ApplicationsResource'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.$state.rolesEdited) {
                this.reloadApp(this.companyId, this.application.id, this.ApplicationsResource);
                this.$state.rolesEdited = false;
            }
            this.$selectedRoles = this.groups.reduce(function (groupIds, group) {
                return _extends({}, groupIds, _defineProperty({}, group.id, _this.application.loginRoles.reduce(function (roleIds, _ref) {
                    var loginRoleId = _ref.loginRoleId;
                    return _extends({}, roleIds, _defineProperty({}, loginRoleId, group.appRoleIds.includes(loginRoleId)));
                }, {})));
            }, {});

            this.selectedRoles = angular.copy(this.$selectedRoles);
            this.managePasswordsVisible = this.application.passwordAuthenticationEnabled || this.application.adAccountPasswordsCanBeEdited && this.application.adAccountPasswordsCanBeViewed && (this.is('computer-login') || this.is('ad-password-manager'));
            this.generateCodesVisible = this.application.adminCanGenerateComputerLoginCode && (this.is('computer-login') || this.is('computer-protection-without-ad'));
            this.samlAppLogo = window.env.urls.samlAppLogo;
        }
    }, {
        key: 'is',
        value: function is() {
            for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
                types[_key] = arguments[_key];
            }

            return types.includes(this.application.applicationType.slug);
        }
    }, {
        key: 'resetRoles',
        value: function resetRoles() {
            this.selectedRoles = angular.copy(this.$selectedRoles);
        }
    }, {
        key: 'rolesNotModified',
        value: function rolesNotModified() {
            return angular.equals(this.$selectedRoles, this.selectedRoles);
        }
    }, {
        key: 'selectedRoleNamesForGroup',
        value: function selectedRoleNamesForGroup(groupId) {
            return this.selectedRolesForGroup(groupId).map(function (role) {
                return role.loginRoleName;
            }).join(', ');
        }
    }, {
        key: 'selectedRolesForGroup',
        value: function selectedRolesForGroup(groupId) {
            var _this2 = this;

            return this.application.loginRoles.filter(function (role) {
                return _this2.selectedRoles[groupId][role.loginRoleId];
            });
        }
    }, {
        key: 'showUnassignGroupModal',
        value: function showUnassignGroupModal(_groupId) {
            var _this3 = this;

            this.$uibModal.open({
                component: 'companyManageApplicationUsersUnassignGroup',
                resolve: {
                    applicationId: function applicationId() {
                        return _this3.application.id;
                    },
                    companyId: function companyId() {
                        return _this3.companyId;
                    },
                    groupId: function groupId() {
                        return _groupId;
                    }
                }
            }).result.then(function () {
                var index = _this3.groups.findIndex(function (_ref2) {
                    var id = _ref2.id;
                    return id === _groupId;
                });
                _this3.groups.splice(index, 1);
                _this3.Alert('success', 'company.manage-application.users.unassign-group.unassigned');
            });
        }
    }, {
        key: 'showEpmCredentialsModal',
        value: function showEpmCredentialsModal(_groupId2) {
            var _this4 = this;

            this.$uibModal.open({
                component: 'companyManageApplicationUsersEpmCredentials',
                resolve: {
                    applicationId: function applicationId() {
                        return _this4.application.id;
                    },
                    companyId: function companyId() {
                        return _this4.companyId;
                    },
                    groupId: function groupId() {
                        return _groupId2;
                    }
                },
                size: 'xl'
            });
        }
    }, {
        key: 'showManagePasswordsModal',
        value: function showManagePasswordsModal(_groupId3) {
            var _this5 = this;

            this.$uibModal.open({
                component: 'companyManageApplicationUsersManagePasswords',
                resolve: {
                    applicationId: function applicationId() {
                        return _this5.application.id;
                    },
                    companyId: function companyId() {
                        return _this5.companyId;
                    },
                    groupId: function groupId() {
                        return _groupId3;
                    },
                    isComputerApplication: function isComputerApplication() {
                        return _this5.is('computer-protection-without-ad', 'computer-login');
                    },
                    isAdPasswordManagerApplication: function isAdPasswordManagerApplication() {
                        return _this5.is('ad-password-manager');
                    },
                    adPasswordViewSupported: function adPasswordViewSupported() {
                        return _this5.application.adAccountPasswordsCanBeViewed;
                    },
                    isAdPassEditableApplication: function isAdPassEditableApplication() {
                        return _this5.application.adAccountPasswordsCanBeEdited && (_this5.is('computer-login') || _this5.is('ad-password-manager'));
                    }
                },
                size: 'xl'
            });
        }
    }, {
        key: 'updateAwsGroupRoles',
        value: function updateAwsGroupRoles() {
            var _this6 = this;

            var data = this.groups.map(function (group) {
                return {
                    groupId: group.id,
                    roleIds: _this6.selectedRolesForGroup(group.id).map(function (role) {
                        return role.loginRoleId;
                    })
                };
            });

            this.isSavingRoles = true;
            this.ApplicationsResource.updateAwsGroupRoles(this.companyId, this.application.id, data).then(function () {
                return _this6.$state.reload('company.manage-application');
            }).then(function () {
                return _this6.Alert('success', 'company.manage-application.users.saved-roles');
            }).finally(function () {
                return _this6.isSavingRoles = false;
            });
        }
    }, {
        key: 'reloadApp',
        value: function reloadApp(companyId, appId, ApplicationsResource) {
            var _this7 = this;

            ApplicationsResource.getApplicationConfiguration(companyId, appId).then(function (app) {
                _this7.application = app;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'ApplicationsResource'];

    /** @ngInject */
    function Controller(Alert, ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.ApplicationsResource.getApplicationSamlAssertionAttributes(this.companyId, this.application.id).then(function (attribs) {
                _this.$attribs = angular.copy(attribs);
                _this.attribs = angular.copy(attribs);
            });

            this.types = [{ value: 'Custom', label: '[Custom Value]' }, { value: 'Username', label: 'Account.Username' }, { value: 'FirstName', label: 'Account.FirstName' }, { value: 'LastName', label: 'Account.LastName' }, { value: 'Email', label: 'Account.Email' }, { value: 'PhoneNumber', label: 'Account.PhoneNumber' }, { value: 'City', label: 'Account.City' }, { value: 'Country', label: 'Account.Country' }, { value: 'StreetAddress', label: 'Account.StreetAddress' }, { value: 'Department', label: 'Account.Department' }, { value: 'JobTitle', label: 'Account.JobTitle' }, { value: 'CompanyName', label: 'Account.CompanyName' }, { value: 'ZipCode', label: 'Account.ZipCode' }];
        }
    }, {
        key: 'add',
        value: function add() {
            this.attribs.push({ name: '', type: 'FirstName', customValue: '' });
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.attribs, this.$attribs);
        }
    }, {
        key: 'remove',
        value: function remove(attrib) {
            this.attribs = this.attribs.filter(function (a) {
                return a !== attrib;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.attribs = angular.copy(this.$attribs);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.isSaving = true;
            this.ApplicationsResource.updateApplicationSamlAssertionAttributes(this.companyId, this.application.id, this.attribs).then(function () {
                _this2.$attribs = angular.copy(_this2.attribs);
                _this2.Alert('success', 'company.manage-application.users.customize-saml-assertion.saved');
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'ApplicationsResource'];

    /** @ngInject */
    function Controller($state, Alert, ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.config = _extends({}, this.application);
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            this.config = _extends({}, this.application);
        }
    }, {
        key: 'is',
        value: function is() {
            for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
                types[_key] = arguments[_key];
            }

            return types.includes(this.application.applicationType.slug);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.application, this.config);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.ApplicationsResource.updateApplicationConfiguration(this.companyId, this.application.id, this.config).then(function () {
                _this.Alert('success', 'company.manage-application.users.saved');
                Object.assign(_this.application, _this.config);
                _this.$state.reload('company.manage-application');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving || this.notModified();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _passwordStrength = __webpack_require__(85);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['AccountsResource', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller(AccountsResource, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.accounts = [];
            this.isLoading = true;

            this.GroupsResource.getAllAccountsForCompanyAndGroupAndApplication(this.companyId, this.groupId, this.appId).then(function (accounts) {
                return accounts.map(function (account) {
                    return _extends({}, account, {
                        passGrade: (0, _passwordStrength.passwordGrade)(account.password),
                        searchObj: [account.username, account.user.saaspassId, account.user.displayName]
                    });
                });
            }).then(function (accounts) {
                return _this.accounts = accounts;
            }).finally(function () {
                return _this.isLoading = false;
            });
        }
    }, {
        key: 'save',
        value: function save(accountId, password) {
            var _this2 = this;

            return this.AccountsResource.setPasswordForAccount(this.companyId, this.appId, accountId, password).then(function () {
                return _this2.accounts.find(function (a) {
                    return a.id === accountId;
                });
            }).then(function (a) {
                a.password = password;
                a.passGrade = (0, _passwordStrength.passwordGrade)(password);
            }).then(function () {
                return _this2.Alert('success', 'company.manage-application.users.manage-passwords.saved');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['AccountsResource', 'Alert', 'GroupsResource', '$scope', '$timeout'];

    /** @ngInject */
    function Controller(AccountsResource, Alert, GroupsResource, $scope, $timeout) {
        _classCallCheck(this, Controller);

        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
        this.$scope = $scope;
        this.$timeout = $timeout;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.accounts = [];
            this.isLoading = true;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });

            this.GroupsResource.getAllAccountsForCompanyAndGroupAndApplication(this.companyId, this.groupId, this.appId).then(function (accounts) {
                return accounts.map(function (account) {
                    return _extends({}, account, {
                        searchObj: [account.username, account.user.saaspassId, account.user.displayName]
                    });
                });
            }).then(function (accounts) {
                return _this.accounts = accounts;
            }).finally(function () {
                return _this.isLoading = false;
            });
        }
    }, {
        key: 'getCode',
        value: function getCode(account) {
            var _this2 = this;

            var accountId = account.id;
            return this.AccountsResource.getComputerLoginCodeForAccount(this.companyId, this.appId, accountId).then(function (data) {
                account.mustRenewCode = false;
                account.code = data.code;
            }).then(function () {
                return _this2.$timeout(30000);
            }).then(function () {
                return account.mustRenewCode = true;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _passwordStrength = __webpack_require__(85);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'ApplicationAccountsResource', 'GroupsResource'];

    /** @ngInject */
    function Controller(Alert, ApplicationAccountsResource, GroupsResource) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.ApplicationAccountsResource = ApplicationAccountsResource;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.accounts = [];
            this.isLoading = true;

            this.isComputerApplication = this.is('computer-protection-without-ad', 'computer-login');
            this.isAdPasswordManagerApplication = this.is('ad-password-manager');
            this.adPasswordViewSupported = this.application.adAccountPasswordsCanBeViewed;
            this.isAdPassEditableApplication = this.application.adAccountPasswordsCanBeEdited && (this.is('computer-login') || this.is('ad-password-manager'));

            this.isAdApplication = this.isAdPassEditableApplication;
            this.numberOfColumns = 3;
            this.GroupsResource.getApplicationGroupAccountCredentials(this.companyId, this.groupId, this.application.id).then(function (dto) {
                _this.policy = dto.applicationPasswordPolicy;
                _this.accounts = dto.appAccountPasswords.map(function (account) {
                    return _extends({}, account, {
                        passGrade: (0, _passwordStrength.passwordGrade)(account.password),
                        searchObj: [account.username, account.user.saaspassId, account.user.displayName]
                    });
                });
                var cantSeePassPart1 = false;
                var canEditPassPart1 = false;
                if (_this.policy !== null) {

                    cantSeePassPart1 = !_this.policy.adminCanSeePassword;
                    canEditPassPart1 = !_this.policy.adminCanSetPassword;
                    if (_this.policy.userCanResetPassword && _this.policy.adminCanResetPassword) {
                        _this.numberOfColumns = 5;
                    } else if (_this.policy.adminCanResetPassword) {
                        _this.numberOfColumns = 4;
                    }
                }
                _this.adminCantSeePass = cantSeePassPart1 || _this.isComputerApplication && _this.isAdPassEditableApplication && !_this.adPasswordViewSupported;
                _this.readOnlyPass = canEditPassPart1 || _this.isComputerApplication && !_this.isAdPassEditableApplication;
            }).finally(function () {
                return _this.isLoading = false;
            });
        }
    }, {
        key: 'saveEmail',
        value: function saveEmail(account, email) {
            var _this2 = this;

            var accId = account.companyUserAccountId;
            return this.ApplicationAccountsResource.setPasswordResetEmailForAppAccount(this.companyId, this.application.id, accId, email).then(function () {
                return account.resetEmail = email;
            }).then(function () {
                return _this2.Alert('success', 'company.manage-application.users.manage-passwords.saved');
            });
        }
    }, {
        key: 'generatePassword',
        value: function generatePassword(account) {
            var accId = account.companyUserAccountId;
            return this.ApplicationAccountsResource.generatePasswordForAppAccount(this.companyId, this.application.id, accId);
        }
    }, {
        key: 'savePassword',
        value: function savePassword(account, password) {
            var _this3 = this;

            var accId = account.companyUserAccountId;
            return this.ApplicationAccountsResource.setPasswordForAppAccount(this.companyId, this.application.id, accId, password).then(function () {
                account.password = password;
                account.passGrade = (0, _passwordStrength.passwordGrade)(password);
                _this3.Alert('success', 'company.manage-application.users.manage-passwords.saved');
            });
        }
    }, {
        key: 'sendReset',
        value: function sendReset(account) {
            var _this4 = this;

            var accId = account.companyUserAccountId;
            this.sendingResetForAccount = account;
            this.ApplicationAccountsResource.sendPasswordResetEmailForAppAccount(this.companyId, this.application.id, accId).then(function () {
                return _this4.Alert('success', 'company.manage-application.users.manage-passwords.sent');
            }).finally(function () {
                return _this4.sendingResetForAccount = null;
            });
        }
    }, {
        key: 'sendResetClass',
        value: function sendResetClass(account) {
            return this.sendingResetForAccount === account ? 'fa fa-sync fa-spin' : 'fa fa-envelope';
        }
    }, {
        key: 'sendResetDisabled',
        value: function sendResetDisabled(account) {
            return !account.resetEmail || this.sendingResetForAccount === account;
        }
    }, {
        key: 'is',
        value: function is() {
            for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
                types[_key] = arguments[_key];
            }

            return types.includes(this.application.applicationType.slug);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["ApplicationsResource"];

    /** @ngInject */
    function Controller(ApplicationsResource) {
        _classCallCheck(this, Controller);

        this.ApplicationsResource = ApplicationsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "unassign",
        value: function unassign() {
            var _this = this;

            this.isSaving = true;
            this.ApplicationsResource.unassignGroup(this.resolve.companyId, this.resolve.applicationId, this.resolve.groupId).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _spUtil = __webpack_require__(73);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.st = new _smartTable.SmartTable();
            this.applications.map(function (application) {
                return _this.setDisplayNames(application);
            });
        }
    }, {
        key: 'setDisplayNames',
        value: function setDisplayNames(application) {
            application.typeDisplayName = this.typeDisplayName(application);
            application.protocolDisplayName = (0, _spUtil.appProtocolDisplayName)(application);
        }
    }, {
        key: 'typeDisplayName',
        value: function typeDisplayName(app) {
            var displayName = app.publicService ? app.publicService.serviceName + ' - ' + app.applicationTypeDisplayName : app.applicationTypeDisplayName;
            return displayName;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _paths = __webpack_require__(137);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$state', 'AddApplicationModal', 'AddNewApplicationResource'];

    /** @ngInject */
    function Controller($scope, $state, AddApplicationModal, AddNewApplicationResource) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
        this.AddApplicationModal = AddApplicationModal;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
            this.localInstructionsExist = (0, _paths.instructionsExist)(this.appType);
            if (!this.localInstructionsExist) {
                this.$scope.$on('language-loaded', function () {
                    return _this.loadHelpXml();
                });
                this.loadHelpXml();
            }
            var isSra = this.appType.slug === 'saaspass-secure-remote-access';
            var isAdPasswordManager = this.appType.slug === 'ad-password-manager';

            var isSraAllowed = this.appPermissions.sra;
            var isAdPasswordManagerAllowed = this.appPermissions.adPasswordManager;

            this.allowAdd = !(isSra && !isSraAllowed || isAdPasswordManager && !isAdPasswordManagerAllowed);
            this.isOidc = this.appType.oidcConfigSupported && this.appType != 'generic-oauth2';
        }
    }, {
        key: 'addNewApplication',
        value: function addNewApplication() {
            var _this2 = this;

            if (this.appType.slug === 'office-365') {
                this.AddApplicationModal(this.appType);
                return;
            }
            this.AddNewApplicationResource.createSecureApp(this.companyId, this.appType.id).then(function (app) {
                return _this2.$state.go('company.manage-application', { appId: app.id });
            });
        }
    }, {
        key: 'loadHelpXml',
        value: function loadHelpXml() {
            var _this3 = this;

            this.isLoading = true;
            this.AddNewApplicationResource.getAllApplicationInfoWithoutParameters(this.companyId, this.appType.id).then(function (instructions) {
                return _this3.instructions = instructions;
            }).finally(function () {
                return _this3.isLoading = false;
            });
        }
    }, {
        key: 'checkIfAdd',
        value: function checkIfAdd() {
            var isSra = this.appType.slug === 'saaspass-secure-remote-access';
            var isAdPasswordManager = this.appType.slug === 'ad-password-manager';

            var isSraAllowed = this.appPermissions.sra;
            var isAdPasswordManagerAllowed = this.appPermissions.adPasswordManager;

            this.allowAdd = !(isSra && !isSraAllowed || isAdPasswordManager && !isAdPasswordManagerAllowed);
            return allowAdd;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var protocols = [{ label: 'ALL', has: function has() {
        return true;
    } }, { label: 'SAML', has: function has(app) {
        return app.isSaml;
    } }, { label: 'OAUTH & OIDC (OPENID CONNECT)', has: function has(app) {
        return app.oidcConfigSupported;
    } }, { label: 'MFA ADAPTER / RADIUS / RDP / VPN', has: function has(app) {
        return app.isRadius || app.isMfaAdapter || app.isVpnRdp;
    } }, { label: 'PROXY SSO', has: function has(app) {
        return app.slug.endsWith('proxy-sso');
    } }, { label: 'PROVISIONING', has: function has(app) {
        return app.provisioningSupported;
    } }];

var allProtocols = protocols[0];
var allCategories = { name: 'All' };

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$filter', '$timeout', 'AddApplicationModal', 'AddNewApplicationResource'];

    /** @ngInject */
    function Controller($state, $filter, $timeout, AddApplicationModal, AddNewApplicationResource) {
        _classCallCheck(this, Controller);

        this.state = $state;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.AddApplicationModal = AddApplicationModal;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.protocol = allProtocols;
            this.protocols = protocols;
            this.category = allCategories;
            this.categories = [allCategories].concat(_toConsumableArray(this.appCategories));
            this.samlAppLogo = window.env.urls.samlAppLogo;
            this.searchText = '';

            if (this.protocolstr == 'oauthoidc') {
                this.protocol = protocols[2];
            }

            this.filteredAppTypes = [];
            setTimeout(function () {
                /*
                * This small delay is added because of smart table pagination.
                * If it is loading for the first time after refreshing page.
                * It was loading all application types and then applying pagination.
                */
                _this.applyFilters();
            }, 100);
            localStorage.setItem('items-per-page:' + this.state.current.name, 50);
        }
    }, {
        key: 'applyFilters',
        value: function applyFilters() {
            var _this2 = this;

            this.filteredAppTypes = [];
            this.$timeout().then(function () {
                return _this2.appTypes;
            }).then(function (apps) {
                return apps.filter(function (app) {
                    return _this2.protocol.has(app);
                });
            }).then(function (apps) {
                return apps.filter(function (app) {
                    return _this2.categoryHas(app);
                });
            }).then(function (apps) {
                return _this2.$filter('filter')(apps, _this2.searchText);
            }).then(function (apps) {
                _this2.filteredAppTypes = apps;
            });
        }
    }, {
        key: 'categoryHas',
        value: function categoryHas(app) {
            return this.category === allCategories || this.category.aTIds.includes(+app.id);
        }
    }, {
        key: 'handleSearchChange',
        value: function handleSearchChange() {
            this.protocol = allProtocols;
            this.category = allCategories;
            this.applyFilters();
        }
    }, {
        key: 'selectCategory',
        value: function selectCategory(category) {
            this.category = category;
            this.searchText = '';
            this.applyFilters();
        }
    }, {
        key: 'selectProtocol',
        value: function selectProtocol(protocol) {
            this.protocol = protocol;
            this.searchText = '';
            this.applyFilters();
        }
    }, {
        key: 'showAddApplicationModal',
        value: function showAddApplicationModal(app) {
            var _this3 = this;

            if (app.slug === 'office-365') {
                this.AddApplicationModal(app);
                return;
            }
            this.isLoading = true;
            this.AddNewApplicationResource.createSecureApp(this.companyId, app.id).then(function (app) {
                return _this3.state.go('company.manage-application', { appId: app.id });
            }).finally(function () {
                return _this3.isLoading = false;
            });
        }
    }, {
        key: 'checkIfAdd',
        value: function checkIfAdd(app) {
            var isSra = app.slug === 'saaspass-secure-remote-access';
            var isAdPasswordManager = app.slug === 'ad-password-manager';

            var isSraAllowed = this.appPermissions.sra;
            var isAdPasswordManagerAllowed = this.appPermissions.adPasswordManager;

            var allowAdd = !(isSra && !isSraAllowed || isAdPasswordManager && !isAdPasswordManagerAllowed);
            return allowAdd;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _applicationTypes = __webpack_require__(58);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AddNewApplicationResource'];

    /** @ngInject */
    function Controller($state, AddNewApplicationResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.applicationRequest = {
                applicationName: '',
                applicationRunningStatus: true,
                applicationType: (0, _applicationTypes.appTypeId)('enterprise-password-manager'),
                epmApplicationSettings: {
                    publicServiceId: this.publicService.id,
                    publicServiceLoginUrl: this.publicService.urlRequired ? '' : undefined,
                    canUserSetPassword: true,
                    canUserViewPassword: true
                },
                mobileApplicationEnabled: false,
                ssoEnabled: true
            };
        }
    }, {
        key: 'canUserSetPasswordChanged',
        value: function canUserSetPasswordChanged() {
            if (this.applicationRequest.epmApplicationSettings.canUserSetPassword) {
                this.applicationRequest.epmApplicationSettings.canUserViewPassword = true;
            }
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.AddNewApplicationResource.createNonDomainApp(this.companyId, { applicationRequest: this.applicationRequest }).then(function (app) {
                return _this.$state.go('company.manage-application', { appId: app.id });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTableCore = __webpack_require__(1670);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope'];

    /** @ngInject */
    function Controller($scope) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.searchText = '';
            this.initTable([]);
            this.loadItems();
        }
    }, {
        key: 'initTable',
        value: function initTable(items) {
            var _this = this;

            var data = items.filter(function (i) {
                return i.slug !== 'other';
            });
            this.custom = items.find(function (i) {
                return i.slug === 'other';
            });

            var st = this.st = {};

            st.table = (0, _smartTableCore.table)({ data: data });

            st.filter = (0, _smartTableCore.filter)({ table: st.table, pointer: 'serviceName' });
            st.slice = (0, _smartTableCore.slice)({ table: st.table });
            st.slice.selectPage(1);
            st.slice.changePageSize(10);

            st.table.onDisplayChange(function (items) {
                return _this.$scope.$apply(function () {
                    var _st$slice$state = st.slice.state(),
                        filteredCount = _st$slice$state.filteredCount,
                        size = _st$slice$state.size;

                    var values = items.map(function (i) {
                        return i.value;
                    });
                    _this.pageCount = Math.ceil(filteredCount / size);
                    _this.displayedItems = [_this.custom].concat(_toConsumableArray(values));
                });
            });
        }
    }, {
        key: 'loadItems',
        value: function loadItems() {
            var _this2 = this;

            this.publicServicesWithEPM$.get().then(function (items) {
                return _this2.initTable(items);
            });
        }
    }, {
        key: 'pageSize',
        get: function get() {
            return this.st.slice.state().size;
        },
        set: function set(value) {
            value && this.st.slice.changePageSize(value);
        }
    }, {
        key: 'selectedPage',
        get: function get() {
            return this.st.slice.state().page;
        },
        set: function set(value) {
            value && this.st.slice.selectPage(value);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.policyToDto = exports.policyFromDto = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _makeSelectables = __webpack_require__(136);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var dateFilter = angular.injector(['ng']).get('dateFilter');

var policyFromDto = exports.policyFromDto = function policyFromDto(policy, countries, browserTypes, osTypes) {
    var deviceAccessRuleDTO = policy.deviceAccessRuleDTO,
        locationAccessRuleDTO = policy.locationAccessRuleDTO,
        timezoneOffset = policy.timezoneOffset;


    var selectableCountries = countries.map(function (name) {
        return { id: name, name: name };
    });
    var trustedCountries = (0, _makeSelectables.makeSelectables)(locationAccessRuleDTO.trustedCountryNames, selectableCountries);
    var notTrustedCountries = (0, _makeSelectables.makeSelectables)(locationAccessRuleDTO.notTrustedCountryNames, selectableCountries);

    var selectableBrowsers = browserTypes.map(function (name) {
        return { id: name, name: name };
    });
    var browsers = (0, _makeSelectables.makeSelectables)(deviceAccessRuleDTO.browsers, selectableBrowsers);

    var selectableOSes = osTypes.map(function (name) {
        return { id: name, name: name };
    });
    var oses = (0, _makeSelectables.makeSelectables)(deviceAccessRuleDTO.allowedOperatingSystemList, selectableOSes);

    var hours = Math.floor(timezoneOffset / 60);
    var mins = timezoneOffset - hours * 60;
    var gmtOffset = { hours: hours, mins: mins };

    var hasTimeAccessRules = policy.timeAccessRules.length !== 0;

    var findRule = function findRule(dayOfWeek) {
        return policy.timeAccessRules.find(function (r) {
            return r.dayOfWeek === dayOfWeek;
        });
    };
    var newRule = function newRule(dayOfWeek) {
        return { isNew: true, startTime: '00:00', endTime: '23:59', dayOfWeek: dayOfWeek };
    };

    var timeAccessRules = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'].map(function (dayOfWeek) {
        return findRule(dayOfWeek) || newRule(dayOfWeek);
    }).map(function (rule) {
        return {
            isSelected: !rule.isNew,
            startTime: new Date('1970-01-01 ' + rule.startTime),
            endTime: new Date('1970-01-01 ' + rule.endTime),
            dayOfWeek: rule.dayOfWeek
        };
    });

    return {
        id: policy.id,
        policyName: policy.policyName,
        deviceAccessRuleDTO: _extends({}, deviceAccessRuleDTO),
        locationAccessRuleDTO: _extends({}, locationAccessRuleDTO),
        browsers: browsers,
        gmtOffset: gmtOffset,
        hasTimeAccessRules: hasTimeAccessRules,
        notTrustedCountries: notTrustedCountries,
        oses: oses,
        timeAccessRules: timeAccessRules,
        trustedCountries: trustedCountries
    };
};

var policyToDto = exports.policyToDto = function policyToDto(policy, countries, browserTypes, osTypes) {
    return {
        id: policy.id,
        policyName: policy.policyName,
        deviceAccessRuleDTO: _extends({}, policy.deviceAccessRuleDTO, {
            browsers: policy.browsers.isAllSelected() ? browserTypes : policy.browsers.getSelectedIds(),
            allowedOperatingSystemList: policy.oses.isAllSelected() ? osTypes : policy.oses.getSelectedIds()
        }),
        locationAccessRuleDTO: _extends({}, policy.locationAccessRuleDTO, {
            trustedCountryNames: policy.trustedCountries.isAllSelected() ? countries : policy.trustedCountries.getSelectedIds(),
            notTrustedCountryNames: policy.notTrustedCountries.isAllSelected() ? countries : policy.notTrustedCountries.getSelectedIds()
        }),
        timeAccessRules: policy.hasTimeAccessRules ? policy.timeAccessRules.filter(function (r) {
            return r.isSelected;
        }).map(function (r) {
            return {
                dayOfWeek: r.dayOfWeek,
                startTime: dateFilter(r.startTime, 'HH:mm'),
                endTime: dateFilter(r.endTime, 'HH:mm')
            };
        }) : [],
        timezoneOffset: policy.gmtOffset.hours * 60 + policy.gmtOffset.mins
    };
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'AuthenticationAccessPolicyResource', 'ConfirmModal'];

    /** @ngInject */
    function Controller($state, Alert, AuthenticationAccessPolicyResource, ConfirmModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
        this.ConfirmModal = ConfirmModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var updateOrder = function updateOrder(array, search) {
                var i = array.findIndex(function (o) {
                    return o.policyName === search;
                });
                if (i === 0) return;else return array.unshift(array.splice(i, 1)[0]);
            };
            updateOrder(this.policies, 'Default Policy');
        }
    }, {
        key: 'addPolicy',
        value: function addPolicy() {
            var _this = this;

            this.isAdding = true;
            this.AuthenticationAccessPolicyResource.createAuthenticationAccessPolicy(this.companyId).then(function (data) {
                _this.policies.push(data);_this.$state.go('company.policies.authentication-access-policies.edit', { policyId: data.id });
            }).then(function () {
                return _this.Alert('success', 'company.policies.authentication-access-policies.added');
            }).finally(function () {
                return _this.isAdding = false;
            });
        }
    }, {
        key: 'removePolicy',
        value: function removePolicy(policy) {
            var _this2 = this;

            this.isRemoving = policy;
            this.ConfirmModal().then(function () {
                return _this2.AuthenticationAccessPolicyResource.deleteAuthenticationAccessPolicy(_this2.companyId, policy.id);
            }).then(function () {
                return _this2.$state.reload('company.policies');
            }).then(function () {
                return _this2.Alert('success', 'company.policies.authentication-access-policies.removed');
            }).finally(function () {
                return _this2.isRemoving = null;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _AuthenticationAccessPolicyDTO = __webpack_require__(482);

var _timezones = __webpack_require__(342);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'AuthenticationAccessPolicyResource', 'ConfirmModal'];

    /** @ngInject */
    function Controller($state, Alert, AuthenticationAccessPolicyResource, ConfirmModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
        this.ConfirmModal = ConfirmModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$policy = (0, _AuthenticationAccessPolicyDTO.policyFromDto)(this.policy, this.countries, this.browserTypes, this.osTypes);
            this.timezones = _timezones.timezones;
            this.handleTimezoneModel = this.timezones.find(function (a) {
                return a.offsetHour === _this.$policy.gmtOffset.hours && a.offsetMin === _this.$policy.gmtOffset.mins;
            });
        }
    }, {
        key: 'isInvalid',
        value: function isInvalid() {
            return !this.$policy.browsers.getSelectedIds().length || !this.$policy.oses.getSelectedIds().length || this.form.$invalid;
        }
    }, {
        key: 'handleTimezoneSelect',
        value: function handleTimezoneSelect(timezone) {
            this.$policy.gmtOffset.hours = timezone.offsetHour * 1;
            this.$policy.gmtOffset.mins = timezone.offsetMin * 1;
        }
    }, {
        key: 'isLoading',
        value: function isLoading() {
            return this.isDeleting || this.isRestoring || this.isSaving;
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            var $policy = this.$policy,
                countries = this.countries,
                browserTypes = this.browserTypes,
                osTypes = this.osTypes;

            var _policy = this.policy,
                appliedApplications = _policy.appliedApplications,
                policy = _objectWithoutProperties(_policy, ['appliedApplications']);

            return angular.equals(policy, (0, _AuthenticationAccessPolicyDTO.policyToDto)($policy, countries, browserTypes, osTypes));
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this2 = this;

            this.isDeleting = true;
            this.ConfirmModal({
                messageKey: 'Do you want to delete this policy?',
                titleKey: 'Delete Policy',
                confirmButtonTextKey: 'Yes'
            }).then(function () {
                return _this2.AuthenticationAccessPolicyResource.deleteAuthenticationAccessPolicy(_this2.companyId, _this2.policy.id);
            }).then(function () {
                return _this2.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this2.Alert('success', 'company.policies.authentication-access-policies.removed');
            }).finally(function () {
                return _this2.isDeleting = false;
            });
        }
    }, {
        key: 'restore',
        value: function restore() {
            var _this3 = this;

            this.isRestoring = true;
            this.ConfirmModal({
                messageKey: 'Do you want to restore the policy settings to be the same as the Default Policy?',
                titleKey: 'Restore to default',
                confirmButtonTextKey: 'Yes'
            }).then(function () {
                return _this3.AuthenticationAccessPolicyResource.reset(_this3.companyId, _this3.policy.id);
            }).then(function () {
                return _this3.$state.reload('company.policies');
            }).then(function () {
                return _this3.Alert('success', 'company.policies.authentication-access-policies.restored');
            }).finally(function () {
                return _this3.isRestoring = false;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this4 = this;

            var $policy = this.$policy,
                countries = this.countries,
                browserTypes = this.browserTypes,
                osTypes = this.osTypes;

            var policy = (0, _AuthenticationAccessPolicyDTO.policyToDto)($policy, countries, browserTypes, osTypes);

            this.isSaving = true;
            this.AuthenticationAccessPolicyResource.updateAuthenticationAccessPolicy(this.companyId, policy).then(function () {
                return _this4.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this4.Alert('success', 'company.policies.authentication-access-policies.saved');
            }).finally(function () {
                return _this4.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.isLoading() || this.isInvalid() || this.notModified();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'AuthenticationAccessPolicyResource'];

    /** @ngInject */
    function Controller($state, Alert, AuthenticationAccessPolicyResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
    }

    _createClass(Controller, [{
        key: 'assign',
        value: function assign(app) {
            var _this = this;

            this.isSaving = app;
            this.AuthenticationAccessPolicyResource.applyPolicy(this.companyId, this.policy.id, app.id).then(function () {
                return _this.$state.reload('company.policies.authentication-access-policies');
            }).then(function () {
                return _this.Alert('success', 'company.policies.authentication-access-policies.manage.assigned');
            }).finally(function () {
                return _this.isSaving = null;
            });
        }
    }, {
        key: 'unassign',
        value: function unassign(app) {
            var _this2 = this;

            this.isSaving = app;
            this.AuthenticationAccessPolicyResource.applyPolicy(this.companyId, this.defaultPolicy.id, app.id).then(function () {
                return _this2.$state.reload('company.policies.authentication-access-policies');
            }).then(function () {
                return _this2.Alert('success', 'company.policies.authentication-access-policies.manage.unassigned');
            }).finally(function () {
                return _this2.isSaving = null;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Account', 'Alert', 'PasswordAuthenticationPoliciesService'];

    /** @ngInject */
    function Controller($state, $uibModal, Account, Alert, PasswordAuthenticationPoliciesService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.PasswordAuthenticationPoliciesService = PasswordAuthenticationPoliciesService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.companyId = this.$state.params.companyId;
        }
    }, {
        key: 'removePolicy',
        value: function removePolicy(applicationId) {
            var _this = this;

            this.PasswordAuthenticationPoliciesService.removePasswordPolicyFromApplication(this.companyId, this.policy.passwordPolicyId, applicationId).then(function () {
                return _this.$state.reload('company.policies.password-authentication-policy');
            }).then(function () {
                return _this.Alert('success', 'company.policies.authentication-access-policies.manage.unassigned');
            }).finally(function () {
                return _this.isSaving = null;
            });
        }
    }, {
        key: 'assignPolicytoApp',
        value: function assignPolicytoApp(applicationId) {
            var _this2 = this;

            this.PasswordAuthenticationPoliciesService.applyPasswordPolicyToApplication(this.companyId, this.policy.passwordPolicyId, applicationId).then(function () {
                return _this2.$state.reload('company.policies.password-authentication-policy');
            }).then(function () {
                return _this2.Alert('success', 'company.policies.authentication-access-policies.manage.assigned');
            }).finally(function () {
                return _this2.isSaving = null;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Account', 'Alert', 'PasswordAuthenticationPoliciesService', 'ConfirmModal'];

    /** @ngInject */
    function Controller($state, Account, Alert, PasswordAuthenticationPoliciesService, ConfirmModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Account = Account;
        this.Alert = Alert;
        this.PasswordAuthenticationPoliciesService = PasswordAuthenticationPoliciesService;
        this.ConfirmModal = ConfirmModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.companyId = this.$state.params.companyId;
            this.newPolicy = angular.copy(this.policy);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.policy, this.newPolicy);
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.notModified();
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.PasswordAuthenticationPoliciesService.editPasswordPolicyDetails(this.companyId, this.policy.id, this.newPolicy).then(function () {
                return _this.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this.Alert('success', 'company.policies.authentication-access-policies.saved');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'deletePolicyModal',
        value: function deletePolicyModal(policyId) {
            var _this2 = this;

            this.isRemoving = true;
            this.ConfirmModal({
                messageKey: 'Do you want to delete this policy?',
                titleKey: 'Delete Policy',
                confirmButtonTextKey: 'Yes'
            }).then(function () {
                return _this2.PasswordAuthenticationPoliciesService.deletePasswordPolicy(_this2.companyId, policyId);
            }).then(function () {
                return _this2.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this2.Alert('success', 'company.policies.authentication-access-policies.removed');
            }).finally(function () {
                return _this2.isRemoving = false;
            });
        }
    }, {
        key: 'resetPolicy',
        value: function resetPolicy(policyId) {
            var _this3 = this;

            this.isRestoring = true;
            this.ConfirmModal({
                messageKey: 'Do you want to restore the policy settings to be the same as the Default Policy?',
                titleKey: 'Restore to default',
                confirmButtonTextKey: 'Yes'
            }).then(function () {
                return _this3.PasswordAuthenticationPoliciesService.resetPasswordPolicy(_this3.companyId, policyId);
            }).then(function () {
                return _this3.$state.reload('company.policies');
            }).then(function () {
                return _this3.Alert('success', 'company.policies.authentication-access-policies.restored');
            }).finally(function () {
                return _this3.isRestoring = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Account', 'Alert', 'ApplicationsResource', 'PasswordAuthenticationPoliciesService', 'ConfirmModal'];

    /** @ngInject */
    function Controller($state, $uibModal, Account, Alert, ApplicationsResource, PasswordAuthenticationPoliciesService, ConfirmModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.PasswordAuthenticationPoliciesService = PasswordAuthenticationPoliciesService;
        this.ApplicationsResource = ApplicationsResource;
        this.ConfirmModal = ConfirmModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.companyId = this.$state.params.companyId;
            var updateOrder = function updateOrder(array, search) {
                var i = array.findIndex(function (o) {
                    return o.passwordPolicyName === search;
                });
                if (i === 0) return;else return array.unshift(array.splice(i, 1)[0]);
            };

            updateOrder(this.companyPasswordPolicies, 'Default Policy');
        }
    }, {
        key: 'editViewPolicy',
        value: function editViewPolicy(policyId) {
            var _this = this;

            this.$uibModal.open({
                component: 'passwordAuthenticationPoliciesViewEdit',
                resolve: { policy: function policy() {
                        return _this.PasswordAuthenticationPoliciesService.getPasswordPolicyDetails(_this.companyId, policyId);
                    } }
            }).result.then().finally(function () {
                return _this.isAdding = false;
            });
        }
    }, {
        key: 'assignApp',
        value: function assignApp(policy) {
            var _this2 = this;

            this.$uibModal.open({
                component: 'passwordAuthenticationPolicyAssignApplication',
                resolve: {
                    policy: policy,
                    policyDetails: function policyDetails() {
                        return _this2.PasswordAuthenticationPoliciesService.getPasswordPolicyDetails(_this2.companyId, policy.passwordPolicyId);
                    },
                    defaultPolicy: function defaultPolicy() {
                        return _this2.companyPasswordPolicies.filter(function (policy) {
                            return policy.passwordPolicyName === 'Default Policy';
                        })[0];
                    }
                }
            }).result.then();
        }
    }, {
        key: 'deletePolicyModal',
        value: function deletePolicyModal(policyId) {
            var _this3 = this;

            this.isRemoving = policyId;
            this.ConfirmModal({
                messageKey: 'Do you want to delete this policy?',
                titleKey: 'Delete Policy',
                confirmButtonTextKey: 'Yes'
            }).then(function () {
                return _this3.PasswordAuthenticationPoliciesService.deletePasswordPolicy(_this3.companyId, policyId);
            }).then(function () {
                return _this3.$state.reload('company.policies');
            }).then(function () {
                return _this3.Alert('success', 'company.policies.authentication-access-policies.removed');
            }).finally(function () {
                return _this3.isRemoving = null;
            });
        }
    }, {
        key: 'createnewPolicy',
        value: function createnewPolicy() {
            var _this4 = this;

            this.isAdding = true;
            this.PasswordAuthenticationPoliciesService.createNewPasswordPolicy(this.companyId)
            // .then(() => this.$state.reload('company.policies'))
            .then(function (data) {
                return _this4.$state.go('company.policies.password-authentication-policy.edit-policy', { policyId: data.id });
            }).then(function () {
                return _this4.Alert('success', 'company.policies.authentication-access-policies.added');
            }).finally(function () {
                return _this4.isAdding = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$scope", "$state", "$uibModal", "Account", "Alert", "CorporateSettingsService", "DestructiveOperationModal"];

    /** @ngInject */
    function Controller($scope, $state, $uibModal, Account, Alert, CorporateSettingsService, DestructiveOperationModal) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Account = Account;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            var companyId = this.companyId = this.$state.params.companyId;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
Controller.$inject = ['$scope', '$state', '$timeout', 'Alert', 'CompanyUser', 'CorporateSettingsService', 'UserAccounts'];
// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, $timeout, Alert, CompanyUser, CorporateSettingsService, UserAccounts) {
    $scope.unblockCompanyUser = unblockCompanyUser;

    function unblockCompanyUser(userAccount) {
        updateUser('unblock', 'groups_users.user_unblocked_success', userAccount.companyUser);
    }

    function updateUser(updateType, key, companyUser) {
        CompanyUser.updateCompanyUser({
            companyId: companyId,
            id: companyUser.id,
            updateAction: updateType
        }, companyUser, function () {
            CompanyUser.identifyCompanyUser({
                companyId: companyId,
                uid: companyUser.saaspassUser.saaspassId
            }, function (data) {
                $scope.companyUser = data;
                $scope.isBlocked = $scope.companyUser.blocked != 'NONE';
                //                $scope.onGroupClick($scope.selectedGroup);
                $state.reload($state.current);
                $timeout(1000).then(function () {
                    return Alert('success', key);
                });
            });
        }, function (response) {
            Alert('danger', response.data.message);
        });
    }

    $scope.showBlockedAccounts = function (data) {
        $scope.userAccounts = data;
        $scope.showingBlockedAccounts = true;
    };

    var accountsResource = UserAccounts.getBlockedUsers({
        companyId: $state.params.companyId
    });
    accountsResource.$promise.then(function (data) {
        $scope.blockedAccounts = data;
        var blockedAccountss = [];
        for (var i = 0; i < data.length; i++) {
            data[i]['companyUser']['saaspassUser']['saaspassId'];
            blockedAccountss.push(data[i]['companyUser']['saaspassUser']['saaspassId']);
        }
        var count = blockedAccountss.reduce(function (values, v) {
            if (!values.set[v]) {
                values.set[v] = 1;
                values.count++;
            }
            return values;
        }, { set: {}, count: 0 }).count;
        $scope.blockedAccountCount = count;
    });

    var companyId = $scope.companyId = $state.params.companyId;

    CorporateSettingsService.get(companyId).then(function (data) {
        $scope.settings = data;
        $scope.newSettings = angular.copy($scope.settings);
    });

    $scope.editRecoverySettings = editRecoverySettings;

    $scope.onGroupClick = function (group) {
        $scope.selectedFilter = 'ALL';
        $scope.displaySpinner = true;
        $scope.groupTable = true;
        $scope.activeDirectoryPage = false;
        $scope.pendingActiveDirectoryPage = false;
        $scope.showingBlockedAccounts = false;
        loadUserAccountsForGroup(group);
    };
    var loadUserAccountsForGroup = function loadUserAccountsForGroup(group) {
        UserAccounts.getAccountsForGroup({
            companyId: companyId,
            groupId: group.id
        }, function (data) {
            userAccounts = $scope.userAccounts = data;
            $scope.displaySpinner = false;
        });
        $scope.selectedGroup = group;
    };

    function editRecoverySettings() {
        CorporateSettingsService.save(companyId, $scope.newSettings).then(function () {
            $scope.settings = angular.copy($scope.newSettings);
            Alert('success', 'corporate.message.updated');
        });
    }
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spLoginPoint = __webpack_require__(133);

var _spLoginType = __webpack_require__(134);

var _spRoleType = __webpack_require__(57);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.roleType = _spRoleType.roleTypes[0];
            this.roleTypeChanged();

            this.datepickerOptions = { maxDate: new Date() };

            this.loginPoints = _spLoginPoint.loginPoints;

            this.loginTypes = _spLoginType.loginTypes;

            this.roleTypes = _spRoleType.roleTypes;

            var companyName = this.currentCompany.companyName;

            this.export = {
                template: 'administrators',
                get name() {
                    return companyName + '_SAASPASS_Statistics';
                },
                fields: ['saaspassId', 'displayName', 'userIdentifyingName', 'loginStatistic.loginType', 'loginStatistic.loginPoint', 'loginStatistic.loginIp', 'loginStatistic.sucessfulLogin', 'loggedInOnDisplay']
            };
        }
    }, {
        key: 'filterByDate',
        value: function filterByDate() {
            var _this = this;

            var endDate = new Date(+this.endDate + 24 * 60 * 60 * 1000);
            var afterStart = function afterStart(log) {
                return _this.startDate ? log.loggedInOn > _this.startDate : true;
            };
            var beforeEnd = function beforeEnd(log) {
                return _this.endDate ? log.loggedInOn < endDate : true;
            };
            this.filteredLogs = this.logs.filter(function (log) {
                return afterStart(log) && beforeEnd(log);
            });
        }
    }, {
        key: 'open',
        value: function open($event, type) {
            $event.preventDefault();
            $event.stopPropagation();
            if (type === 1) {
                this.opened = true;
                this.opened1 = false;
            } else {
                this.opened1 = true;
                this.opened = false;
            }
        }
    }, {
        key: 'getLoginSourceTooltip',
        value: function getLoginSourceTooltip(log) {
            var loginClient = log.loginClient,
                loginClientOs = log.loginClientOs,
                loginIp = log.loginIp;

            return [loginClient, loginClientOs, loginIp && 'IP: ' + loginIp].filter(function ($) {
                return $;
            }).join(' - ');
        }
    }, {
        key: 'getLoginToTooltip',
        value: function getLoginToTooltip(log) {
            var loginService = log.loginService,
                appType = log.appType,
                username = log.username;

            return [loginService, appType, username].filter(function ($) {
                return $;
            }).join(' - ');
        }
    }, {
        key: 'loginPointLabel',
        value: function loginPointLabel(loginPoint) {
            return (0, _spLoginPoint.loginPointLabel)(loginPoint);
        }
    }, {
        key: 'loginTypeLabel',
        value: function loginTypeLabel(loginType) {
            return (0, _spLoginType.loginTypeLabel)(loginType);
        }
    }, {
        key: 'roleTypeChanged',
        value: function roleTypeChanged() {
            var _this2 = this;

            this.logs$[this.roleType].get().then(function (logs) {
                _this2.logs = logs;
                _this2.filterByDate();
                var format = function format(date) {
                    return new Date(date).toString().slice(4, 24);
                };
                _this2.logs.forEach(function (log) {
                    return log.loggedInOnDisplay = format(log.loggedInOn);
                });
            });
        }
    }, {
        key: 'roleTypeLabel',
        value: function roleTypeLabel(roleType) {
            return roleType ? (0, _spRoleType.roleTypeLabel)(roleType) : 'global.filter.all';
        }
    }]);

    return Controller;
}();

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _spLoginPoint = __webpack_require__(133);

var _spLoginType = __webpack_require__(134);

Controller.$inject = ['$scope', '$state', 'CompanyLoginReportService', '$filter', '$translate', 'CompanyUser']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, CompanyLoginReportService, $filter, $translate, CompanyUser) {
    this.loginTypeLabel = _spLoginType.loginTypeLabel;
    this.loginPointLabel = _spLoginPoint.loginPointLabel;
    var self = this;

    $scope.displaySpinner = true;
    $scope.queryAppTypes = "";
    $scope.displayedItems = [];
    $scope.hstep = 1;
    $scope.mstep = 1;
    $scope.loginTypesTranslated = [];
    self.singleSaaspassId = null;
    $scope.noAppSelected = null;
    $scope.boolFlag = { successLogin: true, failLogin: true };
    $scope.timeZoneOfUser = Intl.DateTimeFormat().resolvedOptions().timeZone;

    var companyId = $state.params.companyId;
    CompanyLoginReportService.companyLoginReport.initialReport({ companyId: companyId }, { timeZone: $scope.timeZoneOfUser }).$promise.then(function (data) {
        $scope.displaySpinner = false;
        $scope.reportData = data.reportData;
        for (var i = 0; i < $scope.reportData.length; i++) {
            $scope.reportData[i].loggedInOn = new Date($scope.reportData[i].loggedInOn).toString().slice(4, 24);
        }
        $scope.filterData = data.filterData;
        $scope.filterData.applicationTypes = [];
        $scope.filterData.loginTypes = [];
        $scope.filterData.saaspassIDs = [];
        $scope.companyApplications = data.companyApplications;
        $scope.applicationTypes = data.applicationTypes;
        $scope.loginTypes = data.loginTypes;
        self.startDate = $scope.filterData.startDate;
        self.endDate = $scope.filterData.endDate;
        self.startTime = $filter('date')(self.startDate, "HH:mm:ss");
        self.endTime = $filter('date')(self.endDate, "HH:mm:ss");

        $scope.convertedDateTimeFrom = new Date($scope.filterData.startDate).toString();
        $scope.convertedDateTimeTo = new Date($scope.filterData.endDate).toString();
        $scope.datepickerOptions = { maxDate: new Date($scope.filterData.endDate), minDate: new Date(data.minDate) };
    }, function (error) {
        $scope.displaySpinner = false;
    });
    $scope.thumbnailUrl = function (appType) {
        var appTypeIndex = $scope.applicationTypes.findIndex(function (obj) {
            return obj.applicationTypeName == appType;
        });
        var slug = $scope.applicationTypes[appTypeIndex].slug;
        return 'https://cdn.saaspass.com/apps/' + slug + '/images/thumb.png';
    };

    $scope.changeSelection = function (member) {
        var index = $scope.filterData.applicationTypes.indexOf(member);
        if (index == -1) {
            $scope.filterData.applicationTypes.push(member);
        } else {
            $scope.filterData.applicationTypes.splice(index, 1);
        }
    };
    $scope.clearOldMessage = function () {
        $scope.message = null;
    };
    $scope.identifySaaspassUser = function () {
        $scope.message = null;
        CompanyUser.identifyCompanyUser({
            companyId: companyId,
            uid: encodeURIComponent(self.singleSaaspassId)
        }, function (data) {
            var member = data.saaspassUser.saaspassId;
            var index = $scope.filterData.saaspassIDs.indexOf(member);
            if (index == -1) {
                $scope.filterData.saaspassIDs.push(member);
            }
        }, function (error) {

            if (error.status == 404) {
                $scope.message = $translate.instant('report_section.main.filters.search_saaspass_fail');
            } else {
                $scope.message = error.data.message;
            }
        });
        self.singleSaaspassId = null;
    };

    $scope.convertTZ = function (date) {
        var currentLang = $translate.proposedLanguage() || $translate.use();
        return new Date(date).toLocaleString(currentLang, { timeZone: $scope.timeZoneOfUser });
    };
    $scope.getData = function (dData) {
        return new Date(dData);
    };
    $scope.clearSaaspassList = function () {
        $scope.filterData.saaspassIDs = [];
    };
    $scope.clearAppTypesSelection = function () {
        $scope.filterData.applicationTypes = [];
    };
    $scope.clearLoginTypesSelection = function () {
        $scope.filterData.loginTypes = [];
        $scope.loginTypesTranslated = [];
    };
    $scope.changeStatusFilter = function (newValue, isSuccessFlag) {
        if (isSuccessFlag) $scope.boolFlag.successLogin = newValue;else $scope.boolFlag.failLogin = newValue;
        if ($scope.boolFlag.successLogin) {
            if ($scope.boolFlag.failLogin) {
                $scope.filterData.status = null;
            } else {
                $scope.filterData.status = true;
            }
        } else {
            if ($scope.boolFlag.failLogin) {
                $scope.filterData.status = false;
            } else {
                $scope.filterData.status = null;
            }
        }
    };

    $scope.changeSelectionLoginType = function (member) {
        var translatedMember = $translate.instant((0, _spLoginType.loginTypeLabel)(member));
        var index = $scope.filterData.loginTypes.indexOf(member);
        if (index == -1) {
            $scope.filterData.loginTypes.push(member);
            $scope.loginTypesTranslated.push(translatedMember);
        } else {
            $scope.filterData.loginTypes.splice(index, 1);
            $scope.loginTypesTranslated.splice(index, 1);
        }
    };
    $scope.close = function ($event) {
        self.opened = false;
        self.opened1 = false;
    };
    $scope.open = function ($event, type) {
        $event.preventDefault();
        $event.stopPropagation();
        self.opened1 = false;
        self.opened = false;
        if (type == 1) {
            self.opened = true;
            self.opened1 = false;
        } else {
            self.opened1 = true;
            self.opened = false;
        }
    };
    $scope.applyFilter = function () {
        $scope.displaySpinner = true;
        CompanyLoginReportService.companyLoginReportFilter.doFilter({ companyId: companyId }, $scope.filterData).$promise.then(function (data) {
            $scope.displaySpinner = false;
            $scope.reportData = data;
            for (var i = 0; i < $scope.reportData.length; i++) {
                $scope.reportData[i].loggedInOn = new Date($scope.reportData[i].loggedInOn).toString().slice(4, 24);
            }
            $scope.displayedItems = data;
        }, function (error) {
            $scope.displaySpinner = false;
        });
    };
    $scope.changeDateTime = function () {
        var sDate = new Date($filter('date')(self.startDate, "yyyy-MM-dd") + ' ' + self.startTime);
        var eDate = new Date($filter('date')(self.endDate, "yyyy-MM-dd") + ' ' + self.endTime);
        $scope.filterData.startDate = sDate.getTime();
        $scope.filterData.endDate = eDate.getTime();
        $scope.convertedDateTimeFrom = sDate.toString();
        $scope.convertedDateTimeTo = eDate.toString();
    };

    $scope.export = {
        template: 'companystatistics',
        name: 'SAASPASS_Statistics',
        fields: ['username', 'saaspassId', 'displayName', 'loginType', 'loginIp', 'loginPoint', 'loginService', 'sucessfulLogin', 'loggedInOn']
    };
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["ComputersReportService"];

    /** @ngInject */
    function Controller(ComputersReportService) {
        _classCallCheck(this, Controller);

        this.ComputersReportService = ComputersReportService;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "selectedItemChanged",
        value: function selectedItemChanged() {
            var _this = this;

            this.ComputersReportService.computersReport.getComputersReport({ companyId: this.companyId, appId: this.application.id }).$promise.then(function (computers) {
                return _this.computers = computers;
            });
        }
    }, {
        key: "formatDate",
        value: function formatDate(date) {
            return new Date(date).toString().slice(4, 24);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _spSessionRecordingType = __webpack_require__(330);

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Controller.$inject = ['$scope', '$state', 'SessionRecordingReportService', '$filter', '$translate', 'CompanyUser', 'Alert']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, SessionRecordingReportService, $filter, $translate, CompanyUser, Alert) {
    var _this = this;

    this.sessionRecordingTypeLabel = _spSessionRecordingType.sessionRecordingTypeLabel;
    this.Alert = Alert;
    var self = this;

    $scope.displaySpinner = true;
    $scope.displayedItems = [];
    $scope.hstep = 1;
    $scope.mstep = 1;
    $scope.recordingTypesTranslated = [];
    self.singleSaaspassId = null;
    $scope.noAppSelected = null;
    $scope.boolFlag = { successLogin: true, failLogin: true };
    $scope.timeZoneOfUser = Intl.DateTimeFormat().resolvedOptions().timeZone;

    var companyId = $state.params.companyId;
    SessionRecordingReportService.sessionRecordingReport.initialReport({ companyId: companyId }, { timeZone: $scope.timeZoneOfUser }).$promise.then(function (data) {
        $scope.displaySpinner = false;
        $scope.reportData = data.reportData;
        for (var i = 0; i < $scope.reportData.length; i++) {
            $scope.reportData[i].sessionTime = new Date($scope.reportData[i].sessionTime).toString().slice(4, 24);
        }
        $scope.filterData = data.filterData;
        $scope.filterData.recordingTypes = [];
        $scope.filterData.saaspassIDs = [];
        $scope.companyApplications = data.companyApplications;
        $scope.applicationTypes = data.applicationTypes;
        $scope.recordingTypes = data.recordingTypes;

        self.startDate = $scope.filterData.startDate;
        self.endDate = $scope.filterData.endDate;
        self.startTime = $filter('date')(self.startDate, "HH:mm:ss");
        self.endTime = $filter('date')(self.endDate, "HH:mm:ss");

        $scope.convertedDateTimeFrom = new Date($scope.filterData.startDate).toString();
        $scope.convertedDateTimeTo = new Date($scope.filterData.endDate).toString();

        $scope.datepickerOptions = { maxDate: new Date($scope.filterData.endDate), minDate: new Date(data.minDate) };
    }, function (error) {
        $scope.displaySpinner = false;
    });

    new _clipboard2.default(".copyCli").on('success', function () {
        $scope.$apply(function () {
            _this.Alert('success', 'global.data_copied');
        });
    });

    $scope.thumbnailUrl = function (appType) {
        var appTypeIndex = $scope.applicationTypes.findIndex(function (obj) {
            return obj.applicationTypeName == appType;
        });
        var slug = $scope.applicationTypes[appTypeIndex].slug;
        return 'https://cdn.saaspass.com/apps/' + slug + '/images/thumb.png';
    };

    $scope.clearOldMessage = function () {
        $scope.message = null;
    };
    $scope.identifySaaspassUser = function () {
        $scope.message = null;
        CompanyUser.identifyCompanyUser({
            companyId: companyId,
            uid: encodeURIComponent(self.singleSaaspassId)
        }, function (data) {
            var member = data.saaspassUser.saaspassId;
            var index = $scope.filterData.saaspassIDs.indexOf(member);
            if (index == -1) {
                $scope.filterData.saaspassIDs.push(member);
            }
        }, function (error) {

            if (error.status == 404) {
                $scope.message = $translate.instant('report_section.main.filters.search_saaspass_fail');
            } else {
                $scope.message = error.data.message;
            }
        });
        self.singleSaaspassId = null;
    };
    $scope.clearSaaspassList = function () {
        $scope.filterData.saaspassIDs = [];
    };
    $scope.clearRecordingTypesSelection = function () {
        $scope.filterData.recordingTypes = [];
        $scope.recordingTypesTranslated = [];
    };
    $scope.changeStatusFilter = function (newValue, isSuccessFlag) {
        if (isSuccessFlag) $scope.boolFlag.successLogin = newValue;else $scope.boolFlag.failLogin = newValue;
        if ($scope.boolFlag.successLogin) {
            if ($scope.boolFlag.failLogin) {
                $scope.filterData.status = null;
            } else {
                $scope.filterData.status = true;
            }
        } else {
            if ($scope.boolFlag.failLogin) {
                $scope.filterData.status = false;
            } else {
                $scope.filterData.status = null;
            }
        }
    };

    $scope.changeSelectionRecordingType = function (member) {
        var translatedMember = $translate.instant((0, _spSessionRecordingType.sessionRecordingTypeLabel)(member));
        var index = $scope.filterData.recordingTypes.indexOf(member);
        if (index == -1) {
            $scope.filterData.recordingTypes.push(member);
            $scope.recordingTypesTranslated.push(translatedMember);
        } else {
            $scope.filterData.recordingTypes.splice(index, 1);
            $scope.recordingTypesTranslated.splice(index, 1);
        }
    };

    $scope.close = function ($event) {
        self.opened = false;
        self.opened1 = false;
    };
    $scope.open = function ($event, type) {
        $event.preventDefault();
        $event.stopPropagation();
        self.opened1 = false;
        self.opened = false;
        if (type == 1) {
            self.opened = true;
            self.opened1 = false;
        } else {
            self.opened1 = true;
            self.opened = false;
        }
    };
    $scope.applyFilter = function () {
        $scope.displaySpinner = true;
        SessionRecordingReportService.sessionRecordingReportFilter.doFilter({ companyId: companyId }, $scope.filterData).$promise.then(function (data) {
            $scope.displaySpinner = false;
            $scope.reportData = data;
            for (var i = 0; i < $scope.reportData.length; i++) {
                $scope.reportData[i].sessionTime = new Date($scope.reportData[i].sessionTime).toString().slice(4, 24);
            }
            $scope.displayedItems = data;
        }, function (error) {
            $scope.displaySpinner = false;
        });
    };
    $scope.changeDateTime = function () {
        var sDate = new Date($filter('date')(self.startDate, "yyyy-MM-dd") + ' ' + self.startTime);
        var eDate = new Date($filter('date')(self.endDate, "yyyy-MM-dd") + ' ' + self.endTime);
        $scope.filterData.startDate = sDate.getTime();
        $scope.filterData.endDate = eDate.getTime();
        $scope.convertedDateTimeFrom = sDate.toString();
        $scope.convertedDateTimeTo = eDate.toString();
    };

    $scope.export = {
        template: 'sessionRecordingReport',
        name: 'SAASPASS_Statistics',
        fields: ['username', 'computerName', 'saaspassId', 'applicationName', 'recordingType', 'sessionIp', 'sessionTime']
    };
}

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$scope', 'Alert'];

    /** @ngInject */
    function Controller($state, $scope, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$scope = $scope;
        this.Alert = Alert;
        this.st = new _smartTable.SmartTable();
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$state', '$filter'];

	/** @ngInject */
	function Controller($state, $filter) {
		_classCallCheck(this, Controller);

		this.$state = $state;
		this.$filter = $filter;
		this.st = new _smartTable.SmartTable();
		this.st.displayedItems = this.sharedAccounts;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			var companyName = this.currentCompany.companyName;

			this.export = {
				template: 'sharedloginitem',
				get name() {
					return companyName + '_SAASPASS_SharedLoginItem';
				},
				fields: ['saaspassId', 'displayName', 'serviceName', 'customServiceName', 'enabled2fa', 'username', 'corporateServiceAccountId']
			};
		}
	}, {
		key: 'showAccountData',
		value: function showAccountData(key) {
			if (key == 0) return true;
			return this.st.displayedItems[key - 1].corporateServiceAccountId != this.st.displayedItems[key].corporateServiceAccountId;
		}
	}, {
		key: 'showAccountDataClass',
		value: function showAccountDataClass(key) {

			if (key > 0 && this.st.displayedItems[key - 1].corporateServiceAccountId != this.st.displayedItems[key].corporateServiceAccountId) {
				return 'sp_topBorderStyle';
			} else {
				return 'sp_noTopBorder';
			}
		}
	}]);

	return Controller;
}();

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["ResellerCompanyResource", "$state", "Account"];

    /** @ngInject */

    function Controller(ResellerCompanyResource, $state, Account) {
        _classCallCheck(this, Controller);

        this.ResellerCompanyResource = ResellerCompanyResource;
        this.$state = $state;
        this.Account = Account;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            this.companyname = "";
            this.domain = "";
            this.isSaving = false;
        }
    }, {
        key: "save",
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.ResellerCompanyResource.manageAnotherCompany(this.companyId, this.companyname, this.domain).then(function (data) {
                return _this.Account.reload().then(function () {
                    _this.$state.go('company.reseller.new-company', { createdCompany: data });
                });
            }).finally(function () {
                _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.$state.companyId = this.companyId;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** @ngInject */
var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'ResellerCompanyResource', 'Alert'];

    /** @ngInject */
    function Controller($state, ResellerCompanyResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.ResellerCompanyResource = ResellerCompanyResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!this.createdCompany) {
                this.$state.go('^', {}, { location: 'replace' });
            }
            var companyId = this.companyId;
            this.stAdministrators = new _smartTable.SmartTable();
            this.saaspassId = this.account.login;
            var filteredAdmins = this.administrators.filter(function (o) {
                return o.saaspassId !== _this.saaspassId;
            });
            this.filteredAdmins = filteredAdmins;
        }
    }, {
        key: 'gotoNewCompany',
        value: function gotoNewCompany() {
            this.$state.go('company.landing-page', { companyId: this.createdCompany.companyId });
        }
    }, {
        key: 'addAdministrators',
        value: function addAdministrators(administrators) {
            var _this2 = this;

            this.ResellerCompanyResource.addAdministrators(this.companyId, this.createdCompany.companyId, administrators).then(function (data) {
                _this2.$state.go('company.reseller.list');
                _this2.Alert('success', 'company.reseller.new-company.add-administrators-success');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** @ngInject */
var Controller = exports.Controller = function () {
    Controller.$inject = ["$scope", "$state"];

    /** @ngInject */
    function Controller($scope, $state) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            var companyId = this.companyId;
            this.administrators = this.administrators;
            this.company = this.companyDetails;
            this.companyDomains = this.companyDetails.domains;
            this.companyAdmins = this.companyDetails.administrators;
            this.companyUsers = this.companyDetails.numberOfSaaspassUsers;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spRoleType = __webpack_require__(57);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);

        this.roleTypeLabel = (0, _spRoleType.roleTypeLabel)();
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            this.accountRole = (0, _spRoleType.roleTypeLabel)(this.currentCompany.authoritiesConstants);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'SaaspassConnectService', 'Alert'];

    /** @ngInject */
    function Controller($state, SaaspassConnectService, Alert) {
        _classCallCheck(this, Controller);

        this.SaaspassConnectService = SaaspassConnectService;
        this.Alert = Alert;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.connectApplication = {};
            this.connectApplication.id = null;
            this.connectApplication.oauthClientDetails = {};
            this.connectApplication.oauthClientDetails.callUrl = null;
            this.connectApplication.ipAddressFilter = null;
            this.connectApplication.userProfileScopeRequested = false;
            this.connectApplication.userEmailScopeRequested = true;
            this.connectApplication.userPhoneScopeRequested = false;
            this.connectApplication.userAddressScopeRequested = false;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.SaaspassConnectService.save({ companyId: this.$state.params.companyId }, this.connectApplication).$promise.then(function (data) {
                _this.close();
                _this.$state.go('company.saaspass-connect.manage', { connectId: data.id }, { reload: 'company.saaspass-connect' });
                _this.Alert('success', 'saaspass_connect.create_success');
            }).catch(function (error) {
                return _this.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['SaaspassConnectService', 'Alert', '$state'];

    /** @ngInject */
    function Controller(SaaspassConnectService, Alert, $state) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$state = $state;
        this.SaaspassConnectService = SaaspassConnectService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.newAuthAccessSettings = angular.copy(this.authenticationAccessPolicyList);

            if (this.connectApplication.accessPolicy) {
                this.selectedPolicyId = this.connectApplication.accessPolicy.id;
            } else {
                this.selectedPolicyId = '-1';
            }
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.isSaving || this.notModified();
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return this.connectApplication.accessPolicy == null && this.selectedPolicyId == -1 || this.connectApplication.accessPolicy != null && this.connectApplication.accessPolicy.id === this.selectedPolicyId;
        }
    }, {
        key: 'saveAuthPolicy',
        value: function saveAuthPolicy() {
            var _this = this;

            this.isSaving = true;
            this.SaaspassConnectService.applyPolicy({
                companyId: this.companyId,
                id: this.connectApplication.id,
                policyId: this.selectedPolicyId
            }, {}).$promise.then(function () {
                _this.Alert('success', 'company.policies.settings_updated');
            }).then(function () {
                return _this.$state.reload('company.saaspass-connect.manage');
            }).finally(function () {
                _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
Controller.$inject = ["$scope", "Alert", "DestructiveOperationModal", "SaaspassConnectDevelopersService"];
// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/** @ngInject */
function Controller($scope, Alert, DestructiveOperationModal, SaaspassConnectDevelopersService) {
    var _this = this;

    this.$onInit = function () {
        var companyId = _this.companyId;
        var connectId = _this.connectId;
        $scope.saaspassConnectKey = null;
        $scope.saaspassConnectSecret = null;
        $scope.selection = 'integration';
        $scope.showCredentialsDP = function (applicationId) {
            $scope.appCredUrl = SaaspassConnectDevelopersService.saaspassConnectCredentialsUrl;
            $scope.appCredUrl = $scope.appCredUrl.replace(":companyId", companyId);
            $scope.appCredUrl = $scope.appCredUrl.replace(":connectId", connectId);
            $scope.showSaaspassConnectAppCredPanel = function (data) {
                $scope.selection = 'apikey';
                console.log(data);
                $scope.saaspassConnectKey = data.applicationKey;
                $scope.saaspassConnectSecret = data.applicationPassword;
                $scope.publicKey = data.saaspassConnectPublicKey;
            };
            DestructiveOperationModal({
                titleKey: 'company_application_overview.destructive_op.credentials_title',
                textKey: 'company_application_overview.destructive_op.credentials_message',
                http: { method: 'GET', url: $scope.appCredUrl }
            }).then(function (data) {
                $scope.showSaaspassConnectAppCredPanel(data);
            });
        };

        $scope.changeSecret = function () {
            SaaspassConnectDevelopersService.saaspassConnectCredentials.updateSaaspassConnect({
                companyId: companyId,
                connectId: connectId
            }, {}).$promise.then(function (data) {
                $scope.selection = 'apikey';
                console.log(data);
                $scope.saaspassConnectKey = data.applicationKey;
                $scope.saaspassConnectSecret = data.applicationPassword;
                Alert('success', 'saaspass_connect.update_credentials_success');
            });
        };

        $scope.saaspassConnectDevelopersIntegrationTemplateUrl = __webpack_require__(1773);
        $scope.imageDownloadUrl = function (density) {
            return __webpack_require__(1774)("./" + density + "/login_with-saaspass.png");
        };
    };
}

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2c772c98c572c5a7c8248b55e39a9b67.png";

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
Controller.$inject = ['$scope', '$state', '$uibModal', 'Alert', 'DestructiveOperationModal', 'PhotoUploadService', 'SaaspassConnectOverviewService'];
// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/** @ngInject */
function Controller($scope, $state, $uibModal, Alert, DestructiveOperationModal, PhotoUploadService, SaaspassConnectOverviewService) {
    var _this = this;

    this.$onInit = function () {
        var companyId = _this.companyId;
        var connectId = _this.connectId;

        $scope.basicProfileData = false;
        $scope.extendedProfileData = false;

        $scope.staticUrlPart = window.env.urls.minoIconUrl;
        $scope.photoFile = null;

        $scope.saveConnect = function () {

            SaaspassConnectOverviewService.saaspassConnect.updateSaaspassConnect({
                companyId: companyId,
                connectId: connectId
            }, $scope.connectApplication).$promise.then(function (data) {
                $state.reload('company.saaspass-connect');
                Alert('success', 'saaspass_connect.update_success');
            });
        };

        $scope.fileNameChanged = function (ele) {
            var photo = ele;
            if (photo.size > 1000000) {
                Alert('danger', 'Photo should be smaller than 1MB');
            } else {
                $scope.photoFile = photo;
            }
        };

        $scope.uploadFile = function () {
            var uploadUrl = "app/rest/admin/company/:companyId/saaspassconnects/:id/photo";
            uploadUrl = uploadUrl.replace(":companyId", companyId);
            uploadUrl = uploadUrl.replace(":id", $scope.connectApplication.id);
            PhotoUploadService.upload($scope.photoFile, $scope.connectApplication.id, uploadUrl, function (data) {
                $state.reload('company.saaspass-connect');
                Alert('success', 'saaspass_connect.updload_success');
            }, function (response) {
                $scope.photoFile = null;
                $('#photoUploadInput').val(null);
            });
        };

        var data = _this.connectApplication;
        $scope.connectApplication = data;
        $scope.connectApplication.userProfileScopeRequested = data.oauthClientDetails.oauthScopes.indexOf('profile') != -1;
        $scope.connectApplication.userEmailScopeRequested = true;
        $scope.connectApplication.userPhoneScopeRequested = data.oauthClientDetails.oauthScopes.indexOf('phone') != -1;
        $scope.connectApplication.userAddressScopeRequested = data.oauthClientDetails.oauthScopes.indexOf('address') != -1;

        $scope.showDeleteModal = function () {
            $uibModal.open({ component: 'confirmDeleteSaaspassConnect' }).result.then(function () {
                return $scope.preDeleteApplicationDO();
            });
        };
        function getDestructiveOpUrl() {
            return 'app/rest/admin/company/' + companyId + '/saaspassconnects/' + connectId + '/delete';
        }
        $scope.preDeleteApplicationDO = function () {
            DestructiveOperationModal({
                titleKey: 'saaspass_connect.destructive_op.delete_title',
                textKey: 'saaspass_connect.destructive_op.delete_text',
                http: { method: 'DELETE', url: getDestructiveOpUrl() }
            }).then(function () {
                $scope.saaspassConnectDeleted();
            });
        };
        $scope.saaspassConnectDeleted = function () {
            Alert('success', 'saaspass_connect.delete_success');
            $state.go('company.saaspass-connect', {}, { reload: 'company.saaspass-connect' });
        };

        $scope.addUpdateSaaspassConnectTemplateUrl = __webpack_require__(1786);
        $scope.saaspassConnectInformationTemplateUrl = __webpack_require__(1787);
    };
}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$uibModal', '$state', 'Alert', 'SaaspassConnectService'];

    /** @ngInject */
    function Controller($uibModal, $state, Alert, SaaspassConnectService) {
        _classCallCheck(this, Controller);

        // this.$uibModal = $uibModal;
        this.SaaspassConnectService = SaaspassConnectService;
        this.Alert = Alert;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'addNewSaaspassConnectApp',
        value: function addNewSaaspassConnectApp() {
            var _this = this;

            //this.$uibModal.open({component: 'addSaaspassConnect'});
            this.SaaspassConnectService.save({ companyId: this.$state.params.companyId }, null).$promise.then(function (data) {
                _this.$state.go('company.saaspass-connect.manage', { connectId: data.id }, { reload: 'company.saaspass-connect' });
                _this.Alert('success', 'saaspass_connect.create_success');
            }).catch(function (error) {
                return _this.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$state', 'Alert', 'SaaspassVpnService'];

    /** @ngInject */
    function Controller($scope, $state, Alert, SaaspassVpnService) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
        this.Alert = Alert;
        this.SaaspassVpnService = SaaspassVpnService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var companyId = this.companyId = this.$state.params.companyId;
            this.config = {};
            this.config.authType = 'SHA512';
            this.config.cipherType = 'AES-256-CBC';
            this.config.remotePort = '1194';
        }
    }, {
        key: 'clearNewSettings',
        value: function clearNewSettings() {
            this.newSettings = angular.copy(this.settings);
        }
    }, {
        key: 'generateOvpnConfig',
        value: function generateOvpnConfig() {
            var _this = this;

            console.log(this.config);
            this.loading = true;
            this.SaaspassVpnService.generateOvpnConfig(this.companyId, this.config).then(function (data) {
                var file = new Blob([data], {
                    type: 'application/zip'
                });
                // var file = window.URL.createObjectURL(blob);
                var fileURL = URL.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'OpenVPNConfig.zip';
                document.body.appendChild(a);
                a.click();
            }).finally(function () {
                return _this.loading = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'save',
        value: function save() {
            this.close({ $value: this.st.selectedIds });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$state', 'Alert', 'SharedAccountsService', 'CompanyUser'];

	/** @ngInject */
	function Controller($state, Alert, SharedAccountsService, CompanyUser) {
		_classCallCheck(this, Controller);

		this.$state = $state;
		this.Alert = Alert;
		this.SharedAccountsService = SharedAccountsService;
		this.CompanyUser = CompanyUser;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			if (this.selectedAccounts == null || this.selectedAccounts.length == 0) {
				this.close();
			}
			this.labels$.get().then(function (labels) {
				return _this.labels = labels;
			});
			this.isAuthenticator = this.$state.current.name == 'company.sharing-center.shared-authenticators.manage-bulk';
			this.st = new _smartTable.SmartTable();
			this.st.displayedItems = this.selectedAccounts;
			this.selectedLabels = [];
			this.selectedUnshareLabels = [];
			this.showPasswordEnabled = false;
			this.showOtpEnabled = false;
			this.showNoteEnabled = false;
			this.companyUsers = [];
			this.newUserIdentifier = null;
			this.userIdentifier = null;
		}
	}, {
		key: 'isCheckedLabel',
		value: function isCheckedLabel(label) {
			var indexOfLabel = this.selectedLabels.indexOf(label);
			return indexOfLabel >= 0;
		}
	}, {
		key: 'isCheckedUnshareLabel',
		value: function isCheckedUnshareLabel(label) {
			var indexOfLabel = this.selectedUnshareLabels.indexOf(label);
			return indexOfLabel >= 0;
		}
	}, {
		key: 'isCheckboxDisabled',
		value: function isCheckboxDisabled(label) {
			var isIt = label.name !== "ALL_USERS" && this.selectedLabels.length == 1 && this.selectedLabels[0].name === "ALL_USERS";
			var isLabelInUnshare = this.selectedUnshareLabels.length && (this.selectedUnshareLabels[0].name === "ALL_USERS" || this.selectedUnshareLabels.indexOf(label) >= 0);
			var isAllLabelBlocked = label.name === "ALL_USERS" && this.selectedUnshareLabels.length;
			return isIt || isLabelInUnshare || isAllLabelBlocked;
		}
	}, {
		key: 'isCheckboxUnshareDisabled',
		value: function isCheckboxUnshareDisabled(label) {
			var isIt = label.name !== "ALL_USERS" && this.selectedUnshareLabels.length == 1 && this.selectedUnshareLabels[0].name === "ALL_USERS";
			var isLabelInShare = this.selectedLabels.length && (this.selectedLabels[0].name === "ALL_USERS" || this.selectedLabels.indexOf(label) >= 0);
			var isAllLabelBlocked = label.name === "ALL_USERS" && this.selectedLabels.length;
			return isIt || isLabelInShare || isAllLabelBlocked;
		}
	}, {
		key: 'clickLabel',
		value: function clickLabel(label) {
			var indexOfLabel = this.selectedLabels.indexOf(label);
			if (indexOfLabel >= 0) {
				this.selectedLabels.splice(indexOfLabel, 1);
			} else {
				if (label.name === "ALL_USERS") {
					this.selectedLabels = [];
				}
				this.selectedLabels.push(label);
			}
		}
	}, {
		key: 'clickUnshareLabel',
		value: function clickUnshareLabel(label) {
			var indexOfLabel = this.selectedUnshareLabels.indexOf(label);
			if (indexOfLabel >= 0) {
				this.selectedUnshareLabels.splice(indexOfLabel, 1);
			} else {
				if (label.name === "ALL_USERS") {
					this.selectedUnshareLabels = [];
				}
				this.selectedUnshareLabels.push(label);
			}
		}
	}, {
		key: 'clearSearch',
		value: function clearSearch() {
			this.successResult = false;
			this.companyUser = null;
			this.newUserIdentifier = null;
			this.userIdentifier = null;
			this.showClear = false;
		}
	}, {
		key: 'identifyUser',
		value: function identifyUser() {
			var _this2 = this;

			this.successResult = false;
			this.companyUser = null;
			this.message = null;
			this.userIdentifier = this.newUserIdentifier;
			this.CompanyUser.identifyCompanyUser({
				companyId: this.companyId,
				uid: encodeURIComponent(this.userIdentifier)
			}).$promise.then(function (response) {
				_this2.companyUser = response;
				_this2.companyUser.selected = true;
				_this2.companyUsers.push(_this2.companyUser);
				_this2.message = 'groups_users.user_found';
				_this2.successResult = true;
			}).catch(function (error) {
				console.log(error);
				if (error.status == 404) {
					_this2.message = 'groups_users.user_not_found';
				} else {
					_this2.message = error.message;
				}
			}).finally(function () {
				_this2.showClear = true;
			});
		}
	}, {
		key: 'getSelectedSaaspassUsersIds',
		value: function getSelectedSaaspassUsersIds() {
			return this.companyUsers.filter(function (user) {
				return user.selected;
			}).map(function (user) {
				return user.saaspassUser.id;
			});
		}
	}, {
		key: 'checkboxChange',
		value: function checkboxChange(cUser) {
			var foundIndex = this.companyUsers.findIndex(function (x) {
				return x.id == cUser.id;
			});
			this.companyUsers[foundIndex].selected = !cUser.selected;
		}
	}, {
		key: 'save',
		value: function save() {
			var _this3 = this;

			var saaspassUsersIds = this.getSelectedSaaspassUsersIds();

			var selectedAccountsIds = this.selectedAccounts.map(function (item) {
				return item.id;
			});

			this.SharedAccountsService.updateAndShareServiceAccountsWithLabels({
				companyId: this.companyId,
				showPassword: this.showPasswordEnabled,
				showOtp: this.showOtpEnabled,
				showNote: this.showNoteEnabled

			}, { labels: this.selectedLabels, labelsToUnshare: this.selectedUnshareLabels, corporateServiceAccountIds: selectedAccountsIds, spUsersIds: saaspassUsersIds }).$promise.then(function () {
				_this3.close();
				_this3.Alert('success', 'company.sharing-center.shared-authenticators.bulk-manage.save-succes');
			}).catch(function (error) {
				console.log(error);
				//this.Alert('danger', error.message);
			});
		}
	}, {
		key: 'close',
		value: function close() {
			this.$state.go('^', {}, { reload: true });
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			this.$state.go('^');
		}
	}]);

	return Controller;
}();

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _passwordStrength = __webpack_require__(85);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'ImportSharedAuthenticatorsModal', 'ImportSharedPasswordsModal'];

    /** @ngInject */
    function Controller($state, ImportSharedAuthenticatorsModal, ImportSharedPasswordsModal) {
        _classCallCheck(this, Controller);

        this.ImportSharedAuthenticatorsModal = ImportSharedAuthenticatorsModal;
        this.ImportSharedPasswordsModal = ImportSharedPasswordsModal;
        this.$state = $state;
        this.stAdd2fa = new _smartTable.SmartTable();
        this.stWeaks = new _smartTable.SmartTable();
        this.stDuplicates = new _smartTable.SmartTable();
        // this.stWulnerables = new SmartTable();
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.add2faAccounts = this.accounts.filter(function (account) {
                return account.publicService.slug !== 'other' && !account.enabled2fa && account.publicService.support2fa;
            });
            this.weakAccounts = this.accounts.filter(function (account) {
                return (0, _passwordStrength.passwordGrade)(account.password) < 3;
            });
            this.authenticatorsCount = this.accounts.filter(function (account) {
                return account.enabled2fa;
            }).length;
            this.passwordManagersCount = this.accounts.length - this.authenticatorsCount;
            var passwords = this.accounts.filter(function (account) {
                return account.password && account.password.length > 0;
            }).map(function (item) {
                return item.password;
            });
            this.duplicateAccounts = this.accounts.filter(function (account) {
                return _this.getOccurrence(passwords, account.password) > 1;
            }).sort(function (a, b) {
                return a.password.localeCompare(b.password);
            });
        }
    }, {
        key: 'reload',
        value: function reload() {
            return this.$state.go('.', {}, { reload: '.' });
        }
    }, {
        key: 'showImportPasswordModal',
        value: function showImportPasswordModal() {
            var _this2 = this;

            return this.ImportSharedPasswordsModal().then(function () {
                return _this2.$state.go('company.sharing-center.shared-passwords');
            });
        }
    }, {
        key: 'showImportAuthenticatorModal',
        value: function showImportAuthenticatorModal() {
            var _this3 = this;

            return this.ImportSharedAuthenticatorsModal().then(function () {
                return _this3.$state.go('company.sharing-center.shared-authenticators');
            });
        }
    }, {
        key: 'getOccurrence',
        value: function getOccurrence(array, value) {
            return array.filter(function (v) {
                return v === value;
            }).length;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$state', 'CompanyUser', 'ConfirmDeleteModal', 'SharedAccountsService', 'Alert', 'ChooseSharedFolder', 'SharedFoldersResource'];

	/** @ngInject */
	function Controller($state, CompanyUser, ConfirmDeleteModal, SharedAccountsService, Alert, ChooseSharedFolder, SharedFoldersResource) {
		_classCallCheck(this, Controller);

		this.$state = $state;
		this.CompanyUser = CompanyUser;
		this.ConfirmDeleteModal = ConfirmDeleteModal;
		this.SharedAccountsService = SharedAccountsService;
		this.Alert = Alert;
		this.ChooseSharedFolder = ChooseSharedFolder;
		this.SharedFoldersResource = SharedFoldersResource;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.labels$.get().then(function (labels) {
				return _this.labels = labels;
			});
			this.selectedLabels = this.sharedLabels.filter(function (item) {
				return item.isShared;
			});

			this.$sharedLabels = JSON.parse(JSON.stringify(this.sharedLabels));
			this.newUserIdentifier = null;
			this.userIdentifier = null;
			this.st = new _smartTable.SmartTable();
			this.stLabels = new _smartTable.SmartTable();
			this.stFolders = new _smartTable.SmartTable();

			this.assignedFolders = this.assignedUnassignedFolders.assignedFolders;
			this.unassignedFolders = this.assignedUnassignedFolders.assignableFolders;
		}
	}, {
		key: 'identifyUser',
		value: function identifyUser() {
			var _this2 = this;

			this.message = null;
			this.userIdentifier = this.newUserIdentifier;

			this.CompanyUser.identifyCompanyUser({
				companyId: this.companyId,
				uid: encodeURIComponent(this.userIdentifier)
			}).$promise.then(function (response) {

				_this2.successResult = true;
				_this2.showVerification = false;
				_this2.companyUser = response;

				_this2.message = 'groups_users.user_found';
			}).catch(function (error) {
				_this2.successResult = false;
				_this2.companyUser = null;

				_this2.showVerification = _this2.enableVerification && !_this2.successResult && $rootScope.emailPattern.test(_this2.userIdentifier);

				if (error.status == 404) {
					_this2.message = 'groups_users.user_not_found';
				} else {
					_this2.message = response.data.message;
				}
			});
		}
	}, {
		key: 'getSharingTypeDisplayName',
		value: function getSharingTypeDisplayName(sharingType) {
			if (sharingType == 'INDIVIDUAL_AND_TEAM') {
				return 'INDIVIDUAL & TEAM';
			} else {
				return sharingType;
			}
		}
	}, {
		key: 'share',
		value: function share(saaspassId) {
			var _this3 = this;

			var param = {
				companyId: this.companyId,
				id: this.sharedAccountId,
				saaspassId: saaspassId
			};
			if (this.isNote) {
				this.SharedAccountsService.shareNoteWithSaaspassUser(param, {}).$promise.then(function (response) {
					_this3.successMessageAndReload('shared_accounts.messages.share_account');
				}).catch(function (error) {});
			} else {
				this.SharedAccountsService.shareCompanyServiceAccounts(param, {}).$promise.then(function (response) {
					_this3.successMessageAndReload('shared_accounts.messages.share_account');
				}).catch(function (error) {});
			}
		}
	}, {
		key: 'unshare',
		value: function unshare(saaspassId) {
			var _this4 = this;

			//this.type = 'SINGLE';
			this.saaspassId = saaspassId;
			this.ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete').then(function () {
				var param = {
					companyId: _this4.companyId,
					id: _this4.sharedAccountId,
					saaspassId: _this4.saaspassId
				};
				if (_this4.isNote) {
					_this4.SharedAccountsService.unshareUserNote(param, {}).$promise.then(function (response) {
						_this4.successMessageAndReload('shared_accounts.messages.unshare_account');
					}).catch(function (error) {});
				} else {
					_this4.SharedAccountsService.unshareCompanyServiceAccounts(param, {}).$promise.then(function (response) {
						_this4.successMessageAndReload('shared_accounts.messages.unshare_account');
					}).catch(function (error) {});
				}
			});
		}
	}, {
		key: 'cancelSearch',
		value: function cancelSearch() {
			this.userIdentifier = null;
			this.successResult = null;
			this.showVerification = false;
			this.companyUser = null;
			this.message = null;
			this.newUserIdentifier = null;
		}
	}, {
		key: 'clickLabel',
		value: function clickLabel(label) {
			if (label.name === "ALL_USERS") {
				this.sharedLabels.map(function (item) {
					if (item.name !== "ALL_USERS") {
						item.isShared = false;
					}
				});
			}
			this.selectedLabels = this.sharedLabels.filter(function (item) {
				return item.isShared;
			});
		}
	}, {
		key: 'isCheckboxDisabled',
		value: function isCheckboxDisabled(label) {
			var isIt = label.name !== "ALL_USERS" && this.selectedLabels.length == 1 && this.selectedLabels[0].name === "ALL_USERS";
			return isIt;
		}
	}, {
		key: 'sharedLabelsNotModified',
		value: function sharedLabelsNotModified() {
			return angular.equals(this.$sharedLabels, this.sharedLabels);
		}
	}, {
		key: 'shareWithLabels',
		value: function shareWithLabels() {
			var _this5 = this;

			var param = {
				companyId: this.companyId,
				id: this.sharedAccountId
			};
			if (this.isNote) {
				this.SharedAccountsService.updateCompanyNoteLabels(param, this.sharedLabels).$promise.then(function (response) {
					_this5.successMessageAndReload('shared_accounts.messages.share_account');
				}).catch(function (error) {});
			} else {
				this.SharedAccountsService.updateServiceAccountLabels(param, this.sharedLabels).$promise.then(function (response) {
					_this5.successMessageAndReload('shared_accounts.messages.share_account');
				}).catch(function (error) {});
			}
		}
	}, {
		key: 'addToAnotherFolder',
		value: function addToAnotherFolder() {
			var _this6 = this;

			this.ChooseSharedFolder(this.unassignedFolders).then(function (selectedIds) {
				_this6.SharedFoldersResource.addCorporateItemToSharedFolders(_this6.sharedAccountId, selectedIds, _this6.companyId, _this6.isNote).then(function () {
					_this6.successMessageAndReload('global.messages.operation-successful');
				});
			});
		}
	}, {
		key: 'removeFromSelectedFolders',
		value: function removeFromSelectedFolders() {
			var _this7 = this;

			this.ConfirmDeleteModal('company.sharing-center.shared-folders.remove-from-selected-folders.confirm').then(function () {
				_this7.SharedFoldersResource.removeCorporateItemFromSharedFolders(_this7.sharedAccountId, _this7.stFolders.selectedIds, _this7.companyId, _this7.isNote).then(function () {
					_this7.successMessageAndReload('global.messages.operation-successful');
				});
			});
		}
	}, {
		key: 'successMessageAndReload',
		value: function successMessageAndReload(key) {
			this.$state.go('.', {}, { reload: '.' });
			this.Alert('success', key);
		}
	}]);

	return Controller;
}();

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'ShareAnAdditionalEmailAccount', 'SharedEmailAccountModal'];

    /** @ngInject */
    function Controller($state, ShareAnAdditionalEmailAccount, SharedEmailAccountModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.ShareAnAdditionalEmailAccount = ShareAnAdditionalEmailAccount;
        this.SharedEmailAccountModal = SharedEmailAccountModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.userDirectoriesHref = this.$state.href('company.user-directories');
        }
    }, {
        key: 'showShareAnAdditionalEmailAccountModal',
        value: function showShareAnAdditionalEmailAccountModal() {
            this.ShareAnAdditionalEmailAccount();
        }
    }, {
        key: 'showSharedEmailAccountModal',
        value: function showSharedEmailAccountModal(account) {
            var _this = this;

            this.SharedEmailAccountModal(account.username).then(function () {
                return _this.$state.reload(_this.$state.current);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base32Helper = __webpack_require__(516);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'SharedAccountsService'];

    /** @ngInject */
    function Controller($state, Alert, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$state = $state;
        this.SharedAccountsService = SharedAccountsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.tooltipTemplate = __webpack_require__(107);
            this.simulatedHardtokenTemplate = __webpack_require__(1827);
            if (this.copyAccount != null) {
                this.account = this.copyAccount;
                this.resetHexSecret();
                this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
            } else {
                this.account = {
                    algorithm: 'SHA1',
                    digits: 6,
                    showOtpEnabled: true,
                    showPasswordEnabled: true,
                    showNoteEnabled: false
                };
            }
            this.publicServicesWithSsoAnd2FA$.get().then(function (items) {
                return _this.publicServices = items;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.isSaving = true;
            this.SharedAccountsService.createCompanyServiceAccounts({
                companyId: this.companyId,
                publicServiceId: this.account.publicService.id
            }, {
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: true,
                showOtpEnabled: this.account.showOtpEnabled,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: generatePublicServiceKey(this.account.publicService.serviceName, this.account.username, this.account.secret, this.account.digits, this.account.algorithm)
            }).$promise.then(function (account) {
                _this2.Alert('success', 'company.sharing-center.add.added');
                _this2.$state.go('company.sharing-center.shared-authenticators.manage.edit', { sharedAccountId: account.id }, { reload: 'company.sharing-center.shared-authenticators' });
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid || !this.account.publicService;
        }
    }, {
        key: 'selectCustom',
        value: function selectCustom() {
            this.searchItem = 'Custom';
            this.account.publicService = this.publicServices.find(function (i) {
                return i.slug === "other";
            });
        }
    }, {
        key: 'createSecret',
        value: function createSecret() {
            this.isSaving = true;
            this.showSecret = true;
            this.account.secret = (0, _base32Helper.generateRandomBase32)(32);
            this.resetHexSecret();
            this.isSaving = false;
        }
    }, {
        key: 'resetHexSecret',
        value: function resetHexSecret() {
            this.hexSecret = this.convertHex(this.account.secret);
        }
    }, {
        key: 'convertHex',
        value: function convertHex(value) {
            if (value == null || value.length == 0) return value;
            return (0, _base32Helper.base32tohex)(value);
        }
    }]);

    return Controller;
}();

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    var secret = secretKey.replace(/\s/g, '');
    return 'otpauth://totp/' + issuer + ':' + username + '?secret=' + secret + '&issuer=' + issuer + '&digits=' + digits + '&algorithm=' + algorithm;
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateRandomBase32 = generateRandomBase32;
exports.base32tohex = base32tohex;
var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

function getRandomIndex(max) {
  var number = Math.random() * max;
  return Math.floor(number);
}

function toRandomChar() {
  var index = getRandomIndex(chars.length);
  return chars.charAt(index);
}

function generateRandomBase32() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;

  var arr = Array(length).fill('');
  return arr.map(toRandomChar).join('');
};

function base32tohex(base32) {
  var bits = "";
  var hex = "";

  for (var i = 0; i < base32.length; i++) {
    var val = chars.indexOf(base32.charAt(i).toUpperCase());
    bits += leftpad(val.toString(2), 5, '0');
  }

  for (var i = 0; i + 4 <= bits.length; i += 4) {
    var chunk = bits.substr(i, 4);
    hex = hex + parseInt(chunk, 2).toString(16);
  }
  return hex.toUpperCase();
}

function leftpad(str, len, pad) {
  if (len + 1 >= str.length) {
    str = Array(len + 1 - str.length).join(pad) + str;
  }
  return str;
}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'SharedAccountsService'];

    /** @ngInject */
    function Controller($state, Alert, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _this = this;

            var companyId = this.companyId;
            this.isSaving = true;
            this.SharedAccountsService.deleteBulkCompanyServiceAccounts({ companyId: companyId }, this.st.selectedIds).$promise.then(function () {
                _this.Alert('success', 'company.user-directories.directory-groups.all-accounts.delete.deleted');
                _this.$state.go('^', { companyId: companyId }, { reload: true, inherit: false, notify: false });;
            }).catch(function (error) {}).finally(function () {
                _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _store = __webpack_require__(19);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'SharedAccountsService'];

    /** @ngInject */
    function Controller(Alert, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.showOtpEnabled = false;
            this.showPasswordEnabled = false;
            this.isSelectable = this.isSelectable.bind(this);
        }
    }, {
        key: 'ifSelectable',
        value: function ifSelectable(authenticator) {
            return this.isSelectable(authenticator) && authenticator;
        }
    }, {
        key: 'isSelectable',
        value: function isSelectable(authenticator) {
            //   const hasServiceUrl = !!(authenticator.publicService || {}).serviceUrl;
            //   const customUrlRequired = !!(authenticator.publicService || {}).urlRequired;
            //  const hasCustomUrl = !!(authenticator.customLoginUrl || {}).serviceLoginUrl;
            //  return hasServiceUrl && !customUrlRequired || hasCustomUrl;
            return true;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.SharedAccountsService.importCompanyServiceAccounts({
                companyId: _store.resolve.companyId,
                showOtp: this.showOtpEnabled,
                showPassword: this.showPasswordEnabled
            }, this.st.selectedIds).$promise.then(function (accounts) {
                _this.close({ $value: accounts });
                _this.Alert('success', 'company.sharing-center.import.imported');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _getUrlParam = __webpack_require__(202);

var _passwordStrength = __webpack_require__(85);

var _base32Helper = __webpack_require__(516);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$scope', 'Alert', 'ConfirmDeleteModal', 'SharedAccountsService', 'ConfirmConvertModal', 'ConfirmModal'];

    /** @ngInject */
    function Controller($state, $scope, Alert, ConfirmDeleteModal, SharedAccountsService, ConfirmConvertModal, ConfirmModal) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.ConfirmModal = ConfirmModal;
        this.SharedAccountsService = SharedAccountsService;
        this.$state = $state;
        this.$scope = $scope;
        this.ConfirmConvertModal = ConfirmConvertModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.tooltipTemplate = __webpack_require__(107);
            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });

            if (Object.keys(this.sharedAccount).length === 0) {
                this.$state.go('^');
            }
            var url = this.sharedAccount.publicServiceKey; //this.resolve.account.publicServiceKey;

            this.$account = _extends({}, this.sharedAccount, {
                digits: +(0, _getUrlParam.getUrlParam)(url, 'digits', 6),
                algorithm: (0, _getUrlParam.getUrlParam)(url, 'algorithm', 'SHA1'),
                secret: (0, _getUrlParam.getUrlParam)(url, 'secret')
            });

            this.account = _extends({}, this.$account);
            this.resetHexSecret();
            this.passGrade = (0, _passwordStrength.passwordGrade)(this.account.password);
            this.publicServicesWithSso$.get().then(function (items) {
                return _this.publicServices = items;
            });
            this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
            this.isCustom = this.$account.publicService.slug == 'other';
        }
    }, {
        key: 'saveIcon',
        value: function saveIcon(iconFile) {
            var _this2 = this;

            var formData = new FormData();
            formData.append('iconFile', iconFile);
            return this.SharedAccountsService.uploadCustomIconForCorporateServiceAccount({
                companyId: this.companyId, //resolve.companyId,
                corporateServiceAccountId: this.account.id
            }, formData).$promise.then(function (data) {
                _this2.account.customIcon = data.customIcon;
                _this2.Alert('success', 'company.sharing-center.manage.saved');
            });
        }
    }, {
        key: 'resetIcon',
        value: function resetIcon() {
            var _this3 = this;

            return this.ConfirmModal({
                messageKey: 'Custom icon will be deleted and default icon will be used. Do you want to continue?',
                titleKey: 'Confirm Delete'
            }).then(function () {
                return _this3.SharedAccountsService.deleteCustomIconForCorporateServiceAccount({
                    companyId: _this3.companyId, //resolve.companyId,
                    corporateServiceAccountId: _this3.account.id
                }).$promise.then(function () {
                    _this3.account.customIcon = null;
                    _this3.Alert('success', 'company.sharing-center.manage.saved');
                });
            });
        }
    }, {
        key: 'createCopy',
        value: function createCopy() {
            var url = this.sharedAccount.publicServiceKey;
            var copyAccount = {
                username: this.sharedAccount.username,
                password: this.sharedAccount.password,
                note: this.sharedAccount.note,
                showOtpEnabled: this.sharedAccount.showOtpEnabled,
                showPasswordEnabled: this.sharedAccount.showPasswordEnabled,
                showNoteEnabled: this.sharedAccount.showNoteEnabled,
                publicService: this.publicServices.find(function (i) {
                    return i.slug === "other";
                }),
                customServiceName: this.getCopyServiceName(),
                algorithm: (0, _getUrlParam.getUrlParam)(url, 'algorithm', 'SHA1'),
                digits: +(0, _getUrlParam.getUrlParam)(url, 'digits', 6),
                secret: (0, _getUrlParam.getUrlParam)(url, 'secret'),
                serviceLoginUrl: this.sharedAccount.publicService.slug === 'other' ? this.sharedAccount.serviceLoginUrl : this.sharedAccount.publicService.serviceUrl
            };
            this.$state.go("company.sharing-center.add-shared-authenticator", { copyAccount: copyAccount });
        }
    }, {
        key: 'getCopyServiceName',
        value: function getCopyServiceName() {
            var _this4 = this;

            var currentServiceName = this.sharedAccount.publicService.slug === 'other' ? this.sharedAccount.customServiceName : this.sharedAccount.publicService.serviceName;
            var customServiceNames = this.allAccounts.filter(function (account) {
                return account.username === _this4.sharedAccount.username && account.publicService.slug === 'other' && account.customServiceName != null;
            }).map(function (item) {
                return item.customServiceName;
            });
            currentServiceName = currentServiceName.indexOf(' Copy') !== -1 ? currentServiceName.substring(0, currentServiceName.indexOf(' Copy')) : currentServiceName;
            var copyServiceName = currentServiceName + ' Copy';
            if (customServiceNames.indexOf(copyServiceName) === -1) {
                return copyServiceName;
            }

            var i = 1;
            while (customServiceNames.indexOf(copyServiceName + ' ' + i) !== -1) {
                i++;
            }
            return copyServiceName + ' ' + i;
        }
    }, {
        key: 'changePassGrade',
        value: function changePassGrade() {
            this.passGrade = (0, _passwordStrength.passwordGrade)(this.account.password);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            if (this.$account.publicService.id === this.account.publicService.id) {
                this.account.publicService = this.$account.publicService;
            }
            return angular.equals(this.$account, this.account);
        }
    }, {
        key: 'selectCustom',
        value: function selectCustom() {
            this.searchItem = 'Custom';
            this.account.publicService = this.publicServices.find(function (i) {
                return i.slug === "other";
            });
        }
    }, {
        key: 'serviceSelected',
        value: function serviceSelected(service) {
            this.account.publicService = service;
            if (service.slug !== "other") {
                this.account.customServiceName = null;
            }
        }
    }, {
        key: 'resetHexSecret',
        value: function resetHexSecret() {
            this.hexSecret = this.convertHex(this.account.secret);
        }
    }, {
        key: 'convertHex',
        value: function convertHex(value) {
            if (value == null || value.length == 0) return value;
            return (0, _base32Helper.base32tohex)(value);
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this5 = this;

            this.isRemoving = true;
            this.ConfirmDeleteModal('groups_users.confirm_company_user_account_delete').then(function () {
                return _this5.SharedAccountsService.deleteCompanyServiceAccounts({
                    companyId: _this5.companyId, //resolve.companyId,
                    id: _this5.account.id
                }).$promise;
            }).then(function () {
                _this5.$state.go('^.^', {}, { reload: '^.^' });
                _this5.Alert('success', 'company.sharing-center.manage.removed');
            }).finally(function () {
                return _this5.isRemoving = false;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this6 = this;

            this.isSaving = true;
            this.SharedAccountsService.updateCompanyServiceAccounts({
                companyId: this.companyId, //resolve.companyId,
                publicServiceId: this.account.publicService.id
            }, {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: true,
                showOtpEnabled: this.account.showOtpEnabled,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: generatePublicServiceKey(this.account.publicService.serviceName, this.account.username, this.account.secret, this.account.digits, this.account.algorithm)
            }).$promise.then(function (account) {
                //this.close({$value: account});
                _this6.$state.go('^.^', {}, { reload: '^.^' });
                _this6.Alert('success', 'company.sharing-center.manage.saved');
            }).finally(function () {
                return _this6.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid || this.notModified();
        }
    }, {
        key: 'convertDisabled',
        value: function convertDisabled(form) {
            return this.isSaving || form.$invalid || this.isRemoving;
        }
    }, {
        key: 'convert',
        value: function convert() {
            var _this7 = this;

            this.isRemoving = true;
            this.ConfirmConvertModal('company.sharing-center.manage.convert-auth-to-pass').then(function () {
                return _this7.SharedAccountsService.convertCompanyServiceAccountToPass({
                    companyId: _this7.companyId, //resolve.companyId,
                    publicServiceId: _this7.account.publicService.id
                }, {
                    id: _this7.account.id,
                    username: _this7.account.username,
                    password: _this7.account.password,
                    serviceLoginUrl: _this7.account.serviceLoginUrl,
                    enabled2fa: false,
                    showOtpEnabled: false,
                    showPasswordEnabled: _this7.account.showPasswordEnabled,
                    showNoteEnabled: _this7.account.showNoteEnabled,
                    note: _this7.account.note,
                    customServiceName: _this7.account.customServiceName,
                    publicServiceKey: null
                }).$promise;
            }).then(function () {
                _this7.$state.go('company.sharing-center.shared-passwords');
                _this7.Alert('success', 'company.sharing-center.manage.saved');
            }).finally(function () {
                return _this7.isRemoving = false;
            });
        }
    }]);

    return Controller;
}();

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    var secret = secretKey.replace(/\s/g, '');
    return 'otpauth://totp/' + issuer + ':' + username + '?secret=' + secret + '&issuer=' + issuer + '&digits=' + digits + '&algorithm=' + algorithm;
}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$window', '$timeout', '$scope', 'Alert', 'AddNewSharedAuthenticatorModal', 'ImportSharedAuthenticatorsModal', 'ManageSharedAuthenticatorModal', 'SharedAccountsService'];

    /** @ngInject */
    function Controller($state, $window, $timeout, $scope, Alert, AddNewSharedAuthenticatorModal, ImportSharedAuthenticatorsModal, ManageSharedAuthenticatorModal, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.Alert = Alert;
        this.AddNewSharedAuthenticatorModal = AddNewSharedAuthenticatorModal;
        this.ImportSharedAuthenticatorsModal = ImportSharedAuthenticatorsModal;
        this.ManageSharedAuthenticatorModal = ManageSharedAuthenticatorModal;
        this.SharedAccountsService = SharedAccountsService;
        this.st = new _smartTable.SmartTable();
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'copyToClipboard',
        value: function copyToClipboard(value) {
            navigator.clipboard.writeText(value).then(this.Alert('success', 'global.data_copied'));
        }
    }, {
        key: 'reload',
        value: function reload() {
            return this.$state.reload(this.$state.current);
        }
    }, {
        key: 'export',
        value: function _export(accounts) {
            var _this = this;

            var accountIds = accounts.map(function (item) {
                return item.id;
            });
            var companyId = this.companyId;
            this.SharedAccountsService.exportCompanyServiceAccounts({ companyId: companyId }, accountIds).$promise.then(function (response) {
                var file = new Blob([response.data], {
                    type: 'text/plain'
                });
                var windowUrl = _this.$window.URL;
                var fileURL = windowUrl.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'exported_authenticators_' + new Date().valueOf() + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function () {
                    windowUrl.revokeObjectURL(fileURL);
                }, 100);
                _this.Alert('success', 'company.sharing-center.shared-accounts.export-succes');
            }).catch(function (error) {
                _this.Alert('danger', error.message);
            });
        }
    }, {
        key: 'getOtp',
        value: function getOtp(p) {
            var _this2 = this;

            var param = {
                companyId: this.companyId,
                id: p.id
            };
            return this.SharedAccountsService.getOtp(param).$promise.then(function (data) {
                p.otp = data.otp;
            }).then(function () {
                return _this2.$timeout(30000);
            }).then(function () {
                return p.mustRenewOtp = true;
            });
        }
    }, {
        key: 'renewOTP',
        value: function renewOTP(p) {
            var _this3 = this;

            var param = {
                companyId: this.companyId,
                id: p.id
            };
            return this.SharedAccountsService.getOtp(param).$promise.then(function (data) {
                p.otp = data.otp;
            }).then(function () {
                return p.mustRenewOtp = false;
            }).then(function () {
                return _this3.$timeout(30000);
            }).then(function () {
                return p.mustRenewOtp = true;
            });
        }
    }, {
        key: 'showAddModal',
        value: function showAddModal() {
            /* this.publicServicesWithSsoAnd2FA$.get()
                 .then(items => this.AddNewSharedAuthenticatorModal(items))
                 .then(() => this.reload())*/

            this.$state.go('company.sharing-center.add-shared-authenticator');
        }
    }, {
        key: 'showImportModal',
        value: function showImportModal() {
            var _this4 = this;

            return this.ImportSharedAuthenticatorsModal().then(function () {
                return _this4.reload();
            });
        }
    }, {
        key: 'showManageModal',
        value: function showManageModal(account) {
            var _this5 = this;

            return this.ManageSharedAuthenticatorModal(account).then(function () {
                return _this5.reload();
            });
        }
    }, {
        key: 'showShareModal',
        value: function showShareModal(account) {
            this.$state.go('company.sharing-center.shared-authenticators.manage.share', { sharedAccount: account, sharedAccountId: account.id });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _smartTable = __webpack_require__(2);

var _spAlert = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

Controller.$inject = ['$rootScope', '$scope', '$state', '$translate', 'AccountsResource', 'Alert', 'CompanyUser', 'ConfirmDeleteModal', 'Groups', 'GroupsResource', 'UserAccounts']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($rootScope, $scope, $state, $translate, AccountsResource, Alert, CompanyUser, ConfirmDeleteModal, Groups, GroupsResource, UserAccounts) {
    var _this = this;

    this.$onInit = function () {
        var companyId = $state.params.companyId;
        $scope.companyId = companyId;
        $scope.username = $state.params.username;
        $scope.step = "step0";
        $scope.dropdownIsOpen = false;
        $scope.searchValue = "";
        $scope.groupApplicationsMap = {};
        $scope.st = new _smartTable.SmartTable();

        function initUsers(goToStep0) {

            $scope.userSharedAccounts = UserAccounts.getSharedEmailAccountsByUsername({
                companyId: companyId,
                username: $scope.username
            }, function (data) {
                $scope.userSharedAccounts = data;
                if ($scope.selectedSaaspassId !== null) {
                    if (goToStep0) {
                        $scope.cancleSearch();
                    }
                    $scope.selectSaaspassId($scope.selectedSaaspassId);
                }
                if (data.length == 0) {
                    $state.go('company.sharing-center.shared-accounts', {}, { reload: true });
                } else {
                    if (goToStep0) {
                        $scope.step = "step0";
                    }
                }
            });
        };

        $scope.selectSaaspassId = function (saaspassId) {

            $scope.shareWithAnotherUserButtonClicked = false;
            $scope.selectedSaaspassId = saaspassId;
            $scope.step = "step_user_already_exist";
            var tmpAccount = userExists(saaspassId);
            if (tmpAccount) {
                $scope.account = tmpAccount;
                $scope.resourceIds = {
                    companyId: companyId,
                    id: tmpAccount.id
                };
                getOtherCompanyUserAccounts();
                loadGroups();
            }
        };

        $scope.shareWithAnotherUser = function () {
            identifyUser($scope.newUserIdentifier1);
        };

        $scope.onSearchStart = function (keyEvent) {
            $scope.shareWithAnotherUserButtonClicked = false;
            if (keyEvent.which === 13) {
                identifyUser($scope.newUserIdentifier2);
            }
        };

        $scope.cancleSearch = function () {
            $scope.userIdentifier = null;
            $scope.newUserIdentifier1 = null;
            $scope.newUserIdentifier2 = null;
            $scope.successResult = null;
            $scope.showVerification = false;
            $scope.companyUser = null;
            $scope.message = null;
            $scope.newUserIdentifier = null;
            if (!$scope.shareWithAnotherUserButtonClicked) {
                $scope.step = "step0";
            }
        };

        $scope.share = function (saaspassId) {
            if ($scope.isSendingRequest) {
                return;
            }
            $scope.isSendingRequest = true;

            var param = {
                companyId: companyId
            };
            var dataReq = {
                username: $scope.username,
                companyUser: $scope.companyUser
            };

            UserAccounts.createSharedUserAccount(param, dataReq, function (data) {
                AccountsResource.getAllGroupsForUserAccount(companyId, data.id).then(function (groups) {
                    $scope.groupsOfUser = groups.filter(function (group) {
                        return group.type !== 'EVERYONE';
                    });
                });
                $scope.username = data.username;
                var key = 'groups_users.added_active_account_SHARED_EMAIL';
                var variables = { saaspassId: data.companyUser.saaspassUser.saaspassId };
                $scope.globalTopLevelMessage = new _spAlert.SpAlert('success', key, variables);
                $scope.selectedSaaspassId = saaspassId;
                initUsers(true);
                $scope.cancleSearch();
                $scope.isSendingRequest = false;
            }, function (error) {
                $scope.isSendingRequest = false;
            });
        };

        var userExists = function userExists(saaspassId) {
            for (var i = 0; i < $scope.userSharedAccounts.length; i++) {
                if ($scope.userSharedAccounts[i].companyUser.saaspassUser.saaspassId == saaspassId) {
                    return $scope.userSharedAccounts[i];
                }
            }
            return null;
        };

        $scope.doesUserExists = function (saaspassId) {
            var result = userExists(saaspassId) !== null;
            return result;
        };

        var identifyUser = function identifyUser(identifier) {
            $scope.userIdentifier = identifier;

            if ($scope.userIdentifier == $scope.currentSaaspassId) {
                $scope.successResult = false;
                $scope.showVerification = false;

                $scope.message = 'groups_users.user_is_the_same';
            } else if ($scope.userIdentifier == $scope.currentEmailAddress) {
                $scope.successResult = false;
                $scope.showVerification = false;

                $scope.message = 'groups_users.user_email_is_the_same';
            } else {
                CompanyUser.identifyCompanyUser({
                    companyId: companyId,
                    uid: encodeURIComponent($scope.userIdentifier)
                }, function (data) {
                    if (data.id && data.id == $scope.currentCompanyUserId || data.saaspassUser && data.saaspassUser.id == $scope.currentSaaspassId) {
                        $scope.successResult = false;
                        $scope.showVerification = false;
                        $scope.step = "user_not_found";
                        $scope.message = 'groups_users.user_is_the_same';
                    } else {

                        if (userExists(data.saaspassUser.saaspassId) && !$scope.shareWithAnotherUserButtonClicked) {
                            $scope.cancleSearch();
                            $scope.selectSaaspassId(data.saaspassUser.saaspassId);
                        } else {
                            $scope.step = "step_user_found";
                            $scope.successResult = true;
                            $scope.showVerification = false;
                            $scope.companyUser = data;

                            $scope.message = 'groups_users.user_found';
                        }
                    }
                }, function (error) {
                    $scope.successResult = false;
                    $scope.companyUser = null;

                    $scope.showVerification = $scope.enableVerification && !$scope.successResult && $rootScope.emailPattern.test($scope.userIdentifier);

                    $scope.step = "step_user_not_found";
                    if (error.status == 404) {
                        $scope.message = $translate.instant('sharing_center.user_not_found') + ' ' + identifier;
                    } else {
                        $scope.message = error.data.message;
                    }
                });
            }
        };

        var getOtherCompanyUserAccounts = function getOtherCompanyUserAccounts() {
            var tmpAccount = userExists($scope.selectedSaaspassId);
            if (tmpAccount) {
                var resourceIds = {
                    companyId: companyId,
                    id: tmpAccount.companyUser.id
                };

                CompanyUser.getUserAccounts(resourceIds, function (accounts) {
                    $scope.accountsForCompanyUser = accounts;
                });
            }
        };

        var loadGroups = function loadGroups() {

            AccountsResource.getAllGroupsForUserAccount($scope.resourceIds.companyId, $scope.resourceIds.id).then(function (groupsAndApps) {
                return groupsAndApps.map(function (_ref) {
                    var group = _ref.group;
                    return group;
                });
            }).then(function (groups) {
                $scope.groupsOfUser = groups.filter(function (group) {
                    return group.type !== 'EVERYONE';
                });

                angular.forEach($scope.groupsOfUser, function (group) {

                    if (!$scope.groupApplicationsMap.hasOwnProperty(group.id)) {
                        GroupsResource.getAssignedApplicationsOfGroup(companyId, group.id).then(function (applications) {
                            $scope.groupApplicationsMap[group.id] = applications;
                        });
                    }
                });
            });

            AccountsResource.getAllGroupsUserCanBeAssignedTo($scope.resourceIds.companyId, $scope.resourceIds.id).then(function (data) {
                return $scope.groupsForAdd = data;
            });
        };

        $scope.removeUserFromGroups = function (groupId) {
            AccountsResource.removeUserFromGroups($scope.resourceIds.companyId, $scope.resourceIds.id, [groupId]).then(function () {
                loadGroups();
                Alert('success', 'groups_users.remove_user_from_groups');
            });
        };

        $scope.assignToGroup = function (group) {
            AccountsResource.assignUserToGroups($scope.resourceIds.companyId, $scope.resourceIds.id, [group.id]).then(function () {
                loadGroups();
                Alert('success', 'groups_users.assign_to_group_success');
            });
        };

        $scope.canBeSelected = function (entity) {
            if (angular.isDefined(entity)) {
                return entity.type == "CUSTOM" || entity.type == "APPLICATION";
            }
            return false;
        };

        $scope.shareWithAdditionalUser = function () {
            $scope.cancleSearch();
            $scope.step = "share_with_additional_user";
            $scope.shareWithAnotherUserButtonClicked = true;
        };

        $scope.unshare = function (saaspassId) {
            $scope.type = 'SINGLE';
            $scope.saaspassId = saaspassId;
            ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete').then(function () {
                return AccountsResource.deleteUserAccount($scope.resourceIds.companyId, $scope.resourceIds.id);
            }).then(function () {
                return initUsers(true);
            });
        };

        var loadUserAccountsForGroup = function loadUserAccountsForGroup(group) {
            GroupsResource.getAllAccountsForCompanyAndGroup(companyId, group.id).then(function (userAccounts) {
                return $scope.userAccounts = userAccounts;
            });
        };

        $scope.showGroupData = function (groupType) {

            var group = Groups.getGroupsByType({
                companyId: companyId,
                type: groupType
            });
            group.$promise.then(function (data) {
                var firstGroup = data[0];
                loadUserAccountsForGroup(firstGroup);
            });
        };

        $scope.showGroupData('EVERYONE');

        $scope.customGroups = _this.customGroups;

        $scope.applicationGroups = _this.applicationGroups;

        $scope.userSharedAccounts = _this.sharedAccounts;
    };
}

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'SharedFoldersResource', 'Alert'];

    /** @ngInject */
    function Controller($state, SharedFoldersResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.SharedFoldersResource = SharedFoldersResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.name = "";
        }
    }, {
        key: 'create',
        value: function create() {
            var _this = this;

            this.isSaving = true;
            this.SharedFoldersResource.createSharedFolder(this.companyId, this.name).then(function (data) {
                // var transformedData=data.toJSON();
                _this.sharedFolders.push(data);
                _this.$state.go('company.sharing-center.shared-folders.manage.edit', { sharedFolderId: data.id });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _store = __webpack_require__(19);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'SharedFoldersResource'];

    /** @ngInject */
    function Controller(Alert, SharedFoldersResource) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.SharedFoldersResource = SharedFoldersResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.SharedFoldersResource.addCorporateServiceAccounts(_store.resolve.companyId, this.resolve.sharedFolder.id, this.st.selectedIds).then(function (data) {
                _this.close();
                _this.Alert('success', 'global.messages.operation-successful');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _store = __webpack_require__(19);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'SharedFoldersResource', 'ShowNoteModal'];

    /** @ngInject */
    function Controller(Alert, SharedFoldersResource, ShowNoteModal) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.SharedFoldersResource = SharedFoldersResource;
        this.ShowNoteModal = ShowNoteModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'showNote',
        value: function showNote(note) {
            this.ShowNoteModal('Note', note.note);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.SharedFoldersResource.addCorporateNotes(_store.resolve.companyId, this.resolve.sharedFolder.id, this.st.selectedIds).then(function (data) {
                _this.close();
                _this.Alert('success', 'global.messages.operation-successful');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'SharedFoldersResource', 'Alert', 'ConfirmDeleteModal', 'ConfirmModal', 'SharedFolderAddCSAModal', 'SharedFolderAddNoteModal'];

    /** @ngInject */
    function Controller($state, SharedFoldersResource, Alert, ConfirmDeleteModal, ConfirmModal, SharedFolderAddCSAModal, SharedFolderAddNoteModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.SharedFoldersResource = SharedFoldersResource;
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.ConfirmModal = ConfirmModal;
        this.SharedFolderAddCSAModal = SharedFolderAddCSAModal;
        this.SharedFolderAddNoteModal = SharedFolderAddNoteModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'rename',
        value: function rename(newName) {
            var _this = this;

            this.SharedFoldersResource.renameSharedFolder(this.companyId, this.sharedFolder.id, newName).then(function () {
                _this.$state.reload('company.sharing-center.shared-folders');
            }).then(function () {
                return _this.Alert('success', 'global.messages.operation-successful');
            }).catch(function (error) {});
        }
    }, {
        key: 'showDeleteModal',
        value: function showDeleteModal() {
            var _this2 = this;

            this.isRemoving = true;
            this.ConfirmDeleteModal('company.sharing-center.shared-folders.confirm-delete').then(function () {
                return _this2.SharedFoldersResource.deleteSharedFolder(_this2.companyId, _this2.sharedFolder.id);
            }).then(function () {
                _this2.$state.go('^.^', {}, { reload: '^.^' });
                _this2.Alert('success', 'global.messages.operation-successful');
            }).finally(function () {
                return _this2.isRemoving = false;
            });
        }
    }, {
        key: 'addPasswordManager',
        value: function addPasswordManager() {
            var _this3 = this;

            this.SharedFolderAddCSAModal(false, this.sharedFolder, this.items).then(function () {
                return _this3.$state.reload('company.sharing-center.shared-folders');
            });
        }
    }, {
        key: 'addAuthenticator',
        value: function addAuthenticator() {
            var _this4 = this;

            this.SharedFolderAddCSAModal(true, this.sharedFolder, this.items).then(function () {
                return _this4.$state.reload('company.sharing-center.shared-folders');
            });
        }
    }, {
        key: 'addNote',
        value: function addNote() {
            var _this5 = this;

            this.SharedFolderAddNoteModal(this.sharedFolder, this.items).then(function () {
                return _this5.$state.reload('company.sharing-center.shared-folders');
            });
        }
    }, {
        key: 'removeItems',
        value: function removeItems() {
            var _this6 = this;

            this.ConfirmModal({
                messageKey: 'company.sharing-center.shared-folders.items.confirm-remove',
                titleKey: 'sp-confirm.title'
            }).then(function () {
                _this6.SharedFoldersResource.removeItems(_this6.companyId, _this6.sharedFolder.id, _this6.st.selectedIds).then(function (data) {
                    _this6.$state.reload('company.sharing-center.shared-folders');
                });
            }).finally(function () {
                return _this6.isSending = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'SharedFolderAddCSAModal', 'SharedFolderAddNoteModal'];

    /** @ngInject */
    function Controller($state, SharedFolderAddCSAModal, SharedFolderAddNoteModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.SharedFolderAddCSAModal = SharedFolderAddCSAModal;
        this.SharedFolderAddNoteModal = SharedFolderAddNoteModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'showAddButtons',
        value: function showAddButtons() {
            return this.$state.current.name === 'company.sharing-center.shared-folders.manage.edit';
        }
    }, {
        key: 'addPasswordManager',
        value: function addPasswordManager() {
            var _this = this;

            this.SharedFolderAddCSAModal(false, this.sharedFolder, this.items).then(function () {
                return _this.$state.reload('company.sharing-center.shared-folders');
            });
        }
    }, {
        key: 'addAuthenticator',
        value: function addAuthenticator() {
            var _this2 = this;

            this.SharedFolderAddCSAModal(true, this.sharedFolder, this.items).then(function () {
                return _this2.$state.reload('company.sharing-center.shared-folders');
            });
        }
    }, {
        key: 'addNote',
        value: function addNote() {
            var _this3 = this;

            this.SharedFolderAddNoteModal(this.sharedFolder, this.items).then(function () {
                return _this3.$state.reload('company.sharing-center.shared-folders');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$state', 'CompanyUser', 'ConfirmDeleteModal', 'SharedFoldersResource', 'Alert'];

	/** @ngInject */
	function Controller($state, CompanyUser, ConfirmDeleteModal, SharedFoldersResource, Alert) {
		_classCallCheck(this, Controller);

		this.$state = $state;
		this.CompanyUser = CompanyUser;
		this.ConfirmDeleteModal = ConfirmDeleteModal;
		this.SharedFoldersResource = SharedFoldersResource;
		this.Alert = Alert;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			this.selectedLabels = this.sharedLabels.filter(function (item) {
				return item.isShared;
			});
			this.$sharedLabels = JSON.parse(JSON.stringify(this.sharedLabels));
			this.newUserIdentifier = null;
			this.userIdentifier = null;
			this.st = new _smartTable.SmartTable();
			this.stLabels = new _smartTable.SmartTable();
		}
	}, {
		key: 'identifyUser',
		value: function identifyUser() {
			var _this = this;

			this.message = null;
			this.userIdentifier = this.newUserIdentifier;

			this.CompanyUser.identifyCompanyUser({
				companyId: this.companyId,
				uid: encodeURIComponent(this.userIdentifier)
			}).$promise.then(function (response) {

				_this.successResult = true;
				_this.showVerification = false;
				_this.companyUser = response;
				_this.message = 'groups_users.user_found';
			}).catch(function (error) {
				_this.successResult = false;
				_this.companyUser = null;

				_this.showVerification = _this.enableVerification && !_this.successResult && $rootScope.emailPattern.test(_this.userIdentifier);

				if (error.status == 404) {
					_this.message = 'groups_users.user_not_found';
				} else {
					_this.message = response.data.message;
				}
			});
		}
	}, {
		key: 'getSharingTypeDisplayName',
		value: function getSharingTypeDisplayName(sharingType) {
			if (sharingType == 'INDIVIDUAL_AND_TEAM') {
				return 'INDIVIDUAL & TEAM';
			} else {
				return sharingType;
			}
		}
	}, {
		key: 'share',
		value: function share(saaspassId) {
			var _this2 = this;

			this.SharedFoldersResource.shareWithSaaspassId(this.companyId, this.sharedFolderId, saaspassId).then(function (response) {
				_this2.successMessageAndReload('global.messages.operation-successful');
			});
		}
	}, {
		key: 'unshare',
		value: function unshare(saaspassId) {
			var _this3 = this;

			this.saaspassId = saaspassId;
			this.ConfirmDeleteModal('company.sharing-center.shared-folders.confirm-unshare').then(function () {
				_this3.SharedFoldersResource.unshareWithSaaspassId(_this3.companyId, _this3.sharedFolderId, saaspassId).then(function (response) {
					_this3.successMessageAndReload('global.messages.operation-successful');
				});
			});
		}
	}, {
		key: 'cancelSearch',
		value: function cancelSearch() {
			this.userIdentifier = null;
			this.successResult = null;
			this.showVerification = false;
			this.companyUser = null;
			this.message = null;
			this.newUserIdentifier = null;
		}
	}, {
		key: 'clickLabel',
		value: function clickLabel(label) {
			if (label.name === "ALL_USERS") {
				this.sharedLabels.map(function (item) {
					if (item.name !== "ALL_USERS") {
						item.isShared = false;
					}
				});
			}
			this.selectedLabels = this.sharedLabels.filter(function (item) {
				return item.isShared;
			});
		}
	}, {
		key: 'isCheckboxDisabled',
		value: function isCheckboxDisabled(label) {
			var isIt = label.name !== "ALL_USERS" && this.selectedLabels.length == 1 && this.selectedLabels[0].name === "ALL_USERS";
			return isIt;
		}
	}, {
		key: 'sharedLabelsNotModified',
		value: function sharedLabelsNotModified() {
			return angular.equals(this.$sharedLabels, this.sharedLabels);
		}
	}, {
		key: 'shareWithLabels',
		value: function shareWithLabels() {
			var _this4 = this;

			this.SharedFoldersResource.updateSharedLabels(this.companyId, this.sharedFolderId, this.sharedLabels).then(function (response) {
				_this4.successMessageAndReload('global.messages.operation-successful');
			});
		}
	}, {
		key: 'successMessageAndReload',
		value: function successMessageAndReload(key) {
			this.$state.go('.', {}, { reload: '.' });
			this.Alert('success', key);
		}
	}]);

	return Controller;
}();

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);

        this.st = new _smartTable.SmartTable();
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var format = function format(date) {
                return new Date(date).toString().slice(4, 24);
            };
            this.sharedFolders.forEach(function (sharedFolder) {
                return sharedFolder.createdOnDisplay = format(sharedFolder.createdOn);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';


var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$state'];

	/** @ngInject */
	function Controller($state) {
		_classCallCheck(this, Controller);

		this.$state = $state;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			if (this.isNote) {
				this.accountName = this.sharedAccount.noteName;
			} else {
				this.accountName = this.sharedAccount.publicService.serviceName + ' - ' + this.sharedAccount.username;
			}
			this.defaultBackStateName = Object.keys(this.$state.$current.includes)[3];
		}
	}]);

	return Controller;
}();

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(19);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'SharedAccountsService', '$state'];

    /** @ngInject */
    function Controller(Alert, SharedAccountsService, $state) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.corporateNote = {
                id: null,
                noteName: '',
                note: ''
            };
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.SharedAccountsService.createNote({
                companyId: this.companyId
            }, this.corporateNote).$promise.then(function (note) {
                _this.Alert('success', 'company.sharing-center.note.add.added');
                _this.$state.go('company.sharing-center.shared-notes.manage.edit', { sharedAccountId: note.id }, { reload: 'company.sharing-center.shared-notes' });
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _store = __webpack_require__(19);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'ConfirmDeleteModal', 'SharedAccountsService', '$state'];

    /** @ngInject */
    function Controller(Alert, ConfirmDeleteModal, SharedAccountsService, $state) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.SharedAccountsService = SharedAccountsService;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.theNote = this.sharedAccount;
            if (this.theNote == null) {
                this.$state.go('^');
            }
            this.note = _extends({}, this.theNote);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.note, this.theNote);
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            this.isRemoving = true;
            this.ConfirmDeleteModal('company.sharing-center.confirm_company_note_delete').then(function () {
                return _this.SharedAccountsService.deleteNote({
                    companyId: _this.companyId,
                    id: _this.note.id
                }).$promise;
            }).then(function () {
                _this.$state.go('^.^', {}, { reload: '^.^' });
                _this.Alert('success', 'company.sharing-center.note.manage.removed');
            }).finally(function () {
                return _this.isRemoving = false;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.isSaving = true;
            this.SharedAccountsService.updateNote({
                companyId: this.note.company.id,
                id: this.note.id
            }, this.note).$promise.then(function (note) {
                _this2.$state.go('^.^', {}, { reload: '^.^' });
                _this2.Alert('success', 'company.sharing-center.note.manage.saved');
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid || this.notModified();
        }
    }]);

    return Controller;
}();

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    var secret = secretKey.replace(/\s/g, '');
    return 'otpauth://totp/' + issuer + ':' + username + '?secret=' + secret + '&issuer=' + issuer + '&digits=' + digits + '&algorithm=' + algorithm;
}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AddNewSharedNoteModal', 'ManageSharedNoteModal', 'ShowNoteModal'];

    /** @ngInject */
    function Controller($state, AddNewSharedNoteModal, ManageSharedNoteModal, ShowNoteModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AddNewSharedNoteModal = AddNewSharedNoteModal;
        this.ManageSharedNoteModal = ManageSharedNoteModal;
        this.ShowNoteModal = ShowNoteModal;
        this.st = new _smartTable.SmartTable();
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var format = function format(date) {
                return new Date(date).toString().slice(4, 24);
            };
            this.notes.forEach(function (note) {
                return note.createdOnDisplay = format(note.createdOn);
            });
        }
    }, {
        key: 'showAddModal',
        value: function showAddModal() {
            // this.AddNewSharedNoteModal().then(() => this.reload());;
            this.$state.go(".add");
        }
    }, {
        key: 'showNote',
        value: function showNote(note) {
            this.ShowNoteModal('Note', note.note);
        }
    }, {
        key: 'showManageModal',
        value: function showManageModal(note) {
            // return this.ManageSharedNoteModal(note).then(() => this.reload());
            this.$state.go(".manage.edit", { sharedAccountId: note.id, theNote: note });
        }
    }, {
        key: 'reload',
        value: function reload() {
            return this.$state.reload(this.$state.current);
        }
    }, {
        key: 'showShareModal',
        value: function showShareModal(note) {
            this.$state.go('company.sharing-center.shared-notes.manage.share', { sharedAccount: note, sharedAccountId: note.id });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'SharedAccountsService'];

    /** @ngInject */
    function Controller($state, Alert, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$state = $state;
        this.SharedAccountsService = SharedAccountsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.copyAccount != null) {
                this.account = this.copyAccount;
                this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
            } else {
                this.account = {
                    showOtpEnabled: true,
                    showPasswordEnabled: true,
                    showNoteEnabled: false
                };
            }

            this.publicServicesWithSso$.get().then(function (items) {
                return _this.publicServices = items;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.isSaving = true;
            this.SharedAccountsService.createCompanyServiceAccounts({
                companyId: this.companyId,
                publicServiceId: this.account.publicService.id
            }, {
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: false,
                showOtpEnabled: false,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName
            }).$promise.then(function (account) {
                _this2.Alert('success', 'company.sharing-center.add.added');
                _this2.$state.go('company.sharing-center.shared-passwords.manage.edit', { sharedAccountId: account.id }, { reload: 'company.sharing-center.shared-passwords' });
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid || !this.account.publicService;
        }
    }, {
        key: 'selectCustom',
        value: function selectCustom() {
            this.searchItem = 'Custom';
            this.account.publicService = this.publicServices.find(function (i) {
                return i.slug === "other";
            });
        }
    }, {
        key: 'serviceSelected',
        value: function serviceSelected(service) {
            this.account.publicService = service;
            if (service.slug !== "other") {
                this.account.customServiceName = null;
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'SharedAccountsService'];

    /** @ngInject */
    function Controller($state, Alert, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _this = this;

            var companyId = this.companyId;
            this.isSaving = true;
            this.SharedAccountsService.deleteBulkCompanyServiceAccounts({ companyId: companyId }, this.st.selectedIds).$promise.then(function () {
                _this.Alert('success', 'company.user-directories.directory-groups.all-accounts.delete.deleted');
                _this.$state.go('^', { companyId: companyId }, { reload: true, inherit: false, notify: false });;
            }).catch(function (error) {}).finally(function () {
                _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ["$state", "Alert", "SharedAccountsService", "CompanyUser"];

	/** @ngInject */
	function Controller($state, Alert, SharedAccountsService, CompanyUser) {
		_classCallCheck(this, Controller);

		this.$state = $state;
		this.Alert = Alert;
		this.SharedAccountsService = SharedAccountsService;
		this.CompanyUser = CompanyUser;
	}

	_createClass(Controller, [{
		key: "$onInit",
		value: function $onInit() {
			var _this = this;

			this.importResult = this.$state.params.importResult;
			if (this.importResult == null) {
				this.close();
			}
			this.labels$.get().then(function (labels) {
				return _this.labels = labels;
			});
			this.selectedLabels = [];
			this.showPasswordEnabled = false;
			this.showOtpEnabled = false;
			this.showNoteEnabled = false;
			this.companyUsers = [];
		}
	}, {
		key: "isCheckedLabel",
		value: function isCheckedLabel(label) {
			var indexOfLabel = this.selectedLabels.indexOf(label);
			return indexOfLabel >= 0;
		}
	}, {
		key: "isCheckboxDisabled",
		value: function isCheckboxDisabled(label) {
			var isIt = label.name !== "ALL_USERS" && this.selectedLabels.length == 1 && this.selectedLabels[0].name === "ALL_USERS";
			return isIt;
		}
	}, {
		key: "clickLabel",
		value: function clickLabel(label) {
			var indexOfLabel = this.selectedLabels.indexOf(label);
			if (indexOfLabel >= 0) {
				this.selectedLabels.splice(indexOfLabel, 1);
			} else {
				if (label.name === "ALL_USERS") {
					this.selectedLabels = [];
				}
				this.selectedLabels.push(label);
			}
		}
	}, {
		key: "clearSearch",
		value: function clearSearch() {
			this.successResult = false;
			this.companyUser = null;
			this.newUserIdentifier = null;
			this.showClear = false;
		}
	}, {
		key: "identifyUser",
		value: function identifyUser() {
			var _this2 = this;

			this.successResult = false;
			this.companyUser = null;
			this.message = null;
			this.CompanyUser.identifyCompanyUser({
				companyId: this.companyId,
				uid: encodeURIComponent(this.newUserIdentifier)
			}).$promise.then(function (response) {
				_this2.companyUser = response;
				_this2.companyUser.selected = true;
				_this2.companyUsers.push(_this2.companyUser);
				_this2.message = 'groups_users.user_found';
				_this2.successResult = true;
			}).catch(function (error) {
				console.log(error);
				if (error.status == 404) {
					_this2.message = 'groups_users.user_not_found';
				} else {
					_this2.message = error.message;
				}
			}).finally(function () {
				_this2.showClear = true;
			});
		}
	}, {
		key: "getSelectedSaaspassUsersIds",
		value: function getSelectedSaaspassUsersIds() {
			return this.companyUsers.filter(function (user) {
				return user.selected;
			}).map(function (user) {
				return user.saaspassUser.id;
			});
		}
	}, {
		key: "checkboxChange",
		value: function checkboxChange(cUser) {
			var foundIndex = this.companyUsers.findIndex(function (x) {
				return x.id == cUser.id;
			});
			this.companyUsers[foundIndex].selected = !cUser.selected;
			console.log(this.companyUsers);
		}
	}, {
		key: "save",
		value: function save() {
			var _this3 = this;

			var saaspassUsersIds = this.getSelectedSaaspassUsersIds();
			if (this.selectedLabels.length == 0 && !this.showPasswordEnabled && this.companyUsers.length == 0) {
				this.close();
			} else {
				this.SharedAccountsService.updateAndShareServiceAccountsWithLabels({
					companyId: this.companyId,
					showPassword: this.showPasswordEnabled,
					showOtp: this.showOtpEnabled,
					showNote: this.showNoteEnabled

				}, { labels: this.selectedLabels, corporateServiceAccountIds: this.importResult.importedIds, spUsersIds: saaspassUsersIds, labelsToUnshare: [] }).$promise.then(function () {
					_this3.close();
					_this3.Alert('success', 'company.sharing-center.shared-passwords.import-csv.import-completed.success');
				}).catch(function (error) {
					console.log(error);
					_this3.Alert('danger', error.message);
				});
			}
		}
	}, {
		key: "close",
		value: function close() {
			this.$state.go('company.sharing-center.shared-passwords', {}, { reload: true });
		}
	}]);

	return Controller;
}();

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$timeout', 'Alert', 'SharedAccountsService'];

    /** @ngInject */
    function Controller($state, $timeout, Alert, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
        this.$state = $state;
        this.$timeout = $timeout;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.fileType = null;
            this.importResult = null;
            this.fileToUpload = { value: null };
            this.isUploading = false;
            //this.importFileTypes=['GENERIC','MOZILLA','CLASSIC_BROWSER'];//when we start suppoting all types just delete this line
        }
    }, {
        key: 'uploadCSV',
        value: function uploadCSV() {
            var _this = this;

            if (!this.fileToUpload.value) {
                return;
            }
            this.isUploading = true;
            var formData = new FormData();
            formData.append('file', this.fileToUpload.value);
            this.SharedAccountsService.importCompanyServiceAccountsFromCsv({
                companyId: this.companyId,
                fileType: this.fileType
            }, formData).$promise.then(function (results) {
                console.log(results);
                _this.$state.go('.import-completed', { importResult: results });
            }).catch(function (error) {
                console.log(error);
                //this.Alert('danger',error.message);
            }).finally(function () {
                _this.isUploading = false;_this.fileToUpload = { value: null };
            });
        }
    }, {
        key: 'fnc',
        value: function fnc() {
            this.$timeout(function () {
                document.getElementById("uploadInput").click();
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _store = __webpack_require__(19);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'SharedAccountsService'];

    /** @ngInject */
    function Controller(Alert, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.showOtpEnabled = false;
            this.showPasswordEnabled = false;
            this.isSelectable = this.isSelectable.bind(this);
        }
    }, {
        key: 'ifSelectable',
        value: function ifSelectable(authenticator) {
            return this.isSelectable(authenticator) && authenticator;
        }
    }, {
        key: 'isSelectable',
        value: function isSelectable(authenticator) {
            //const hasServiceUrl = !!(authenticator.publicService || {}).serviceUrl;
            // const customUrlRequired = !!(authenticator.publicService || {}).urlRequired;
            // const hasCustomUrl = !!(authenticator.customLoginUrl || {}).serviceLoginUrl;
            // return hasServiceUrl && !customUrlRequired || hasCustomUrl;

            return true;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.SharedAccountsService.importCompanyServiceAccounts({
                companyId: _store.resolve.companyId,
                showOtp: false,
                showPassword: this.showPasswordEnabled
            }, this.st.selectedIds).$promise.then(function (accounts) {
                _this.close({ $value: accounts });
                _this.Alert('success', 'company.sharing-center.import.imported');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _passwordStrength = __webpack_require__(85);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//import { resolve } from '../../../../../init/store';

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$scope', 'Alert', 'ConfirmDeleteModal', 'SharedAccountsService', 'ConfirmModal'];

    /** @ngInject */
    function Controller($state, $scope, Alert, ConfirmDeleteModal, SharedAccountsService, ConfirmModal) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.ConfirmModal = ConfirmModal;
        this.SharedAccountsService = SharedAccountsService;
        this.$state = $state;
        this.$scope = $scope;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.tooltipTemplate = __webpack_require__(107);
            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
            if (Object.keys(this.sharedAccount).length === 0) {
                this.$state.go('^');
            }
            this.$account = _extends({}, this.sharedAccount); //{...this.resolve.account};
            this.account = _extends({}, this.$account);
            this.passGrade = (0, _passwordStrength.passwordGrade)(this.account.password);
            this.publicServicesWithSso$.get().then(function (items) {
                return _this.publicServices = items;
            });
            this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';

            if (this.convert2fa) {
                this.changeToConvertState();
            }
            this.isCustom = this.$account.publicService.slug == 'other';
        }
    }, {
        key: 'saveIcon',
        value: function saveIcon(iconFile) {
            var _this2 = this;

            var formData = new FormData();
            formData.append('iconFile', iconFile);
            return this.SharedAccountsService.uploadCustomIconForCorporateServiceAccount({
                companyId: this.companyId, //resolve.companyId,
                corporateServiceAccountId: this.account.id
            }, formData).$promise.then(function (data) {
                _this2.account.customIcon = data.customIcon;
                _this2.Alert('success', 'company.sharing-center.manage.saved');
            });
        }
    }, {
        key: 'resetIcon',
        value: function resetIcon() {
            var _this3 = this;

            return this.ConfirmModal({
                messageKey: 'Custom icon will be deleted and default icon will be used. Do you want to continue?',
                titleKey: 'Confirm Delete'
            }).then(function () {
                return _this3.SharedAccountsService.deleteCustomIconForCorporateServiceAccount({
                    companyId: _this3.companyId, //resolve.companyId,
                    corporateServiceAccountId: _this3.account.id
                }).$promise.then(function () {
                    _this3.account.customIcon = null;
                    _this3.Alert('success', 'company.sharing-center.manage.saved');
                });
            });
        }
    }, {
        key: 'createCopy',
        value: function createCopy() {
            var copyAccount = {
                username: this.sharedAccount.username,
                password: this.sharedAccount.password,
                note: this.sharedAccount.note,
                showOtpEnabled: this.sharedAccount.showOtpEnabled,
                showPasswordEnabled: this.sharedAccount.showPasswordEnabled,
                showNoteEnabled: this.sharedAccount.showNoteEnabled,
                publicService: this.publicServices.find(function (i) {
                    return i.slug === "other";
                }),
                customServiceName: this.getCopyServiceName(),
                serviceLoginUrl: this.sharedAccount.publicService.slug === 'other' ? this.sharedAccount.serviceLoginUrl : this.sharedAccount.publicService.serviceUrl
            };
            this.$state.go("company.sharing-center.add-shared-password", { copyAccount: copyAccount });
        }
    }, {
        key: 'getCopyServiceName',
        value: function getCopyServiceName() {
            var _this4 = this;

            var currentServiceName = this.sharedAccount.publicService.slug === 'other' ? this.sharedAccount.customServiceName : this.sharedAccount.publicService.serviceName;
            var customServiceNames = this.allAccounts.filter(function (account) {
                return account.username === _this4.sharedAccount.username && account.publicService.slug === 'other' && account.customServiceName != null;
            }).map(function (item) {
                return item.customServiceName;
            });
            currentServiceName = currentServiceName.indexOf(' Copy') !== -1 ? currentServiceName.substring(0, currentServiceName.indexOf(' Copy')) : currentServiceName;
            var copyServiceName = currentServiceName + ' Copy';
            if (customServiceNames.indexOf(copyServiceName) === -1) {
                return copyServiceName;
            }

            var i = 1;
            while (customServiceNames.indexOf(copyServiceName + ' ' + i) !== -1) {
                i++;
            }
            return copyServiceName + ' ' + i;
        }
    }, {
        key: 'changePassGrade',
        value: function changePassGrade() {
            this.passGrade = (0, _passwordStrength.passwordGrade)(this.account.password);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            if (this.$account.publicService.id === this.account.publicService.id) {
                this.account.publicService = this.$account.publicService;
            }
            return angular.equals(this.$account, this.account);
        }
    }, {
        key: 'selectCustom',
        value: function selectCustom() {
            this.searchItem = 'Custom';
            this.account.publicService = this.publicServices.find(function (i) {
                return i.slug === "other";
            });
        }
    }, {
        key: 'serviceSelected',
        value: function serviceSelected(service) {
            this.account.publicService = service;
            if (service.slug !== "other") {
                this.account.customServiceName = null;
            }
        }
    }, {
        key: 'isComputerAdministrationAccount',
        value: function isComputerAdministrationAccount() {
            return this.account.publicService.serviceName == 'ComputerLocalAccountAdministration';
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this5 = this;

            this.isRemoving = true;
            this.ConfirmDeleteModal('groups_users.confirm_company_user_account_delete').then(function () {
                return _this5.SharedAccountsService.deleteCompanyServiceAccounts({
                    companyId: _this5.companyId, //resolve.companyId,
                    id: _this5.account.id
                }).$promise;
            }).then(function () {
                //this.close();
                _this5.$state.go('^.^', {}, { reload: '^.^' });
                _this5.Alert('success', 'company.sharing-center.manage.removed');
            }).finally(function () {
                return _this5.isRemoving = false;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this6 = this;

            this.isSaving = true;
            this.SharedAccountsService.updateCompanyServiceAccounts({
                companyId: this.companyId, //resolve.companyId,
                publicServiceId: this.account.publicService.id
            }, {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: false,
                showOtpEnabled: false,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName
            }).$promise.then(function (account) {
                //this.close({$value: account});
                _this6.$state.go('^.^', {}, { reload: '^.^' });
                _this6.Alert('success', 'company.sharing-center.manage.saved');
            }).finally(function () {
                return _this6.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid || this.notModified();
        }
    }, {
        key: 'convertDisabled',
        value: function convertDisabled(form) {
            return this.isSaving || form.$invalid;
        }
    }, {
        key: 'changeToConvertState',
        value: function changeToConvertState() {
            this.convert = true;
            this.authenticator = {
                algorithm: 'SHA1',
                digits: 6,
                showOtpEnabled: false,
                secret: ''

            };
        }
    }, {
        key: 'convertToAuth',
        value: function convertToAuth() {
            var _this7 = this;

            this.isSaving = true;
            this.SharedAccountsService.convertCompanyServiceAccountToAuth({
                companyId: this.companyId, //resolve.companyId,
                publicServiceId: this.account.publicService.id
            }, {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: true,
                showOtpEnabled: this.authenticator.showOtpEnabled,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: generatePublicServiceKey(this.account.publicService.serviceName, this.account.username, this.authenticator.secret, this.authenticator.digits, this.authenticator.algorithm)
            }).$promise.then(function (account) {
                //this.close({$value: account});
                _this7.$state.go('company.sharing-center.shared-authenticators');
                _this7.Alert('success', 'company.sharing-center.manage.saved');
            }).finally(function () {
                return _this7.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    var secret = secretKey.replace(/\s/g, '');
    return 'otpauth://totp/' + issuer + ':' + username + '?secret=' + secret + '&issuer=' + issuer + '&digits=' + digits + '&algorithm=' + algorithm;
}

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$window', 'Alert', 'AddNewSharedPasswordModal', 'ImportSharedPasswordsModal', 'ManageSharedPasswordModal', 'ComputerAdministrationAccountShare', 'SharedAccountsService'];

    /** @ngInject */
    function Controller($state, $window, Alert, AddNewSharedPasswordModal, ImportSharedPasswordsModal, ManageSharedPasswordModal, ComputerAdministrationAccountShare, SharedAccountsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$window = $window;
        this.Alert = Alert;
        this.AddNewSharedPasswordModal = AddNewSharedPasswordModal;
        this.ImportSharedPasswordsModal = ImportSharedPasswordsModal;
        this.ManageSharedPasswordModal = ManageSharedPasswordModal;
        this.ComputerAdministrationAccountShare = ComputerAdministrationAccountShare;
        this.SharedAccountsService = SharedAccountsService;
        this.st = new _smartTable.SmartTable();
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'isComputerAdministrationAccount',
        value: function isComputerAdministrationAccount(account) {
            return account.publicService.serviceName == 'ComputerLocalAccountAdministration';
        }
    }, {
        key: 'export',
        value: function _export(accounts) {
            var _this = this;

            var accountIds = accounts.map(function (item) {
                return item.id;
            });
            var companyId = this.companyId;
            this.SharedAccountsService.exportCompanyServiceAccounts({ companyId: companyId }, accountIds).$promise.then(function (response) {
                var file = new Blob([response.data], {
                    type: 'text/plain'
                });
                var windowUrl = _this.$window.URL;
                var fileURL = windowUrl.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'exported_passwords_' + new Date().valueOf() + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function () {
                    windowUrl.revokeObjectURL(fileURL);
                }, 100);
                _this.Alert('success', 'company.sharing-center.shared-accounts.export-succes');
            }).catch(function (error) {
                _this.Alert('danger', error.message);
            });
        }
    }, {
        key: 'showManageModal',
        value: function showManageModal(account) {
            var _this2 = this;

            this.ManageSharedPasswordModal(account).then(function () {
                return _this2.$state.reload(_this2.$state.current);
            });
        }
    }, {
        key: 'showAddModal',
        value: function showAddModal() {
            /* this.publicServicesWithSso$.get()
                 .then(items => this.AddNewSharedPasswordModal(items))
                 .then(account => this.accounts.push(account))*/
            this.$state.go('company.sharing-center.add-shared-password');
        }
    }, {
        key: 'showImportModal',
        value: function showImportModal() {
            var _this3 = this;

            this.ImportSharedPasswordsModal().then(function (accounts) {
                var _accounts;

                return (_accounts = _this3.accounts).push.apply(_accounts, _toConsumableArray(accounts));
            });
        }
    }, {
        key: 'showShareModal',
        value: function showShareModal(account) {
            if (this.isComputerAdministrationAccount(account)) {
                this.ComputerAdministrationAccountShare(account);
            } else {
                this.$state.go('company.sharing-center.shared-passwords.manage.share', { sharedAccount: account, sharedAccountId: account.id });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AddNewSharedPasswordModal', 'ImportSharedPasswordsModal', 'AddNewSharedAuthenticatorModal', 'ImportSharedAuthenticatorsModal', 'ShareAnAdditionalEmailAccount'];

    /** @ngInject */
    function Controller($state, AddNewSharedPasswordModal, ImportSharedPasswordsModal, AddNewSharedAuthenticatorModal, ImportSharedAuthenticatorsModal, ShareAnAdditionalEmailAccount) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AddNewSharedPasswordModal = AddNewSharedPasswordModal;
        this.ImportSharedPasswordsModal = ImportSharedPasswordsModal;
        this.ImportSharedAuthenticatorsModal = ImportSharedAuthenticatorsModal;
        this.AddNewSharedAuthenticatorModal = AddNewSharedAuthenticatorModal;
        this.ShareAnAdditionalEmailAccount = ShareAnAdditionalEmailAccount;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            //this.labels$.get().then((labels) => this.labels=labels);
        }
    }, {
        key: 'importFromCSv',
        value: function importFromCSv() {
            this.$state.go('company.sharing-center.import-csv');
        }
    }, {
        key: 'showAuthenticatorAddModal',
        value: function showAuthenticatorAddModal() {
            //  this.publicServicesWithSsoAnd2FA$.get()
            //    .then(items => this.AddNewSharedAuthenticatorModal(items))
            //   .then(() => this.$state.reload(this.$state.current))
            this.$state.go('company.sharing-center.add-shared-authenticator');
        }
    }, {
        key: 'showAuthenticatorImportModal',
        value: function showAuthenticatorImportModal() {
            var _this = this;

            this.ImportSharedAuthenticatorsModal().then(function () {
                return _this.$state.reload(_this.$state.current);
            });
        }
    }, {
        key: 'showPasswordManagerAddModal',
        value: function showPasswordManagerAddModal() {
            // this.publicServicesWithSso$.get()
            //  .then(items => this.AddNewSharedPasswordModal(items))
            //  .then(() => this.$state.reload(this.$state.current))
            this.$state.go('company.sharing-center.add-shared-password');
        }
    }, {
        key: 'showPasswordManagerImportModal',
        value: function showPasswordManagerImportModal() {
            var _this2 = this;

            this.ImportSharedPasswordsModal().then(function () {
                return _this2.$state.reload(_this2.$state.current);
            });
        }
    }, {
        key: 'showShareAnAdditionalEmailAccountModal',
        value: function showShareAnAdditionalEmailAccountModal() {
            this.ShareAnAdditionalEmailAccount();
        }

        /*showSettingsModal() {
               return this.SharingSettingsModal().then(() => this.reload());
           }*/

    }, {
        key: 'stateCheckSharedNotes',
        value: function stateCheckSharedNotes() {
            return this.$state.is('company.sharing-center.shared-notes');
        }
    }, {
        key: 'stateCheckSharedPasswords',
        value: function stateCheckSharedPasswords() {
            return this.$state.is('company.sharing-center.shared-passwords');
        }
    }, {
        key: 'stateCheckSharedAuthenticator',
        value: function stateCheckSharedAuthenticator() {
            return this.$state.is('company.sharing-center.shared-authenticators');
        }
    }, {
        key: 'stateCheckCompanyAccount',
        value: function stateCheckCompanyAccount() {
            return this.$state.is('company.sharing-center.shared-accounts');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$state', '$rootScope', 'SharingSettingsService', 'Alert'];

	/** @ngInject */
	function Controller($state, $rootScope, SharingSettingsService, Alert) {
		_classCallCheck(this, Controller);

		this.$state = $state;
		this.$rootScope = $rootScope;
		this.SharingSettingsService = SharingSettingsService;
		this.Alert = Alert;
		// console.log(this);
		//this.settingsDetails.then(result=>{this.labels=result.companyLabels; this.settings=result.companySettings;});
		// this.settings=this.settingsDetails.companySettings;

	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			this.labels = this.settingsDetails.companyLabels;
			this.resetSettings();
		}
	}, {
		key: 'getLabelsMapLength',
		value: function getLabelsMapLength() {
			var theKeys = Object.keys(this.settings.labelsMap);
			return theKeys.length;
		}
	}, {
		key: 'resetSettings',
		value: function resetSettings() {
			this.settings = angular.copy(this.settingsDetails.companySettings);
			this.allUsersShare = this.getLabelsMapLength() == 1 && this.settings.labelsMap["ALL_USERS"] !== undefined;
			//this.sharings = this.settings.labelsMap;
		}
	}, {
		key: 'saveSettings',
		value: function saveSettings() {
			var _this = this;

			if (this.settings.allowShare && this.getLabelsMapLength() === 0) {
				this.Alert('danger', 'must_choose_labels');
			} else {
				var companyId = this.$state.params.companyId;
				this.SharingSettingsService.saveSettings({ companyId: companyId }, this.settings).$promise.then(function () {
					_this.goBack();
					_this.Alert('success', 'saaspass_connect.create_success');
				}).catch(function (error) {
					_this.Alert('danger', error.data.message);
				});
			}
		}
	}, {
		key: 'letUserChoosesOtpVisibility',
		value: function letUserChoosesOtpVisibility() {
			this.settings.showOtpEnabled = false;
		}
	}, {
		key: 'letUserChoosesPassVisibility',
		value: function letUserChoosesPassVisibility() {
			this.settings.showPasswordEnabled = false;
		}
	}, {
		key: 'mainSettingChange',
		value: function mainSettingChange() {
			if (!this.settings.allowShare) {
				this.settings.labelsMap = {};
				this.settings.showPasswordEnabled = false;
				this.settings.showOtpEnabled = false;
				this.settings.userChoosesPassVisibility = false;
				this.settings.userChoosesOtpVisibility = false;
			}
		}
	}, {
		key: 'changeToAllShare',
		value: function changeToAllShare() {
			//if(this.allUsersShare){
			this.settings.labelsMap = { "ALL_USERS": [] };
		}
	}, {
		key: 'changeToLabelsShare',
		value: function changeToLabelsShare() {
			this.settings.labelsMap = {};
		}
	}, {
		key: 'isItCheckedAsShared',
		value: function isItCheckedAsShared(keyName, subLabel) {
			delete subLabel.$$hashKey;
			var list = this.settings.labelsMap[keyName];
			var isIt = false; //this.sharings[keyName].indexOf(subLabel)>=0;
			list.forEach(function (listItem) {
				if (listItem.name === subLabel.name) isIt = true;
			});
			return isIt;
		}
	}, {
		key: 'checkboxShareWithLabelChange',
		value: function checkboxShareWithLabelChange(subLabel, keyName) {
			var subLabelIndex = this.settings.labelsMap[keyName].findIndex(function (item) {
				return item.name === subLabel.name;
			});
			if (subLabelIndex >= 0) {
				this.settings.labelsMap[keyName].splice(subLabelIndex, 1);
			} else {
				delete subLabel.$$hashKey;
				if (subLabel.name === "ALL_USERS") {
					this.settings.labelsMap[keyName] = [subLabel];
				} else {
					this.settings.labelsMap[keyName].push(subLabel);
				}
			}
		}
	}, {
		key: 'isCheckboxInTableDisabled',
		value: function isCheckboxInTableDisabled(subLabel, keyName) {
			var isIt = subLabel.name !== "ALL_USERS" && this.settings.labelsMap[keyName].length === 1 && this.settings.labelsMap[keyName][0].name === "ALL_USERS";
			return isIt;
		}
	}, {
		key: 'changeInAllowShare',
		value: function changeInAllowShare() {
			this.settings.allowShare = !this.settings.allowShare;
		}
	}, {
		key: 'checkboxSharingLabelChange',
		value: function checkboxSharingLabelChange(labelName) {
			if (this.settings.labelsMap[labelName] === undefined) {
				this.settings.labelsMap[labelName] = [];
			} else {
				this.removeSharing(labelName);
			}
		}
	}, {
		key: 'removeSharing',
		value: function removeSharing(keyName) {
			delete this.settings.labelsMap[keyName];
		}
	}, {
		key: 'goBack',
		value: function goBack() {
			var goToState = this.$rootScope.transition.from();
			var theState = goToState.name;
			if (theState === "") {
				theState = goToState.url;
			}
			this.$state.go(theState);
		}
	}]);

	return Controller;
}();

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _applicationTypes = __webpack_require__(58);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AddNewApplicationResource', 'Alert', 'SlackInfoService'];

    /** @ngInject */
    function Controller($state, AddNewApplicationResource, Alert, SlackInfoService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AddNewApplicationResource = AddNewApplicationResource;
        this.Alert = Alert;
        this.SlackInfoService = SlackInfoService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (!this.state || !this.code) {
                return;
            }

            this.SlackInfoService.processSlackAuth.save({ companyId: this.companyId, state: this.state, code: this.code }, {}).$promise.then(function (data) {
                return _this.Alert('success', 'company.slack-info.installed', { teamID: data.teamName });
            }).catch(function () {
                return _this.Alert('danger', 'company.slack-info.error');
            }).finally(function () {
                return _this.$state.go('company.slack-info', { state: null, code: null });
            });
        }
    }, {
        key: 'getSlackAuthorizeUrl',
        value: function getSlackAuthorizeUrl() {
            var _this2 = this;

            this.SlackInfoService.getSlackAuthorizeUrl.get({ companyId: this.companyId }).$promise.then(function (data) {
                return window.location.assign(data.url);
            }, function () {
                return _this2.Alert('danger', 'company.slack-info.error');
            });
        }
    }, {
        key: 'showAddApplicationModal',
        value: function showAddApplicationModal() {
            var _this3 = this;

            this.AddNewApplicationResource.createSecureApp(this.companyId, (0, _applicationTypes.appTypeId)('slack')).then(function (app) {
                return _this3.$state.go('company.manage-application', { appId: app.id });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            this.smsAutoApproval = this.resolve.smsAutoApproval;
        }
    }, {
        key: "submit",
        value: function submit() {
            this.close({ $value: this.smsAutoApproval });
        }
    }, {
        key: "notModified",
        value: function notModified() {
            return this.smsAutoApproval === this.resolve.smsAutoApproval;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$translate"];

    /** @ngInject */
    function Controller($translate) {
        _classCallCheck(this, Controller);

        this.$translate = $translate;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "templateUrl",
        value: function templateUrl() {
            return __webpack_require__(1927)("./how-to-add-sms-user-" + this.$translate.use() + ".html");
        }
    }]);

    return Controller;
}();

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$translate"];

    /** @ngInject */
    function Controller($translate) {
        _classCallCheck(this, Controller);

        this.$translate = $translate;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "templateUrl",
        value: function templateUrl() {
            return __webpack_require__(1938)("./sms-credit-" + this.$translate.use() + ".html");
        }
    }]);

    return Controller;
}();

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.tab = 'what-is-sms-service';
        }
    }]);

    return Controller;
}();

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$translate"];

    /** @ngInject */
    function Controller($translate) {
        _classCallCheck(this, Controller);

        this.$translate = $translate;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "templateUrl",
        value: function templateUrl() {
            return __webpack_require__(1952)("./sms-settings-" + this.$translate.use() + ".html");
        }
    }]);

    return Controller;
}();

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$translate"];

    /** @ngInject */
    function Controller($translate) {
        _classCallCheck(this, Controller);

        this.$translate = $translate;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "templateUrl",
        value: function templateUrl() {
            return __webpack_require__(1963)("./what-is-sms-service-" + this.$translate.use() + ".html");
        }
    }]);

    return Controller;
}();

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert'];

    /** @ngInject */
    function Controller($state, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$state.go('^').then(function () {
                return _this.Alert('danger', 'company.sms-services.paypal-cancelled.payment-cancelled');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$state', '$timeout', 'Alert', 'SmsServices'];

    /** @ngInject */
    function Controller($q, $state, $timeout, Alert, SmsServices) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Alert = Alert;
        this.SmsServices = SmsServices;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.page = 3;
        }
    }, {
        key: 'purchase',
        value: function purchase() {
            var _this = this;

            this.finalizeCheckoutPayment('DS').then(function () {
                return _this.page = 4;
            });
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            var _this2 = this;

            this.$q.resolve(this.page === 3 && this.finalizeCheckoutPayment('CA')).then(function () {
                _this2.Alert('success', 'company.sms-services.paypal-confirmed.payment-cancelled');
                _this2.$state.go('^');
            });
        }

        /** @private */

    }, {
        key: 'finalizeCheckoutPayment',
        value: function finalizeCheckoutPayment(status) {
            var _this3 = this;

            return this.SmsServices.finalizeCheckoutPayment(this.$state.params.companyId, this.payment.token, status).catch(function (error) {
                if (!error.data) {
                    _this3.Alert('danger', 'company.sms-services.paypal-confirmed.payment-failed');
                }
                throw error;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'SmsServices'];

    /** @ngInject */
    function Controller($state, SmsServices) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.SmsServices = SmsServices;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.page = 1;
            this.acceptTerms = false;
            this.packageType = 100;
        }
    }, {
        key: 'checkout',
        value: function checkout() {
            var _this = this;

            this.SmsServices.setupExpressCheckout(this.$state.params.companyId, this.packageType).then(function (_ref) {
                var url = _ref.url;
                return window.location.href = url;
            }).catch(function (error) {
                return _this.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'CorporateSettingsService', 'SmsUsageReportModal'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, CorporateSettingsService, SmsUsageReportModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.CorporateSettingsService = CorporateSettingsService;
        this.SmsUsageReportModal = SmsUsageReportModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.periodFilter = 'TODAY';
            this.startDate = new Date();
            this.endDate = new Date();
        }
    }, {
        key: 'purchase',
        value: function purchase() {
            if (this.settings.phoneNumber) {
                this.$uibModal.open({ component: 'smsPurchase' });
            } else {
                this.Alert('danger', 'company.sms-services.phone-number-required');
            }
        }
    }, {
        key: 'editSmsApproval',
        value: function editSmsApproval() {
            var _this = this;

            this.$uibModal.open({
                component: 'editCorporateSmsSettings',
                resolve: { smsAutoApproval: function smsAutoApproval() {
                        return _this.settings.smsAutoApproval;
                    } }
            }).result.then(function (smsAutoApproval) {
                _this.updatingSmsApproval = true;
                _this.CorporateSettingsService.save(_this.companyId, _extends({}, _this.settings, { smsAutoApproval: smsAutoApproval })).then(function () {
                    return _this.$state.reload(_this.$state.current);
                }).then(function () {
                    return _this.Alert('success', 'corporate.message.updated');
                }).finally(function () {
                    return _this.updatingSmsApproval = false;
                });
            });
        }
    }, {
        key: 'getReport',
        value: function getReport() {
            if (this.periodFilter === 'CUSTOM' && this.endDate < this.startDate) {
                this.Alert('danger', 'company.sms-services.invalid-date-range');
                return;
            }
            this.SmsUsageReportModal({
                periodFilter: this.periodFilter,
                startDate: this.startDate.toLocaleDateString(),
                endDate: this.endDate.toLocaleDateString()
            });
        }
    }, {
        key: 'turnOffSmsSupport',
        value: function turnOffSmsSupport() {
            var _this2 = this;

            this.$uibModal.open({ component: 'companySmsServicesConfirmTurnOff' }).result.then(function () {
                return _this2.toggleSmsSupport(false);
            }).then(function () {
                return _this2.$state.reload(_this2.$state.current);
            }).then(function () {
                return _this2.Alert('success', 'company.sms-services.sms-support-turned-off');
            });
        }
    }, {
        key: 'turnOnSmsSupport',
        value: function turnOnSmsSupport() {
            var _this3 = this;

            this.toggleSmsSupport(true).then(function () {
                return _this3.$state.reload(_this3.$state.current);
            }).then(function () {
                return _this3.Alert('success', 'company.sms-services.sms-support-turned-on');
            });
        }

        /** @private */

    }, {
        key: 'toggleSmsSupport',
        value: function toggleSmsSupport(smsSupported) {
            var _this4 = this;

            this.isToggling = true;
            return this.CorporateSettingsService.save(this.companyId, _extends({}, this.settings, { smsSupported: smsSupported })).then(function () {
                return _this4.settings.smsSupported = smsSupported;
            }).finally(function () {
                return _this4.isToggling = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.usageReport = this.resolve.usageReport;
            this.st = new _smartTable.SmartTable();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'SoftwareLicenseManagementService'];

    /** @ngInject */
    function Controller($state, Alert, SoftwareLicenseManagementService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.SoftwareLicenseManagementService = SoftwareLicenseManagementService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.samlAppLogo = window.env.urls.samlAppLogo;
            this.slmiDTO = {};
        }
    }, {
        key: 'chooseApp',
        value: function chooseApp() {
            this.selectedApp = this.st.selectedItems[0];
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            window.history.back();
        }
    }, {
        key: 'isFormFilled',
        value: function isFormFilled() {
            return this.slmiDTO.description || this.slmiDTO.licenseCount || this.slmiDTO.licenseCost || this.slmiDTO.renewalDate;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.slmiDTO.applicationId = this.selectedApp.id;
            this.isSaving = true;
            this.SoftwareLicenseManagementService.createSoftwareLicenseManagementInfo(this.companyId, this.slmiDTO).then(function () {
                return _this.$state.go('^', {}, { reload: 'company.software-license-management' });
            }).then(function () {
                return _this.Alert('success', 'global.messages.operation-successful');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'ConfirmDeleteModal', 'SoftwareLicenseManagementService'];

    /** @ngInject */
    function Controller($state, Alert, ConfirmDeleteModal, SoftwareLicenseManagementService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.SoftwareLicenseManagementService = SoftwareLicenseManagementService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.$slmi = angular.copy(this.slmi);
            this.st = new _smartTable.SmartTable();
            this.samlAppLogo = window.env.urls.samlAppLogo;
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.slmi = angular.copy(this.$slmi);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$slmi, this.slmi);
        }
    }, {
        key: 'isFormFilled',
        value: function isFormFilled() {
            return this.slmi.description || this.slmi.licenseCount || this.slmi.licenseCost || this.slmi.renewalDate;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            var slmiDTO = {
                'id': this.slmi.id,
                'applicationId': this.slmi.application.id,
                'licenseCount': this.slmi.licenseCount,
                'licenseCost': this.slmi.licenseCost,
                'renewalDate': this.slmi.renewalDate,
                'description': this.slmi.description
            };

            this.isSaving = true;
            this.SoftwareLicenseManagementService.updateSoftwareLicenseManagementInfo(this.companyId, slmiDTO).then(function () {
                return _this.$state.go('^', {}, { reload: 'company.software-license-management' });
            }).then(function () {
                return _this.Alert('success', 'global.messages.operation-successful');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            window.history.back();
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _this2 = this;

            this.isSaving = true;
            this.ConfirmDeleteModal('company.software-license-management.confirm-delete.text').then(function () {
                _this2.SoftwareLicenseManagementService.deleteSoftwareLicenseManagementInfo(_this2.companyId, _this2.slmi.id).then(function () {
                    _this2.Alert('success', 'global.messages.operation-successful');
                    _this2.$state.go('company.software-license-management', {}, { reload: true });
                });
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['ShowNoteModal'];

    /** @ngInject */
    function Controller(ShowNoteModal) {
        _classCallCheck(this, Controller);

        this.ShowNoteModal = ShowNoteModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'showDescription',
        value: function showDescription(description) {
            this.ShowNoteModal('company.software-license-management.description', description);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$stateParams', '$http'];

    /** @ngInject */
    function Controller($stateParams, $http) {
        _classCallCheck(this, Controller);

        this.$stateParams = $stateParams;
        this.$http = $http;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            var ctrl = this;
            this.callServer = function callServer(tableState) {
                ctrl.isLoading = true;
                var pagination = tableState.pagination;
                var page = pagination.start / pagination.number;
                var number = pagination.number;

                var searchText = tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '';
                var sort = tableState.sort.predicate;
                var sortReverse = tableState.sort.reverse;
                if (ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                    ctrl.page = page;
                    ctrl.number = number;
                    ctrl.searchText = searchText;
                    ctrl.sort = sort;
                    ctrl.sortReverse = sortReverse;
                    var url = 'app/rest/v2/company/' + ctrl.$stateParams.companyId + '/saaspassadmin/list-all';
                    var params = { page: ctrl.page };
                    ctrl.$http.post(url, { page: ctrl.page, itemPerPage: number, searchText: searchText, sort: sort, reverse: sortReverse }).then(function (_ref) {
                        var data = _ref.data;
                        return data;
                    }).then(function (dto) {
                        pagination.totalItemCount = dto.totalElements;
                        pagination.numberOfPages = dto.totalPages;
                        ctrl.st.displayedItems = dto.content;
                    }).finally(function () {
                        return ctrl.isLoading = false;
                    });
                }
            };
        }
    }]);

    return Controller;
}();

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'DestructiveOperationModal', 'Alert'];

    /** @ngInject */
    function Controller($state, DestructiveOperationModal, Alert) {
        _classCallCheck(this, Controller);

        this.DestructiveOperationModal = DestructiveOperationModal;
        this.$state = $state;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.stAdministrators = new _smartTable.SmartTable();
            this.stDirectories = new _smartTable.SmartTable();

            this.administrators = this.cmpDetail.administrators;
            this.directories = this.cmpDetail.directories;
            this.domains = this.cmpDetail.domains;
            this.company = this.cmp.company;
        }
    }, {
        key: 'deleteCompany',
        value: function deleteCompany() {
            var _this = this;

            var companyId = this.$state.params.companyId;
            var cmpId = this.cmpDetail.companyId;
            var url = 'app/rest/v2/company/' + companyId + '/saaspassadmin/company/' + cmpId;
            this.DestructiveOperationModal({
                titleKey: 'global.confirm_delete',
                textKey: 'Company and all related data will be deleted. This action can not be undone. <br><br>Are you sure you want to permanantly delete this company?',
                http: { method: 'DELETE', url: url }
            }).then(function () {
                _this.Alert('success', 'Company and all related data is deleted');
                _this.$state.go('^', {}, { reload: '^' });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _account = __webpack_require__(48);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['GroupsResource'];

    /** @ngInject */
    function Controller(GroupsResource) {
        _classCallCheck(this, Controller);

        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            var ctrl = this;
            this.displayed = [];
            this.callServer = function callServer(tableState) {
                ctrl.isLoading = true;
                var pagination = tableState.pagination;
                var page = pagination.start / pagination.number;
                var number = pagination.number;
                var searchText = tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '';
                var sort = tableState.sort.predicate;
                var sortReverse = tableState.sort.reverse;
                if (ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                    ctrl.page = page;
                    ctrl.number = number;
                    ctrl.searchText = searchText;
                    ctrl.sort = sort;
                    ctrl.sortReverse = sortReverse;
                    ctrl.GroupsResource.getAllAccountsForCompanyAndEveryoneGroupWithPagination(ctrl.companyId, ctrl.page, ctrl.number, ctrl.searchText, ctrl.sort, ctrl.sortReverse).then(function (dto) {
                        pagination.totalItemCount = dto.totalElements;
                        pagination.numberOfPages = dto.totalPages;
                        ctrl.st.displayedItems = dto.content.map(_account.accountFromDto);
                    }).finally(function () {
                        return ctrl.isLoading = false;
                    });
                }
            };
        }
    }, {
        key: 'selectedDeletableItems',
        value: function selectedDeletableItems() {
            return this.st.selectedItems.filter(function (_ref) {
                var accountType = _ref.accountType,
                    isAdmin = _ref.isAdmin;
                return accountType !== 'AD' && !isAdmin;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'copy',
        value: function copy() {
            var _this = this;

            var accountIds = this.accounts.map(function (_ref) {
                var id = _ref.id;
                return id;
            });

            this.isSaving = true;
            this.AccountsResource.copyUsersToGroup(this.companyId, this.st.selectedIds, accountIds).then(function () {
                return _this.$state.go('^');
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.directory-groups.all-accounts.copy.copied');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.selectedAccounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
            this.selectedAdAccounts = this.selectedAccounts.filter(function (account) {
                return account.accountType === 'AD';
            });
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _this = this;

            var accountIds = this.selectedAccounts.filter(function (_ref) {
                var isDeletable = _ref.isDeletable;
                return isDeletable;
            }).map(function (_ref2) {
                var id = _ref2.id;
                return id;
            });

            this.isSaving = true;
            this.AccountsResource.deleteUserAccounts(this.companyId, accountIds).then(function () {
                _this.Alert('success', 'company.user-directories.directory-groups.all-accounts.delete.deleted');
                _this.$state.go('^');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
            this.export = {
                template: 'groupsusers',
                name: this.currentCompany.companyName + '-all-users',
                fields: ['username', 'user', 'accountType', 'status']
            };
        }
    }]);

    return Controller;
}();

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.resendIfActive = true;
        }
    }, {
        key: 'send',
        value: function send() {
            var _this = this;

            this.Alert('info', 'company.user-directories.directory-groups.all-accounts.verify.re-sending-verifications');

            this.isSaving = true;
            this.AccountsResource.resendVerificationEmailForDirectoryAccounts(this.companyId, this.resendIfActive).then(function () {
                return _this.$state.go('^');
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.directory-groups.all-accounts.verify.re-sending-verifications-success');
            }).catch(function () {
                return _this.Alert('danger', 'company.user-directories.directory-groups.all-accounts.verify.re-sending-verifications-error');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller($state, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.groupName = '';
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.GroupsResource.createNewCustomGroup(this.companyId, this.groupName).then(function (_ref) {
                var id = _ref.id;
                return _this.$state.go('company.user-directories.manage-group.accounts.add', { groupId: id });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.directory-groups.directory.add-new-group.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$state', '$uibModal', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($q, $state, $uibModal, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.username = this.userAccountEmail;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            var rejectAlreadyExistingAccount = function rejectAlreadyExistingAccount(account) {
                if (account.justCreated) {
                    return _this.$q.resolve(account);
                } else {
                    _this.$uibModal.open({ component: 'companyUserDirectoriesManageUserAddAccountAccountAlreadyExists' }).result.then(function () {
                        return _this.$state.go('company.user-directories.manage-account', { accountId: account.id });
                    });
                    return _this.$q.reject();
                }
            };

            this.isSaving = true;
            this.AccountsResource.addNewUserAccount(this.companyId, this.username).then(rejectAlreadyExistingAccount).then(function (account) {
                return _this.$state.go('company.user-directories.manage-account', { accountId: account.id });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.directory-groups.directory.add-user.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _directory = __webpack_require__(203);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.st = {};
            this.domains.forEach(function (domain) {
                return _this.st[domain.domainName] = new _smartTable.SmartTable();
            });
            this.isAzure = (0, _directory.isAzure)(this.directory);
        }
    }, {
        key: 'reload',
        value: function reload() {
            var _this2 = this;

            this.isReloading = true;
            this.$state.reload(this.$state.current).finally(function () {
                return _this2.isReloading = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$filter', '$state', 'AccountsResource', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller($filter, $state, AccountsResource, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$filter = $filter;
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.file = null;
            this.allowChangeOwner = true;
            this.verificationTypes = [{ name: 'USER', selected: true }, { name: 'ADMIN', selected: true }];
        }
    }, {
        key: 'selectCsv',
        value: function selectCsv() {
            document.querySelector('input[type=file]').click();
        }
    }, {
        key: 'uploadCSV',
        value: function uploadCSV() {
            var _this = this;

            var verificationTypes = this.verificationTypes.filter(function (verificationType) {
                return verificationType.selected;
            }).map(function (verificationType) {
                return verificationType.name;
            });

            this.AccountsResource.uploadUsers(this.companyId, verificationTypes, this.allowChangeOwner, this.file).then(function (importResult) {

                var accountIds = importResult.importedUsers.map(function (_ref) {
                    var importedUser = _ref.importedUser;
                    return importedUser.id;
                }).filter(function (v) {
                    return v;
                });

                if (!accountIds.length) {
                    return importResult;
                }

                return _this.GroupsResource.createNewCustomGroup(_this.companyId, 'imported ' + _this.$filter('date')(new Date(), 'MM/dd/yyyy HH:mm:ss')).then(function (group) {
                    return _this.AccountsResource.copyUsersToGroup(_this.companyId, [group.id], accountIds).then(function () {
                        return _extends({}, importResult, { group: group });
                    });
                });
            }).then(function (importResult) {
                return _this.$state.go('.upload-result', { importResult: importResult }, { reload: '^' });
            }).catch(function (_ref2) {
                var status = _ref2.status;

                document.querySelector('input[type=file]').value = '';
                _this.file = null;
                if (status === 500 || status === 413) {
                    _this.Alert('danger', 'company.user-directories.directory-groups.directory.import-users.failed');
                }
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.importResult) {
                this.$state.go('^', {}, { location: 'replace' });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["GroupsResource"];

    /** @ngInject */
    function Controller(GroupsResource) {
        _classCallCheck(this, Controller);

        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            this.GroupsResource.deleteGroups(this.resolve.companyId, this.resolve.groupIds).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$uibModal', 'Alert'];

    /** @ngInject */
    function Controller($uibModal, Alert) {
        _classCallCheck(this, Controller);

        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.stApplicationGroups = new _smartTable.SmartTable();
            this.stCustomGroups = new _smartTable.SmartTable();
            this.stSmartGroups = new _smartTable.SmartTable();

            this.applicationGroups = this.groups.filter(function (_ref) {
                var type = _ref.type;
                return type === 'APPLICATION';
            });
            this.customGroups = this.groups.filter(function (_ref2) {
                var type = _ref2.type;
                return type === 'CUSTOM';
            });
            this.smartGroups = this.groups.filter(function (_ref3) {
                var type = _ref3.type;
                return !['APPLICATION', 'CUSTOM'].includes(type);
            });
        }
    }, {
        key: 'showRemoveGroupsModal',
        value: function showRemoveGroupsModal() {
            var _this = this;

            var selectedIds = this.stCustomGroups.selectedIds;

            this.$uibModal.open({
                component: 'companyUserDirectoriesDirectoryGroupsDirectoryRemoveGroups',
                resolve: {
                    companyId: function companyId() {
                        return _this.companyId;
                    },
                    groupIds: function groupIds() {
                        return selectedIds;
                    }
                }
            }).result.then(function () {
                var _groups;

                var groups = _this.groups.filter(function (group) {
                    return !selectedIds.includes(group.id);
                });
                (_groups = _this.groups).splice.apply(_groups, [0, _this.groups.length].concat(_toConsumableArray(groups)));
                _this.$onInit();
                _this.Alert('success', 'company.user-directories.directory-groups.directory.remove-groups.removed');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _smartTable = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;

        this.st = new _smartTable.SmartTable();
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var attributesMap = null;
            if (this.profileAttributes.profile.customAttributes != undefined) {
                attributesMap = JSON.parse(this.profileAttributes.profile.customAttributes);
            }

            var attribs = [];
            for (var key in attributesMap) {
                attribs.push({ name: key, value: attributesMap[key] });
            }
            this.$attribs = angular.copy(attribs);
            this.attribs = angular.copy(attribs);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;

            var attribsMap = this.attribs.reduce(function (map, obj) {
                map[obj.name] = obj.value;
                return map;
            }, {});
            this.AccountsResource.updateCustomAttributes(this.companyId, this.accountId, attribsMap).then(function () {
                _this.$state.go('.', {}, { reload: '.' });
                _this.Alert('success', 'company.user-directories.custom-attributes.saved');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'validateAttributes',
        value: function validateAttributes() {
            var names = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.attribs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var attrib = _step.value;

                    if (attrib.name.length == 0 || attrib.value.length == 0) {
                        return false;
                    }
                    if (names.includes(attrib.name)) {
                        return false;
                    }
                    names.push(attrib.name);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return true;
        }
    }, {
        key: 'add',
        value: function add() {
            this.attribs.push({ name: '', value: '' });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.notModified() || !this.validateAttributes();
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.attribs, this.$attribs);
        }
    }, {
        key: 'remove',
        value: function remove(attrib) {
            this.attribs = this.attribs.filter(function (a) {
                return a !== attrib;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.attribs = angular.copy(this.$attribs);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _account = __webpack_require__(48);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'AccountsResource', 'Alert', 'SharedEmailAccountModal'];

    /** @ngInject */
    function Controller($state, $uibModal, AccountsResource, Alert, SharedEmailAccountModal) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.SharedEmailAccountModal = SharedEmailAccountModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.account = (0, _account.accountFromDto)(this.account, this.account.companyUser);
        }
    }, {
        key: 'invalidateVerificationButtonVisible',
        value: function invalidateVerificationButtonVisible() {
            return this.account.activeVerification || this.account.accountType == 'SIMPLE_USERNAME' || this.account.accountType == 'AD';
        }
    }, {
        key: 'setupVerificationPanelVisible',
        value: function setupVerificationPanelVisible() {
            return !this.account.emailAddress && (this.account.accountType == 'SIMPLE_USERNAME' || this.account.accountType == 'AD');
        }
    }, {
        key: 'sendVerificationEmail',
        value: function sendVerificationEmail() {
            var _this = this;

            this.isSending = true;
            this.AccountsResource.sendVerificationEmail(this.companyId, this.account.id, this.account.emailAddress).then(function () {
                return _this.$state.reload('company.user-directories.manage-account');
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-account.details.resent-verification');
            }).finally(function () {
                return _this.isSending = false;
            });
        }
    }, {
        key: 'invalidateVerificationData',
        value: function invalidateVerificationData() {
            var _this2 = this;

            this.isInvalidating = true;
            this.AccountsResource.invalidateVerificationData(this.companyId, this.account.id).then(function () {
                return _this2.$state.reload('company.user-directories.manage-account');
            }).finally(function () {
                return _this2.isInvalidating = false;
            });
        }
    }, {
        key: 'showDeleteAccountModal',
        value: function showDeleteAccountModal() {
            var _this3 = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageAccountRemove',
                resolve: {
                    accountId: function accountId() {
                        return _this3.account.id;
                    },
                    companyId: function companyId() {
                        return _this3.companyId;
                    }
                }
            }).result.then(function () {
                return _this3.$state.go('company.user-directories');
            }).then(function () {
                return _this3.Alert('success', 'company.user-directories.manage-account.remove.removed');
            });
        }
    }, {
        key: 'showRemoveOwnerModal',
        value: function showRemoveOwnerModal() {
            var _this4 = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageAccountRemoveOwner',
                resolve: {
                    accountId: function accountId() {
                        return _this4.account.id;
                    },
                    companyId: function companyId() {
                        return _this4.companyId;
                    }
                }
            }).result.then(function () {
                return _this4.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this4.Alert('success', 'company.user-directories.manage-account.owner.remove.removed');
            });
        }
    }, {
        key: 'showShareModal',
        value: function showShareModal() {
            var _this5 = this;

            this.isOpeningModal = true;
            this.SharedEmailAccountModal(this.account.username, this.account.companyUser.id).then(function () {
                return _this5.$state.reload('company.user-directories.manage-account');
            }).finally(function () {
                return _this5.isOpeningModal = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'add',
        value: function add() {
            var _this = this;

            this.isSaving = true;
            this.AccountsResource.assignUserToGroups(this.companyId, this.account.id, this.st.selectedIds).then(function () {
                return _this.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-account.groups-apps.add-to-groups.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.samlAppLogo = window.env.urls.samlAppLogo;
        }
    }, {
        key: 'isSelectable',
        value: function isSelectable(item) {
            return ['CUSTOM', 'APPLICATION'].includes(item.group.type);
        }
    }, {
        key: 'ifSelectable',
        value: function ifSelectable(item) {
            return this.isSelectable(item) && item;
        }
    }, {
        key: 'showRemoveFromGroupsModal',
        value: function showRemoveFromGroupsModal() {
            var _this = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageAccountGroupsAppsRemoveFromGroups',
                resolve: {
                    accountId: function accountId() {
                        return _this.accountId;
                    },
                    companyId: function companyId() {
                        return _this.companyId;
                    },
                    groupIds: function groupIds() {
                        return _this.st.selectedItems.map(function (_ref) {
                            var group = _ref.group;
                            return group.id;
                        });
                    }
                }
            }).result.then(function () {
                return _this.$state.reload(_this.$state.current);
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-account.groups-apps.remove-from-groups.removed');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["AccountsResource"];

    /** @ngInject */
    function Controller(AccountsResource) {
        _classCallCheck(this, Controller);

        this.AccountsResource = AccountsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            this.AccountsResource.removeUserFromGroups(this.resolve.companyId, this.resolve.accountId, this.resolve.groupIds).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'showAddToGroups',
        value: function showAddToGroups() {
            return this.$state.is('company.user-directories.manage-account.groups-apps');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["AccountsResource"];

    /** @ngInject */
    function Controller(AccountsResource) {
        _classCallCheck(this, Controller);

        this.AccountsResource = AccountsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "change",
        value: function change() {
            var _this = this;

            this.isSaving = true;
            this.AccountsResource.changeOwner(this.resolve.companyId, this.resolve.accountId, this.resolve.newOwner).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'UsersResource'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, UsersResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.searchText = '';
        }
    }, {
        key: 'search',
        value: function search() {
            var _this = this;

            this.spAlert = null;
            this.selectedCompanyUser = null;

            if (this.searchText === this.account.companyUser.saaspassUser.saaspassId) {
                this.Alert('danger', 'company.user-directories.manage-account.owner.same-user', false);
                return;
            }

            if (this.searchText === this.account.emailAddress) {
                this.Alert('danger', 'company.user-directories.manage-account.owner.same-email', false);
                return;
            }

            this.isSearching = true;

            this.UsersResource.getCompanyUserForSaaspassUser(this.companyId, this.searchText).then(function (companyUser) {
                if (companyUser.id === _this.account.companyUser.id || companyUser.saaspassUser.id === _this.account.companyUser.saaspassUser.id) {
                    _this.Alert('danger', 'company.user-directories.manage-account.owner.same-user', false);
                } else {
                    _this.selectedCompanyUser = companyUser;
                }
            }).catch(function (response) {
                if (response.status === 404) {
                    _this.Alert('danger', 'company.user-directories.manage-account.owner.user-not-found', false);
                }
            }).finally(function () {
                return _this.isSearching = false;
            });
        }
    }, {
        key: 'showChangeModal',
        value: function showChangeModal() {
            var _this2 = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageAccountChangeOwnerConfirm',
                resolve: {
                    accountId: function accountId() {
                        return _this2.account.id;
                    },
                    companyId: function companyId() {
                        return _this2.companyId;
                    },
                    newOwner: function newOwner() {
                        return _this2.selectedCompanyUser;
                    }
                }
            }).result.then(function () {
                return _this2.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this2.Alert('success', 'company.user-directories.manage-account.owner.change.success');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["AccountsResource"];

    /** @ngInject */
    function Controller(AccountsResource) {
        _classCallCheck(this, Controller);

        this.AccountsResource = AccountsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            this.AccountsResource.removeAccountOwner(this.resolve.companyId, this.resolve.accountId).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _googleLibphonenumber = __webpack_require__(194);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.$profile = this.profileFromDto();
            this.profile = this.profileFromDto();
            this.PNU = _googleLibphonenumber.PhoneNumberUtil.getInstance();
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.AccountsResource.updateProfileAttributes(this.companyId, this.accountId, this.profile).then(function (profile) {
                Object.assign(_this.profileAttributes.profile, profile);
                _this.$state.go('^', {}, { reload: 'company.user-directories.manage-account' });
                _this.Alert('success', 'company.user-directories.manage-account.profile-attributes.edit.saved');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'profileFromDto',
        value: function profileFromDto() {
            var profile = this.profileAttributes.profile;
            return {
                id: profile.id,
                firstName: profile.firstName || '',
                lastName: profile.lastName || '',
                email: profile.email || '',
                phoneNumber: profile.phoneNumber || '',
                city: profile.city || '',
                streetAddress: profile.streetAddress || '',
                country: profile.country || '',
                department: profile.department || '',
                jobTitle: profile.jobTitle || '',
                companyName: profile.companyName || '',
                zipCode: profile.zipCode || '',
                customAttributes: profile.customAttributes
            };
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.$profile, this.profile);
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.invalidPhoneNumber || this.isSaving || this.notModified();
        }
    }, {
        key: 'validatePhoneNumber',
        value: function validatePhoneNumber() {
            this.invalidPhoneNumber = !!this.profile.phoneNumber && (!this.PNU.isPossibleNumberString(this.profile.phoneNumber) || !this.PNU.isValidNumber(this.PNU.parse(this.profile.phoneNumber)));
        }
    }]);

    return Controller;
}();

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["AccountsResource"];

    /** @ngInject */
    function Controller(AccountsResource) {
        _classCallCheck(this, Controller);

        this.AccountsResource = AccountsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            this.AccountsResource.deleteUserAccount(this.resolve.companyId, this.resolve.accountId).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($q, $state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.email = this.account.profileEmailAddress;
        }
    }, {
        key: 'send',
        value: function send() {
            var _this = this;

            this.isSaving = true;
            this.$q.resolve(this.AccountsResource.sendVerificationEmail(this.companyId, this.account.id, this.email)).then(function () {
                return _this.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-account.send-verification-email.sent');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert', 'UsersResource'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert, UsersResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.searchText = '';
        }
    }, {
        key: 'search',
        value: function search() {
            var _this = this;

            this.spAlert = null;
            this.selectedCompanyUser = null;
            this.isSearching = true;

            this.UsersResource.getCompanyUserForSaaspassUser(this.companyId, this.searchText).then(function (companyUser) {
                return _this.selectedCompanyUser = companyUser;
            }).catch(function (response) {
                if (response.status === 404) {
                    _this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            }).finally(function () {
                return _this.isSearching = false;
            });
        }
    }, {
        key: 'verify',
        value: function verify() {
            var _this2 = this;

            this.isVerifying = true;
            this.AccountsResource.verifyAccount(this.companyId, this.account.id, this.selectedCompanyUser).then(function () {
                return _this2.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this2.Alert('success', 'company.user-directories.manage-account.verify.success');
            }).finally(function () {
                return _this2.isVerifying = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _account = __webpack_require__(48);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$state', '$uibModal', 'AccountsResource', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller($q, $state, $uibModal, AccountsResource, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.username = '';
            this.searchText = '';
            this.form = 'existingForm';
            this.st = new _smartTable.SmartTable();
            var ctrl = this;
            this.callServer = function callServer(tableState) {
                ctrl.tableState = tableState;
                ctrl.isLoading = true;
                var pagination = tableState.pagination;
                var page = pagination.start / pagination.number;
                var number = pagination.number;
                var searchText = tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '';
                var sort = tableState.sort.predicate;
                var sortReverse = tableState.sort.reverse;
                if (ctrl.reloadTable || ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                    ctrl.reloadTable = false;
                    ctrl.page = page;
                    ctrl.number = number;
                    ctrl.searchText = searchText;
                    ctrl.sort = sort;
                    ctrl.sortReverse = sortReverse;
                    ctrl.GroupsResource.getAllAccountsInCompanyAndNotInGroupWithPagination(ctrl.companyId, ctrl.group.id, ctrl.page, ctrl.number, ctrl.searchText, ctrl.sort, ctrl.sortReverse).then(function (dto) {
                        pagination.totalItemCount = dto.totalElements;
                        pagination.numberOfPages = dto.totalPages;
                        ctrl.st.displayedItems = dto.content.map(_account.accountFromDto);
                    }).finally(function () {
                        return ctrl.isLoading = false;
                    });
                }
            };
        }
    }, {
        key: 'focusNewForm',
        value: function focusNewForm() {
            this.form = 'newForm';
        }
    }, {
        key: 'focusExistingForm',
        value: function focusExistingForm() {
            this.form = 'existingForm';
            this.searchText = '';
            if (this.tableState) {
                this.reloadTable = true;
            }
            this.username = '';
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            var rejectAlreadyExistingAccount = function rejectAlreadyExistingAccount(account) {
                if (account.justCreated) {
                    return _this.$q.resolve(account);
                } else {
                    _this.$uibModal.open({ component: 'companyUserDirectoriesManageUserAddAccountAccountAlreadyExists' }).result.then(function () {
                        return _this.$state.go('company.user-directories.manage-account', { accountId: account.id });
                    });
                    return _this.$q.reject();
                }
            };

            this.isSaving = true;
            (this.form === 'newForm' ? this.GroupsResource.addNewUserToGroup(this.companyId, this.group.id, this.username).then(_account.accountFromDto).then(rejectAlreadyExistingAccount) : this.AccountsResource.copyUsersToGroup(this.companyId, [this.group.id], this.st.selectedIds)).then(function () {
                return _this.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-group.accounts.add.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.isSaving || this.isSearching || this.form === 'newForm' && !this.username || this.form === 'existingForm' && !this.st.selectedItems.length;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'GroupsResource'];

    /** @ngInject */
    function Controller($state, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            // this.activeAccounts = this.connectionDetails.activeAccounts;
            // this.pendingAccounts = this.connectionDetails.pendingAccounts;
            // this.allAccounts = this.activeAccounts + this.pendingAccounts;
            this.file = null;
            this.verificationTypes = [{ name: 'USER', selected: true }, { name: 'ADMIN', selected: true }];
        }
    }, {
        key: 'selectCsv',
        value: function selectCsv(csvType) {
            document.querySelector('[ng-change*="' + csvType + '"]').click();
        }
    }, {
        key: 'uploadCsv',
        value: function uploadCsv(csvType) {
            var _this = this;

            var verificationTypes = this.verificationTypes.filter(function (verificationType) {
                return verificationType.selected;
            }).map(function (verificationType) {
                return verificationType.name;
            });

            this.GroupsResource.userVerification(this.companyId, this.groupId, verificationTypes, csvType, this.file).then(function (_ref) {
                var importedUsers = _ref.importedUsers;

                _this.$state.go('^.bulk-verification-result', { importedUsers: importedUsers }, { reload: '^' });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.importedUsers) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.activeAccounts = this.connectionDetails.activeAccounts;
            this.pendingAccounts = this.connectionDetails.pendingAccounts;
            this.allAccounts = this.activeAccounts + this.pendingAccounts;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$translate', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller($state, $translate, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$translate = $translate;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'csvImportAvailable',
        value: function csvImportAvailable() {
            return this.group.directory && this.group.directory.type == 'AD';
        }
    }, {
        key: 'resendVerifications',
        value: function resendVerifications() {
            var _this = this;

            this.isSaving = true;

            this.Alert('info', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications');

            this.GroupsResource.resendVerifications(this.companyId, this.group).then(function () {
                _this.Alert('success', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications-success');
            }).catch(function () {
                _this.Alert('danger', 'company.user-directories.directory-groups.directory.bulk-verification.re-sending-verifications-error');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'templateUrl',
        value: function templateUrl() {
            return __webpack_require__(2107)("./bulk-verification-" + this.$translate.use() + '.html');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'copy',
        value: function copy() {
            var _this = this;

            var accountIds = this.accounts.map(function (_ref) {
                var id = _ref.id;
                return id;
            });

            this.isSaving = true;
            this.AccountsResource.copyUsersToGroup(this.companyId, this.st.selectedIds, accountIds).then(function () {
                return _this.$state.go('^');
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-group.accounts.copy.copied');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.selectedAccounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
            this.selectedAdAccounts = this.selectedAccounts.filter(function (account) {
                return account.accountType === 'AD';
            });
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            var accountIds = this.selectedAccounts.filter(function (_ref) {
                var isDeletable = _ref.isDeletable;
                return isDeletable;
            }).map(function (_ref2) {
                var id = _ref2.id;
                return id;
            });

            this.isSaving = true;
            this.AccountsResource.deleteUserAccounts(this.companyId, accountIds).then(function () {
                _this.Alert('success', 'company.user-directories.manage-group.accounts.delete.deleted');
                _this.$state.go('^');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
            this.export = {
                template: 'groupsusers',
                name: this.currentCompany.companyName + '_' + this.group.groupName + '_Users',
                fields: ['username', 'user', 'accountType', 'status']
            };
        }
    }]);

    return Controller;
}();

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _account = __webpack_require__(48);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.isAD = ['AD_DOMAIN', 'AD_GROUP', 'AD_OU'].includes(this.group.type);

            var ctrl = this;
            this.displayed = [];
            this.callServer = function callServer(tableState) {
                ctrl.isLoading = true;
                var pagination = tableState.pagination;
                var page = pagination.start / pagination.number;
                var number = pagination.number;
                var searchText = tableState.search.predicateObject ? tableState.search.predicateObject.searchText : '';
                var sort = tableState.sort.predicate;
                var sortReverse = tableState.sort.reverse;
                if (ctrl.page != page || ctrl.number != number || ctrl.searchText != searchText || ctrl.sort != sort || ctrl.sortReverse != sortReverse) {
                    ctrl.page = page;
                    ctrl.number = number;
                    ctrl.searchText = searchText;
                    ctrl.sort = sort;
                    ctrl.sortReverse = sortReverse;
                    ctrl.GroupsResource.getAllAccountsForCompanyAndGroupWithPagination(ctrl.companyId, ctrl.group.id, ctrl.page, ctrl.number, ctrl.searchText, ctrl.sort, ctrl.sortReverse).then(function (dto) {
                        pagination.totalItemCount = dto.totalElements;
                        pagination.numberOfPages = dto.totalPages;
                        ctrl.st.displayedItems = dto.content.map(_account.accountFromDto);
                    }).finally(function () {
                        return ctrl.isLoading = false;
                    });
                }
            };
        }
    }, {
        key: 'selectedDeletableItems',
        value: function selectedDeletableItems() {
            return this.st.selectedItems.filter(function (account) {
                return account.isDeletable;
            });
        }
    }, {
        key: 'showRemoveModal',
        value: function showRemoveModal() {
            var _this = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageGroupAccountsRemove',
                resolve: {
                    companyId: function companyId() {
                        return _this.companyId;
                    },
                    groupId: function groupId() {
                        return _this.group.id;
                    },
                    accountIds: function accountIds() {
                        return _this.st.selectedIds;
                    }
                }
            }).result.then(function () {
                var key = 'company.user-directories.manage-group.accounts.remove.removed';
                var variables = { groupName: _this.group.groupName };
                _this.Alert('success', key, variables);
                _this.$state.go(_this.$state.current, {}, { reload: true });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.file = null;
            this.allowChangeOwner = true;
            this.verificationTypes = [{ name: 'USER', selected: true }, { name: 'ADMIN', selected: true }];
        }
    }, {
        key: 'selectCsv',
        value: function selectCsv() {
            document.querySelector('input[type=file]').click();
        }
    }, {
        key: 'uploadCSV',
        value: function uploadCSV() {
            var _this = this;

            var verificationTypes = this.verificationTypes.filter(function (verificationType) {
                return verificationType.selected;
            }).map(function (verificationType) {
                return verificationType.name;
            });

            this.AccountsResource.uploadUsers(this.companyId, verificationTypes, this.allowChangeOwner, this.file, this.group.id).then(function (importResult) {
                return _this.$state.go('.result', { importResult: importResult }, { reload: '^' });
            }).catch(function (_ref) {
                var status = _ref.status;

                document.querySelector('input[type=file]').value = '';
                _this.file = null;
                if (status === 500 || status === 413) {
                    _this.Alert('danger', 'company.user-directories.manage-group.accounts.import.failed');
                }
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.importResult) {
                this.$state.go('^', {}, { location: 'replace' });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'move',
        value: function move() {
            var _this = this;

            var accountIds = this.accounts.map(function (_ref) {
                var id = _ref.id;
                return id;
            });

            this.isSaving = true;
            this.AccountsResource.moveUsersToGroup(this.companyId, this.group.id, this.st.selectedIds[0], accountIds).then(function () {
                return _this.$state.go('^', { groupId: _this.st.selectedIds[0] });
            }).then(function () {
                var key = 'company.user-directories.manage-group.accounts.move.moved';
                var variables = { groupName: _this.st.selectedItems[0].groupName };
                _this.Alert('success', key, variables);
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["AccountsResource"];

    /** @ngInject */
    function Controller(AccountsResource) {
        _classCallCheck(this, Controller);

        this.AccountsResource = AccountsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            this.AccountsResource.removeUsersFromGroup(this.resolve.companyId, this.resolve.groupId, this.resolve.accountIds).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.resendIfActive = true;
        }
    }, {
        key: 'send',
        value: function send() {
            var _this = this;

            this.Alert('info', 'company.user-directories.manage-group.accounts.verify.re-sending-verifications');

            this.isSaving = true;
            this.AccountsResource.resendVerificationEmailForGroup(this.companyId, this.group.id, this.resendIfActive).then(function () {
                return _this.$state.go('^');
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-group.accounts.verify.re-sending-verifications-success');
            }).catch(function () {
                return _this.Alert('danger', 'company.user-directories.manage-group.accounts.verify.re-sending-verifications-error');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller($state, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.samlAppLogo = window.env.urls.samlAppLogo;
        }
    }, {
        key: 'assign',
        value: function assign() {
            var _this = this;

            this.isSaving = true;
            this.GroupsResource.assignGroupToApplication(this.companyId, this.group.id, this.st.selectedIds).then(function () {
                return _this.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-group.applications.assign.assigned');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller($state, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.samlAppLogo = window.env.urls.samlAppLogo;
        }
    }, {
        key: 'unassign',
        value: function unassign() {
            var _this = this;

            this.isSaving = true;
            this.GroupsResource.unassignGroupFromApplications(this.companyId, this.group.id, this.st.selectedIds).then(function () {
                return _this.$state.reload(_this.$state.current);
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-group.applications.unassigned');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _smartTable = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'GroupsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, GroupsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.GroupsResource = GroupsResource;
        this.Alert = Alert;

        this.st = new _smartTable.SmartTable();
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var attribs = [];
            for (var key in this.customAttributes) {
                attribs.push({ name: key, value: this.customAttributes[key] });
            }
            this.$attribs = angular.copy(attribs);
            this.attribs = angular.copy(attribs);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;

            var attribsMap = this.attribs.reduce(function (map, obj) {
                map[obj.name] = obj.value;
                return map;
            }, {});
            this.GroupsResource.updateCustomAttributes(this.companyId, this.group.id, attribsMap).then(function () {
                _this.$state.go('.', {}, { reload: '.' });
                _this.Alert('success', 'company.user-directories.custom-attributes.saved');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'validateAttributes',
        value: function validateAttributes() {
            var names = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.attribs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var attrib = _step.value;

                    if (attrib.name.length == 0 || attrib.value.length == 0) {
                        return false;
                    }
                    if (names.includes(attrib.name)) {
                        return false;
                    }
                    names.push(attrib.name);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return true;
        }
    }, {
        key: 'add',
        value: function add() {
            this.attribs.push({ name: '', value: '' });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.notModified() || !this.validateAttributes();
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.attribs, this.$attribs);
        }
    }, {
        key: 'remove',
        value: function remove(attrib) {
            this.attribs = this.attribs.filter(function (a) {
                return a !== attrib;
            });
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.attribs = angular.copy(this.$attribs);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'showAddAccountButtons',
        value: function showAddAccountButtons() {
            return this.$state.is('company.user-directories.manage-group.accounts') && (this.group.type === 'CUSTOM' || this.group.type === 'APPLICATION');
        }
    }, {
        key: 'showAssignApplicationButton',
        value: function showAssignApplicationButton() {
            return this.$state.is('company.user-directories.manage-group.applications') && this.group.type !== 'APPLICATION';
        }
    }]);

    return Controller;
}();

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["GroupsResource"];

    /** @ngInject */
    function Controller(GroupsResource) {
        _classCallCheck(this, Controller);

        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            this.isSaving = true;
            this.GroupsResource.deleteGroups(this.resolve.companyId, [this.resolve.groupId]).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'GroupsResource'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, GroupsResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'saveGroupName',
        value: function saveGroupName(groupName) {
            var _this = this;

            return this.GroupsResource.renameGroup(this.companyId, this.group.id, groupName).then(function () {
                return _this.$state.reload('company.user-directories');
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-group.settings.renamed');
            });
        }
    }, {
        key: 'showRemoveModal',
        value: function showRemoveModal() {
            var _this2 = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageGroupRemove',
                resolve: {
                    companyId: function companyId() {
                        return _this2.companyId;
                    },
                    groupId: function groupId() {
                        return _this2.group.id;
                    }
                }
            }).result.then(function () {
                if (_this2.group.type == 'CUSTOM') {
                    _this2.$state.go('company.user-directories.directory-groups.directory', { directoryId: 'saaspass-cloud-directory' });
                } else {
                    _this2.$state.go('company.user-directories.directory-groups.directory', { directoryId: _this2.group.directory.id });
                }
            }).then(function () {
                var key = 'company.user-directories.manage-group.remove.removed';
                var variables = { groupName: _this2.group.groupName };
                _this2.Alert('success', key, variables);
            });
        }
    }, {
        key: 'isDeletable',
        value: function isDeletable() {
            var type = this.group.type;
            return type == 'CUSTOM' || type == 'AZURE_AD' || type == 'SCIM_DIRECTORY';
        }
    }]);

    return Controller;
}();

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

var _account = __webpack_require__(48);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$state', '$uibModal', 'AccountsResource', 'Alert', 'UsersResource'];

    /** @ngInject */
    function Controller($q, $state, $uibModal, AccountsResource, Alert, UsersResource) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.username = '';
            this.searchText = '';
            this.lastSearchText = '';
            this.form = 'newForm';
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'focusNewForm',
        value: function focusNewForm() {
            this.form = 'newForm';
            this.searchText = '';
            this.lastSearchText = '';
            this.accounts = null;
        }
    }, {
        key: 'focusExistingForm',
        value: function focusExistingForm() {
            this.form = 'existingForm';
            this.username = '';
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            var addAccount = function addAccount() {
                if (_this.companyUser.id) {
                    return _this.UsersResource.addNewAccountForUser(_this.companyId, _this.companyUser, _this.username).then(rejectAlreadyExistingAccount).then(function (account) {
                        return _this.accountsForCompanyUser.push(account);
                    });
                } else {
                    return _this.UsersResource.addHardtokenUserWithAccount(_this.companyId, _this.companyUser, _this.username).then(function (companyUser) {
                        return Object.assign(_this.companyUser, companyUser);
                    });
                }
            };

            var rejectAlreadyExistingAccount = function rejectAlreadyExistingAccount(account) {
                if (account.justCreated) {
                    return _this.$q.resolve(account);
                } else {
                    _this.$uibModal.open({ component: 'companyUserDirectoriesManageUserAddAccountAccountAlreadyExists' }).result.then(function () {
                        return _this.$state.go('company.user-directories.manage-account', { accountId: account.id });
                    });
                    return _this.$q.reject();
                }
            };

            var verifyAccount = function verifyAccount(account) {
                return _this.AccountsResource.verifyAccount(_this.companyId, account.id, _this.companyUser).then(function () {
                    _this.accountsForCompanyUser.push((0, _account.accountFromDto)(_extends({}, account, { isSelected: false, status: 'ACTIVE' }), _this.companyUser));
                });
            };

            var redirect = function redirect() {
                if (_this.companyUser.id) {
                    return _this.$state.go('^', { companyUserId: _this.companyUser.id });
                } else {
                    // first account is added (inactive hard-token), and company user is created
                    return _this.UsersResource.getCompanyUserForSaaspassUser(_this.companyId, _this.companyUser.saaspassUser.saaspassId).then(function (companyUser) {
                        return _this.$state.go('^', { companyUserId: companyUser.id });
                    });
                }
            };

            this.isSaving = true;
            if (this.form === 'newForm') {
                addAccount().then(redirect).then(function () {
                    return _this.Alert('success', 'company.user-directories.manage-user.accounts.add.added-new');
                }).finally(function () {
                    return _this.isSaving = false;
                });
            } else if (this.st.selectedItems.length) {
                verifyAccount(this.st.selectedItems[0]).then(redirect).then(function () {
                    return _this.Alert('success', 'company.user-directories.manage-user.accounts.add.added-existing');
                }).finally(function () {
                    return _this.isSaving = false;
                });
            }
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled() {
            return this.isSaving || this.isSearching || this.form === 'newForm' && !this.username || this.form === 'existingForm' && !this.st.selectedItems.length;
        }
    }, {
        key: 'search',
        value: function search() {
            var _this2 = this;

            this.isSearching = true;
            this.accounts = null;
            this.AccountsResource.getAccountsByUsername(this.companyId, '', this.searchText).then(function (accounts) {
                return accounts.filter(function (_ref) {
                    var status = _ref.status,
                        accountType = _ref.accountType;
                    return status !== 'ACTIVE' && !['EXTERNAL_EMAIL', 'PHONENUMBER'].includes(accountType);
                });
            }).then(function (accounts) {
                _this2.accounts = accounts;
                _this2.lastSearchText = _this2.searchText;
            }).finally(function () {
                return _this2.isSearching = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'UsersResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, UsersResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }
            this.st = new _smartTable.SmartTable();
            this.translateKey = function (type) {
                return {
                    AD: 'sp-account-type.active-directory',
                    EXTERNAL_EMAIL: 'sp-account-type.external-email',
                    INTERNAL_EMAIL: 'sp-account-type.internal-email',
                    PHONENUMBER: 'sp-account-type.phone-number',
                    SHARED_EMAIL: 'sp-account-type.shared-email',
                    SIMPLE_USERNAME: 'sp-account-type.simple-username'
                }[type];
            };
        }
    }, {
        key: 'search',
        value: function search() {
            var _this = this;

            this.spAlert = null;
            this.selectedCompanyUser = null;
            this.isSearching = true;

            this.UsersResource.getCompanyUserForSaaspassUser(this.companyId, this.searchText).then(function (companyUser) {
                _this.selectedCompanyUser = companyUser;
            }).catch(function (response) {
                if (response.status === 404) {
                    _this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            }).finally(function () {
                return _this.isSearching = false;
            });
        }
    }, {
        key: 'copy',
        value: function copy() {
            var _this2 = this;

            var accountIds = this.accounts.filter(function (_ref) {
                var isCopyable = _ref.isCopyable;
                return isCopyable;
            }).map(function (_ref2) {
                var id = _ref2.id;
                return id;
            });
            this.isSaving = true;

            if (accountIds.length == 0) {
                this.Alert('success', 'company.user-directories.manage-user.copy-accounts.nothingToCopy');
                this.$state.go('company.user-directories.saaspass-users');
            } else {
                this.AccountsResource.bulkCopyCompanyUserAccount(this.companyId, this.companyUser.id, this.selectedCompanyUser, accountIds).then(function () {
                    var accounts = null;
                    _this2.Alert('success', 'company.user-directories.manage-user.copy-accounts.copied');
                    _this2.$state.go('^');
                }).finally(function () {
                    return _this2.isSaving = false;
                });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'UsersResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, UsersResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'search',
        value: function search() {
            var _this = this;

            this.spAlert = null;
            this.selectedCompanyUser = null;
            this.isSearching = true;

            this.UsersResource.getCompanyUserForSaaspassUser(this.companyId, this.searchText).then(function (companyUser) {
                _this.selectedCompanyUser = companyUser;
            }).catch(function (response) {
                if (response.status === 404) {
                    _this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            }).finally(function () {
                return _this.isSearching = false;
            });
        }
    }, {
        key: 'copy',
        value: function copy() {
            var _this2 = this;

            var accountIds = this.accounts.filter(function (_ref) {
                var isCopyable = _ref.isCopyable;
                return isCopyable;
            }).map(function (_ref2) {
                var id = _ref2.id;
                return id;
            });
            this.isSaving = true;
            this.AccountsResource.bulkCopyCompanySharedAccount(this.companyId, this.companyUser.id, this.selectedCompanyUser, accountIds).then(function () {
                var accounts = null;
                _this2.Alert('success', 'company.user-directories.manage-user.move-accounts.moved');
                _this2.$state.go('^');
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.selectedAccounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
            this.selectedAdAccounts = this.selectedAccounts.filter(function (account) {
                return account.accountType === 'AD';
            });
        }
    }, {
        key: 'delete',
        value: function _delete() {
            var _this = this;

            var accountIds = this.selectedAccounts.filter(function (_ref) {
                var isDeletable = _ref.isDeletable;
                return isDeletable;
            }).map(function (_ref2) {
                var id = _ref2.id;
                return id;
            });

            this.isSaving = true;
            this.AccountsResource.deleteUserAccounts(this.companyId, accountIds).then(function () {
                var accounts = _this.accountsForCompanyUser;
                var filteredAccounts = accounts.filter(function (_ref3) {
                    var id = _ref3.id;
                    return !accountIds.includes(id);
                });
                accounts.splice.apply(accounts, [0, accounts.length].concat(_toConsumableArray(filteredAccounts)));
                _this.Alert('success', 'company.user-directories.manage-user.delete-accounts.deleted');

                if (accounts.length) {
                    _this.$state.go('^');
                } else {
                    // When all accounts are deleted, company user is also deleted
                    _this.$state.go('company.user-directories.saaspass-users');
                }
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["UsersResource"];

    /** @ngInject */
    function Controller(UsersResource) {
        _classCallCheck(this, Controller);

        this.UsersResource = UsersResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "delete",
        value: function _delete() {
            var _this = this;

            var _resolve = this.resolve,
                companyId = _resolve.companyId,
                companyUserId = _resolve.companyUserId;


            this.isSaving = true;
            this.UsersResource.deleteCompanyUser(companyId, companyUserId).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$location', '$state', '$uibModal', 'Alert', 'HardTokenResource'];

    /** @ngInject */
    function Controller($location, $state, $uibModal, Alert, HardTokenResource) {
        _classCallCheck(this, Controller);

        this.$location = $location;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.Alert = Alert;
        this.HardTokenResource = HardTokenResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.companyUser = this.resolve.companyUser;
            this.companyId = this.resolve.companyId;
            this.hardTokens = this.resolve.hardTokens.filter(function (token) {
                return token.isSecondaryDeviceOfUser === false;
            });
        }
    }, {
        key: 'assingTokenSecondary',
        value: function assingTokenSecondary(tokenId) {
            var _this = this;

            this.HardTokenResource.assingTokenAsSecondary(this.companyId, this.companyUser.id, tokenId).then(function (data) {
                _this.$state.reload('company.user-directories.manage-user');
                _this.Alert('success', 'company.user-directories.manage-user.device_assigned');
            });
        }
    }, {
        key: 'showConformModal',
        value: function showConformModal(_token) {
            var _this2 = this;

            this.close();
            this.$uibModal.open({
                component: 'companyUserDirectoriesManageUserDetailsAssignHardTokenConfirmAssign',
                resolve: {
                    companyUser: function companyUser() {
                        return _this2.companyUser;
                    },
                    token: function token() {
                        return _token;
                    },
                    companyId: function companyId() {
                        return _this2.companyId;
                    }
                }
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'HardTokenResource'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, HardTokenResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.HardTokenResource = HardTokenResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.companyUser = this.resolve.companyUser;
            this.companyId = this.resolve.companyId;
            this.token = this.resolve.token;
        }
    }, {
        key: 'assingTokenSecondary',
        value: function assingTokenSecondary() {
            var _this = this;

            this.HardTokenResource.assingTokenAsSecondary(this.companyId, this.companyUser.id, this.token.id).then(function (data) {
                _this.$state.reload('company.user-directories.manage-user');
                _this.Alert('success', 'company.user-directories.manage-user.device_assigned');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
				Controller.$inject = ['$state', '$window', '$filter', 'Alert', 'UsersResource'];

				/** @ngInject */
				function Controller($state, $window, $filter, Alert, UsersResource) {
								_classCallCheck(this, Controller);

								this.Alert = Alert;
								this.$state = $state;
								this.UsersResource = UsersResource;
								this.$window = $window;
								this.$filter = $filter;
				}

				_createClass(Controller, [{
								key: '$onInit',
								value: function $onInit() {}
				}, {
								key: 'generateBackupCodes',
								value: function generateBackupCodes() {
												var _this = this;

												var companyId = this.companyId;
												var companyUserId = this.companyUser.id;
												this.isSaving = true;
												//var a = document.createElement("a");
												//document.body.appendChild(a);
												this.UsersResource.getUsersBackupOtps(companyId, companyUserId).then(function (response) {
																//var filename = this.getFileNameFromHttpResponse(response);
																//console.log(filename);
																//var fileURL = this.$window.URL.createObjectURL(response.data);
																//a.href = fileURL;
																//a.download = filename;
																//a.click();
																//setTimeout(function() { this.$window.URL.revokeObjectURL(fileURL); }, 100);
																_this.generatedContent = response;
												}).finally(function () {
																return _this.isSaving = false;
												});
								}
				}, {
								key: 'downloadGeneratedContent',
								value: function downloadGeneratedContent() {
												var timeOfGeneration = new Date(Number(this.generatedContent.timestamp));
												var formatedDate = '#Generated Codes: ' + this.$filter('date')(timeOfGeneration, "dd-MM-yyyy hh:mm:ss");
												var fileContent = formatedDate + "\n\n" + this.generatedContent.backupOtps.join("\n");

												var file = new Blob([fileContent], {
																type: 'text/plain'
												});
												var fileURL = this.$window.URL.createObjectURL(file);
												var a = document.createElement('a');
												a.href = fileURL;
												a.target = '_blank';
												a.download = this.companyUser.saaspassUser.saaspassId + '_emergency_access_codes_company_' + this.currentCompany.companyName + '.txt';
												document.body.appendChild(a);
												a.click();
												setTimeout(function () {
																this.$window.URL.revokeObjectURL(fileURL);
												}, 100);
								}
				}, {
								key: 'getFileNameFromHttpResponse',
								value: function getFileNameFromHttpResponse(httpResponse) {
												var contentDispositionHeader = httpResponse.headers('Content-Disposition');
												var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
												return result.replace(/"/g, '');
								}
				}, {
								key: 'cancel',
								value: function cancel() {
												this.$state.go('^');
								}
				}]);

				return Controller;
}();

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["UsersResource"];

    /** @ngInject */
    function Controller(UsersResource) {
        _classCallCheck(this, Controller);

        this.UsersResource = UsersResource;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "deactivate",
        value: function deactivate() {
            var _this = this;

            this.isSaving = true;
            this.UsersResource.deactivateSmsUsageForCompanyUser(this.resolve.companyId, this.resolve.companyUserId).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

hardTokens.$inject = ['$filter', 'HardTokenService'];

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$state', '$uibModal', 'Alert', 'HardTokenEditModal', 'HardTokenService', 'HardTokenResource', 'UsersResource', 'ConfirmDeleteModal'];

    /** @ngInject */
    function Controller($q, $state, $uibModal, Alert, HardTokenEditModal, HardTokenService, HardTokenResource, UsersResource, ConfirmDeleteModal) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$state = $state;

        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.HardTokenEditModal = HardTokenEditModal;
        this.HardTokenService = HardTokenService;
        this.HardTokenResource = HardTokenResource;
        this.UsersResource = UsersResource;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.stAccounts = new _smartTable.SmartTable();
            this.stDevices = new _smartTable.SmartTable();
            this.stSharedServiceAccounts = new _smartTable.SmartTable();
            this.stSharedNotes = new _smartTable.SmartTable();
            this.emailAccounts = this.accountsForCompanyUser.filter(function (a) {
                return a.status === 'ACTIVE';
            });
            this.notificationEmailAccount = this.emailAccounts.find(function (account) {
                return account.username === _this.companyUser.userIdentifyingName;
            });
            this.isSmsUser = this.companyUser.saaspassUser.userType === 'SMS_USER';
            this.isRoleEditable = this.companyUser.blocked === 'NONE' && this.emailAccounts.length && this.companyUser.saaspassUser.saaspassId !== this.account.login;
            this.initializeUserStatusFlags();
        }
    }, {
        key: 'initializeUserStatusFlags',
        value: function initializeUserStatusFlags() {
            this.isBlocked = this.companyUser.blocked != 'NONE';
            this.isPaused = this.companyUser.status == 'PAUSED';
            this.isActive = this.companyUser.status == 'ACTIVE';
        }
    }, {
        key: 'getSharingTypeDisplayName',
        value: function getSharingTypeDisplayName(sharingType) {
            if (sharingType == 'INDIVIDUAL_AND_TEAM') {
                return 'INDIVIDUAL & TEAM';
            } else {
                return sharingType;
            }
        }
    }, {
        key: 'allowGenerateBackupCodes',
        value: function allowGenerateBackupCodes() {
            return this.companyUser.id && !this.isSmsUser && this.userSettings.backupCodesEnabled;
        }
    }, {
        key: 'disableSmsUsage',
        value: function disableSmsUsage() {
            var _this2 = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageUserDetailsDeactivateSms',
                resolve: {
                    companyId: function companyId() {
                        return _this2.companyId;
                    },
                    companyUserId: function companyUserId() {
                        return _this2.companyUser.id;
                    }
                }
            }).result.then(function () {
                _this2.companyUser.smsUsageApproved = false;
                _this2.Alert('success', 'company.user-directories.manage-user.sms-usage-disabled');
            });
        }
    }, {
        key: 'editRole',
        value: function editRole() {
            if (this.companyUser.roleType === 'END_USER') {
                this.$state.go('company.administrators.add', { email: this.emailAccounts[0].username });
            } else {
                this.$state.go('company.administrators.edit', { companyUserId: this.companyUser.id });
            }
        }
    }, {
        key: 'enableSmsUsage',
        value: function enableSmsUsage() {
            var _this3 = this;

            this.isEnablingSmsUsage = true;
            this.UsersResource.activateSmsUsageForCompanyUser(this.companyId, this.companyUser.id).then(function () {
                _this3.companyUser.smsUsageApproved = true;
                _this3.Alert('success', 'company.user-directories.manage-user.sms-usage-enabled');
            }).finally(function () {
                return _this3.isEnablingSmsUsage = false;
            });
        }
    }, {
        key: 'showAssignModal',
        value: function showAssignModal() {
            var _this4 = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageUserDetailsAssignHardToken',
                size: 'xl',
                resolve: { companyUser: function companyUser() {
                        return _this4.companyUser;
                    }, hardTokens: hardTokens, companyId: function companyId() {
                        return _this4.companyId;
                    } }
            });
        }
    }, {
        key: 'unAssingTokenSecondary',
        value: function unAssingTokenSecondary(tokenId) {
            var _this5 = this;

            this.HardTokenResource.unAssingTokenAsSecondary(this.companyId, this.companyUser.id, tokenId).then(function (data) {
                _this5.devicesForCompanyUser.splice(_this5.devicesForCompanyUser.findIndex(function (t) {
                    return t.deviceId === tokenId;
                }), 1);
                _this5.Alert('success', 'company.user-directories.manage-user.device_unassigned');
            });
        }

        /* manageHardToken() {
             this.isManagingHardToken = true;
             this.$q
                 .resolve(
                     !this.companyUser.id && this.hardToken ||
                     this.UsersResource.getCompanyUserHardToken(this.companyId, this.companyUser.id)
                 )
                 .then(token => this.HardTokenService.getDetail(token.id)
                     .then(data => Object.assign(token, data)))
                 .then((token) => this.HardTokenEditModal(token))
                 .finally(() => this.isManagingHardToken = false)
         }*/

    }, {
        key: 'manageHardToken',
        value: function manageHardToken() {
            var _this6 = this;

            this.isManagingHardToken = true;
            this.$q.resolve(!this.companyUser.id && this.hardToken || this.UsersResource.getCompanyUserHardToken(this.companyId, this.companyUser.id)).then(function (token) {
                return _this6.HardTokenService.getDetail(token.id).then(function (data) {
                    return Object.assign(token, data);
                });
            }).then(function (token) {
                return _this6.$state.go('company.hard-token-management.edit', { token: token, hardTokenId: token.id });
            }).finally(function () {
                return _this6.isManagingHardToken = false;
            });
        }
    }, {
        key: 'changeNotificationEmail',
        value: function changeNotificationEmail() {
            var _this7 = this;

            this.isSavingNotificationEmail = true;
            this.UsersResource.changeNotificationEmail(this.companyId, this.companyUser.id, this.notificationEmailAccount.id).then(function () {
                _this7.$state.reload();
                _this7.Alert('success', 'company.user-directories.manage-user.notification-email-changed');
                _this7.companyUser.userIdentifyingName = _this7.notificationEmailAccount.username;
            }).finally(function () {
                return _this7.isSavingNotificationEmail = false;
            });
        }
    }, {
        key: 'selectedDeletableItems',
        value: function selectedDeletableItems() {
            return this.stAccounts.selectedItems.filter(function (account) {
                return account.isDeletable;
            });
        }
    }, {
        key: 'selectedRemovableItems',
        value: function selectedRemovableItems() {
            return this.stAccounts.selectedItems.filter(function (account) {
                return account.isDisownable;
            });
        }
    }, {
        key: 'showDeleteUserModal',
        value: function showDeleteUserModal() {
            var _this8 = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageUserDeleteUser',
                resolve: {
                    companyId: function companyId() {
                        return _this8.companyId;
                    },
                    companyUserId: function companyUserId() {
                        return _this8.companyUser.id;
                    }
                }
            }).result.then(function () {
                return _this8.$state.go('company.user-directories.saaspass-users');
            }).then(function () {
                return _this8.Alert('success', 'company.user-directories.manage-user.delete-user.deleted');
            });
        }
    }, {
        key: 'showBackupcodesModal',
        value: function showBackupcodesModal() {
            /*  this.$uibModal
                  .open({
                      component: 'companyUserDirectoriesManageUserGenerateBC',
                      resolve: {
                          companyId: () => this.companyId,
                          companyUserId: () => this.companyUser.id,
                      },
                  }).result
                  */
            this.$state.go('.backup-codes');
        }
    }, {
        key: 'showSmsResetPinModal',
        value: function showSmsResetPinModal() {
            var _this9 = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesManageUserSmsResetPin',
                resolve: {
                    companyId: function companyId() {
                        return _this9.companyId;
                    },
                    companyUserId: function companyUserId() {
                        return _this9.companyUser.id;
                    }
                }
            }).result.then(function () {
                return _this9.$state.go('^');
            }).then(function () {
                return _this9.Alert('success', 'groups_users.company_user_reset_pin_code_sent_success');
            });
        }
    }, {
        key: 'unblock',
        value: function unblock() {
            var _this10 = this;

            this.isUpdatingStatus = true;
            this.UsersResource.unblockCompanyUser(this.companyId, this.companyUser.id).then(function () {
                _this10.companyUser.blocked = 'NONE';
                _this10.initializeUserStatusFlags();
                _this10.Alert('success', 'company.user-directories.manage-user.unblocked');
            }).finally(function () {
                return _this10.isUpdatingStatus = false;
            });
        }
    }, {
        key: 'pause',
        value: function pause() {
            var _this11 = this;

            this.isUpdatingStatus = true;
            this.UsersResource.pauseCompanyUser(this.companyId, this.companyUser.id).then(function () {
                _this11.companyUser.status = 'PAUSED';
                _this11.initializeUserStatusFlags();
                _this11.Alert('success', 'company.user-directories.manage-user.paused');
            }).finally(function () {
                return _this11.isUpdatingStatus = false;
            });
        }
    }, {
        key: 'unpause',
        value: function unpause() {
            var _this12 = this;

            this.isUpdatingStatus = true;
            this.UsersResource.unpauseCompanyUser(this.companyId, this.companyUser.id).then(function () {
                _this12.companyUser.status = 'ACTIVE';
                _this12.initializeUserStatusFlags();
                _this12.Alert('success', 'company.user-directories.manage-user.unpaused');
            }).finally(function () {
                return _this12.isUpdatingStatus = false;
            });
        }
    }, {
        key: 'unshareServiceAccount',
        value: function unshareServiceAccount(item) {
            var _this13 = this;

            this.ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete').then(function () {

                var accountIds = [item.id];

                _this13.isSaving = true;
                _this13.UsersResource.deleteUserSharedServiceAccounts(_this13.companyId, _this13.companyUser.id, accountIds).then(function () {
                    _this13.Alert('success', 'company.user-directories.manage-user.shared-accounts.unshared');

                    var companyAccounts = _this13.accountsForCompanyUser;
                    var notes = _this13.userSharedNotes;
                    var corporateAccounts = void 0;
                    _this13.UsersResource.getUserSharedServiceAccounts(_this13.companyId, _this13.companyUser.id).then(function (result) {
                        _this13.userSharedServiceAccounts = result;
                        corporateAccounts = _this13.userSharedServiceAccounts;

                        if (corporateAccounts.length || companyAccounts.length || notes.length) {
                            _this13.$state.go('^');
                        } else {
                            // When all accounts are deleted, company user is also deleted
                            _this13.$state.go('company.user-directories.saaspass-users');
                        }
                    }).catch(function (response) {
                        if (response.data.serviceErrorCode === "ERR_200016") {
                            _this13.$state.go('company.user-directories.saaspass-users');
                        }
                    });
                }).finally(function () {
                    return _this13.isSaving = false;
                });
            });
        }
    }, {
        key: 'unshareNote',
        value: function unshareNote(item) {
            var _this14 = this;

            this.ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete').then(function () {

                var noteIds = [item.id];

                _this14.isSaving = true;
                _this14.UsersResource.deleteUserSharedNotes(_this14.companyId, _this14.companyUser.id, noteIds).then(function () {
                    _this14.Alert('success', 'company.user-directories.manage-user.shared-accounts.unshared');

                    var companyAccounts = _this14.accountsForCompanyUser;
                    var corporateAccounts = _this14.userSharedServiceAccounts;
                    var notes = void 0;
                    _this14.UsersResource.getUserSharedNotes(_this14.companyId, _this14.companyUser.id).then(function (result) {
                        _this14.userSharedNotes = result;
                        notes = _this14.userSharedNotes;

                        if (corporateAccounts.length || companyAccounts.length || notes.length) {
                            _this14.$state.go('^');
                        } else {
                            // When all accounts are deleted, company user is also deleted
                            _this14.$state.go('company.user-directories.saaspass-users');
                        }
                    }).catch(function (response) {

                        if (response.data.serviceErrorCode === "ERR_200016") {
                            _this14.$state.go('company.user-directories.saaspass-users');
                        }
                    });
                }).finally(function () {
                    return _this14.isSaving = false;
                });
            });
        }
    }]);

    return Controller;
}();

/** @ngInject */


function hardTokens($filter, HardTokenService) {
    // return HardTokenService.list().then((items) => $filter('orderBy')(items, 'effectiveStatus'));
    return HardTokenService.list().then(function (items) {
        return items;
    });
}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'UsersResource'];

    /** @ngInject */
    function Controller($state, Alert, UsersResource) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.displayName = this.companyUser.displayName;
            this.selection = null;
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return !this.selection && this.displayName === this.companyUser.displayName;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.UsersResource.editDisplayNameOfEmployee(this.companyId, this.companyUser.id, this.displayName).then(function () {
                return _this.$state.go('^', {}, { reload: '^' });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.manage-user.edit-display-name.saved');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'selectionChanged',
        value: function selectionChanged() {
            this.displayName = (this.selection || this.companyUser).displayName;
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return form.$invalid || this.isSaving || this.notModified();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
				Controller.$inject = ['UsersResource', '$window'];

				/** @ngInject */
				function Controller(UsersResource, $window) {
								_classCallCheck(this, Controller);

								this.UsersResource = UsersResource;
								this.$window = $window;
				}

				_createClass(Controller, [{
								key: '$onInit',
								value: function $onInit() {}
				}, {
								key: 'generateBackupCodes',
								value: function generateBackupCodes() {
												var _this = this;

												var _resolve = this.resolve,
												    companyId = _resolve.companyId,
												    companyUserId = _resolve.companyUserId;

												this.isSaving = true;
												var a = document.createElement("a");
												document.body.appendChild(a);
												this.UsersResource.getUsersBackupOtps(companyId, companyUserId).then(function (response) {
																var filename = _this.getFileNameFromHttpResponse(response);
																var fileURL = _this.$window.URL.createObjectURL(response.data);
																a.href = fileURL;
																a.download = filename;
																a.click();
																setTimeout(function () {
																				this.$window.URL.revokeObjectURL(fileURL);
																}, 100);
																_this.close();
												}).finally(function () {
																return _this.isSaving = false;
												});
								}
				}, {
								key: 'getFileNameFromHttpResponse',
								value: function getFileNameFromHttpResponse(httpResponse) {
												var contentDispositionHeader = httpResponse.headers('Content-Disposition');
												var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
												return result.replace(/"/g, '');
								}
				}]);

				return Controller;
}();

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'showAddAccountButton',
        value: function showAddAccountButton() {
            return this.$state.is('company.user-directories.manage-user.details');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'UsersResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, UsersResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }
            this.st = new _smartTable.SmartTable();
            this.translateKey = function (type) {
                return {
                    AD: 'sp-account-type.active-directory',
                    EXTERNAL_EMAIL: 'sp-account-type.external-email',
                    INTERNAL_EMAIL: 'sp-account-type.internal-email',
                    PHONENUMBER: 'sp-account-type.phone-number',
                    SHARED_EMAIL: 'sp-account-type.shared-email',
                    SIMPLE_USERNAME: 'sp-account-type.simple-username'
                }[type];
            };
        }
    }, {
        key: 'search',
        value: function search() {
            var _this = this;

            this.spAlert = null;
            this.selectedCompanyUser = null;
            this.isSearching = true;

            this.UsersResource.getCompanyUserForSaaspassUser(this.companyId, this.searchText).then(function (companyUser) {
                return _this.selectedCompanyUser = companyUser;
            }).catch(function (response) {
                if (response.status === 404) {
                    _this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            }).finally(function () {
                return _this.isSearching = false;
            });
        }
    }, {
        key: 'move',
        value: function move() {
            var _this2 = this;

            var accountIds = this.accounts.filter(function (_ref) {
                var isDisownable = _ref.isDisownable;
                return isDisownable;
            }).map(function (_ref2) {
                var id = _ref2.id;
                return id;
            });
            this.isSaving = true;

            if (accountIds.length == 0) {
                this.Alert('success', 'company.user-directories.manage-user.move-accounts.nothingTomoved');
                this.$state.go('company.user-directories.saaspass-users');
            } else {

                this.AccountsResource.bulkMoveCompanyUserAccount(this.companyId, this.companyUser.id, this.selectedCompanyUser, accountIds).then(function () {
                    var accounts = _this2.accountsForCompanyUser;
                    var filteredAccounts = accounts.filter(function (_ref3) {
                        var id = _ref3.id;
                        return !accountIds.includes(id);
                    });
                    accounts.splice.apply(accounts, [0, accounts.length].concat(_toConsumableArray(filteredAccounts)));

                    if (accounts.length) {
                        _this2.$state.go('^', {}, { reload: '^' });
                    } else {
                        _this2.$state.go('company.user-directories.saaspass-users');
                    }
                    _this2.Alert('success', 'company.user-directories.manage-user.move-accounts.moved');
                }).finally(function () {
                    return _this2.isSaving = false;
                });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'UsersResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, UsersResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }
            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'search',
        value: function search() {
            var _this = this;

            this.spAlert = null;
            this.selectedCompanyUser = null;
            this.isSearching = true;

            this.UsersResource.getCompanyUserForSaaspassUser(this.companyId, this.searchText).then(function (companyUser) {
                _this.selectedCompanyUser = companyUser;
            }).catch(function (response) {
                if (response.status === 404) {
                    _this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            }).finally(function () {
                return _this.isSearching = false;
            });
        }
    }, {
        key: 'move',
        value: function move() {
            var _this2 = this;

            var accounts = this.accountsForCompanyUser;
            var accountIds = this.accounts.map(function (_ref) {
                var id = _ref.id;
                return id;
            });;
            this.isSaving = true;
            this.AccountsResource.bulkMoveCompanySharedAccount(this.companyId, this.companyUser.id, this.selectedCompanyUser, accountIds).then(function () {
                _this2.Alert('success', 'company.user-directories.manage-user.move-accounts.moved');
                if (accounts.length) {
                    _this2.$state.go('^', {}, { reload: true });
                } else {
                    // When all accounts are deleted, company user is also deleted
                    _this2.$state.go('company.user-directories.saaspass-users', {}, { reload: true });
                }
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$state', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($q, $state, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            var accountIds = this.accounts.filter(function (_ref) {
                var isDisownable = _ref.isDisownable;
                return isDisownable;
            }).map(function (_ref2) {
                var id = _ref2.id;
                return id;
            });

            this.isSaving = true;
            this.$q.all(accountIds.map(function (id) {
                return _this.AccountsResource.removeAccountOwner(_this.companyId, id);
            })).then(function () {
                var accounts = _this.accountsForCompanyUser;
                var filteredAccounts = accounts.filter(function (_ref3) {
                    var id = _ref3.id;
                    return !accountIds.includes(id);
                });
                accounts.splice.apply(accounts, [0, accounts.length].concat(_toConsumableArray(filteredAccounts)));
                _this.Alert('success', 'company.user-directories.manage-user.remove-accounts.removed');

                if (accounts.length) {
                    return _this.$state.go('^');
                } else {
                    // When all accounts are deleted, company user is also deleted
                    return _this.$state.go('company.user-directories.saaspass-users');
                }
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["SmsResetPin"];

    /** @ngInject */
    function Controller(SmsResetPin) {
        _classCallCheck(this, Controller);

        this.SmsResetPin = SmsResetPin;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "reset",
        value: function reset() {
            var _this = this;

            this.isSaving = true;
            this.SmsResetPin.sendResetPinCode(this.resolve.companyId, this.resolve.companyUserId).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'AccountsResource', 'UsersResource', 'Alert'];

    /** @ngInject */
    function Controller($state, AccountsResource, UsersResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.accounts.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'unshare',
        value: function unshare() {
            var _this = this;

            var accountIds = this.accounts.map(function (_ref) {
                var id = _ref.id;
                return id;
            });

            this.isSaving = true;
            this.UsersResource.deleteUserSharedServiceAccounts(this.companyId, this.companyUser.id, accountIds).then(function () {
                var companyAccounts = _this.accountsForCompanyUser;
                var notes = _this.userSharedNotes;
                var sharedAccounts = _this.userSharedServiceAccounts;
                var filteredAccounts = sharedAccounts.filter(function (_ref2) {
                    var id = _ref2.id;
                    return !accountIds.includes(id);
                });
                sharedAccounts.splice.apply(sharedAccounts, [0, sharedAccounts.length].concat(_toConsumableArray(filteredAccounts)));
                _this.Alert('success', 'company.user-directories.manage-user.shared-accounts.unshared');

                if (companyAccounts.length || filteredAccounts.length || notes.lenght) {
                    _this.$state.go('^');
                } else {
                    // When all accounts are deleted, company user is also deleted
                    _this.$state.go('company.user-directories.saaspass-users');
                }
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'UsersResource', 'Alert'];

    /** @ngInject */
    function Controller($state, UsersResource, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.notes.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'unshare',
        value: function unshare() {
            var _this = this;

            var notesIds = this.notes.map(function (_ref) {
                var id = _ref.id;
                return id;
            });

            this.isSaving = true;
            this.UsersResource.deleteUserSharedNotes(this.companyId, this.companyUser.id, notesIds).then(function () {
                var companyAccounts = _this.accountsForCompanyUser;
                var notes = _this.userSharedNotes;
                var sharedAccounts = _this.userSharedServiceAccounts;
                var filteredAccounts = notes.filter(function (_ref2) {
                    var id = _ref2.id;
                    return !notesIds.includes(id);
                });
                notes.splice.apply(notes, [0, notes.length].concat(_toConsumableArray(filteredAccounts)));
                _this.Alert('success', 'company.user-directories.manage-user.shared-notes.unshared');

                if (companyAccounts.length || filteredAccounts.length || sharedAccounts.lenght) {
                    _this.$state.go('^');
                } else {
                    // When all accounts are deleted, company user is also deleted
                    _this.$state.go('company.user-directories.saaspass-users');
                }
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.allItems = [].concat(_toConsumableArray(this.allUsers), _toConsumableArray(this.hardTokens)).filter(function (_ref) {
                var companyUserId = _ref.companyUserId;
                return !companyUserId;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["UserSettingsService"];

    /** @ngInject */
    function Controller(UserSettingsService) {
        _classCallCheck(this, Controller);

        this.UserSettingsService = UserSettingsService;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            this.setDisplayNaming = this.resolve.setDisplayNaming;
        }
    }, {
        key: "process",
        value: function process() {
            var _this = this;

            this.isSaving = true;
            this.UserSettingsService.applyDisplayNameChanges(this.resolve.companyId, this.resolve.setDisplayNaming).then(function () {
                return _this.close();
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert', 'UserSettingsService'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert, UserSettingsService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.UserSettingsService = UserSettingsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.newSettings = angular.copy(this.userSettings);
            this.setDisplayNaming = null;
        }
    }, {
        key: 'cancelSettings',
        value: function cancelSettings() {
            this.newSettings = angular.copy(this.userSettings);
        }
    }, {
        key: 'confirmProcess',
        value: function confirmProcess() {
            var _this = this;

            this.$uibModal.open({
                component: 'companyUserDirectoriesSaaspassUsersUserSettingsConfirm',
                resolve: {
                    companyId: function companyId() {
                        return _this.companyId;
                    },
                    setDisplayNaming: function setDisplayNaming() {
                        return _this.setDisplayNaming;
                    }
                }
            }).result.then(function () {
                return _this.Alert('success', 'company.user-directories.saaspass-users.user-settings.successMessage');
            });
        }
    }, {
        key: 'editRecoverySettings',
        value: function editRecoverySettings() {
            var _this2 = this;

            this.UserSettingsService.setAdminSettings(this.companyId, this.newSettings).then(function () {
                _this2.Alert('success', 'company.user-directories.saaspass-users.user-settings.successMessage');
                _this2.userSettings = angular.copy(_this2.newSettings);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'UsersResource'];

    /** @ngInject */
    function Controller(Alert, UsersResource) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'unblock',
        value: function unblock(account) {
            var _this = this;

            this.isUnblocking = true;
            this.UsersResource.unblockCompanyUser(this.companyId, account.id).then(function () {
                var index = _this.blockedUsers.indexOf(account);
                _this.blockedUsers.splice(index, 1);
                _this.numberOfUsers.blockedUsers -= 1;
                account.blocked = 'NONE';
                _this.Alert('success', 'company.user-directories.manage-user.unblocked');
            }).finally(function () {
                return _this.isUnblocking = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.allItems = [].concat(_toConsumableArray(this.hardTokenUsers), _toConsumableArray(this.hardTokens)).filter(function (_ref) {
                var companyUserId = _ref.companyUserId;
                return !companyUserId;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'UsersResource'];

    /** @ngInject */
    function Controller(Alert, UsersResource) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.UsersResource = UsersResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'unpause',
        value: function unpause(account) {
            var _this = this;

            this.isUnpausing = true;
            this.UsersResource.unpauseCompanyUser(this.companyId, account.id).then(function () {
                var index = _this.pausedUsers.indexOf(account);
                _this.numberOfUsers.pausedUsers -= 1;
                _this.pausedUsers.splice(index, 1);
                account.status = 'ACTIVE';
                _this.Alert('success', 'company.user-directories.manage-user.unpaused');
            }).finally(function () {
                return _this.isUnpausing = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$q', '$state', '$uibModal', 'AccountsResource', 'Alert'];

    /** @ngInject */
    function Controller($q, $state, $uibModal, AccountsResource, Alert) {
        _classCallCheck(this, Controller);

        this.$q = $q;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.username = '';
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            var rejectAlreadyExistingAccount = function rejectAlreadyExistingAccount(account) {
                if (account.justCreated) {
                    return _this.$q.resolve(account);
                } else {
                    _this.$uibModal.open({ component: 'companyUserDirectoriesManageUserAddAccountAccountAlreadyExists' }).result.then(function () {
                        return _this.$state.go('company.user-directories.manage-account', { accountId: account.id });
                    });
                    return _this.$q.reject();
                }
            };

            this.isSaving = true;
            this.AccountsResource.addNewUserAccount(this.companyId, this.username).then(rejectAlreadyExistingAccount).then(function (_ref) {
                var id = _ref.id;
                return _this.$state.go('company.user-directories.manage-account', { accountId: id });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.saaspass-users.sms-users.add.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'UserLabelsService', 'Alert'];

    /** @ngInject */
    function Controller($state, UserLabelsService, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.users.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
            this.st.displayedItems = angular.copy(this.labels);
        }
    }, {
        key: 'add',
        value: function add() {
            var _this = this;

            //const userIds = this.users.map(({id}) => id);
            var selectedUsers = this.users.filter(function (e) {
                return e.roleType;
            });
            var userIds = selectedUsers.map(function (e) {
                return e.id;
            });
            this.isSaving = true;
            var companyId = this.companyId;
            this.UserLabelsService
            //  .addCompanyUsers({companyId,labelId}, userIds).$promise
            .addCompanyUsersToLabels({ companyId: companyId }, { aIds: userIds, bIds: this.st.selectedIds }).$promise.then(function () {
                return _this.$state.go('company.user-directories.saaspass-users.all-users', {}, { reload: '^.^' });
            }).then(function () {
                return _this.Alert('success', 'company.user-directories.saaspass-users.user-labels.users.copy.copied');
            }).catch(function (error) {
                _this.Alert('danger', error.data.message);
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'UserLabelsService', 'Alert'];

    /** @ngInject */
    function Controller($state, UserLabelsService, Alert) {
        var _this = this;

        _classCallCheck(this, Controller);

        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
        this.queryLabelIds = function (labelInRow) {
            return labelInRow.id !== _this.userLabelId;
        };
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.users.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
            this.st.displayedItems = angular.copy(this.labels);
        }
    }, {
        key: 'copy',
        value: function copy() {
            var _this2 = this;

            var userIds = this.users.map(function (_ref) {
                var id = _ref.id;
                return id;
            });

            this.isSaving = true;
            var companyId = this.companyId;
            var labelId = this.userLabelId;
            this.UserLabelsService
            //  .addCompanyUsers({companyId,labelId}, userIds).$promise
            .copyCompanyUsersToLabels({ companyId: companyId, labelId: labelId }, { aIds: userIds, bIds: this.st.selectedIds }).$promise.then(function () {
                return _this2.$state.go('^', { userLabelId: labelId }, { reload: '^.^' });
            }).then(function () {
                return _this2.Alert('success', 'company.user-directories.saaspass-users.user-labels.users.copy.copied');
            }).catch(function (error) {
                _this2.Alert('danger', error.data.message);
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'UserLabelsService', 'Alert'];

    /** @ngInject */
    function Controller($state, UserLabelsService, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.labelName = "";
        }
    }, {
        key: 'create',
        value: function create() {
            var _this = this;

            var companyId = this.companyId;
            this.isSaving = true;
            this.UserLabelsService.createLabel({ companyId: companyId }, this.labelName).$promise.then(function (data) {
                var transformedData = data.toJSON();
                _this.labels.push(transformedData);
                _this.$state.go('company.user-directories.saaspass-users.user-labels.import-users-to-label', { userLabelId: data.id });
            }).then(function () {
                // const key = 'company.user-directories.manage-group.accounts.move.moved';
                // const variables = {labelName: this.st.selectedItems[0].labelName};
                // this.Alert('success', key, variables);
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'UserLabelsService', 'Alert'];

    /** @ngInject */
    function Controller($state, UserLabelsService, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.allItems = [].concat(_toConsumableArray(this.regCompanyUsers)).filter(function (_ref) {
                var companyUserId = _ref.companyUserId;
                return !companyUserId;
            });
            this.usersAlreadyInTeam = angular.copy(this.companyUsers);
            this.st = new _smartTable.SmartTable();
            this.usersNotInTeam = this.allItems.filter(function (el) {
                return !_this.usersAlreadyInTeam.some(function (item) {
                    return item.saaspassId.includes(el.saaspassId);
                });
            });
        }
    }, {
        key: 'import',
        value: function _import() {
            var _this2 = this;

            //const selectedItems=this.st.selectedItems.filter((e)=>e.roleType);
            //var selectedIds=selectedItems.map((e) =>e.id);
            this.isSaving = true;
            var companyId = this.companyId;
            var labelId = this.userLabelId;
            this.UserLabelsService.addCompanyUsers({ companyId: companyId, labelId: labelId }, this.st.selectedIds).$promise.then(function () {
                var tempArray = angular.copy(_this2.st.selectedItems);
                var newArray = tempArray.map(function (_ref2) {
                    var isSelected = _ref2.isSelected,
                        keepArray = _objectWithoutProperties(_ref2, ['isSelected']);

                    return keepArray;
                });
                Array.prototype.push.apply(_this2.companyUsers, newArray);
                _this2.$state.go('^', {}, { reload: '^.^' });
            }).then(function () {
                return _this2.Alert('success', 'company.user-directories.saaspass-users.user-labels.users.import.imported');
            }).catch(function (error) {
                _this2.Alert('danger', error.data.message);
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['UserLabelsService', 'Alert'];

    /** @ngInject */
    function Controller(UserLabelsService, Alert) {
        _classCallCheck(this, Controller);

        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'delete',
        value: function _delete() {
            var _this = this;

            this.isSaving = true;
            var companyId = this.resolve.companyId;
            var labelId = this.resolve.labelId;
            this.UserLabelsService.deleteLabel({ companyId: companyId, labelId: labelId }).$promise.then(function () {
                _this.close();
            }).catch(function (error) {
                _this.spAlert = new SpAlert('danger', error.data.message);
            }).finally(function () {
                _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'UserLabelsService', 'Alert'];

    /** @ngInject */
    function Controller($state, $uibModal, UserLabelsService, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
        this.$uibModal = $uibModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            //console.log(this);


        }
    }, {
        key: 'rename',
        value: function rename(newName) {
            var _this = this;

            var companyId = this.companyId;
            var labelId = this.labelGroup.id;
            this.UserLabelsService.renameLabel({ companyId: companyId, labelId: labelId }, newName).$promise.then(function () {
                _this.$state.reload('company.user-directories.saaspass-users');
            }).then(function () {
                return _this.Alert('success', 'company.saaspass-users.label.settings.renamed');
            }).catch(function (error) {});
            //.finally(()=>{});
        }
    }, {
        key: 'showDeleteModal',
        value: function showDeleteModal() {
            var _this2 = this;

            this.$uibModal.open({
                component: 'companyUserLabelDelete',
                resolve: {
                    companyId: function companyId() {
                        return _this2.companyId;
                    },
                    labelId: function labelId() {
                        return _this2.labelGroup.id;
                    }
                }
            }).result.then(function () {
                return _this2.$state.go('company.user-directories.saaspass-users', { companyId: _this2.companyId }, { reload: true, inherit: false, notify: false });
            }).then(function () {
                var key = 'company.user-directories.saaspass-users.user-labels.label.settings.delete.success';
                var variables = { groupName: _this2.labelGroup.labelName };
                _this2.Alert('success', key, variables);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'UserLabelsService', 'Alert'];

    /** @ngInject */
    function Controller($state, UserLabelsService, Alert) {
        var _this = this;

        _classCallCheck(this, Controller);

        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
        this.queryLabelIds = function (labelInRow) {
            return labelInRow.id !== _this.userLabelId;
        };
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (!this.users.length) {
                this.$state.go('^', {}, { location: 'replace' });
            }

            this.st = new _smartTable.SmartTable();
        }
    }, {
        key: 'move',
        value: function move() {
            var _this2 = this;

            var companyId = this.companyId;
            var labelId = this.userLabelId;
            var userIds = this.users.map(function (_ref) {
                var id = _ref.id;
                return id;
            });
            var toLabelId = this.st.selectedIds[0];
            this.isSaving = true;
            this.UserLabelsService.moveCompanyUsersToLabel({ companyId: companyId, labelId: labelId, toLabelId: toLabelId }, userIds).$promise.then(function () {
                return _this2.$state.go('^', { userLabelId: _this2.st.selectedIds[0] }, { reload: '^.^' });
            }).then(function () {
                var key = 'company.user-directories.saaspass-users.user-labels.users.move.moved';
                var variables = { labelName: _this2.st.selectedItems[0].labelName };
                _this2.Alert('success', key, variables);
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["UserLabelsService"];

    /** @ngInject */
    function Controller(UserLabelsService) {
        _classCallCheck(this, Controller);

        this.UserLabelsService = UserLabelsService;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            var companyId = this.resolve.companyId;
            var userLabelId = this.resolve.userLabelId;
        }
    }, {
        key: "remove",
        value: function remove() {
            var _this = this;

            var companyId = this.resolve.companyId;
            var labelId = this.resolve.userLabelId;
            var userIds = this.resolve.userIds;
            this.isSaving = true;
            this.UserLabelsService.removeCompanyUsers({ companyId: companyId,
                labelId: labelId }, userIds).$promise.then(function () {
                return _this.close(userIds);
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$uibModal', 'Alert'];

    /** @ngInject */
    function Controller($state, $uibModal, Alert) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.st = new _smartTable.SmartTable();
            this.label = angular.copy(this.labelGroup);
            //this.displayItems=this.companyUsers;
        }
    }, {
        key: 'showRemoveModal',
        value: function showRemoveModal() {
            var _this = this;

            this.$uibModal.open({
                component: 'companyUserLabelMembersRemove',
                backdrop: 'static',
                resolve: {
                    companyId: function companyId() {
                        return _this.companyId;
                    },
                    userLabelId: function userLabelId() {
                        return _this.label.id;
                    },
                    userIds: function userIds() {
                        return _this.st.selectedIds;
                    }
                }
            }).result.then(function () {
                _this.$state.go('.', { userLabelId: _this.label.id }, { reload: '^' });
                var key = 'company.user-directories.saaspass-users.user-labels.users.removed';
                var variables = { labelName: _this.label.labelName };
                _this.Alert('success', key, variables);
            }, function (res) {}).catch(function (error) {});
        }
    }]);

    return Controller;
}();

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$state"];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }]);

    return Controller;
}();

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _updates = __webpack_require__(139);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.updates = _updates.updates;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {}
    }, {
        key: "templateUrl",
        value: function templateUrl() {
            return __webpack_require__(2284)("./" + this.updateId + "/whats-new.html");
        }
    }]);

    return Controller;
}();

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
/** @ngInject */
function Controller() {
    var url = window.location.href;
    var idx = url.indexOf("/loginSaml/client/sso/");
    if (idx > -1) {
        var url = url.replace("#/", "");
        window.location.href = url;
    }
}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["AuthenticationSharedService"];

    /** @ngInject */
    function Controller(AuthenticationSharedService) {
        _classCallCheck(this, Controller);

        this.AuthenticationSharedService = AuthenticationSharedService;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            this.isSsoLoading = true;
            this.AuthenticationSharedService.login({}).finally(function () {
                return _this.isSsoLoading = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "02ad2cdcaed33aee7e7a6858ad40eba3.html";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sessionId = __webpack_require__(22);

var _captcha = __webpack_require__(18);

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$scope', '$state', 'AuthenticationSharedService', 'CompanyRegistration', 'RegistrationCodeGeneratonService'];

    /** @ngInject */
    function Controller($scope, $state, AuthenticationSharedService, CompanyRegistration, RegistrationCodeGeneratonService) {
        _classCallCheck(this, Controller);

        this.$scope = $scope;
        this.$state = $state;
        this.AuthenticationSharedService = AuthenticationSharedService;
        this.CompanyRegistration = CompanyRegistration;
        this.RegistrationCodeGeneratonService = RegistrationCodeGeneratonService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.companyName = '';
            this.email = '';
            this.showCaptcha = false;
            this.captcha = new _captcha.Captcha({ isVisible: function isVisible() {
                    return _this.showCaptcha;
                } });

            this.$scope.$on('websocket.REGISTERED_COMPANY', function (event, data) {
                var username = data.username,
                    password = data.password,
                    company = data.company;

                _this.AuthenticationSharedService.loginAfterRegistration({ username: username, password: password, companyId: company.id });
            });
        }
    }, {
        key: 'loadQrData',
        value: function loadQrData() {
            var _this2 = this;

            return this.RegistrationCodeGeneratonService.get({ uuid: _sessionId.SESSION_ID }).$promise.then(function (barcode) {
                _this2.showCaptcha = barcode.showCaptcha;
                return barcode.barcodeimage;
            });
        }
    }, {
        key: 'register',
        value: function register() {
            var _this3 = this;

            this.CompanyRegistration.save({
                companyName: this.companyName,
                email: this.email,
                captchaResponse: this.captcha.response
            }).$promise.then(function () {
                return _this3.$state.go('public.company-registration-success');
            }, function (_ref) {
                var status = _ref.status,
                    data = _ref.data;

                if (status === 412) {
                    var key = 'registration.company.messages.invalid_captcha';
                    _this3.spAlert = new _spAlert.SpAlert('danger', key);
                } else {
                    _this3.spAlert = new _spAlert.SpAlert('danger', data.message, {}, false);
                }
                _this3.captcha.reset();
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['ContactService'];

    /** @ngInject */
    function Controller(ContactService) {
        _classCallCheck(this, Controller);

        this.ContactService = ContactService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.reset();
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.message = { name: '', email: '', text: '' };
        }
    }, {
        key: 'sendMessage',
        value: function sendMessage() {
            var _this = this;

            this.ContactService.save(this.message).$promise.then(function () {
                alert('Message sent successfully');
                _this.reset();
            }, function () {
                return alert('Error occured!!!!');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _captcha = __webpack_require__(18);

var _spAlert = __webpack_require__(4);

Controller.$inject = ['$scope', '$state', 'DataDeletionFormService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, DataDeletionFormService) {

    $scope.dataDeletion = {};
    var captcha = $scope.captcha = new _captcha.Captcha({ isVisible: function isVisible() {
            return true;
        } });
    $scope.submit = function (form) {

        $scope.dataDeletion.captchaResponse = captcha.response;

        DataDeletionFormService.save($scope.dataDeletion).$promise.then(function (data) {
            $scope.topLevelMessage = new _spAlert.SpAlert('success', 'Data deletion request is sent. We will process your request and inform you with the status.');
        }, function (error) {
            if (error.status == 412) {
                var key = 'registration.company.messages.invalid_captcha';
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', key);
            } else {
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', error.data.message);
            }
        }).finally(function () {
            return captcha.reset();
        });

        $scope.dataDeletion = {};
    };
}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {

    /** @ngInject */
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.showIEText = !(_userAgent.ua.isChrome() || _userAgent.ua.isOpera() || _userAgent.ua.isFirefox() || _userAgent.ua.isSafari());
        }
    }]);

    return Controller;
}();

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$uibModal'];

    /** @ngInject */
    function Controller($rootScope, $uibModal) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'openLoginModal',
        value: function openLoginModal() {
            this.$rootScope.loginModal = this.$uibModal.open({ component: 'loginModal' });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _sessionId = __webpack_require__(22);

var _userAgent = __webpack_require__(13);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$rootScope', '$scope', '$state', '$timeout', '$window', 'AuthenticationSharedService', 'BarcodeGeneratonService', 'GoogleSharedService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($rootScope, $scope, $state, $timeout, $window, AuthenticationSharedService, BarcodeGeneratonService, GoogleSharedService) {
    $scope.domainName = $state.params.domain;

    $scope.showFullPage = false;

    $scope.samlImage = window.env.urls.samlAppLogo('google-apps');

    $scope.errorMessage = '';
    $scope.errorCode = $state.params.error_code;
    $scope.codeGoogle = $state.params.code;

    if ($scope.errorCode) {
        if ($scope.errorCode == '1') {
            $scope.errorMessage = "The Domain that you want to protect is not the same domain as the email address you selected for authentication.";
        } else if ($scope.errorCode == '2') {
            $scope.errorMessage = "You email account is not Google domain admin.";
        }
    } else if ($scope.domainName && $scope.codeGoogle) {
        $scope.showFullPage = true;
    } else {
        var expires = new Date(Date.now() + 60 * 1000).toUTCString();
        document.cookie = 'gmarketDomain=' + $scope.domainName + '; path=/; expires=' + expires;

        GoogleSharedService.getGoogleAuthUrl.get({}, function (data) {

            var redirectUrl = data.requestUrl;

            $window.location = redirectUrl;
        }, function (error) {});
    }

    $scope.loggingIn = false;

    var captcha = $scope.captcha = new _captcha.Captcha();

    var $ctrl = this;

    $ctrl.loadQrData = function () {
        return BarcodeGeneratonService.get({ uuid: _sessionId.SESSION_ID }).$promise.then(function (barcode) {
            $rootScope.passwordMode = $ctrl.passwordMode = barcode.passwordMode;
            $ctrl.mobileLoginUrl = 'saaspass-wa://login?barcode=' + barcode.bluetoothcode;
            $ctrl.bluetoothCode = barcode.bluetoothcode;
            return barcode.barcodeimage;
        });
    };

    $scope.pulssing = "";

    $scope.pulse = function () {
        $scope.pulssing = "pulseAnimate";
        $("html, body").animate({ scrollTop: $(document).height() }, 2000);

        $timeout(function () {
            $scope.pulssing = "";
        }, 2000);
    };

    $scope.login = function () {
        login($scope.username, $scope.password, captcha.response);
    };

    $scope.$on('websocket.LOGIN', function (event, data) {
        login(data.username, data.password);
    });

    function login(username, password, captchaResponse) {
        $scope.loggingIn = true;
        AuthenticationSharedService.login({
            username: username,
            password: password,
            captchaResponse: captchaResponse,
            googleMarketPlaceConfiguration: true,
            domain: $state.params.domain,
            code: $state.params.code
        }).finally(function () {
            $scope.loggingIn = false;
            captcha.reset();
        });
    }

    $scope.newLoginButton = _userAgent.ua.isAndroid() || _userAgent.ua.isIOS();
}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ["$window", "GoogleSharedService"];

    /** @ngInject */
    function Controller($window, GoogleSharedService) {
        _classCallCheck(this, Controller);

        this.$window = $window;
        this.GoogleSharedService = GoogleSharedService;
    }

    _createClass(Controller, [{
        key: "$onInit",
        value: function $onInit() {
            var _this = this;

            var expires = new Date(Date.now() + 60 * 1000).toUTCString();
            document.cookie = "gmarketDomainEndUser=" + this.domain + "; path=/; expires=" + expires;
            this.GoogleSharedService.getGoogleEndUserAuthUrl.get().$promise.then(function (data) {
                return _this.$window.location = data.requestUrl;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _captcha = __webpack_require__(18);

var _spAlert = __webpack_require__(4);

Controller.$inject = ['$scope', '$state', 'HardTokenSyncService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, HardTokenSyncService) {

    $scope.hardTokenSync = {};
    $scope.isTrackerValid = false;

    var tracker = $state.params.tracker;

    if (tracker) {
        HardTokenSyncService.get({
            trackerId: tracker
        }).$promise.then(function (data) {
            $scope.isTrackerValid = true;
            $scope.hardTokenSyncInfo = data;
        }, function (error) {
            $scope.topLevelMessage = new _spAlert.SpAlert('danger', error.data.message);
        });
    }

    var captcha = $scope.captcha = new _captcha.Captcha({ isVisible: function isVisible() {
            return true;
        } });
    $scope.synchronize = function (form) {

        $scope.hardTokenSync.captchaResponse = captcha.response;

        var data = {};
        if ($scope.isTrackerValid) {
            data.trackerId = $scope.hardTokenSyncInfo.trackerId;
        }

        HardTokenSyncService.save(data, $scope.hardTokenSync).$promise.then(function (data) {
            $scope.topLevelMessage = new _spAlert.SpAlert('success', 'hard_token_sync.messages.success');
        }, function (error) {
            if (error.status == 412) {
                var key = 'registration.company.messages.invalid_captcha';
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', key);
            } else {
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', error.data.message);
            }
        }).finally(function () {
            return captcha.reset();
        });

        $scope.hardTokenSync = {};
    };
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _sessionId = __webpack_require__(22);

var _userAgent = __webpack_require__(13);

var _captcha = __webpack_require__(18);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

Controller.$inject = ['$rootScope', '$scope', '$state', '$timeout', 'AuthenticationSharedService', 'BarcodeGeneratonService', 'HardTokenLoginModal', 'SamlLoginHandler', 'SamlService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($rootScope, $scope, $state, $timeout, AuthenticationSharedService, BarcodeGeneratonService, HardTokenLoginModal, SamlLoginHandler, SamlService) {
    var vm = $scope.vm = {};
    $scope.loginPasswordModeF = function (m) {
        return $scope.loginPasswordMode = m;
    };
    $scope.rememberMe = false;
    $scope.loginPassword = false;
    var appKey = $scope.appData = $state.params.applicationId;
    $scope.icon = $state.params.icon;
    $scope.appName = $state.params.appName;
    $scope.samlTracker = $state.params.SAMLTracker;
    $scope.loginPasswordModeF($state.params.loginWithPassword);
    var sendingPushLoginNotification = false;
    var appType = $scope.appType = $state.params.appType;
    var icon = $state.params.icon;
    $scope.appAccountFormat = 'USERNAME_AND_EMAIL';
    vm.passwordManual = '';
    //$scope.infoSamlMsg = "Logging in. Please wait...";
    SamlService.getAppAccountFormat.get({
        appKey: appKey
    }, function (data) {
        $scope.isReady = true;
        $scope.appAccountFormat = data.accountFormat;
        $scope.pwdAuthenticationEnabled = data.pwdAuthenticationEnabled;
        $scope.pwdAuthenticationOnSaaspass = data.pwdAuthenticationOnSaaspass;
        $scope.ilEnabled = data.ilEnabled;
        $scope.plEnabled = data.plEnabled;
        if ($scope.pwdAuthenticationEnabled) {
            if (appType === 'google-apps') {
                if ($scope.pwdAuthenticationOnSaaspass === true) {
                    $rootScope.passwordMode = $scope.passwordMode = false;
                    $scope.loginPassword = true;
                } else {
                    $rootScope.passwordMode = $scope.passwordMode = true;
                    $scope.loginPassword = false;
                }
            } else {
                $scope.loginPassword = true;
            }
        }
    }, function (error) {
        $scope.isReady = true;
    });

    if (icon) {
        $scope.samlImage = icon;
    } else {
        $scope.samlImage = window.env.urls.samlAppLogo(appType);
    }

    var captcha = $scope.captcha = new _captcha.Captcha();

    $scope.loadQrData = function () {
        return BarcodeGeneratonService.applicationBarcode({ uuid: _sessionId.SESSION_ID, appKey: appKey }).$promise.then(function (barcode) {
            $scope.mobileLoginUrl = 'saaspass-wa://login?barcode=' + barcode.bluetoothcode;
            $scope.bluetoothCode = barcode.bluetoothcode;
            return barcode.barcodeimage;
        }).catch(function (response) {
            if (response.status === 400) {
                $state.go('public.custom-error', { error_message: response.data.message });
            }
        });
    };

    var usernameStorage = localStorage.getItem("saml_username_" + appKey);
    var saaspassIdStorage = localStorage.getItem("saml_saaspassId" + appKey);
    if (usernameStorage != null && angular.isDefined(usernameStorage)) {
        $scope.rememberMe = true;
        $scope.username = angular.copy(usernameStorage);
        if (saaspassIdStorage != null && angular.isDefined(saaspassIdStorage)) {
            $scope.saaspassId = saaspassIdStorage;
        }
        if (captcha.isValid()) {
            pushLogin(usernameStorage);
        }
    }

    $scope.$on('websocket.SAML_LOGIN', function (event, data) {
        SamlLoginHandler.login(data.username, data.password, true, false);
    });

    $scope.$on('websocket.LOGIN_REJECTED', function (event, data) {
        $('#pushLoginModal').modal('hide');
    });

    var samlSaaspassIdTemp = null;
    function onPushLoginSuccess(username) {
        vm.pushLoginPopoverIsOpen = true;
        $timeout(2000).then(function () {
            return vm.pushLoginPopoverIsOpen = false;
        });
        if ($scope.rememberMe) {
            localStorage.setItem("saml_username_" + appKey, username);
            if (samlSaaspassIdTemp) {
                localStorage.setItem("saml_saaspassId_" + appKey, samlSaaspassIdTemp);
            }
        }
        var pushLoginModal = $('#pushLoginModal');
        if (pushLoginModal.is(':visible')) {
            pushLoginModal.modal('hide');
        }
    }

    function onPushLoginError(code) {
        if (code == "ERR_101203") {
            $rootScope.authenticationError = false;
            $("#pushLoginModal").modal();
            var loginAttempts = +localStorage.getItem('loginAttempts') || 0;
            localStorage.setItem('loginAttempts', loginAttempts - 1);
        } else if (code == "ERR_100701") {
            $("#pushLoginModal").modal('hide');
        }
    }

    $scope.pushLogin = pushLogin;
    function pushLogin(username) {
        if (!username) {
            username = $scope.username;
        }

        sendingPushLoginNotification = true;
        AuthenticationSharedService.sendPushLoginNotification(captcha.response, username, null, appKey, $scope.saaspassId).then(onPushLoginSuccess).catch(onPushLoginError).finally(function () {
            captcha.reset();
            sendingPushLoginNotification = false;
        });
        samlSaaspassIdTemp = angular.copy($scope.saaspassId);
        $scope.saaspassId = null;
    }

    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem("saml_username_" + appKey);
            localStorage.removeItem("saml_saaspassId_" + appKey);
        }
    };

    $scope.pulssing = "";

    $scope.pulse = function () {
        $scope.pulssing = "pulseAnimate";
        $("html, body").animate({ scrollTop: $(document).height() }, 2000);

        $timeout(function () {
            $scope.pulssing = "";
        }, 2000);
    };

    $scope.login = function () {
        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        if (!$scope.loginPasswordMode) {
            SamlLoginHandler.login($scope.username, vm.otpPassword, false, false, captcha.response, errorCallback);
        } else {
            SamlLoginHandler.login($scope.username, vm.passwordManual, false, true, captcha.response, errorCallback);
        }
    };
    $scope.oldLogin = function () {
        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        SamlLoginHandler.login($scope.username, $scope.password, false, true, captcha.response, errorCallback);
    };

    $scope.newLoginButton = _userAgent.ua.isAndroid() || _userAgent.ua.isIOS();

    // error callback function on login
    var errorCallback = function errorCallback(response) {
        var status = response.status;
        if (status == 412) {
            $rootScope.captchaError = true;
            $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
        } else {
            $rootScope.authenticationError = true;
        }
        captcha.reset();
    };

    $scope.pushLoginDisabled = pushLoginDisabled;

    function pushLoginDisabled() {
        return !$scope.username || sendingPushLoginNotification || vm.pushLoginPopoverIsOpen || !captcha.isValid();
    }

    $scope.showHardTokenLoginModal = function () {
        return HardTokenLoginModal();
    };
}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b1cf8f523c814619e1d452049a9f03e.html";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.Controller = Controller;
Controller.$inject = ["AuthenticationSharedService"];
/** @ngInject */
function Controller(AuthenticationSharedService) {
        AuthenticationSharedService.logout();
}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'PinReset'];

    /** @ngInject */
    function Controller($state, Alert, PinReset) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.PinReset = PinReset;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.reset();
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            this.$state.go('public.sms-user-otp');
        }
    }, {
        key: 'reset',
        value: function reset() {
            this.confirmPin = '';
            this.pinReset = { phoneNumber: '', resetPin: '', pin: '' };
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.PinReset.save(this.pinReset).$promise.then(function () {
                return _this.$state.go('public.sms-user-otp', { showResetPinSuccessMessage: true });
            }, function (_ref) {
                var data = _ref.data;

                _this.spAlert = new _spAlert.SpAlert('danger', data.message);
                _this.reset();
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$scope', '$state'];

    /** @ngInject */
    function Controller($rootScope, $scope, $state) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.isSaml = this.$state.is('public.login-saml-with-app-id') || this.$state.is('public.login-saml-with-req-link');
            this.isOldLogin = this.$state.is('public.old-login') || this.$state.is('public.old-login-with-app-id');

            this.$rootScope.queryString = window.location.href.split('?')[1];
            // Saaspass Connect | OIDC Client login request check
            this.$rootScope.isSaaspassConnectLogin = false;
            this.$rootScope.isOidcClientLogin = false;
            this.$rootScope.oauthClientId = null;
            this.$rootScope.ilEnabled = true;
            this.$rootScope.plEnabled = true;
            var type = this.$state.params.type;
            if (type != null) {
                this.$rootScope.clientDisplayName = this.$state.params.client;
                if (type == 'saaspassConnect') {
                    this.$rootScope.isSaaspassConnectLogin = true;
                } else if (type == 'oidcClient') {
                    this.$rootScope.isOidcClientLogin = true;
                    this.$rootScope.ilEnabled = this.$state.params.ilenabled != 'false';
                    this.$rootScope.plEnabled = this.$state.params.plenabled != 'false';
                    var continueParam = this.$state.params.continue;
                    if (continueParam != null) {
                        var url = new URL(continueParam);
                        var searchParams = url.searchParams;
                        this.$rootScope.oauthClientId = searchParams.get('client_id');
                    }
                }
            }
        }
    }, {
        key: 'switchOldRegularLogin',
        value: function switchOldRegularLogin() {
            this.$rootScope.authenticationError = false;
            this.$rootScope.captchaError = false;
            localStorage.setItem('loginAttempts', '0');

            if (this.$state.is('public.old-login-with-app-id')) {
                this.$state.go('public.login-web-saml', this.$state.params);
            } else if (this.$state.is('public.login-web-saml')) {
                this.$state.go('public.old-login-with-app-id', this.$state.params);
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'ResetPasswordVerifyService'];

    /** @ngInject */
    function Controller($state, Alert, ResetPasswordVerifyService) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.ResetPasswordVerifyService = ResetPasswordVerifyService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.newpassword = '';
            this.newpasswordAgain = '';
            this.successReset = false;
            this.autoRedirect = this.$state.params.autoRedirect;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.ResetPasswordVerifyService.resetPassword(this.$state.params.appKey, this.$state.params.rkey, this.newpassword).then(function () {
                return _this.newpassword = _this.newpasswordAgain = '';
            }).then(function () {
                return _this.successReset = true;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'ResetPasswordService', '$stateParams'];

    /** @ngInject */
    function Controller($state, Alert, ResetPasswordService, $stateParams) {
        _classCallCheck(this, Controller);

        this.$stateParams = $stateParams;
        this.$state = $state;
        this.Alert = Alert;
        this.ResetPasswordService = ResetPasswordService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.user = {};
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            this.$state.go('public.login-web-saml', { applicationId: this.$state.params.appKey, SAMLTracker: this.$state.params.SAMLTracker, appName: this.$state.params.appName, appType: this.$state.params.appType, icon: this.$state.params.icon, loginWithPassword: true });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.ResetPasswordService.sendResetEmail(this.$state.params.appKey, this.user.username, this.user.email).then(function () {
                _this.Alert('success', 'Instructions to reset your password has been sent to the email', false);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$http', '$location', '$state'];

    /** @ngInject */
    function Controller($http, $location, $state) {
        _classCallCheck(this, Controller);

        this.$http = $http;
        this.$location = $location;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.$http.get('app/rest/account', { ignoreAuthModule: true }).then(function () {
                return _this.$location.href(decodeURI(_this.$state.params.continue));
            }).catch(function () {
                return _this.$state.go('public.login', _this.$state.params);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
Controller.$inject = ['$state', 'SamlService'];
/** @ngInject */
function Controller($state, SamlService) {
    var req = $state.params.req;
    var link = $state.params.link;
    SamlService.getIDPSamlLoginUrl.get({
        req: req,
        link: link
    }).$promise.then(function (data) {
        if (data.authorized) {
            $('#SAMLResponse').val(data.samlResponse);
            $('#RelayState').val(data.relayState);

            if (null == data.casLt) {
                $('#lt').remove();
            } else {
                $('#lt').val(data.casLt);
            }

            if (null == data.casExecution) {
                $('#execution').remove();
            } else {
                $('#execution').val(data.casExecution);
            }

            if (null == data.casEventId) {
                $('#_eventId').remove();
            } else {
                $('#_eventId').val(data.casEventId);
            }

            $('#samlloginForm').attr('action', data.redirectionLink);

            $('#samlloginForm').submit();
        }
    });
}

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _spAlert = __webpack_require__(4);

Controller.$inject = ['$location', '$rootScope', '$scope', '$state', '$translate', 'SamlService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($location, $rootScope, $scope, $state, $translate, SamlService) {
    var appKey = $state.params.applicationId;

    $scope.infoSamlMsg = $translate.instant('saml.messages.logging_process');

    SamlService.getSPSamlData.get({
        SAMLTracker: $location.search().SAMLTracker,
        appKey: appKey
    }, function (data) {
        if (data.authorized) {
            $scope.infoSamlMsg = $translate.instant('saml.messages.logging_process');
            $('#SAMLResponse').val(data.samlResponse);
            $('#RelayState').val(data.relayState);

            if (null == data.casLt) {
                $('#lt').remove();
            } else {
                $('#lt').val(data.casLt);
            }

            if (null == data.casExecution) {
                $('#execution').remove();
            } else {
                $('#execution').val(data.casExecution);
            }

            if (null == data.casEventId) {
                $('#_eventId').remove();
            } else {
                $('#_eventId').val(data.casEventId);
            }

            $('#samlloginForm').attr('action', data.redirectionLink);

            $('#samlloginForm').submit();
        } else {
            $state.go('public.logout-saml');
        }
    }, function (error) {
        if (error.data.serviceErrorCode == 'ERR_101204') {
            $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', error.data.message);

            $scope.infoSamlMsg = error.data.message;
        } else {
            $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', 'saml.messages.not_authorized');
            $scope.infoSamlMsg = $translate.instant('saml.messages.not_authorized');
        }
    });
}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
/** @ngInject */
function Controller() {
    document.cookie = "sso=none; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT"; //set on production: secure = true
}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
Controller.$inject = ['$rootScope', '$state', '$uibModal'];
/** @ngInject */
function Controller($rootScope, $state, $uibModal) {

    $uibModal.open({ component: 'sessionExpired' }).result.finally(function () {
        $rootScope.authenticationError = false;
        $state.go('public.login');
    });
}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _captcha = __webpack_require__(18);

var _spAlert = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

Controller.$inject = ['$scope', '$state', '$timeout', '$stateParams', 'SmsGatewaysService', 'SmsUserOtp']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, $timeout, $stateParams, SmsGatewaysService, SmsUserOtp) {
    this.$onInit = function () {
        if ($stateParams.showResetPinSuccessMessage) {
            $timeout(1000).then(function () {
                return $scope.topLevelMessage = new _spAlert.SpAlert('success', 'pin.reset.pin_code_sent_success');
            });
        }
    };
    $scope.smsUserOtpFlag = true;
    $scope.smsUserCompanyOtpFlag = false;
    $scope.showCaptcha = false;

    var captcha = $scope.captcha = new _captcha.Captcha({
        isVisible: function isVisible() {
            return $scope.showCaptcha;
        }
    });

    $scope.smsUserOtp = {
        "mobilePhoneNumber": null,
        "pin": null,
        "smsCompanies": null,
        "showCaptcha": false,
        "captchaResponse": null
    };
    $scope.generateOtp = function () {
        localStorage.setItem('preferred-sms-gateway', $scope.smsUserOtp.smsGatewayIdentifier);
        $scope.smsUserOtp.captchaResponse = captcha.response;
        SmsUserOtp.save($scope.smsUserOtp, function (response, responseHeaders) {
            var status = responseHeaders("x-sp-status");
            if (status == 307) {
                $scope.smsCompanyItems = response.smsCompanies;
                $scope.smsUserOtpFlag = false;
                $scope.smsUserCompanyOtpFlag = true;
            } else {
                $scope.smsUserOtp.pin = null;
                $scope.topLevelMessage = new _spAlert.SpAlert('success', 'sms.otp.messages.sms_otp_send');
            }
            $scope.showCaptcha = false;
            captcha.reset();
        }, function (response) {
            var status = response.status;
            captcha.reset();
            if (angular.isDefined(response.data.serviceErrorCode) && (response.data.serviceErrorCode.toString() == 'ERR_101407' || response.data.serviceErrorCode.toString() == 'ERR_101409')) {
                $scope.smsUserOtp.showCaptcha = true;
                $scope.showCaptcha = true;
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
            } else if (status == 412) {
                var key = 'registration.company.messages.invalid_captcha';
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', key);
            } else {
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
            }
        });
    };

    $scope.generateCompanyOtp = function (id) {
        SmsUserOtp.save({
            id: id
        }, $scope.smsUserOtp, function (response) {
            $scope.smsUserOtpFlag = true;
            $scope.smsUserCompanyOtpFlag = false;
            $scope.smsUserOtp.pin = null;
            $scope.showCaptcha = false;
            captcha.reset();
            $scope.topLevelMessage = new _spAlert.SpAlert('success', 'sms.otp.messages.sms_otp_send');
        }, function (response) {
            $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
        });
    };

    $scope.cancel = function () {
        $scope.smsUserOtpFlag = true;
        $scope.smsUserCompanyOtpFlag = false;
        $scope.showCaptcha = false;
        captcha.reset();
        $scope.smsUserOtp = {
            "mobilePhoneNumber": null,
            "pin": null,
            "smsCompanies": null,
            "showCaptcha": false,
            "captchaResponse": null
        };
    };

    $scope.$watch('smsGenerateOtpForm.$error.err', function (error) {
        if (error || !$scope.smsUserOtp.mobilePhoneNumber) {
            $scope.gateways = [];
            $scope.smsUserOtp.smsGatewayIdentifier = undefined;
        } else {
            SmsGatewaysService.getSmsGatewayList($scope.smsUserOtp.mobilePhoneNumber).then(function (gateways) {
                $scope.gateways = gateways;
                var preferredGateway = localStorage.getItem('preferred-sms-gateway');
                if (gateways.includes(preferredGateway)) {
                    $scope.smsUserOtp.smsGatewayIdentifier = preferredGateway;
                } else {
                    $scope.smsUserOtp.smsGatewayIdentifier = gateways[0];
                }
            });
        }
    });
}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _captcha = __webpack_require__(18);

var _spAlert = __webpack_require__(4);

Controller.$inject = ['$scope', '$state', '$timeout', 'SmsGatewaysService', 'SmsUserActivationCodeGeneration', 'SmsUserRegistration']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, $timeout, SmsGatewaysService, SmsUserActivationCodeGeneration, SmsUserRegistration) {

    $scope.smsUserRegistrationFirstPageFlag = true;
    $scope.smsUserRegistrationSecondPageFlag = false;
    $scope.notMatched = false;

    $scope.smsUserRegistration = {
        "mobilePhoneNumber": null,
        "activationCode": null,
        "pin": null,
        "captchaResponse": null
    };

    var captcha = $scope.captcha = new _captcha.Captcha({ isVisible: function isVisible() {
            return true;
        } });

    $scope.generateActivationCode = function () {
        $scope.smsUserRegistration.captchaResponse = captcha.response;
        localStorage.setItem('preferred-sms-gateway', $scope.smsUserRegistration.smsGatewayIdentifier);
        SmsUserActivationCodeGeneration.save($scope.smsUserRegistration, function (response) {
            $scope.smsUserRegistrationFirstPageFlag = false;
            $scope.smsUserRegistrationSecondPageFlag = true;
            $scope.smsUserRegistration.activationCode = null;
            $scope.smsUserRegistration.pin = null;
            $scope.confirmPin = null;
            $scope.notMatched = false;
            var key = 'sms.registration.messages.activation_code';
            $scope.topLevelMessage = new _spAlert.SpAlert('success', key);
        }, function (response) {
            var status = response.status;
            if (status == 412) {
                var key = 'registration.company.messages.invalid_captcha';
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', key);
            } else {
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
            }
            captcha.reset();
        });
    };

    $scope.registerSmsUser = function () {
        SmsUserRegistration.save($scope.smsUserRegistration, function (response) {
            $scope.smsUserRegistrationFirstPageFlag = true;
            $scope.smsUserRegistrationSecondPageFlag = false;
            $scope.smsUserRegistration = {
                "mobilePhoneNumber": null,
                "activationCode": null,
                "pin": null,
                "captchaResponse": null
            };
            $scope.selectedCountry = null;
            $scope.notMatched = false;
            var key = 'sms.registration.messages.registration_succeeded';
            $scope.topLevelMessage = new _spAlert.SpAlert('success', key);
            $timeout(function () {
                $state.go('public.sms-user-otp');
            }, 3000);
        }, function (response) {
            $scope.smsUserRegistrationFirstPageFlag = false;
            $scope.smsUserRegistrationSecondPageFlag = true;
            $scope.smsUserRegistration.activationCode = null;
            $scope.smsUserRegistration.pin = null;
            $scope.confirmPin = null;
            $scope.notMatched = false;
            if (response.data.serviceErrorCode.toString() == 'ERR_101403') {
                $scope.cancel();
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
            } else {
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
            }
        });
    };

    $scope.cancel = function () {
        $scope.smsUserRegistrationFirstPageFlag = true;
        $scope.smsUserRegistrationSecondPageFlag = false;
        $scope.smsUserRegistration = {
            "mobilePhoneNumber": null,
            "activationCode": null,
            "pin": null,
            "captchaResponse": null
        };
        $scope.selectedCountry = null;
        $scope.notMatched = false;
        captcha.reset();
    };

    $scope.$watch('smsUserRegistrationFirstForm.$error.err', function (error) {
        if (error || !$scope.smsUserRegistration.mobilePhoneNumber) {
            $scope.gateways = [];
            $scope.smsUserRegistration.smsGatewayIdentifier = undefined;
        } else {
            SmsGatewaysService.getSmsGatewayList($scope.smsUserRegistration.mobilePhoneNumber).then(function (gateways) {
                $scope.gateways = gateways;
                var preferredGateway = localStorage.getItem('preferred-sms-gateway');
                if (gateways.includes(preferredGateway)) {
                    $scope.smsUserRegistration.smsGatewayIdentifier = preferredGateway;
                } else {
                    $scope.smsUserRegistration.smsGatewayIdentifier = gateways[0];
                }
            });
        }
    });
}

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _sessionId = __webpack_require__(22);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$http', '$scope', '$state', 'AuthenticationSharedService', 'BarcodeGeneratonService', 'EmailVerificationDataService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($http, $scope, $state, AuthenticationSharedService, BarcodeGeneratonService, EmailVerificationDataService) {
    var $ctrl = this;
    $scope.displaySpinner = true;
    $ctrl.message = [];
    var captcha = $scope.captcha = new _captcha.Captcha({
        isVisible: function isVisible() {
            return $scope.attempts >= 5;
        }
    });
    var INFO = "INFO";
    var ERROR = "ERROR";
    var SUCCESS = "SUCCESS";

    $scope.icon = INFO;
    $scope.showVerificationForm = true;
    $scope.showIframe = false;

    // gets vkey attribute from query string
    $scope.vkey = $state.params.vkey;

    // e-mail verification on page load
    EmailVerificationDataService.get({
        vkey: $scope.vkey
    }, function (data) {
        $scope.displaySpinner = false;
        if (!data.verificationRequired) {
            // E-mail verified
            $scope.vkey = null;
            $ctrl.message = [data.message];
            $scope.showVerificationForm = false;
            $scope.icon = SUCCESS;
            $scope.showIframe = false;
        } else {
            // Show credentials page
            $scope.showIframe = true;
            $scope.showVerificationForm = true;
            $scope.icon = INFO;
            $scope.verificationType = data.emailVerificationType;
            $scope.isCompanyVerification = false;
            if ($scope.verificationType == 'COMPANY_VERIFICATION') {
                $scope.isCompanyVerification = true;
            }
            /* if ($scope.icon = SUCCESS) {
                 $scope.showIframe = false;
             }*/
            $scope.attempts = data.numberOfAttempts;
            if ($scope.verificationType == 'COMPANY_VERIFICATION') {
                $ctrl.message = ['email_verification_data.messages.verification.company'];
            } else if ($scope.verificationType == 'EMAIL_VERIFICATION') $ctrl.message = ['email_verification_data.messages.verification.user'];else {
                $ctrl.message = [data.message, 'email_verification_data.messages.verification.user'];
            }
        }
    }, function (error) {
        // Error on verifying e-mail. Do not show credentials page
        $scope.displaySpinner = false;
        $scope.icon = ERROR;
        $scope.verificationType = error.data.emailVerificationType;
        if ($scope.verificationType == 'COMPANY_VERIFICATION') {
            $scope.isCompanyVerification = true;
        } else {
            $scope.isCompanyVerification = false;
        }
        $scope.showVerificationForm = false;
        $ctrl.message = [error.data.message];
        $scope.message2 = error.data.secondaryMessage;
    });

    $scope.verify = function () {
        $scope.trackerId = null;
        sendVerificationRequestWithCredentials();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    };

    // e-mail after credentials are submited
    function sendVerificationRequestWithCredentials() {
        var url = 'app/rest/emailverificationdata/credentialcheck';
        var requestBody = {};
        requestBody.vkey = $scope.vkey;
        requestBody.saaspassId = $scope.username;
        requestBody.verificationType = $scope.verificationType;
        if ($scope.password) {
            requestBody.otp = $scope.password;
        } else {
            requestBody.trackerId = $scope.trackerId;
        }

        requestBody.captchaResponse = captcha.response;

        $scope.authenticationError = false;
        $scope.captchaError = false;
        $http.post(url, requestBody).then(function (response) {
            var data = response.data;
            // Email verified
            if ($scope.verificationType == 'COMPANY_VERIFICATION') {
                AuthenticationSharedService.loginAfterRegistration({
                    username: $scope.username,
                    password: data.companyTracker,
                    companyId: data.companyId
                });
            } else {
                $scope.icon = SUCCESS;
                $ctrl.message = [data.message];
                $scope.message2 = data.secondaryMessage;
                $scope.showVerificationForm = false;
            }
        }).catch(function (response) {
            var data = response.data;
            if (data.incorrectCredentials) {
                // incorrect credentials
                $scope.attempts = data.numberOfAttempts;
                if (data.message == "Incorrect Captcha") {
                    $scope.captchaError = true;
                } else {
                    $scope.authenticationError = true;
                }

                return;
            }
            // Error on verifying e-mail. Do not show credentials page
            $scope.icon = ERROR;
            $scope.showVerificationForm = false;
            $ctrl.message = [data.message];
            $scope.message2 = data.secondaryMessage;
        }).finally(function () {
            return captcha.reset();
        });
    }

    $scope.$on('websocket.LOGIN', function (event, data) {
        $scope.trackerId = data.password;
        $scope.username = data.username;
        $scope.password = null;
        sendVerificationRequestWithCredentials();
    });

    $scope.loadQrData = function () {
        return BarcodeGeneratonService.get({ uuid: _sessionId.SESSION_ID }).$promise.then(function (barcode) {
            $scope.mobileLoginUrl = 'saaspass-wa://login?barcode=' + barcode.bluetoothcode;
            return barcode.barcodeimage;
        });
    };
}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _sessionId = __webpack_require__(22);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$http', '$scope', '$state', 'AuthenticationSharedService', 'BarcodeGeneratonService', 'EmailVerificationDataService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($http, $scope, $state, AuthenticationSharedService, BarcodeGeneratonService, EmailVerificationDataService) {
    var $ctrl = this;
    $scope.displaySpinner = true;
    $ctrl.message = [];
    var captcha = $scope.captcha = new _captcha.Captcha({
        isVisible: function isVisible() {
            return $scope.attempts >= 5;
        }
    });
    var INFO = "INFO";
    var ERROR = "ERROR";
    var SUCCESS = "SUCCESS";

    $scope.icon = INFO;
    $scope.showVerificationForm = true;
    $scope.showIframe = false;

    // gets vkey attribute from query string
    $scope.vkey = $state.params.vkey;

    // e-mail verification on page load
    EmailVerificationDataService.get({
        vkey: $scope.vkey
    }, function (data) {
        $scope.displaySpinner = false;
        if (!data.verificationRequired) {
            // E-mail verified
            $scope.vkey = null;
            $ctrl.message = [data.message];
            $scope.showVerificationForm = false;
            $scope.icon = SUCCESS;
            $scope.showIframe = false;
        } else {
            // Show credentials page
            $scope.showIframe = true;
            $scope.showVerificationForm = true;
            $scope.icon = INFO;
            $scope.verificationType = data.emailVerificationType;
            $scope.isCompanyVerification = false;
            if ($scope.verificationType == 'COMPANY_VERIFICATION') {
                $scope.isCompanyVerification = true;
            }
            /* if ($scope.icon = SUCCESS) {
                 $scope.showIframe = false;
             }*/
            $scope.attempts = data.numberOfAttempts;
            if ($scope.verificationType == 'COMPANY_VERIFICATION') {
                $ctrl.message = ['email_verification_data.messages.verification.company'];
            } else if ($scope.verificationType == 'EMAIL_VERIFICATION') $ctrl.message = ['email_verification_data.messages.verification.user'];else {
                $ctrl.message = [data.message, 'email_verification_data.messages.verification.user'];
            }
        }
    }, function (error) {
        // Error on verifying e-mail. Do not show credentials page
        $scope.displaySpinner = false;
        $scope.icon = ERROR;
        $scope.verificationType = error.data.emailVerificationType;
        if ($scope.verificationType == 'COMPANY_VERIFICATION') {
            $scope.isCompanyVerification = true;
        } else {
            $scope.isCompanyVerification = false;
        }
        $scope.showVerificationForm = false;
        $ctrl.message = [error.data.message];
        $scope.message2 = error.data.secondaryMessage;
    });

    $scope.verify = function () {
        $scope.trackerId = null;
        sendVerificationRequestWithCredentials();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    };

    // e-mail after credentials are submited
    function sendVerificationRequestWithCredentials() {
        var url = 'app/rest/emailverificationdata/credentialcheck';
        var requestBody = {};
        requestBody.vkey = $scope.vkey;
        requestBody.saaspassId = $scope.username;
        requestBody.verificationType = $scope.verificationType;
        if ($scope.password) {
            requestBody.otp = $scope.password;
        } else {
            requestBody.trackerId = $scope.trackerId;
        }

        requestBody.captchaResponse = captcha.response;

        $scope.authenticationError = false;
        $scope.captchaError = false;
        $http.post(url, requestBody).then(function (response) {
            var data = response.data;
            // Email verified
            if ($scope.verificationType == 'COMPANY_VERIFICATION') {
                AuthenticationSharedService.loginAfterRegistration({
                    username: $scope.username,
                    password: data.companyTracker,
                    companyId: data.companyId
                });
            } else {
                $scope.icon = SUCCESS;
                $ctrl.message = [data.message];
                $scope.message2 = data.secondaryMessage;
                $scope.showVerificationForm = false;
            }
        }).catch(function (response) {
            var data = response.data;
            if (data.incorrectCredentials) {
                // incorrect credentials
                $scope.attempts = data.numberOfAttempts;
                if (data.message == "Incorrect Captcha") {
                    $scope.captchaError = true;
                } else {
                    $scope.authenticationError = true;
                }

                return;
            }
            // Error on verifying e-mail. Do not show credentials page
            $scope.icon = ERROR;
            $scope.showVerificationForm = false;
            $ctrl.message = [data.message];
            $scope.message2 = data.secondaryMessage;
        }).finally(function () {
            return captcha.reset();
        });
    }

    $scope.$on('websocket.LOGIN', function (event, data) {
        $scope.trackerId = data.password;
        $scope.username = data.username;
        $scope.password = null;
        sendVerificationRequestWithCredentials();
    });

    $scope.loadQrData = function () {
        return BarcodeGeneratonService.get({ uuid: _sessionId.SESSION_ID }).$promise.then(function (barcode) {
            $scope.mobileLoginUrl = 'saaspass-wa://login?barcode=' + barcode.bluetoothcode;
            return barcode.barcodeimage;
        });
    };
}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _yubicoWebauthn = __webpack_require__(72);

var _captcha = __webpack_require__(18);

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _spAlert = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$scope', '$window', 'FidoRegistrationDataService', '$translate'];

	/** @ngInject */
	function Controller($scope, $window, FidoRegistrationDataService, $translate) {
		_classCallCheck(this, Controller);

		this.$scope = $scope;
		this.$window = $window;
		this.$translate = $translate;
		this.FidoRegistrationDataService = FidoRegistrationDataService;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.displaySpinner = true;
			this.spAlert = null;
			this.registrationSuccessful = false;
			this.registrationFailed = false;
			this.FidoRegistrationDataService.getData({ vKey: this.vkey }).$promise.then(function (response) {
				return _this.verificationData = response;
			}).catch(function (error) {
				console.log(error);
				_this.registrationFailed = true;
				_this.linkExpired = true;
				_this.errorMessage = _this.$translate.instant('public.hard-token.fido-registration.link-expired');
			}).finally(function () {
				return _this.displaySpinner = false;
			});

			this.captcha = new _captcha.Captcha({ isVisible: function isVisible() {
					return true;
				} });
			new _clipboard2.default(".copyCli").on('success', function () {
				_this.$scope.$apply(function () {
					_this.spAlert = new _spAlert.SpAlert('success', 'global.data_copied');
				});
			});
		}
	}, {
		key: 'startRegistration',
		value: function startRegistration() {
			var _this2 = this;

			var hardTokenId = this.verificationData.hardTokenId;
			var vKey = this.vkey;
			this.FidoRegistrationDataService.startRegistration({ vKey: vKey, hardTokenId: hardTokenId }, this.captcha.response).$promise.then(function (response) {
				var credOpts = (0, _yubicoWebauthn.convertStartRegResponse)(response);
				_this2.$window.navigator.credentials.create(credOpts).then(function (credentials) {
					var finishRegRequest = (0, _yubicoWebauthn.convertFinishRegRequest)(credentials, response);
					_this2.finishRegistration(finishRegRequest);
				}).catch(function (error) {
					return console.log(error);
				});
			}).catch(function (error) {
				console.log(error);
				_this2.registerFailedOutput();
				var key = 'hard_tokens.edit.U2F_failed';
				_this2.spAlert = new _spAlert.SpAlert('danger', key);
			}).finally(function () {
				return _this2.captcha.reset();
			});
		}
	}, {
		key: 'finishRegistration',
		value: function finishRegistration(data) {
			var _this3 = this;

			var hardTokenId = this.verificationData.hardTokenId;
			this.FidoRegistrationDataService.finishRegistration({ hardTokenId: hardTokenId }, data).$promise.then(function () {
				_this3.registerSucceededOutput();
			}).catch(function (error) {
				console.log(error);
				_this3.registerFailedOutput();
				var key = 'hard_tokens.edit.U2F_failed';
				_this3.spAlert = new _spAlert.SpAlert('danger', key);
			});
		}
	}, {
		key: 'registerFailedOutput',
		value: function registerFailedOutput() {
			this.registrationFailed = true;
			this.registrationSuccessful = false;
		}
	}, {
		key: 'registerSucceededOutput',
		value: function registerSucceededOutput() {
			this.registrationFailed = false;
			this.registrationSuccessful = true;
		}
	}]);

	return Controller;
}();

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _sessionId = __webpack_require__(22);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$http', '$scope', '$state', 'BarcodeGeneratonService', 'SlackVerificationDataService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($http, $scope, $state, BarcodeGeneratonService, SlackVerificationDataService) {

    $scope.displaySpinner = true;
    $scope.message = null;

    var INFO = "INFO";
    var ERROR = "ERROR";
    var SUCCESS = "SUCCESS";

    $scope.icon = INFO;
    $scope.showVerificationForm = true;
    $scope.showIframe = false;

    var captcha = $scope.captcha = new _captcha.Captcha({
        isVisible: function isVisible() {
            return $scope.attempts >= 5;
        }
    });

    // gets vkey attribute from query string
    $scope.vkey = $state.params.vkey;

    SlackVerificationDataService.get({
        vkey: $scope.vkey
    }, function (data) {
        $scope.displaySpinner = false;
        // Show credentials page
        $scope.showVerificationForm = true;
        $scope.icon = INFO;
        $scope.isSlack = true;
        $scope.message = "Activate SAASPASS Single Sign-on for Slack with your SAASPASS Mobile App";
        $scope.slackTeam = data.slackTeam;
        $scope.slackUsername = data.slackUsername;
        $scope.attempts = data.numberOfAttempts;
        $scope.showIframe = true;
    }, function (error) {
        // Error on verifying slack user. Do not show credentials page
        $scope.displaySpinner = false;
        $scope.icon = ERROR;
        $scope.showVerificationForm = false;
        $scope.message = error.data.message;
        $scope.message2 = error.data.secondaryMessage;
        $scope.showIframe = false;
    });

    $scope.verify = function () {
        $scope.trackerId = null;
        sendVerificationRequestWithCredentials();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    };

    // e-mail after credentials are submited
    function sendVerificationRequestWithCredentials() {
        var url = 'app/rest/slackverificationdata/credentialcheck';
        var requestBody = {};
        requestBody.vkey = $scope.vkey;
        requestBody.saaspassId = $scope.username;
        requestBody.otp = $scope.password;
        requestBody.trackerId = $scope.trackerId;
        requestBody.captchaResponse = captcha.response;
        $scope.authenticationError = false;
        $scope.captchaError = false;
        $http.post(url, requestBody).then(function (response) {
            var data = response.data;
            // Email verified
            $scope.icon = SUCCESS;
            $scope.message = data.message;
            $scope.message2 = data.secondaryMessage;
            $scope.showVerificationForm = false;
        }).catch(function (response) {
            var data = response.data;
            if (data.incorrectCredentials) {
                // incorrect credentials
                $scope.attempts = data.numberOfAttempts;
                if (data.message == "Incorrect Captcha") {
                    $scope.captchaError = true;
                } else {
                    $scope.authenticationError = true;
                }

                return;
            }
            // Error on verifying slack user. Do not show credentials page
            $scope.icon = ERROR;
            $scope.showVerificationForm = false;
            $scope.message = data.message;
            $scope.message2 = data.secondaryMessage;
        }).finally(function () {
            return captcha.reset();
        });
    }

    $scope.$on('websocket.LOGIN', function (event, data) {
        $scope.trackerId = data.password;
        $scope.username = data.username;
        $scope.password = null;
        sendVerificationRequestWithCredentials();
    });

    $scope.loadQrData = function () {
        return BarcodeGeneratonService.get({ uuid: _sessionId.SESSION_ID }).$promise.then(function (barcode) {
            return barcode.barcodeimage;
        });
    };
}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['AccountConfigService'];

    /** @ngInject */
    function Controller(AccountConfigService) {
        _classCallCheck(this, Controller);

        this.AccountConfigService = AccountConfigService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.applicationId = this.resolve.applicationId;
            this.accountId = this.resolve.accountId;
            this.config = this.resolve.config;
            this.elements = this.config.accountConfig.elements;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.AccountConfigService.save(this.applicationId, this.accountId, this.config).then(function (response) {
                return _this.close({ $value: response });
            }).catch(function (response) {
                return _this.spAlert = new _spAlert.SpAlert('danger', response.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['AccountPasswordUpdate'];

    /** @ngInject */
    function Controller(AccountPasswordUpdate) {
        _classCallCheck(this, Controller);

        this.AccountPasswordUpdate = AccountPasswordUpdate;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.application = this.resolve.application;
            this.password = this.resolve.application.password;
            this.username = null;
            this.resetEmail = null;
            this.passwordGenerationDate = null;
            this.isPasswordExpired = null;
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            var _application = this.application,
                applicationId = _application.applicationId,
                companyUserAccountId = _application.companyUserAccountId;

            this.AccountPasswordUpdate.save({ applicationId: applicationId, companyUserAccountId: companyUserAccountId, username: this.username, password: this.password, resetEmail: this.resetEmail, passwordGenerationDate: this.passwordGenerationDate, isPasswordExpired: this.isPasswordExpired }).$promise.then(function () {
                return _this.close({ $value: _this.password });
            }).catch(function (error) {
                var message = ((error || {}).data || {}).message;
                var key = message || 'applications.account_password_updated_error';
                _this.spAlert = new _spAlert.SpAlert('danger', key);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$uibModal', 'AccountConfigModal', 'Alert', 'LoginRoleSelectModal', 'SamlService', 'SharedEpmFactory'];

    /** @ngInject */
    function Controller($rootScope, $uibModal, AccountConfigModal, Alert, LoginRoleSelectModal, SamlService, SharedEpmFactory) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.AccountConfigModal = AccountConfigModal;
        this.Alert = Alert;
        this.LoginRoleSelectModal = LoginRoleSelectModal;
        this.SamlService = SamlService;
        this.SharedEpmFactory = SharedEpmFactory;
    }

    _createClass(Controller, [{
        key: 'modalOpen',
        value: function modalOpen() {
            this.$rootScope.loginModal = this.$uibModal.open({ component: 'loginModal' });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
            this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
            this.samlAppLogo = window.env.urls.samlAppLogo;
            this.showExtensionAlert = false;
        }
    }, {
        key: 'getSamlLoginUrl',
        value: function getSamlLoginUrl(applicationId, accountId, awsrole) {
            var app = this.applications.find(function (a) {
                return a.applicationId === applicationId;
            });
            var tabWindowId = window.open('about:blank', '_blank');

            tabWindowId.document.write('\n            <img\n                src="' + window.env.urls.samlAppLogo(app.slug) + '"\n                alt="' + app.applicationTypeDisplayName + '"\n                onload="this.style.display = \'block\'"\n                style="display: none; margin: 50px auto 0;"\n            />\n        ');

            tabWindowId.document.write('\n            <p style="text-align: center; color:#40A3DB;">\n                <img\n                    src="' + __webpack_require__(2447) + '"\n                    onload="this.style.display = \'initial\'"\n                    alt="Loading..."\n                    style="display: none; vertical-align: middle; margin-right: 5px"\n                />\n                Loading...\n            </p>\n        ');

            this.SamlService.getSamlLoginUrl.get({ applicationId: applicationId, accountId: accountId, awsrole: awsrole }).$promise.then(function (data) {
                var expires = new Date(Date.now() + 60 * 1000).toUTCString();
                if (data.url.includes("&noCookie=true")) {
                    data.url = data.url.replace("&noCookie=true", '');
                } else {
                    document.cookie = 'sso=' + app.applicationId + '; path=/; expires=' + expires; //set on production: secure = true
                }

                if (_userAgent.ua.isIOS()) {
                    window.location.assign(data.url);
                } else {
                    tabWindowId.location.href = data.url;
                    if (data.url.includes("/#/")) {
                        tabWindowId.location.reload();
                    }
                }
            }, function (error) {
                tabWindowId.document.write('<p style="text-align: center; color:red">Error: ' + error.data + '</p>');
            });
        }
    }, {
        key: 'showEditPasswordModal',
        value: function showEditPasswordModal(_application) {
            var _this = this;

            this.$uibModal.open({
                component: 'accountPasswordUpdate',
                resolve: { application: function application() {
                        return _application;
                    } }
            }).result.then(function (password) {
                _application.password = password;
                _this.Alert('success', 'applications.account_password_updated');
            });
        }
    }, {
        key: 'showAccountConfigModal',
        value: function showAccountConfigModal(applicationId, accountId) {
            this.AccountConfigModal(applicationId, accountId);
        }
    }, {
        key: 'epmLogin',
        value: function epmLogin(sharedAccount) {
            this.SharedEpmFactory.epmsSSO(sharedAccount);

            var isExtensionInstalled = !!document.getElementById("saaspass-extension-info") || !!document.getElementById('extension-is-installed-v2.0.1') || !!document.getElementById('extension-is-installed-v2.1.0');

            if (!isExtensionInstalled) {
                this.showExtensionAlert = true;
                this.showIEText = !(_userAgent.ua.isChrome() || _userAgent.ua.isOpera() || _userAgent.ua.isFirefox() || _userAgent.ua.isSafari());
            }
        }
    }, {
        key: 'showAwsConfigModal',
        value: function showAwsConfigModal(applicationId, accountId) {
            var _this2 = this;

            this.LoginRoleSelectModal(applicationId, accountId).then(function (role) {
                return _this2.getSamlLoginUrl(applicationId, accountId, role);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['ExtentionManaging'];

    /** @ngInject */
    function Controller(ExtentionManaging) {
        _classCallCheck(this, Controller);

        this.ExtentionManaging = ExtentionManaging;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'installExtension',
        value: function installExtension() {
            this.ExtentionManaging.installExtension();
        }
    }, {
        key: 'installExtensionButtonVisible',
        value: function installExtensionButtonVisible() {
            if (this.account.roles.includes('ROLE_HARD_TOKEN_USER')) {
                return false;
            }
            if (this.account.roles.includes('ROLE_SMS_USER')) {
                return false;
            }
            if (_userAgent.ua.isIOS()) {
                return false;
            }
            if (document.getElementById("saaspass-extension-info")) {
                return false;
            }
            if (document.getElementById('extension-is-installed-v2.0.1')) {
                return false;
            }
            if (document.getElementById('extension-is-installed-v2.1.0')) {
                return false;
            }
            return (_userAgent.ua.isFirefox() || _userAgent.ua.isSafari() || _userAgent.ua.isChrome() || _userAgent.ua.isOpera()) && !_userAgent.ua.isIOS();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.roles = this.resolve.roles;
            this.role = { roleValue: '' };
        }
    }]);

    return Controller;
}();

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'DestructiveOperationModal'];

    /** @ngInject */
    function Controller(Alert, DestructiveOperationModal) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
            this.isHardTokenUser = this.account.roles.includes('ROLE_HARD_TOKEN_USER') || this.account.isSecondaryDeviceSession;
        }
    }, {
        key: 'showDeleteConnectorDP',
        value: function showDeleteConnectorDP(id) {
            var _this = this;

            this.DestructiveOperationModal({
                titleKey: 'connectors.messages.delete_connector',
                textKey: 'connectors.messages.warning',
                http: { method: 'DELETE', url: 'app/rest/connectors/' + id }
            }).then(function () {
                var index = _this.connectors.findIndex(function (c) {
                    return c.id === id;
                });
                _this.connectors.splice(index, 1);
                _this.Alert('success', 'connectors.messages.delete');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'DestructiveOperationModal', 'DeviceManagement', 'ShowCloneCodeModal', 'ConfirmModal', '$rootScope'];

    /** @ngInject */
    function Controller(Alert, DestructiveOperationModal, DeviceManagement, ShowCloneCodeModal, ConfirmModal, $rootScope) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.DeviceManagement = DeviceManagement;
        this.ShowCloneCodeModal = ShowCloneCodeModal;
        this.ConfirmModal = ConfirmModal;
        this.$rootScope = $rootScope;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.isHardTokenUser = this.account.isSecondaryDeviceSession;
            this.userDevices = this.devices.userDevices;
            this.hardTokens = this.devices.hardTokens;
        }
    }, {
        key: 'showDeleteDeviceDP',
        value: function showDeleteDeviceDP(id) {
            var _this = this;

            this.DestructiveOperationModal({
                titleKey: 'device_management.delete_modal_header',
                textKey: 'device_management.delete_modal_content',
                http: { method: 'DELETE', url: 'app/rest/device_management/' + id }
            }).then(function () {
                var index = _this.userDevices.findIndex(function (d) {
                    return d.id === id;
                });
                _this.userDevices.splice(index, 1);
                _this.Alert('success', 'device_management.messages.delete');
            });
        }
    }, {
        key: 'generateCloneCode',
        value: function generateCloneCode() {
            var _this2 = this;

            this.ConfirmModal({
                messageKey: 'You can clone your SAASPASS ID to another device. <br><br>Download SAASPASS application to your other device and choose \'RECOVER or CLONE your SAASPASS ID\' at the bottom of the first screen after you create a PIN. <br><br>Then choose \'CLONE SAASPASS ID\' and then enter your SAASPASS ID and cloning code. <br><br>Click YES to generate cloning code which is valid for 15 minutes.',
                titleKey: 'GENERATE CLONE CODE'
            }).then(function () {
                return _this2.DeviceManagement.generateCloneCode().$promise.then(function (result) {
                    _this2.ShowCloneCodeModal('CLONE SAASPASS ID', _this2.$rootScope.account.login, result.cloneCode);
                });
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'UserEmailsService'];

    /** @ngInject */
    function Controller(Alert, UserEmailsService) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.UserEmailsService = UserEmailsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.email = '';
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.UserEmailsService.save({ emailAddress: this.email }).$promise.then(function (email) {
                _this.Alert('success', 'emails.messages.email_added');
                _this.close({ $value: email });
            }).catch(function (error) {
                var message = ((error || {}).data || {}).message;
                var key = message || 'emails.messages.adding_email_failed';
                _this.spAlert = new _spAlert.SpAlert('danger', key);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _smartTable = __webpack_require__(2);

Controller.$inject = ['$scope', '$uibModal', 'Alert', 'DestructiveOperationModal', 'UserEmailsService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $uibModal, Alert, DestructiveOperationModal, UserEmailsService) {
    var _this = this;

    this.$onInit = function () {
        var emails = _this.emails;
        $scope.st = new _smartTable.SmartTable();

        $scope.isHardTokenUser = _this.account.roles.includes('ROLE_HARD_TOKEN_USER') || _this.account.isSecondaryDeviceSession;
        $scope.isSmsUser = _this.account.roles.includes('ROLE_SMS_USER');

        $scope.showDeleteEmailDestructiveOp = function (emailDtoObject) {
            $scope.emailToBeDeleted = emailDtoObject;
            if (emailDtoObject.userEmail.status == null) {
                UserEmailsService.delete({
                    id: emailDtoObject.userEmail.id
                }).$promise.then(function (data) {
                    $scope.deleteEmailSuccess();
                });
            } else {
                var url = 'app/rest/emails/active_email/' + emailDtoObject.userEmail.id;
                DestructiveOperationModal({
                    titleKey: 'emails.delete_email_modal',
                    textKey: 'emails.messages.warning_delete_email',
                    http: { method: 'DELETE', url: url }
                }).then(function () {
                    $scope.deleteEmailSuccess();
                });
            }
        };

        $scope.deleteEmailSuccess = function () {
            Alert('success', 'emails.messages.email_deleted');
            emails.splice(emails.indexOf($scope.emailToBeDeleted), 1);
        };

        $scope.createUserEmail = function () {
            $uibModal.open({ component: 'addUserEmail' }).result.then(function (data) {
                emails.push({ userEmail: data, companyEmail: false });
            });
        };

        $scope.resendVerificationEmail = function (emailDtoObject) {
            var id = emailDtoObject.userEmail.id;
            UserEmailsService.get({
                id: id
            }).$promise.then(function (data) {
                Alert('success', 'emails.messages.verification_link_resend');
            });
        };
    };
}

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'UserNotesService', '$state'];

    /** @ngInject */
    function Controller(Alert, UserNotesService, $state) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.UserNotesService = UserNotesService;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.note = {
                id: null,
                title: '',
                text: ''
            };
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.isSaving = true;
            this.UserNotesService.save(this.note).$promise.then(function (note) {
                _this.$state.go('^.edit', { noteId: note.id }, { reload: "^" });
                _this.Alert('success', 'company.sharing-center.note.add.added');
            }).finally(function () {
                return _this.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'ConfirmDeleteModal', 'UserNotesService', '$state', '$stateParams'];

    /** @ngInject */
    function Controller(Alert, ConfirmDeleteModal, UserNotesService, $state, $stateParams) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.UserNotesService = UserNotesService;
        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.theNote = this.note;
            if (this.theNote == null) {
                this.$state.go('^');
            }
            this.note = _extends({}, this.theNote);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            return angular.equals(this.note, this.theNote);
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this = this;

            this.isRemoving = true;
            this.ConfirmDeleteModal('company.sharing-center.confirm_company_note_delete').then(function () {
                return _this.UserNotesService.delete({ id: _this.note.id }).$promise;
            }).then(function () {
                _this.$state.go('^', {}, { reload: '^' });
                _this.Alert('success', 'company.sharing-center.note.manage.removed');
            }).finally(function () {
                return _this.isRemoving = false;
            });
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.isSaving = true;
            this.UserNotesService.save(this.note).$promise.then(function (note) {
                _this2.$state.go('.', {}, { reload: '^' });
                _this2.Alert('success', 'company.sharing-center.note.manage.saved');
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid || this.notModified();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', '$scope', '$rootScope', '$state', 'UserNotesService', 'ShowNoteModal', 'ConfirmDeleteModal', '$timeout'];

    /** @ngInject */
    function Controller(Alert, $scope, $rootScope, $state, UserNotesService, ShowNoteModal, ConfirmDeleteModal, $timeout) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.UserNotesService = UserNotesService;
        this.ShowNoteModal = ShowNoteModal;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.keepLockerOnServer = this.$rootScope.account.keepLockerOnServer;
            var format = function format(date) {
                return new Date(date).toString().slice(4, 24);
            };
            this.notes.forEach(function (note) {
                return note.updatedOnDisplay = format(note.updatedOn);
            });

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
        }
    }, {
        key: 'showNote',
        value: function showNote(note) {
            this.ShowNoteModal('Note', note.text);
        }
    }, {
        key: 'deleteNote',
        value: function deleteNote(note) {
            var _this2 = this;

            this.isRemoving = true;
            this.ConfirmDeleteModal('company.sharing-center.confirm_company_note_delete').then(function () {
                return _this2.UserNotesService.delete({ id: note.id }).$promise;
            }).then(function () {
                _this2.notes.splice(_this2.notes.indexOf(note), 1);
                _this2.Alert('success', 'company.sharing-center.note.manage.removed');
            }).finally(function () {
                return _this2.isRemoving = false;
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$uibModal', 'UserPhoneNumber'];

    /** @ngInject */
    function Controller($rootScope, $uibModal, UserPhoneNumber) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.UserPhoneNumber = UserPhoneNumber;
        this.$uibModal = $uibModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.phoneNumber = '';
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.UserPhoneNumber.save({
                phoneNumber: this.phoneNumber,
                usedForRecovery: false,
                smsNumber: false
            }, function (value, responseHeaders) {
                var id = responseHeaders('Location').split('/')[4];
                _this.UserPhoneNumber.get({ id: id }).$promise.then(function (_phoneNumber) {
                    _this.$uibModal.open({
                        component: 'verifyPhoneNumber',
                        resolve: { phoneNumber: function phoneNumber() {
                                return _phoneNumber;
                            } }
                    }).result.finally(function () {
                        return _this.close();
                    });
                });
            }, function (response) {
                _this.dismiss();
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _smartTable = __webpack_require__(2);

var _spAlert = __webpack_require__(4);

SmsNumberModalInstanceCtrl.$inject = ['$state', '$scope', '$uibModalInstance', 'Alert', 'id', 'NewSmsNumber', 'SmsNumber', 'SmsNumberGenerateCode'];
Controller.$inject = ['$scope', '$state', '$uibModal', 'Alert', 'DestructiveOperationModal', 'UserPhoneNumber']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, $uibModal, Alert, DestructiveOperationModal, UserPhoneNumber) {
    var _this = this;

    this.$onInit = function () {
        $scope.userPhoneNumbers = _this.phoneNumbers;
        $scope.st = new _smartTable.SmartTable();
        $scope.isSmsUser = _this.account.roles.includes('ROLE_SMS_USER');

        $scope.deleteNumber = function (phoneNumber) {
            $scope.successfulDelete = function () {
                var key = 'phone_numbers.sms_number.delete_number';
                var variables = { phoneNumber: phoneNumber.phoneNumber };
                Alert('success', key, variables);
                location.reload();
            };
            if (phoneNumber.status == "ACTIVE") {
                var url = 'app/rest/phonenumbers/' + phoneNumber.id + '?status=ACTIVE';
                DestructiveOperationModal({
                    titleKey: 'destructive_operation.delete_mobile_number_title',
                    textKey: 'destructive_operation.delete_mobile_number_text',
                    http: { method: 'DELETE', url: url }
                }).then(function () {
                    $scope.successfulDelete();
                });
            } else {
                UserPhoneNumber.deletePendingNumber({
                    id: phoneNumber.id
                }, function () {
                    $scope.successfulDelete();
                });
            }
        };

        $scope.openVerificationModal = function (_phoneNumber) {
            $uibModal.open({
                component: 'verifyPhoneNumber',
                resolve: { phoneNumber: function phoneNumber() {
                        return _phoneNumber;
                    } }
            }).result.then(function () {
                return $scope.userPhoneNumbers = UserPhoneNumber.query();
            });
        };

        $scope.setAsSmsNumber = function (_id) {
            $uibModal.open({
                templateUrl: __webpack_require__(2495),
                controller: SmsNumberModalInstanceCtrl,
                resolve: {
                    id: function id() {
                        return _id;
                    }
                }
            });
        };
    };
}

/** @ngInject */
function SmsNumberModalInstanceCtrl($state, $scope, $uibModalInstance, Alert, id, NewSmsNumber, SmsNumber, SmsNumberGenerateCode) {

    $scope.showFirst = true;
    $scope.showSecond = false;
    $scope.showThird = false;
    $scope.userPhoneId = id;

    $scope.checkPin = function () {
        SmsNumber.save({
            id: $scope.userPhoneId
        }, $scope.pin, function (response) {
            $scope.showFirst = false;
            $scope.showSecond = true;
            $scope.showThird = false;
        }, function (response) {
            $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
        });
    };

    $scope.continueSmsNumber = function () {
        SmsNumberGenerateCode.save({
            id: $scope.userPhoneId
        }, $scope.pin, function (response) {
            $scope.showFirst = false;
            $scope.showSecond = false;
            $scope.showThird = true;
        }, function (response) {
            $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
            $scope.cancel();
        });
    };

    $scope.setSmsNumber = function () {
        NewSmsNumber.save({
            id: $scope.userPhoneId
        }, $scope.activationCode, function (response) {
            Alert('success', 'phone_numbers.sms_number.messages.change_sms_number');
            $scope.cancel();
            $state.reload('user.mobile-numbers');
        }, function (response) {
            if (response.data.serviceErrorCode.toString() == 'ERR_101403') {
                $scope.cancel();
                $state.reload('user.mobile-numbers');
            } else {
                $scope.topLevelMessage = new _spAlert.SpAlert('danger', response.data.message);
            }
        });
    };

    $scope.cancel = function () {
        $scope.userPhoneId = null;
        $scope.pin = null;
        $scope.activationCode = null;
        $scope.showFirst = false;
        $scope.showSecond = false;
        $scope.showThird = false;
        $uibModalInstance.dismiss('cancel');
    };
}

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** @ngInject */
var Controller = exports.Controller = function () {
    function Controller() {
        _classCallCheck(this, Controller);
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.isHardTokenUser = this.account.roles.includes('ROLE_HARD_TOKEN_USER') || this.account.isSecondaryDeviceSession;
        }
    }]);

    return Controller;
}();

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', 'Alert', 'RecoverySettingsService'];

    /** @ngInject */
    function Controller($rootScope, Alert, RecoverySettingsService) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.Alert = Alert;
        this.RecoverySettingsService = RecoverySettingsService;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.$rootScope.account.hasVerifiedNumbers) {
                this.popoverTemplate = __webpack_require__(2504);
            } else {
                this.popoverTemplate = __webpack_require__(2505);
            }
        }
    }, {
        key: 'close',
        value: function close() {
            var _this = this;

            this.popoverIsOpen = false;
            if (this.doNotRemind) {
                this.RecoverySettingsService.changeRecoveryReminder.save(function () {
                    _this.$rootScope.account.recoveryReminder = false;
                }, function () {
                    _this.Alert('danger', 'recovery.action_text.change_reminder_failed');
                });
            }
        }
    }]);

    return Controller;
}();

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
Controller.$inject = ['$scope', '$state', '$uibModal', 'Alert', 'RecoverySettingsService'];
// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/** @ngInject */
function Controller($scope, $state, $uibModal, Alert, RecoverySettingsService) {
    var _this = this;

    this.$onInit = function () {
        $scope.formData = {};
        $scope.turnedOff = false;
        $scope.hasRecovery = true;
        $scope.questionAnswerPattern = /^(\S.{4,198}\S)$/;
        $scope.choosenNumber = 0;
        var recoverySetting = {};
        var data = _this.recoverySettingsData;
        _this.activeNumbers = _this.phoneNumbers.filter(function (number) {
            return number.status === 'ACTIVE';
        });
        var userPhoneNumber = _this.activeNumbers[0];
        if (userPhoneNumber) {
            $scope.choosenNumber = userPhoneNumber.id;
        }
        $scope.delay = {};
        $scope.ask = {};
        $scope.delay.immediateRadio = data.sendRecoverySmsImmediately;
        $scope.turnedOff = data.recoveryTurnedOff;
        $scope.recoveryPhoneNumber = data.userPhoneNumber;
        if ($scope.recoveryPhoneNumber) {
            $scope.hasRecovery = true;
        } else {
            $scope.hasRecovery = false;
        }
        if (data.recoverySecurityQuestion) {
            $scope.ask.questionRadio = true;
            $scope.formData.question = data.recoverySecurityQuestion.recoverySecurityQuestion;
            $scope.formData.answer = data.recoverySecurityQuestion.recoverySecurityQuestionAnswer;
        } else {
            $scope.ask.questionRadio = false;
        }

        $scope.updateChoosenNumber = function (id) {
            $scope.choosenNumber = id;
        };

        $scope.setRecoveryNumber = function () {
            if ($scope.choosenNumber == 0) {
                $state.go('^.add');
            } else {
                RecoverySettingsService.setRecoveryNumber.get({
                    phoneNumberId: $scope.choosenNumber
                }).$promise.then(function (data) {
                    $state.go('^.list', {}, { reload: '^' });
                    Alert('success', 'recovery.action_text.recovery_number_set');
                });
            }
        };

        $scope.turnOff = function () {
            $uibModal.open({ component: 'confirmTurnOffRecovery' }).result.then(function () {
                RecoverySettingsService.turnOffRecovery.save(function (data) {
                    $state.go('^.list', {}, { reload: '^' });
                    Alert('success', 'recovery.action_text.turn_off_success');
                }, function () {
                    Alert('danger', 'recovery.action_text.turn_off_failed');
                });
            });
        };
        $scope.removeRecovery = function () {
            $uibModal.open({ component: 'confirmRemoveRecovery' }).result.then(function () {
                RecoverySettingsService.removeRecovery.save(function (data) {
                    $state.go('^.list', {}, { reload: '^' });
                    Alert('success', 'recovery.action_text.remove_success');
                }, function () {
                    Alert('danger', 'recovery.action_text.turn_off_failed');
                });
            });
        };
        $scope.updateRecovery = function () {
            $uibModal.open({ component: 'confirmUpdateRecovery' }).result.then(function () {
                recoverySetting.sendRecoverySmsImmediately = $scope.delay.immediateRadio;
                if ($scope.ask.questionRadio) {
                    var recoverySecurityQuestion = {
                        recoverySecurityQuestion: $scope.formData.question,
                        recoverySecurityQuestionAnswer: $scope.formData.answer
                    };
                    recoverySetting.recoverySecurityQuestion = recoverySecurityQuestion;
                } else {
                    recoverySetting.recoverySecurityQuestion = null;
                }
                RecoverySettingsService.updateSettings.save(recoverySetting, function (data) {
                    Alert('success', 'recovery.action_text.update_success');
                    $state.go('^.list', {}, { reload: '^' });
                }, function () {
                    Alert('danger', 'recovery.action_text.update_failed');
                });
            });
        };
    };
}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$resource', '$state', '$timeout', 'Alert', 'UserPhoneNumber'];

    /** @ngInject */
    function Controller($resource, $state, $timeout, Alert, UserPhoneNumber) {
        _classCallCheck(this, Controller);

        this.$resource = $resource;
        this.$timeout = $timeout;
        this.$state = $state;
        this.Alert = Alert;
        this.UserPhoneNumber = UserPhoneNumber;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.phoneNumber = this.resolve.phoneNumber;
            this.verificationCode = '';
            var key = 'phone_numbers.sms_number.mobile_number_submitted';
            this.$timeout(function () {
                return _this.spAlert = new _spAlert.SpAlert('info', key, {}, false);
            });
        }
    }, {
        key: 'resend',
        value: function resend() {
            var _this2 = this;

            this.$resource('app/rest/phonenumbers/:id/verificationresend').save({ id: this.phoneNumber.id }, null).$promise.then(function () {
                _this2.verificationCode = '';
                var key = 'phone_numbers.sms_number.verification_message';
                _this2.spAlert = new _spAlert.SpAlert('info', key);
            });
        }
    }, {
        key: 'verify',
        value: function verify() {
            var _this3 = this;

            this.$resource('app/rest/phonenumbers/:id/verification').save({ id: this.phoneNumber.id }, { verificationCode: this.verificationCode }).$promise.then(function () {
                _this3.Alert('success', 'phone_numbers.sms_number.successful_verification');
                _this3.$state.go('user.mobile-numbers.list').then(function () {
                    return location.reload();
                });
            }).catch(function (response) {
                _this3.spAlert = new _spAlert.SpAlert('danger', response.data.message, {}, false);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['RegistrationProfile'];

    /** @ngInject */
    function Controller(RegistrationProfile) {
        _classCallCheck(this, Controller);

        this.RegistrationProfile = RegistrationProfile;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeEmails = this.resolve.activeEmails;
            this.profile = {};
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.RegistrationProfile.save(this.profile).$promise.then(function (profile) {
                return _this.close({ $value: profile });
            }).catch(function (response) {
                _this.spAlert = new _spAlert.SpAlert('danger', response.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getFacebookData = getFacebookData;

var _loadFacebookSdk = __webpack_require__(698);

function getFacebookData() {
    return (0, _loadFacebookSdk.loadFacebookSdk)().then(function (FB) {
        return new Promise(function (resolve, reject) {
            FB.login(function (_ref) {
                var authResponse = _ref.authResponse;

                if (!authResponse) {
                    return reject();
                }
                Promise.all([new Promise(function (resolve) {
                    return FB.api('/me', function (data) {
                        return resolve(data);
                    });
                }), new Promise(function (resolve) {
                    return FB.api('/me/likes', function (data) {
                        return resolve(data);
                    });
                })]).then(function (_ref2) {
                    var _ref3 = _slicedToArray(_ref2, 2),
                        facebookData = _ref3[0],
                        facebookLikes = _ref3[1];

                    resolve({ facebookData: facebookData, facebookLikes: facebookLikes });
                });
            }, {
                scope: ['email', 'user_birthday', 'user_education_history', 'user_interests', 'user_work_history', 'user_likes', 'user_relationships', 'user_location'].join(', ')
            });
        });
    });
}

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadFacebookSdk = loadFacebookSdk;

var _scriptjs = __webpack_require__(191);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promise = void 0;

function loadFacebookSdk() {
    return promise ? promise : promise = new Promise(function (resolve) {
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: window.env.facebookAppId,
                status: true,
                cookie: true,
                xfbml: true,
                version: 'v2.4'
            });
            resolve(window.FB);
        };
        (0, _scriptjs2.default)('https://connect.facebook.net/en_US/sdk.js');
    });
}

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'EditProfileBasicModal'];

    /** @ngInject */
    function Controller(Alert, EditProfileBasicModal) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.EditProfileBasicModal = EditProfileBasicModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'isActiveDirectory',
        value: function isActiveDirectory() {
            return !!this.profile.adAccountClone;
        }
    }, {
        key: 'isFacebook',
        value: function isFacebook() {
            return this.profile.profileSource === 'FACEBOOK';
        }
    }, {
        key: 'showEditProfileBasicModal',
        value: function showEditProfileBasicModal() {
            var _this = this;

            this.EditProfileBasicModal(this.profile).then(function (profile) {
                Object.assign(_this.profile, profile);
                _this.Alert('success', 'registration_profiles.messages.edit');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['RegistrationProfile'];

    /** @ngInject */
    function Controller(RegistrationProfile) {
        _classCallCheck(this, Controller);

        this.RegistrationProfile = RegistrationProfile;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.genders = this.resolve.genders;
            this.maritalStates = this.resolve.maritalStates;
            this.profile = angular.copy(this.resolve.profile);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.RegistrationProfile.updateProfile({ id: this.profile.id }, this.profile).$promise.then(function (profile) {
                return _this.close({ $value: profile });
            }).catch(function (response) {
                _this.spAlert = new _spAlert.SpAlert('danger', response.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _spAlert = __webpack_require__(4);

var _countries = __webpack_require__(193);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['RegistrationProfile'];

    /** @ngInject */
    function Controller(RegistrationProfile) {
        _classCallCheck(this, Controller);

        this.RegistrationProfile = RegistrationProfile;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.countries = Object.keys(_countries.countries).map(function (code) {
                return _countries.countries[code];
            });
            this.phoneNumbers = this.resolve.phoneNumbers;
            this.profile = angular.copy(this.resolve.profile);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.RegistrationProfile.updateProfile({ id: this.profile.id }, this.profile).$promise.then(function (profile) {
                return _this.close({ $value: profile });
            }).catch(function (response) {
                _this.spAlert = new _spAlert.SpAlert('danger', response.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'EditProfileExtendedModal'];

    /** @ngInject */
    function Controller(Alert, EditProfileExtendedModal) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.EditProfileExtendedModal = EditProfileExtendedModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'isActiveDirectory',
        value: function isActiveDirectory() {
            return !!this.profile.adAccountClone;
        }
    }, {
        key: 'isFacebook',
        value: function isFacebook() {
            return this.profile.profileSource === 'FACEBOOK';
        }
    }, {
        key: 'showEditProfileExtendedModal',
        value: function showEditProfileExtendedModal() {
            var _this = this;

            this.EditProfileExtendedModal(this.profile).then(function (profile) {
                Object.assign(_this.profile, profile);
                _this.Alert('success', 'registration_profiles.messages.edit');
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['RegistrationProfile'];

    /** @ngInject */
    function Controller(RegistrationProfile) {
        _classCallCheck(this, Controller);

        this.RegistrationProfile = RegistrationProfile;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.profile = this.resolve.profile;
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            this.RegistrationProfile.delete({ id: this.profile.id }).$promise.then(function () {
                return _this.close();
            }).catch(function (response) {
                _this.spAlert = new _spAlert.SpAlert('danger', response.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _spAlert = __webpack_require__(4);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['RegistrationProfile'];

    /** @ngInject */
    function Controller(RegistrationProfile) {
        _classCallCheck(this, Controller);

        this.RegistrationProfile = RegistrationProfile;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.activeEmails = this.resolve.activeEmails;
            this.profile = angular.copy(this.resolve.profile);
        }
    }, {
        key: 'save',
        value: function save() {
            var _this = this;

            this.RegistrationProfile.updateProfile({ id: this.profile.id }, this.profile).$promise.then(function (profile) {
                return _this.close({ $value: profile });
            }).catch(function (response) {
                _this.spAlert = new _spAlert.SpAlert('danger', response.data.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;
Controller.$inject = ['$scope', '$state', '$uibModal', 'Alert', 'EditProfileMainModal', 'RegistrationProfile'];
// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/** @ngInject */
function Controller($scope, $state, $uibModal, Alert, EditProfileMainModal, RegistrationProfile) {
    var _this = this;

    this.$onInit = function () {
        return $scope.profile = _this.profile;
    };

    $scope.isFacebook = function (profile) {
        return profile.profileSource == "FACEBOOK";
    };

    $scope.isActiveDirectory = function (profile) {
        return profile.adAccountClone != null;
    };

    $scope.changeDefaultProfile = function () {
        RegistrationProfile.setDefault({ id: _this.profile.id }, _this.profile.isDefault).$promise.then(function (profiles) {
            return Object.assign(_this.profiles, profiles);
        });
    };

    $scope.editProfileMain = function (profile) {
        EditProfileMainModal(profile).then(editSuccess);
    };

    function editSuccess(profile) {
        Object.assign($scope.profile, profile);
        Alert('success', 'registration_profiles.messages.edit');
    }

    $scope.copy = function (profile) {
        RegistrationProfile.copyProfile({
            id: profile.id
        }, function (data) {
            Alert('success', 'registration_profiles.messages.copy');
        });
    };

    $scope.deleteProfile = function (_profile) {
        $uibModal.open({ component: 'deleteProfile', resolve: { profile: function profile() {
                    return _profile;
                } } }).result.then(function () {
            Alert('success', 'registration_profiles.messages.delete');
            $state.go('user.profiles', {}, { reload: true });
        });
    };
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _facebookProfileImport = __webpack_require__(697);

Controller.$inject = ['$scope', '$state', '$uibModal', 'AddProfileModal', 'Alert', 'RegistrationProfile']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope, $state, $uibModal, AddProfileModal, Alert, RegistrationProfile) {
    var _this = this;

    this.$onInit = function () {

        if ($state.is('user.profiles') && _this.profiles.length) {
            $state.go('.profile.main', { profileId: _this.profiles[0].id }, { location: 'replace' });
        }

        $scope.profiles = _this.profiles;
        $scope.facebookProfiles = new Array();
        $scope.userProfiles = new Array();

        $scope.isSmsUser = _this.account.roles.includes('ROLE_SMS_USER');
        $scope.isHardTokenUser = _this.account.roles.includes('ROLE_HARD_TOKEN_USER') || _this.account.isSecondaryDeviceSession;

        /**
         * Separates all returned registration profiles into two arrays of user
         * profiles and facebook profiles.
         */
        var separateProfiles = function separateProfiles() {
            $scope.facebookProfiles = [];
            $scope.userProfiles = [];
            for (var i = 0; i < $scope.profiles.length; i++) {
                if ($scope.profiles[i].profileSource == "FACEBOOK") {
                    $scope.facebookProfiles.push($scope.profiles[i]);
                } else {
                    $scope.userProfiles.push($scope.profiles[i]);
                }
            }
        };

        separateProfiles();

        $scope.addProfile = function () {
            AddProfileModal().then(function (profile) {
                Alert('success', 'registration_profiles.messages.save');
                RegistrationProfile.query(function (profiles) {
                    Object.assign($scope.profiles, profiles);
                    $state.go('user.profiles.profile', { profileId: profile.id });
                    separateProfiles();
                });
            });
        };

        $scope.importFacebookProfile = function () {
            (0, _facebookProfileImport.getFacebookData)().then(function (facebookData) {

                RegistrationProfile.importFacebookProfile(facebookData, function (data) {
                    $scope.profiles = RegistrationProfile.query(function () {
                        separateProfiles();
                        Alert('success', 'registration_profiles.messages.import');
                    });
                });
            });
        };

        $scope.showProfilesInfo = function () {
            return $uibModal.open({ component: 'profilesInfo' });
        };
        $scope.showSocialProfilesInfo = function () {
            return $uibModal.open({ component: 'socialProfilesInfo' });
        };
    };
}

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', 'Alert', 'Authenticator'];

    /** @ngInject */
    function Controller($state, Alert, Authenticator) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$state = $state;
        this.Authenticator = Authenticator;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isAuthenticator = this.type == 'authenticator';
            this.tooltipTemplate = __webpack_require__(107);
            if (this.copyAccount != null) {
                this.account = this.copyAccount;
                this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
            } else {
                this.account = {
                    algorithm: 'SHA1',
                    digits: 6
                };
            }
            if (this.isAuthenticator) {
                this.publicServicesWithSsoAnd2FA$.get().then(function (items) {
                    return _this.publicServices = items;
                });
            } else {
                this.publicServicesWithSso$.get().then(function (items) {
                    return _this.publicServices = items;
                });
            }
        }
    }, {
        key: 'save',
        value: function save() {
            var _this2 = this;

            this.isSaving = true;
            var publicServiceKey = null;
            if (this.isAuthenticator) {
                publicServiceKey = generatePublicServiceKey(this.account.publicService.serviceName, this.account.username, this.account.secret, this.account.digits, this.account.algorithm);
            }
            this.Authenticator.create({
                publicServiceId: this.account.publicService.id
            }, {
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: this.isAuthenticator,
                note: this.account.note,
                customServiceName: this.account.customServiceName,
                publicServiceKey: publicServiceKey
            }).$promise.then(function (account) {
                _this2.$state.go('^.edit', { publicUserAccountId: account.id }, { reload: "^" });
                if (_this2.isAuthenticator) {
                    _this2.Alert('success', 'user.public-user-accounts.add.authenticator.added');
                } else {
                    _this2.Alert('success', 'user.public-user-accounts.add.password-manager.added');
                }
            }).finally(function () {
                return _this2.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid || !this.account.publicService;
        }
    }, {
        key: 'selectCustom',
        value: function selectCustom() {
            this.searchItem = 'Custom';
            this.account.publicService = this.publicServices.find(function (i) {
                return i.slug === "other";
            });
        }
    }]);

    return Controller;
}();

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    var secret = secretKey.replace(/\s/g, '');
    return 'otpauth://totp/' + issuer + ':' + username + '?secret=' + secret + '&issuer=' + issuer + '&digits=' + digits + '&algorithm=' + algorithm;
}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _getUrlParam = __webpack_require__(202);

var _passwordStrength = __webpack_require__(85);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$scope', 'Alert', 'ConfirmDeleteModal', 'ConfirmModal', 'Authenticator', 'PasswordManagers', 'ConfirmConvertModal', 'DestructiveOperationModal', '$uibModal'];

    /** @ngInject */
    function Controller($state, $scope, Alert, ConfirmDeleteModal, ConfirmModal, Authenticator, PasswordManagers, ConfirmConvertModal, DestructiveOperationModal, $uibModal) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.ConfirmModal = ConfirmModal;
        this.Authenticator = Authenticator;
        this.PasswordManagers = PasswordManagers;
        this.$state = $state;
        this.$scope = $scope;
        this.ConfirmConvertModal = ConfirmConvertModal;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.$uibModal = $uibModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.tooltipTemplate = __webpack_require__(107);
            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });

            if (this.publicUserAccount == null) {
                this.$state.go('^');
            }
            this.$account = _extends({}, this.publicUserAccount, {
                digits: 6,
                algorithm: 'SHA1',
                secret: null
            });

            if (this.publicUserAccount.authenticator && this.publicUserAccount.serviceKey) {
                var url = this.publicUserAccount.serviceKey.publicServiceKey;
                this.$account = _extends({}, this.$account, {
                    digits: +(0, _getUrlParam.getUrlParam)(url, 'digits', 6),
                    algorithm: (0, _getUrlParam.getUrlParam)(url, 'algorithm', 'SHA1'),
                    secret: (0, _getUrlParam.getUrlParam)(url, 'secret')
                });
            }

            this.account = JSON.parse(JSON.stringify(this.$account));
            this.passGrade = (0, _passwordStrength.passwordGrade)(this.account.password);
            this.publicServicesWithSso$.get().then(function (items) {
                return _this.publicServices = items;
            });
            this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';

            this.isCustom = this.$account.publicService.slug == 'other';
        }
    }, {
        key: 'saveIcon',
        value: function saveIcon(iconFile) {
            var _this2 = this;

            var formData = new FormData();
            formData.append('iconFile', iconFile);
            return this.Authenticator.uploadCustomIcon({
                publicUserAccountId: this.account.id
            }, formData).$promise.then(function (data) {
                _this2.account.customIcon = data.customIcon;
                _this2.Alert('success', 'user.public-user-accounts.edit.updated');
            });
        }
    }, {
        key: 'resetIcon',
        value: function resetIcon() {
            var _this3 = this;

            return this.ConfirmModal({
                messageKey: 'Custom icon will be deleted and default icon will be used. Do you want to continue?',
                titleKey: 'Confirm Delete'
            }).then(function () {
                return _this3.Authenticator.deleteCustomIcon({
                    publicUserAccountId: _this3.account.id
                }).$promise.then(function () {
                    _this3.account.customIcon = null;
                    _this3.Alert('success', 'user.public-user-accounts.edit.updated');
                });
            });
        }
    }, {
        key: 'changePassGrade',
        value: function changePassGrade() {
            this.passGrade = (0, _passwordStrength.passwordGrade)(this.account.password);
        }
    }, {
        key: 'notModified',
        value: function notModified() {
            if (this.$account.publicService.id === this.account.publicService.id) {
                this.account.publicService = this.$account.publicService;
            }
            return angular.equals(this.$account, this.account);
        }
    }, {
        key: 'selectCustom',
        value: function selectCustom() {
            this.searchItem = 'Custom';
            this.account.publicService = this.publicServices.find(function (i) {
                return i.slug === "other";
            });
        }
    }, {
        key: 'serviceSelected',
        value: function serviceSelected(service) {
            this.account.publicService = service;
            if (service.slug !== "other") {
                this.account.customAuthenticator = null;
            }
        }
    }, {
        key: 'remove',
        value: function remove() {
            var _this4 = this;

            this.isRemoving = true;
            if (this.$account.authenticator) {
                this.DestructiveOperationModal({
                    titleKey: 'authenticators.messages.delete_authenticator_title',
                    textKey: 'authenticators.messages.warning',
                    http: { method: 'DELETE', url: 'app/rest/authenticators/' + this.account.id }
                }).then(function () {
                    _this4.$state.go('^', {}, { reload: '^' });
                    _this4.Alert('success', 'authenticators.messages.delete');
                    _this4.isRemoving = false;
                }).finally(function () {
                    return _this4.isRemoving = false;
                });
            } else {
                this.$uibModal.open({ component: 'userPasswordManagerConfirmRemove' }).result.then(function () {
                    _this4.PasswordManagers.remove(_this4.account.id).then(function () {
                        _this4.Alert('success', 'authenticators.messages.deleteLoginItem');
                        _this4.$state.go('^', {}, { reload: '^' });
                    });
                }).finally(function () {
                    return _this4.isRemoving = false;
                });
            }
        }
    }, {
        key: 'save',
        value: function save() {
            var _this5 = this;

            this.isSaving = true;
            if (this.$account.authenticator && !this.account.authenticator) {
                this.ConfirmConvertModal('user.public-user-accounts.edit.convert-auth-to-pass').then(function () {
                    return _this5.performSave();
                }).finally(function () {
                    return _this5.isSaving = false;
                });
            } else {
                this.performSave();
            }
        }
    }, {
        key: 'performSave',
        value: function performSave() {
            var _this6 = this;

            var customServiceName = void 0;
            if (this.account.customAuthenticator) {
                customServiceName = this.account.customAuthenticator.customAuthenticatorName;
            }
            var publicServiceKey = void 0;
            if (this.account.authenticator) {
                publicServiceKey = generatePublicServiceKey(this.account.publicService.serviceName, this.account.username, this.account.secret, this.account.digits, this.account.algorithm);
            }
            var serviceLoginUrl = void 0;
            if (this.account.customLoginUrl) {
                serviceLoginUrl = this.account.customLoginUrl.serviceLoginUrl;
            }

            this.Authenticator.edit({
                publicServiceId: this.account.publicService.id
            }, {
                id: this.account.id,
                username: this.account.username,
                password: this.account.password,
                note: this.account.note,
                serviceLoginUrl: serviceLoginUrl,
                enabled2fa: this.account.authenticator,
                customServiceName: customServiceName,
                publicServiceKey: publicServiceKey
            }).$promise.then(function (account) {
                _this6.$state.go('.', {}, { reload: '^' });
                _this6.Alert('success', 'user.public-user-accounts.edit.updated');
            }).finally(function () {
                return _this6.isSaving = false;
            });
        }
    }, {
        key: 'saveDisabled',
        value: function saveDisabled(form) {
            return this.isSaving || form.$invalid || this.notModified();
        }
    }, {
        key: 'convertDisabled',
        value: function convertDisabled(form) {
            return this.isSaving || this.isRemoving;
        }
    }, {
        key: 'convert',
        value: function convert() {
            this.account.authenticator = !this.account.authenticator;
        }
    }, {
        key: 'createCopy',
        value: function createCopy() {
            var copyAccount = {
                username: this.publicUserAccount.username,
                password: this.publicUserAccount.password,
                note: this.publicUserAccount.note,
                publicService: this.publicServices.find(function (i) {
                    return i.slug === "other";
                }),
                customServiceName: this.getCopyServiceName(),
                serviceLoginUrl: this.publicUserAccount.publicService.slug === 'other' ? this.publicUserAccount.customLoginUrl : this.publicUserAccount.publicService.serviceUrl
            };

            if (this.publicUserAccount.authenticator) {
                var url = this.publicUserAccount.serviceKey.publicServiceKey;
                copyAccount = _extends({}, copyAccount, {
                    algorithm: (0, _getUrlParam.getUrlParam)(url, 'algorithm', 'SHA1'),
                    digits: +(0, _getUrlParam.getUrlParam)(url, 'digits', 6),
                    secret: (0, _getUrlParam.getUrlParam)(url, 'secret')
                });
            }

            var type = this.publicUserAccount.authenticator ? 'authenticator' : 'password-manager';
            this.$state.go("user.public.user-accounts.add", { type: type, copyAccount: copyAccount });
        }
    }, {
        key: 'getCopyServiceName',
        value: function getCopyServiceName() {
            var _this7 = this;

            var currentServiceName = this.publicUserAccount.publicService.slug === 'other' ? this.publicUserAccount.customAuthenticator.customAuthenticatorName : this.publicUserAccount.publicService.serviceName;
            var customServiceNames = this.publicUserAccounts.filter(function (account) {
                return account.username === _this7.publicUserAccount.username && account.publicService.slug === 'other' && account.customAuthenticator != null;
            }).map(function (item) {
                return item.customAuthenticator.customAuthenticatorName;
            });
            currentServiceName = currentServiceName.indexOf(' Copy') !== -1 ? currentServiceName.substring(0, currentServiceName.indexOf(' Copy')) : currentServiceName;
            var copyServiceName = currentServiceName + ' Copy';
            if (customServiceNames.indexOf(copyServiceName) === -1) {
                return copyServiceName;
            }

            var i = 1;
            while (customServiceNames.indexOf(copyServiceName + ' ' + i) !== -1) {
                i++;
            }
            return copyServiceName + ' ' + i;
        }
    }]);

    return Controller;
}();

function generatePublicServiceKey(issuer, username, secretKey, digits, algorithm) {
    var secret = secretKey.replace(/\s/g, '');
    return 'otpauth://totp/' + issuer + ':' + username + '?secret=' + secret + '&issuer=' + issuer + '&digits=' + digits + '&algorithm=' + algorithm;
}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['ExtentionManaging'];

    /** @ngInject */
    function Controller(ExtentionManaging) {
        _classCallCheck(this, Controller);

        this.ExtentionManaging = ExtentionManaging;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'installExtension',
        value: function installExtension() {
            this.ExtentionManaging.installExtension();
        }
    }, {
        key: 'installExtensionButtonVisible',
        value: function installExtensionButtonVisible() {
            if (this.account.roles.includes('ROLE_HARD_TOKEN_USER')) {
                return false;
            }
            if (this.account.roles.includes('ROLE_SMS_USER')) {
                return false;
            }
            if (_userAgent.ua.isIOS()) {
                return false;
            }
            if (document.getElementById("saaspass-extension-info")) {
                return false;
            }
            if (document.getElementById('extension-is-installed-v2.1.0')) {
                return false;
            }
            if (document.getElementById('extension-is-installed-v2.1.0')) {
                return false;
            }
            return (_userAgent.ua.isFirefox() || _userAgent.ua.isSafari() || _userAgent.ua.isChrome() || _userAgent.ua.isOpera()) && !_userAgent.ua.isIOS();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state'];

    /** @ngInject */
    function Controller($state) {
        _classCallCheck(this, Controller);

        this.$state = $state;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.importResult = this.$state.params.importResult;
            this.close = function () {
                _this.$state.go('user.public.user-accounts', {}, { reload: true });
            };
        }
    }]);

    return Controller;
}();

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$state', '$timeout', 'Alert', 'PasswordManagers'];

    /** @ngInject */
    function Controller($state, $timeout, Alert, PasswordManagers) {
        _classCallCheck(this, Controller);

        this.$state = $state;
        this.Alert = Alert;
        this.$timeout = $timeout;
        this.PasswordManagers = PasswordManagers;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.fileType = null;
            this.importResult = null;
            this.fileToUpload = { value: null };
            this.isUploading = false;
            this.uploadCSV = function () {

                if (!_this.fileToUpload.value) {
                    return;
                }
                _this.isUploading = true;
                _this.PasswordManagers.importItems(_this.fileType, _this.fileToUpload.value, function (data) {
                    _this.isUploading = false;
                    if (data.numberOfFailedImport == 0) {
                        _this.$state.go('user.public.user-accounts', {}, { reload: true });
                        _this.Alert('success', 'password-managers-import.result.success');
                    } else {
                        _this.$state.go('user.public.user-accounts.import.result', { importResult: data });
                    }
                }, function (response, status) {
                    _this.isUploading = false;
                    _this.fileToUpload.value = null;
                    document.getElementById("uploadInput").value = null;
                    _this.importResult = null;
                });
            };
            this.fnc = function () {
                _this.$timeout(function () {
                    document.getElementById("uploadInput").click();
                });
            };
        }
    }]);

    return Controller;
}();

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

var _smartTable = __webpack_require__(2);

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', 'Authenticator', 'PasswordManagers', 'DestructiveOperationModal', '$uibModal', 'SsoFactory', '$scope', '$state', '$window', '$timeout', 'ShowNoteModal'];

    /** @ngInject */
    function Controller(Alert, Authenticator, PasswordManagers, DestructiveOperationModal, $uibModal, SsoFactory, $scope, $state, $window, $timeout, ShowNoteModal) {
        _classCallCheck(this, Controller);

        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.$state = $state;
        this.Alert = Alert;
        this.Authenticator = Authenticator;
        this.PasswordManagers = PasswordManagers;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.SsoFactory = SsoFactory;
        this.$timeout = $timeout;
        this.ShowNoteModal = ShowNoteModal;
        this.$window = $window;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
            this.isHardTokenUser = this.account.roles.includes('ROLE_HARD_TOKEN_USER') || this.account.isSecondaryDeviceSession;
            this.st = new _smartTable.SmartTable();
            this.showExtensionAlert = false;
            this.showIEText = false;
            this.mustRenewOtp = false;
            var hasExtensionInstalled201 = document.getElementById('extension-is-installed-v2.0.1') != null;
            this.hasPass = false;
            this.showPassword = false;
            this.oldExtensionInstalled = hasExtensionInstalled201;
            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
        }
    }, {
        key: 'copyCli',
        value: function copyCli(p) {
            this.getPassword(p);
        }
    }, {
        key: 'getPassword',
        value: function getPassword(p) {
            return this.PasswordManagers.getPassword(p.id).then(function (data) {
                p.password = data.password;
                p.hiddenPass = true;
                p.hasPass = true;
            });
        }
    }, {
        key: 'getOtp',
        value: function getOtp(p) {
            var _this2 = this;

            return this.PasswordManagers.getOtp(p.id).then(function (data) {
                p.otp = data.otp;
            }).then(function () {
                return _this2.$timeout(30000);
            }).then(function () {
                return p.mustRenewOtp = true;
            });
        }
    }, {
        key: 'renewOTP',
        value: function renewOTP(p) {
            var _this3 = this;

            return this.PasswordManagers.getOtp(p.id).then(function (data) {
                p.otp = data.otp;
            }).then(function () {
                return p.mustRenewOtp = false;
            }).then(function () {
                return _this3.$timeout(30000);
            }).then(function () {
                return p.mustRenewOtp = true;
            });
        }
    }, {
        key: 'showPasswordF',
        value: function showPasswordF(p) {
            p.hiddenPass = !p.hiddenPass;
        }
    }, {
        key: 'showPassword',
        value: function showPassword(p) {
            this.PasswordManagers.getPassword(p.id).then(function (data) {
                p.password = data.password;
            });
        }
    }, {
        key: 'login',
        value: function login(authenticator) {
            this.SsoFactory.authenticatorsSSO(authenticator);

            var hasExtensionInstalled = document.getElementById('extension-is-installed-v2.0.1') != null || document.getElementById('extension-is-installed-v2.1.0') != null;
            if (!hasExtensionInstalled && !document.getElementById("saaspass-extension-info")) {
                this.showExtensionAlert = true;
                $('html, body').animate({ scrollTop: 0 }, 'slow');
                this.showIEText = !(_userAgent.ua.isChrome() || _userAgent.ua.isOpera() || _userAgent.ua.isFirefox() || _userAgent.ua.isSafari());
            }
        }
    }, {
        key: 'showDeleteAuthenticatorDP',
        value: function showDeleteAuthenticatorDP(id) {
            var _this4 = this;

            this.DestructiveOperationModal({
                titleKey: 'authenticators.messages.delete_authenticator_title',
                textKey: 'authenticators.messages.warning',
                http: { method: 'DELETE', url: 'app/rest/authenticators/' + id }
            }).then(function () {
                _this4.$state.reload(_this4.$state.current);
                _this4.Alert('success', 'authenticators.messages.delete');
            });
        }
    }, {
        key: 'loginButtonVisible',
        value: function loginButtonVisible(authenticator) {
            if (this.oldExtensionInstalled && !authenticator.publicService.ssoInstructions) {
                return false;
            }
            if (authenticator.accountType === 'AUTHENTICATOR' && !authenticator.ssoEnabled) {
                return false;
            }
            var hasServiceUrl = !!(authenticator.publicService || {}).serviceUrl;
            var customUrlRequired = !!(authenticator.publicService || {}).urlRequired;
            var hasCustomUrl = !!(authenticator.customLoginUrl || {}).serviceLoginUrl;
            return hasServiceUrl && !customUrlRequired || hasCustomUrl;
        }
    }, {
        key: 'showDeletePasswordManagerDP',
        value: function showDeletePasswordManagerDP(id) {
            var _this5 = this;

            this.$uibModal.open({ component: 'userPasswordManagerConfirmRemove' }).result.then(function () {
                _this5.PasswordManagers.remove(id).then(function () {
                    _this5.Alert('success', 'authenticators.messages.deleteLoginItem');
                    _this5.$state.reload(_this5.$state.current);
                });
            });
        }
    }, {
        key: 'showNote',
        value: function showNote(authenticator) {
            this.ShowNoteModal('Note', authenticator.note);
        }
    }, {
        key: 'exportAll',
        value: function exportAll() {
            var _this6 = this;

            this.Authenticator.exportAll().$promise.then(function (response) {
                var file = new Blob([response.data], {
                    type: 'text/plain'
                });
                var windowUrl = _this6.$window.URL;
                var fileURL = windowUrl.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'exported_authenticators&passwords_' + new Date().valueOf() + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function () {
                    windowUrl.revokeObjectURL(fileURL);
                }, 100);
                _this6.Alert('success', 'public-user-accounts.export-succes');
            }).catch(function (error) {
                _this6.Alert('danger', error.message);
            });
        }
    }]);

    return Controller;
}();

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _smartTable = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
	Controller.$inject = ['$state', '$rootScope', 'Alert', 'UsersSharedAccountService'];

	/** @ngInject */
	function Controller($state, $rootScope, Alert, UsersSharedAccountService) {
		_classCallCheck(this, Controller);

		this.$state = $state;
		this.Alert = Alert;
		this.$rootScope = $rootScope;
		this.UsersSharedAccountService = UsersSharedAccountService;
	}

	_createClass(Controller, [{
		key: '$onInit',
		value: function $onInit() {
			if (!(Array.isArray(this.companies) && this.companies.length)) {
				this.$state.go('user.shared-accounts', {}, { location: 'replace' });
			}

			this.publicUserAccounts = null;
			this.visibilitySetting = { showOtpEnabled: false, showPasswordEnabled: false };
		}
	}, {
		key: 'changeCompany',
		value: function changeCompany() {
			this.publicUserAccounts = null;
			this.hasOtp = null;
		}
	}, {
		key: 'goBack',
		value: function goBack() {
			var goToState = this.$rootScope.transition.from();
			var theState = goToState.name;
			if (theState === "") {
				theState = goToState.url;
			}
			this.$state.go(theState);
		}
	}, {
		key: 'importPasswordManagers',
		value: function importPasswordManagers() {
			this.publicUserAccounts = angular.copy(this.passwordManagers);
			this.st = new _smartTable.SmartTable();
			this.st.displayedItems = this.publicUserAccounts;
			this.hasOtp = false;
		}
	}, {
		key: 'importAuthenticators',
		value: function importAuthenticators() {
			this.publicUserAccounts = angular.copy(this.authenticators);
			this.st = new _smartTable.SmartTable();
			this.st.displayedItems = this.publicUserAccounts;

			this.hasOtp = true;
		}
	}, {
		key: 'add',
		value: function add(selectedPublicUserAccounts) {
			this.showConfirm = true;
			this.userAccountsToShare = selectedPublicUserAccounts;
			//this.st = new SmartTable();
			//this.st.displayedItems=this.userAccountsToShare;
		}
	}, {
		key: 'cancelConfirm',
		value: function cancelConfirm() {
			this.showConfirm = false;
			this.userAccountsToShare = null;
		}
	}, {
		key: 'goFromBegining',
		value: function goFromBegining() {
			this.$state.transitionTo(this.$state.current, { companies: this.companies }, {
				reload: true, inherit: false, notify: false
			});
		}
	}, {
		key: 'save',
		value: function save() {
			var _this = this;

			this.isSaving = true;
			var showOtp = this.visibilitySetting.showOtpEnabled;
			var showPass = this.visibilitySetting.showPasswordEnabled;
			var companyId = this.selectedCompany.id;
			var publicUserAccountsIds = this.userAccountsToShare.map(function (uats) {
				return uats.id;
			});
			this.UsersSharedAccountService.usersCompanySharedAccounts.shareAccountsWithCompany({ companyId: companyId, showOtp: showOtp, showPass: showPass }, publicUserAccountsIds).$promise.then(function () {
				_this.Alert('success', 'users.public-user-accounts.share.success');
				_this.goBack();
			}).catch(function (error) {
				_this.Alert('danger', error.data.message);
			}).finally(function () {
				return _this.isSaving = false;
			});
		}
	}]);

	return Controller;
}();

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = Controller;

var _smartTable = __webpack_require__(2);

var _spLoginPoint = __webpack_require__(133);

var _spLoginType = __webpack_require__(134);

Controller.$inject = ['$scope']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

/** @ngInject */
function Controller($scope) {
    var _this = this;

    this.$onInit = function () {
        _this.loginTypes = _spLoginType.loginTypes;
        _this.loginPoints = _spLoginPoint.loginPoints;
        _this.loginTypeLabel = _spLoginType.loginTypeLabel;
        _this.loginPointLabel = _spLoginPoint.loginPointLabel;

        var logs = _this.logs;
        var format = function format(date) {
            return new Date(date).toString().slice(4, 24);
        };
        logs.forEach(function (log) {
            return log.loggedInOnDisplay = format(log.loggedInOn);
        });
        $scope.st = new _smartTable.SmartTable();

        $scope.isHardTokenUser = _this.account.isSecondaryDeviceSession;
        $scope.datepickerOptions = { maxDate: new Date() };
        $scope.startDate = null;
        $scope.endDate = null;

        $scope.getLoginSourceTooltip = function (log) {
            var loginClient = log.loginClient,
                loginClientOs = log.loginClientOs,
                loginIp = log.loginIp;

            return [loginClient, loginClientOs, loginIp && 'IP: ' + loginIp].filter(function ($) {
                return $;
            }).join(' - ');
        };

        $scope.getLoginToTooltip = function (log) {
            var loginService = log.loginService,
                appType = log.appType,
                username = log.username;

            return [loginService, appType, username].filter(function ($) {
                return $;
            }).join(' - ');
        };

        $scope.filterByDate = function () {
            var endDate = new Date(+$scope.endDate + 24 * 60 * 60 * 1000);
            var afterStart = function afterStart(log) {
                return $scope.startDate ? log.loggedInOn > $scope.startDate : true;
            };
            var beforeEnd = function beforeEnd(log) {
                return $scope.endDate ? log.loggedInOn < endDate : true;
            };
            _this.logs = logs.filter(function (log) {
                return afterStart(log) && beforeEnd(log);
            });
        };

        $scope.open = function ($event, type) {
            $event.preventDefault();
            $event.stopPropagation();
            if (type == 1) {
                $scope.opened = true;
                $scope.opened1 = false;
            } else {
                $scope.opened1 = true;
                $scope.opened = false;
            }
        };
        // show-hide search button on (login-to) input field
        $(function () {
            $(".sp_filterSearchLoginTo").keyup(function () {
                var myLength = $(".sp_filterSearchLoginTo").val().length;
                if (myLength >= 1) {
                    $(".sp_filterSearchLoginToSpan").hide();
                } else {
                    $(".sp_filterSearchLoginToSpan").show();
                }
            });
        });

        $scope.export = {
            template: 'statistics',
            name: 'SAASPASS_Statistics',
            fields: ['username', 'loginType', 'loginPoint', 'loginService', 'sucessfulLogin', 'loginIp', 'loggedInOnDisplay']
        };
    };
}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$uibModal', 'CompanyUserResource'];

    /** @ngInject */
    function Controller($rootScope, $uibModal, CompanyUserResource) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.CompanyUserResource = CompanyUserResource;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
            this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
            this.isUser = this.account.roles.includes('ROLE_USER');
        }
    }, {
        key: 'companyRoleIconClass',
        value: function companyRoleIconClass(role) {
            return {
                'APPLICATION_ADMIN': 'fa fa-list-alt',
                'DEVELOPER_ADMIN': 'fa fa-wrench',
                'ORGANIZATION_ADMIN': 'fa fa-sitemap',
                'READ_ONLY_ADMIN': 'fa fa-eye',
                'SUPER_ADMIN': 'fa fa-building',
                'SAASPASS_ADMIN': 'fa fa-building'
            }[role];
        }
    }, {
        key: 'onUserCompaniesDropdownToggle',
        value: function onUserCompaniesDropdownToggle() {
            this.userCompaniesDropdownSearchKey = '';
        }
    }, {
        key: 'logAdminDevSwitchToCompany',
        value: function logAdminDevSwitchToCompany(companyId) {
            this.$rootScope.logCompanyAccessed$ = this.CompanyUserResource.logCompanyAccessed(companyId);
        }
    }, {
        key: 'showYouAreNotCompanyAdminMessage',
        value: function showYouAreNotCompanyAdminMessage() {
            this.$uibModal.open({ component: 'youAreNotCompanyAdmin' });
        }
    }, {
        key: 'showRecoveryReminder',
        value: function showRecoveryReminder() {
            return !this.account.hasRecovery && !this.account.recoveryTurnedOff && this.account.recoveryReminder && !this.account.roles.includes('ROLE_HARD_TOKEN_USER');
        }
    }]);

    return Controller;
}();

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['ExtentionManaging'];

    /** @ngInject */
    function Controller(ExtentionManaging) {
        _classCallCheck(this, Controller);

        this.ExtentionManaging = ExtentionManaging;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'installExtension',
        value: function installExtension() {
            this.ExtentionManaging.installExtension();
        }
    }, {
        key: 'installExtensionButtonVisible',
        value: function installExtensionButtonVisible() {
            if (this.account.roles.includes('ROLE_HARD_TOKEN_USER')) {
                return false;
            }
            if (this.account.roles.includes('ROLE_SMS_USER')) {
                return false;
            }
            if (_userAgent.ua.isIOS()) {
                return false;
            }
            if (document.getElementById("saaspass-extension-info")) {
                return false;
            }
            if (document.getElementById('extension-is-installed-v2.0.1')) {
                return false;
            }
            if (document.getElementById('extension-is-installed-v2.1.0')) {
                return false;
            }
            return (_userAgent.ua.isFirefox() || _userAgent.ua.isSafari() || _userAgent.ua.isChrome() || _userAgent.ua.isOpera()) && !_userAgent.ua.isIOS();
        }
    }]);

    return Controller;
}();

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['$rootScope', '$state', '$uibModal', 'AccountConfigModal', 'Alert', 'LoginRoleSelectModal', 'SamlService', 'SharedEpmFactory', 'SharedSsoFactory', 'PasswordManagers', '$scope', '$timeout', 'ShowNoteModal'];

    /** @ngInject */
    function Controller($rootScope, $state, $uibModal, AccountConfigModal, Alert, LoginRoleSelectModal, SamlService, SharedEpmFactory, SharedSsoFactory, PasswordManagers, $scope, $timeout, ShowNoteModal) {
        _classCallCheck(this, Controller);

        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountConfigModal = AccountConfigModal;
        this.Alert = Alert;
        this.LoginRoleSelectModal = LoginRoleSelectModal;
        this.SamlService = SamlService;
        this.SharedEpmFactory = SharedEpmFactory;

        this.SharedSsoFactory = SharedSsoFactory;
        this.PasswordManagers = PasswordManagers;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ShowNoteModal = ShowNoteModal;
    }

    _createClass(Controller, [{
        key: 'modalOpen',
        value: function modalOpen() {
            this.$rootScope.loginModal = this.$uibModal.open({ component: 'loginModal' });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
            this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
            this.samlAppLogo = window.env.urls.samlAppLogo;
            this.showExtensionAlert = false;

            this.showIEText = false;
            this.showExtensionAlert = false;
            this.oldExtensionInstalled = !!document.getElementById('extension-is-installed-v2.0.1');
            this.hasPass = false;
            this.showPassword = false;
            this.mustRenewOtp = false;
            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
            var localStorageKey = 'items-per-page:' + this.$state.current.name;
            if (localStorage.getItem(localStorageKey) == null) {
                localStorage.setItem(localStorageKey, 500);
            }
        }
    }, {
        key: 'getSamlLoginUrl',
        value: function getSamlLoginUrl(applicationId, accountId, awsrole) {
            var app = this.applications.find(function (a) {
                return a.applicationId === applicationId;
            });
            var tabWindowId = window.open('about:blank', '_blank');

            tabWindowId.document.write('\n            <img\n                src="' + window.env.urls.samlAppLogo(app.slug) + '"\n                alt="' + app.applicationTypeDisplayName + '"\n                onload="this.style.display = \'block\'"\n                style="display: none; margin: 50px auto 0;"\n            />\n        ');

            tabWindowId.document.write('\n            <p style="text-align: center; color:#40A3DB;">\n                <img\n                    src="' + __webpack_require__(2587) + '"\n                    onload="this.style.display = \'initial\'"\n                    alt="Loading..."\n                    style="display: none; vertical-align: middle; margin-right: 5px"\n                />\n                Loading...\n            </p>\n        ');

            this.SamlService.getSamlLoginUrl.get({ applicationId: applicationId, accountId: accountId, awsrole: awsrole }).$promise.then(function (data) {
                var expires = new Date(Date.now() + 60 * 1000).toUTCString();
                if (data.url.includes("&noCookie=true")) {
                    data.url = data.url.replace("&noCookie=true", '');
                } else {
                    document.cookie = 'sso=' + app.applicationId + '; path=/; expires=' + expires; //set on production: secure = true
                }

                if (_userAgent.ua.isIOS()) {
                    window.location.assign(data.url);
                } else {
                    tabWindowId.location.href = data.url;
                    if (data.url.includes("/#/")) {
                        tabWindowId.location.reload();
                    }
                }
            }, function (error) {
                tabWindowId.document.write('<p style="text-align: center; color:red">Error: ' + error.data + '</p>');
            });
        }
    }, {
        key: 'showEditPasswordModal',
        value: function showEditPasswordModal(_application) {
            var _this2 = this;

            this.$uibModal.open({
                component: 'accountPasswordUpdate',
                resolve: { application: function application() {
                        return _application;
                    } }
            }).result.then(function (password) {
                _application.password = password;
                _this2.Alert('success', 'applications.account_password_updated');
            });
        }
    }, {
        key: 'showAccountConfigModal',
        value: function showAccountConfigModal(applicationId, accountId) {
            this.AccountConfigModal(applicationId, accountId);
        }
    }, {
        key: 'epmLogin',
        value: function epmLogin(sharedAccount) {
            this.SharedEpmFactory.epmsSSO(sharedAccount);

            var isExtensionInstalled = !!document.getElementById("saaspass-extension-info") || !!document.getElementById('extension-is-installed-v2.0.1') || !!document.getElementById('extension-is-installed-v2.1.0');

            if (!isExtensionInstalled) {
                this.showExtensionAlert = true;
                this.showIEText = !(_userAgent.ua.isChrome() || _userAgent.ua.isOpera() || _userAgent.ua.isFirefox() || _userAgent.ua.isSafari());
            }
        }
    }, {
        key: 'showAwsConfigModal',
        value: function showAwsConfigModal(applicationId, accountId) {
            var _this3 = this;

            this.LoginRoleSelectModal(applicationId, accountId).then(function (role) {
                return _this3.getSamlLoginUrl(applicationId, accountId, role);
            });
        }

        /*
         * START - shared user account methods
         */

    }, {
        key: 'isComputerAdministrationAccount',
        value: function isComputerAdministrationAccount(account) {
            return account.publicService.serviceName == 'ComputerLocalAccountAdministration';
        }
    }, {
        key: 'copyCli',
        value: function copyCli(p) {
            this.getPassword(p);
        }
    }, {
        key: 'getPassword',
        value: function getPassword(p) {
            return this.PasswordManagers.getCorporatePassword(p.id).then(function (data) {
                if (data.password) {
                    p.password = data.password;
                    // p.hiddenPass = true;
                    p.hasPass = true;
                } else p.noPassword = true;
            });
        }
    }, {
        key: 'getOtp',
        value: function getOtp(p) {
            var _this4 = this;

            return this.PasswordManagers.getCorporateOtp(p.id).then(function (data) {
                p.otp = data.otp;
            }).then(function () {
                return _this4.$timeout(30000);
            }).then(function () {
                return p.mustRenewOtp = true;
            });
        }
    }, {
        key: 'renewOTP',
        value: function renewOTP(p) {
            var _this5 = this;

            return this.PasswordManagers.getCorporateOtp(p.id).then(function (data) {
                p.otp = data.otp;
            }).then(function () {
                return p.mustRenewOtp = false;
            }).then(function () {
                return _this5.$timeout(30000);
            }).then(function () {
                return p.mustRenewOtp = true;
            });
        }
    }, {
        key: 'showPasswordF',
        value: function showPasswordF(p) {
            if (p.hiddenPass == undefined || p.hiddenPass == null) {
                p.hiddenPass = false;
            }
            p.hiddenPass = p.hiddenPass === false;
            if (this.isComputerAdministrationAccount(p) && p.hiddenPass == false) {
                p.password = null;
                p.hasPass = false;
            }
        }
    }, {
        key: 'showNote',
        value: function showNote(account) {
            this.ShowNoteModal('Note', account.note);
        }
    }, {
        key: 'ssoLogin',
        value: function ssoLogin(sharedAccount) {
            this.SharedSsoFactory.authenticatorsSSO(sharedAccount);

            var isExtensionInstalled = !!document.getElementById("saaspass-extension-info") || !!document.getElementById('extension-is-installed-v2.0.1') || !!document.getElementById('extension-is-installed-v2.1.0');

            if (!isExtensionInstalled) {
                this.showExtensionAlert = true;
                this.showIEText = !(_userAgent.ua.isChrome() || _userAgent.ua.isOpera() || _userAgent.ua.isFirefox() || _userAgent.ua.isSafari());
            }
        }
        /*
         * END - shared user account methods
         */

    }]);

    return Controller;
}();

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Controller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _userAgent = __webpack_require__(13);

var _clipboard = __webpack_require__(14);

var _clipboard2 = _interopRequireDefault(_clipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Controller = exports.Controller = function () {
    Controller.$inject = ['Alert', '$scope', 'ShowNoteModal', '$timeout'];

    /** @ngInject */
    function Controller(Alert, $scope, ShowNoteModal, $timeout) {
        _classCallCheck(this, Controller);

        this.Alert = Alert;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.ShowNoteModal = ShowNoteModal;
    }

    _createClass(Controller, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            var format = function format(date) {
                return new Date(date).toString().slice(4, 24);
            };
            this.sharedNotes.forEach(function (note) {
                return note.createdOnDisplay = format(note.createdOn);
            });

            new _clipboard2.default(".copyCli").on('success', function () {
                _this.$scope.$apply(function () {
                    _this.Alert('success', 'global.data_copied');
                });
            });
        }
    }, {
        key: 'showNote',
        value: function showNote(corporateNote) {
            this.ShowNoteModal('Note', corporateNote.note);
        }
    }]);

    return Controller;
}();

/***/ }),
/* 719 */,
/* 720 */,
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88);
__webpack_require__(142);
module.exports = __webpack_require__(246);


/***/ }),
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./app.js": 0,
	"./components/application-usage-report/application-usage-report.component.js": 1016,
	"./components/application-usage-report/application-usage-report.controller.js": 298,
	"./components/application-usage-report/user-accounts.service.js": 1018,
	"./components/captcha/captcha.component.js": 1019,
	"./components/captcha/captcha.model.js": 18,
	"./components/captcha/sp-grecaptcha/load-grecaptcha-api.js": 300,
	"./components/captcha/sp-grecaptcha/sp-grecaptcha.component.js": 1021,
	"./components/captcha/sp-grecaptcha/sp-grecaptcha.controller.js": 301,
	"./components/captcha/sp-grecaptcha/sp-grecaptcha.scss": 1022,
	"./components/info-sharing-accounts/info-sharing-accounts.component.js": 1023,
	"./components/info-sharing-accounts/info-sharing-accounts.controller.js": 302,
	"./components/info-sharing-center/info-sharing-center.component.js": 1033,
	"./components/info-sharing-center/info-sharing-center.controller.js": 303,
	"./components/language-switcher/language-switcher.component.js": 1043,
	"./components/language-switcher/language-switcher.controller.js": 304,
	"./components/language-switcher/language-switcher.scss": 1055,
	"./components/show-clone-code/show-clone-code.component.js": 1056,
	"./components/show-clone-code/show-clone-code.controller.js": 305,
	"./components/show-clone-code/show-clone-code.modal.js": 1058,
	"./components/show-note/show-note.component.js": 1059,
	"./components/show-note/show-note.controller.js": 306,
	"./components/show-note/show-note.modal.js": 1061,
	"./components/smart-table/export/st-export.component.js": 1062,
	"./components/smart-table/export/st-export.controller.js": 307,
	"./components/smart-table/export/st-export.scss": 1064,
	"./components/smart-table/pagination/sp-pagination.component.js": 1065,
	"./components/smart-table/pagination/sp-pagination.controller.js": 308,
	"./components/smart-table/pagination/sp-pagination.scss": 1067,
	"./components/smart-table/select/st-select-all.component.js": 1068,
	"./components/smart-table/select/st-select-all.controller.js": 309,
	"./components/smart-table/select/st-select-row.directive.js": 1070,
	"./components/smart-table/smart-table.config.js": 1071,
	"./components/smart-table/smart-table.css": 1073,
	"./components/smart-table/smart-table.model.js": 2,
	"./components/sp-account-status/sp-account-status.component.js": 1074,
	"./components/sp-account-status/sp-account-status.controller.js": 310,
	"./components/sp-account-type/sp-account-type.component.js": 1076,
	"./components/sp-account-type/sp-account-type.controller.js": 311,
	"./components/sp-addition-source/sp-addition-source.component.js": 1078,
	"./components/sp-addition-source/sp-addition-source.controller.js": 312,
	"./components/sp-alert/sp-alert.component.js": 1080,
	"./components/sp-alert/sp-alert.controller.js": 313,
	"./components/sp-alert/sp-alert.css": 1082,
	"./components/sp-alert/sp-alert.model.js": 4,
	"./components/sp-back/sp-back.component.js": 1083,
	"./components/sp-back/sp-back.controller.js": 314,
	"./components/sp-back/sp-back.scss": 1085,
	"./components/sp-company-user-label/sp-company-user-label.component.js": 1086,
	"./components/sp-company-user-label/sp-company-user-label.controller.js": 315,
	"./components/sp-confirm/sp-confirm.component.js": 1088,
	"./components/sp-confirm/sp-confirm.modal.js": 1090,
	"./components/sp-directory-label/sp-directory-label.component.js": 1091,
	"./components/sp-directory-label/sp-directory-label.controller.js": 316,
	"./components/sp-editable-image/sp-editable-image.component.js": 1093,
	"./components/sp-editable-image/sp-editable-image.controller.js": 317,
	"./components/sp-editable-label/sp-editable-label.component.js": 1095,
	"./components/sp-editable-label/sp-editable-label.controller.js": 318,
	"./components/sp-editable-password/sp-editable-password.component.js": 1097,
	"./components/sp-editable-password/sp-editable-password.controller.js": 319,
	"./components/sp-editable-password/sp-editable-password.scss": 1099,
	"./components/sp-footer/sp-footer.component.js": 1100,
	"./components/sp-footer/sp-footer.scss": 1102,
	"./components/sp-global-search/functions.js": 320,
	"./components/sp-global-search/searchable-states.js": 321,
	"./components/sp-global-search/sp-global-search.component.js": 1103,
	"./components/sp-global-search/sp-global-search.controller.js": 323,
	"./components/sp-global-search/states.js": 322,
	"./components/sp-group-link/sp-group-link.component.js": 1105,
	"./components/sp-group-name/sp-group-name.component.js": 1107,
	"./components/sp-group-name/sp-group-name.controller.js": 324,
	"./components/sp-group-type/sp-group-type.component.js": 1109,
	"./components/sp-group-type/sp-group-type.controller.js": 325,
	"./components/sp-group-type/sp-group-type.exports.js": 132,
	"./components/sp-header/sp-breadcrumbs/hidden-breadcrumbs.js": 326,
	"./components/sp-header/sp-breadcrumbs/sp-breadcrumbs.component.js": 1111,
	"./components/sp-header/sp-breadcrumbs/sp-breadcrumbs.controller.js": 327,
	"./components/sp-header/sp-breadcrumbs/sp-breadcrumbs.init.js": 1113,
	"./components/sp-header/sp-breadcrumbs/sp-breadcrumbs.scss": 1114,
	"./components/sp-header/sp-header-support-links/sp-header-support-links.component.js": 1115,
	"./components/sp-header/sp-header-support-links/sp-header-support-links.scss": 1117,
	"./components/sp-header/sp-header.component.js": 1118,
	"./components/sp-header/sp-header.scss": 1120,
	"./components/sp-info/sp-info.component.js": 1121,
	"./components/sp-license-info/sp-license-info.component.js": 1123,
	"./components/sp-license-info/sp-license-info.controller.js": 328,
	"./components/sp-login-point/sp-login-point.enum.js": 133,
	"./components/sp-login-type/sp-login-type.enum.js": 134,
	"./components/sp-ok/sp-ok.component.js": 1125,
	"./components/sp-ok/sp-ok.modal.js": 1127,
	"./components/sp-role-type/sp-role-type.component.js": 1128,
	"./components/sp-role-type/sp-role-type.controller.js": 329,
	"./components/sp-role-type/sp-role-type.exports.js": 57,
	"./components/sp-session-recording-type/sp-session-recording-type.enum.js": 330,
	"./components/sp-session-recording-type/sp-session-recording-type.js": 1130,
	"./components/sp-store-links/sp-store-links.component.js": 1131,
	"./components/sp-user-status/sp-user-status.component.js": 1133,
	"./components/sp-user-status/sp-user-status.controller.js": 331,
	"./components/sp-user-status/sp-user-status.exports.js": 332,
	"./components/sp-user-type/sp-user-type.component.js": 1135,
	"./components/sp-user-type/sp-user-type.controller.js": 333,
	"./components/sp-verification-source/sp-verification-source.component.js": 1137,
	"./components/sp-verification-source/sp-verification-source.controller.js": 334,
	"./components/upload-result-table/upload-result-table.component.js": 1139,
	"./config/auth-token-interceptor.config.js": 1141,
	"./config/error-interceptor.config.js": 1142,
	"./config/i18n.config.js": 1143,
	"./config/location.config.js": 1158,
	"./config/resource-interceptor.config.js": 1159,
	"./config/sanitize.config.js": 1160,
	"./config/states-provider.config.js": 1161,
	"./data/constants.js": 192,
	"./data/countries.js": 193,
	"./data/timezones.js": 342,
	"./directives/auto-focus.directive.js": 1162,
	"./directives/char-set.js": 1163,
	"./directives/file-input.directive.js": 1164,
	"./directives/prevent-default.directive.js": 1165,
	"./directives/sp-phone-number-input/sp-phone-number-input.directive.js": 1166,
	"./filters/phone-number.filter.js": 1168,
	"./index.js": 246,
	"./init/angular-loading-bar/angular-loading-bar.js": 1169,
	"./init/angular-loading-bar/bar.css": 1171,
	"./init/root-scope.js": 1172,
	"./init/store.js": 19,
	"./init/ui-router/close-modal-on-exit.js": 1173,
	"./init/ui-router/handle-reload-error.js": 1174,
	"./init/ui-router/scroll-to-top.js": 1175,
	"./init/ui-router/transition.js": 1176,
	"./lib/lazy-load.js": 71,
	"./lib/load-google-visualization-api.js": 299,
	"./lib/local-storage-polyfill.js": 248,
	"./lib/u2f-api.js": 135,
	"./lib/yubico-webauthn.js": 72,
	"./modals/add-update-application/sp-add-application-modal.directive.js": 1177,
	"./modals/confirm-delete/confirm-delete.component.js": 1180,
	"./modals/confirm-delete/confirm-delete.modal.js": 1182,
	"./modals/destructive-operation/destructive-operation.component.js": 1183,
	"./modals/destructive-operation/destructive-operation.controller.js": 343,
	"./modals/destructive-operation/destructive-operation.modal.js": 1185,
	"./modals/destructive-operation/destructive-operation.scss": 1186,
	"./modals/hard-token-edit/hard-token-edit.modal.js": 1187,
	"./modals/shared-email-account/shared-email-account.modal.js": 1189,
	"./models/application-types.js": 58,
	"./models/hard-token.js": 195,
	"./partials/push-login-button-popover/push-login-button-popover.js": 1191,
	"./partials/saaspass-full-experience/saaspass-full-experience.js": 1193,
	"./rest/ApplicationAccountsResource.js": 1195,
	"./rest/AuthenticationAccessPolicyResource.js": 1196,
	"./rest/EpmAccountResource.js": 1197,
	"./rest/FederateSsoResource.js": 1198,
	"./rest/GroupsResource.js": 1199,
	"./rest/HardTokenResource.js": 1200,
	"./rest/PublicServiceResource.js": 1201,
	"./rest/ResellerCompanyResource.js": 1202,
	"./rest/RoleResource.js": 1203,
	"./rest/SimulatorResource.js": 1204,
	"./rest/StatisticsResource.js": 1205,
	"./services/account.service.js": 1206,
	"./services/add-new-application-resource.service.js": 1207,
	"./services/alert.service.js": 1208,
	"./services/authentication-shared.service.js": 1209,
	"./services/barcode-generation.service.js": 1210,
	"./services/company-user-resource.service.js": 1211,
	"./services/company-user.service.js": 1212,
	"./services/google-shared.service.js": 1213,
	"./services/groups-and-users.service.js": 1214,
	"./services/hard-token-management.service.js": 1215,
	"./services/identity-prove.service.js": 1216,
	"./services/registration-code-generation.service.js": 1217,
	"./services/token.service.js": 1218,
	"./services/user-phone-number.service.js": 1219,
	"./states/company/administrators/add/add-new-administrator.component.js": 1220,
	"./states/company/administrators/add/add-new-administrator.controller.js": 344,
	"./states/company/administrators/add/add-new-administrator.state.js": 1222,
	"./states/company/administrators/administrators.component.js": 1223,
	"./states/company/administrators/administrators.dto.js": 104,
	"./states/company/administrators/administrators.state.js": 1225,
	"./states/company/administrators/edit/edit-administrator.component.js": 1226,
	"./states/company/administrators/edit/edit-administrator.controller.js": 345,
	"./states/company/administrators/edit/edit-administrator.state.js": 1228,
	"./states/company/administrators/list/administrators-list.component.js": 1229,
	"./states/company/administrators/list/administrators-list.controller.js": 346,
	"./states/company/administrators/list/administrators-list.state.js": 1231,
	"./states/company/administrators/make-selectables.js": 136,
	"./states/company/app-integration-instructions/local/app-api-credentials/app-api-credentials.component.js": 1232,
	"./states/company/app-integration-instructions/local/app-api-credentials/app-api-credentials.controller.js": 347,
	"./states/company/app-integration-instructions/local/app-integration-instructions-local.component.js": 1234,
	"./states/company/app-integration-instructions/local/app-integration-instructions-local.controller.js": 348,
	"./states/company/app-integration-instructions/local/paths.js": 137,
	"./states/company/app-integration-instructions/local/radius-proxy-download-form/radius-proxy-download-form.component.js": 1265,
	"./states/company/app-integration-instructions/oauth-endpoints/oauth-endpoints.component.js": 1267,
	"./states/company/app-integration-instructions/oauth-endpoints/oauth-endpoints.controller.js": 349,
	"./states/company/app-integration-instructions/oidc-endpoints/oidc-endpoints.component.js": 1269,
	"./states/company/app-integration-instructions/oidc-endpoints/oidc-endpoints.controller.js": 350,
	"./states/company/app-integration-instructions/remote/app-integration-instructions-remote.component.js": 1271,
	"./states/company/app-integration-instructions/saml-metadata/saml-metadata.component.js": 1273,
	"./states/company/app-integration-instructions/saml-metadata/saml-metadata.controller.js": 351,
	"./states/company/company.component.js": 1275,
	"./states/company/company.controller.js": 352,
	"./states/company/company.state.js": 1277,
	"./states/company/computer-protection/computer-protection.component.js": 1278,
	"./states/company/computer-protection/computer-protection.controller.js": 353,
	"./states/company/computer-protection/computer-protection.state.js": 1280,
	"./states/company/corporate-settings/company-profile/company-profile.component.js": 1281,
	"./states/company/corporate-settings/company-profile/company-profile.controller.js": 354,
	"./states/company/corporate-settings/company-profile/company-profile.service.js": 1283,
	"./states/company/corporate-settings/company-profile/company-profile.state.js": 1284,
	"./states/company/corporate-settings/company-profile/edit-ip-address-filter/edit-ip-address-filter.component.js": 1285,
	"./states/company/corporate-settings/company-profile/edit-ip-address-filter/edit-ip-address-filter.controller.js": 355,
	"./states/company/corporate-settings/company-profile/edit-profile/edit-profile.component.js": 1287,
	"./states/company/corporate-settings/company-profile/edit-profile/edit-profile.controller.js": 356,
	"./states/company/corporate-settings/company-profile/generate-credentials/generate-credentials.component.js": 1289,
	"./states/company/corporate-settings/corporate-settings.component.js": 1291,
	"./states/company/corporate-settings/corporate-settings.controller.js": 357,
	"./states/company/corporate-settings/corporate-settings.service.js": 1293,
	"./states/company/corporate-settings/corporate-settings.state.js": 1294,
	"./states/company/custom-application-integration/custom-application-integration.component.js": 1295,
	"./states/company/custom-application-integration/custom-application-integration.controller.js": 358,
	"./states/company/custom-application-integration/custom-application-integration.state.js": 1297,
	"./states/company/directory-integration/add/add-directory.component.js": 1298,
	"./states/company/directory-integration/add/add-directory.controller.js": 359,
	"./states/company/directory-integration/add/add-directory.state.js": 1300,
	"./states/company/directory-integration/directory-integration.component.js": 1301,
	"./states/company/directory-integration/directory-integration.controller.js": 360,
	"./states/company/directory-integration/directory-integration.functions.js": 56,
	"./states/company/directory-integration/directory-integration.state.js": 1303,
	"./states/company/directory-integration/list/directory-list.component.js": 1304,
	"./states/company/directory-integration/list/directory-list.controller.js": 361,
	"./states/company/directory-integration/list/directory-list.state.js": 1306,
	"./states/company/directory-integration/manage/connection-azure/directory-manage-connection-azure.component.js": 1307,
	"./states/company/directory-integration/manage/connection-azure/directory-manage-connection-azure.controller.js": 362,
	"./states/company/directory-integration/manage/connection-azure/directory-manage-connection-azure.state.js": 1309,
	"./states/company/directory-integration/manage/connection/deactivate-agent/deactivate-agent.component.js": 1310,
	"./states/company/directory-integration/manage/connection/deactivate-agent/deactivate-agent.controller.js": 363,
	"./states/company/directory-integration/manage/connection/directory-manage-connection.component.js": 1312,
	"./states/company/directory-integration/manage/connection/directory-manage-connection.controller.js": 364,
	"./states/company/directory-integration/manage/connection/directory-manage-connection.state.js": 1314,
	"./states/company/directory-integration/manage/connection/download-agent/download-agent.component.js": 1315,
	"./states/company/directory-integration/manage/connection/download-agent/download-agent.controller.js": 365,
	"./states/company/directory-integration/manage/connection/on-premises-form/on-premises-form.component.js": 1317,
	"./states/company/directory-integration/manage/connection/on-premises-form/on-premises-form.controller.js": 366,
	"./states/company/directory-integration/manage/connection/ou-imported/ou-imported.component.js": 1319,
	"./states/company/directory-integration/manage/connection/ou-imported/ou-imported.controller.js": 367,
	"./states/company/directory-integration/manage/connection/ou-imported/ou-imported.state.js": 1321,
	"./states/company/directory-integration/manage/directory-manage.component.js": 1322,
	"./states/company/directory-integration/manage/directory-manage.controller.js": 368,
	"./states/company/directory-integration/manage/directory-manage.state.js": 1324,
	"./states/company/directory-integration/manage/domains-azure/directory-manage-domains-azure.component.js": 1325,
	"./states/company/directory-integration/manage/domains-azure/directory-manage-domains-azure.controller.js": 369,
	"./states/company/directory-integration/manage/domains-azure/directory-manage-domains-azure.state.js": 1327,
	"./states/company/directory-integration/manage/domains/add-domain/add-domain.component.js": 1328,
	"./states/company/directory-integration/manage/domains/add-domain/add-domain.controller.js": 370,
	"./states/company/directory-integration/manage/domains/add-domain/add-domain.state.js": 1331,
	"./states/company/directory-integration/manage/domains/configuration/directory-manage-configuration.component.js": 1332,
	"./states/company/directory-integration/manage/domains/configuration/directory-manage-configuration.controller.js": 371,
	"./states/company/directory-integration/manage/domains/delete-domain/delete-domain.component.js": 1334,
	"./states/company/directory-integration/manage/domains/delete-domain/delete-domain.controller.js": 372,
	"./states/company/directory-integration/manage/domains/delete-domain/delete-domain.state.js": 1336,
	"./states/company/directory-integration/manage/domains/directory-manage-domains.component.js": 1337,
	"./states/company/directory-integration/manage/domains/directory-manage-domains.controller.js": 196,
	"./states/company/directory-integration/manage/domains/directory-manage-domains.state.js": 1339,
	"./states/company/directory-integration/manage/domains/domains-configuration.component.js": 1340,
	"./states/company/directory-integration/manage/domains/edit-domain/edit-domain.component.js": 1342,
	"./states/company/directory-integration/manage/domains/edit-domain/edit-domain.controller.js": 373,
	"./states/company/directory-integration/manage/domains/edit-domain/edit-domain.state.js": 1344,
	"./states/company/directory-integration/manage/instructions-azure/directory-integration-instructions-azure.component.js": 1345,
	"./states/company/directory-integration/manage/instructions-azure/directory-integration-instructions-azure.state.js": 1347,
	"./states/company/directory-integration/manage/main/directory-manage-main.component.js": 1348,
	"./states/company/directory-integration/manage/main/directory-manage-main.controller.js": 374,
	"./states/company/directory-integration/manage/main/directory-manage-main.state.js": 1350,
	"./states/company/directory-integration/manage/main/remove/remove-directory.component.js": 1351,
	"./states/company/directory-integration/manage/main/remove/remove-directory.controller.js": 375,
	"./states/company/directory-integration/manage/main/remove/remove-directory.state.js": 1353,
	"./states/company/directory-integration/manage/scim/connection/directory-manage-connection-scim.component.js": 1354,
	"./states/company/directory-integration/manage/scim/connection/directory-manage-connection-scim.controller.js": 376,
	"./states/company/directory-integration/manage/scim/connection/directory-manage-connection-scim.state.js": 1356,
	"./states/company/directory-integration/manage/scim/instructions/directory-integration-instructions-scim.component.js": 1357,
	"./states/company/directory-integration/manage/scim/instructions/directory-integration-instructions-scim.state.js": 1359,
	"./states/company/directory-integration/manage/scim/sync-and-prov/directory-manage-sync-and-prov-scim.component.js": 1360,
	"./states/company/directory-integration/manage/scim/sync-and-prov/directory-manage-sync-and-prov-scim.controller.js": 377,
	"./states/company/directory-integration/manage/scim/sync-and-prov/directory-manage-sync-and-prov-scim.state.js": 1362,
	"./states/company/domains/domains.component.js": 1363,
	"./states/company/domains/domains.controller.js": 378,
	"./states/company/domains/domains.service.js": 1365,
	"./states/company/domains/domains.state.js": 1366,
	"./states/company/google-hangouts-bot/google-hangouts-bot.component.js": 1367,
	"./states/company/google-hangouts-bot/google-hangouts-bot.controller.js": 379,
	"./states/company/google-hangouts-bot/google-hangouts-bot.js": 1369,
	"./states/company/google-hangouts-bot/google-hangouts-bot.state.js": 1370,
	"./states/company/google-marketplace-configuration/google-marketplace-configuration.component.js": 1371,
	"./states/company/google-marketplace-configuration/google-marketplace-configuration.controller.js": 380,
	"./states/company/google-marketplace-configuration/google-marketplace-configuration.state.js": 1373,
	"./states/company/google-marketplace-instructions/google-marketplace-instructions.component.js": 1374,
	"./states/company/google-marketplace-instructions/google-marketplace-instructions.controller.js": 381,
	"./states/company/google-marketplace-instructions/google-marketplace-instructions.state.js": 1376,
	"./states/company/hard-token-management/hard-token-add/fido-add/fido-add.component.js": 1377,
	"./states/company/hard-token-management/hard-token-add/fido-add/fido-add.controller.js": 382,
	"./states/company/hard-token-management/hard-token-add/fido-add/fido-add.state.js": 1379,
	"./states/company/hard-token-management/hard-token-add/hard-token-add.controller.js": 138,
	"./states/company/hard-token-management/hard-token-add/hotp-totp-add/hotp-totp-add.component.js": 1380,
	"./states/company/hard-token-management/hard-token-add/hotp-totp-add/hotp-totp-add.controller.js": 383,
	"./states/company/hard-token-management/hard-token-add/hotp-totp-add/hotp-totp-add.state.js": 1382,
	"./states/company/hard-token-management/hard-token-add/usb-token-add/integrate-usb-token.component.js": 1383,
	"./states/company/hard-token-management/hard-token-add/usb-token-add/usb-add.controller.js": 384,
	"./states/company/hard-token-management/hard-token-add/usb-token-add/usb-add.state.js": 1387,
	"./states/company/hard-token-management/hard-token-edit/hard-token-edit.component.js": 1388,
	"./states/company/hard-token-management/hard-token-edit/hard-token-edit.state.js": 1390,
	"./states/company/hard-token-management/hard-token-edit/registration/hard-token-registration.component.js": 1391,
	"./states/company/hard-token-management/hard-token-edit/registration/hard-token-registration.controller.js": 387,
	"./states/company/hard-token-management/hard-token-edit/registration/hard-token-registration.state.js": 1393,
	"./states/company/hard-token-management/hard-token-edit/settings/hard-token-settings.component.js": 1394,
	"./states/company/hard-token-management/hard-token-edit/settings/hard-token-settings.controller.js": 388,
	"./states/company/hard-token-management/hard-token-edit/settings/hard-token-settings.state.js": 1396,
	"./states/company/hard-token-management/hard-token-edit/synchronize/hard-token-synchronize.component.js": 1397,
	"./states/company/hard-token-management/hard-token-edit/synchronize/hard-token-synchronize.controller.js": 389,
	"./states/company/hard-token-management/hard-token-edit/synchronize/hard-token-synchronize.state.js": 1399,
	"./states/company/hard-token-management/hard-token-integration/hard-token-importer-csv/hard-token-importer-csv.component.js": 1400,
	"./states/company/hard-token-management/hard-token-integration/hard-token-importer-csv/hard-token-importer-csv.controller.js": 390,
	"./states/company/hard-token-management/hard-token-integration/hard-token-importer-csv/hard-token-importer-csv.css": 1402,
	"./states/company/hard-token-management/hard-token-integration/hard-token-importer-table/hard-token-importer-table.component.js": 1403,
	"./states/company/hard-token-management/hard-token-integration/hard-token-importer-table/hard-token-importer-table.controller.js": 392,
	"./states/company/hard-token-management/hard-token-integration/hard-token-importer-table/hard-token-importer-table.css": 1405,
	"./states/company/hard-token-management/hard-token-integration/hard-token-integration-properties.js": 197,
	"./states/company/hard-token-management/hard-token-integration/hard-token-integration-samples.js": 391,
	"./states/company/hard-token-management/hard-token-integration/hard-token-integration.controller.js": 105,
	"./states/company/hard-token-management/hard-token-integration/integrate-fido-u2f/integrate-fido-u2f.component.js": 1406,
	"./states/company/hard-token-management/hard-token-integration/integrate-fido-u2f/integrate-fido-u2f.controller.js": 393,
	"./states/company/hard-token-management/hard-token-integration/integrate-hard-token/integrate-hard-token.component.js": 1408,
	"./states/company/hard-token-management/hard-token-integration/integrate-hard-token/integrate-hard-token.controller.js": 394,
	"./states/company/hard-token-management/hard-token-integration/integrate-usb-token/integrate-usb-token.component.js": 1410,
	"./states/company/hard-token-management/hard-token-integration/integrate-usb-token/integrate-usb-token.controller.js": 395,
	"./states/company/hard-token-management/hard-token-integration/integrate-usb-token/integrate-usb-token.css": 1414,
	"./states/company/hard-token-management/hard-token-integration/max-token-count.js": 106,
	"./states/company/hard-token-management/hard-token-management.component.js": 1415,
	"./states/company/hard-token-management/hard-token-management.controller.js": 398,
	"./states/company/hard-token-management/hard-token-management.scss": 1417,
	"./states/company/hard-token-management/hard-token-management.state.js": 1418,
	"./states/company/hard-token-management/hard-token-sync/hard-token-sync.component.js": 1419,
	"./states/company/hard-token-management/hard-token-sync/hard-token-sync.controller.js": 399,
	"./states/company/idp-authenticators/add/idp-authenticator-add.component.js": 1421,
	"./states/company/idp-authenticators/add/idp-authenticator-add.controller.js": 400,
	"./states/company/idp-authenticators/add/idp-authenticator-add.state.js": 1423,
	"./states/company/idp-authenticators/idp-authenticators.component.js": 1424,
	"./states/company/idp-authenticators/idp-authenticators.controller.js": 401,
	"./states/company/idp-authenticators/idp-authenticators.service.js": 1426,
	"./states/company/idp-authenticators/idp-authenticators.state.js": 1427,
	"./states/company/idp-authenticators/list/idp-authenticators-list.component.js": 1428,
	"./states/company/idp-authenticators/list/idp-authenticators-list.controller.js": 402,
	"./states/company/idp-authenticators/list/idp-authenticators-list.state.js": 1430,
	"./states/company/idp-authenticators/manage/applications/assign/idp-authenticator-applications-assign.component.js": 1431,
	"./states/company/idp-authenticators/manage/applications/assign/idp-authenticator-applications-assign.controller.js": 403,
	"./states/company/idp-authenticators/manage/applications/assign/idp-authenticator-applications-assign.state.js": 1433,
	"./states/company/idp-authenticators/manage/applications/idp-authenticator-applications.component.js": 1434,
	"./states/company/idp-authenticators/manage/applications/idp-authenticator-applications.controller.js": 404,
	"./states/company/idp-authenticators/manage/applications/idp-authenticator-applications.state.js": 1436,
	"./states/company/idp-authenticators/manage/config/idp-authenticator-config.component.js": 1437,
	"./states/company/idp-authenticators/manage/config/idp-authenticator-config.controller.js": 405,
	"./states/company/idp-authenticators/manage/config/idp-authenticator-config.state.js": 1439,
	"./states/company/idp-authenticators/manage/idp-authenticator-manage.component.js": 1440,
	"./states/company/idp-authenticators/manage/idp-authenticator-manage.controller.js": 406,
	"./states/company/idp-authenticators/manage/idp-authenticator-manage.state.js": 1442,
	"./states/company/idp-authenticators/manage/integration/idp-authenticator-integration.component.js": 1443,
	"./states/company/idp-authenticators/manage/integration/idp-authenticator-integration.state.js": 1445,
	"./states/company/idp-authenticators/manage/tabs/idp-authenticator-manage-tabs.component.js": 1446,
	"./states/company/landing-page/landing-page.component.js": 1448,
	"./states/company/landing-page/landing-page.controller.js": 407,
	"./states/company/landing-page/landing-page.state.js": 1450,
	"./states/company/landing-page/news-popup/news-popup.component.js": 1451,
	"./states/company/license-management/activities/license-activities.component.js": 1453,
	"./states/company/license-management/activities/license-activities.controller.js": 408,
	"./states/company/license-management/activities/license-activities.state.js": 1455,
	"./states/company/license-management/current-plan/current-plan.component.js": 1456,
	"./states/company/license-management/current-plan/current-plan.controller.js": 409,
	"./states/company/license-management/current-plan/current-plan.state.js": 1458,
	"./states/company/license-management/current-plan/subscription-info/subscription-info.component.js": 1459,
	"./states/company/license-management/current-plan/subscription-info/subscription-info.controller.js": 410,
	"./states/company/license-management/invoices/license-invoices.component.js": 1461,
	"./states/company/license-management/invoices/license-invoices.controller.js": 411,
	"./states/company/license-management/invoices/license-invoices.state.js": 1463,
	"./states/company/license-management/license-management.component.js": 1464,
	"./states/company/license-management/license-management.controller.js": 412,
	"./states/company/license-management/license-management.service.js": 1466,
	"./states/company/license-management/license-management.state.js": 1467,
	"./states/company/license-management/purchase-license/purchase-license.component.js": 1468,
	"./states/company/license-management/purchase-license/purchase-license.controller.js": 413,
	"./states/company/license-management/purchase-license/purchase-license.state.js": 1470,
	"./states/company/license-management/tier-details/license-tier-details.component.js": 1471,
	"./states/company/license-management/tier-details/license-tier-details.controller.js": 414,
	"./states/company/license-management/tier-details/license-tier-details.modal.js": 1473,
	"./states/company/license-management/upgrade/seat/add-seat.component.js": 1474,
	"./states/company/license-management/upgrade/seat/add-seat.controller.js": 415,
	"./states/company/license-management/upgrade/seat/add-seat.state.js": 1476,
	"./states/company/license-management/upgrade/tier/upgrade-license-tier.component.js": 1477,
	"./states/company/license-management/upgrade/tier/upgrade-license-tier.controller.js": 416,
	"./states/company/license-management/upgrade/tier/upgrade-license-tier.state.js": 1479,
	"./states/company/license-management/upgrade/upgrade-license.component.js": 1480,
	"./states/company/license-management/upgrade/upgrade-license.controller.js": 417,
	"./states/company/license-management/upgrade/upgrade-license.state.js": 1482,
	"./states/company/manage-application/applications-resource.service.js": 1483,
	"./states/company/manage-application/authentication-policies/access-control-policy/access-control-policy.component.js": 1484,
	"./states/company/manage-application/authentication-policies/access-control-policy/access-control-policy.controller.js": 418,
	"./states/company/manage-application/authentication-policies/access-control-policy/access-control-policy.scss": 1486,
	"./states/company/manage-application/authentication-policies/access-control-policy/access-control-policy.state.js": 1487,
	"./states/company/manage-application/authentication-policies/authentication-policies.component.js": 1488,
	"./states/company/manage-application/authentication-policies/authentication-policies.controller.js": 419,
	"./states/company/manage-application/authentication-policies/authentication-policies.scss": 1490,
	"./states/company/manage-application/authentication-policies/authentication-policies.service.js": 1491,
	"./states/company/manage-application/authentication-policies/authentication-policies.state.js": 1492,
	"./states/company/manage-application/authentication-policies/password-policy/password-policy.component.js": 1493,
	"./states/company/manage-application/authentication-policies/password-policy/password-policy.controller.js": 420,
	"./states/company/manage-application/authentication-policies/password-policy/password-policy.scss": 1495,
	"./states/company/manage-application/authentication-policies/password-policy/password-policy.state.js": 1496,
	"./states/company/manage-application/configuration/application-configuration-form.component.js": 1497,
	"./states/company/manage-application/configuration/application-configuration-form.controller.js": 421,
	"./states/company/manage-application/configuration/application-configuration-form.functions.js": 422,
	"./states/company/manage-application/configuration/application-configuration.component.js": 1500,
	"./states/company/manage-application/configuration/application-configuration.controller.js": 423,
	"./states/company/manage-application/configuration/application-configuration.scss": 1502,
	"./states/company/manage-application/configuration/application-configuration.state.js": 1503,
	"./states/company/manage-application/configuration/login-services-form.component.js": 1504,
	"./states/company/manage-application/configuration/login-services-form.controller.js": 427,
	"./states/company/manage-application/configuration/login-services-form.functions.js": 424,
	"./states/company/manage-application/configuration/push-approval-services-form.component.js": 1506,
	"./states/company/manage-application/configuration/push-approval-services-form.controller.js": 428,
	"./states/company/manage-application/configuration/push-approval-services-form.functions.js": 426,
	"./states/company/manage-application/configuration/registration-services-form.component.js": 1508,
	"./states/company/manage-application/configuration/registration-services-form.controller.js": 429,
	"./states/company/manage-application/configuration/registration-services-form.functions.js": 425,
	"./states/company/manage-application/dropbox-provisioning/confirm-remove-mapping/confirm-remove-mapping.component.js": 1510,
	"./states/company/manage-application/dropbox-provisioning/dropbox-provisioning-mapping/dropbox-provisioning-mapping.component.js": 1512,
	"./states/company/manage-application/dropbox-provisioning/dropbox-provisioning-mapping/dropbox-provisioning-mapping.controller.js": 430,
	"./states/company/manage-application/dropbox-provisioning/dropbox-provisioning-settings/dropbox-provisioning-settings.component.js": 1514,
	"./states/company/manage-application/dropbox-provisioning/dropbox-provisioning-settings/dropbox-provisioning-settings.controller.js": 431,
	"./states/company/manage-application/dropbox-provisioning/dropbox-provisioning.component.js": 1516,
	"./states/company/manage-application/dropbox-provisioning/dropbox-provisioning.controller.js": 432,
	"./states/company/manage-application/dropbox-provisioning/dropbox-provisioning.service.js": 1518,
	"./states/company/manage-application/dropbox-provisioning/dropbox-provisioning.state.js": 1519,
	"./states/company/manage-application/dropbox-provisioning/dropbox-sync-mapping/dropbox-sync-mapping.component.js": 1520,
	"./states/company/manage-application/dropbox-provisioning/dropbox-sync-mapping/dropbox-sync-mapping.controller.js": 433,
	"./states/company/manage-application/dropbox-provisioning/dropbox-sync-settings/dropbox-sync-settings.component.js": 1522,
	"./states/company/manage-application/dropbox-provisioning/dropbox-sync-settings/dropbox-sync-settings.controller.js": 434,
	"./states/company/manage-application/dropbox-provisioning/fixed-header-scroll.directive.js": 1524,
	"./states/company/manage-application/idp-authenticators/app-idp-authenticators.component.js": 1525,
	"./states/company/manage-application/idp-authenticators/app-idp-authenticators.controller.js": 435,
	"./states/company/manage-application/idp-authenticators/app-idp-authenticators.state.js": 1527,
	"./states/company/manage-application/integration-developers/app-key-password/app-key-password.component.js": 1528,
	"./states/company/manage-application/integration-developers/app-key-password/app-key-password.controller.js": 436,
	"./states/company/manage-application/integration-developers/app-key-password/app-key-password.state.js": 1530,
	"./states/company/manage-application/integration-developers/app-key-password/regenerate/regenerate-app-password.component.js": 1531,
	"./states/company/manage-application/integration-developers/app-key-password/regenerate/regenerate-app-password.controller.js": 437,
	"./states/company/manage-application/integration-developers/company-application-overview.service.js": 1533,
	"./states/company/manage-application/integration-developers/configure-sso/auto-configure-sso/auto-configure-sso.component.js": 1534,
	"./states/company/manage-application/integration-developers/configure-sso/auto-configure-sso/auto-configure-sso.controller.js": 438,
	"./states/company/manage-application/integration-developers/configure-sso/configure-sso.component.js": 1536,
	"./states/company/manage-application/integration-developers/configure-sso/configure-sso.controller.js": 439,
	"./states/company/manage-application/integration-developers/configure-sso/configure-sso.state.js": 1546,
	"./states/company/manage-application/integration-developers/help/help.component.js": 1547,
	"./states/company/manage-application/integration-developers/help/help.controller.js": 440,
	"./states/company/manage-application/integration-developers/help/help.state.js": 1550,
	"./states/company/manage-application/integration-developers/integration-developers.component.js": 1551,
	"./states/company/manage-application/integration-developers/integration-developers.controller.js": 446,
	"./states/company/manage-application/integration-developers/integration-developers.state.js": 1554,
	"./states/company/manage-application/integration-developers/integration-office-365/integration-office-365.component.js": 1555,
	"./states/company/manage-application/integration-developers/integration-office-365/integration-office-365.controller.js": 447,
	"./states/company/manage-application/integration-developers/integration-office-365/integration-office-365.state.js": 1557,
	"./states/company/manage-application/integration-developers/integration/application-integration.component.js": 1558,
	"./states/company/manage-application/integration-developers/integration/application-integration.controller.js": 448,
	"./states/company/manage-application/integration-developers/integration/application-integration.state.js": 1560,
	"./states/company/manage-application/integration-developers/integration/manual-integration.state.js": 1561,
	"./states/company/manage-application/integration-developers/non-domain-protection-key/non-domain-protection-key.component.js": 1562,
	"./states/company/manage-application/integration-developers/non-domain-protection-key/non-domain-protection-key.controller.js": 449,
	"./states/company/manage-application/integration-developers/non-domain-protection-key/non-domain-protection-key.state.js": 1564,
	"./states/company/manage-application/integration-developers/remove-configuration/remove-configuration.component.js": 1565,
	"./states/company/manage-application/integration-developers/remove-configuration/remove-configuration.state.js": 1567,
	"./states/company/manage-application/integration-developers/scim-prov-instructions/scim-prov-instructions.component.js": 1568,
	"./states/company/manage-application/integration-developers/scim-prov-instructions/scim-prov-instructions.state.js": 1570,
	"./states/company/manage-application/integration-developers/simulators/simulators.component.js": 1571,
	"./states/company/manage-application/integration-developers/simulators/simulators.controller.js": 450,
	"./states/company/manage-application/integration-developers/simulators/simulators.state.js": 1573,
	"./states/company/manage-application/integration-developers/widgets/widgets.component.js": 1574,
	"./states/company/manage-application/integration-developers/widgets/widgets.controller.js": 451,
	"./states/company/manage-application/integration-developers/widgets/widgets.state.js": 1576,
	"./states/company/manage-application/manage-application.component.js": 1577,
	"./states/company/manage-application/manage-application.controller.js": 452,
	"./states/company/manage-application/manage-application.state.js": 1579,
	"./states/company/manage-application/mobile-app-support/mobile-app-support-form.component.js": 1580,
	"./states/company/manage-application/mobile-app-support/mobile-app-support-form.controller.js": 453,
	"./states/company/manage-application/mobile-app-support/mobile-app-support.component.js": 1582,
	"./states/company/manage-application/mobile-app-support/mobile-app-support.controller.js": 454,
	"./states/company/manage-application/mobile-app-support/mobile-app-support.functions.js": 198,
	"./states/company/manage-application/mobile-app-support/mobile-app-support.state.js": 1584,
	"./states/company/manage-application/o365-provisioning/o365-provisioning.component.js": 1585,
	"./states/company/manage-application/o365-provisioning/o365-provisioning.controller.js": 455,
	"./states/company/manage-application/o365-provisioning/o365-provisioning.service.js": 1587,
	"./states/company/manage-application/o365-provisioning/o365-provisioning.state.js": 1588,
	"./states/company/manage-application/remote-app-access/add/add-remote-app.component.js": 1589,
	"./states/company/manage-application/remote-app-access/add/add-remote-app.controller.js": 456,
	"./states/company/manage-application/remote-app-access/add/add-remote-app.state.js": 1591,
	"./states/company/manage-application/remote-app-access/edit/edit-remote-app.component.js": 1592,
	"./states/company/manage-application/remote-app-access/edit/edit-remote-app.controller.js": 457,
	"./states/company/manage-application/remote-app-access/edit/edit-remote-app.state.js": 1594,
	"./states/company/manage-application/remote-app-access/remote-app-access.component.js": 1595,
	"./states/company/manage-application/remote-app-access/remote-app-access.controller.js": 458,
	"./states/company/manage-application/remote-app-access/remote-app-access.service.js": 1597,
	"./states/company/manage-application/remote-app-access/remote-app-access.state.js": 1598,
	"./states/company/manage-application/remote-app-access/remove/remove-remote-app.component.js": 1599,
	"./states/company/manage-application/remote-app-access/remove/remove-remote-app.controller.js": 459,
	"./states/company/manage-application/remove/remove-application.component.js": 1601,
	"./states/company/manage-application/remove/remove-application.controller.js": 460,
	"./states/company/manage-application/remove/remove-application.state.js": 1603,
	"./states/company/manage-application/roles/add/add-role.component.js": 1604,
	"./states/company/manage-application/roles/add/add-role.controller.js": 461,
	"./states/company/manage-application/roles/add/add-role.state.js": 1606,
	"./states/company/manage-application/roles/edit/edit-role.component.js": 1607,
	"./states/company/manage-application/roles/edit/edit-role.controller.js": 462,
	"./states/company/manage-application/roles/edit/edit-role.state.js": 1609,
	"./states/company/manage-application/roles/remove/remove-role.component.js": 1610,
	"./states/company/manage-application/roles/remove/remove-role.controller.js": 463,
	"./states/company/manage-application/roles/role-management-resource.service.js": 1612,
	"./states/company/manage-application/roles/roles.component.js": 1613,
	"./states/company/manage-application/roles/roles.controller.js": 464,
	"./states/company/manage-application/roles/roles.exports.js": 199,
	"./states/company/manage-application/roles/roles.state.js": 1615,
	"./states/company/manage-application/scim-provisioning/scim-provisioning.component.js": 1616,
	"./states/company/manage-application/scim-provisioning/scim-provisioning.controller.js": 465,
	"./states/company/manage-application/scim-provisioning/scim-provisioning.service.js": 1618,
	"./states/company/manage-application/scim-provisioning/scim-provisioning.state.js": 1619,
	"./states/company/manage-application/session-recording/session-recording-form.component.js": 1620,
	"./states/company/manage-application/session-recording/session-recording-form.controller.js": 466,
	"./states/company/manage-application/session-recording/session-recording.component.js": 1622,
	"./states/company/manage-application/session-recording/session-recording.controller.js": 467,
	"./states/company/manage-application/session-recording/session-recording.scss": 1624,
	"./states/company/manage-application/session-recording/session-recording.state.js": 1625,
	"./states/company/manage-application/usage-data/usage-data.component.js": 1626,
	"./states/company/manage-application/usage-data/usage-data.state.js": 1628,
	"./states/company/manage-application/users/application-users.component.js": 1629,
	"./states/company/manage-application/users/application-users.controller.js": 468,
	"./states/company/manage-application/users/application-users.state.js": 1631,
	"./states/company/manage-application/users/assign-groups/assign-groups.component.js": 1632,
	"./states/company/manage-application/users/assign-groups/assign-groups.controller.js": 469,
	"./states/company/manage-application/users/assign-groups/assign-groups.state.js": 1634,
	"./states/company/manage-application/users/assigned-groups/assigned-groups.component.js": 1635,
	"./states/company/manage-application/users/assigned-groups/assigned-groups.controller.js": 470,
	"./states/company/manage-application/users/customize-saml-assertion/customize-saml-assertion.component.js": 1637,
	"./states/company/manage-application/users/customize-saml-assertion/customize-saml-assertion.controller.js": 471,
	"./states/company/manage-application/users/customize-user-authentication/customize-user-authentication.component.js": 1639,
	"./states/company/manage-application/users/customize-user-authentication/customize-user-authentication.controller.js": 472,
	"./states/company/manage-application/users/epm-credentials/epm-credentials.component.js": 1641,
	"./states/company/manage-application/users/epm-credentials/epm-credentials.controller.js": 473,
	"./states/company/manage-application/users/epm-credentials/epm-credentials.state.js": 1643,
	"./states/company/manage-application/users/generate-login-code/generate-login-code.component.js": 1644,
	"./states/company/manage-application/users/generate-login-code/generate-login-code.controller.js": 474,
	"./states/company/manage-application/users/generate-login-code/generate-login-code.state.js": 1646,
	"./states/company/manage-application/users/manage-passwords/manage-passwords.component.js": 1647,
	"./states/company/manage-application/users/manage-passwords/manage-passwords.controller.js": 475,
	"./states/company/manage-application/users/manage-passwords/manage-passwords.state.js": 1649,
	"./states/company/manage-application/users/unassign-group/unassign-group.component.js": 1650,
	"./states/company/manage-application/users/unassign-group/unassign-group.controller.js": 476,
	"./states/company/manage-applications/added-applications-list/added-applications-list.component.js": 1652,
	"./states/company/manage-applications/added-applications-list/added-applications-list.controller.js": 477,
	"./states/company/manage-applications/added-applications-list/added-applications-list.state.js": 1654,
	"./states/company/manage-applications/application-info/application-info.component.js": 1655,
	"./states/company/manage-applications/application-info/application-info.controller.js": 478,
	"./states/company/manage-applications/application-info/application-info.state.js": 1657,
	"./states/company/manage-applications/integration-you-are-done/integration-you-are-done.component.js": 1658,
	"./states/company/manage-applications/integration-you-are-done/integration-you-are-done.scss": 1660,
	"./states/company/manage-applications/ports-used-by-saaspass-products/ports-used-by-saaspass-products.component.js": 1661,
	"./states/company/manage-applications/supported-application-types/supported-application-types.component.js": 1663,
	"./states/company/manage-applications/supported-application-types/supported-application-types.controller.js": 479,
	"./states/company/manage-applications/supported-application-types/supported-application-types.state.js": 1665,
	"./states/company/manage-applications/supported-epm-types/add/add-epm.component.js": 1666,
	"./states/company/manage-applications/supported-epm-types/add/add-epm.controller.js": 480,
	"./states/company/manage-applications/supported-epm-types/add/add-epm.state.js": 1668,
	"./states/company/manage-applications/supported-epm-types/list/supported-epm-types.component.js": 1669,
	"./states/company/manage-applications/supported-epm-types/list/supported-epm-types.controller.js": 481,
	"./states/company/manage-applications/supported-epm-types/list/supported-epm-types.scss": 1684,
	"./states/company/manage-applications/supported-epm-types/list/supported-epm-types.state.js": 1685,
	"./states/company/policies/authentication-access-policies/AuthenticationAccessPolicyDTO.js": 482,
	"./states/company/policies/authentication-access-policies/authentication-access-policies.component.js": 1686,
	"./states/company/policies/authentication-access-policies/authentication-access-policies.controller.js": 483,
	"./states/company/policies/authentication-access-policies/authentication-access-policies.state.js": 1688,
	"./states/company/policies/authentication-access-policies/edit-policy/edit-policy.component.js": 1689,
	"./states/company/policies/authentication-access-policies/edit-policy/edit-policy.controller.js": 484,
	"./states/company/policies/authentication-access-policies/edit-policy/edit-policy.scss": 1691,
	"./states/company/policies/authentication-access-policies/edit-policy/edit-policy.state.js": 1692,
	"./states/company/policies/authentication-access-policies/manage/manage-policy-apps.component.js": 1693,
	"./states/company/policies/authentication-access-policies/manage/manage-policy-apps.controller.js": 485,
	"./states/company/policies/authentication-access-policies/manage/manage-policy-apps.state.js": 1695,
	"./states/company/policies/password-authentication-policy/assign-application/assign-application.component.js": 1696,
	"./states/company/policies/password-authentication-policy/assign-application/assign-application.controller.js": 486,
	"./states/company/policies/password-authentication-policy/assign-application/assign-application.state.js": 1698,
	"./states/company/policies/password-authentication-policy/edit-policy/edit-policy.component.js": 1699,
	"./states/company/policies/password-authentication-policy/edit-policy/edit-policy.controller.js": 487,
	"./states/company/policies/password-authentication-policy/edit-policy/edit-policy.state.js": 1701,
	"./states/company/policies/password-authentication-policy/password-authentication-policy.component.js": 1702,
	"./states/company/policies/password-authentication-policy/password-authentication-policy.controller.js": 488,
	"./states/company/policies/password-authentication-policy/password-authentication-policy.service.js": 1704,
	"./states/company/policies/password-authentication-policy/password-authentication-policy.state.js": 1705,
	"./states/company/policies/policies.component.js": 1706,
	"./states/company/policies/policies.controller.js": 489,
	"./states/company/policies/policies.services.js": 1708,
	"./states/company/policies/policies.state.js": 1709,
	"./states/company/recovery-center/recovery.component.js": 1710,
	"./states/company/recovery-center/recovery.controller.js": 490,
	"./states/company/recovery-center/recovery.service.js": 1711,
	"./states/company/recovery-center/recovery.state.js": 1712,
	"./states/company/reports/administrator-audit/administrator-audit.component.js": 1714,
	"./states/company/reports/administrator-audit/administrator-audit.controller.js": 491,
	"./states/company/reports/administrator-audit/administrator-audit.scss": 1716,
	"./states/company/reports/administrator-audit/administrator-audit.state.js": 1717,
	"./states/company/reports/application-usage-report/application-usage-report.component.js": 1718,
	"./states/company/reports/application-usage-report/application-usage-report.service.js": 1720,
	"./states/company/reports/application-usage-report/application-usage-report.state.js": 1721,
	"./states/company/reports/company-login-report/company-login-report.component.js": 1722,
	"./states/company/reports/company-login-report/company-login-report.controller.js": 492,
	"./states/company/reports/company-login-report/company-login-report.service.js": 1724,
	"./states/company/reports/company-login-report/company-login-report.state.js": 1725,
	"./states/company/reports/computers-report/computers-report.component.js": 1726,
	"./states/company/reports/computers-report/computers-report.controller.js": 493,
	"./states/company/reports/computers-report/computers-report.service.js": 1728,
	"./states/company/reports/computers-report/computers-report.state.js": 1729,
	"./states/company/reports/header.component.js": 1730,
	"./states/company/reports/session-recording-report/session-recording-report.component.js": 1732,
	"./states/company/reports/session-recording-report/session-recording-report.controller.js": 494,
	"./states/company/reports/session-recording-report/session-recording-report.service.js": 1734,
	"./states/company/reports/session-recording-report/session-recording-report.state.js": 1735,
	"./states/company/reports/sharing-center-reports/sharing-center-deleted-report/sharing-center-deleted-report.component.js": 1736,
	"./states/company/reports/sharing-center-reports/sharing-center-deleted-report/sharing-center-deleted-report.controller.js": 495,
	"./states/company/reports/sharing-center-reports/sharing-center-deleted-report/sharing-center-deleted-report.state.js": 1738,
	"./states/company/reports/sharing-center-reports/sharing-center-reports.component.js": 1739,
	"./states/company/reports/sharing-center-reports/sharing-center-reports.controller.js": 496,
	"./states/company/reports/sharing-center-reports/sharing-center-reports.state.js": 1741,
	"./states/company/reseller/add-new-company/add-new-company.component.js": 1742,
	"./states/company/reseller/add-new-company/add-new-company.controller.js": 497,
	"./states/company/reseller/add-new-company/add-new-company.state.js": 1744,
	"./states/company/reseller/list/reseller-list.component.js": 1745,
	"./states/company/reseller/list/reseller-list.controller.js": 498,
	"./states/company/reseller/list/reseller-list.state.js": 1747,
	"./states/company/reseller/new-company/new-company.component.js": 1748,
	"./states/company/reseller/new-company/new-company.controller.js": 499,
	"./states/company/reseller/new-company/new-company.state.js": 1750,
	"./states/company/reseller/reseller-company-detail/reseller-company-detail.component.js": 1751,
	"./states/company/reseller/reseller-company-detail/reseller-company-detail.controller.js": 500,
	"./states/company/reseller/reseller-company-detail/reseller-company-detail.state.js": 1753,
	"./states/company/reseller/reseller.component.js": 1754,
	"./states/company/reseller/reseller.controller.js": 501,
	"./states/company/reseller/reseller.state.js": 1756,
	"./states/company/resources/resources.component.js": 1757,
	"./states/company/resources/resources.controller.js": 201,
	"./states/company/resources/resources.service.js": 1759,
	"./states/company/resources/resources.state.js": 1760,
	"./states/company/roles-help/roles-help.component.js": 1761,
	"./states/company/roles-help/roles-help.controller.js": 502,
	"./states/company/roles-help/roles-help.state.js": 1763,
	"./states/company/saaspass-connect/add-saaspass-connect/add-saaspass-connect.component.js": 1764,
	"./states/company/saaspass-connect/add-saaspass-connect/add-saaspass-connect.controller.js": 503,
	"./states/company/saaspass-connect/confirm-delete-sasspass-connect/confirm-delete-sasspass-connect.component.js": 1766,
	"./states/company/saaspass-connect/manage/access-control-policy/oidc-access-control-policy.component.js": 1768,
	"./states/company/saaspass-connect/manage/access-control-policy/oidc-access-control-policy.controller.js": 504,
	"./states/company/saaspass-connect/manage/access-control-policy/oidc-access-control-policy.scss": 1770,
	"./states/company/saaspass-connect/manage/access-control-policy/oidc-access-control-policy.state.js": 1771,
	"./states/company/saaspass-connect/manage/developers/developers.component.js": 1772,
	"./states/company/saaspass-connect/manage/developers/developers.controller.js": 505,
	"./states/company/saaspass-connect/manage/developers/developers.service.js": 1780,
	"./states/company/saaspass-connect/manage/developers/developers.state.js": 1781,
	"./states/company/saaspass-connect/manage/manage.component.js": 1782,
	"./states/company/saaspass-connect/manage/manage.state.js": 1784,
	"./states/company/saaspass-connect/manage/overview/overview.component.js": 1785,
	"./states/company/saaspass-connect/manage/overview/overview.controller.js": 507,
	"./states/company/saaspass-connect/manage/overview/overview.service.js": 1789,
	"./states/company/saaspass-connect/manage/overview/overview.state.js": 1790,
	"./states/company/saaspass-connect/manage/overview/photo-upload.service.js": 1791,
	"./states/company/saaspass-connect/saaspass-connect.component.js": 1792,
	"./states/company/saaspass-connect/saaspass-connect.controller.js": 508,
	"./states/company/saaspass-connect/saaspass-connect.service.js": 1794,
	"./states/company/saaspass-connect/saaspass-connect.state.js": 1795,
	"./states/company/saaspass-vpn/configuration/configuration.component.js": 1796,
	"./states/company/saaspass-vpn/configuration/configuration.controller.js": 509,
	"./states/company/saaspass-vpn/configuration/configuration.service.js": 1798,
	"./states/company/saaspass-vpn/configuration/configuration.state.js": 1799,
	"./states/company/saaspass-vpn/integration/integration.component.js": 1800,
	"./states/company/saaspass-vpn/integration/integration.state.js": 1802,
	"./states/company/saaspass-vpn/saaspass-vpn.component.js": 1803,
	"./states/company/saaspass-vpn/saaspass-vpn.state.js": 1805,
	"./states/company/sharing-center/choose-folder/choose-shared-folder.component.js": 1806,
	"./states/company/sharing-center/choose-folder/choose-shared-folder.controller.js": 510,
	"./states/company/sharing-center/choose-folder/choose-shared-folder.modal.js": 1808,
	"./states/company/sharing-center/manage-bulk/manage-bulk.component.js": 1809,
	"./states/company/sharing-center/manage-bulk/manage-bulk.controller.js": 511,
	"./states/company/sharing-center/manage-bulk/manage-bulk.state.js": 1811,
	"./states/company/sharing-center/public-services.service.js": 1812,
	"./states/company/sharing-center/security-scan/security-scan.component.js": 1813,
	"./states/company/sharing-center/security-scan/security-scan.controller.js": 512,
	"./states/company/sharing-center/security-scan/security-scan.state.js": 1815,
	"./states/company/sharing-center/share/computer-administration-accounts-share.modal.js": 1816,
	"./states/company/sharing-center/share/share.component.js": 1818,
	"./states/company/sharing-center/share/share.controller.js": 513,
	"./states/company/sharing-center/share/share.state.js": 1820,
	"./states/company/sharing-center/shared-accounts/share-an-additinal-email-account/share-an-additional-email-account.modal.js": 1821,
	"./states/company/sharing-center/shared-accounts/shared-accounts.component.js": 1823,
	"./states/company/sharing-center/shared-accounts/shared-accounts.controller.js": 514,
	"./states/company/sharing-center/shared-accounts/shared-accounts.state.js": 1825,
	"./states/company/sharing-center/shared-authenticators/add/add-shared-authenticator.component.js": 1826,
	"./states/company/sharing-center/shared-authenticators/add/add-shared-authenticator.controller.js": 515,
	"./states/company/sharing-center/shared-authenticators/add/add-shared-authenticator.modal.js": 1829,
	"./states/company/sharing-center/shared-authenticators/add/add-shared-authenticator.state.js": 1830,
	"./states/company/sharing-center/shared-authenticators/delete/delete-accounts.component.js": 1831,
	"./states/company/sharing-center/shared-authenticators/delete/delete-accounts.controller.js": 517,
	"./states/company/sharing-center/shared-authenticators/delete/delete-accounts.state.js": 1833,
	"./states/company/sharing-center/shared-authenticators/import/import-shared-authenticator.component.js": 1834,
	"./states/company/sharing-center/shared-authenticators/import/import-shared-authenticator.controller.js": 518,
	"./states/company/sharing-center/shared-authenticators/import/import-shared-authenticator.modal.js": 1836,
	"./states/company/sharing-center/shared-authenticators/manage/confirm-convert/confirm-convert.component.js": 1837,
	"./states/company/sharing-center/shared-authenticators/manage/confirm-convert/confirm-convert.modal.js": 1839,
	"./states/company/sharing-center/shared-authenticators/manage/getUrlParam.js": 202,
	"./states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.component.js": 1840,
	"./states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.controller.js": 519,
	"./states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.modal.js": 1842,
	"./states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.state.js": 1843,
	"./states/company/sharing-center/shared-authenticators/shared-authenticators.component.js": 1844,
	"./states/company/sharing-center/shared-authenticators/shared-authenticators.controller.js": 520,
	"./states/company/sharing-center/shared-authenticators/shared-authenticators.state.js": 1846,
	"./states/company/sharing-center/shared-company-account/shared-company-account.component.js": 1847,
	"./states/company/sharing-center/shared-company-account/shared-company-account.controller.js": 521,
	"./states/company/sharing-center/shared-company-account/shared-company-account.scss": 1849,
	"./states/company/sharing-center/shared-company-account/shared-company-account.state.js": 1850,
	"./states/company/sharing-center/shared-folders/create/create-shared-folder.component..js": 1851,
	"./states/company/sharing-center/shared-folders/create/create-shared-folder.controller.js": 522,
	"./states/company/sharing-center/shared-folders/create/create-shared-folder.state.js": 1853,
	"./states/company/sharing-center/shared-folders/manage/add-csa/shared-folder-add-csa.component.js": 1854,
	"./states/company/sharing-center/shared-folders/manage/add-csa/shared-folder-add-csa.controller.js": 523,
	"./states/company/sharing-center/shared-folders/manage/add-csa/shared-folder-add-csa.modal.js": 1856,
	"./states/company/sharing-center/shared-folders/manage/add-note/shared-folder-add-note.component.js": 1857,
	"./states/company/sharing-center/shared-folders/manage/add-note/shared-folder-add-note.controller.js": 524,
	"./states/company/sharing-center/shared-folders/manage/add-note/shared-folder-add-note.modal.js": 1859,
	"./states/company/sharing-center/shared-folders/manage/edit/edit-shared-folder.component..js": 1860,
	"./states/company/sharing-center/shared-folders/manage/edit/edit-shared-folder.controller.js": 525,
	"./states/company/sharing-center/shared-folders/manage/edit/edit-shared-folder.state.js": 1862,
	"./states/company/sharing-center/shared-folders/manage/manage-shared-folder.component..js": 1863,
	"./states/company/sharing-center/shared-folders/manage/manage-shared-folder.controller.js": 526,
	"./states/company/sharing-center/shared-folders/manage/manage-shared-folder.state.js": 1865,
	"./states/company/sharing-center/shared-folders/manage/share/share-shared-folder.component.js": 1866,
	"./states/company/sharing-center/shared-folders/manage/share/share-shared-folder.controller.js": 527,
	"./states/company/sharing-center/shared-folders/manage/share/share-shared-folder.state.js": 1868,
	"./states/company/sharing-center/shared-folders/shared-folders-resource.service.js": 1869,
	"./states/company/sharing-center/shared-folders/shared-folders.component.js": 1870,
	"./states/company/sharing-center/shared-folders/shared-folders.controller.js": 528,
	"./states/company/sharing-center/shared-folders/shared-folders.state.js": 1872,
	"./states/company/sharing-center/shared-inner-menu/shared-inner-menu.component.js": 1873,
	"./states/company/sharing-center/shared-inner-menu/shared-inner-menu.controller.js": 529,
	"./states/company/sharing-center/shared-inner-menu/shared-inner-menu.state.js": 1875,
	"./states/company/sharing-center/shared-notes/add/add-shared-note.component.js": 1876,
	"./states/company/sharing-center/shared-notes/add/add-shared-note.controller.js": 530,
	"./states/company/sharing-center/shared-notes/add/add-shared-note.modal.js": 1878,
	"./states/company/sharing-center/shared-notes/add/add-shared-note.state.js": 1879,
	"./states/company/sharing-center/shared-notes/manage/manage-shared-note.component.js": 1880,
	"./states/company/sharing-center/shared-notes/manage/manage-shared-note.controller.js": 531,
	"./states/company/sharing-center/shared-notes/manage/manage-shared-note.modal.js": 1882,
	"./states/company/sharing-center/shared-notes/manage/manage-shared-note.state.js": 1883,
	"./states/company/sharing-center/shared-notes/shared-notes.component.js": 1884,
	"./states/company/sharing-center/shared-notes/shared-notes.controller.js": 532,
	"./states/company/sharing-center/shared-notes/shared-notes.state.js": 1886,
	"./states/company/sharing-center/shared-passwords/add/add-shared-password.component.js": 1887,
	"./states/company/sharing-center/shared-passwords/add/add-shared-password.controller.js": 533,
	"./states/company/sharing-center/shared-passwords/add/add-shared-password.modal.js": 1889,
	"./states/company/sharing-center/shared-passwords/add/add-shared-password.state.js": 1890,
	"./states/company/sharing-center/shared-passwords/delete/delete-accounts.component.js": 1891,
	"./states/company/sharing-center/shared-passwords/delete/delete-accounts.controller.js": 534,
	"./states/company/sharing-center/shared-passwords/delete/delete-accounts.state.js": 1893,
	"./states/company/sharing-center/shared-passwords/import-csv/import-completed/import-completed.component.js": 1894,
	"./states/company/sharing-center/shared-passwords/import-csv/import-completed/import-completed.controller.js": 535,
	"./states/company/sharing-center/shared-passwords/import-csv/import-completed/import-completed.state.js": 1896,
	"./states/company/sharing-center/shared-passwords/import-csv/import-csv.component.js": 1897,
	"./states/company/sharing-center/shared-passwords/import-csv/import-csv.controller.js": 536,
	"./states/company/sharing-center/shared-passwords/import-csv/import-csv.state.js": 1899,
	"./states/company/sharing-center/shared-passwords/import/import-shared-password.component.js": 1900,
	"./states/company/sharing-center/shared-passwords/import/import-shared-password.controller.js": 537,
	"./states/company/sharing-center/shared-passwords/import/import-shared-password.modal.js": 1902,
	"./states/company/sharing-center/shared-passwords/manage/manage-shared-password.component.js": 1903,
	"./states/company/sharing-center/shared-passwords/manage/manage-shared-password.controller.js": 538,
	"./states/company/sharing-center/shared-passwords/manage/manage-shared-password.modal.js": 1905,
	"./states/company/sharing-center/shared-passwords/manage/manage-shared-password.state.js": 1906,
	"./states/company/sharing-center/shared-passwords/shared-passwords.component.js": 1907,
	"./states/company/sharing-center/shared-passwords/shared-passwords.controller.js": 539,
	"./states/company/sharing-center/shared-passwords/shared-passwords.state.js": 1909,
	"./states/company/sharing-center/sharing-center.component.js": 1910,
	"./states/company/sharing-center/sharing-center.controller.js": 540,
	"./states/company/sharing-center/sharing-center.service.js": 1912,
	"./states/company/sharing-center/sharing-center.state.js": 1913,
	"./states/company/sharing-center/sharing-settings/sharing-settings.component.js": 1914,
	"./states/company/sharing-center/sharing-settings/sharing-settings.controller.js": 541,
	"./states/company/sharing-center/sharing-settings/sharing-settings.service.js": 1916,
	"./states/company/sharing-center/sharing-settings/sharing-settings.state.js": 1917,
	"./states/company/slack-info/slack-info.component.js": 1918,
	"./states/company/slack-info/slack-info.controller.js": 542,
	"./states/company/slack-info/slack-info.service.js": 1920,
	"./states/company/slack-info/slack-info.state.js": 1921,
	"./states/company/sms-services/confirm-turn-off/confirm-turn-off-sms-service.component.js": 1922,
	"./states/company/sms-services/edit-sms-settings/edit-sms-settings.component.js": 1924,
	"./states/company/sms-services/edit-sms-settings/edit-sms-settings.controller.js": 543,
	"./states/company/sms-services/help/how-to-add-sms-user/how-to-add-sms-user.component.js": 1926,
	"./states/company/sms-services/help/how-to-add-sms-user/how-to-add-sms-user.controller.js": 544,
	"./states/company/sms-services/help/how-to-add-sms-user/how-to-add-sms-user.state.js": 1936,
	"./states/company/sms-services/help/sms-credit/sms-credit.component.js": 1937,
	"./states/company/sms-services/help/sms-credit/sms-credit.controller.js": 545,
	"./states/company/sms-services/help/sms-credit/sms-credit.state.js": 1947,
	"./states/company/sms-services/help/sms-services-help.component.js": 1948,
	"./states/company/sms-services/help/sms-services-help.controller.js": 546,
	"./states/company/sms-services/help/sms-services-help.state.js": 1950,
	"./states/company/sms-services/help/sms-settings/sms-settings.component.js": 1951,
	"./states/company/sms-services/help/sms-settings/sms-settings.controller.js": 547,
	"./states/company/sms-services/help/sms-settings/sms-settings.state.js": 1961,
	"./states/company/sms-services/help/what-is-sms-service/what-is-sms-service.component.js": 1962,
	"./states/company/sms-services/help/what-is-sms-service/what-is-sms-service.controller.js": 548,
	"./states/company/sms-services/help/what-is-sms-service/what-is-sms-service.state.js": 1972,
	"./states/company/sms-services/invoice/sms-purchase-invoice.component.js": 1973,
	"./states/company/sms-services/invoice/sms-purchase-invoice.controller.js": 549,
	"./states/company/sms-services/invoice/sms-purchase-invoice.scss": 1975,
	"./states/company/sms-services/invoice/sms-purchase-invoice.state.js": 1976,
	"./states/company/sms-services/paypal-cancelled/paypal-cancelled.component.js": 1977,
	"./states/company/sms-services/paypal-cancelled/paypal-cancelled.controller.js": 550,
	"./states/company/sms-services/paypal-cancelled/paypal-cancelled.state.js": 1979,
	"./states/company/sms-services/paypal-confirmed/paypal-confirmed.component.js": 1980,
	"./states/company/sms-services/paypal-confirmed/paypal-confirmed.controller.js": 551,
	"./states/company/sms-services/paypal-confirmed/paypal-confirmed.state.js": 1982,
	"./states/company/sms-services/purchase-history/sms-purchase-history.component.js": 1983,
	"./states/company/sms-services/purchase-history/sms-purchase-history.controller.js": 552,
	"./states/company/sms-services/sms-purchase/sms-purchase.component.js": 1985,
	"./states/company/sms-services/sms-purchase/sms-purchase.controller.js": 553,
	"./states/company/sms-services/sms-services.component.js": 1987,
	"./states/company/sms-services/sms-services.controller.js": 554,
	"./states/company/sms-services/sms-services.service.js": 1989,
	"./states/company/sms-services/sms-services.state.js": 1990,
	"./states/company/sms-services/sms-usage-report/sms-usage-report.component.js": 1991,
	"./states/company/sms-services/sms-usage-report/sms-usage-report.controller.js": 555,
	"./states/company/sms-services/sms-usage-report/sms-usage-report.modal.js": 1993,
	"./states/company/software-license-management/add/software-license-management-add.component.js": 1994,
	"./states/company/software-license-management/add/software-license-management-add.controller.js": 556,
	"./states/company/software-license-management/add/software-license-management-add.state.js": 1996,
	"./states/company/software-license-management/edit/software-license-management-edit.component.js": 1997,
	"./states/company/software-license-management/edit/software-license-management-edit.controller.js": 557,
	"./states/company/software-license-management/edit/software-license-management-edit.state.js": 1999,
	"./states/company/software-license-management/list/software-license-management.list.component.js": 2000,
	"./states/company/software-license-management/list/software-license-management.list.controller.js": 558,
	"./states/company/software-license-management/list/software-license-management.list.state.js": 2002,
	"./states/company/software-license-management/software-license-management.component.js": 2003,
	"./states/company/software-license-management/software-license-management.controller.js": 559,
	"./states/company/software-license-management/software-license-management.service.js": 2005,
	"./states/company/software-license-management/software-license-management.state.js": 2006,
	"./states/company/sp-admin/company-list/company-list.component.js": 2007,
	"./states/company/sp-admin/company-list/company-list.controller.js": 560,
	"./states/company/sp-admin/company-list/company-list.state.js": 2009,
	"./states/company/sp-admin/details/company-details.component.js": 2010,
	"./states/company/sp-admin/details/company-details.controller.js": 561,
	"./states/company/sp-admin/details/company-details.state.js": 2012,
	"./states/company/sp-admin/sp-admin.component.js": 2013,
	"./states/company/sp-admin/sp-admin.controller.js": 562,
	"./states/company/sp-admin/sp-admin.state.js": 2015,
	"./states/company/user-directories/account.dto.js": 48,
	"./states/company/user-directories/accounts-resource.service.js": 2016,
	"./states/company/user-directories/directories-resource.service.js": 2017,
	"./states/company/user-directories/directory-groups/all-accounts/all-accounts.component.js": 2018,
	"./states/company/user-directories/directory-groups/all-accounts/all-accounts.controller.js": 563,
	"./states/company/user-directories/directory-groups/all-accounts/all-accounts.state.js": 2020,
	"./states/company/user-directories/directory-groups/all-accounts/copy/copy-accounts-to-groups.component.js": 2021,
	"./states/company/user-directories/directory-groups/all-accounts/copy/copy-accounts-to-groups.controller.js": 564,
	"./states/company/user-directories/directory-groups/all-accounts/copy/copy-accounts-to-groups.state.js": 2023,
	"./states/company/user-directories/directory-groups/all-accounts/delete/delete-accounts.component.js": 2024,
	"./states/company/user-directories/directory-groups/all-accounts/delete/delete-accounts.controller.js": 565,
	"./states/company/user-directories/directory-groups/all-accounts/delete/delete-accounts.state.js": 2026,
	"./states/company/user-directories/directory-groups/all-accounts/export/export-accounts.component.js": 2027,
	"./states/company/user-directories/directory-groups/all-accounts/export/export-accounts.controller.js": 566,
	"./states/company/user-directories/directory-groups/all-accounts/export/export-accounts.state.js": 2029,
	"./states/company/user-directories/directory-groups/all-accounts/verify/send-verification-emails.component.js": 2030,
	"./states/company/user-directories/directory-groups/all-accounts/verify/send-verification-emails.controller.js": 567,
	"./states/company/user-directories/directory-groups/all-accounts/verify/send-verification-emails.state.js": 2032,
	"./states/company/user-directories/directory-groups/directory-groups-side-menu/directory-groups-side-menu.component.js": 2033,
	"./states/company/user-directories/directory-groups/directory/add-new-group/add-new-group.component.js": 2035,
	"./states/company/user-directories/directory-groups/directory/add-new-group/add-new-group.controller.js": 568,
	"./states/company/user-directories/directory-groups/directory/add-new-group/add-new-group.state.js": 2037,
	"./states/company/user-directories/directory-groups/directory/add-user/add-user.component.js": 2038,
	"./states/company/user-directories/directory-groups/directory/add-user/add-user.controller.js": 569,
	"./states/company/user-directories/directory-groups/directory/add-user/add-user.state.js": 2040,
	"./states/company/user-directories/directory-groups/directory/directory.component.js": 2041,
	"./states/company/user-directories/directory-groups/directory/directory.controller.js": 570,
	"./states/company/user-directories/directory-groups/directory/directory.functions.js": 203,
	"./states/company/user-directories/directory-groups/directory/directory.state.js": 2043,
	"./states/company/user-directories/directory-groups/directory/import-users/import-users.component.js": 2044,
	"./states/company/user-directories/directory-groups/directory/import-users/import-users.controller.js": 571,
	"./states/company/user-directories/directory-groups/directory/import-users/import-users.state.js": 2046,
	"./states/company/user-directories/directory-groups/directory/import-users/upload-result/upload-result.component.js": 2047,
	"./states/company/user-directories/directory-groups/directory/import-users/upload-result/upload-result.controller.js": 572,
	"./states/company/user-directories/directory-groups/directory/import-users/upload-result/upload-result.state.js": 2049,
	"./states/company/user-directories/directory-groups/directory/remove-groups/remove-groups.component.js": 2050,
	"./states/company/user-directories/directory-groups/directory/remove-groups/remove-groups.controller.js": 573,
	"./states/company/user-directories/directory-groups/directory/saaspass-cloud-directory/saaspass-cloud-directory.component.js": 2052,
	"./states/company/user-directories/directory-groups/directory/saaspass-cloud-directory/saaspass-cloud-directory.controller.js": 574,
	"./states/company/user-directories/directory-groups/user-directories.component.js": 2054,
	"./states/company/user-directories/directory-groups/user-directories.controller.js": 575,
	"./states/company/user-directories/directory-groups/user-directories.state.js": 2056,
	"./states/company/user-directories/group.dto.js": 84,
	"./states/company/user-directories/manage-account/custom-attributes/account-custom-attributes.component.js": 2057,
	"./states/company/user-directories/manage-account/custom-attributes/account-custom-attributes.controller.js": 576,
	"./states/company/user-directories/manage-account/custom-attributes/account-custom-attributes.state.js": 2059,
	"./states/company/user-directories/manage-account/details/account-details.component.js": 2060,
	"./states/company/user-directories/manage-account/details/account-details.controller.js": 577,
	"./states/company/user-directories/manage-account/details/account-details.state.js": 2062,
	"./states/company/user-directories/manage-account/groups-apps/add-to-groups/add-account-to-groups.component.js": 2063,
	"./states/company/user-directories/manage-account/groups-apps/add-to-groups/add-account-to-groups.controller.js": 578,
	"./states/company/user-directories/manage-account/groups-apps/add-to-groups/add-account-to-groups.state.js": 2065,
	"./states/company/user-directories/manage-account/groups-apps/groups-apps.component.js": 2066,
	"./states/company/user-directories/manage-account/groups-apps/groups-apps.controller.js": 579,
	"./states/company/user-directories/manage-account/groups-apps/groups-apps.state.js": 2068,
	"./states/company/user-directories/manage-account/groups-apps/remove-from-group/remove-account-from-group.component.js": 2069,
	"./states/company/user-directories/manage-account/groups-apps/remove-from-group/remove-account-from-group.controller.js": 580,
	"./states/company/user-directories/manage-account/manage-account-tabs.component.js": 2071,
	"./states/company/user-directories/manage-account/manage-account.component.js": 2073,
	"./states/company/user-directories/manage-account/manage-account.controller.js": 581,
	"./states/company/user-directories/manage-account/manage-account.state.js": 2075,
	"./states/company/user-directories/manage-account/owner/change/change-account-owner.component.js": 2076,
	"./states/company/user-directories/manage-account/owner/change/change-account-owner.controller.js": 582,
	"./states/company/user-directories/manage-account/owner/manage-account-owner.component.js": 2078,
	"./states/company/user-directories/manage-account/owner/manage-account-owner.controller.js": 583,
	"./states/company/user-directories/manage-account/owner/manage-account-owner.state.js": 2080,
	"./states/company/user-directories/manage-account/owner/remove/remove-account-owner.component.js": 2081,
	"./states/company/user-directories/manage-account/owner/remove/remove-account-owner.controller.js": 584,
	"./states/company/user-directories/manage-account/profile-attributes/edit/edit-profile-attributes.component.js": 2083,
	"./states/company/user-directories/manage-account/profile-attributes/edit/edit-profile-attributes.controller.js": 585,
	"./states/company/user-directories/manage-account/profile-attributes/edit/edit-profile-attributes.state.js": 2085,
	"./states/company/user-directories/manage-account/profile-attributes/profile-attributes.component.js": 2086,
	"./states/company/user-directories/manage-account/profile-attributes/profile-attributes.controller.js": 586,
	"./states/company/user-directories/manage-account/profile-attributes/profile-attributes.state.js": 2088,
	"./states/company/user-directories/manage-account/remove/remove-account.component.js": 2089,
	"./states/company/user-directories/manage-account/remove/remove-account.controller.js": 587,
	"./states/company/user-directories/manage-account/send-verification-email/send-verification-email.component.js": 2091,
	"./states/company/user-directories/manage-account/send-verification-email/send-verification-email.controller.js": 588,
	"./states/company/user-directories/manage-account/send-verification-email/send-verification-email.state.js": 2093,
	"./states/company/user-directories/manage-account/verify/verify-account-owner.component.js": 2094,
	"./states/company/user-directories/manage-account/verify/verify-account-owner.controller.js": 589,
	"./states/company/user-directories/manage-account/verify/verify-account-owner.state.js": 2096,
	"./states/company/user-directories/manage-group/accounts/add/add-account-to-group.component.js": 2097,
	"./states/company/user-directories/manage-group/accounts/add/add-account-to-group.controller.js": 590,
	"./states/company/user-directories/manage-group/accounts/add/add-account-to-group.state.js": 2099,
	"./states/company/user-directories/manage-group/accounts/bulk-verification-csv/bulk-verification-csv.component.js": 2100,
	"./states/company/user-directories/manage-group/accounts/bulk-verification-csv/bulk-verification-csv.controller.js": 591,
	"./states/company/user-directories/manage-group/accounts/bulk-verification-csv/bulk-verification-csv.state.js": 2102,
	"./states/company/user-directories/manage-group/accounts/bulk-verification-result/bulk-verification-result.component.js": 2103,
	"./states/company/user-directories/manage-group/accounts/bulk-verification-result/bulk-verification-result.controller.js": 592,
	"./states/company/user-directories/manage-group/accounts/bulk-verification-result/bulk-verification-result.state.js": 2105,
	"./states/company/user-directories/manage-group/accounts/bulk-verification/bulk-verification.component.js": 2106,
	"./states/company/user-directories/manage-group/accounts/bulk-verification/bulk-verification.controller.js": 593,
	"./states/company/user-directories/manage-group/accounts/bulk-verification/bulk-verification.state.js": 2116,
	"./states/company/user-directories/manage-group/accounts/copy/copy-accounts-to-groups.component.js": 2117,
	"./states/company/user-directories/manage-group/accounts/copy/copy-accounts-to-groups.controller.js": 594,
	"./states/company/user-directories/manage-group/accounts/copy/copy-accounts-to-groups.state.js": 2119,
	"./states/company/user-directories/manage-group/accounts/delete/delete-accounts.component.js": 2120,
	"./states/company/user-directories/manage-group/accounts/delete/delete-accounts.controller.js": 595,
	"./states/company/user-directories/manage-group/accounts/delete/delete-accounts.state.js": 2122,
	"./states/company/user-directories/manage-group/accounts/export/export-accounts.component.js": 2123,
	"./states/company/user-directories/manage-group/accounts/export/export-accounts.controller.js": 596,
	"./states/company/user-directories/manage-group/accounts/export/export-accounts.state.js": 2125,
	"./states/company/user-directories/manage-group/accounts/group-accounts.component.js": 2126,
	"./states/company/user-directories/manage-group/accounts/group-accounts.controller.js": 597,
	"./states/company/user-directories/manage-group/accounts/group-accounts.state.js": 2128,
	"./states/company/user-directories/manage-group/accounts/import/import-accounts-to-group.component.js": 2129,
	"./states/company/user-directories/manage-group/accounts/import/import-accounts-to-group.controller.js": 598,
	"./states/company/user-directories/manage-group/accounts/import/import-accounts-to-group.state.js": 2131,
	"./states/company/user-directories/manage-group/accounts/import/result/import-result.component.js": 2132,
	"./states/company/user-directories/manage-group/accounts/import/result/import-result.controller.js": 599,
	"./states/company/user-directories/manage-group/accounts/import/result/import-result.state.js": 2134,
	"./states/company/user-directories/manage-group/accounts/move/move-accounts-to-group.component.js": 2135,
	"./states/company/user-directories/manage-group/accounts/move/move-accounts-to-group.controller.js": 600,
	"./states/company/user-directories/manage-group/accounts/move/move-accounts-to-group.state.js": 2137,
	"./states/company/user-directories/manage-group/accounts/remove/remove-accounts-from-group.component.js": 2138,
	"./states/company/user-directories/manage-group/accounts/remove/remove-accounts-from-group.controller.js": 601,
	"./states/company/user-directories/manage-group/accounts/verify/send-verification-emails.component.js": 2140,
	"./states/company/user-directories/manage-group/accounts/verify/send-verification-emails.controller.js": 602,
	"./states/company/user-directories/manage-group/accounts/verify/send-verification-emails.state.js": 2142,
	"./states/company/user-directories/manage-group/applications/assign/assign-group-to-application.component.js": 2143,
	"./states/company/user-directories/manage-group/applications/assign/assign-group-to-application.controller.js": 603,
	"./states/company/user-directories/manage-group/applications/assign/assign-group-to-application.state.js": 2145,
	"./states/company/user-directories/manage-group/applications/group-applications.component.js": 2146,
	"./states/company/user-directories/manage-group/applications/group-applications.controller.js": 604,
	"./states/company/user-directories/manage-group/applications/group-applications.state.js": 2148,
	"./states/company/user-directories/manage-group/custom-attributes/group-custom-attributes.component.js": 2149,
	"./states/company/user-directories/manage-group/custom-attributes/group-custom-attributes.controller.js": 605,
	"./states/company/user-directories/manage-group/custom-attributes/group-custom-attributes.state.js": 2151,
	"./states/company/user-directories/manage-group/manage-group-tabs/manage-group-tabs.component.js": 2152,
	"./states/company/user-directories/manage-group/manage-group.component.js": 2154,
	"./states/company/user-directories/manage-group/manage-group.controller.js": 606,
	"./states/company/user-directories/manage-group/manage-group.state.js": 2156,
	"./states/company/user-directories/manage-group/remove/remove-group.component.js": 2157,
	"./states/company/user-directories/manage-group/remove/remove-group.controller.js": 607,
	"./states/company/user-directories/manage-group/settings/group-settings.component.js": 2159,
	"./states/company/user-directories/manage-group/settings/group-settings.controller.js": 608,
	"./states/company/user-directories/manage-group/settings/group-settings.state.js": 2161,
	"./states/company/user-directories/manage-user/add-account/account-already-exists/account-already-exists.component.js": 2162,
	"./states/company/user-directories/manage-user/add-account/add-account.component.js": 2164,
	"./states/company/user-directories/manage-user/add-account/add-account.controller.js": 609,
	"./states/company/user-directories/manage-user/add-account/add-account.state.js": 2166,
	"./states/company/user-directories/manage-user/copy-accounts/copy-accounts.component.js": 2167,
	"./states/company/user-directories/manage-user/copy-accounts/copy-accounts.controller.js": 610,
	"./states/company/user-directories/manage-user/copy-accounts/copy-accounts.state.js": 2169,
	"./states/company/user-directories/manage-user/copy-shared-accounts/copy-shared-accounts.component.js": 2170,
	"./states/company/user-directories/manage-user/copy-shared-accounts/copy-shared-accounts.controller.js": 611,
	"./states/company/user-directories/manage-user/copy-shared-accounts/copy-shared-accounts.state.js": 2172,
	"./states/company/user-directories/manage-user/delete-accounts/delete-accounts.component.js": 2173,
	"./states/company/user-directories/manage-user/delete-accounts/delete-accounts.controller.js": 612,
	"./states/company/user-directories/manage-user/delete-accounts/delete-accounts.state.js": 2175,
	"./states/company/user-directories/manage-user/delete-user/delete-user.component.js": 2176,
	"./states/company/user-directories/manage-user/delete-user/delete-user.controller.js": 613,
	"./states/company/user-directories/manage-user/details/assign-hard-token/assign-hard-token.component.js": 2178,
	"./states/company/user-directories/manage-user/details/assign-hard-token/assign-hard-token.controller.js": 614,
	"./states/company/user-directories/manage-user/details/assign-hard-token/confirm-assign/confirm-assign.component.js": 2180,
	"./states/company/user-directories/manage-user/details/assign-hard-token/confirm-assign/confirm-assign.controller.js": 615,
	"./states/company/user-directories/manage-user/details/backup-codes/backup-codes.component.js": 2182,
	"./states/company/user-directories/manage-user/details/backup-codes/backup-codes.controller.js": 616,
	"./states/company/user-directories/manage-user/details/backup-codes/backup-codes.state.js": 2184,
	"./states/company/user-directories/manage-user/details/deactivate-sms/deactivate-sms.component.js": 2185,
	"./states/company/user-directories/manage-user/details/deactivate-sms/deactivate-sms.controller.js": 617,
	"./states/company/user-directories/manage-user/details/manage-user-details.component.js": 2187,
	"./states/company/user-directories/manage-user/details/manage-user-details.controller.js": 618,
	"./states/company/user-directories/manage-user/details/manage-user-details.state.js": 2189,
	"./states/company/user-directories/manage-user/edit-display-name/edit-display-name.component.js": 2190,
	"./states/company/user-directories/manage-user/edit-display-name/edit-display-name.controller.js": 619,
	"./states/company/user-directories/manage-user/edit-display-name/edit-display-name.state.js": 2192,
	"./states/company/user-directories/manage-user/generate-backup-codes/generate-backup-codes.component.js": 2193,
	"./states/company/user-directories/manage-user/generate-backup-codes/generate-backup-codes.controller.js": 620,
	"./states/company/user-directories/manage-user/manage-user.component.js": 2195,
	"./states/company/user-directories/manage-user/manage-user.controller.js": 621,
	"./states/company/user-directories/manage-user/manage-user.state.js": 2197,
	"./states/company/user-directories/manage-user/move-accounts/move-accounts.component.js": 2198,
	"./states/company/user-directories/manage-user/move-accounts/move-accounts.controller.js": 622,
	"./states/company/user-directories/manage-user/move-accounts/move-accounts.state.js": 2200,
	"./states/company/user-directories/manage-user/move-shared-accounts/move-shared-accounts.component.js": 2201,
	"./states/company/user-directories/manage-user/move-shared-accounts/move-shared-accounts.controller.js": 623,
	"./states/company/user-directories/manage-user/move-shared-accounts/move-shared-accounts.state.js": 2203,
	"./states/company/user-directories/manage-user/remove-accounts/remove-accounts.component.js": 2204,
	"./states/company/user-directories/manage-user/remove-accounts/remove-accounts.controller.js": 624,
	"./states/company/user-directories/manage-user/remove-accounts/remove-accounts.state.js": 2206,
	"./states/company/user-directories/manage-user/sms-reset-pin/sms-reset-pin.component.js": 2207,
	"./states/company/user-directories/manage-user/sms-reset-pin/sms-reset-pin.controller.js": 625,
	"./states/company/user-directories/manage-user/sms-reset-pin/sms-reset-pin.service.js": 2209,
	"./states/company/user-directories/manage-user/unshare-shared-accounts/unshare-shared-accounts.component.js": 2210,
	"./states/company/user-directories/manage-user/unshare-shared-accounts/unshare-shared-accounts.controller.js": 626,
	"./states/company/user-directories/manage-user/unshare-shared-accounts/unshare-shared-accounts.state.js": 2212,
	"./states/company/user-directories/manage-user/unshare-shared-notes/unshare-shared-notes.component.js": 2213,
	"./states/company/user-directories/manage-user/unshare-shared-notes/unshare-shared-notes.controller.js": 627,
	"./states/company/user-directories/manage-user/unshare-shared-notes/unshare-shared-notes.state.js": 2215,
	"./states/company/user-directories/saaspass-users/administrators-developers/administrators-developers.component.js": 2216,
	"./states/company/user-directories/saaspass-users/administrators-developers/administrators-developers.controller.js": 628,
	"./states/company/user-directories/saaspass-users/administrators-developers/administrators-developers.state.js": 2218,
	"./states/company/user-directories/saaspass-users/all-users/all-users.component.js": 2219,
	"./states/company/user-directories/saaspass-users/all-users/all-users.controller.js": 629,
	"./states/company/user-directories/saaspass-users/all-users/all-users.state.js": 2221,
	"./states/company/user-directories/saaspass-users/all-users/user-settings/confirm/user-settings-confirm.component.js": 2222,
	"./states/company/user-directories/saaspass-users/all-users/user-settings/confirm/user-settings-confirm.controller.js": 630,
	"./states/company/user-directories/saaspass-users/all-users/user-settings/user-settings.component.js": 2224,
	"./states/company/user-directories/saaspass-users/all-users/user-settings/user-settings.controller.js": 631,
	"./states/company/user-directories/saaspass-users/all-users/user-settings/user-settings.service.js": 2226,
	"./states/company/user-directories/saaspass-users/all-users/user-settings/user-settings.state.js": 2227,
	"./states/company/user-directories/saaspass-users/blocked-users/blocked-users.component.js": 2228,
	"./states/company/user-directories/saaspass-users/blocked-users/blocked-users.controller.js": 632,
	"./states/company/user-directories/saaspass-users/blocked-users/blocked-users.state.js": 2230,
	"./states/company/user-directories/saaspass-users/hard-token-users/hard-token-users.component.js": 2231,
	"./states/company/user-directories/saaspass-users/hard-token-users/hard-token-users.controller.js": 633,
	"./states/company/user-directories/saaspass-users/hard-token-users/hard-token-users.state.js": 2233,
	"./states/company/user-directories/saaspass-users/paused-users/paused-users.component.js": 2234,
	"./states/company/user-directories/saaspass-users/paused-users/paused-users.controller.js": 634,
	"./states/company/user-directories/saaspass-users/paused-users/paused-users.state.js": 2236,
	"./states/company/user-directories/saaspass-users/regular-saaspass-app-users/regular-saaspass-app-users.component.js": 2237,
	"./states/company/user-directories/saaspass-users/regular-saaspass-app-users/regular-saaspass-app-users.state.js": 2239,
	"./states/company/user-directories/saaspass-users/saaspass-users.component.js": 2240,
	"./states/company/user-directories/saaspass-users/saaspass-users.state.js": 2242,
	"./states/company/user-directories/saaspass-users/sms-users/add/add-sms-user.component.js": 2243,
	"./states/company/user-directories/saaspass-users/sms-users/add/add-sms-user.controller.js": 635,
	"./states/company/user-directories/saaspass-users/sms-users/add/add-sms-user.state.js": 2245,
	"./states/company/user-directories/saaspass-users/sms-users/sms-users.component.js": 2246,
	"./states/company/user-directories/saaspass-users/sms-users/sms-users.controller.js": 636,
	"./states/company/user-directories/saaspass-users/sms-users/sms-users.state.js": 2248,
	"./states/company/user-directories/saaspass-users/user-labels/add/add-users-to-labels.component.js": 2249,
	"./states/company/user-directories/saaspass-users/user-labels/add/add-users-to-labels.controller.js": 637,
	"./states/company/user-directories/saaspass-users/user-labels/add/add-users-to-labels.state.js": 2251,
	"./states/company/user-directories/saaspass-users/user-labels/copy/copy-users-to-labels.component.js": 2252,
	"./states/company/user-directories/saaspass-users/user-labels/copy/copy-users-to-labels.controller.js": 638,
	"./states/company/user-directories/saaspass-users/user-labels/copy/copy-users-to-labels.state.js": 2254,
	"./states/company/user-directories/saaspass-users/user-labels/create-label/create-label.component..js": 2255,
	"./states/company/user-directories/saaspass-users/user-labels/create-label/create-label.controller.js": 639,
	"./states/company/user-directories/saaspass-users/user-labels/create-label/create-label.state.js": 2257,
	"./states/company/user-directories/saaspass-users/user-labels/import/import-users-to-label.component.js": 2258,
	"./states/company/user-directories/saaspass-users/user-labels/import/import-users-to-label.controller.js": 640,
	"./states/company/user-directories/saaspass-users/user-labels/import/import-users-to-label.state.js": 2260,
	"./states/company/user-directories/saaspass-users/user-labels/label-settings/delete/delete-label.component.js": 2261,
	"./states/company/user-directories/saaspass-users/user-labels/label-settings/delete/delete-label.controller.js": 641,
	"./states/company/user-directories/saaspass-users/user-labels/label-settings/label-settings.component.js": 2263,
	"./states/company/user-directories/saaspass-users/user-labels/label-settings/label-settings.controller.js": 642,
	"./states/company/user-directories/saaspass-users/user-labels/label-settings/label-settings.state.js": 2265,
	"./states/company/user-directories/saaspass-users/user-labels/move/move-users-to-label.component..js": 2266,
	"./states/company/user-directories/saaspass-users/user-labels/move/move-users-to-label.controller.js": 643,
	"./states/company/user-directories/saaspass-users/user-labels/move/move-users-to-label.state.js": 2268,
	"./states/company/user-directories/saaspass-users/user-labels/remove/remove-users-from-label.component.js": 2269,
	"./states/company/user-directories/saaspass-users/user-labels/remove/remove-users-from-label.controller.js": 644,
	"./states/company/user-directories/saaspass-users/user-labels/user-labels.component.js": 2271,
	"./states/company/user-directories/saaspass-users/user-labels/user-labels.controller.js": 645,
	"./states/company/user-directories/saaspass-users/user-labels/user-labels.service.js": 2273,
	"./states/company/user-directories/saaspass-users/user-labels/user-labels.state.js": 2274,
	"./states/company/user-directories/saaspass-users/users-side-menu/users-side-menu.component.js": 2275,
	"./states/company/user-directories/user-directories.component.js": 2277,
	"./states/company/user-directories/user-directories.controller.js": 646,
	"./states/company/user-directories/user-directories.state.js": 2279,
	"./states/company/user-directories/users-resource.service.js": 2280,
	"./states/company/whats-new/updates.js": 139,
	"./states/company/whats-new/whats-new-sidemenu/whats-new-sidemenu.component.js": 2281,
	"./states/company/whats-new/whats-new-sidemenu/whats-new-sidemenu.controller.js": 647,
	"./states/company/whats-new/whats-new.component.js": 2283,
	"./states/company/whats-new/whats-new.controller.js": 648,
	"./states/company/whats-new/whats-new.scss": 2308,
	"./states/company/whats-new/whats-new.state.js": 2309,
	"./states/public/client-saml-login/client-saml-login.component.js": 2310,
	"./states/public/client-saml-login/client-saml-login.controller.js": 649,
	"./states/public/client-saml-login/client-saml-login.state.js": 2311,
	"./states/public/client-sso-saaspass-login/client-sso-saaspass-login.component.js": 2312,
	"./states/public/client-sso-saaspass-login/client-sso-saaspass-login.controller.js": 650,
	"./states/public/client-sso-saaspass-login/client-sso-saaspass-login.state.js": 2313,
	"./states/public/company-created-success/company-created-success.state.js": 2314,
	"./states/public/company-registration-success/company-registration-success.state.js": 2316,
	"./states/public/company-registration/company-registration.component.js": 2318,
	"./states/public/company-registration/company-registration.controller.js": 652,
	"./states/public/company-registration/company-registration.service.js": 2320,
	"./states/public/company-registration/company-registration.state.js": 2321,
	"./states/public/contact/contact.component.js": 2322,
	"./states/public/contact/contact.controller.js": 653,
	"./states/public/contact/contact.service.js": 2324,
	"./states/public/contact/contact.state.js": 2325,
	"./states/public/custom-error/custom-error.component.js": 2326,
	"./states/public/custom-error/custom-error.state.js": 2328,
	"./states/public/data-deletion-form/data-deletion-form.component.js": 2329,
	"./states/public/data-deletion-form/data-deletion-form.controller.js": 654,
	"./states/public/data-deletion-form/data-deletion-form.service.js": 2331,
	"./states/public/data-deletion-form/data-deletion-form.state.js": 2332,
	"./states/public/default/default.state.js": 2333,
	"./states/public/domain-login/domain-login.state.js": 2334,
	"./states/public/extension-alert/extension-alert.component.js": 2335,
	"./states/public/extension-alert/extension-alert.controller.js": 655,
	"./states/public/extension-alert/extension-alert.state.js": 2337,
	"./states/public/google-info/google-info.component.js": 2338,
	"./states/public/google-info/google-info.controller.js": 656,
	"./states/public/google-info/google-info.state.js": 2340,
	"./states/public/google-marketplace-configuration-error/google-marketplace-configuration-error.component.js": 2341,
	"./states/public/google-marketplace-configuration-error/google-marketplace-configuration-error.state.js": 2343,
	"./states/public/google-marketplace-configuration-login/google-marketplace-configuration-login.component.js": 2344,
	"./states/public/google-marketplace-configuration-login/google-marketplace-configuration-login.controller.js": 657,
	"./states/public/google-marketplace-configuration-login/google-marketplace-configuration-login.state.js": 2346,
	"./states/public/google-marketplace-login/google-marketplace-login.component.js": 2347,
	"./states/public/google-marketplace-login/google-marketplace-login.controller.js": 658,
	"./states/public/google-marketplace-login/google-marketplace-login.state.js": 2348,
	"./states/public/hard-token-login/hard-token-login.controller.js": 2349,
	"./states/public/hard-token-login/hard-token-login.service.js": 2350,
	"./states/public/hard-token-login/hard-token-login.state.js": 2351,
	"./states/public/hard-token-login/u2f-login.controller.js": 2353,
	"./states/public/hard-token-login/usb-token-login.controller.js": 2354,
	"./states/public/hard-token-sync/hard-token-sync.component.js": 2355,
	"./states/public/hard-token-sync/hard-token-sync.controller.js": 659,
	"./states/public/hard-token-sync/hard-token-sync.service.js": 2357,
	"./states/public/hard-token-sync/hard-token-sync.state.js": 2358,
	"./states/public/login-modal/login-modal.component.js": 2359,
	"./states/public/login-modal/login.modal.scss": 2361,
	"./states/public/login-web-saml/hard-token-login/hard-token-login.modal.js": 2362,
	"./states/public/login-web-saml/hard-token-login/hard-token-saml-login.controller.js": 2364,
	"./states/public/login-web-saml/hard-token-login/hard-token-saml-login.service.js": 2365,
	"./states/public/login-web-saml/hard-token-login/hard-token-tabs.directive.js": 2366,
	"./states/public/login-web-saml/hard-token-login/pane.directive.js": 2367,
	"./states/public/login-web-saml/hard-token-login/u2f-saml-login.controller.js": 2368,
	"./states/public/login-web-saml/hard-token-login/usb-saml-login-handler.service.js": 2369,
	"./states/public/login-web-saml/hard-token-login/usb-token-saml-login.controller.js": 2370,
	"./states/public/login-web-saml/login-web-saml.controller.js": 660,
	"./states/public/login-web-saml/login-web-saml.state.js": 2371,
	"./states/public/login/login.component.js": 2373,
	"./states/public/login/login.controller.js": 205,
	"./states/public/login/login.state.js": 2374,
	"./states/public/logout/logout.controller.js": 662,
	"./states/public/logout/logout.state.js": 2375,
	"./states/public/pin-reset/pin-reset.component.js": 2376,
	"./states/public/pin-reset/pin-reset.controller.js": 663,
	"./states/public/pin-reset/pin-reset.service.js": 2378,
	"./states/public/pin-reset/pin-reset.state.js": 2379,
	"./states/public/public.component.js": 2380,
	"./states/public/public.controller.js": 664,
	"./states/public/public.state.js": 2382,
	"./states/public/reset-password-verify/reset-password-verify.component.js": 2383,
	"./states/public/reset-password-verify/reset-password-verify.controller.js": 665,
	"./states/public/reset-password-verify/reset-password-verify.service.js": 2385,
	"./states/public/reset-password-verify/reset-password-verify.state.js": 2386,
	"./states/public/reset-password/reset-password.component.js": 2387,
	"./states/public/reset-password/reset-password.controller.js": 666,
	"./states/public/reset-password/reset-password.service.js": 2389,
	"./states/public/reset-password/reset-password.state.js": 2390,
	"./states/public/saaspass-connect-login/saaspass-connect-login.component.js": 2391,
	"./states/public/saaspass-connect-login/saaspass-connect-login.controller.js": 667,
	"./states/public/saaspass-connect-login/saaspass-connect-login.state.js": 2393,
	"./states/public/saml-idp-login/saml-idp-login.controller.js": 668,
	"./states/public/saml-idp-login/saml-idp-login.state.js": 2394,
	"./states/public/saml-login-handler.service.js": 2395,
	"./states/public/saml-login/saml-login.controller.js": 669,
	"./states/public/saml-login/saml-login.state.js": 2396,
	"./states/public/saml-logout/saml-logout.component.js": 2397,
	"./states/public/saml-logout/saml-logout.controller.js": 670,
	"./states/public/saml-logout/saml-logout.state.js": 2399,
	"./states/public/saml.service.js": 2400,
	"./states/public/session-expired/session-expired.component.js": 2401,
	"./states/public/session-expired/session-expired.controller.js": 671,
	"./states/public/session-expired/session-expired.state.js": 2403,
	"./states/public/sms-user-otp/sms-gateways.service.js": 2404,
	"./states/public/sms-user-otp/sms-user-otp.component.js": 2405,
	"./states/public/sms-user-otp/sms-user-otp.controller.js": 672,
	"./states/public/sms-user-otp/sms-user-otp.service.js": 2407,
	"./states/public/sms-user-otp/sms-user-otp.state.js": 2408,
	"./states/public/sms-user-registration/sms-user-activation-code-generation.service.js": 2409,
	"./states/public/sms-user-registration/sms-user-registration.component.js": 2410,
	"./states/public/sms-user-registration/sms-user-registration.controller.js": 673,
	"./states/public/sms-user-registration/sms-user-registration.service.js": 2412,
	"./states/public/sms-user-registration/sms-user-registration.state.js": 2413,
	"./states/public/sms-user-registration/sp-credential-check.directive.js": 2414,
	"./states/public/subscription-error/subscription-error.component.js": 2415,
	"./states/public/subscription-error/subscription-error.state.js": 2417,
	"./states/public/subscription-success/subscription-success.component.js": 2418,
	"./states/public/subscription-success/subscription-success.state.js": 2420,
	"./states/public/verification/company/company-verification.component.js": 2421,
	"./states/public/verification/company/company-verification.controller.js": 674,
	"./states/public/verification/company/company-verification.state.js": 2423,
	"./states/public/verification/email/email-verification.component.js": 2424,
	"./states/public/verification/email/email-verification.controller.js": 675,
	"./states/public/verification/email/email-verification.scss": 2426,
	"./states/public/verification/email/email-verification.service.js": 2427,
	"./states/public/verification/email/email-verification.state.js": 2428,
	"./states/public/verification/fido-registration/fido-registration.component.js": 2429,
	"./states/public/verification/fido-registration/fido-registration.controller.js": 676,
	"./states/public/verification/fido-registration/fido-registration.service.js": 2431,
	"./states/public/verification/fido-registration/fido-registration.state.js": 2432,
	"./states/public/verification/slack/slack-verification.component.js": 2433,
	"./states/public/verification/slack/slack-verification.controller.js": 677,
	"./states/public/verification/slack/slack-verification.scss": 2435,
	"./states/public/verification/slack/slack-verification.service.js": 2436,
	"./states/public/verification/slack/slack-verification.state.js": 2437,
	"./states/url-rewrite.state.js": 2438,
	"./states/user/applications/account-config/account-config.component.js": 2439,
	"./states/user/applications/account-config/account-config.controller.js": 678,
	"./states/user/applications/account-config/account-config.modal.js": 2441,
	"./states/user/applications/account-config/account-config.service.js": 2442,
	"./states/user/applications/account-password-update/account-password-update.component.js": 2443,
	"./states/user/applications/account-password-update/account-password-update.controller.js": 679,
	"./states/user/applications/account-password-update/account-password-update.service.js": 2445,
	"./states/user/applications/applications.component.js": 2446,
	"./states/user/applications/applications.controller.js": 680,
	"./states/user/applications/applications.service.js": 2449,
	"./states/user/applications/applications.state.js": 2450,
	"./states/user/applications/header.component.js": 2451,
	"./states/user/applications/header.controller.js": 681,
	"./states/user/applications/login-role-select/login-role-select.component.js": 2453,
	"./states/user/applications/login-role-select/login-role-select.controller.js": 682,
	"./states/user/applications/login-role-select/login-role-select.modal.js": 2455,
	"./states/user/applications/login-role-select/login-roles.service.js": 2456,
	"./states/user/applications/shared-epm.service.js": 2457,
	"./states/user/connectors/connectors.component.js": 2458,
	"./states/user/connectors/connectors.controller.js": 683,
	"./states/user/connectors/connectors.service.js": 2460,
	"./states/user/connectors/connectors.state.js": 2461,
	"./states/user/device-management/device-management.component.js": 2462,
	"./states/user/device-management/device-management.controller.js": 684,
	"./states/user/device-management/device-management.service.js": 2464,
	"./states/user/device-management/device-management.state.js": 2465,
	"./states/user/emails/add/add.component.js": 2466,
	"./states/user/emails/add/add.controller.js": 685,
	"./states/user/emails/emails.component.js": 2468,
	"./states/user/emails/emails.controller.js": 686,
	"./states/user/emails/emails.service.js": 2470,
	"./states/user/emails/emails.state.js": 2471,
	"./states/user/header.component.js": 2472,
	"./states/user/notes/add/add-note.component.js": 2474,
	"./states/user/notes/add/add-note.controller.js": 687,
	"./states/user/notes/add/add-note.state.js": 2476,
	"./states/user/notes/edit/edit-note.component.js": 2477,
	"./states/user/notes/edit/edit-note.controller.js": 688,
	"./states/user/notes/edit/edit-note.state.js": 2479,
	"./states/user/notes/notes.component.js": 2480,
	"./states/user/notes/notes.controller.js": 689,
	"./states/user/notes/notes.service.js": 2482,
	"./states/user/notes/notes.state.js": 2483,
	"./states/user/phone-numbers/add/add-phone-number.component.js": 2484,
	"./states/user/phone-numbers/add/add-phone-number.controller.js": 690,
	"./states/user/phone-numbers/add/add-phone-number.state.js": 2486,
	"./states/user/phone-numbers/confirm-remove-recovery/confirm-remove-recovery.component.js": 2487,
	"./states/user/phone-numbers/confirm-turn-off-recovery/confirm-turn-off-recovery.component.js": 2489,
	"./states/user/phone-numbers/confirm-update-recovery/confirm-update-recovery.component.js": 2491,
	"./states/user/phone-numbers/list/new-sms-number.service.js": 2493,
	"./states/user/phone-numbers/list/phone-number-list.component.js": 2494,
	"./states/user/phone-numbers/list/phone-number-list.controller.js": 691,
	"./states/user/phone-numbers/list/phone-number-list.state.js": 2497,
	"./states/user/phone-numbers/list/sms-number-generate-code.service.js": 2498,
	"./states/user/phone-numbers/list/sms-number.service.js": 2499,
	"./states/user/phone-numbers/phone-numbers.component.js": 2500,
	"./states/user/phone-numbers/phone-numbers.controller.js": 692,
	"./states/user/phone-numbers/phone-numbers.state.js": 2502,
	"./states/user/phone-numbers/recovery-settings/recovery-reminder/recovery-reminder.component.js": 2503,
	"./states/user/phone-numbers/recovery-settings/recovery-reminder/recovery-reminder.controller.js": 693,
	"./states/user/phone-numbers/recovery-settings/recovery-reminder/recovery-reminder.scss": 2507,
	"./states/user/phone-numbers/recovery-settings/recovery-settings.component.js": 2508,
	"./states/user/phone-numbers/recovery-settings/recovery-settings.controller.js": 694,
	"./states/user/phone-numbers/recovery-settings/recovery-settings.service.js": 2510,
	"./states/user/phone-numbers/recovery-settings/recovery-settings.state.js": 2511,
	"./states/user/phone-numbers/verify/verify.component.js": 2512,
	"./states/user/phone-numbers/verify/verify.controller.js": 695,
	"./states/user/profiles/add/add.component.js": 2514,
	"./states/user/profiles/add/add.controller.js": 696,
	"./states/user/profiles/add/add.modal.js": 2516,
	"./states/user/profiles/facebook-profile-import.js": 697,
	"./states/user/profiles/info/info.component.js": 2517,
	"./states/user/profiles/load-facebook-sdk.js": 698,
	"./states/user/profiles/profile/basic/basic.component.js": 2519,
	"./states/user/profiles/profile/basic/basic.controller.js": 699,
	"./states/user/profiles/profile/basic/basic.state.js": 2521,
	"./states/user/profiles/profile/basic/edit/edit.component.js": 2522,
	"./states/user/profiles/profile/basic/edit/edit.controller.js": 700,
	"./states/user/profiles/profile/basic/edit/edit.modal.js": 2524,
	"./states/user/profiles/profile/extended/edit/edit.component.js": 2525,
	"./states/user/profiles/profile/extended/edit/edit.controller.js": 701,
	"./states/user/profiles/profile/extended/edit/edit.modal.js": 2527,
	"./states/user/profiles/profile/extended/extended.component.js": 2528,
	"./states/user/profiles/profile/extended/extended.controller.js": 702,
	"./states/user/profiles/profile/extended/extended.state.js": 2530,
	"./states/user/profiles/profile/main/delete/delete.component.js": 2531,
	"./states/user/profiles/profile/main/delete/delete.controller.js": 703,
	"./states/user/profiles/profile/main/edit/edit.component.js": 2533,
	"./states/user/profiles/profile/main/edit/edit.controller.js": 704,
	"./states/user/profiles/profile/main/edit/edit.modal.js": 2535,
	"./states/user/profiles/profile/main/main.component.js": 2536,
	"./states/user/profiles/profile/main/main.controller.js": 705,
	"./states/user/profiles/profile/main/main.state.js": 2538,
	"./states/user/profiles/profile/profile.component.js": 2539,
	"./states/user/profiles/profile/profile.state.js": 2541,
	"./states/user/profiles/profiles.component.js": 2542,
	"./states/user/profiles/profiles.controller.js": 706,
	"./states/user/profiles/profiles.service.js": 2544,
	"./states/user/profiles/profiles.state.js": 2545,
	"./states/user/profiles/social/social.component.js": 2546,
	"./states/user/public-user-accounts/add/add-public-user-account.component.js": 2548,
	"./states/user/public-user-accounts/add/add-public-user-account.controller.js": 707,
	"./states/user/public-user-accounts/add/add-public-user-account.state.js": 2550,
	"./states/user/public-user-accounts/authenticators.service.js": 2551,
	"./states/user/public-user-accounts/confirm-remove/confirm-remove.component.js": 2552,
	"./states/user/public-user-accounts/edit/edit-public-user-account.component.js": 2554,
	"./states/user/public-user-accounts/edit/edit-public-user-account.controller.js": 708,
	"./states/user/public-user-accounts/edit/edit-public-user-account.state.js": 2556,
	"./states/user/public-user-accounts/header.component.js": 2557,
	"./states/user/public-user-accounts/header.controller.js": 709,
	"./states/user/public-user-accounts/import/import-result/import-result.component.js": 2559,
	"./states/user/public-user-accounts/import/import-result/import-result.controller.js": 710,
	"./states/user/public-user-accounts/import/import-result/import-result.state.js": 2561,
	"./states/user/public-user-accounts/import/import.component.js": 2562,
	"./states/user/public-user-accounts/import/import.controller.js": 711,
	"./states/user/public-user-accounts/import/import.state.js": 2564,
	"./states/user/public-user-accounts/password-manager.service.js": 2565,
	"./states/user/public-user-accounts/public-user-accounts.component.js": 2566,
	"./states/user/public-user-accounts/public-user-accounts.controller.js": 712,
	"./states/user/public-user-accounts/public-user-accounts.scss": 2568,
	"./states/user/public-user-accounts/public-user-accounts.state.js": 2569,
	"./states/user/public-user-accounts/public.component.js": 2570,
	"./states/user/public-user-accounts/public.state.js": 2572,
	"./states/user/public-user-accounts/share-public-user-account/share-public-user-account.component.js": 2573,
	"./states/user/public-user-accounts/share-public-user-account/share-public-user-account.controller.js": 713,
	"./states/user/public-user-accounts/share-public-user-account/share-public-user-account.state.js": 2575,
	"./states/user/statistics/statistics.component.js": 2576,
	"./states/user/statistics/statistics.controller.js": 714,
	"./states/user/statistics/statistics.state.js": 2578,
	"./states/user/user.component.js": 2579,
	"./states/user/user.controller.js": 715,
	"./states/user/user.scss": 2581,
	"./states/user/user.state.js": 2582,
	"./states/user/users-shared-accounts/header.component.js": 2583,
	"./states/user/users-shared-accounts/header.controller.js": 716,
	"./states/user/users-shared-accounts/shared-sso.service.js": 2585,
	"./states/user/users-shared-accounts/users-shared-accounts.component.js": 2586,
	"./states/user/users-shared-accounts/users-shared-accounts.controller.js": 717,
	"./states/user/users-shared-accounts/users-shared-accounts.service.js": 2589,
	"./states/user/users-shared-accounts/users-shared-accounts.state.js": 2590,
	"./states/user/users-shared-accounts/users-shared-notes.component.js": 2591,
	"./states/user/users-shared-accounts/users-shared-notes.controller.js": 718,
	"./states/user/users-shared-accounts/users-shared-notes.state.js": 2593,
	"./states/user/users-shared-accounts/users-shared.component.js": 2594,
	"./states/user/users-shared-accounts/users-shared.state.js": 2596,
	"./states/user/you-are-not-company-admin/you-are-not-company-admin.component.js": 2597,
	"./styles/portal.scss": 2599,
	"./styles/sp-title-row.scss": 2600,
	"./styles/sprites.css": 2601
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 933;

/***/ }),
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _applicationUsageReport = __webpack_require__(298);

_app.app.component('applicationUsageReport', {
    bindings: {
        application: '<' },
    controller: _applicationUsageReport.Controller,
    templateUrl: __webpack_require__(1017)
});

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8ee89122fc1b532fc8e48f8b4a0d5093.html";

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UserAccountsService.$inject = ['$resource'];


_app.app.factory('UserAccountsService', UserAccountsService);

/** @ngInject */
function UserAccountsService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/useraccounts';

    return {
        assignedGroups: $resource(rootUrl),
        userAccountAction: $resource(rootUrl + '/group/:groupId')
    };
}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('captcha', {
    bindings: { state: '<' },
    templateUrl: __webpack_require__(1020)
});

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9840a0b7423f4c61ce1670a5ded2a526.html";

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spGrecaptcha = __webpack_require__(301);

_app.app.component('spGrecaptcha', {
    bindings: { state: '<' },
    controller: _spGrecaptcha.Controller
});

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _infoSharingAccounts = __webpack_require__(302);

_app.app.component('infoSharingAccounts', {
    controller: _infoSharingAccounts.Controller,
    templateUrl: __webpack_require__(1032)
});

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./info-sharing-accounts-de.html": 1025,
	"./info-sharing-accounts-en.html": 1026,
	"./info-sharing-accounts-es.html": 1027,
	"./info-sharing-accounts-fr.html": 1028,
	"./info-sharing-accounts-ja.html": 1029,
	"./info-sharing-accounts-pt.html": 1030,
	"./info-sharing-accounts-zh.html": 1031
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1024;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0cfad8942790169fef3fb535a4c0921e.html";

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "15b7f0185ca4da61163b3118b1d3f43f.html";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c3e431b864fc75e92f2510ba7ca05c8e.html";

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d9da87ae4260b4047c9d719c734865bb.html";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba343bb5f6d8c1596d4f3be019c82d8c.html";

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d37d81bd733ba810048781622a03e120.html";

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e2790ea16eeea684c81d71ef1cafb223.html";

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf29164929282069d596e9b6d9036c60.html";

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _infoSharingCenter = __webpack_require__(303);

_app.app.component('infoSharingCenter', {
    controller: _infoSharingCenter.Controller,
    templateUrl: __webpack_require__(1042)
});

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./info-sharing-center-de.html": 1035,
	"./info-sharing-center-en.html": 1036,
	"./info-sharing-center-es.html": 1037,
	"./info-sharing-center-fr.html": 1038,
	"./info-sharing-center-ja.html": 1039,
	"./info-sharing-center-pt.html": 1040,
	"./info-sharing-center-zh.html": 1041
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1034;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a2bff4aa1a5287e16ed89a3c8233137b.html";

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b598df86dadd294be00ea54a21ff98e.html";

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60a4fdb20da02f574373c542b5943f7d.html";

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6da8ad11e9f1b1fb06d079f8f51e7af3.html";

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "68aed551fa33de68db02a0ed246163ae.html";

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ad0683c86387db0cf18f5fcefee8b816.html";

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3c6b1adb5469a95c9edcf7a87219b981.html";

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2a7f130f34226f57b22a0291e5eb836e.html";

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _languageSwitcher = __webpack_require__(304);

_app.app.component('languageSwitcher', {
    controller: _languageSwitcher.Controller,
    templateUrl: __webpack_require__(1054)
});

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de.png": 1045,
	"./en.png": 1046,
	"./es.png": 1047,
	"./fr.png": 1048,
	"./ja.png": 1049,
	"./mk.png": 1050,
	"./pt.png": 1051,
	"./tr.png": 1052,
	"./zh.png": 1053
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1044;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e507e6987de7c6830bb03a3f93e9cc39.png";

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "557b5183c970bab553782fdfc18a6c51.png";

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dca1d04764d25fc2134c3241d6e53cd6.png";

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8275090ee300dca73c63a65231ad2b60.png";

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2141b99db5ff6911b6e6545ef47e3f84.png";

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e070ffafde0d641079574bd23c87d60c.png";

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f96f5c5a0b548a02faf7d47a5609d872.png";

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c81e4da0eaa50a3dfeb75f70761bad8f.png";

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cebb5cb9e6e289cf159c0082f0daa2a6.png";

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b59d01a71e3624b4120d0fdaf56ff969.html";

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _showCloneCode = __webpack_require__(305);

_app.app.component('showCloneCode', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _showCloneCode.Controller,
    templateUrl: __webpack_require__(1057)
});

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6cf7370dd5efb41eafba5ac5be623e23.html";

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ShowCloneCodeModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_title, _saaspassId, _cloneCode) {
        return $uibModal.open({
            component: 'showCloneCode',
            resolve: {
                title: function title() {
                    return _title;
                },
                saaspassId: function saaspassId() {
                    return _saaspassId;
                },
                cloneCode: function cloneCode() {
                    return _cloneCode;
                }
            }
        }).result;
    };
}

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _showNote = __webpack_require__(306);

_app.app.component('showNote', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _showNote.Controller,
    templateUrl: __webpack_require__(1060)
});

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7985432e00b24be9ccd59a1a4afb0aa2.html";

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ShowNoteModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_title, _note) {
        return $uibModal.open({
            component: 'showNote',
            resolve: {
                title: function title() {
                    return _title;
                },
                note: function note() {
                    return _note;
                }
            }
        }).result;
    };
}

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _stExport = __webpack_require__(307);

_app.app.component('stExport', {
    bindings: {
        name: '<',
        fields: '<',
        template: '<'
    },
    controller: _stExport.Controller,
    require: { stTable: '^' },
    templateUrl: __webpack_require__(1063)
});

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "55d596a495f1909d854b39bca97a357c.html";

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spPagination = __webpack_require__(308);

_app.app.component('spPagination', {
    bindings: {
        hasCustomItemsPerPage: '<?'
    },
    controller: _spPagination.Controller,
    require: { stTable: '^' },
    templateUrl: __webpack_require__(1066)
});

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7de79e9d91fc3df58db4d1a9832216b5.html";

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _stSelectAll = __webpack_require__(309);

_app.app.component('stSelectAll', {
    bindings: {
        items: '<',
        itemSelectable: '<'
    },
    controller: _stSelectAll.Controller,
    templateUrl: __webpack_require__(1069)
});

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61129c0edfb26357340629e6105025f2.html";

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

// when we have st-select-row on a table row, clicking the row selects the item bound to that row.
// if we also have a link on a child cell, then both the link and the parent row receives
// the click event. link is activated, but also the checkbox is toggled.
// to avoid this, we extend the `stSelectRow` directive to stop event propagation.

_app.app.directive('stSelectRow', function () {
    return function (scope, element) {
        element.on('click', '[ng-click], [ng-href], [ui-sref], [uib-dropdown]', function (e) {
            return e.stopPropagation();
        });
    };
});

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['stConfig'];


_app.app.config(config);

/** @ngInject */
function config(stConfig) {
    stConfig.pagination.displayedPages = 1;
    stConfig.pagination.template = __webpack_require__(1072);
    stConfig.search.inputEvent = 'input change';
    stConfig.select.selectedClass = 'st-selected active';
    stConfig.select.mode = 'multiple';
}

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "72aa11fcde04c079f59a9ad2e7b3b3b1.html";

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spAccountStatus = __webpack_require__(310);

_app.app.component('spAccountStatus', {
    bindings: {
        accountStatus: '<',
        tooltipPlacement: '@'
    },
    controller: _spAccountStatus.Controller,
    templateUrl: __webpack_require__(1075)
});

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "02bf4507e91c41b71162e9060e92c616.html";

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spAccountType = __webpack_require__(311);

_app.app.component('spAccountType', {
    bindings: {
        accountType: '<',
        tooltipPlacement: '@'
    },
    controller: _spAccountType.Controller,
    templateUrl: __webpack_require__(1077)
});

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85293d118dddcae20562cc6a9cb89642.html";

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spAdditionSource = __webpack_require__(312);

_app.app.component('spAdditionSource', {
    bindings: {
        additionSource: '<',
        tooltipPlacement: '@'
    },
    controller: _spAdditionSource.Controller,
    templateUrl: __webpack_require__(1079)
});

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85293d118dddcae20562cc6a9cb89642.html";

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spAlert = __webpack_require__(313);

/**
 * @example
 * <sp-alert options="$ctrl.spAlert"></sp-alert>
 *
 * @example
 * class Controller {
 *   $onInit() {
 *     this.spAlert = new SpAlert('success', 'global.messages.success')
 *   }
 * }
 */
_app.app.component('spAlert', {
  bindings: { options: '<' },
  controller: _spAlert.Controller,
  templateUrl: __webpack_require__(1081)
});

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3c54f1300981951cbf3aaed4461d075e.html";

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spBack = __webpack_require__(314);

_app.app.component('spBack', {
    bindings: { defaultBack: '<', reloadSimpleBack: '<' },
    controller: _spBack.Controller,
    templateUrl: __webpack_require__(1084)
});

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "91e5a9db570c74085484af45cc769f13.html";

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spCompanyUserLabel = __webpack_require__(315);

_app.app.component('spCompanyUserLabel', {
    bindings: {
        companyUserId: '<',
        displayName: '<',
        saaspassId: '<'
    },
    controller: _spCompanyUserLabel.Controller,
    templateUrl: __webpack_require__(1087)
});

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85312d3fdc6a4066da6a326b7d711eb5.html";

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('spConfirm', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1089)
});

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b7dfd56e5563bb807479481c9340844c.html";

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ConfirmModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _cancelButtonTextKey = _ref.cancelButtonTextKey,
            _confirmButtonTextKey = _ref.confirmButtonTextKey,
            _messageKey = _ref.messageKey,
            _onConfirm = _ref.onConfirm,
            _titleKey = _ref.titleKey;

        return $uibModal.open({
            component: 'spConfirm',
            resolve: {
                cancelButtonTextKey: function cancelButtonTextKey() {
                    return _cancelButtonTextKey;
                },
                confirmButtonTextKey: function confirmButtonTextKey() {
                    return _confirmButtonTextKey;
                },
                messageKey: function messageKey() {
                    return _messageKey;
                },
                onConfirm: function onConfirm() {
                    return _onConfirm;
                },
                titleKey: function titleKey() {
                    return _titleKey;
                }
            }
        }).result;
    };
}

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spDirectoryLabel = __webpack_require__(316);

_app.app.component('spDirectoryLabel', {
    bindings: {
        directoryDto: '<',
        isSideMenu: '<'
    },
    controller: _spDirectoryLabel.Controller,
    templateUrl: __webpack_require__(1092)
});

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba9de1b27d3d25631ad3c37449e0e3d3.html";

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spEditableImage = __webpack_require__(317);

_app.app.component('spEditableImage', {
    bindings: {
        imageMaxSize: '<',
        resettable: '<',
        onSave: '&',
        onReset: '&'
    },
    controller: _spEditableImage.Controller,
    templateUrl: __webpack_require__(1094)
});

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1c006807d9e64349eb1a6e7dd97ad35c.html";

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spEditableLabel = __webpack_require__(318);

_app.app.component('spEditableLabel', {
    bindings: {
        initialValue: '<',
        inputMaxLength: '<',
        inputPattern: '<',
        isOptional: '<',
        onSave: '&'
    },
    controller: _spEditableLabel.Controller,
    templateUrl: __webpack_require__(1096)
});

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e0dd902f9e2418181cb30b106efcbdbd.html";

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spEditablePassword = __webpack_require__(319);

_app.app.component('spEditablePassword', {
    bindings: {
        initialValue: '<',
        isPasswordHidden: '<',
        inputMaxLength: '<',
        adminCantSeePassword: '<',
        inputPattern: '<',
        isOptional: '<',
        isReadOnly: '<',
        generateAvailable: '<',
        onGenerate: '&?',
        onSave: '&',
        patternWarningKey: '<'
    },
    controller: _spEditablePassword.Controller,
    templateUrl: __webpack_require__(1098)
});

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "22f2898028a6e1c7ed2692b9e6ce4eed.html";

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('spFooter', {
    templateUrl: __webpack_require__(1101)
});

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80d0d024fe8378fc8fe55a5efd444b8b.html";

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spGlobalSearch = __webpack_require__(323);

_app.app.component('spGlobalSearch', {
    controller: _spGlobalSearch.Controller,
    templateUrl: __webpack_require__(1104)
});

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a9576c4cce8d3624e19c6c881dfabcaf.html";

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('spGroupLink', {
    bindings: {
        groupId: '<',
        groupName: '<',
        groupType: '<',
        hideIcon: '<',
        tooltipPlacement: '@'
    },
    templateUrl: __webpack_require__(1106)
});

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fad2b5ad209d712c51adfea085fd1dfb.html";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spGroupName = __webpack_require__(324);

_app.app.component('spGroupName', {
    bindings: {
        groupName: '<',
        groupType: '<',
        hideIcon: '<',
        tooltipPlacement: '@'
    },
    controller: _spGroupName.Controller,
    templateUrl: __webpack_require__(1108)
});

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c5b032c1858de85099dd7129a0c35b05.html";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spGroupType = __webpack_require__(325);

_app.app.component('spGroupType', {
    bindings: {
        groupType: '<',
        hideIcon: '<',
        tooltipPlacement: '@'
    },
    controller: _spGroupType.Controller,
    templateUrl: __webpack_require__(1110)
});

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "49620a3f9af1d336719cfa1113db29df.html";

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spBreadcrumbs = __webpack_require__(327);

_app.app.component('spBreadcrumbs', {
    templateUrl: __webpack_require__(1112),
    controller: _spBreadcrumbs.Controller
});

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f2e8e38da1b724d35d59d345d6386b21.html";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

init.$inject = ['$q', '$rootScope', '$state', '$transitions', '$translate'];

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_app.app.run(init);

/** @ngInject */
function init($q, $rootScope, $state, $transitions, $translate) {

    var history = $rootScope.breadcrumbHistory = [];

    var setBreadcrumbs = function setBreadcrumbs() {

        if (!$rootScope.transition) {
            return;
        }

        var promises = $rootScope.transition.treeChanges().to.map(function (_ref) {
            var resolvables = _ref.resolvables,
                state = _ref.state;

            var resolvable = resolvables.find(function (_ref2) {
                var token = _ref2.token;
                return token === '$breadcrumbs';
            });
            var breadcrumbs = (resolvable || {}).data || [{}];
            return breadcrumbs.map(function (breadcrumb) {
                return _extends({}, breadcrumb, { state: state });
            });
        }).reduce(function (a, b) {
            return [].concat(_toConsumableArray(a), _toConsumableArray(b));
        }).map(function (_ref3) {
            var state = _ref3.state,
                stateName = _ref3.stateName,
                stateParams = _ref3.stateParams,
                title = _ref3.title,
                vars = _ref3.vars;

            var href = stateName ? $state.href(stateName, stateParams) : $state.href(state);
            var name = stateName || state.name;
            return $q.resolve(title || $translate(name + '.$title', vars)).then(function (title) {
                return { href: href, name: name, title: title };
            }).catch(function () {
                return {};
            });
        });

        $q.all(promises).then(function (breadcrumbs) {
            return breadcrumbs.filter(function (_ref4) {
                var title = _ref4.title;
                return title;
            });
        }).then(function (breadcrumbs) {
            $rootScope.breadcrumbs = breadcrumbs;

            setTimeout(function () {
                return document.title = breadcrumbs.map(function (b) {
                    return b.title;
                }).reverse().concat('SAASPASS').join(' - ');
            });

            var breadcrumb = breadcrumbs.slice(-1)[0] || {};
            $rootScope.stateTitle = breadcrumb.title;
            history.push(breadcrumb);
            history.length > 100 && history.splice(0, 50);
        });
    };

    $transitions.onSuccess({}, setBreadcrumbs);
    $rootScope.$on('breadcrumb-data-changed', setBreadcrumbs);
    $rootScope.$on('language-loaded', setBreadcrumbs);
}

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('spHeaderSupportLinks', {
    templateUrl: __webpack_require__(1116)
});

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "29a83012b66ae89408f1748b2195056b.html";

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('spHeader', {
    templateUrl: __webpack_require__(1119),
    transclude: true
});

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b2655f81d24064d709b1fb33c9c48520.html";

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('spInfo', {
    transclude: true,
    templateUrl: __webpack_require__(1122)
});

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f81905c9ce4bfaccfd1ca209cc88a5e8.html";

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spLicenseInfo = __webpack_require__(328);

_app.app.component('spLicenseInfo', {
    bindings: {
        licenseInfo: '<'
    },
    controller: _spLicenseInfo.Controller,
    templateUrl: __webpack_require__(1124)
});

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "46acd668b58c71e4de37abdd374b42c6.html";

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('spOk', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1126)
});

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "277225946fea1f1ad4c59cf41e15e5d2.html";

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('OkModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_messageKey, _titleKey, _okButtonTextKey) {
        return $uibModal.open({
            component: 'spOk',
            resolve: {
                messageKey: function messageKey() {
                    return _messageKey;
                },
                titleKey: function titleKey() {
                    return _titleKey;
                },
                okButtonTextKey: function okButtonTextKey() {
                    return _okButtonTextKey;
                }
            }
        }).result;
    };
}

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spRoleType = __webpack_require__(329);

_app.app.component('spRoleType', {
    bindings: {
        roleType: '<',
        hideIcon: '<',
        tooltipPlacement: '@'
    },
    controller: _spRoleType.Controller,
    templateUrl: __webpack_require__(1129)
});

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "53be6cd495217147d9ef8a67e844cb37.html";

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sessionRecordingTypes = exports.sessionRecordingTypes = ['NONE', 'VIDEO', 'TEXT', 'BOTH'];

var sessionRecordingTypeLabel = exports.sessionRecordingTypeLabel = function sessionRecordingTypeLabel(sessionRecordingType) {
    return {
        NONE: 'company.manage-application.configuration.session-recording.recording-type.none',
        VIDEO: 'company.manage-application.configuration.session-recording.recording-type.video',
        TEXT: 'company.manage-application.configuration.session-recording.recording-type.text',
        BOTH: 'company.manage-application.configuration.session-recording.recording-type.both'
    }[loginType];
};

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('spStoreLinks', {
    templateUrl: __webpack_require__(1132)
});

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "67e12d801b84ca2e50e0d4c100bf8c37.html";

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spUserStatus = __webpack_require__(331);

_app.app.component('spUserStatus', {
    bindings: {
        status: '<',
        blockedStatus: '<',
        tooltipPlacement: '@'
    },
    controller: _spUserStatus.Controller,
    templateUrl: __webpack_require__(1134)
});

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "02bf4507e91c41b71162e9060e92c616.html";

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spUserType = __webpack_require__(333);

_app.app.component('spUserType', {
    bindings: {
        userType: '<',
        tooltipPlacement: '@'
    },
    controller: _spUserType.Controller,
    templateUrl: __webpack_require__(1136)
});

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85293d118dddcae20562cc6a9cb89642.html";

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spVerificationSource = __webpack_require__(334);

_app.app.component('spVerificationSource', {
    bindings: {
        verificationSource: '<',
        tooltipPlacement: '@'
    },
    controller: _spVerificationSource.Controller,
    templateUrl: __webpack_require__(1138)
});

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85293d118dddcae20562cc6a9cb89642.html";

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('uploadResultTable', {
    bindings: { importResult: '<' },
    templateUrl: __webpack_require__(1140)
});

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3e640157a50562ea628166183f0fa9e7.html";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

interceptor.$inject = ['TokenService'];
config.$inject = ['$httpProvider'];


_app.app.config(config);

/** @ngInject */
function config($httpProvider) {
    $httpProvider.interceptors.push(interceptor);
}

/** @ngInject */
function interceptor(TokenService) {

    return { request: request };

    function request(config) {
        var token = TokenService.getAccessToken();
        if (token && config.url !== 'oauth/token' && !config.url.startsWith('https://')) {
            config.headers.Authorization = 'Bearer ' + token;
        }

        return config;
    }
}

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

interceptor.$inject = ['$q', 'Alert'];
config.$inject = ['$httpProvider'];


_app.app.config(config);

/** @ngInject */
function config($httpProvider) {
    $httpProvider.interceptors.push(interceptor);
}

/** @ngInject */
function interceptor($q, Alert) {
    var responseError = function responseError(response) {
        var message = (response.data || {}).message;
        var showErrorAlert = !(response.config || {}).skipErrorAlert;
        if (message && showErrorAlert) {
            Alert('danger', message);
        }
        return $q.reject(response);
    };

    return { responseError: responseError };
}

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _constants = __webpack_require__(192);

initLocales.$inject = ['tmhDynamicLocaleCache'];
initTranslate.$inject = ['$rootScope', '$translate', 'tmhDynamicLocale'];
sanitizeCookie.$inject = ['$translate', '$cookies'];
configureLocales.$inject = ['tmhDynamicLocaleProvider'];
configureTranslate.$inject = ['$translateProvider'];


_app.app.config(configureTranslate);
_app.app.config(configureLocales);
_app.app.run(sanitizeCookie);
_app.app.run(initTranslate);
_app.app.run(initLocales);

/** @ngInject */
function configureTranslate($translateProvider) {

    $translateProvider.useStaticFilesLoader({
        prefix: '',
        suffix: '',
        fileMap: {
            de: __webpack_require__(1144),
            en: __webpack_require__(1145),
            es: __webpack_require__(1146),
            fr: __webpack_require__(1147),
            ja: __webpack_require__(1148),
            pt: __webpack_require__(1149),
            zh: __webpack_require__(1150)
        }
    });

    $translateProvider.preferredLanguage('en');
    $translateProvider.useCookieStorage();
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
}

/** @ngInject */
function configureLocales(tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.useCookieStorage('NG_TRANSLATE_LANG_KEY');
}

/** @ngInject */
function sanitizeCookie($translate, $cookies) {
    // this is a workaround to handle a ghost bug. NG_TRANSLATE_LANG_KEY
    // cookie value was corrupt, and i18n/{corruptKey}.json could not be loaded.
    var NG_TRANSLATE_LANG_KEY = $cookies.get('NG_TRANSLATE_LANG_KEY');
    var supportedLangKeys = _constants.languages.map(function (lang) {
        return lang.key;
    });
    if (NG_TRANSLATE_LANG_KEY && !supportedLangKeys.includes(NG_TRANSLATE_LANG_KEY)) {
        $cookies.remove('NG_TRANSLATE_LANG_KEY');
        $translate.use('en');
    }
}

/** @ngInject */
function initTranslate($rootScope, $translate, tmhDynamicLocale) {
    $translate.onReady(languageLoaded);
    $rootScope.$on('$translateChangeSuccess', languageLoaded);

    function languageLoaded() {
        tmhDynamicLocale.set($translate.use());
        $rootScope.$broadcast('language-loaded');
    }
}

/** @ngInject */
function initLocales(tmhDynamicLocaleCache) {

    // Do not change this to a loop!
    // If you do something like require('angular-i18n/' + locale)
    // webpack will pack all locales, because it cannot
    // understand what you want to `require` at compile-time.
    __webpack_require__(335);cache('de');
    __webpack_require__(336);cache('en');
    __webpack_require__(337);cache('es');
    __webpack_require__(338);cache('fr');
    __webpack_require__(339);cache('ja');
    __webpack_require__(340);cache('pt');
    __webpack_require__(341);cache('zh');

    function cache(key) {
        tmhDynamicLocaleCache.put(key, angular.injector(['ngLocale']).get('$locale'));
    }
}

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1073fe3b049addd142de98c9b252751b.json";

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c4ce834716f586177be961c23910be58.json";

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd40fe3a982a8e30a12b21a13a588802.json";

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1b4a52c55f1f8f6ae40fad1ee63d4986.json";

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "68148835ed65465c47c896ea68d0c185.json";

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "502eb5b1872c609c428193574eeb18c2.json";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6e1642c44cc5a708ebaf31f4b69dc0c3.json";

/***/ }),
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$locationProvider'];


_app.app.config(config);

/** @ngInject */
function config($locationProvider) {
    $locationProvider.hashPrefix('');
}

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$httpProvider'];


_app.app.config(config);

/** @ngInject */
function config($httpProvider) {
    $httpProvider.interceptors.push(interceptor);
}

/** @ngInject */
function interceptor() {

    return { request: request };

    function request(config) {
        if (config.data) {
            delete config.data.$promise;
            delete config.data.$resolved;
        }
        return config;
    }
}

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$compileProvider', '$sceDelegateProvider'];


_app.app.config(config);

/** @ngInject */
function config($compileProvider, $sceDelegateProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|saaspass|saaspass-wa|mailto|chrome-extension):/);
    $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|saaspass|file|blob):|data:image\//);
    $sceDelegateProvider.resourceUrlWhitelist(['**']);
}

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
	$stateProvider.states = function (statesArr, obj) {

		for (var i in statesArr) {
			var state = statesArr[i];
			$stateProvider.state(state, angular.copy(obj));
		}

		return $stateProvider;
	};
}

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.directive('autofocus', autofocus);

/** @ngInject */
function autofocus() {
    return {
        restrict: 'A',
        link: function link($scope, $element) {
            return $element[0].focus();
        }
    };
}

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.directive('charSet', directive);

/** @ngInject */
function directive() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: link
    };
}

function link(scope, element, attrs, ngModel) {

    ngModel.$parsers.push(parser);

    function parser(inputValue) {

        if (!attrs.charSet) {
            return inputValue;
        }

        var pattern = new RegExp('[^' + attrs.charSet + ']', 'g');
        var transformedInput = inputValue.replace(pattern, '');

        if (transformedInput !== inputValue) {
            ngModel.$setViewValue(transformedInput);
            ngModel.$render();
        }

        return transformedInput;
    }
}

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.directive('fileInput', fileInput);

/** @ngInject */
function fileInput() {
    return {
        restrict: 'A',
        require: "ngModel",
        link: function link(scope, element, attrs, ngModel) {
            element.bind('change', function (event) {
                var files = event.target.files;
                var file = files[0];
                ngModel.$setViewValue(file);
                scope.$apply();
            });
        }
    };
}

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.directive('preventDefault', preventDefault);

/** @ngInject */
function preventDefault() {
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            $(element).on("click", function (event) {
                event.preventDefault();
            });
        }
    };
}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _googleLibphonenumber = __webpack_require__(194);

var _app = __webpack_require__(0);

var _countries = __webpack_require__(193);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

_app.app.directive('spPhoneNumberInput', spPhoneNumberInput);

/** @ngInject */
function spPhoneNumberInput() {

    var PNU = _googleLibphonenumber.PhoneNumberUtil.getInstance();

    return {
        restrict: 'E',
        scope: { requiredNumber: "=", directiveNumber: "=" },
        templateUrl: __webpack_require__(1167),
        require: 'ngModel',
        link: function link(scope, iElement, iAttrs, ngModelCtrl) {
            scope.allCountries = Object.keys(_countries.countries).map(function (key) {
                return {
                    countryCode: key,
                    countryName: _countries.countries[key]
                };
            });
            scope.onlyNumbers = /^[0-9]+$/;
            scope.countryCode = null;
            scope.number = null;
            var required = true;
            if (angular.isDefined(scope.requiredNumber)) {
                required = scope.requiredNumber;
            }
            ngModelCtrl.$formatters.push(function (modelValue) {
                if (!PNU.isPossibleNumberString(modelValue)) {
                    return {};
                }
                if (!PNU.isValidNumber(PNU.parse(modelValue))) {
                    scope.isInvalidNumber = null;
                    scope.isValidNumber = null;
                    return {
                        countryCode: null,
                        number: null
                    };
                }
                var countryCode = PNU.parse(modelValue).getCountryCode();
                var number = PNU.parse(modelValue).getNationalNumber();
                return {
                    countryCode: '' + countryCode,
                    number: '' + number
                };
            });
            ngModelCtrl.$render = function () {
                scope.countryCode = ngModelCtrl.$viewValue.countryCode;
                scope.number = ngModelCtrl.$viewValue.number;
                var regionCode = PNU.getRegionCodeForCountryCode(scope.countryCode);
                scope.selectedCountry = _countries.countries[regionCode];
            };
            ngModelCtrl.$parsers.push(function (viewValue) {
                if (!viewValue.countryCode || !viewValue.number) {
                    return "";
                }
                return "+" + viewValue.countryCode + viewValue.number;
            });
            scope.$watch('countryCode + number', function () {
                if (scope.countryCode && scope.number) {
                    var number = '+' + scope.countryCode + scope.number;
                    scope.isInvalidNumber = !PNU.isPossibleNumberString(number) || !PNU.isValidNumber(PNU.parse(number));
                    scope.isValidNumber = !scope.isInvalidNumber;
                    if (scope.isValidNumber && scope.number.charAt(0) == '0') {
                        scope.number = scope.number.slice(1);
                    }
                }
                ngModelCtrl.$setViewValue({
                    countryCode: scope.countryCode,
                    number: scope.number
                });
                if (!required && (scope.number == null || scope.number.length == 0)) {
                    ngModelCtrl.$setValidity("err", true);
                } else {
                    ngModelCtrl.$setValidity("err", !!scope.isValidNumber);
                }
            });
            iElement.find('select').on("change", function (event) {
                scope.countryCode = PNU.getCountryCodeForRegion(scope.selectedCountry.countryCode);
                scope.$apply();
            });
            document.getElementById('phoneNumberInput').onkeypress = function (evt) {
                var charCode = evt.charCode;
                if (charCode > 47 && charCode < 58 || charCode == 0) return true;
                return false;
            };
        }
    };
}

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0b14640360d4e2a0e37da5e9b107c02f.html";

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _googleLibphonenumber = __webpack_require__(194);

var _app = __webpack_require__(0);

_app.app.filter('phoneNumber', phoneNumber);

/** @ngInject */
function phoneNumber() {
    var PNU = _googleLibphonenumber.PhoneNumberUtil.getInstance();
    return function (input) {
        if (PNU.isPossibleNumberString(input)) {
            var number = PNU.parse(input);
            return PNU.format(number, _googleLibphonenumber.PhoneNumberFormat.INTERNATIONAL);
        }
    };
}

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['cfpLoadingBarProvider'];


_app.app.config(config);

/** @ngInject */
function config(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.spinnerTemplate = __webpack_require__(1170);
}

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports = "<style>.angular-loading-bar-spinner{position:fixed;top:80px;left:50%;transform:translate(-50%,-50%);z-index:100}</style> <div class=angular-loading-bar-spinner> &nbsp; </div> ";

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$location', '$rootScope', '$state', 'AuthenticationSharedService'];


_app.app.run(config);

/** @ngInject */
function config($location, $rootScope, $state, AuthenticationSharedService) {
    /*
     * saaspassId pattern constant 9 digits and it can be used
     * with adding ng-pattern="saaspassIdPattern"
     */
    $rootScope.saaspassIdPattern = /^\d{9}$/;
    /*
     * pin pattern constant 4 to 8 digits and it can be used
     * with adding ng-pattern="pinPattern"
     */
    $rootScope.pinPattern = /^\d{4,8}$/;

    /*
     * activation code pattern constant 8 digits and it can be
     * used with adding ng-pattern="activationCodePattern"
     */
    $rootScope.activationCodePattern = /^\d{8}$/;

    // copied from emailregex.com
    $rootScope.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    $rootScope.webPattern = /^https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,}$/;

    /*
     * activeDirectory domain pattern and it can be used with
     * adding ng-pattern="activeDirectoryDomainPattern" example:
     * mytest.com
     */
    $rootScope.activeDirectoryDomainPattern = /^[0-9a-zA-Z-.]+$/;

    /*
     * Ip address regex that allows IPv4, IPv6 and IPv4 with
     * mask addresses. Multiple addresses should use semicolon
     * ";" as delimiter
     */
    $rootScope.ipAddressPattern = /^(((([a-f]|[0-9]){1,4})(:(([a-f]|[0-9]){1,4})){7})|((?:(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9])\.){3}(?:(?:2([0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))(\/(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))?))(;(((([a-f]|[0-9]){1,4})(:(([a-f]|[0-9]){1,4})){7})|((?:(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9])\.){3}(?:(?:2([0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))(\/(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))?)))*$/;

    // Call when the the client is confirmed
    $rootScope.$on('event:auth-loginConfirmed', function (data) {
        if ($state.is('public.login')) {
            if ($state.params.redirect) {
                $location.path($state.params.redirect).search('redirect', null).replace();
            } else {
                $state.go('user');
            }
        }
    });

    // Call when the 401 response is returned by the server
    $rootScope.$on('event:auth-loginRequired', function (rejection) {
        AuthenticationSharedService.refresh();
    });
}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

init.$inject = ['$transitions', '$uibModalStack'];


_app.app.run(init);

/** @ngInject */
function init($transitions, $uibModalStack) {
    $transitions.onExit({}, function () {
        while ($uibModalStack.getTop()) {
            $uibModalStack.dismiss($uibModalStack.getTop().key);
        }

        /* todo: delete after all modals are converted to $uibModal */
        $('.sp_modalView').modal('hide');
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    });

    /* todo: delete after all modals are converted to $uibModal */
    $(function () {
        $('body').on('hidden.bs.modal', function () {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        });
    });
}

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularjs = __webpack_require__(259);

var _app = __webpack_require__(0);

var _store = __webpack_require__(19);

init.$inject = ['$state', '$transitions'];


_app.app.run(init);

/** @ngInject */
function init($state, $transitions) {
    $transitions.onError({}, function (transition) {
        var isReloading = $state.current.abstract;
        var resolveFailed = transition.error().type === _angularjs.RejectType.ERROR;
        if (!isReloading || !resolveFailed) return;

        var isCompanyState = transition.to().name.startsWith('company.');
        var isAdmin = !!_store.resolve.currentCompany;

        var state = isCompanyState && isAdmin ? 'company' : 'user';
        $state.go(state, transition.params());
    });
}

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

init.$inject = ['$transitions'];


_app.app.run(init);

/** @ngInject */
function init($transitions) {
    $transitions.onSuccess({}, function () {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    /* todo: delete after all modals are converted to $uibModal */
    $(function () {
        return $('body').on('hide.bs.modal', function () {
            return $('.modal-body').scrollTop(0);
        });
    });
}

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

init.$inject = ['$rootScope', '$transitions'];


_app.app.run(init);

/** @ngInject */
function init($rootScope, $transitions) {
    $transitions.onStart({}, function (transition) {
        return $rootScope.transition = transition;
    });
}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _app = __webpack_require__(0);

var _store = __webpack_require__(19);

var _applicationTypes = __webpack_require__(58);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

modal.$inject = ['$uibModal']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.service('AddApplicationModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (appType) {
        controller.$inject = ['$rootScope', '$scope', '$state', '$uibModalInstance', 'AddNewApplicationResource', 'DomainsService'];

        return $uibModal.open({
            templateUrl: __webpack_require__(1178),
            controller: controller
        }).result;

        /** @ngInject */
        function controller($rootScope, $scope, $state, $uibModalInstance, AddNewApplicationResource, DomainsService) {
            $scope.companyId = _store.resolve.companyId;
            $scope.isRadius = (0, _applicationTypes.isRadius)(appType.slug);
            var is = $scope.is = function () {
                for (var _len = arguments.length, slugs = Array(_len), _key = 0; _key < _len; _key++) {
                    slugs[_key] = arguments[_key];
                }

                return slugs.includes(appType.slug);
            };

            $scope.applicationRequest = {};
            $scope.domainType = '0';
            $scope.tempDomainNames = {
                computerProtectionADDomainName: null,
                computerProtectionLDAPDomainName: null
            };
            $scope.noSelectExistingDirectory = false;
            $scope.selectedCompanyAdDomain = null;
            $scope.selectedAppType = appType;
            $scope.selectedFederatedDomain = null;
            $scope.showStaticPasswordForApp = showStaticPasswordForApp();

            $scope.federated_domains = DomainsService.query({
                companyId: $scope.companyId
            });

            AddNewApplicationResource.getApplicationConfigParameters($scope.companyId, $scope.selectedAppType.id).then(function (data) {
                if (is('computer-login') && (!data.companyAdDomains || !data.companyAdDomains.length)) {
                    $scope.domainType = '1';
                    $scope.noSelectExistingDirectory = true;
                }

                $scope.ssoSupported = data.ssoSupported;
                $scope.ssoEditable = data.ssoEditable;
                $scope.ssoPostUrlEditable = data.ssoPostUrlEditable;

                $scope.applicationRequest = {
                    applicationRunningStatus: false,
                    otp: $scope.selectedAppType.otpSupported,
                    staticPassword: showStaticPasswordForApp(),
                    instantLogin: $scope.selectedAppType.instantLoginSupported,
                    instantRegistration: $scope.selectedAppType.instantRegistrationSupported,
                    blueLoginEnabled: $scope.selectedAppType.bluePassSupported,
                    applicationName: data.applicationDefaultName,
                    applicationType: $scope.selectedAppType.id,
                    mobileApplicationEnabled: false,
                    mobAppSettings: {
                        iosEnabled: true,
                        androidEnabled: true
                    },
                    applicationSecDomain: '',
                    ssoEnabled: $scope.ssoSupported && !$scope.ssoPostUrlEditable,
                    autoAddUser: is('owa'),
                    pushlogin: $scope.selectedAppType.pushLoginSupported,
                    storePasswordOnServer: true,
                    pendingAssignedAccountLoginSetting: 'REJECT',
                    notAssignedAccountLoginSetting: 'REJECT_ALWAYS',
                    notExistAccountLoginSetting: 'REJECT_ALWAYS',
                    computerProtectionDomainIsForLdap: false,
                    computerProtectionDomainName: null,
                    computerProtectionNetbiosName: null,
                    offlineLoginEnabledForUnprotectedAccount: false
                };

                $scope.companyAdDomains = data.companyAdDomains;

                if ($scope.selectedFederatedDomain) {
                    $scope.applicationRequest.domainId = $scope.selectedFederatedDomain.id;
                }

                setAdDomainIfOnlyOne();

                $scope.configDTO = data.configDTO;

                $scope.configValidation = [];
                if ($scope.configDTO && $scope.configDTO.appConfig != null) {
                    angular.forEach($scope.configDTO.appConfig.elements, function (value, key) {
                        if (!value.validations) {
                            $scope.configValidation.push(/.*/);
                        }
                        angular.forEach(value.validations, function (value, key) {
                            if (value.type == "url") {
                                $scope.configValidation.push($rootScope.webPattern);
                            } else if (value.type == "email") {
                                $scope.configValidation.push($rootScope.emailPattern);
                            } else {
                                $scope.configValidation.push(/.*/);
                            }
                        });
                    });
                }
            });

            function showStaticPasswordForApp() {
                return is('custom');
            }

            $scope.save = function () {
                if (is('computer-login', 'computer-protection-without-ad')) {
                    Object.assign($scope.applicationRequest, {
                        remoteLoginEnabled: true,
                        remoteLockEnabled: true,
                        rememberMeEnabled: true,
                        autoLoginEnabled: true,
                        upgradeNotificationEnabled: true
                    });
                }
                var applicationAndConfigDTO = {
                    configDTO: $scope.configDTO,
                    applicationRequest: $scope.applicationRequest
                };

                if (is('office-365') && !$scope.selectedFederatedDomain) {
                    return;
                }

                AddNewApplicationResource.createNonDomainApp($scope.companyId, applicationAndConfigDTO).then(function (app) {
                    return $state.go('company.manage-application', { appId: app.id });
                });
            };

            $scope.ilOrProximityCheck = function () {
                if ($scope.applicationRequest.instantLogin || $scope.applicationRequest.blueLoginEnabled) {
                    $scope.applicationRequest.otp = true;
                }
            };

            $scope.setNewRequestDomainName = function (newValue) {
                $scope.applicationRequest.computerProtectionDomainName = newValue;
            };
            var setAdDomainIfOnlyOne = function setAdDomainIfOnlyOne() {
                if ($scope.companyAdDomains && $scope.companyAdDomains.length == 1) {
                    var domain = $scope.companyAdDomains[0];
                    $scope.selectedCompanyAdDomain = domain;
                    $scope.applicationRequest.activeDirectoryDomainId = domain.id;
                }
            };
            $scope.changeComputerDomainType = function (computerDomainType) {
                $scope.domainType = computerDomainType;
                $scope.applicationRequest.computerProtectionNetbiosName = null;
                $scope.applicationRequest.computerProtectionDomainName = null;
                $scope.tempDomainNames.computerProtectionADDomainName = null;
                if (computerDomainType == '2') {
                    $scope.applicationRequest.computerProtectionDomainIsForLdap = true;
                    $scope.applicationRequest.activeDirectoryDomainId = null;
                    $scope.selectedCompanyAdDomain = null;
                } else {
                    $scope.tempDomainNames.computerProtectionLDAPDomainName = null;
                    $scope.applicationRequest.computerProtectionDomainIsForLdap = false;
                    if (computerDomainType == '1') {
                        $scope.applicationRequest.activeDirectoryDomainId = null;
                        $scope.selectedCompanyAdDomain = null;
                    } else {
                        setAdDomainIfOnlyOne();
                    }
                }
            };

            $scope.selectCompanyAdDomain = function (domain) {
                $scope.selectedCompanyAdDomain = domain;
                $scope.applicationRequest.activeDirectoryDomainId = domain.id;
            };
            $scope.selectFederatedDomain = function (domain) {
                $scope.selectedFederatedDomain = domain;
                $scope.applicationRequest.domainId = domain.id;
            };

            $scope.dismiss = function () {
                return $uibModalInstance.dismiss();
            };

            $scope.addUpdateApplicationModalBodyTemplateUrl = __webpack_require__(1179);
        }
    };
}

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "957e9db34f3514326a8c4674bfd8ea42.html";

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9de79eb975fda0cc8da39ff912ce6485.html";

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('confirmDelete', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1181)
});

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8ed0e58c4d8bf343c8e72233db2de4c9.html";

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ConfirmDeleteModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_messageKey) {
        return $uibModal.open({
            component: 'confirmDelete',
            resolve: { messageKey: function messageKey() {
                    return _messageKey;
                } }
        }).result;
    };
}

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _destructiveOperation = __webpack_require__(343);

_app.app.component('destructiveOperation', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _destructiveOperation.Controller,
    templateUrl: __webpack_require__(1184)
});

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a2849bb962380d1eb8d406f4cea1a5ca.html";

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('DestructiveOperationModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_config) {
        return $uibModal.open({
            component: 'destructiveOperation',
            resolve: { config: function config() {
                    return _config;
                } },
            windowClass: 'destructive-operation'
        }).result;
    };
}

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _app = __webpack_require__(0);

var _spAlert = __webpack_require__(4);

var _yubicoWebauthn = __webpack_require__(72);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

modal.$inject = ['$uibModal']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.factory('HardTokenEditModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (token) {
        controller.$inject = ['$scope', '$window', '$state', '$uibModalInstance', 'Alert', 'DestructiveOperationModal', 'HardTokenService', 'HardTokenResource', 'UsersResource'];


        return $uibModal.open({
            templateUrl: __webpack_require__(1188),
            controller: controller
        }).result.finally(function () {
            /* workaround to overcome incompatibility with non-$uibModal */
            /* todo: delete after all modals are converted to $uibModal */
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        });

        /** @ngInject */
        function controller($scope, $window, $state, $uibModalInstance, Alert, DestructiveOperationModal, HardTokenService, HardTokenResource, UsersResource) {

            restoreToken();

            $scope.cancel = cancel;
            $scope.search = search;
            $scope.assignHardTokenToUser = assignHardTokenToUser;
            $scope.unAssingTokenSecondary = unAssingTokenSecondary;
            $scope.close = close;
            $scope.save = save;
            $scope.disable = disable;
            $scope.enable = enable;
            $scope.showDeleteModal = showDeleteModal;
            $scope.u2fRegistrationStart = u2fRegistrationStart;
            $scope.u2fAuthenticationStart = u2fAuthenticationStart;
            $scope.canRegister = canRegister;
            $scope.searchinput = { text: '' };
            $scope.spAlert = null;
            $scope.selectedCompanyUser = null;
            $scope.isSearching = false;

            function search() {

                $scope.spAlert = null;
                $scope.selectedCompanyUser = null;
                $scope.isSearching = true;
                var companyId = $state.params.companyId;

                UsersResource.getCompanyUserForSaaspassUser(companyId, $scope.searchinput.text).then(function (companyUser) {
                    if (companyUser.saaspassUser.userType !== "SMS_USER") $scope.selectedCompanyUser = companyUser;else $scope.spAlert = new _spAlert.SpAlert('danger', 'hard_tokens.edit.failed_assign', false);
                    // if (companyUser.roleType === "END_USER")
                    //     $scope.spAlert=new SpAlert('danger', 'hard_tokens.edit.failed_save', false);
                    // else
                    //     $scope.selectedCompanyUser = companyUser
                }).catch(function (response) {
                    if (response.status === 404) {
                        $scope.spAlert = new _spAlert.SpAlert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                    }
                }).finally(function () {
                    return $scope.isSearching = false;
                });
            }

            function assignHardTokenToUser() {
                var companyId = $state.params.companyId;
                HardTokenResource.assingTokenAsSecondary(companyId, $scope.selectedCompanyUser.id, $scope.token.id).then(function () {
                    Alert('success', 'company.user-directories.manage-user.device_assigned');
                    $state.go('company.user-directories.manage-user', { companyUserId: $scope.selectedCompanyUser.id });
                });
            }
            function unAssingTokenSecondary(token) {
                var companyId = $state.params.companyId;
                HardTokenResource.unAssingTokenAsSecondary(companyId, token.companyUserId, token.id).then(function (data) {
                    Alert('success', 'company.user-directories.manage-user.device_unassigned');
                    $state.reload($state.current);
                });
            }

            function cancel() {
                restoreToken();
            }

            function initInputs() {
                $scope.edit = {};
                $scope.show = {};
            }

            function replaceToken(value) {
                initInputs();
                angular.copy(value, $scope.token);
                angular.copy(value, token);
            }

            function updateToken(value) {
                initInputs();
                angular.extend($scope.token, value);
                angular.extend(token, value);
            }

            function restoreToken() {
                initInputs();
                $scope.token = angular.copy(token);
            }

            function close() {
                $scope.token.secret = null;
                return $uibModalInstance.dismiss();
            }

            function save() {

                HardTokenService.save($scope.token).then(success).catch(error);

                function success(response) {
                    replaceToken(response);

                    $scope.spAlert = new _spAlert.SpAlert('success', 'hard_tokens.edit.saved_successfully');
                }

                function error() {
                    restoreToken();
                    $scope.spAlert = new _spAlert.SpAlert('danger', 'hard_tokens.edit.failed_save');
                }
            }

            function disable() {

                HardTokenService.disable(token).then(success).catch(error);

                function success() {

                    updateToken({ status: 'INACTIVE' });
                    $state.reload($state.current);
                    $scope.spAlert = new _spAlert.SpAlert('success', 'hard_tokens.edit.disabled_successfully');
                }

                function error() {
                    restoreToken();
                    $scope.spAlert = new _spAlert.SpAlert('danger', 'hard_tokens.edit.failed_to_disable');
                }
            }

            function enable() {

                HardTokenService.enable(token).then(success).catch(error);

                function success() {

                    updateToken({ status: 'ACTIVE' });
                    $state.reload($state.current);
                    $scope.spAlert = new _spAlert.SpAlert('success', 'hard_tokens.edit.enabled_successfully');
                }

                function error() {
                    restoreToken();
                    $scope.spAlert = new _spAlert.SpAlert('danger', 'hard_tokens.edit.failed_to_enable');
                }
            }
            function showDeleteModal() {
                var companyId = $state.params.companyId;
                var url = 'app/rest/admin/company/' + companyId + '/hardtoken/' + token.id;
                DestructiveOperationModal({
                    titleKey: 'hard_tokens.management.delete',
                    textKey: $scope.token.isSecondaryDeviceOfUser ? 'hard_tokens.management.info_secondarydevice' : 'hard_tokens.management.info',
                    http: { method: 'DELETE', url: url }
                }).then(function () {
                    return successfulDelete();
                });
            }
            function successfulDelete() {
                close();
                $state.go('company.hard-token-management', {}, { reload: true });
                Alert('success', 'hard_tokens.management.delete.success');
            }

            function canRegister() {
                return token.otpType == 'U2F' && $scope.token.otpType == 'U2F';
            }

            function u2fRegistrationStart(reset) {
                if (reset) {
                    HardTokenService.u2fResetRegistrationStart(token).then(success).catch(error);
                } else {
                    HardTokenService.u2fRegistrationStart(token).then(success).catch(error);
                }

                function success(response) {
                    var credOpts = (0, _yubicoWebauthn.convertStartRegResponse)(response);
                    $window.navigator.credentials.create(credOpts).then(function (credentials) {
                        var finishRegRequest = (0, _yubicoWebauthn.convertFinishRegRequest)(credentials, response);
                        u2fRegistrationFinish(finishRegRequest);
                    }).catch(function (error) {
                        return console.log(error);
                    });
                }

                function error() {
                    $scope.spAlert = new _spAlert.SpAlert('danger', 'hard_tokens.edit.U2F_failed');
                }
            }

            function u2fRegistrationFinish(data) {

                HardTokenService.u2fRegistrationFinish(token, data).then(success).catch(error);

                function success(response) {

                    replaceToken(response.hardToken);

                    var key = 'hard_tokens.edit.U2F_registration_successfully';
                    $scope.spAlert = new _spAlert.SpAlert('success', key);
                }

                function error() {
                    $scope.spAlert = new _spAlert.SpAlert('danger', 'hard_tokens.edit.U2F_failed');
                }
            }

            function u2fAuthenticationStart() {

                HardTokenService.u2fAuthenticationStart(token).then(success).catch(error);

                function success(response) {

                    //$scope.spAlert = new SpAlert('success', 'hard_tokens.edit.U2F_test');
                    var credOpts = (0, _yubicoWebauthn.convertStartAuthResponse)(response);
                    $window.navigator.credentials.get(credOpts).then(function (credentials) {
                        var finishRegRequest = (0, _yubicoWebauthn.convertFinishAuthRequest)(credentials, response);
                        u2fAuthenticationFinish(finishRegRequest);
                    });
                    /*  u2f.sign(response.authenticateRequests, data => {
                           if (!data.errorCode) {
                              u2fAuthenticationFinish(data);
                              return;
                          }
                           const key = 'hard_tokens.edit.authentication_test_fail_error';
                          const variables = {errorCode: data.errorCode};
                          $scope.spAlert = new SpAlert('danger', key, variables);
                      });*/
                }

                function error() {
                    var key = 'hard_tokens.edit.authentication_test_failed';
                    $scope.spAlert = new _spAlert.SpAlert('danger', key);
                }
            }

            function u2fAuthenticationFinish(authdata) {

                HardTokenService.u2fAuthenticationFinish(token, authdata).then(success).catch(error);

                function success() {
                    var key = 'hard_tokens.edit.authentication_test_successfully';
                    $scope.spAlert = new _spAlert.SpAlert('success', key);
                }

                function error() {
                    var key = 'hard_tokens.edit.authentication_test_failed';
                    $scope.spAlert = new _spAlert.SpAlert('danger', key);
                }
            }
        }
    };
}

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "92b664a55d0eb131f6ee348b56fa1151.html";

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smartTable = __webpack_require__(2);

var _spAlert = __webpack_require__(4);

var _store = __webpack_require__(19);

modal.$inject = ['$uibModal']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.factory('SharedEmailAccountModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (username, companyUserId) {
        userAccounts.$inject = ['UserAccounts'];
        controller.$inject = ['$rootScope', '$scope', '$state', '$translate', '$uibModalInstance', 'Alert', 'CompanyUser', 'ConfirmDeleteModal', 'UserAccounts', 'userAccounts'];


        return $uibModal.open({
            templateUrl: __webpack_require__(1190),
            controller: controller,
            resolve: {
                userAccounts: userAccounts
            }
        }).result;

        /** @ngInject */
        function controller($rootScope, $scope, $state, $translate, $uibModalInstance, Alert, CompanyUser, ConfirmDeleteModal, UserAccounts, userAccounts) {
            $scope.st = new _smartTable.SmartTable();
            $scope.cancel = function () {
                return $uibModalInstance.dismiss();
            };
            $scope.step = "step1";
            $scope.username = username;
            $scope.companyUserId = companyUserId;
            var companyId = $state.params.companyId;

            $scope.isSendingRequest = false;

            function reload() {
                $scope.userAccounts = UserAccounts.getSharedEmailAccountsByUsername({
                    companyId: companyId,
                    username: username
                }, function () {
                    if ($scope.userAccounts.length == 0) {
                        $uibModalInstance.close();
                    }
                });
            }

            $scope.cancleSearch = function () {
                $scope.userIdentifier = null;
                $scope.successResult = null;
                $scope.showVerification = false;
                $scope.companyUser = null;
                $scope.message = null;
                $scope.newUserIdentifier = null;
            };

            $scope.unshare = function (account) {
                ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete').then(function () {
                    return $scope.deleteConfirmed(account);
                });
            };

            $scope.deleteConfirmed = function (account) {

                var param = {
                    companyId: companyId,
                    id: account.id
                };

                UserAccounts.deleteUserAccount(param, {}, function (success) {
                    var key = 'groups_users.user_delete_success';
                    $scope.globalTopLevelMessage = new _spAlert.SpAlert('success', key);
                    reload();
                }, function (error) {
                    $scope.globalTopLevelMessage = new _spAlert.SpAlert('danger', error.data.message);
                });
            };

            $scope.share = function (saaspassId) {
                if ($scope.isSendingRequest) {
                    return;
                }
                $scope.isSendingRequest = true;

                var param = {
                    companyId: companyId
                };
                var dataReq = {
                    username: username,
                    companyUser: $scope.companyUser
                };

                UserAccounts.createSharedUserAccount(param, dataReq, function (data) {
                    $scope.groupsOfUser = UserAccounts.getGroupsOfAccount({
                        companyId: companyId,
                        id: data.id
                    });
                    $scope.userAccount = data;
                    $scope.username = data.username;
                    $scope.newAccount = data;
                    var key = 'groups_users.added_active_account_SHARED_EMAIL';
                    var variables = { saaspassId: saaspassId };
                    Alert('success', key, variables);
                    $uibModalInstance.close();
                }, function (error) {

                    $scope.globalTopLevelMessage = new _spAlert.SpAlert('danger', error.data.message);
                });
            };

            $scope.identifyUser = function () {
                $scope.message = null;
                $scope.userIdentifier = $scope.newUserIdentifier;

                if ($scope.userIdentifier == $scope.currentSaaspassId) {
                    $scope.successResult = false;
                    $scope.showVerification = false;

                    $scope.message = 'groups_users.user_is_the_same';
                } else if ($scope.userIdentifier == $scope.currentEmailAddress) {
                    $scope.successResult = false;
                    $scope.showVerification = false;

                    $scope.message = 'groups_users.user_email_is_the_same';
                } else {
                    CompanyUser.identifyCompanyUser({
                        companyId: companyId,
                        uid: encodeURIComponent($scope.userIdentifier)
                    }, function (data) {
                        if (data.id && data.id == $scope.currentCompanyUserId || data.saaspassUser && data.saaspassUser.id == $scope.currentSaaspassId) {
                            $scope.successResult = false;
                            $scope.showVerification = false;

                            $scope.message = 'groups_users.user_is_the_same';
                        } else {
                            $scope.successResult = true;
                            $scope.showVerification = false;
                            $scope.companyUser = data;

                            $scope.message = 'groups_users.user_found';
                        }
                    }, function (response) {
                        $scope.successResult = false;
                        $scope.companyUser = null;

                        $scope.showVerification = $scope.enableVerification && !$scope.successResult && $rootScope.emailPattern.test($scope.userIdentifier);

                        if (response.status == 404) {
                            $scope.message = 'groups_users.user_not_found';
                        } else {
                            $scope.message = response.data.message;
                        }
                    });
                }
            };
            $scope.cancleSearch();
            $scope.userAccounts = userAccounts;
        }

        /** @ngInject */
        function userAccounts(UserAccounts) {
            var companyId = _store.resolve.companyId;
            return UserAccounts.getSharedEmailAccountsByUsername({ companyId: companyId, username: username }).$promise;
        }
    };
}

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "72145ef98919a3d397f54d1dbb57c5ab.html";

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

init.$inject = ['$rootScope'];


_app.app.run(init);

/** @ngInject */
function init($rootScope) {
    $rootScope.pushLoginButtonPopoverTemplate = __webpack_require__(1192);
}

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "89a16a414d3885793753b4ba307e2704.html";

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

init.$inject = ['$rootScope'];


_app.app.run(init);

/** @ngInject */
function init($rootScope) {
    $rootScope.saaspassFullExperienceTemplate = __webpack_require__(1194);
}

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4d3d4c416e72c5ea7a11874444ef9983.html";

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApplicationAccountsResource = function () {
    ApplicationAccountsResource.$inject = ['$http'];

    /** @ngInject */
    function ApplicationAccountsResource($http) {
        _classCallCheck(this, ApplicationAccountsResource);

        this.$http = $http;
    }

    _createClass(ApplicationAccountsResource, [{
        key: 'setPasswordForAppAccount',
        value: function setPasswordForAppAccount(companyId, appId, accId, password) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + appId + '/' + accId + '/setpassword';
            var params = { password: password };
            return this.$http.post(url, null, { params: params }).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getPasswordForAppAccount',
        value: function getPasswordForAppAccount(companyId, appId, accId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + appId + '/' + accId + '/getpassword';
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'generatePasswordForAppAccount',
        value: function generatePasswordForAppAccount(companyId, appId, accId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + appId + '/' + accId + '/generatepassword';
            return this.$http.get(url, { transformResponse: transformResponse }).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });

            // fixme: this is a workaround. response body should contain valid json.
            function transformResponse(data) {
                try {
                    // response.data.message is available when the request fails
                    return JSON.parse(data);
                } catch (e) {
                    // success response is a bare string which cannot be parsed as json
                    return data;
                }
            }
        }
    }, {
        key: 'setPasswordResetEmailForAppAccount',
        value: function setPasswordResetEmailForAppAccount(companyId, appId, accId, email) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + appId + '/' + accId + '/updatepwdresetemail';
            var params = { email: email };
            return this.$http.post(url, null, { params: params }).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'sendPasswordResetEmailForAppAccount',
        value: function sendPasswordResetEmailForAppAccount(companyId, appId, accId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + appId + '/' + accId + '/sendpwdresetemail';
            return this.$http.get(url).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }]);

    return ApplicationAccountsResource;
}();

_app.app.service('ApplicationAccountsResource', ApplicationAccountsResource);

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthenticationAccessPolicyResource = function () {
    AuthenticationAccessPolicyResource.$inject = ['$http'];

    /** @ngInject */
    function AuthenticationAccessPolicyResource($http) {
        _classCallCheck(this, AuthenticationAccessPolicyResource);

        this.$http = $http;
    }

    _createClass(AuthenticationAccessPolicyResource, [{
        key: 'getAuthenticationAccessPolicyList',
        value: function getAuthenticationAccessPolicyList(companyId, info) {
            var url = 'app/rest/company/' + companyId + '/policies/accesspolicies?info=' + info;
            return this.$http.get(url).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'createAuthenticationAccessPolicy',
        value: function createAuthenticationAccessPolicy(companyId) {
            var url = 'app/rest/company/' + companyId + '/policies/accesspolicies';
            return this.$http.post(url).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'updateAuthenticationAccessPolicy',
        value: function updateAuthenticationAccessPolicy(companyId, policy) {
            var url = 'app/rest/company/' + companyId + '/policies/accesspolicies/' + policy.id;
            return this.$http.put(url, policy).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'deleteAuthenticationAccessPolicy',
        value: function deleteAuthenticationAccessPolicy(companyId, policyId) {
            var url = 'app/rest/company/' + companyId + '/policies/accesspolicies/' + policyId;
            return this.$http.delete(url).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'reset',
        value: function reset(companyId, policyId) {
            var url = 'app/rest/company/' + companyId + '/policies/accesspolicies/' + policyId;
            var params = { action: 'reset' };
            return this.$http.put(url, null, { params: params }).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'applyPolicy',
        value: function applyPolicy(companyId, policyId, appId) {
            var url = 'app/rest/company/' + companyId + '/policies/accesspolicies/' + policyId + '/' + appId;
            return this.$http.put(url).then(function (response) {
                return response.data;
            });
        }
    }]);

    return AuthenticationAccessPolicyResource;
}();

_app.app.service('AuthenticationAccessPolicyResource', AuthenticationAccessPolicyResource);

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EpmAccountResource = function () {
    EpmAccountResource.$inject = ['$http'];

    /** @ngInject */
    function EpmAccountResource($http) {
        _classCallCheck(this, EpmAccountResource);

        this.$http = $http;
    }

    _createClass(EpmAccountResource, [{
        key: 'getEpmSsoInstructions',
        value: function getEpmSsoInstructions(applicationId, accountId) {
            var url = 'app/rest/epm/account/sso-instructions/' + applicationId + '/' + accountId;
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getEpmTracker',
        value: function getEpmTracker(applicationId, accountId) {
            var url = 'app/rest/epm/account/tracker/' + applicationId + '/' + accountId;
            return this.$http.get(url, { transformResponse: transformResponse }).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });

            // fixme: this is a workaround. response body should contain valid json.
            function transformResponse(data) {
                try {
                    // response.data.message is available when the request fails
                    return JSON.parse(data);
                } catch (e) {
                    // success response is a bare string which cannot be parsed as json
                    return data;
                }
            }
        }
    }]);

    return EpmAccountResource;
}();

_app.app.service('EpmAccountResource', EpmAccountResource);

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FederateSsoResource = function () {
    FederateSsoResource.$inject = ['$http'];

    /** @ngInject */
    function FederateSsoResource($http) {
        _classCallCheck(this, FederateSsoResource);

        this.$http = $http;
    }

    _createClass(FederateSsoResource, [{
        key: 'federateSso',
        value: function federateSso(companyId, appId, credentials) {
            var url = 'app/rest/admin/company/' + companyId + '/application/' + appId + '/manageapp/federatesso';
            return this.$http.post(url, credentials).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }]);

    return FederateSsoResource;
}();

_app.app.service('FederateSsoResource', FederateSsoResource);

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

var _account = __webpack_require__(48);

var _group = __webpack_require__(84);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GroupsResource = function () {
    GroupsResource.$inject = ['$http'];

    /** @ngInject */
    function GroupsResource($http) {
        _classCallCheck(this, GroupsResource);

        this.$http = $http;
    }

    _createClass(GroupsResource, [{
        key: 'getAllCustomAndApplication',
        value: function getAllCustomAndApplication(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getAllCompanyGroups',
        value: function getAllCompanyGroups(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups';
            var params = { type: 'company' };
            return this.$http.get(url, { params: params }).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'getGroupById',
        value: function getGroupById(companyId, groupId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId;
            return this.$http.get(url).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            }).then(_group.groupFromDto);
        }
    }, {
        key: 'createNewCustomGroup',
        value: function createNewCustomGroup(companyId, name) {
            var url = 'app/rest/v2/company/' + companyId + '/groups';
            var params = { name: name };
            return this.$http.post(url, null, { params: params }).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'deleteGroups',
        value: function deleteGroups(companyId, groupIds) {
            return this.$http({
                method: 'DELETE',
                url: 'app/rest/v2/company/' + companyId + '/groups',
                data: groupIds,
                headers: { 'Content-Type': 'application/json' }
            }).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'renameGroup',
        value: function renameGroup(companyId, groupId, groupName) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/rename';
            return this.$http.put(url, { groupName: groupName }).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'getAllAccountsForCompanyAndEveryoneGroup',
        value: function getAllAccountsForCompanyAndEveryoneGroup(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/everyone/accounts';
            return this.$http.get(url).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            }).then(function (accounts) {
                return accounts.map(_account.accountFromDto);
            });
        }
    }, {
        key: 'getAllAccountsForCompanyAndEveryoneGroupWithPagination',
        value: function getAllAccountsForCompanyAndEveryoneGroupWithPagination(companyId, page, itemPerPage, searchText, sort, reverse) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/everyone/accounts/pagination';
            return this.$http.post(url, { page: page, itemPerPage: itemPerPage, searchText: searchText, sort: sort, reverse: reverse }).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            });
        }
    }, {
        key: 'getAllAccountsForCompanyAndGroup',
        value: function getAllAccountsForCompanyAndGroup(companyId, groupId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/accounts';
            return this.$http.get(url).then(function (_ref9) {
                var data = _ref9.data;
                return data;
            }).then(function (accounts) {
                return accounts.map(_account.accountFromDto);
            });
        }
    }, {
        key: 'getAllAccountsForCompanyAndGroupWithPagination',
        value: function getAllAccountsForCompanyAndGroupWithPagination(companyId, groupId, page, itemPerPage, searchText, sort, reverse) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/accounts/pagination';
            return this.$http.post(url, { page: page, itemPerPage: itemPerPage, searchText: searchText, sort: sort, reverse: reverse }).then(function (_ref10) {
                var data = _ref10.data;
                return data;
            });
        }
    }, {
        key: 'getAllAccountsInCompanyAndNotInGroupWithPagination',
        value: function getAllAccountsInCompanyAndNotInGroupWithPagination(companyId, groupId, page, itemPerPage, searchText, sort, reverse) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/accounts/excluded/pagination';
            return this.$http.post(url, { page: page, itemPerPage: itemPerPage, searchText: searchText, sort: sort, reverse: reverse }).then(function (_ref11) {
                var data = _ref11.data;
                return data;
            });
        }
    }, {
        key: 'getAllAccountsForCompanyAndGroupAndApplication',
        value: function getAllAccountsForCompanyAndGroupAndApplication(companyId, groupId, appId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/' + appId + '/accounts';
            return this.$http.get(url).then(function (_ref12) {
                var data = _ref12.data;
                return data;
            });
        }
    }, {
        key: 'addNewUserToGroup',
        value: function addNewUserToGroup(companyId, groupId, username) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/accounts';
            return this.$http.post(url, null, { params: { username: username } }).then(function (_ref13) {
                var data = _ref13.data;
                return data;
            });
        }
    }, {
        key: 'getAssignedApplicationsOfGroup',
        value: function getAssignedApplicationsOfGroup(companyId, groupId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/applications';
            return this.$http.get(url, { params: { type: 'assigned' } }).then(function (_ref14) {
                var data = _ref14.data;
                return data;
            });
        }
    }, {
        key: 'getAssignableApplicationsForGroup',
        value: function getAssignableApplicationsForGroup(companyId, groupId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/applications';
            return this.$http.get(url, { params: { type: 'unassigned' } }).then(function (_ref15) {
                var data = _ref15.data;
                return data;
            });
        }
    }, {
        key: 'unassignGroupFromApplications',
        value: function unassignGroupFromApplications(companyId, groupId, applicationIds) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/applications';
            var params = { action: 'unassign' };
            return this.$http.post(url, applicationIds, { params: params }).then(function (_ref16) {
                var data = _ref16.data;
                return data;
            });
        }
    }, {
        key: 'assignGroupToApplication',
        value: function assignGroupToApplication(companyId, groupId, applicationIds) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/applications';
            var params = { action: 'assign' };
            var data = applicationIds.map(function (applicationId) {
                return { applicationId: applicationId };
            });
            return this.$http.post(url, data, { params: params }).then(function (_ref17) {
                var data = _ref17.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationGroupAccountCredentials',
        value: function getApplicationGroupAccountCredentials(companyId, groupId, appId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/' + appId + '/accountcredentials';
            return this.$http.get(url).then(function (_ref18) {
                var data = _ref18.data;
                return data;
            });
        }
    }, {
        key: 'getCustomAttributes',
        value: function getCustomAttributes(companyId, groupId) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/customattributes';
            return this.$http.get(url).then(function (_ref19) {
                var data = _ref19.data;
                return data;
            });
        }
    }, {
        key: 'updateCustomAttributes',
        value: function updateCustomAttributes(companyId, groupId, attribs) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId + '/customattributes/update';
            return this.$http.put(url, attribs).then(function (_ref20) {
                var data = _ref20.data;
                return data;
            });
        }
    }, {
        key: 'userVerification',
        value: function userVerification(companyId, groupId, verificationtypes, verificationparameter, file) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + groupId;
            var formData = new FormData();
            formData.append('file', file);
            var params = { type: 'userverification', verificationtypes: verificationtypes, verificationparameter: verificationparameter };
            var headers = { 'Content-Type': undefined };
            return this.$http.post(url, formData, { params: params, headers: headers }).then(function (_ref21) {
                var data = _ref21.data;
                return data;
            });
        }
    }, {
        key: 'resendVerifications',
        value: function resendVerifications(companyId, group) {
            var url = 'app/rest/v2/company/' + companyId + '/groups/' + group.id + '/sendverifications';
            return this.$http.get(url).then(function (_ref22) {
                var data = _ref22.data;
                return data;
            });
        }
    }]);

    return GroupsResource;
}();

_app.app.service('GroupsResource', GroupsResource);

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HardTokenResource = function () {
    HardTokenResource.$inject = ['$http'];

    /** @ngInject */
    function HardTokenResource($http) {
        _classCallCheck(this, HardTokenResource);

        this.$http = $http;
    }

    _createClass(HardTokenResource, [{
        key: 'u2fLoginStart',
        value: function u2fLoginStart(username) {
            var url = 'app/rest/hardtoken/u2floginstart';
            return this.$http.post(url, { username: username }, { skipErrorAlert: true }).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'assingTokenAsSecondary',
        value: function assingTokenAsSecondary(companyId, companyUserId, hardTokenId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/hardToken/' + hardTokenId + '?action=assign';
            return this.$http.post(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'unAssingTokenAsSecondary',
        value: function unAssingTokenAsSecondary(companyId, companyUserId, hardTokenId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/hardToken/' + hardTokenId + '?action=unassign';
            return this.$http.post(url).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }]);

    return HardTokenResource;
}();

_app.app.service('HardTokenResource', HardTokenResource);

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PublicServiceResource = function () {
    PublicServiceResource.$inject = ['$http'];

    /** @ngInject */
    function PublicServiceResource($http) {
        _classCallCheck(this, PublicServiceResource);

        this.$http = $http;
    }

    _createClass(PublicServiceResource, [{
        key: 'getAllWithEpmSupportFiltered',
        value: function getAllWithEpmSupportFiltered() {
            var url = 'app/rest/public_services/epmsupported';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }]);

    return PublicServiceResource;
}();

_app.app.service('PublicServiceResource', PublicServiceResource);

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResellerCompanyResource = function () {
    ResellerCompanyResource.$inject = ['$http'];

    /** @ngInject */
    function ResellerCompanyResource($http) {
        _classCallCheck(this, ResellerCompanyResource);

        this.$http = $http;
    }

    _createClass(ResellerCompanyResource, [{
        key: 'manageAnotherCompany',
        value: function manageAnotherCompany(companyId, companyName, domainName) {
            var url = 'app/rest/reseller/' + companyId + '/company';
            return this.$http.post(url, { companyName: companyName, domainName: domainName }, {}).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getCompanies',
        value: function getCompanies(companyId) {
            var url = 'app/rest/reseller/' + companyId + '/companies';
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'addAdministrators',
        value: function addAdministrators(resellerCompanyId, companyId, administrators) {
            var url = 'app/rest/reseller/' + resellerCompanyId + '/company/' + companyId + '/administrators';
            return this.$http.post(url, administrators, {}).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'getCompanyDetail',
        value: function getCompanyDetail(resellerCompanyId, companyId) {
            var url = 'app/rest/reseller/' + resellerCompanyId + '/company/' + companyId;
            return this.$http.get(url).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }]);

    return ResellerCompanyResource;
}();

_app.app.service('ResellerCompanyResource', ResellerCompanyResource);

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoleResource = function () {
    RoleResource.$inject = ['$http'];

    /** @ngInject */
    function RoleResource($http) {
        _classCallCheck(this, RoleResource);

        this.$http = $http;
    }

    _createClass(RoleResource, [{
        key: 'getAllCompanyUsersByRole',
        value: function getAllCompanyUsersByRole(companyId, role) {
            var url = 'app/rest/v2/company/' + companyId + '/roles/' + role;
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getAllCompanyUsersWithRole',
        value: function getAllCompanyUsersWithRole(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/roles';
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            }).then(function (users) {
                return users.map(sanitize);
            });

            function sanitize(user) {
                return _extends({}, user, {
                    applicationIds: user.applicationIds || [],
                    applicationTypeIds: user.applicationTypeIds || [],
                    groupIds: user.groupIds || []
                });
            }
        }
    }, {
        key: 'addNewRole',
        value: function addNewRole(companyId, companyUserDTO) {
            var url = 'app/rest/v2/company/' + companyId + '/roles';
            return this.$http.post(url, companyUserDTO).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'removeRoleInCompany',
        value: function removeRoleInCompany(companyId, companyUserId, params) {
            var url = 'app/rest/v2/company/' + companyId + '/roles/' + companyUserId;
            return this.$http.delete(url, { params: params }).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'unblockUserInCompany',
        value: function unblockUserInCompany(companyId, companyUserId, params) {
            var url = 'app/rest/v2/company/' + companyId + '/roles/' + companyUserId;
            return this.$http.post(url, null, { params: params }).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationsAndTypes',
        value: function getApplicationsAndTypes(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/roles';
            var params = { role: 'application', type: 'data' };
            return this.$http.get(url, { params: params }).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'editApplicationAdminRole',
        value: function editApplicationAdminRole(companyId, companyUserDTO) {
            var url = 'app/rest/v2/company/' + companyId + '/roles';
            var params = { role: 'application', action: 'edit' };
            return this.$http.put(url, companyUserDTO, { params: params }).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }, {
        key: 'editOrganizationAdminRole',
        value: function editOrganizationAdminRole(companyId, companyUserDTO) {
            var url = 'app/rest/v2/company/' + companyId + '/roles';
            var params = { role: 'organization', action: 'edit' };
            return this.$http.put(url, companyUserDTO, { params: params }).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            });
        }
    }]);

    return RoleResource;
}();

_app.app.service('RoleResource', RoleResource);

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimulatorResource = function () {
    SimulatorResource.$inject = ['$http'];

    /** @ngInject */
    function SimulatorResource($http) {
        _classCallCheck(this, SimulatorResource);

        this.$http = $http;
    }

    _createClass(SimulatorResource, [{
        key: 'simulateManualLogin',
        value: function simulateManualLogin(companyId, appId, username, otp) {
            var url = 'app/rest/admin/company/' + companyId + '/application/' + appId + '/manageapp/simulator/manual';
            var params = { username: username, otp: otp };
            return this.$http.get(url, { params: params }).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }]);

    return SimulatorResource;
}();

_app.app.service('SimulatorResource', SimulatorResource);

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StatisticsResource = function () {
    StatisticsResource.$inject = ['$http'];

    /** @ngInject */
    function StatisticsResource($http) {
        _classCallCheck(this, StatisticsResource);

        this.$http = $http;
    }

    _createClass(StatisticsResource, [{
        key: 'getUserOtpStatistics',
        value: function getUserOtpStatistics() {
            var url = 'app/rest/statistics';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getCompanyAdminAudits',
        value: function getCompanyAdminAudits(companyId, role) {
            var url = 'app/rest/company/' + companyId + '/statistics/role/' + role;
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }]);

    return StatisticsResource;
}();

_app.app.service('StatisticsResource', StatisticsResource);

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

Account.$inject = ['$http', '$rootScope'];


_app.app.factory('Account', Account);

/** @ngInject */
function Account($http, $rootScope) {

    var promise = void 0;

    return {
        get: get,
        reload: reload
    };

    function get() {
        return promise || reload();
    }

    function reload() {
        promise = $http.get('app/rest/account').then(function (response) {
            return response.data;
        }).then(initialize);

        return promise;
    }

    function initialize(account) {
        $rootScope.sessionExpired = false;
        return $rootScope.account = account;
    }
}

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddNewApplicationResource = function () {
    AddNewApplicationResource.$inject = ['$http'];

    /** @ngInject */
    function AddNewApplicationResource($http) {
        _classCallCheck(this, AddNewApplicationResource);

        this.$http = $http;
    }

    _createClass(AddNewApplicationResource, [{
        key: 'getAllApplicationsTypes',
        value: function getAllApplicationsTypes(companyId) {
            var url = 'app/rest/admin/company/' + companyId + '/applications/types';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationsType',
        value: function getApplicationsType(companyId, appTypeId) {
            var url = 'app/rest/admin/company/' + companyId + '/applications/types/' + appTypeId;
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationConfigParameters',
        value: function getApplicationConfigParameters(companyId, appTypeId) {
            var url = 'app/rest/admin/company/' + companyId + '/applications/types/' + appTypeId;
            var params = { action: 'config' };
            return this.$http.get(url, { params: params }).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'createNonDomainApp',
        value: function createNonDomainApp(companyId, applicationAndConfigDto) {
            var appTypeId = applicationAndConfigDto.applicationRequest.applicationType;
            var url = 'app/rest/admin/company/' + companyId + '/applications/types/' + appTypeId;
            return this.$http.post(url, applicationAndConfigDto).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'createSecureApp',
        value: function createSecureApp(companyId, appTypeId) {
            var url = 'app/rest/admin/company/' + companyId + '/applications/types/' + appTypeId;
            var params = { action: 'create' };
            return this.$http.post(url, null, { params: params }).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'getAllApplicationInfoWithoutParameters',
        value: function getAllApplicationInfoWithoutParameters(companyId, appTypeId) {
            var url = 'app/rest/admin/company/' + companyId + '/applications/types/' + appTypeId;
            var params = { action: 'info' };
            return this.$http.get(url, { params: params }).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationPermissionsInCompany',
        value: function getApplicationPermissionsInCompany(companyId) {
            var url = 'app/rest/admin/company/' + companyId + '/applications/types/app-permissions';
            return this.$http.get(url).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }]);

    return AddNewApplicationResource;
}();

_app.app.service('AddNewApplicationResource', AddNewApplicationResource);

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spAlert = __webpack_require__(4);

Alert.$inject = ['$rootScope'];


_app.app.service('Alert', Alert);

/** @ngInject */
function Alert($rootScope) {
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return $rootScope.globalTopLevelMessage = new (Function.prototype.bind.apply(_spAlert.SpAlert, [null].concat(args)))();
    };
}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _sessionId = __webpack_require__(22);

var _app = __webpack_require__(0);

var _spAlert = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

AuthenticationSharedService.$inject = ['$http', '$location', '$q', '$rootScope', '$state', '$window', 'Account', 'authService', 'TokenService', 'WebSocket'];


_app.app.factory('AuthenticationSharedService', AuthenticationSharedService);

/** @ngInject */
function AuthenticationSharedService($http, $location, $q, $rootScope, $state, $window, Account, authService, TokenService, WebSocket) {
    var gmpLoginSession = false;

    var setInvalidAttempts = function setInvalidAttempts(data) {
        if (data.error_description && data.error_description.indexOf('numberOfAttempts') > -1) {
            var numberOfAttempts = +data.error_description.split('=')[1];
            localStorage.setItem('loginAttempts', numberOfAttempts);
        } else {
            var loginAttempts = +localStorage.getItem('loginAttempts') || 0;
            localStorage.setItem('loginAttempts', loginAttempts + 1);
        }
    };
    return {

        sendPushLoginNotification: function sendPushLoginNotification(captchaResponse, username, oauthClientId, appKey, saaspassId) {

            WebSocket.connect();

            var loginAttempts = +localStorage.getItem('loginAttempts') || 0;
            localStorage.setItem('loginAttempts', loginAttempts + 1);

            $rootScope.authenticationError = false;
            $rootScope.captchaError = false;

            var deferred = $q.defer();

            $http.get('app/rest/pushlogin/saaspass', { params: {
                    username: username,
                    sessionid: _sessionId.SESSION_ID,
                    appKey: appKey,
                    saaspassId: saaspassId,
                    oauth_client_id: oauthClientId,
                    captchaResponse: captchaResponse
                }, ignoreAuthModule: true }).then(function () {
                return deferred.resolve(username);
            }).catch(function (response) {
                var data = response.data;
                if (response.status === 412) {
                    if (data.message && data.message.indexOf('numberOfAttempts') > -1) {
                        var numberOfAttempts = +data.message.split('=')[1];
                        localStorage.setItem('loginAttempts', numberOfAttempts);
                    }
                    $rootScope.captchaError = true;
                    $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
                } else {
                    $rootScope.authenticationError = true;
                }

                deferred.reject(data.serviceErrorCode);
            });

            return deferred.promise;
        },

        getGmpLoginSession: function getGmpLoginSession() {
            return gmpLoginSession;
        },

        loginAfterRegistration: function loginAfterRegistration(param) {
            var username = param.username;
            var password = param.password;

            var data = "username=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password) + "&grant_type=password&scope=read%20write&client_secret=mySecretOAuthSecret&client_id=SaaSPassapp";
            if (param.captchaResponse != null) {
                data += "&captchaResponse=" + param.captchaResponse;
            }
            var promise = $http.post('oauth/token', data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Accept": "application/json",
                    "Authorization": 'Basic ' + btoa('SaaSPassapp:mySecretOAuthSecret')
                },
                ignoreAuthModule: 'ignoreAuthModule'
            }).then(function (response) {

                TokenService.setToken(response.data);

                Account.reload().then(function (data) {

                    authService.loginConfirmed(data);
                }).catch(function (response) {
                    if (response.status != 0) {
                        $rootScope.authenticationError = false;
                        TokenService.remove();

                        $http.get('app/logout');
                        $rootScope.account = null;
                        $state.go('user');
                    }
                });

                var companyId = param.companyId;
                $state.go('company', { companyId: companyId, reg: password });
                localStorage.setItem('loginAttempts', 0);
                $rootScope.captchaError = false;
            });
        },
        login: function login(param) {
            $rootScope.authenticationError = false;
            var redirection = $state.params.redirect;
            var username = param.username;
            var password = param.password;
            if (redirection != null) {
                var idx = redirection.indexOf("/loginSaml/client/sso/");
                var tmp = redirection;
            } else {
                var idx = $location.absUrl().indexOf("/loginSaml/client/sso/");
                var tmp = $location.absUrl();
            }
            if (idx > -1) {
                var tracker = tmp.substring(idx + "/loginSaml/client/sso/".length, tmp.length);
                if (tracker != null) {
                    if (username == null) {
                        username = "tracker";
                    }
                    if (password == null) {
                        password = tracker;
                    }
                }
            }

            if (redirection != null) {
                var idx = redirection.indexOf("/ssosaaspass/");
                var tmp = redirection;
            } else {
                var idx = $location.absUrl().indexOf("/ssosaaspass/");
                var tmp = $location.absUrl();
            }
            if (idx > -1) {
                var content = tmp.substring(idx + "/ssosaaspass/".length, tmp.length);
                if (content != null) {
                    if (username == null) {
                        username = "ssosaaspass";
                    }
                    if (password == null) {
                        password = content;
                    }
                }
            }

            var data = "username=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password) + "&grant_type=password&scope=read%20write&client_secret=mySecretOAuthSecret&client_id=SaaSPassapp";

            if (param.oauthClientId != null) {
                data += "&oauth_client_id=" + param.oauthClientId;
            }
            if (param.captchaResponse != null) {
                data += "&captchaResponse=" + param.captchaResponse;
            }
            if (param.googleAppsLogin) {
                data += '&googleAppsLogin=' + param.googleAppsLogin;
                data += '&code=' + param.code;
            }
            if (param.googleMarketPlaceConfiguration) {
                data += "&gmpConfig=" + param.googleMarketPlaceConfiguration;
                data += "&code=" + param.code;
                data += "&domain=" + param.domain;
            }
            if (redirection != null && redirection.indexOf('/loginSAML/') > -1) {
                var appKey = redirection.replace(/\/loginSAML\/(.*)/, '$1');
                data += "&appKey=" + appKey;

                if (param.passwordLogin) {
                    data += '&passwordLogin=' + param.passwordLogin;
                }
            }
            var idxSSO = $location.absUrl().indexOf("/loginSaml/client/sso/");
            if (idxSSO > -1) {
                data += "&tracker=" + password;
            }

            var promise = $http.post('oauth/token', data, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Accept": "application/json",
                    "Authorization": 'Basic ' + btoa('SaaSPassapp:mySecretOAuthSecret')
                },
                ignoreAuthModule: 'ignoreAuthModule'
            }).then(function (response) {
                if ($rootScope.loginModal) {
                    $rootScope.loginModal.close();
                }
                $rootScope.refreshers = [];
                TokenService.setToken(response.data);

                // Saaspass Connect login request check
                var continueUrl;
                var continueParam = $state.params.continue;
                if (continueParam) {
                    $('#clientDisplayName').text('Please wait...');
                    continueUrl = decodeURI(continueParam);
                }

                Account.reload().then(function (data) {
                    if (data.userEmailAddress) {

                        var redirection = $state.params.redirect;
                        if (param.googleMarketPlaceConfiguration) {
                            gmpLoginSession = true;
                            redirection = $state.href('gmp-config');
                        }
                        if ($state.is('public.gmarket-login')) {
                            redirection = $state.href('gmp-config');
                        }

                        if (redirection != null) {
                            $location.path(redirection);
                            $location.url($location.path());
                        }
                    }

                    // Saaspass Connect login request check
                    if (continueUrl) {
                        $window.location.href = continueUrl;
                    } else {
                        authService.loginConfirmed(data);
                    }
                }).catch(function (response) {
                    if (response.status != 0) {
                        $rootScope.authenticationError = false;
                        TokenService.remove();

                        $http.get('app/logout');
                        $rootScope.account = null;
                        $state.go('user');
                    }
                });

                var redirection = $state.params.redirect;
                if (param.googleMarketPlaceConfiguration) {
                    gmpLoginSession = true;
                }
                if (param.googleAppsLogin) {
                    redirection = '/applications';
                }
                if (redirection != null && redirection.indexOf('/ssosaaspass/') > -1) {
                    redirection = '/authenticator';
                }
                if (redirection == null || redirection == '') {
                    var idx = $location.absUrl().indexOf("/loginSaml/client/sso/");
                    var tmp = $location.absUrl();
                    if (idx > -1) {
                        var tracker = tmp.substring(idx + "/loginSaml/client/sso/".length, tmp.length);
                    }
                    if (tracker == null) {
                        redirection = '/authenticator';
                    }
                } else if (redirection.indexOf('/loginSaml/client/sso') > -1) {
                    redirection = null;
                } else if (redirection.indexOf('/loginSAML') > -1) {

                    redirection += '?SAMLTracker=' + encodeURIComponent($location.search().SAMLTracker);

                    try {
                        var targeting = '_self';
                        $window.open('#' + redirection, targeting);
                    } catch (e) {
                        console.log(e);
                    }

                    redirection = $state.href('user');
                }
                if (redirection != null) {
                    if (continueUrl) {
                        return;
                    } else {
                        $location.path(redirection);
                        $location.url($location.path());
                    }
                }
                localStorage.setItem('loginAttempts', 0);
                $rootScope.captchaError = false;
            });

            promise.catch(function (response) {
                var data = response.data;
                if (data.error_description && data.error_description.indexOf('Google') > -1) {
                    $state.go('public.google-info');
                    return;
                } else if (data.error_description && data.error_description.indexOf('captcha') > -1) {
                    $rootScope.captchaError = true;
                    if (!localStorage.getItem('loginAttempts')) {
                        $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha_first_time';
                        if ($state.is('public.hard-token-login')) {
                            $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', $rootScope.captchaErrorMsg);
                        }
                    } else {
                        $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
                        if ($state.is('public.hard-token-login')) {
                            $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', $rootScope.captchaErrorMsg);
                        }
                    }
                } else {
                    $rootScope.captchaError = false;
                }
                $rootScope.authenticationError = true;
                if (!$rootScope.loginModal) {
                    setInvalidAttempts(data);
                    $rootScope.account = null;
                    TokenService.remove();
                    if ($state.is('public.hard-token-login')) {
                        var key = 'login.messages.error.authenticationToken';
                        $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', key);
                    } else {
                        $rootScope.$broadcast('event:auth-loginRequired', data);
                    }
                }
            });

            return promise;
        },
        refresh: function refresh() {

            if ($rootScope.transition.to().name.startsWith('public.')) {
                $rootScope.account = null;
                TokenService.remove();
                $rootScope.sessionExpired = true;
                return;
            }

            var token = TokenService.getAccessToken();

            if (!token) {
                // the token is removed, logout occured.
                $rootScope.account = null;

                var redirect = $location.path();
                if (redirect.indexOf("loginSAML") != -1) {
                    $state.go('public.login', { redirect: redirect }, { location: 'replace' });
                } else if (redirect.indexOf("gmarketlogin") != -1) {
                    $location.path(redirect);
                } else {
                    if (!$rootScope.sessionExpired) {
                        $state.go('public.login');
                    } else {
                        $state.go('public.session-expired');
                    }
                }

                return;
            }

            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : r & 0x3 | 0x8;
                return v.toString(16);
            });

            if (!angular.isDefined($rootScope.refreshers)) {
                $rootScope.refreshers = [];
            }

            $rootScope.refreshers.push(uuid);

            var refreshPromise = $rootScope.$watch('refreshers', function () {
                // TODO I am seeing dead people!
                if (!$rootScope.refreshers || !$rootScope.refreshers.length) {
                    // something happend there
                    // are no refreshers
                    // avalible, do not care :)
                    // relase the promise!
                    refreshPromise();
                }

                var currentTurnUuid = $rootScope.refreshers[0];
                if (uuid !== currentTurnUuid) {
                    return;
                }
                var currentKnownToken = {};
                if (TokenService.getAccessToken()) {
                    currentKnownToken = TokenService.getAccessToken();
                }

                if (currentKnownToken === token) {

                    $http.post('oauth/token', 'refresh_token=' + TokenService.getRefreshToken() + '&grant_type=refresh_token', {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Accept": "application/json",
                            "Authorization": 'Basic ' + btoa('SaaSPassapp:mySecretOAuthSecret')
                        },
                        ignoreAuthModule: 'ignoreAuthModule'
                    }).then(function (response) {
                        var data = response.data;
                        TokenService.setToken(data);
                        authService.loginConfirmed(data);
                        $rootScope.refreshers.shift();
                        // revoke
                        // all
                        // watchers
                        var notAccountWatches = [];
                        angular.forEach($rootScope.$$watchers, function (value, key) {
                            if (value.exp !== 'refreshers') {
                                notAccountWatches.push(value);
                            }
                        });
                        $rootScope.$$watchers = notAccountWatches;
                        $rootScope.refreshers = [];
                        $rootScope.refreshers.shift();
                        refreshPromise();
                    }).catch(function () {
                        authService.loginCancelled();
                        $rootScope.refreshers.shift();
                        // revoke
                        // all
                        // watchers
                        var notAccountWatches = [];
                        angular.forEach($rootScope.$$watchers, function (value, key) {
                            if (value.exp !== 'refreshers' && value.exp !== 'account') {
                                notAccountWatches.push(value);
                            }
                        });
                        $rootScope.$$watchers = notAccountWatches;
                        $rootScope.refreshers = [];
                        TokenService.remove();
                        $rootScope.account = null;
                        $rootScope.sessionExpired = true;

                        var redirect = $location.path();
                        if (redirect.indexOf("loginSAML") != -1) {
                            $state.go('public.login', { redirect: redirect }, { location: 'replace' });
                        }
                        $state.go('public.session-expired');

                        $rootScope.refreshers.shift();
                        refreshPromise();
                    });
                } else {
                    refreshPromise();
                    // revoke all watchers
                    var notAccountWatches = [];
                    angular.forEach($rootScope.$$watchers, function (value, key) {
                        if (value.exp !== 'refreshers') {
                            notAccountWatches.push(value);
                        }
                    });
                    $rootScope.$$watchers = notAccountWatches;
                    $rootScope.refreshers = [];
                }
            });
        },
        logout: function logout() {
            $rootScope.authenticationError = false;
            TokenService.remove();
            $http.get('app/logout');
            $rootScope.account = null;
            $window.location.href = "https://www.saaspass.com";
        }
    };
}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

BarcodeGeneratonService.$inject = ['$resource'];


_app.app.factory('BarcodeGeneratonService', BarcodeGeneratonService);

/** @ngInject */
function BarcodeGeneratonService($resource) {
    return $resource('app/rest/barcode/:uuid', {}, {
        "applicationBarcode": {
            method: 'GET',
            url: 'app/rest/barcode/:uuid?appKey=:appKey',
            params: {
                uuid: '@uuid',
                appKey: '@appKey'
            }
        },
        "simulatorBarcode": {
            method: 'GET',
            url: 'app/rest/barcode/simulator/:uuid?appKey=:appKey',
            params: {
                uuid: '@uuid',
                appKey: '@appKey'
            }
        }
    });
}

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompanyUserResource = function () {
    CompanyUserResource.$inject = ['$http'];

    /** @ngInject */
    function CompanyUserResource($http) {
        _classCallCheck(this, CompanyUserResource);

        this.$http = $http;
    }

    _createClass(CompanyUserResource, [{
        key: 'logCompanyAccessed',
        value: function logCompanyAccessed(companyId) {
            var url = 'app/rest/companies/' + companyId + '/companyusers/access';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }]);

    return CompanyUserResource;
}();

_app.app.service('CompanyUserResource', CompanyUserResource);

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

CompanyUser.$inject = ['$resource'];


_app.app.factory('CompanyUser', CompanyUser);

/** @ngInject */
function CompanyUser($resource) {
    return $resource('app/rest/companies/:companyId/companyusers/:id', {
        companyId: '@companyId',
        id: "@id"
    }, {
        'identifyCompanyUser': {
            method: 'GET',
            url: 'app/rest/companies/:companyId/companyusers?uid=:uid',
            params: {
                companyId: '@companyId',
                uid: '@uid'
            }
        },
        'getUserAccounts': {
            method: 'GET',
            url: 'app/rest/companies/:companyId/companyusers/:id/useraccounts',
            isArray: true,
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'updateCompanyUser': {
            method: 'POST',
            url: 'app/rest/companies/:companyId/companyusers/:id?update=:updateAction',
            params: {
                companyId: '@companyId',
                id: '@id',
                updateAction: '@updateAction'
            }
        }
    });
}

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

GoogleSharedService.$inject = ['$resource'];


_app.app.factory('GoogleSharedService', GoogleSharedService);

/** @ngInject */
function GoogleSharedService($resource) {

    var getGoogleAuthUrl = $resource('app/rest/googleauth/requesturl', {}, {});

    var getEmailStatus = $resource('app/rest/googleconfig/checkemailstatus', {}, {});

    var getGoogleAppsInfo = $resource('app/rest/googleconfig/googleappsinfo', {}, {});

    var saveGoogleApplication = $resource('app/rest/googleconfig/savegoogleapplication', {}, {});

    var updateGoogleApplicationWithDomain = $resource('app/rest/googleconfig/updategoogleapplication', {}, {});

    var updateUserEmailOwner = $resource('app/rest/googleconfig/updatemailowner', {}, {});

    var createUserEmail = $resource('app/rest/googleconfig/createuseremail', {}, {});

    var changeUserEmailOwnerNoDomain = $resource('app/rest/googleconfig/updateuseremailnodomain', {}, {});

    var updateCompanyWithDomain = $resource('app/rest/googleconfig/updatecompanywithdomain', {}, {});

    var createCompanyWithDomain = $resource('app/rest/googleconfig/createcompanywithdomain', {}, {});

    var getGoogleEndUserAuthUrl = $resource('app/rest/googleauth/requesturlenduser', {}, {});

    return {
        getGoogleAuthUrl: getGoogleAuthUrl,
        getEmailStatus: getEmailStatus,
        getGoogleAppsInfo: getGoogleAppsInfo,
        saveGoogleApplication: saveGoogleApplication,
        updateGoogleApplicationWithDomain: updateGoogleApplicationWithDomain,
        updateUserEmailOwner: updateUserEmailOwner,
        createUserEmail: createUserEmail,
        changeUserEmailOwnerNoDomain: changeUserEmailOwnerNoDomain,
        updateCompanyWithDomain: updateCompanyWithDomain,
        createCompanyWithDomain: createCompanyWithDomain,
        getGoogleEndUserAuthUrl: getGoogleEndUserAuthUrl
    };
}

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UserAccounts.$inject = ['$resource'];
Groups.$inject = ['$resource'];


_app.app.factory('Groups', Groups);

/** @ngInject */
function Groups($resource) {
    return $resource('app/rest/company/:companyId/groups/:id', {
        companyId: '@companyId',
        id: "@id"
    }, {
        'getGroupsByType': {
            method: 'GET',
            url: 'app/rest/company/:companyId/groups?type=:type',
            isArray: true,
            params: {
                companyId: '@companyId',
                type: '@type'
            }
        }
    });
}

_app.app.factory('UserAccounts', UserAccounts);

/** @ngInject */
function UserAccounts($resource) {
    return $resource('app/rest/company/:companyId/useraccounts/:id', {
        companyId: '@companyId',
        id: "@id"
    }, {
        'getAccountsForGroup': {
            method: 'GET',
            url: 'app/rest/company/:companyId/useraccounts?groupId=:groupId',
            isArray: true,
            params: {
                companyId: '@id',
                groupId: '@id'
            }
        },
        'getSharedEmailAccountsByUsername': {
            method: 'GET',
            url: 'app/rest/company/:companyId/useraccounts/sharedemailaccountsbyusername?username=:username',
            isArray: true,
            params: {
                companyId: '@id',
                username: '@username'
            }
        },
        'getSharedEmailAccounts': {
            method: 'GET',
            url: 'app/rest/company/:companyId/useraccounts/sharedemailaccounts?username=:username',
            isArray: true,
            params: {
                companyId: '@id'
            }
        },
        'getSharedEmailAccountType': {
            method: 'GET',
            url: 'app/rest/company/:companyId/sharedemailccounts/accountType?username=:username',
            params: {
                companyId: '@id',
                username: '@username'
            }
        },
        'getGroupsOfAccount': {
            method: 'GET',
            url: 'app/rest/company/:companyId/useraccounts/:id/groups',
            params: {
                companyId: '@id',
                id: '@id'
            },
            isArray: true
        },
        'assignUserToGroups': {
            method: 'POST',
            url: 'app/rest/company/:companyId/useraccounts/:id/groups?addusers=true',
            params: {
                companyId: '@id',
                id: '@id'
            }
        },
        'createSharedUserAccount': {
            method: 'POST',
            url: 'app/rest/company/:companyId/useraccounts/shared',
            params: {
                companyId: '@id'
            }
        },
        'deleteUserAccount': {
            method: 'DELETE',
            url: 'app/rest/company/:companyId/useraccounts/:id',
            params: {
                companyId: '@companyId',
                id: "@id"
            }
        },
        'verify': {
            method: 'POST',
            url: 'app/rest/company/:companyId/useraccounts/:id/verify',
            params: {
                companyId: '@id',
                id: '@id'
            }
        },
        'getBlockedUsers': {
            method: 'GET',
            isArray: true,
            url: 'app/rest/company/:companyId/useraccounts?blocked=true',
            params: {
                companyId: '@id',
                id: '@id'
            }
        }
    });
}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _store = __webpack_require__(19);

var _hardToken = __webpack_require__(195);

HardTokenService.$inject = ['$http'];


_app.app.factory('HardTokenService', HardTokenService);

/** @ngInject */
function HardTokenService($http) {

    return {
        get: get,
        getDetail: getDetail,
        list: list,
        save: save,
        disable: disable,
        enable: enable,
        remove: remove,
        u2fRegistrationStart: u2fRegistrationStart,
        u2fRegistrationFinish: u2fRegistrationFinish,
        u2fResetRegistrationStart: u2fResetRegistrationStart,
        u2fAuthenticationStart: u2fAuthenticationStart,
        u2fAuthenticationFinish: u2fAuthenticationFinish,
        generateSyncUrl: generateSyncUrl,
        getRegEmailData: getRegEmailData,
        putRegEmailData: putRegEmailData,
        resendRegEmail: resendRegEmail,
        sync: sync,
        add: add
    };

    function get(id) {
        return $http.get('app/rest/admin/company/' + companyId() + '/hardtoken/' + id).then(function (response) {
            return new _hardToken.HardToken(response.data);
        });
    }

    function getDetail(id) {
        return $http.get('app/rest/admin/company/' + companyId() + '/ht/' + id).then(function (response) {
            return response.data;
        });
    }

    function list() {
        return $http.get('app/rest/admin/company/' + companyId() + '/hardtoken').then(function (response) {
            return response.data.map(function (tokenDto) {
                return new _hardToken.HardToken(tokenDto);
            });
        });
    }

    function save(token) {
        if (token.hasOwnProperty("isSelected")) {
            delete token.isSelected;
        }
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id, token.toDto()).then(function (response) {
            return response.data;
        });
    }
    function remove(token) {
        return $http.delete('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id);
    }

    function disable(token) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/disable').then(function (response) {
            return response.data;
        });
    }

    function enable(token) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/enable').then(function (response) {
            return response.data;
        });
    }

    function u2fRegistrationStart(token) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/u2fregistrationstart').then(function (response) {
            return response.data;
        });
    }
    function u2fResetRegistrationStart(token) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/u2fregistrationreset').then(function (response) {
            return response.data;
        });
    }

    function u2fRegistrationFinish(token, data) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/u2fregistrationfinish', data).then(function (response) {
            return new _hardToken.HardToken(response.data);
        });
    }

    function u2fAuthenticationStart(token) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/u2fauthenticationstart').then(function (response) {
            return response.data;
        });
    }

    function u2fAuthenticationFinish(token, data) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/u2fauthenticationfinish', data).then(function (response) {
            return response.data;
        });
    }

    function generateSyncUrl(token) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/synchronize/generate').then(function (response) {
            return response.data;
        });
    }

    function getRegEmailData(token) {
        return $http.get('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/registrationEmail').then(function (response) {
            return response.data;
        });
    }

    function putRegEmailData(token, email) {
        return $http.put('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/registrationEmail', email).then(function (response) {
            return response.data;
        });
    }
    function resendRegEmail(token) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/registrationEmail/resend').then(function (response) {
            return response.data;
        });
    }

    function sync(token, otps) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken/' + token.id + '/synchronize', otps).then(function (response) {
            return response.data;
        });
    }

    function add(tokens) {
        return $http.post('app/rest/admin/company/' + companyId() + '/hardtoken', tokens).then(function (response) {
            return response.data;
        });
    }

    function companyId() {
        return _store.resolve.companyId;
    }
}

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

IdentityProveService.$inject = ['$resource'];


_app.app.factory('IdentityProveService', IdentityProveService);

/** @ngInject */
function IdentityProveService($resource) {
    return $resource('app/rest/identityprove', {}, {
        'otpcheck': {
            method: 'GET',
            url: 'app/rest/identityprove/otpchecks?otp=:otp',
            params: {
                otp: '@otp'
            }
        },
        'pincheck': {
            method: 'GET',
            url: 'app/rest/identityprove/pinchecks?pin=:pin',
            params: {
                pin: '@pin'
            }
        }
    });
}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

RegistrationCodeGeneratonService.$inject = ['$resource'];


_app.app.factory('RegistrationCodeGeneratonService', RegistrationCodeGeneratonService);

/** @ngInject */
function RegistrationCodeGeneratonService($resource) {
    return $resource('app/rest/registrationcode/:uuid', {}, {
        "simulatorBarcode": {
            method: 'GET',
            url: 'app/rest/registrationcode/simulator/:uuid?appKey=:appKey',
            params: {
                uuid: '@uuid',
                appKey: '@appKey'
            }
        }
    });
}

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.factory('TokenService', TokenService);

/** @ngInject */
function TokenService() {

    return {
        setToken: setToken,
        getAccessToken: getAccessToken,
        getRefreshToken: getRefreshToken,
        remove: remove
    };

    function setToken(token) {
        localStorage.setItem('token', JSON.stringify(token));
    }

    function getToken() {
        var token = localStorage.getItem('token');
        return token && JSON.parse(token);
    }

    function getAccessToken() {
        var token = getToken();
        return token && token.access_token;
    }

    function getRefreshToken() {
        var token = getToken();
        return token && token.refresh_token;
    }

    function remove() {
        localStorage.removeItem('token');
    }
}

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UserPhoneNumber.$inject = ['$resource'];


_app.app.factory('UserPhoneNumber', UserPhoneNumber);

/** @ngInject */
function UserPhoneNumber($resource) {
    return $resource('app/rest/phonenumbers/:id', {}, {
        'query': {
            method: 'GET',
            isArray: true
        },
        'get': {
            method: 'GET'
        },
        'deletePendingNumber': {
            url: 'app/rest/phonenumbers/:id?status=PENDING',
            method: 'DELETE'
        }
    });
}

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addNewAdministrator = __webpack_require__(344);

_app.app.component('addNewAdministrator', {
    bindings: {
        administrators: '<',
        applications$: '<',
        appTypes$: '<',
        companyId: '<',
        email: '<',
        groups$: '<'
    },
    controller: _addNewAdministrator.Controller,
    templateUrl: __webpack_require__(1221)
});

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f681d6cb7bde64bbe71cf04cca9aab14.html";

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

email.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.administrators.add', {
        url: '/add?email',
        component: 'addNewAdministrator',
        resolve: { email: email }
    });
}

/** @ngInject */
function email($stateParams) {
    return $stateParams.email;
}

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyAdministrators', {
    templateUrl: __webpack_require__(1224)
});

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f36a297358c272b32ca7d5e27282ef8.html";

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _lazyLoad = __webpack_require__(71);

var _administrators = __webpack_require__(104);

groups$.$inject = ['$filter', 'companyId', 'GroupsResource'];
appTypes$.$inject = ['$filter', 'applicationsAndTypes$'];
applicationsAndTypes$.$inject = ['companyId', 'RoleResource'];
applications$.$inject = ['$filter', 'applicationsAndTypes$'];
administrators.$inject = ['$filter', 'account', 'companyId', 'RoleResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.administrators', {
        url: '/administrators',
        redirectTo: 'company.administrators.list',
        component: 'companyAdministrators',
        resolve: {
            administrators: administrators,
            applications$: applications$,
            applicationsAndTypes$: applicationsAndTypes$,
            appTypes$: appTypes$,
            groups$: groups$
        }
    });
}

/** @ngInject */
function administrators($filter, account, companyId, RoleResource) {
    return RoleResource.getAllCompanyUsersWithRole(companyId).then(function (users) {
        return users.map(_administrators.userFromDto);
    }).then(function (users) {
        return users.map(function (user) {
            return _extends({}, user, { order: user.order + (account.login === user.saaspassId ? 1 : 0)
            });
        });
    }).then(function (users) {
        return $filter('orderBy')(users, 'order', true);
    });
}

/** @ngInject */
function applications$($filter, applicationsAndTypes$) {
    return applicationsAndTypes$.map(function (_ref) {
        var applications = _ref.applications;
        return applications;
    }).map(function (applications) {
        return applications.map(function (a) {
            return _extends({}, a, { name: a.applicationName });
        });
    }).map(function (applications) {
        return $filter('orderBy')(applications, 'name');
    });
}

/** @ngInject */
function applicationsAndTypes$(companyId, RoleResource) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return RoleResource.getApplicationsAndTypes(companyId);
    });
}

/** @ngInject */
function appTypes$($filter, applicationsAndTypes$) {
    return applicationsAndTypes$.map(function (_ref2) {
        var types = _ref2.types;
        return types;
    }).map(function (types) {
        return types.map(function (t) {
            return { id: '' + t.applicationTypeId, name: t.applicationTypeDisplayName };
        });
    }).map(function (types) {
        return $filter('orderBy')(types, 'name');
    });
}

/** @ngInject */
function groups$($filter, companyId, GroupsResource) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return GroupsResource.getAllCompanyGroups(companyId);
    }).map(function (groups) {
        return groups.map(function (g) {
            return _extends({}, g, { name: g.groupName });
        });
    }).map(function (groups) {
        return $filter('orderBy')(groups, 'name');
    });
}

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editAdministrator = __webpack_require__(345);

_app.app.component('editAdministrator', {
    bindings: {
        administrator: '<',
        administrators: '<',
        applications$: '<',
        appTypes$: '<',
        companyId: '<',
        groups$: '<'
    },
    controller: _editAdministrator.Controller,
    templateUrl: __webpack_require__(1227)
});

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f5f443ba8dbddb41a50685b9d3fca979.html";

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

companyUserId.$inject = ['$stateParams'];
administrator.$inject = ['administrators', 'companyUserId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.administrators.edit', {
        url: '/edit/:companyUserId',
        component: 'editAdministrator',
        resolve: {
            administrator: administrator,
            companyUserId: companyUserId
        }
    });
}

/** @ngInject */
function administrator(administrators, companyUserId) {
    return administrators.find(function (_ref) {
        var id = _ref.id;
        return id === companyUserId;
    });
}

/** @ngInject */
function companyUserId($stateParams) {
    return $stateParams.companyUserId;
}

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _administratorsList = __webpack_require__(346);

_app.app.component('companyAdministratorsList', {
    bindings: {
        account: '<',
        administrators: '<',
        companyId: '<'
    },
    controller: _administratorsList.Controller,
    templateUrl: __webpack_require__(1230)
});

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2ec00083123b25db1a2875ae120e642e.html";

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.administrators.list', {
        url: '/list',
        component: 'companyAdministratorsList'
    });
}

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _appApiCredentials = __webpack_require__(347);

_app.app.component('appApiCredentials', {
    bindings: {
        application: '<'
    },
    controller: _appApiCredentials.Controller,
    templateUrl: __webpack_require__(1233)
});

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd7a9757d0613c0106e02113782c3460.html";

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _appIntegrationInstructionsLocal = __webpack_require__(348);

_app.app.component('appIntegrationInstructionsLocal', {
    bindings: {
        application: '<',
        appType: '<'
    },
    controller: _appIntegrationInstructionsLocal.Controller,
    templateUrl: __webpack_require__(1264)
});

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ad-password-manager/index.html": 1236,
	"./array-networks-radius/index.html": 1237,
	"./check-point/index.html": 1238,
	"./cisco-asa/index.html": 1239,
	"./cisco-meraki-client-vpn/index.html": 1240,
	"./cisco-meraki-radius/index.html": 1241,
	"./citrix-net-scaler-radius/index.html": 1242,
	"./computer-login/index.html": 1243,
	"./computer-protection-without-ad/index.html": 1244,
	"./custom/index.html": 1245,
	"./defensx-oidc/index.html": 1246,
	"./dell-sonic-wall-radius/index.html": 1247,
	"./exchange-active-sync/index.html": 1248,
	"./generic-oauth2/index.html": 1249,
	"./generic-oidc/index.html": 1250,
	"./linux-ssh/index.html": 1251,
	"./microsoft-radius-remote-desktop-gateway/index.html": 1252,
	"./microsoft-routing-and-remote-access-rras/index.html": 1253,
	"./open-vpn/index.html": 1254,
	"./radius/index.html": 1255,
	"./remote-desktop-web-access/index.html": 1256,
	"./reverse-proxy-sso/index.html": 1257,
	"./saaspass-secure-remote-access/index.html": 1258,
	"./sophos-firewall-xg-radius/index.html": 1259,
	"./t-splus/index.html": 1260,
	"./thinfinity/index.html": 1261,
	"./v-mware-horizon-view/index.html": 1262,
	"./wi-fi-captive-portal/index.html": 1263
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1235;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae6d6e42182a2984ad26b6d63a961ec5.html";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a3b335ca889876d53f3d503866cb1d1a.html";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60ab9c819018a95637e17b9fff892b4e.html";

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8c60c15f48b7de595a6fc48e1d6d50c3.html";

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7898544b4958b38c39c20d8a7a3633eb.html";

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b5d178f1f7c363b4e045b94a955d73cc.html";

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b6546a0d165bf34dcc6619cfb3dbd245.html";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa92bbcac487cb248ea6f1ea3327dd30.html";

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9ffc637192911c57a4c2181ca3842cb7.html";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd2b0528e89f28e1087af439ff3509a1.html";

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5291e145283cbc3c5d10bc0ad4055c7a.html";

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f7e2cd2024d431636caf38da2ef22fc7.html";

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7a96dcba8ff0ca8b6a5feb8e55cb1d83.html";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3193d108cbd0b34ad5eb1a445711890c.html";

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f268f8aa23d69cfd1ecd533f389573fe.html";

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c7c4df46ca176a203148a18a2d1abd9e.html";

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "52e176196e96dd560bfd5e020e989af9.html";

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "419e0d428e12dbc74b7c4dae28410b5b.html";

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d3f50edb36bd98ffade2f563856b5f6f.html";

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5ab44b4d16f70899a9e638d248610cbc.html";

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0a69999422da892b0697edf18cf1bf36.html";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "51bc8a4164eb0a388728aefe1ac0a5c0.html";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ab0e92c591b8a00b6f3e91e88fff44d9.html";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e416880aa1322352ff5a63b8d18ca2b1.html";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ab0e92c591b8a00b6f3e91e88fff44d9.html";

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d19a2ae2570ef1a429754d4713edf3e5.html";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "26f1ef79aebfc99e36a55574da36eea4.html";

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ac8b7d317e1ff058872570034ea2dc92.html";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2a7f130f34226f57b22a0291e5eb836e.html";

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('radiusProxyDownloadForm', {
    bindings: {
        action: '<',
        appType: '<'
    },
    templateUrl: __webpack_require__(1266)
});

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b553f74d7128b8399fff4f5af5123f15.html";

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _oauthEndpoints = __webpack_require__(349);

_app.app.component('oauthEndpoints', {
    bindings: {
        clientId: '<',
        credentials$: '<'
    },
    controller: _oauthEndpoints.Controller,
    templateUrl: __webpack_require__(1268)
});

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa5139f30e8b93a5feb68d5a0b196c69.html";

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _oidcEndpoints = __webpack_require__(350);

_app.app.component('oidcEndpoints', {
    bindings: {
        clientId: '<',
        credentials$: '<'
    },
    controller: _oidcEndpoints.Controller,
    templateUrl: __webpack_require__(1270)
});

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ffe5f0b957a78d6643b5d0ed01ae019d.html";

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('appIntegrationInstructionsRemote', {
    bindings: { instructions: '<' },
    templateUrl: __webpack_require__(1272)
});

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f55c0aa2366730361757a449d59eb906.html";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _samlMetadata = __webpack_require__(351);

_app.app.component('samlMetadata', {
    bindings: {
        metadata: '<'
    },
    controller: _samlMetadata.Controller,
    templateUrl: __webpack_require__(1274)
});

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "82f7ae6fb28b95f602c500d5cdc039d2.html";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _company = __webpack_require__(352);

_app.app.component('company', {
    bindings: {
        account: '<',
        companyId: '<',
        currentCompany: '<',
        licenseInfo: '<'
    },
    controller: _company.Controller,
    templateUrl: __webpack_require__(1276)
});

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f7f59b63b8d47808c1bcc1bd02a0820.html";

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _store = __webpack_require__(19);

var _lazyLoad = __webpack_require__(71);

licenseInfo.$inject = ['LicenseManagementService', 'companyId'];
publicServicesWithEPM$.$inject = ['PublicServiceResource'];
prefetch.$inject = ['appTypes$', 'publicServicesWithEPM$'];
currentCompany.$inject = ['account', 'companyId'];
companyId.$inject = ['$stateParams'];
appTypesAndCategories$.$inject = ['AddNewApplicationResource', 'companyId'];
appTypes$.$inject = ['$filter', '$q', 'appTypesAndCategories$'];
appType$.$inject = ['AddNewApplicationResource', 'companyId'];
appCategories$.$inject = ['appTypesAndCategories$'];
account.$inject = ['Account'];
$breadcrumbs.$inject = ['currentCompany'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company', {
        url: '/admin/company/:companyId',
        redirectTo: 'company.landing-page',
        component: 'company',
        resolve: {
            $breadcrumbs: $breadcrumbs,
            account: account,
            appCategories$: appCategories$,
            appType$: appType$,
            appTypes$: appTypes$,
            appTypesAndCategories$: appTypesAndCategories$,
            companyId: companyId,
            currentCompany: currentCompany,
            prefetch: prefetch,
            publicServicesWithEPM$: publicServicesWithEPM$,
            licenseInfo: licenseInfo
        }
    });
}

/** @ngInject */
function $breadcrumbs(currentCompany) {
    return [{ title: currentCompany.companyName }];
}

/** @ngInject */
function account(Account) {
    return Account.get();
}

/** @ngInject */
function appCategories$(appTypesAndCategories$) {
    return appTypesAndCategories$.map(function (_ref) {
        var aCs = _ref.aCs;
        return aCs;
    });
}

appType$.byId = {};

/** @ngInject */
function appType$(AddNewApplicationResource, companyId) {
    return function (appTypeId) {
        return appType$.byId[appTypeId] = appType$.byId[appTypeId] || (0, _lazyLoad.lazyLoad)(function () {
            return AddNewApplicationResource.getApplicationsType(companyId, appTypeId);
        });
    };
}

/** @ngInject */
function appTypes$($filter, $q, appTypesAndCategories$) {
    return appTypesAndCategories$.map(function (_ref2) {
        var aTs = _ref2.aTs;
        return aTs;
    }).map(function (items) {
        return items.filter(function (item) {
            return item.slug !== 'enterprise-password-manager';
        });
    }).map(function (items) {
        return $filter('orderBy')(items, 'applicationTypeDisplayName');
    }).map(function (items) {
        items.forEach(function (item) {
            return appType$.byId[item.id] = (0, _lazyLoad.lazyLoad)(function () {
                return $q.resolve(item);
            });
        });
        return items;
    });
}

/** @ngInject */
function appTypesAndCategories$(AddNewApplicationResource, companyId) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return AddNewApplicationResource.getAllApplicationsTypes(companyId);
    });
}

/** @ngInject */
function companyId($stateParams) {
    return _store.resolve.companyId = $stateParams.companyId;
}

/** @ngInject */
function currentCompany(account, companyId) {
    return _store.resolve.currentCompany = account.userCompanyRoles.find(function (company) {
        return company.companyId === companyId;
    });
}

/** @ngInject */
function prefetch(appTypes$, publicServicesWithEPM$) {
    appTypes$.get();
    publicServicesWithEPM$.get();
}

/** @ngInject */
function publicServicesWithEPM$(PublicServiceResource) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return PublicServiceResource.getAllWithEpmSupportFiltered();
    }).map(function (items) {
        var custom = items.find(function (i) {
            return i.slug === 'other';
        });
        custom.serviceName = 'Custom Password Manager';
        return items;
    });
}

/** @ngInject */
function licenseInfo(LicenseManagementService, companyId) {
    return LicenseManagementService.licenseCheck(companyId);
}

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _computerProtection = __webpack_require__(353);

_app.app.component('companyComputerProtection', {
    bindings: {
        applications: '<',
        appType$: '<',
        companyId: '<'
    },
    controller: _computerProtection.Controller,
    templateUrl: __webpack_require__(1279)
});

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9a2d4b198329d05114d8335dc954c868.html";

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

applications.$inject = ['ApplicationsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.computer-protection', {
        url: '/computerProtection',
        component: 'companyComputerProtection',
        resolve: {
            applications: applications
        }
    });
}

/** @ngInject */
function applications(ApplicationsResource, companyId) {
    return ApplicationsResource.getAllComputerProtectionApplicationsForCompany(companyId);
}

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _companyProfile = __webpack_require__(354);

_app.app.component('companyProfile', {
    bindings: {
        settings: '<',
        accessPolicies: '<'
    },
    controller: _companyProfile.Controller,
    templateUrl: __webpack_require__(1282)
});

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ef0c3f92a712273bfd269a922ceec76.html";

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CorporateSettingsService = function () {
    CorporateSettingsService.$inject = ['$http'];

    /** @ngInject */
    function CorporateSettingsService($http) {
        _classCallCheck(this, CorporateSettingsService);

        this.$http = $http;
    }

    _createClass(CorporateSettingsService, [{
        key: 'save',
        value: function save(companyId, settings) {
            return this.$http.post('app/rest/company/' + companyId + '/corporateSettings/', settings).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'get',
        value: function get(companyId) {
            return this.$http.get('app/rest/company/' + companyId + '/corporateSettings/').then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'setIpFilter',
        value: function setIpFilter(companyId, ipFilter) {
            return this.$http.post('app/rest/company/' + companyId + '/setIpFilter', ipFilter).then(function (response) {
                return response.data;
            });
        }
    }]);

    return CorporateSettingsService;
}();

_app.app.service('CorporateSettingsService', CorporateSettingsService);

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accessPolicies.$inject = ['AuthenticationAccessPolicyResource', 'companyId'];
settings.$inject = ['companyId', 'CorporateSettingsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.corporate-settings.company-profile', {
        url: '/companyProfile',
        component: 'companyProfile',
        resolve: { settings: settings, accessPolicies: accessPolicies }
    });
}

/** @ngInject */
function settings(companyId, CorporateSettingsService) {
    return CorporateSettingsService.get(companyId);
}

/** @ngInject */
function accessPolicies(AuthenticationAccessPolicyResource, companyId) {
    var type = 'basic';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId, type);
}

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editIpAddressFilter = __webpack_require__(355);

_app.app.component('editCorporateIpAddressFilter', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _editIpAddressFilter.Controller,
    templateUrl: __webpack_require__(1286)
});

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eb32013b6c02d11d31a47d98f8517ad7.html";

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editProfile = __webpack_require__(356);

_app.app.component('editCorporateProfile', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _editProfile.Controller,
    templateUrl: __webpack_require__(1288)
});

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e07cbb87b8b4f063e791220c5f047022.html";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('generateCorporateCredentials', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1290)
});

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "84d9ddfda46bfa45323d0b92945796b0.html";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _corporateSettings = __webpack_require__(357);

_app.app.component('corporateSettings', {
    bindings: {
        settings: '<'
    },
    controller: _corporateSettings.Controller,
    templateUrl: __webpack_require__(1292)
});

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6241d1de26f8989fd9bedb1a6c76248a.html";

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CorporateSettingsService = function () {
    CorporateSettingsService.$inject = ['$http'];

    /** @ngInject */
    function CorporateSettingsService($http) {
        _classCallCheck(this, CorporateSettingsService);

        this.$http = $http;
    }

    _createClass(CorporateSettingsService, [{
        key: 'save',
        value: function save(companyId, settings) {
            return this.$http.post('app/rest/company/' + companyId + '/corporateSettings/', settings).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'get',
        value: function get(companyId) {
            return this.$http.get('app/rest/company/' + companyId + '/corporateSettings/').then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'setIpFilter',
        value: function setIpFilter(companyId, ipFilter) {
            return this.$http.post('app/rest/company/' + companyId + '/setIpFilter', ipFilter).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'enableDynamicClientRegistration',
        value: function enableDynamicClientRegistration(companyId) {
            return this.$http.put('app/rest/company/' + companyId + '/enabledcr/').then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'disableDynamicClientRegistration',
        value: function disableDynamicClientRegistration(companyId) {
            return this.$http.put('app/rest/company/' + companyId + '/disabledcr/').then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'setAdminAccessPolicy',
        value: function setAdminAccessPolicy(companyId, policyId) {
            return this.$http.put('app/rest/company/' + companyId + '/setadminsaccesspolicy/' + policyId).then(function (response) {
                return response.data;
            });
        }
    }]);

    return CorporateSettingsService;
}();

_app.app.service('CorporateSettingsService', CorporateSettingsService);

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.corporate-settings', {
        url: '/corporateSettings',
        component: 'corporateSettings',
        redirectTo: 'company.corporate-settings.company-profile'
    });
}

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _customApplicationIntegration = __webpack_require__(358);

_app.app.component('companyCustomAppIntegration', {
    bindings: {
        applications: '<',
        appType$: '<',
        companyId: '<'
    },
    controller: _customApplicationIntegration.Controller,
    templateUrl: __webpack_require__(1296)
});

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6767e0e5bfbce73ef6f6817682362e8c.html";

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

applications.$inject = ['ApplicationsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.custom-app-integration', {
        url: '/custom-app-integration',
        component: 'companyCustomAppIntegration',
        resolve: {
            applications: applications
        }
    });
}

/** @ngInject */
function applications(ApplicationsResource, companyId) {
    return ApplicationsResource.getAllCustomApplicationsForCompany(companyId);
}

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addDirectory = __webpack_require__(359);

_app.app.component('companyDirectoryIntegrationAddDirectory', {
    bindings: {
        companyId: '<',
        directories: '<',
        directoryType: '<'
    },
    controller: _addDirectory.Controller,
    templateUrl: __webpack_require__(1299)
});

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b1cefcac9ecbc9d6905ba45a8f3c756e.html";

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

directoryType.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.add-directory', {
        url: '/add-directory/:directoryType',
        views: {
            '@company.directory-integration': 'companyDirectoryIntegrationAddDirectory'
        },
        resolve: {
            directoryType: directoryType
        }

    });
}

/** @ngInject */
function directoryType($stateParams) {
    return $stateParams.directoryType;
}

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryIntegration = __webpack_require__(360);

_app.app.component('companyDirectoryIntegration', {
    controller: _directoryIntegration.Controller,
    templateUrl: __webpack_require__(1302)
});

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c1844525a6919b0fdb8ac1985a03f9c5.html";

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryIntegration = __webpack_require__(56);

directories.$inject = ['companyId', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration', {
        url: '/directory-integration',
        redirectTo: 'company.directory-integration.list',
        component: 'companyDirectoryIntegration',
        resolve: { directories: directories }
    });
}

/** @ngInject */
function directories(companyId, DirectoriesResource) {
    return DirectoriesResource.getCompanyDirectories(companyId).then(function (_ref) {
        var directories = _ref.directories;
        return directories.map(function (directory) {
            return (0, _directoryIntegration.toDirectoryDTO)(directory);
        });
    });
}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryList = __webpack_require__(361);

_app.app.component('companyDirectoryIntegrationList', {
    bindings: { directories: '<' },
    controller: _directoryList.Controller,
    templateUrl: __webpack_require__(1305)
});

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "50feebfbaf09173b7915c082ee0b6899.html";

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.list', {
        url: '/list',
        component: 'companyDirectoryIntegrationList'
    });
}

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageConnectionAzure = __webpack_require__(362);

_app.app.component('companyDirectoryIntegrationManageConnectionAzure', {
    bindings: {
        tenantParameters: '<',
        companyId: '<',
        directoryId: '<'
    },
    controller: _directoryManageConnectionAzure.Controller,
    templateUrl: __webpack_require__(1308)
});

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2451081ff7215fad85c6fe8236eecb7e.html";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

tenantParameters.$inject = ['$filter', 'companyId', 'directoryId', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.connection-azure', {
        url: '/connection-azure',
        component: 'companyDirectoryIntegrationManageConnectionAzure',
        resolve: {
            tenantParameters: tenantParameters
        }
    });
}

/** @ngInject */
function tenantParameters($filter, companyId, directoryId, DirectoriesResource) {
    return DirectoriesResource.getAzureTenantParameters(companyId, directoryId);
}

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deactivateAgent = __webpack_require__(363);

_app.app.component('companyDirectoryIntegrationManageConnectionDeactivateAgent', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _deactivateAgent.Controller,
    templateUrl: __webpack_require__(1311)
});

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9ab26939f9c372e440144bea6c5b3d94.html";

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageConnection = __webpack_require__(364);

_app.app.component('companyDirectoryIntegrationManageConnection', {
    bindings: {
        connectionDetails: '<',
        companyId: '<',
        directory: '<',
        optionalOnPrem: '<'
    },
    controller: _directoryManageConnection.Controller,
    templateUrl: __webpack_require__(1313)
});

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "531e60e57293a510497a3fef87ff8003.html";

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

optionalOnPrem.$inject = ['connectionDetails'];
connectionDetails.$inject = ['companyId', 'directory', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.connection', {
        url: '/connection',
        component: 'companyDirectoryIntegrationManageConnection',
        resolve: {
            connectionDetails: connectionDetails,
            optionalOnPrem: optionalOnPrem
        }
    });
}

/** @ngInject */
function connectionDetails(companyId, directory, DirectoriesResource) {
    if (directory.agentConnected === 'ACTIVE') {
        return DirectoriesResource.getDirectoryConnectionDetails(companyId, directory.id);
    }
    return null;
}

/** @ngInject */
function optionalOnPrem(connectionDetails) {
    return connectionDetails !== null && connectionDetails.adAccountPasswordsCanBeEdited;
}

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _downloadAgent = __webpack_require__(365);

_app.app.component('companyDirectoryIntegrationManageConnectionDownloadAgent', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _downloadAgent.Controller,
    templateUrl: __webpack_require__(1316)
});

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b87842fb248b02100515cfd2a12e7f5d.html";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _onPremisesForm = __webpack_require__(366);

_app.app.component('directoryIntegrationOnPremisesForm', {
    bindings: {
        companyId: '<',
        directoryId: '<',
        initialValue: '<',
        onSave: '&'
    },
    controller: _onPremisesForm.Controller,
    templateUrl: __webpack_require__(1318)
});

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e59ebd6a65e610d8451b7d735aad7a16.html";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _ouImported = __webpack_require__(367);

_app.app.component('companyDirectoryIntegrationManageConnectionOuImported', {
    bindings: { domains: '<' },
    controller: _ouImported.Controller,
    templateUrl: __webpack_require__(1320)
});

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "55fb040a7a41a78687b4d1ae9d942c6f.html";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

domains.$inject = ['companyId', 'directory', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.connection.ou-imported', {
        url: '/ou-imported',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageConnectionOuImported'
        },
        resolve: {
            domains: domains
        }
    });
}

/** @ngInject */
function domains(companyId, directory, DirectoriesResource) {
    return DirectoriesResource.getDomains(companyId, directory.id, directory.type);
}

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManage = __webpack_require__(368);

_app.app.component('companyDirectoryIntegrationManage', {
    bindings: {
        directory: '<',
        companyId: '<',
        directories: '<'
    },
    controller: _directoryManage.Controller,
    templateUrl: __webpack_require__(1323)
});

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97237d04a13a5e72a39982990443ef74.html";

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryIntegration = __webpack_require__(56);

directoryType.$inject = ['directories', 'directoryId'];
directoryId.$inject = ['$stateParams'];
directory.$inject = ['companyId', 'DirectoriesResource', 'directoryId', 'directoryType'];
$breadcrumbs.$inject = ['directory'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage', {
        url: '/manage/:directoryId',
        redirectTo: 'company.directory-integration.manage.main',
        component: 'companyDirectoryIntegrationManage',
        resolve: {
            $breadcrumbs: $breadcrumbs,
            directory: directory,
            directoryId: directoryId,
            directoryType: directoryType
        }
    });
}

/** @ngInject */
function $breadcrumbs(directory) {
    return [{ title: directory.name }];
}

/** @ngInject */
function directory(companyId, DirectoriesResource, directoryId, directoryType) {
    return DirectoriesResource.getDirectory(companyId, directoryId, directoryType).then(function (directory) {
        return (0, _directoryIntegration.toDirectoryDTO)(directory);
    });
}

/** @ngInject */
function directoryId($stateParams) {
    return $stateParams.directoryId;
}

/** @ngInject */
function directoryType(directories, directoryId) {
    /** @ngInject */
    var current = directories.find(function (directory) {
        return directory.id === directoryId;
    });
    return current.type;
}

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageDomainsAzure = __webpack_require__(369);

_app.app.component('companyDirectoryIntegrationManageDomainsAzure', {
    bindings: {
        azureStatus: '<',
        companyId: '<',
        domains: '<',
        directory: '<'
    },
    controller: _directoryManageDomainsAzure.Controller,
    templateUrl: __webpack_require__(1326)
});

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bffe9c5bece125b88d2b87749640140e.html";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

azureStatus.$inject = ['companyId', 'directory', 'DirectoriesResource'];
domains.$inject = ['$filter', 'companyId', 'directory', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains-azure', {
        url: '/domains-azure',
        component: 'companyDirectoryIntegrationManageDomainsAzure',
        resolve: {
            domains: domains,
            azureStatus: azureStatus
        }
    });
}

/** @ngInject */
function domains($filter, companyId, directory, DirectoriesResource) {
    return DirectoriesResource.getDomains(companyId, directory.id, directory.type).then(function (domains) {
        return $filter('orderBy')(domains, 'isInitial', true);
    });
}

/** @ngInject */
function azureStatus(companyId, directory, DirectoriesResource) {
    return DirectoriesResource.getDirectoryStatus(companyId, directory);
}

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addDomain = __webpack_require__(370);

_app.app.component('companyDirectoryIntegrationManageDomainsAddDomain', {
    bindings: {
        companyId: '<',
        directory: '<',
        domains: '<'
    },
    controller: _addDomain.Controller,
    templateUrl: __webpack_require__(1330)
});

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f14225194e804362168b2d72a27446cc.png";

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "79c1580274dd8759e2c4f5e0d495d0d0.html";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains.add-domain', {
        url: '/add-domain',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageDomainsAddDomain'
        }
    });
}

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageConfiguration = __webpack_require__(371);

_app.app.component('companyDirectoryIntegrationManageConfiguration', {
    bindings: {
        companyId: '<',
        directory: '<',
        domains: '<'
    },
    controller: _directoryManageConfiguration.Controller,
    templateUrl: __webpack_require__(1333)
});

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8b6332fdf8feb1d24c0b6f88b2d5bbf5.html";

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deleteDomain = __webpack_require__(372);

_app.app.component('companyDirectoryIntegrationManageDomainsDeleteDomain', {
    bindings: {
        companyId: '<',
        directory: '<',
        domain: '<'
    },
    controller: _deleteDomain.Controller,
    templateUrl: __webpack_require__(1335)
});

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7440f668d047ea8e0de26560675853e2.html";

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

domainId.$inject = ['$stateParams'];
domain.$inject = ['domainId', 'domains'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains.delete-domain', {
        url: '/delete-domain/:domainId',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageDomainsDeleteDomain'
        },
        resolve: {
            domain: domain,
            domainId: domainId
        }
    });
}

/** @ngInject */
function domain(domainId, domains) {
    return domains.find(function (domain) {
        return domain.id === domainId;
    });
}

/** @ngInject */
function domainId($stateParams) {
    return $stateParams.domainId;
}

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageDomains = __webpack_require__(196);

_app.app.component('companyDirectoryIntegrationManageDomains', {
    bindings: { domains: '<' },
    controller: _directoryManageDomains.Controller,
    templateUrl: __webpack_require__(1338)
});

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "023e4f04f70b8134ef641a6915d10229.html";

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

domains.$inject = ['$filter', 'companyId', 'directory', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains', {
        url: '/domains',
        component: 'companyDirectoryIntegrationManageDomainsConfiguration',
        resolve: {
            domains: domains
        }
    });
}

/** @ngInject */
function domains($filter, companyId, directory, DirectoriesResource) {
    return DirectoriesResource.getDomains(companyId, directory.id, directory.type).then(function (domains) {
        return $filter('orderBy')(domains, 'isRootDomain', true);
    });
}

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageDomains = __webpack_require__(196);

_app.app.component('companyDirectoryIntegrationManageDomainsConfiguration', {
    bindings: {
        companyId: '<',
        directory: '<',
        domains: '<'
    },
    controller: _directoryManageDomains.Controller,
    templateUrl: __webpack_require__(1341)
});

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a9d3f7d2d679e371ce3a586ab4bf4e9e.html";

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editDomain = __webpack_require__(373);

_app.app.component('companyDirectoryIntegrationManageDomainsEditDomain', {
    bindings: {
        companyId: '<',
        directory: '<',
        domain: '<'
    },
    controller: _editDomain.Controller,
    templateUrl: __webpack_require__(1343)
});

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7c687c68bed2718b13e90937e0f1cb20.html";

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

domainId.$inject = ['$stateParams'];
domain.$inject = ['domainId', 'domains'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains.edit-domain', {
        url: '/edit-domain/:domainId',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageDomainsEditDomain'
        },
        resolve: {
            domain: domain,
            domainId: domainId
        }
    });
}

/** @ngInject */
function domain(domainId, domains) {
    return domains.find(function (domain) {
        return domain.id === domainId;
    });
}

/** @ngInject */
function domainId($stateParams) {
    return $stateParams.domainId;
}

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyDirectoryIntegrationManageInstructionsAzure', {
    bindings: {},
    templateUrl: __webpack_require__(1346)
});

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3b00cd046a684efee0ca6fa0aebe1fb4.html";

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.instructions-azure', {
        url: '/instructions-azure',
        component: 'companyDirectoryIntegrationManageInstructionsAzure',
        resolve: {}
    });
}

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageMain = __webpack_require__(374);

_app.app.component('companyDirectoryIntegrationManageMain', {
    bindings: {
        companyId: '<',
        directory: '<',
        rootDomain: '<'
    },
    controller: _directoryManageMain.Controller,
    templateUrl: __webpack_require__(1349)
});

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a63aa5b9ee4168d91fbc9f5e4772ec2f.html";

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.main', {
        url: '/main',
        component: 'companyDirectoryIntegrationManageMain'
    });
}

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeDirectory = __webpack_require__(375);

_app.app.component('companyDirectoryIntegrationManageMainRemove', {
    bindings: {
        companyId: '<',
        directory: '<'
    },
    controller: _removeDirectory.Controller,
    templateUrl: __webpack_require__(1352)
});

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "80382f5cd5aae44a31f4181e44d13b48.html";

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.main.remove', {
        url: '/remove',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageMainRemove'
        }
    });
}

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageConnectionScim = __webpack_require__(376);

_app.app.component('companyDirectoryIntegrationManageConnectionScim', {
    bindings: {
        conConfig: '<',
        companyId: '<',
        directoryId: '<'
    },
    controller: _directoryManageConnectionScim.Controller,
    templateUrl: __webpack_require__(1355)
});

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "06f10f2cbe81fb8c1279481eb536446a.html";

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

conConfig.$inject = ['companyId', 'directoryId', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.connection-scim', {
        url: '/connection-scim',
        component: 'companyDirectoryIntegrationManageConnectionScim',
        resolve: {
            conConfig: conConfig
        }
    });
}

/** @ngInject */
function conConfig(companyId, directoryId, DirectoriesResource) {
    return DirectoriesResource.getScimConfig(companyId, directoryId);
}

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyDirectoryIntegrationManageInstructionsScim', {
    bindings: {},
    templateUrl: __webpack_require__(1358)
});

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "84ba846a70a1ef649b9f0aebfb3dd785.html";

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.instructions-scim', {
        url: '/instructions-scim',
        component: 'companyDirectoryIntegrationManageInstructionsScim',
        resolve: {}
    });
}

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directoryManageSyncAndProvScim = __webpack_require__(377);

_app.app.component('companyDirectoryIntegrationManageSyncAndProvScim', {
    bindings: {
        directoryStatus: '<',
        companyId: '<',
        directory: '<'
    },
    controller: _directoryManageSyncAndProvScim.Controller,
    templateUrl: __webpack_require__(1361)
});

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6b49ed64f9a56e60e05ba7d601e07eb3.html";

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

directoryStatus.$inject = ['companyId', 'directory', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.sync-and-prov-scim', {
        url: '/sync-and-prov-scim',
        component: 'companyDirectoryIntegrationManageSyncAndProvScim',
        resolve: {
            directoryStatus: directoryStatus
        }
    });
}

/** @ngInject */
function directoryStatus(companyId, directory, DirectoriesResource) {
    return DirectoriesResource.getDirectoryStatus(companyId, directory);
}

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _domains = __webpack_require__(378);

_app.app.component('companyDomains', {
    bindings: { domains: '<' },
    controller: _domains.Controller,
    templateUrl: __webpack_require__(1364)
});

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "343d7e9091eb8b677a65424bb68f88b3.html";

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

DomainsService.$inject = ['$resource'];


_app.app.factory('DomainsService', DomainsService);

/** @ngInject */
function DomainsService($resource) {
    return $resource('app/rest/:companyId/domains/:id', { companyId: '@companyId', id: "@id" }, {});
}

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

domains.$inject = ['companyId', 'DomainsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.domains', {
        url: '/domains',
        component: 'companyDomains',
        resolve: { domains: domains }
    });
}

function domains(companyId, DomainsService) {
    return DomainsService.query({ companyId: companyId }).$promise;
}

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _googleHangoutsBot = __webpack_require__(379);

_app.app.component('companyGoogleHangoutsBot', {
    bindings: { appType$: '<' },
    controller: _googleHangoutsBot.Controller,
    templateUrl: __webpack_require__(1368)
});

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7ad47655c43f673d24f32382df22c06c.html";

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.google-hangouts-bot', {
        url: '/google-hangouts-bot',
        component: 'companyGoogleHangoutsBot'
    });
}

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _googleMarketplaceConfiguration = __webpack_require__(380);

_app.app.component('googleMarketplaceConfiguration', {
    templateUrl: __webpack_require__(1372),
    controller: _googleMarketplaceConfiguration.Controller
});

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c591f4e6b931b3e85edfb778d0b59977.html";

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('gmp-config', {
        url: '/gmpconfig',
        component: 'googleMarketplaceConfiguration'
    });
}

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _googleMarketplaceInstructions = __webpack_require__(381);

_app.app.component('companyGoogleMarketplaceInstructions', {
  bindings: {
    appType$: '<',
    companyId: '<'
  },
  controller: _googleMarketplaceInstructions.Controller,
  templateUrl: __webpack_require__(1375)
});

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dbb8e04e371d7efb89d9611fb4dacb33.html";

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.google-marketplace-instructions', {
        url: '/googleMarketPlaceInstructions',
        component: 'companyGoogleMarketplaceInstructions'
    });
}

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _fidoAdd = __webpack_require__(382);

_app.app.component('addFidoTokens', {
  // bindings: {close: '&', dismiss: '&', resolve: '<'},
  // bindings: { companyId: '<'},
  controller: _fidoAdd.Controller,
  templateUrl: __webpack_require__(1378)
});

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba6b0bc03c436ae476344b025ea13fa9.html";

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.fido-add', {
        url: '/add-fido-tokens',
        // component: 'addFidoTokens'
        views: {
            '@company': 'addFidoTokens'
        }
    });
}

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hotpTotpAdd = __webpack_require__(383);

_app.app.component('addHotpTotpTokens', {
    controller: _hotpTotpAdd.Controller,
    templateUrl: __webpack_require__(1381)
});

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "71f0399e13fff0369592c1b73990284e.html";

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.hotp-totp-add', {
        url: '/add-hard-tokens',
        // component: 'addFidoTokens'
        views: {
            '@company': 'addHotpTotpTokens'
        }
    });
}

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _usbAdd = __webpack_require__(384);

_app.app.component('addUsbTokens', {
    controller: _usbAdd.Controller,
    templateUrl: __webpack_require__(1386)
});

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "243d0b547fc25182b9fbafb6420f3fbe.html";

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "289fcc29032e4cbc0c6f2fa823979f02.html";

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e8d022eadd0e979dd0992f9dba5aafed.html";

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.usb-add', {
        url: '/add-usb-tokens',
        views: {
            '@company': 'addUsbTokens'
        }
    });
}

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('editHardToken', {
    bindings: {
        companyId: '<',
        token: '<'
    },
    templateUrl: __webpack_require__(1389)
});

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ff7c5f581f22ee5ca3861a8573eb0b0f.html";

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

token.$inject = ['$stateParams', 'HardTokenService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.edit', {
        url: '/edit/:hardTokenId',
        params: { token: {}, hardtokenId: null },
        redirectTo: 'company.hard-token-management.edit.settings',
        //component: 'editHardToken',
        views: {
            '@company': 'editHardToken'
        },
        resolve: { token: token }
    });
}

/** @ngInject */
function token($stateParams, HardTokenService) {
    if (Object.keys($stateParams.token).length != 0) {
        return $stateParams.token;
    } else {
        var id = $stateParams.hardTokenId;
        return HardTokenService.get(id);
    }
}

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenRegistration = __webpack_require__(387);

_app.app.component('editHardTokenRegistration', {
     bindings: {
          companyId: '<',
          token: '=',
          regEmailData: '<'
     },
     controller: _hardTokenRegistration.Controller,
     templateUrl: __webpack_require__(1392)
});

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61934a9160c14297d25883e4dc040b32.html";

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

regEmailData.$inject = ['HardTokenService', 'token'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.edit.registration', {
        url: '/registration',
        component: 'editHardTokenRegistration',
        resolve: { regEmailData: regEmailData }
    });
}
/** @ngInject */
function regEmailData(HardTokenService, token) {

    return HardTokenService.getRegEmailData(token);
}

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenSettings = __webpack_require__(388);

_app.app.component('editHardTokenSettings', {
     bindings: {
          companyId: '<',
          token: '='
     },
     controller: _hardTokenSettings.Controller,
     templateUrl: __webpack_require__(1395)
});

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "95eeb6a9385dad1f8fcaa366300d6ef5.html";

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.edit.settings', {
        url: '/settings',
        component: 'editHardTokenSettings'

    });
}

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenSynchronize = __webpack_require__(389);

_app.app.component('editHardTokenSynchronize', {
     bindings: {
          companyId: '<',
          token: '<'
     },
     controller: _hardTokenSynchronize.Controller,
     templateUrl: __webpack_require__(1398)
});

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "00ecb2992edaeaec3b599a1b9a7e3678.html";

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.edit.synchronize', {
        url: '/synch',
        component: 'editHardTokenSynchronize'

    });
}

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenImporterCsv = __webpack_require__(390);

_app.app.component('hardTokenImporterCsv', {
    templateUrl: __webpack_require__(1401),
    controller: _hardTokenImporterCsv.Controller,
    bindings: {
        type: '<',
        otpType: '<',
        tokens: '<',
        onChange: '&'
    }
});

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c63b3a3e5575a9e80f55a9f5f01c16f3.html";

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenImporterTable = __webpack_require__(392);

_app.app.component('hardTokenImporterTable', {
    templateUrl: __webpack_require__(1404),
    controller: _hardTokenImporterTable.Controller,
    bindings: {
        type: '<',
        otpType: '<',
        tokens: '<',
        onChange: '&'
    }
});

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "34d28559fecc372eed32e11c1549aa5d.html";

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _integrateFidoU2f = __webpack_require__(393);

_app.app.component('integrateFidoU2f', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _integrateFidoU2f.Controller,
    templateUrl: __webpack_require__(1407)
});

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "294581286acd692e8f4dcf6eff2c6a7b.html";

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _integrateHardToken = __webpack_require__(394);

_app.app.component('integrateHardToken', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _integrateHardToken.Controller,
    templateUrl: __webpack_require__(1409)
});

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bfa66ce2e5915cb7f6eb5cb94ff70c2d.html";

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _integrateUsbToken = __webpack_require__(395);

_app.app.component('integrateUsbToken', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _integrateUsbToken.Controller,
    templateUrl: __webpack_require__(1413)
});

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "243d0b547fc25182b9fbafb6420f3fbe.html";

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "289fcc29032e4cbc0c6f2fa823979f02.html";

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e91d60d7227dbb828a11ef2a78dba851.html";

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenManagement = __webpack_require__(398);

_app.app.component('companyHardTokenManagement', {
    bindings: {
        companyId: '<',
        hardTokens: '<'
    },
    controller: _hardTokenManagement.Controller,
    templateUrl: __webpack_require__(1416)
});

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e77c66642a43f7e8df553f77edb05500.html";

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

hardTokens.$inject = ['$filter', 'HardTokenService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management', {
        url: '/hard-token-management',
        component: 'companyHardTokenManagement',
        resolve: { hardTokens: hardTokens }
    });
}

/** @ngInject */
function hardTokens($filter, HardTokenService) {
    return HardTokenService.list().then(function (items) {
        return $filter('orderBy')(items, 'effectiveStatus');
    });
}

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenSync = __webpack_require__(399);

_app.app.component('companyHardTokenManagementSync', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _hardTokenSync.Controller,
    templateUrl: __webpack_require__(1420)
});

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8385e449593e21b6d55cb7878a6b5cab.html";

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _idpAuthenticatorAdd = __webpack_require__(400);

_app.app.component('companyIdpAuthenticatorsAdd', {
    bindings: {
        companyId: '<',
        idpAuthenticators: '<'
    },
    controller: _idpAuthenticatorAdd.Controller,
    templateUrl: __webpack_require__(1422)
});

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "703ad48b90c4942fbab1e5dd9cdc2d12.html";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.add', {
        url: '/add',
        component: 'companyIdpAuthenticatorsAdd',
        resolve: {}

    });
}

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _idpAuthenticators = __webpack_require__(401);

_app.app.component('companyIdpAuthenticators', {
    controller: _idpAuthenticators.Controller,
    templateUrl: __webpack_require__(1425)
});

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f82ce76d703b19e95f033c8d3284c4f2.html";

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IdpAuthenticatorsService = function () {
    IdpAuthenticatorsService.$inject = ['$http'];

    /** @ngInject */
    function IdpAuthenticatorsService($http) {
        _classCallCheck(this, IdpAuthenticatorsService);

        this.$http = $http;
    }

    _createClass(IdpAuthenticatorsService, [{
        key: 'getIdpAuthenticators',
        value: function getIdpAuthenticators(companyId) {
            var url = 'app/rest/' + companyId + '/idpauthenticators';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'createIdpAuthenticator',
        value: function createIdpAuthenticator(companyId, name, type) {
            var url = 'app/rest/' + companyId + '/idpauthenticators';
            var params = { name: name, type: type };
            return this.$http.post(url, null, { params: params }).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'updateIdpAuthenticator',
        value: function updateIdpAuthenticator(companyId, idpAuthenticator) {
            var url = 'app/rest/' + companyId + '/idpauthenticators/' + idpAuthenticator.id;
            return this.$http.put(url, idpAuthenticator).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'uploadMetadataXml',
        value: function uploadMetadataXml(companyId, idpAuthenticatorId, metadataStr) {
            var url = 'app/rest/' + companyId + '/idpauthenticators/' + idpAuthenticatorId + '/saml/metadata';
            return this.$http.post(url, metadataStr).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'uploadMetadataUrl',
        value: function uploadMetadataUrl(companyId, idpAuthenticatorId, metadataUrl) {
            var url = 'app/rest/' + companyId + '/idpauthenticators/' + idpAuthenticatorId + '/saml/metadataurl';
            return this.$http.post(url, metadataUrl).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'deleteIdpAuthenticator',
        value: function deleteIdpAuthenticator(companyId, idpAuthenticatorId, params) {
            var url = 'app/rest/' + companyId + '/idpauthenticators/' + idpAuthenticatorId;
            return this.$http.delete(url, { params: params }).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'getAssignedApplications',
        value: function getAssignedApplications(companyId, idpAuthenticatorId) {
            var url = 'app/rest/' + companyId + '/idpauthenticators/' + idpAuthenticatorId + '/applications';
            return this.$http.get(url, { params: { type: 'assigned' } }).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }, {
        key: 'getAssignableApplications',
        value: function getAssignableApplications(companyId, idpAuthenticatorId) {
            var url = 'app/rest/' + companyId + '/idpauthenticators/' + idpAuthenticatorId + '/applications';
            return this.$http.get(url, { params: { type: 'assignable' } }).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            });
        }
    }, {
        key: 'assignApplications',
        value: function assignApplications(companyId, idpAuthenticatorId, applicationIds) {
            var url = 'app/rest/' + companyId + '/idpauthenticators/' + idpAuthenticatorId + '/applications';
            return this.$http.put(url, applicationIds).then(function (_ref9) {
                var data = _ref9.data;
                return data;
            });
        }
    }, {
        key: 'unassignApplications',
        value: function unassignApplications(companyId, idpAuthenticatorId, applicationIds) {
            var url = 'app/rest/' + companyId + '/idpauthenticators/' + idpAuthenticatorId + '/applications';
            return this.$http.post(url, applicationIds).then(function (_ref10) {
                var data = _ref10.data;
                return data;
            });
        }
    }]);

    return IdpAuthenticatorsService;
}();

_app.app.service('IdpAuthenticatorsService', IdpAuthenticatorsService);

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

idpAuthenticators.$inject = ['companyId', 'IdpAuthenticatorsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators', {
        url: '/idp-authenticators',
        redirectTo: 'company.idp-authenticators.list',
        component: 'companyIdpAuthenticators',
        resolve: { idpAuthenticators: idpAuthenticators }
    });
}

/** @ngInject */
function idpAuthenticators(companyId, IdpAuthenticatorsService) {
    return IdpAuthenticatorsService.getIdpAuthenticators(companyId);
}

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _idpAuthenticatorsList = __webpack_require__(402);

_app.app.component('companyIdpAuthenticatorsList', {
    bindings: {
        companyId: '<',
        idpAuthenticators: '<'
    },
    controller: _idpAuthenticatorsList.Controller,
    templateUrl: __webpack_require__(1429)
});

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f14104c4bd5aa6f90ac99c841023c0b1.html";

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.list', {
        url: '/list',
        component: 'companyIdpAuthenticatorsList',
        resolve: {}
    });
}

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _idpAuthenticatorApplicationsAssign = __webpack_require__(403);

_app.app.component('companyIdpAuthenticatorsManageApplicationsAssign', {
    bindings: {
        companyId: '<',
        idpAuthenticator: '<',
        applications: '<'
    },
    controller: _idpAuthenticatorApplicationsAssign.Controller,
    templateUrl: __webpack_require__(1432)
});

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2f84d74458ba0630c66997817678d974.html";

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _spUtil = __webpack_require__(73);

applications.$inject = ['companyId', 'idpAuthenticator', 'IdpAuthenticatorsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage.applications.assign', {
        url: '/assign',
        views: {
            '@company.idp-authenticators.manage': 'companyIdpAuthenticatorsManageApplicationsAssign'
        },
        resolve: {
            applications: applications
        }
    });
}

/** @ngInject */
function applications(companyId, idpAuthenticator, IdpAuthenticatorsService) {
    return IdpAuthenticatorsService.getAssignableApplications(companyId, idpAuthenticator.id).then(function (applications) {
        return applications.map(function (app) {
            return _extends({}, app, { protocol: (0, _spUtil.appProtocolDisplayName)(app) });
        });
    });
}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _idpAuthenticatorApplications = __webpack_require__(404);

_app.app.component('companyIdpAuthenticatorsManageApplications', {
    bindings: {
        companyId: '<',
        idpAuthenticator: '<',
        applications: '<'
    },
    controller: _idpAuthenticatorApplications.Controller,
    templateUrl: __webpack_require__(1435)
});

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "59bef34e0219fddf1136a28b2f5416c6.html";

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _spUtil = __webpack_require__(73);

applications.$inject = ['idpAuthenticator', 'companyId', 'IdpAuthenticatorsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage.applications', {
        url: '/applications',
        views: {
            '@company.idp-authenticators.manage': 'companyIdpAuthenticatorsManageApplications'
        },
        resolve: {
            applications: applications
        }

    });
}

/** @ngInject */
function applications(idpAuthenticator, companyId, IdpAuthenticatorsService) {
    if (idpAuthenticator != null) {
        return IdpAuthenticatorsService.getAssignedApplications(companyId, idpAuthenticator.id).then(function (applications) {
            return applications.map(function (app) {
                return _extends({}, app, { protocol: (0, _spUtil.appProtocolDisplayName)(app) });
            });
        });
    }
}

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _idpAuthenticatorConfig = __webpack_require__(405);

_app.app.component('companyIdpAuthenticatorsManageConfig', {
    bindings: {
        companyId: '<',
        idpAuthenticator: '<',
        idpAuthenticators: '<'
    },
    controller: _idpAuthenticatorConfig.Controller,
    templateUrl: __webpack_require__(1438)
});

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "255c57cd7e8ba07b7b84f50e8afb387a.html";

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage.config', {
        url: '/config',
        component: 'companyIdpAuthenticatorsManageConfig',
        resolve: {}

    });
}

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _idpAuthenticatorManage = __webpack_require__(406);

_app.app.component('companyIdpAuthenticatorsManage', {
    bindings: {
        companyId: '<',
        idpAuthenticators: '<',
        idpAuthenticator: '<'
    },
    controller: _idpAuthenticatorManage.Controller,
    templateUrl: __webpack_require__(1441)
});

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "26b1ebe23ddcc6d2fcfdaeb1172efb69.html";

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

idpAuthenticator.$inject = ['idpAuthenticators', '$stateParams'];
$breadcrumbs.$inject = ['idpAuthenticator'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage', {
        url: '/manage/:idpAuthenticatorId',
        redirectTo: 'company.idp-authenticators.manage.config',
        component: 'companyIdpAuthenticatorsManage',
        resolve: {
            $breadcrumbs: $breadcrumbs,
            idpAuthenticator: idpAuthenticator
        }

    });
}

/** @ngInject */
function idpAuthenticator(idpAuthenticators, $stateParams) {
    return idpAuthenticators.find(function (idp) {
        return idp.id === $stateParams.idpAuthenticatorId;
    });
}

/** @ngInject */
function $breadcrumbs(idpAuthenticator) {
    if (idpAuthenticator == null) {
        return;
    }
    var title = {
        // getter to allow dynamic updates
        get title() {
            return idpAuthenticator.name;
        }
    };

    return [{ stateName: 'company.idp-authenticators.manage' }, title];
}

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyIdpAuthenticatorsManageIntegration', {
    templateUrl: __webpack_require__(1444)
});

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ae4199be1b045c34d494d259a8a9d7fa.html";

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage.integration', {
        url: '/integration',
        component: 'companyIdpAuthenticatorsManageIntegration',
        resolve: {}

    });
}

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('idpAuthenticatorManageTabs', {
    templateUrl: __webpack_require__(1447)
});

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2dc139d1daf61bfb01a95e7b8faff4c7.html";

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _landingPage = __webpack_require__(407);

_app.app.component('companyLandingPage', {
    bindings: {
        currentCompany: '<',
        reg: '<',
        licenseInfo: '<'
    },
    controller: _landingPage.Controller,
    templateUrl: __webpack_require__(1449)
});

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "37665550d487b3aeecc035687bfa9adc.html";

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

reg.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.landing-page', {
        url: '?reg',
        component: 'companyLandingPage',
        resolve: {
            reg: reg
        }
    });
}

/** @ngInject */
function reg($stateParams) {
    return $stateParams.reg;
}

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('whatsNewAlertModal', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1452)
});

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1b0b038565bbf20e793173f37d5ca101.html";

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _licenseActivities = __webpack_require__(408);

_app.app.component('licenseActivities', {
    bindings: {
        activities: '<'
    },
    controller: _licenseActivities.Controller,
    templateUrl: __webpack_require__(1454)
});

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cdb8d7584f0da562952f71ba7fd4ea4d.html";

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

activities.$inject = ['LicenseManagementService', '$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.activities', {
        url: '/activities',
        component: 'licenseActivities',
        resolve: {
            activities: activities
        }
    });
}

/** @ngInject */
function activities(LicenseManagementService, $stateParams) {
    return LicenseManagementService.getLicenseActivities($stateParams.companyId);
}

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _currentPlan = __webpack_require__(409);

_app.app.component('currentPlan', {
    bindings: {
        licenseDetails: '<',
        licenseTiers: '<'
    },
    controller: _currentPlan.Controller,
    templateUrl: __webpack_require__(1457)
});

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e4426e71b83283a94cacee19f2edf9f7.html";

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.current-plan', {
        url: '/currentPlan',
        component: 'currentPlan'
    });
}

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _subscriptionInfo = __webpack_require__(410);

_app.app.component('subscriptionInfo', {
    bindings: {
        licenseInfo: '<',
        currentPlan: '<',
        licenseTiers: '<'
    },
    controller: _subscriptionInfo.Controller,
    templateUrl: __webpack_require__(1460)
});

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5918a2dbf3017d231975a662e1258d50.html";

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _licenseInvoices = __webpack_require__(411);

_app.app.component('licenseInvoices', {
    bindings: {
        invoices: '<'
    },
    controller: _licenseInvoices.Controller,
    templateUrl: __webpack_require__(1462)
});

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "15ca5c0ef4785973764cba21ae096b5e.html";

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

invoices.$inject = ['LicenseManagementService', '$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.invoices', {
        url: '/invoices',
        component: 'licenseInvoices',
        resolve: {
            invoices: invoices
        }
    });
}

/** @ngInject */
function invoices(LicenseManagementService, $stateParams) {
    return LicenseManagementService.getLicenseInvoices($stateParams.companyId);
}

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _licenseManagement = __webpack_require__(412);

_app.app.component('licenseManagement', {
    bindings: {
        licenseDetails: '<',
        licenseTiers: '<'
    },
    controller: _licenseManagement.Controller,
    templateUrl: __webpack_require__(1465)
});

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "832d5f1323feda7a3fb85f1b88c025c3.html";

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LicenseManagementService = function () {
    LicenseManagementService.$inject = ['$http'];

    /** @ngInject */
    function LicenseManagementService($http) {
        _classCallCheck(this, LicenseManagementService);

        this.$http = $http;
    }

    _createClass(LicenseManagementService, [{
        key: 'licenseCheck',
        value: function licenseCheck(companyId) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-check';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getLicenseDetails',
        value: function getLicenseDetails(companyId) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-details';
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'getLicenseTiers',
        value: function getLicenseTiers(companyId) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-tiers';
            return this.$http.get(url).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'licensePurchase',
        value: function licensePurchase(companyId, purchaseDTO) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-purchase';
            return this.$http.post(url, purchaseDTO).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'upgradeLicense',
        value: function upgradeLicense(companyId, purchaseDTO) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-upgrade';
            return this.$http.post(url, purchaseDTO).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'upgradeLicenseTier',
        value: function upgradeLicenseTier(companyId, purchaseDTO) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-tierupgrade';
            return this.$http.post(url, purchaseDTO).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'calculateLicenseCharges',
        value: function calculateLicenseCharges(companyId, purchaseDTO) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-calculatecharges';
            return this.$http.post(url, purchaseDTO).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }, {
        key: 'cancelAutoRenewal',
        value: function cancelAutoRenewal(companyId) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-cancelrenewal';
            return this.$http.get(url).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            });
        }
    }, {
        key: 'getLicenseInvoices',
        value: function getLicenseInvoices(companyId) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-invoices';
            return this.$http.get(url).then(function (_ref9) {
                var data = _ref9.data;
                return data;
            });
        }
    }, {
        key: 'getLicenseActivities',
        value: function getLicenseActivities(companyId) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-activities';
            return this.$http.get(url).then(function (_ref10) {
                var data = _ref10.data;
                return data;
            });
        }
    }, {
        key: 'changeLicenseEmail',
        value: function changeLicenseEmail(companyId, email) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-changeemail?email=' + email;
            return this.$http.get(url).then(function (_ref11) {
                var data = _ref11.data;
                return data;
            });
        }
    }, {
        key: 'cancelWaitingActivity',
        value: function cancelWaitingActivity(companyId) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-cancelwaitingactivity';
            return this.$http.get(url).then(function (_ref12) {
                var data = _ref12.data;
                return data;
            });
        }
    }, {
        key: 'setPaymentMethod',
        value: function setPaymentMethod(companyId) {
            var url = 'app/rest/' + companyId + '/licensemanagement/license-setpaymentmethod';
            return this.$http.get(url, { transformResponse: [] }).then(function (_ref13) {
                var data = _ref13.data;
                return data;
            });
        }
    }]);

    return LicenseManagementService;
}();

_app.app.service('LicenseManagementService', LicenseManagementService);

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

licenseTiers.$inject = ['LicenseManagementService', '$stateParams'];
licenseDetails.$inject = ['LicenseManagementService', '$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management', {
        url: '/licenseManagement',
        component: 'licenseManagement',
        redirectTo: 'company.license-management.current-plan',
        resolve: {
            licenseDetails: licenseDetails,
            licenseTiers: licenseTiers
        }
    });
}

/** @ngInject */
function licenseDetails(LicenseManagementService, $stateParams) {
    return LicenseManagementService.getLicenseDetails($stateParams.companyId);
}

/** @ngInject */
function licenseTiers(LicenseManagementService, $stateParams) {
    return LicenseManagementService.getLicenseTiers($stateParams.companyId);
}

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _purchaseLicense = __webpack_require__(413);

_app.app.component('purchaseLicense', {
    bindings: {
        licenseDetails: '<',
        licenseTiers: '<'
    },
    controller: _purchaseLicense.Controller,
    templateUrl: __webpack_require__(1469)
});

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "83dcc9eb0c813b7b65d6e1f190f5b54f.html";

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.purchase-license', {
        url: '/purchase',
        component: 'purchaseLicense',
        resolve: {}
    });
}

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _licenseTierDetails = __webpack_require__(414);

_app.app.component('licenseManagementTierDetails', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _licenseTierDetails.Controller,
    templateUrl: __webpack_require__(1472)
});

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "94033028a0c9ab1a36bdabaa5cee33d7.html";

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('LicenseTierDetails', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_tiers) {
        return $uibModal.open({
            component: 'licenseManagementTierDetails',
            resolve: {
                tiers: function tiers() {
                    return _tiers;
                }
            },
            windowClass: 'tier-details-modal-window'
        }).result;
    };
}

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addSeat = __webpack_require__(415);

_app.app.component('upgradeLicenseSeat', {
    bindings: {
        licenseDetails: '<',
        licenseTiers: '<'
    },
    controller: _addSeat.Controller,
    templateUrl: __webpack_require__(1475)
});

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d6dd0e1bfe7aa21a30169176c713eb36.html";

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.upgrade-license.seat', {
        url: '/seat',
        component: 'upgradeLicenseSeat',
        resolve: {}
    });
}

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _upgradeLicenseTier = __webpack_require__(416);

_app.app.component('upgradeLicenseTier', {
    bindings: {
        licenseDetails: '<',
        licenseTiers: '<'
    },
    controller: _upgradeLicenseTier.Controller,
    templateUrl: __webpack_require__(1478)
});

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "370496191a843e2f248bf11a16b58b4e.html";

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.upgrade-license.tier', {
        url: '/tier',
        component: 'upgradeLicenseTier',
        resolve: {}
    });
}

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _upgradeLicense = __webpack_require__(417);

_app.app.component('upgradeLicense', {
    bindings: {
        licenseDetails: '<',
        licenseTiers: '<'
    },
    controller: _upgradeLicense.Controller,
    templateUrl: __webpack_require__(1481)
});

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "40ba2272c6e5cb62c9e50b2d2a1ade3f.html";

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.upgrade-license', {
        url: '/upgrade',
        component: 'upgradeLicense',
        redirectTo: 'company.license-management.upgrade-license.tier',
        resolve: {}
    });
}

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

var _group = __webpack_require__(84);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApplicationsResource = function () {
    ApplicationsResource.$inject = ['$http'];

    /** @ngInject */
    function ApplicationsResource($http) {
        _classCallCheck(this, ApplicationsResource);

        this.$http = $http;
    }

    _createClass(ApplicationsResource, [{
        key: 'getAllApplicationsForCompany',
        value: function getAllApplicationsForCompany(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getAllComputerProtectionApplicationsForCompany',
        value: function getAllComputerProtectionApplicationsForCompany(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications';
            var params = { type: 'computer' };
            return this.$http.get(url, { params: params }).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'getAllCustomApplicationsForCompany',
        value: function getAllCustomApplicationsForCompany(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications';
            var params = { type: 'custom' };
            return this.$http.get(url, { params: params }).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationConfiguration',
        value: function getApplicationConfiguration(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId;

            return this.$http.get(url).then(function (_ref4) {
                var data = _ref4.data;
                return _extends({}, data, {
                    loginRoles: data.loginRoles || []
                });
            }).then(function (data) {
                return _extends({}, data, {
                    ilQrCodeSettings: data.ilQrCodeSettings && {
                        qrCodeBackgroundColor: '#' + data.ilQrCodeSettings.qrCodeBackgroundColor,
                        qrCodeForegroundColor: '#' + data.ilQrCodeSettings.qrCodeForegroundColor,
                        qrCodeSize: data.ilQrCodeSettings.qrCodeSize
                    },
                    irQrCodeSettings: data.irQrCodeSettings && {
                        qrCodeBackgroundColor: '#' + data.irQrCodeSettings.qrCodeBackgroundColor,
                        qrCodeForegroundColor: '#' + data.irQrCodeSettings.qrCodeForegroundColor,
                        qrCodeSize: data.irQrCodeSettings.qrCodeSize
                    }
                });
            }).then(function (data) {
                [data].filter(function (data) {
                    return data.epmAppSettings;
                }).filter(function (data) {
                    return data.epmAppSettings.publicService.slug === 'other';
                }).forEach(function (data) {
                    return data.epmAppSettings.publicService.serviceName = 'Custom';
                });
                return data;
            });
        }
    }, {
        key: 'updateApplicationConfiguration',
        value: function updateApplicationConfiguration(companyId, applicationId, config) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId;
            return this.$http.put(url, sanitize(config)).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });

            function sanitize(config) {
                return _extends({}, config, {
                    companyAdDomains: undefined,
                    ssoPostUrl: config.ssoEnabled && config.ssoPostUrl || undefined
                });
            }
        }
    }, {
        key: 'getApplicationHelpInfo',
        value: function getApplicationHelpInfo(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/helpinfo';
            return this.$http.get(url).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationSamlAssertionAttributes',
        value: function getApplicationSamlAssertionAttributes(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/assertions';
            return this.$http.get(url).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }, {
        key: 'updateApplicationSamlAssertionAttributes',
        value: function updateApplicationSamlAssertionAttributes(companyId, applicationId, attribs) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/assertions';
            return this.$http.put(url, attribs).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            });
        }
    }, {
        key: 'deleteApplication',
        value: function deleteApplication(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId;
            var params = { action: 'delete' };
            return this.$http.delete(url, null, { params: params }).then(function (_ref9) {
                var data = _ref9.data;
                return data;
            });
        }
    }, {
        key: 'changeApplicationStatus',
        value: function changeApplicationStatus(companyId, applicationId, status) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId;
            var params = { action: 'status', status: status };
            return this.$http.put(url, null, { params: params }).then(function (_ref10) {
                var data = _ref10.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationAssignedGroups',
        value: function getApplicationAssignedGroups(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/assignedgroups';
            return this.$http.get(url).then(function (_ref11) {
                var data = _ref11.data;
                return data;
            }).then(function (groups) {
                return groups.map(function (group) {
                    var appRoleIds = group.appRoleIds || [];
                    return _extends({}, group, { appRoleIds: appRoleIds });
                });
            }).then(function (groups) {
                return groups.map(_group.groupFromDto);
            });
        }
    }, {
        key: 'getApplicationNotAssignedGroups',
        value: function getApplicationNotAssignedGroups(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/notassignedgroups';
            return this.$http.get(url).then(function (_ref12) {
                var data = _ref12.data;
                return data;
            }).then(function (groups) {
                return groups.map(_group.groupFromDto);
            });
        }
    }, {
        key: 'assignGroups',
        value: function assignGroups(companyId, applicationId, groupsWithRoles) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/groups';
            var params = { action: 'assign' };
            return this.$http.put(url, groupsWithRoles, { params: params }).then(function (_ref13) {
                var data = _ref13.data;
                return data;
            });
        }
    }, {
        key: 'unassignGroup',
        value: function unassignGroup(companyId, applicationId, groupId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/group';
            var params = { action: 'unassign' };
            return this.$http.put(url, groupId, { params: params }).then(function (_ref14) {
                var data = _ref14.data;
                return data;
            });
        }
    }, {
        key: 'updateAwsGroupRoles',
        value: function updateAwsGroupRoles(companyId, applicationId, groupsWithRoles) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/groups';
            var params = { action: 'updateroles' };
            return this.$http.put(url, groupsWithRoles, { params: params }).then(function (_ref15) {
                var data = _ref15.data;
                return data;
            });
        }
    }, {
        key: 'getUsageData',
        value: function getUsageData(companyId, applicationId, filterUser, periodFilter, displayData, saaspassId, startDate, endDate) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/usagedata';
            var params = {
                filterUser: filterUser,
                periodFilter: periodFilter,
                displayData: displayData,
                saaspassId: saaspassId,
                startDate: startDate,
                endDate: endDate,
                timeZone: new Date().getTimezoneOffset() / -60
            };
            return this.$http.get(url, { params: params }).then(function (_ref16) {
                var data = _ref16.data;
                return data;
            });
        }
    }, {
        key: 'regeneratePassword',
        value: function regeneratePassword(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/regeneratepass';
            return this.$http.put(url).then(function (_ref17) {
                var data = _ref17.data;
                return data;
            });
        }
    }, {
        key: 'sha2CertUpdate',
        value: function sha2CertUpdate(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/sha2CertUpdate';
            return this.$http.get(url).then(function (_ref18) {
                var data = _ref18.data;
                return data;
            });
        }
    }, {
        key: 'changeNonDomainComputerProtectionKey',
        value: function changeNonDomainComputerProtectionKey(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/changeNonDomainKey';
            return this.$http.post(url).then(function (_ref19) {
                var data = _ref19.data;
                return data;
            });
        }
    }, {
        key: 'getApplicationApiCredentials',
        value: function getApplicationApiCredentials(companyId, applicationId, params) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/credentials';
            return this.$http.get(url, { params: params }).then(function (_ref20) {
                var data = _ref20.data;
                return data;
            });
        }
    }, {
        key: 'uploadMetadataXml',
        value: function uploadMetadataXml(companyId, applicationId, configDTO, metadataStr) {
            var fd = new FormData();
            var configDTOBlob = new Blob([JSON.stringify(configDTO)], {
                type: 'application/json'
            });
            fd.append('configDTO', configDTOBlob);
            if (metadataStr != null) {
                fd.append('metadataStr', metadataStr);
            }
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/saml/metadata';
            return this.$http.post(url, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (_ref21) {
                var data = _ref21.data;
                return data;
            });
        }
    }, {
        key: 'uploadMetadataUrl',
        value: function uploadMetadataUrl(companyId, applicationId, configDTO, metadataUrl) {
            var fd = new FormData();
            var configDTOBlob = new Blob([JSON.stringify(configDTO)], {
                type: 'application/json'
            });
            fd.append('configDTO', configDTOBlob);
            if (metadataUrl != null) {
                fd.append('metadataUrl', metadataUrl);
            }
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/saml/metadataurl';
            return this.$http.post(url, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (_ref22) {
                var data = _ref22.data;
                return data;
            });
        }
    }, {
        key: 'uploadCustomIcon',
        value: function uploadCustomIcon(companyId, applicationId, iconFile, logoFile) {
            var fd = new FormData();
            fd.append('file', iconFile);
            if (logoFile != null) {
                fd.append('logoFile', logoFile);
            }
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/photo';
            return this.$http.post(url, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (_ref23) {
                var data = _ref23.data;
                return data;
            });
        }
    }, {
        key: 'deleteCustomIcon',
        value: function deleteCustomIcon(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/photo/icon';
            var params = { action: 'delete' };
            return this.$http.delete(url, null, { params: params }).then(function (_ref24) {
                var data = _ref24.data;
                return data;
            });
        }
    }, {
        key: 'deleteCustomLogo',
        value: function deleteCustomLogo(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/photo/logo';
            var params = { action: 'delete' };
            return this.$http.delete(url, null, { params: params }).then(function (_ref25) {
                var data = _ref25.data;
                return data;
            });
        }
    }, {
        key: 'setProvisioningDirectory',
        value: function setProvisioningDirectory(companyId, applicationId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/setprovisioningdirectory';
            var params = { directoryId: directoryId };
            return this.$http.put(url, null, { params: params }).then(function (_ref26) {
                var data = _ref26.data;
                return data;
            });
        }
    }, {
        key: 'getProvisioningDirectory',
        value: function getProvisioningDirectory(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/getprovisioningdirectory';
            return this.$http.get(url).then(function (_ref27) {
                var data = _ref27.data;
                return data;
            });
        }
    }, {
        key: 'removeProvisioningDirectory',
        value: function removeProvisioningDirectory(companyId, applicationId) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + applicationId + '/removeprovisioningdirectory';
            return this.$http.put(url).then(function (_ref28) {
                var data = _ref28.data;
                return data;
            });
        }
    }]);

    return ApplicationsResource;
}();

_app.app.service('ApplicationsResource', ApplicationsResource);

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _accessControlPolicy = __webpack_require__(418);

_app.app.component('companyManageApplicationAccessControlPolicy', {
    bindings: {
        application: '<',
        companyId: '<',
        authenticationAccessPolicyList: '<'
    },
    controller: _accessControlPolicy.Controller,
    templateUrl: __webpack_require__(1485)
});

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "789c831a324436aaa3cf095dc7ab65a0.html";

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

authenticationAccessPolicyList.$inject = ['AuthenticationAccessPolicyResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.access-control-policy', {
        url: '/access-control-policy',
        component: 'companyManageApplicationAccessControlPolicy',
        resolve: { authenticationAccessPolicyList: authenticationAccessPolicyList }
    });
}

/** @ngInject */
function authenticationAccessPolicyList(AuthenticationAccessPolicyResource, companyId) {
    var type = 'basic';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId, type);
}

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _authenticationPolicies = __webpack_require__(419);

_app.app.component('companyManageApplicationAuthenticationPolicies', {
    bindings: {
        application: '<',
        companyId: '<',
        currentPasswordAuthenticationSettings: '<',
        authenticationAccessPolicyList: '<'
    },
    controller: _authenticationPolicies.Controller,
    templateUrl: __webpack_require__(1489)
});

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7df259634e0d676d3fc4fc182064cfd0.html";

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthenticationPoliciesService = function () {
    AuthenticationPoliciesService.$inject = ['$http'];

    /** @ngInject */
    function AuthenticationPoliciesService($http) {
        _classCallCheck(this, AuthenticationPoliciesService);

        this.$http = $http;
    }

    _createClass(AuthenticationPoliciesService, [{
        key: 'GetCurrentPasswordAuthenticationSettings',
        value: function GetCurrentPasswordAuthenticationSettings(companyId, id) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + id + '/pwdauthpolicy';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'GetCurrentAuthenticationPoliciesSettings',
        value: function GetCurrentAuthenticationPoliciesSettings(companyId, id) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + id + '/pwdauthpolicy';
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'UpdateCurrentPasswordAuthenticationSettings',
        value: function UpdateCurrentPasswordAuthenticationSettings(companyId, id, passwordAuthenticationSettings) {
            var url = 'app/rest/v2/company/' + companyId + '/applications/' + id + '/pwdauthpolicy';
            return this.$http.put(url, passwordAuthenticationSettings).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }]);

    return AuthenticationPoliciesService;
}();

_app.app.service('AuthenticationPoliciesService', AuthenticationPoliciesService);

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

authenticationAccessPolicyList.$inject = ['AuthenticationAccessPolicyResource', 'companyId'];
currentPasswordAuthenticationSettings.$inject = ['companyId', 'application', 'AuthenticationPoliciesService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.authentication-policies', {
        url: '/authentication-policies',
        component: 'companyManageApplicationAuthenticationPolicies',
        resolve: { currentPasswordAuthenticationSettings: currentPasswordAuthenticationSettings, authenticationAccessPolicyList: authenticationAccessPolicyList }
    });
}
/** @ngInject */
function currentPasswordAuthenticationSettings(companyId, application, AuthenticationPoliciesService) {
    return AuthenticationPoliciesService.GetCurrentPasswordAuthenticationSettings(companyId, application.id);
}
/** @ngInject */
function authenticationAccessPolicyList(AuthenticationAccessPolicyResource, companyId) {
    var type = 'basic';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId, type);
}

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _passwordPolicy = __webpack_require__(420);

_app.app.component('companyManageApplicationPasswordPolicy', {
    bindings: {
        application: '<',
        companyId: '<',
        currentPasswordAuthenticationSettings: '<'
    },
    controller: _passwordPolicy.Controller,
    templateUrl: __webpack_require__(1494)
});

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dbca05375ef95544767b6e75daa83e6e.html";

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

currentPasswordAuthenticationSettings.$inject = ['companyId', 'application', 'AuthenticationPoliciesService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.password-policy', {
        url: '/password-policy',
        component: 'companyManageApplicationPasswordPolicy',
        resolve: { currentPasswordAuthenticationSettings: currentPasswordAuthenticationSettings }
    });
}
/** @ngInject */
function currentPasswordAuthenticationSettings(companyId, application, AuthenticationPoliciesService) {
    return AuthenticationPoliciesService.GetCurrentPasswordAuthenticationSettings(companyId, application.id);
}

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _applicationConfigurationForm = __webpack_require__(421);

_app.app.component('applicationConfigurationForm', {
    bindings: {
        applicationConfiguration: '<',
        companyDomains: '<',
        onChange: '&',
        onEnter: '&',
        onSaveName: '&',
        onSaveMetadata: '&'
    },
    controller: _applicationConfigurationForm.Controller,
    templateUrl: __webpack_require__(1499)
});

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b7db7b4e41258e801488eec0032d7887.html";

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e2830edc5f3b1f4513fbfffdad745077.html";

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _applicationConfiguration = __webpack_require__(423);

_app.app.component('companyManageApplicationConfiguration', {
    bindings: {
        application: '<',
        companyDomains: '<',
        companyId: '<'
    },
    controller: _applicationConfiguration.Controller,
    templateUrl: __webpack_require__(1501)
});

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "648702f3152ff88176b680a595bebc25.html";

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.configuration', {
        url: '/configuration',
        component: 'companyManageApplicationConfiguration'
    });
}

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _loginServicesForm = __webpack_require__(427);

_app.app.component('loginServicesForm', {
    bindings: {
        loginServicesConfiguration: '<',
        onChange: '&',
        onEnter: '&'
    },
    controller: _loginServicesForm.Controller,
    templateUrl: __webpack_require__(1505)
});

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "73e6134762f9bc5ec24ae4a163ac8b03.html";

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _pushApprovalServicesForm = __webpack_require__(428);

_app.app.component('pushApprovalServicesForm', {
    bindings: {
        pushApprovalServicesConfiguration: '<',
        onChange: '&',
        onEnter: '&'
    },
    controller: _pushApprovalServicesForm.Controller,
    templateUrl: __webpack_require__(1507)
});

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "04edc1f0e6b5810281017efa6b4ec0fe.html";

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _registrationServicesForm = __webpack_require__(429);

_app.app.component('registrationServicesForm', {
    bindings: {
        registrationServicesConfiguration: '<',
        onChange: '&',
        onEnter: '&'
    },
    controller: _registrationServicesForm.Controller,
    templateUrl: __webpack_require__(1509)
});

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "36b483c5cf111a9e1c632431b9901ce5.html";

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('confirmRemoveDropboxProvisioningMapping', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1511)
});

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b5cc345b0b1fa49ac04287df8fb0f652.html";

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _dropboxProvisioningMapping = __webpack_require__(430);

_app.app.component('dropboxProvisioningMapping', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _dropboxProvisioningMapping.Controller,
    templateUrl: __webpack_require__(1513)
});

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b4fbd095ddb89431cefc0c53a494179.html";

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _dropboxProvisioningSettings = __webpack_require__(431);

_app.app.component('dropboxProvisioningSettings', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _dropboxProvisioningSettings.Controller,
    templateUrl: __webpack_require__(1515)
});

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b4de236baf2f2e90cb4f4e746c22e0c9.html";

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _dropboxProvisioning = __webpack_require__(432);

_app.app.component('companyManageApplicationDropboxProvisioning', {
    bindings: {
        application: '<',
        dropboxConfigurationDTO: '<'
    },
    controller: _dropboxProvisioning.Controller,
    templateUrl: __webpack_require__(1517)
});

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf44a59fbcf4b2aec600eb8d70728816.html";

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

DropboxProvisioningService.$inject = ['$resource'];


_app.app.factory('DropboxProvisioningService', DropboxProvisioningService);

/** @ngInject */
function DropboxProvisioningService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/dropboxprovisioning';

    return {
        provisioningConfiguration: $resource(rootUrl, {}, {
            'updateProvisioningConfiguration': {
                method: 'PUT'
            }
        }),
        dropboxSync: $resource(rootUrl + '/dropboxGroups', {}),
        mappingSettings: $resource(rootUrl + '/mapping/settings', {}, {
            'update': {
                method: 'PUT'
            }
        }),
        groupMapping: $resource(rootUrl + '/mapping/remove', {}, {
            'remove': {
                method: 'PUT'
            }
        }),
        syncMapping: $resource(rootUrl + '/mapping/sync'),
        provMapping: $resource(rootUrl + '/mapping/prov'),
        automap: $resource(rootUrl + '/automap'),
        provisionNow: $resource(rootUrl + '/provision'),
        syncNow: $resource(rootUrl + '/sync')

    };
}

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

dropboxConfigurationDTO.$inject = ['appId', 'companyId', 'DropboxProvisioningService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.dropbox-provisioning', {
        url: '/dropbox-provisioning',
        component: 'companyManageApplicationDropboxProvisioning',
        resolve: {
            dropboxConfigurationDTO: dropboxConfigurationDTO
        }
    });
}

function dropboxConfigurationDTO(appId, companyId, DropboxProvisioningService) {
    return DropboxProvisioningService.provisioningConfiguration.get({ companyId: companyId, appId: appId }).$promise;
}

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _dropboxSyncMapping = __webpack_require__(433);

_app.app.component('dropboxSyncMapping', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _dropboxSyncMapping.Controller,
    templateUrl: __webpack_require__(1521)
});

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f08aae80b68d124ba26ac853b8a59d66.html";

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _dropboxSyncSettings = __webpack_require__(434);

_app.app.component('dropboxSyncSettings', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _dropboxSyncSettings.Controller,
    templateUrl: __webpack_require__(1523)
});

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a53ef3a75140d7c2db32330c0ab2586f.html";

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.directive('fixedHeaderScroll', ['$timeout', function ($timeout) {

    return {
        restrict: 'A',
        scope: {
            fixedHeaderScroll: '='
        },
        link: function link($scope, $elem, $attrs, $ctrl) {

            var elem = $elem[0];
            $scope.$watchCollection('fixedHeaderScroll', // $attrs.$observe('tbRowsNumber',
            function () {

                //console.log($scope.fixedHeaderScroll);


                // wrap in $timeout to give table a chance to finish rendering
                $timeout(function () {

                    var tbody = elem.querySelector('tbody');
                    var rowsNumber = 0; //tbRowsNumber;
                    if ($scope.fixedHeaderScroll == undefined) {
                        //if it wasn't set expected table length then we use the tbody rows number
                        rowsNumber = tbody.children.length;
                    } else {
                        rowsNumber = $scope.fixedHeaderScroll.length;
                    }
                    // reset display styles so column widths are correct when measured below
                    angular.element(elem.querySelectorAll('thead, tbody, tfoot')).css('display', '');
                    if (rowsNumber > $attrs.tbMaxRows) {

                        var rowHeight = tbody.children[0].offsetHeight;
                        var bodyHeight = rowHeight * $attrs.tbMaxRows;

                        // set widths of columns
                        angular.forEach(elem.querySelectorAll('tr:first-child th'), function (thElem, i) {

                            var tdElems = elem.querySelector('tbody tr:first-child td:nth-child(' + (i + 1) + ')');
                            var tfElems = elem.querySelector('tfoot tr:first-child td:nth-child(' + (i + 1) + ')');

                            var columnWidth = tdElems ? tdElems.offsetWidth : thElem.offsetWidth;
                            if (tdElems) {
                                tdElems.style.width = columnWidth + 'px';
                            }
                            if (thElem) {
                                thElem.style.width = columnWidth + 'px';
                            }
                            if (tfElems) {
                                tfElems.style.width = columnWidth + 'px';
                            }
                        });

                        // set css styles on thead and tbody
                        angular.element(elem.querySelectorAll('thead, tfoot')).css('display', 'block');

                        angular.element(elem.querySelectorAll('tbody')).css({
                            'display': 'block',
                            'height': bodyHeight + 'px' || 'inherit',
                            'overflow': 'auto'
                        });

                        // reduce width of last column by width of scrollbar

                        var scrollBarWidth = tbody.offsetWidth - tbody.clientWidth;
                        if (scrollBarWidth > 0) {
                            // for some reason trimming the width by 2px lines everything up better
                            scrollBarWidth -= 2;
                            var lastColumn = elem.querySelector('tbody tr:first-child td:last-child');
                            lastColumn.style.width = lastColumn.offsetWidth - scrollBarWidth + 'px';
                        }
                    }
                });
            });
        }
    };
}]); // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/**
 * AngularJS fixed header scrollable table directive. - NOTE edited to our needs.
 * original @author Jason Watmore <jason@pointblankdevelopment.com.au> (http://jasonwatmore.com)
 * 
 * The attribute fixedHeaderScroll can have value of collection that will be shown in table or can be undefined. 
 * Attribute tbMaxRows is required to define how many rows we want in the scrollable table body.
 * To be used only on table tag.
 * @author teodora.krotkova
 */

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _appIdpAuthenticators = __webpack_require__(435);

_app.app.component('companyManageApplicationIdpAuthenticators', {
    bindings: {
        application: '<',
        companyId: '<',
        idpAuthenticators: '<'
    },
    controller: _appIdpAuthenticators.Controller,
    templateUrl: __webpack_require__(1526)
});

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ca2239d2708cd2db8121275f063e97ba.html";

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

idpAuthenticators.$inject = ['companyId', 'IdpAuthenticatorsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.idp-authenticators', {
        url: '/idp-authenticators',
        component: 'companyManageApplicationIdpAuthenticators',
        resolve: {
            idpAuthenticators: idpAuthenticators
        }
    });
}

/** @ngInject */
function idpAuthenticators(companyId, IdpAuthenticatorsService) {
    return IdpAuthenticatorsService.getIdpAuthenticators(companyId);
}

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _appKeyPassword = __webpack_require__(436);

_app.app.component('companyManageApplicationIntegrationDevelopersAppKeyPassword', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _appKeyPassword.Controller,
    templateUrl: __webpack_require__(1529)
});

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c962d60b55f4e3df7fbd72448a977727.html";

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

credentials.$inject = ['credentials$'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.app-key-password', {
        url: '/app-key-password',
        component: 'companyManageApplicationIntegrationDevelopersAppKeyPassword',
        resolve: {
            credentials: credentials
        }
    });
}

/** @ngInject */
function credentials(credentials$) {
    return credentials$.get();
}

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _regenerateAppPassword = __webpack_require__(437);

_app.app.component('companyManageApplicationIntegrationDevelopersAppKeyPasswordRegenerate', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _regenerateAppPassword.Controller,
    templateUrl: __webpack_require__(1532)
});

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e8801060f3e3ce52ab24a5c33615681.html";

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

CompanyApplicationOverviewService.$inject = ['$http', '$resource'];


_app.app.factory('CompanyApplicationOverviewService', CompanyApplicationOverviewService);

/** @ngInject */
function CompanyApplicationOverviewService($http, $resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/overview';

    return {
        drawChart: $resource(rootUrl + '/drawChart')
    };
}

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _autoConfigureSso = __webpack_require__(438);

_app.app.component('autoConfigureSsoModal', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _autoConfigureSso.Controller,
    templateUrl: __webpack_require__(1535)
});

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "529a41515fda9b87daf6366b8909592a.html";

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _configureSso = __webpack_require__(439);

_app.app.component('companyManageApplicationIntegrationDevelopersConfigureSso', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _configureSso.Controller,
    templateUrl: __webpack_require__(1545)
});

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./configure-sso-de.html": 1538,
	"./configure-sso-en.html": 1539,
	"./configure-sso-es.html": 1540,
	"./configure-sso-fr.html": 1541,
	"./configure-sso-ja.html": 1542,
	"./configure-sso-pt.html": 1543,
	"./configure-sso-zh.html": 1544
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1537;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aac29050d495cb8d096c9fc11960f8f2.html";

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9026d8795419792859ca7a96bf194ae9.html";

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4f919f1958877de906bdc9375ed8af28.html";

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9eff88e37ec4a6a4b5e1aef4b7293125.html";

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "92a08dc42be61608c27d5e25b84bcdfd.html";

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "911e86589926e0aa3c1a4c0b521ee2d0.html";

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3d22ce1919e90c4cbd9942cde658ae2d.html";

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "193fb86e79c231d7d96ea1ed11f2a368.html";

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.configure-sso', {
        url: '/configure-sso',
        component: 'companyManageApplicationIntegrationDevelopersConfigureSso'
    });
}

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _help = __webpack_require__(440);

_app.app.component('companyManageApplicationIntegrationDevelopersHelp', {
    bindings: { application: '<' },
    controller: _help.Controller,
    templateUrl: __webpack_require__(1549)
});

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./check-point.html": 441,
	"./cisco-asa.html": 442,
	"./computer-login.html": 443,
	"./computer-protection-without-ad.html": 444,
	"./radius.html": 445
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1548;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8e9120b76898ffc50009bcafaae33c8f.html";

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.help', {
        url: '/help',
        component: 'companyManageApplicationIntegrationDevelopersHelp'
    });
}

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _integrationDevelopers = __webpack_require__(446);

_app.app.component('companyManageApplicationIntegrationDevelopers', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _integrationDevelopers.Controller,
    templateUrl: __webpack_require__(1553)
});

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./check-point.html": 441,
	"./cisco-asa.html": 442,
	"./computer-login.html": 443,
	"./computer-protection-without-ad.html": 444,
	"./radius.html": 445
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1552;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d02ed75131692673dafda2bb8a8e1e1b.html";

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers', {
        url: '/integration-developers',
        redirectTo: redirectTo,
        component: 'companyManageApplicationIntegrationDevelopers'
    });
}

function redirectTo(transition) {
    return transition.injector().getAsync('application').then(function (application) {
        if (application.applicationType.slug === 'office-365') {
            return 'company.manage-application.integration-developers.integration-office-365';
        } else {
            return 'company.manage-application.integration-developers.integration';
        }
    });
}

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _integrationOffice = __webpack_require__(447);

_app.app.component('companyManageApplicationIntegrationDevelopersIntegrationOffice365', {
    controller: _integrationOffice.Controller,
    templateUrl: __webpack_require__(1556)
});

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d8e74a0b356c6c808fa37981c52e8f1.html";

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.integration-office-365', {
        url: '/integration-office-365',
        component: 'companyManageApplicationIntegrationDevelopersIntegrationOffice365'
    });
}

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _applicationIntegration = __webpack_require__(448);

_app.app.component('companyManageApplicationIntegrationDevelopersIntegration', {
    bindings: {
        account: '<',
        application: '<',
        applicationHelpInfo: '<',
        credentials$: '<'
    },
    controller: _applicationIntegration.Controller,
    templateUrl: __webpack_require__(1559)
});

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "194cb45ffc0b303c7fee4c1d05997716.html";

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

applicationHelpInfo.$inject = ['appId', 'ApplicationsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.integration', {
        url: '/integration',
        component: 'companyManageApplicationIntegrationDevelopersIntegration',
        resolve: {
            applicationHelpInfo: applicationHelpInfo
        }
    });
}

/** @ngInject */
function applicationHelpInfo(appId, ApplicationsResource, companyId) {
    return ApplicationsResource.getApplicationHelpInfo(companyId, appId);
}

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

applicationHelpInfo.$inject = ['appId', 'ApplicationsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.manual-integration', {
        url: '/manual-integration',
        component: 'companyManageApplicationIntegrationDevelopersIntegration',
        resolve: {
            applicationHelpInfo: applicationHelpInfo
        }
    });
}

/** @ngInject */
function applicationHelpInfo(appId, ApplicationsResource, companyId) {
    return ApplicationsResource.getApplicationHelpInfo(companyId, appId);
}

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _nonDomainProtectionKey = __webpack_require__(449);

_app.app.component('companyManageApplicationIntegrationDevelopersNonDomainProtectionKey', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _nonDomainProtectionKey.Controller,
    templateUrl: __webpack_require__(1563)
});

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eed993a0a24e63984359730d143a78a3.html";

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.non-domain-protection-key', {
        url: '/non-domain-protection-key',
        component: 'companyManageApplicationIntegrationDevelopersNonDomainProtectionKey'
    });
}

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyManageApplicationIntegrationDevelopersRemoveConfiguration', {
    templateUrl: __webpack_require__(1566)
});

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d1660105558c6714e2250bb077b99767.html";

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.remove-configuration', {
        url: '/remove-configuration',
        component: 'companyManageApplicationIntegrationDevelopersRemoveConfiguration'
    });
}

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyManageApplicationIntegrationDevelopersScimProvInstructions', {
    bindings: {},
    templateUrl: __webpack_require__(1569)
});

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e869f43232faca4bee03ebdde89019e9.html";

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.scim-prov-instructions', {
        url: '/scim-prov-instructions',
        component: 'companyManageApplicationIntegrationDevelopersScimProvInstructions',
        resolve: {}
    });
}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _simulators = __webpack_require__(450);

_app.app.component('companyManageApplicationIntegrationDevelopersSimulators', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _simulators.Controller,
    templateUrl: __webpack_require__(1572)
});

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "34df6ec3c932f036020fd715c53d233e.html";

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

credentials.$inject = ['credentials$'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.simulators', {
        url: '/simulators',
        component: 'companyManageApplicationIntegrationDevelopersSimulators',
        resolve: {
            credentials: credentials
        }
    });
}

/** @ngInject */
function credentials(credentials$) {
    return credentials$.get();
}

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _widgets = __webpack_require__(451);

_app.app.component('companyManageApplicationIntegrationDevelopersWidgets', {
    bindings: { appId: '<' },
    controller: _widgets.Controller,
    templateUrl: __webpack_require__(1575)
});

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "121fd8dfb5b63abe43be8d3fba651e68.html";

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.integration-developers.widgets', {
        url: '/widgets',
        component: 'companyManageApplicationIntegrationDevelopersWidgets'
    });
}

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageApplication = __webpack_require__(452);

_app.app.component('companyManageApplication', {
    bindings: {
        account: '<',
        application: '<',
        companyId: '<'
    },
    controller: _manageApplication.Controller,
    templateUrl: __webpack_require__(1578)
});

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "41f6335378d64211e6349b61050a49f7.html";

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _store = __webpack_require__(19);

var _lazyLoad = __webpack_require__(71);

appId.$inject = ['$stateParams'];
credentials$.$inject = ['application', 'ApplicationsResource', 'companyId', 'DestructiveOperationModal'];
companyDomains.$inject = ['application', 'companyId', 'DomainsService'];
application.$inject = ['companyId', 'appId', 'ApplicationsResource'];
appId.$inject = ['$stateParams'];
$breadcrumbs.$inject = ['application'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application', {
        url: '/application/:appId',
        redirectTo: 'company.manage-application.configuration',
        views: {
            '@company': 'companyManageApplication'
        },
        resolve: {
            $breadcrumbs: $breadcrumbs,
            appId: appId,
            application: application,
            companyDomains: companyDomains,
            credentials$: credentials$
        }
    });
}

/** @ngInject */
function $breadcrumbs(application) {
    var title = {
        // getter to allow dynamic updates
        get title() {
            return application.applicationName;
        }
    };

    if (application.applicationType.slug === 'computer-login') {
        return [{ stateName: 'company.computer-protection' }, title];
    }
    if (application.applicationType.slug === 'computer-protection-without-ad') {
        return [{ stateName: 'company.computer-protection' }, title];
    }
    if (application.applicationType.slug === 'custom') {
        return [{ stateName: 'company.custom-app-integration' }, title];
    }
    return [{ stateName: 'company.applications' }, title];
}

/** @ngInject */
function appId($stateParams) {
    return $stateParams.appId;
}

/** @ngInject */
function application(companyId, appId, ApplicationsResource) {
    return ApplicationsResource.getApplicationConfiguration(companyId, appId);
}

/** @ngInject */
function companyDomains(application, companyId, DomainsService) {
    if (application.applicationType.slug === 'office-365') {
        return DomainsService.query({ companyId: companyId }).$promise.then(function (domains) {
            return domains.map(function (_ref) {
                var id = _ref.id,
                    domainName = _ref.domainName;
                return { domainId: id, domainName: domainName };
            });
        });
    }
}

/** @ngInject */
function credentials$(application, ApplicationsResource, companyId, DestructiveOperationModal) {
    return _store.resolve.credentials$ = (0, _lazyLoad.lazyLoad)(function () {
        return DestructiveOperationModal({
            titleKey: 'company.manage-application.integration-developers.app-key-password.destructive.title',
            textKey: 'company.manage-application.integration-developers.app-key-password.destructive.text',
            onSubmit: function onSubmit(params) {
                return ApplicationsResource.getApplicationApiCredentials(companyId, application.id, params);
            }
        });
    }).map(function (v) {
        var credentials = {
            applicationApiKey: v.applicationKey,
            applicationApiPassword: v.applicationPassword,
            saaspassConnectPublicKey: v.saaspassConnectPublicKey
        };
        Object.assign(application, credentials);
        return credentials;
    });
}

/** @ngInject */
function appId($stateParams) {
    return $stateParams.appId;
}

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _mobileAppSupportForm = __webpack_require__(453);

_app.app.component('mobileApplicationSettingsForm', {
    bindings: {
        mobileApplicationSettings: '<',
        onChange: '&',
        onEnter: '&'
    },
    controller: _mobileAppSupportForm.Controller,
    templateUrl: __webpack_require__(1581)
});

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "19fe5fc2e24534a21a97f35a89896dad.html";

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _mobileAppSupport = __webpack_require__(454);

_app.app.component('companyManageApplicationMobileAppSupport', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _mobileAppSupport.Controller,
    templateUrl: __webpack_require__(1583)
});

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "091571c7c4bb8e81e84911a1294e007a.html";

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.mobile-app-support', {
        url: '/mobile-app-support',
        component: 'companyManageApplicationMobileAppSupport'
    });
}

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _o365Provisioning = __webpack_require__(455);

_app.app.component('companyManageApplicationOffice365Provisioning', {
    bindings: {
        application: '<',
        configurationOverviewDTO: '<'
    },
    controller: _o365Provisioning.Controller,
    templateUrl: __webpack_require__(1586)
});

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ebe4c4ae25821d3ff9123033350c22e9.html";

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UserProvisioningService.$inject = ['$resource'];


_app.app.factory('UserProvisioningService', UserProvisioningService);

/** @ngInject */
function UserProvisioningService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/userprovisioning';

    return {
        provisioningConfiguration: $resource(rootUrl, {}, {
            'updateAutoProvisioning': {
                method: 'PUT'
            },
            'updateVerificationEmailFlag': {
                method: 'PUT',
                url: rootUrl + '/verificationEmail'
            }
        }),
        userProvisioningAction: $resource(rootUrl + '/disable'),
        userProvisioningTest: $resource(rootUrl + '/testConnection', {}, { 'testConnection': {
                method: 'POST',
                isArray: true
            } }),
        userProvisioningImport: $resource(rootUrl + '/import'),
        userProvisioningExport: $resource(rootUrl + '/export'),
        userProvisioningLicenses: $resource(rootUrl + '/licences')
    };
}

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

configurationOverviewDTO.$inject = ['appId', 'companyId', 'UserProvisioningService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.o365-provisioning', {
        url: '/o365-provisioning',
        component: 'companyManageApplicationOffice365Provisioning',
        resolve: {
            configurationOverviewDTO: configurationOverviewDTO
        }
    });
}

/** @ngInject */
function configurationOverviewDTO(appId, companyId, UserProvisioningService) {
    return UserProvisioningService.provisioningConfiguration.get({ appId: appId, companyId: companyId }).$promise;
}

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addRemoteApp = __webpack_require__(456);

_app.app.component('companyManageApplicationRemoteAppAdd', {
    bindings: {
        appId: '<',
        companyId: '<',
        application: '<',
        remoteApps: '='
    },
    controller: _addRemoteApp.Controller,
    templateUrl: __webpack_require__(1590)
});

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1fb2de3757f0845c3bb84126da0c7440.html";

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.remote-app-access.add', {
        url: '/add',
        views: {
            '@company.manage-application': 'companyManageApplicationRemoteAppAdd'
        }
    });
}

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editRemoteApp = __webpack_require__(457);

_app.app.component('companyManageApplicationRemoteAppEdit', {
    bindings: {
        appId: '<',
        companyId: '<',
        groups: '<',
        remoteApp: '<',
        remoteApps: '=',
        groupsModel: '<'
    },
    controller: _editRemoteApp.Controller,
    templateUrl: __webpack_require__(1593)
});

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4f9847b3b00f09b8089542297c51997b.html";

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groupsModel.$inject = ['groups', 'remoteApp'];
remoteAppId.$inject = ['$stateParams'];
remoteApp.$inject = ['remoteAppId', 'remoteApps'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.remote-app-access.edit', {
        url: '/:remoteAppId/edit',
        views: {
            '@company.manage-application': 'companyManageApplicationRemoteAppEdit'
        },
        resolve: {
            remoteApp: remoteApp,
            remoteAppId: remoteAppId,
            groupsModel: groupsModel
        }
    });
}

/** @ngInject */
function groupsModel(groups, remoteApp) {
    groupsModel = groups;
    groupsModel.map(function (group) {
        group.isSelected = remoteApp.groups.findIndex(function (record) {
            return record.id === group.id;
        }) != -1;
    });
    return groupsModel;
}
/** @ngInject */
function remoteApp(remoteAppId, remoteApps) {
    return remoteApps.find(function (remoteApp) {
        return remoteApp.sraRemoteApp.id === remoteAppId;
    });
}

/** @ngInject */
function remoteAppId($stateParams) {
    return $stateParams.remoteAppId;
}

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _remoteAppAccess = __webpack_require__(458);

_app.app.component('companyManageRemoteAppAccess', {
    bindings: {
        appId: '<',
        companyId: '<',
        groups: '<',
        application: '<',
        remoteApps: '<'
    },
    controller: _remoteAppAccess.Controller,
    templateUrl: __webpack_require__(1596)
});

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "04d9de5a634fedc4e5a66cd5d1fbd6e4.html";

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RemoteAppAccessService = function () {
    RemoteAppAccessService.$inject = ['$http'];

    /** @ngInject */
    function RemoteAppAccessService($http) {
        _classCallCheck(this, RemoteAppAccessService);

        this.$http = $http;
    }

    _createClass(RemoteAppAccessService, [{
        key: 'constructUrl',
        value: function constructUrl(companyId, appId, remoteAppId) {
            var url = 'app/rest/admin/company/' + companyId + '/application/' + appId + '/sraapps';
            if (remoteAppId !== null) {
                url = url + ('/' + remoteAppId);
            }
            return url;
        }
    }, {
        key: 'list',
        value: function list(companyId, appId) {
            var url = this.constructUrl(companyId, appId, null);
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'remove',
        value: function remove(companyId, appId, remoteAppId) {
            var url = this.constructUrl(companyId, appId, remoteAppId);
            return this.$http.delete(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'save',
        value: function save(companyId, appId, remoteApp) {
            var url = this.constructUrl(companyId, appId, null);
            return this.$http.post(url, remoteApp).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }]);

    return RemoteAppAccessService;
}();

_app.app.service('RemoteAppAccessService', RemoteAppAccessService);

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

remoteApps.$inject = ['appId', 'companyId', 'RemoteAppAccessService'];
groups.$inject = ['companyId', 'appId', 'ApplicationsResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.remote-app-access', {
        url: '/remote-app-access',
        component: 'companyManageRemoteAppAccess',
        resolve: {
            groups: groups,
            remoteApps: remoteApps
        }
    });
}

/** @ngInject */
function groups(companyId, appId, ApplicationsResource) {
    return ApplicationsResource.getApplicationAssignedGroups(companyId, appId);
}

/** @ngInject */
function remoteApps(appId, companyId, RemoteAppAccessService) {
    return RemoteAppAccessService.list(companyId, appId);
}

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeRemoteApp = __webpack_require__(459);

_app.app.component('companyManageApplicationRemoteAppRemove', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeRemoteApp.Controller,
    templateUrl: __webpack_require__(1600)
});

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6fc7fc9e81d85931fea438b46929645b.html";

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeApplication = __webpack_require__(460);

_app.app.component('companyManageApplicationRemove', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _removeApplication.Controller,
    templateUrl: __webpack_require__(1602)
});

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cff56450fcba5c302bb217d1c22747d9.html";

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.remove', {
        url: '/remove',
        component: 'companyManageApplicationRemove'
    });
}

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addRole = __webpack_require__(461);

_app.app.component('companyManageApplicationRolesAdd', {
    bindings: {
        appId: '<',
        companyId: '<',
        roles: '<'
    },
    controller: _addRole.Controller,
    templateUrl: __webpack_require__(1605)
});

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0e6c3c4476f94d40658611dedec83d5c.html";

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.roles.add', {
        url: '/add',
        views: {
            '@company.manage-application': 'companyManageApplicationRolesAdd'
        }
    });
}

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editRole = __webpack_require__(462);

_app.app.component('companyManageApplicationRolesEdit', {
    bindings: {
        appId: '<',
        companyId: '<',
        groups: '<',
        role: '<',
        roles: '<'
    },
    controller: _editRole.Controller,
    templateUrl: __webpack_require__(1608)
});

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a18818c75883c1c9ab79bf208de31e9f.html";

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

roleId.$inject = ['$stateParams'];
role.$inject = ['roleId', 'roles'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.roles.edit', {
        url: '/:roleId/edit',
        views: {
            '@company.manage-application': 'companyManageApplicationRolesEdit'
        },
        resolve: {
            role: role,
            roleId: roleId
        }
    });
}

/** @ngInject */
function role(roleId, roles) {
    return roles.find(function (role) {
        return role.loginRole.id === roleId;
    });
}

/** @ngInject */
function roleId($stateParams) {
    return $stateParams.roleId;
}

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeRole = __webpack_require__(463);

_app.app.component('companyManageApplicationRolesRemove', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeRole.Controller,
    templateUrl: __webpack_require__(1611)
});

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c39d551dcd7135bd6d2e5a0c8133eba7.html";

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

var _group = __webpack_require__(84);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoleManagementResource = function () {
    RoleManagementResource.$inject = ['$http'];

    /** @ngInject */
    function RoleManagementResource($http) {
        _classCallCheck(this, RoleManagementResource);

        this.$http = $http;
    }

    _createClass(RoleManagementResource, [{
        key: 'list',
        value: function list(companyId, appId) {
            var url = 'app/rest/admin/company/' + companyId + '/application/' + appId + '/loginroles/all';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'remove',
        value: function remove(companyId, appId, roleId) {
            var url = 'app/rest/admin/company/' + companyId + '/application/' + appId + '/loginroles/' + roleId;
            return this.$http.delete(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'save',
        value: function save(companyId, appId, role) {
            var url = 'app/rest/admin/company/' + companyId + '/application/' + appId + '/loginroles';
            return this.$http.post(url, role).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'groups',
        value: function groups(companyId, appId) {
            var url = 'app/rest/admin/company/' + companyId + '/application/' + appId + '/loginroles/groups';
            return this.$http.get(url).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            }).then(function (items) {
                return items.map(function (item) {
                    return _extends({}, item, { group: (0, _group.groupFromDto)(item.group) });
                });
            });
        }
    }]);

    return RoleManagementResource;
}();

_app.app.service('RoleManagementResource', RoleManagementResource);

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _roles = __webpack_require__(464);

_app.app.component('companyManageApplicationRoles', {
    bindings: {
        appId: '<',
        companyId: '<',
        groups: '<',
        roles: '<'
    },
    controller: _roles.Controller,
    templateUrl: __webpack_require__(1614)
});

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e042eee5549dc28c169bf2b8ba24bcce.html";

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

roles.$inject = ['appId', 'companyId', 'RoleManagementResource'];
groups.$inject = ['appId', 'companyId', 'RoleManagementResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.roles', {
        url: '/roles',
        component: 'companyManageApplicationRoles',
        resolve: {
            groups: groups,
            roles: roles
        }
    });
}

/** @ngInject */
function groups(appId, companyId, RoleManagementResource) {
    return RoleManagementResource.groups(companyId, appId);
}

/** @ngInject */
function roles(appId, companyId, RoleManagementResource) {
    return RoleManagementResource.list(companyId, appId);
}

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _scimProvisioning = __webpack_require__(465);

_app.app.component('companyManageApplicationScimProvisioning', {
    bindings: {
        application: '<',
        companyId: '<',
        provisioningDirectory: '<'
    },
    controller: _scimProvisioning.Controller,
    templateUrl: __webpack_require__(1617)
});

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f2386ad4404c928009e26ed3c73aa08.html";

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UserProvisioningService.$inject = ['$resource'];


_app.app.factory('UserProvisioningService', UserProvisioningService);

/** @ngInject */
function UserProvisioningService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/userprovisioning';

    return {
        provisioningConfiguration: $resource(rootUrl, {}, {
            'updateAutoProvisioning': {
                method: 'PUT'
            },
            'updateVerificationEmailFlag': {
                method: 'PUT',
                url: rootUrl + '/verificationEmail'
            }
        }),
        userProvisioningAction: $resource(rootUrl + '/disable'),
        userProvisioningTest: $resource(rootUrl + '/testConnection', {}, { 'testConnection': {
                method: 'POST',
                isArray: true
            } }),
        userProvisioningImport: $resource(rootUrl + '/import'),
        userProvisioningExport: $resource(rootUrl + '/export'),
        userProvisioningLicenses: $resource(rootUrl + '/licences')
    };
}

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

provisioningDirectory.$inject = ['companyId', 'appId', 'ApplicationsResource'];
companyId.$inject = ['$stateParams'];
appId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.scim-provisioning', {
        url: '/scim-provisioning',
        component: 'companyManageApplicationScimProvisioning',
        resolve: {
            appId: appId,
            companyId: companyId,
            provisioningDirectory: provisioningDirectory
        }
    });
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}

/** @ngInject */
function appId($stateParams) {
    return $stateParams.appId;
}

/** @ngInject */
function provisioningDirectory(companyId, appId, ApplicationsResource) {
    return ApplicationsResource.getProvisioningDirectory(companyId, appId);
}

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sessionRecordingForm = __webpack_require__(466);

_app.app.component('sessionRecordingForm', {
    bindings: {
        loginServicesConfiguration: '<',
        onChange: '&',
        onEnter: '&'
    },
    controller: _sessionRecordingForm.Controller,
    templateUrl: __webpack_require__(1621)
});

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14612e2e71a5caaa7d5006a3fa85006b.html";

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sessionRecording = __webpack_require__(467);

_app.app.component('companyManageApplicationSessionRecording', {
    bindings: {
        application: '<',
        companyDomains: '<',
        companyId: '<'
    },
    controller: _sessionRecording.Controller,
    templateUrl: __webpack_require__(1623)
});

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "db53a7738eff349c2b16031c0f5b34ea.html";

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.session-recording', {
        url: '/session-recording',
        component: 'companyManageApplicationSessionRecording'
    });
}

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyManageApplicationUsageData', {
    bindings: { application: '<' },
    templateUrl: __webpack_require__(1627)
});

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dd8da8d03f5c2acd2abd3bab8ff9f3a1.html";

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.usage-data', {
        url: '/usage-data',
        component: 'companyManageApplicationUsageData'
    });
}

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _applicationUsers = __webpack_require__(468);

_app.app.component('companyManageApplicationUsers', {
    bindings: {
        application: '<',
        companyId: '<',
        groups: '<'
    },
    controller: _applicationUsers.Controller,
    templateUrl: __webpack_require__(1630)
});

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa7a28dcb6bb11fba5e3c2d7b64f3c71.html";

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groups.$inject = ['companyId', 'appId', 'ApplicationsResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.users', {
        url: '/users',
        component: 'companyManageApplicationUsers',
        resolve: {
            groups: groups
        }
    });
}

/** @ngInject */
function groups(companyId, appId, ApplicationsResource) {
    return ApplicationsResource.getApplicationAssignedGroups(companyId, appId);
}

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _assignGroups = __webpack_require__(469);

_app.app.component('companyManageApplicationUsersAssignGroups', {
    bindings: {
        application: '<',
        companyId: '<',
        groups: '<'
    },
    controller: _assignGroups.Controller,
    templateUrl: __webpack_require__(1633)
});

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aadd72d7c10f072c654e3bd807717d2d.html";

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groups.$inject = ['companyId', 'appId', 'ApplicationsResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.users.assign-groups', {
        url: '/assign-groups',
        views: {
            '@company.manage-application': 'companyManageApplicationUsersAssignGroups'
        },
        resolve: {
            groups: groups
        }
    });
}

/** @ngInject */
function groups(companyId, appId, ApplicationsResource) {
    return ApplicationsResource.getApplicationNotAssignedGroups(companyId, appId);
}

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _assignedGroups = __webpack_require__(470);

_app.app.component('assignedGroups', {
    bindings: {
        application: '<',
        companyId: '<',
        groups: '<'
    },
    controller: _assignedGroups.Controller,
    templateUrl: __webpack_require__(1636)
});

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3695a823a594809250e794aef172ea83.html";

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _customizeSamlAssertion = __webpack_require__(471);

_app.app.component('customizeSamlAssertion', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _customizeSamlAssertion.Controller,
    templateUrl: __webpack_require__(1638)
});

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a9ce9617ba4f3de18f9b5b81843661db.html";

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _customizeUserAuthentication = __webpack_require__(472);

_app.app.component('customizeUserAuthentication', {
    bindings: {
        application: '<',
        companyId: '<'
    },
    controller: _customizeUserAuthentication.Controller,
    templateUrl: __webpack_require__(1640)
});

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14ef5e5ecd523ead1731ff8bbce2b3b5.html";

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _epmCredentials = __webpack_require__(473);

_app.app.component('companyManageApplicationUsersEpmCredentials', {
    bindings: {
        groupId: '<',
        appId: '<',
        companyId: '<'
    },
    controller: _epmCredentials.Controller,
    templateUrl: __webpack_require__(1642)
});

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cd534653ded941f38f9c4e68dc03d1aa.html";

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groupId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.users.epm-credentials', {
        url: '/:groupId/epm-credentials',
        params: { groupId: null },
        views: {
            '@company.manage-application': 'companyManageApplicationUsersEpmCredentials'
        },
        resolve: {
            groupId: groupId
        }
    });
}

/** @ngInject */
function groupId($stateParams) {
    return $stateParams.groupId;
}

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _generateLoginCode = __webpack_require__(474);

_app.app.component('companyManageApplicationUsersGenerateLoginCode', {
    bindings: {
        groupId: '<',
        appId: '<',
        companyId: '<'
    },
    controller: _generateLoginCode.Controller,
    templateUrl: __webpack_require__(1645)
});

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "15d30e0e62c0661dbee8c9d829f4ee2c.html";

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groupId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.users.generate-login-code', {
        url: '/:groupId/generate-login-code',
        params: { groupId: null },
        views: {
            '@company.manage-application': 'companyManageApplicationUsersGenerateLoginCode'
        },
        resolve: {
            groupId: groupId
        }
    });
}

/** @ngInject */
function groupId($stateParams) {
    return $stateParams.groupId;
}

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _managePasswords = __webpack_require__(475);

_app.app.component('companyManageApplicationUsersManagePasswords', {
    bindings: {
        groupId: '<',
        application: '<',
        companyId: '<'
    },
    controller: _managePasswords.Controller,
    templateUrl: __webpack_require__(1648)
});

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eaf92e0264512bbd7208816276e56d3c.html";

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groupId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.users.manage-passwords', {
        url: '/:groupId/manage-passwords',
        params: { groupId: null },
        views: {
            '@company.manage-application': 'companyManageApplicationUsersManagePasswords'
        },
        resolve: {
            groupId: groupId
        }
    });
}

/** @ngInject */
function groupId($stateParams) {
    return $stateParams.groupId;
}

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _unassignGroup = __webpack_require__(476);

_app.app.component('companyManageApplicationUsersUnassignGroup', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _unassignGroup.Controller,
    templateUrl: __webpack_require__(1651)
});

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b81db2b4f0cc8edb8127e51e5f216b84.html";

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addedApplicationsList = __webpack_require__(477);

_app.app.component('companyApplicationsList', {
    bindings: { applications: '<' },
    controller: _addedApplicationsList.Controller,
    templateUrl: __webpack_require__(1653)
});

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20b904e0c70f27d0127002e01ae7433a.html";

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

applications.$inject = ['ApplicationsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.applications', {
        url: '/applications',
        component: 'companyApplicationsList',
        resolve: { applications: applications }
    });
}

/** @ngInject */
function applications(ApplicationsResource, companyId) {
    return ApplicationsResource.getAllApplicationsForCompany(companyId).then(function (apps) {
        apps.filter(function (app) {
            return app.publicService;
        }).filter(function (app) {
            return app.publicService.slug === 'other';
        }).forEach(function (app) {
            return app.publicService.serviceName = 'Custom';
        });
        return apps;
    }).then(function (apps) {
        return apps.map(function (app) {
            return Object.assign(app, {
                samlAppLogo: window.env.urls.samlAppLogo(app.slug, 'thumb')
            });
        });
    });
}

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _applicationInfo = __webpack_require__(478);

_app.app.component('companyApplicationInfo', {
    bindings: {
        account: '<',
        appType: '<',
        companyId: '<',
        appPermissions: '<'
    },
    controller: _applicationInfo.Controller,
    templateUrl: __webpack_require__(1656)
});

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "36c16efc64de1029da34c386b47b9ff2.html";

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

appPermissions.$inject = ['$stateParams'];
appTypeId.$inject = ['$stateParams'];
appType.$inject = ['appTypeId', 'appType$'];
$breadcrumbs.$inject = ['appType'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.application-info', {
        url: '/application/info/:appTypeId',
        component: 'companyApplicationInfo',
        params: {
            appPermissions: { sra: false }
        },
        resolve: {
            $breadcrumbs: $breadcrumbs,
            appType: appType,
            appTypeId: appTypeId,
            appPermissions: appPermissions
        }
    });
}

/** @ngInject */
function $breadcrumbs(appType) {
    var title = appType.applicationTypeDisplayName;
    return [{ stateName: 'company.supported-application-types' }, { title: title }];
}

/** @ngInject */
function appType(appTypeId, appType$) {
    return appType$(appTypeId).get();
}

/** @ngInject */
function appTypeId($stateParams) {
    return $stateParams.appTypeId;
}

/** @ngInject */
function appPermissions($stateParams) {
    return $stateParams.appPermissions;
}

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('integrationYouAreDone', {
    templateUrl: __webpack_require__(1659)
});

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d251ecf610307e3b5ff3f4bad65ef585.html";

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('portsUsedBySaaspassProducts', {
    templateUrl: __webpack_require__(1662)
});

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2881350dc0d02504a2ba0065cf42b939.html";

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _supportedApplicationTypes = __webpack_require__(479);

_app.app.component('companySupportedApplicationTypes', {
    bindings: {
        appCategories: '<',
        companyId: '<',
        appTypes: '<',
        appPermissions: '<',
        protocolstr: '<'
    },
    controller: _supportedApplicationTypes.Controller,
    templateUrl: __webpack_require__(1664)
});

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "03c6d43d4421a6ad1b4dc66ba1a2445f.html";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

protocolstr.$inject = ['$stateParams'];
appPermissions.$inject = ['AddNewApplicationResource', 'companyId'];
appTypes.$inject = ['appTypes$'];
appCategories.$inject = ['appCategories$'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.supported-application-types', {
        url: '/application/add/:protocolstr',
        params: { protocolstr: null },
        component: 'companySupportedApplicationTypes',
        resolve: {
            appCategories: appCategories,
            appTypes: appTypes,
            appPermissions: appPermissions,
            protocolstr: protocolstr
        }
    });
}

/** @ngInject */
function appCategories(appCategories$) {
    return appCategories$.get();
}

/** @ngInject */
function appTypes(appTypes$) {
    return appTypes$.get();
}

/** @ngInject */
function appPermissions(AddNewApplicationResource, companyId) {
    return AddNewApplicationResource.getApplicationPermissionsInCompany(companyId);
}

function protocolstr($stateParams) {
    return $stateParams.protocolstr;
}

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addEpm = __webpack_require__(480);

_app.app.component('companyAddEpm', {
    bindings: {
        companyId: '<',
        publicService: '<'
    },
    controller: _addEpm.Controller,
    templateUrl: __webpack_require__(1667)
});

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "94511ac0af209c50e8d0872a30a480dd.html";

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

publicServiceId.$inject = ['$stateParams'];
publicService.$inject = ['publicServiceId', 'publicServicesWithEPM$'];
$breadcrumbs.$inject = ['publicService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.supported-epm-types.add-epm', {
        url: '/add-epm/:publicServiceId',
        // component: 'companyAddEpm',
        views: {
            '@company': 'companyAddEpm'
        },
        resolve: {
            $breadcrumbs: $breadcrumbs,
            publicService: publicService,
            publicServiceId: publicServiceId
        }
    });
}

/** @ngInject */
function $breadcrumbs(publicService) {
    return [{ vars: { serviceName: publicService.serviceName } }];
}

/** @ngInject */
function publicService(publicServiceId, publicServicesWithEPM$) {
    return publicServicesWithEPM$.get().then(function (pss) {
        return pss.find(function (ps) {
            return ps.id === publicServiceId;
        });
    });
}

/** @ngInject */
function publicServiceId($stateParams) {
    return $stateParams.publicServiceId;
}

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _supportedEpmTypes = __webpack_require__(481);

_app.app.component('companySupportedEpmTypes', {
    bindings: {
        publicServicesWithEPM$: '<'
    },
    controller: _supportedEpmTypes.Controller,
    templateUrl: __webpack_require__(1683)
});

/***/ }),
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1eddf4c048f2616e9ec8cb62870f84ea.html";

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.supported-epm-types', {
        url: '/supported-epm-types',
        component: 'companySupportedEpmTypes'
    });
}

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _authenticationAccessPolicies = __webpack_require__(483);

_app.app.component('companyPoliciesAuthenticationAccessPolicies', {
    bindings: {
        companyId: '<',
        defaultPolicy: '<',
        policies: '<'
    },
    controller: _authenticationAccessPolicies.Controller,
    templateUrl: __webpack_require__(1687)
});

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d42fb78884c236975352054e65c8c428.html";

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

policies.$inject = ['authenticationAccessPolicyList'];
osTypes.$inject = ['authenticationAccessPolicyList'];
defaultPolicy.$inject = ['AuthenticationAccessPolicyResource', 'companyId', 'policies'];
countries.$inject = ['authenticationAccessPolicyList'];
browserTypes.$inject = ['authenticationAccessPolicyList'];
authenticationAccessPolicyList.$inject = ['AuthenticationAccessPolicyResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.authentication-access-policies', {
        url: '/access-control-policies',
        component: 'companyPoliciesAuthenticationAccessPolicies',
        resolve: {
            authenticationAccessPolicyList: authenticationAccessPolicyList,
            browserTypes: browserTypes,
            countries: countries,
            defaultPolicy: defaultPolicy,
            osTypes: osTypes,
            policies: policies
        }
    });
}

/** @ngInject */
function authenticationAccessPolicyList(AuthenticationAccessPolicyResource, companyId) {
    var type = 'extra';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId, type);
}

/** @ngInject */
function browserTypes(authenticationAccessPolicyList) {
    return authenticationAccessPolicyList.browserTypes;
}

/** @ngInject */
function countries(authenticationAccessPolicyList) {
    return authenticationAccessPolicyList.countries;
}

/** @ngInject */
function defaultPolicy(AuthenticationAccessPolicyResource, companyId, policies) {
    return policies.find(function (policy) {
        return policy.policyName === 'Default Policy';
    });
}

/** @ngInject */
function osTypes(authenticationAccessPolicyList) {
    return authenticationAccessPolicyList.osTypes;
}

/** @ngInject */
function policies(authenticationAccessPolicyList) {
    return authenticationAccessPolicyList.policies.sort();
}

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editPolicy = __webpack_require__(484);

_app.app.component('companyPoliciesAuthenticationAccessPoliciesEdit', {
    bindings: {
        browserTypes: '<',
        companyId: '<',
        countries: '<',
        defaultPolicy: '<',
        osTypes: '<',
        policy: '<'
    },
    controller: _editPolicy.Controller,
    templateUrl: __webpack_require__(1690)
});

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "200805bd18980e9d1dcbb7530a87c0da.html";

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

policy.$inject = ['$stateParams', 'policies'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.authentication-access-policies.edit', {
        url: '/:policyId/edit',
        views: { '@company.policies': 'companyPoliciesAuthenticationAccessPoliciesEdit' },
        resolve: { policy: policy }
    });
}

/** @ngInject */
function policy($stateParams, policies) {
    return policies.find(function (p) {
        return p.id === $stateParams.policyId;
    });
}

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _managePolicyApps = __webpack_require__(485);

_app.app.component('companyPoliciesAuthenticationAccessPoliciesManage', {
    bindings: {
        companyId: '<',
        defaultPolicy: '<',
        policy: '<'
    },
    controller: _managePolicyApps.Controller,
    templateUrl: __webpack_require__(1694)
});

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "32240a1c383c401be90ab1c658016510.html";

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

policyId.$inject = ['$stateParams'];
policy.$inject = ['policyId', 'policies'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.authentication-access-policies.manage', {
        url: '/:policyId/manage',
        views: { '@company.policies': 'companyPoliciesAuthenticationAccessPoliciesManage' },
        resolve: {
            policy: policy,
            policyId: policyId
        }
    });
}

/** @ngInject */
function policy(policyId, policies) {
    return policies.find(function (p) {
        return p.id === policyId;
    });
}

/** @ngInject */
function policyId($stateParams) {
    return $stateParams.policyId;
}

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _assignApplication = __webpack_require__(486);

_app.app.component('passwordAuthenticationPolicyAssignApplication', {
    bindings: {
        companyId: '<',
        defaultPolicy: '<',
        policy: '<'
    },
    controller: _assignApplication.Controller,
    templateUrl: __webpack_require__(1697)
});

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "144520c2b303081673607cbf56d23aa2.html";

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

policyId.$inject = ['$stateParams'];
policy.$inject = ['policyId', 'companyPasswordPolicies'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.password-authentication-policy.manage', {
        url: '/:policyId/manage',
        views: { '@company.policies': 'passwordAuthenticationPolicyAssignApplication' },
        resolve: {
            policy: policy,
            policyId: policyId
        }
    });
}

/** @ngInject */
function policy(policyId, companyPasswordPolicies) {
    return companyPasswordPolicies.find(function (p) {
        return p.passwordPolicyId === policyId;
    });
}

/** @ngInject */
function policyId($stateParams) {
    return $stateParams.policyId;
}

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editPolicy = __webpack_require__(487);

_app.app.component('passwordAuthenticationPoliciesViewEdit', {
    bindings: {
        companyPasswordPolicies: '<',
        policy: '<'
    },
    controller: _editPolicy.Controller,
    templateUrl: __webpack_require__(1700)
});

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "86addeab62e9f71349e0c21c4ca30b31.html";

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

policy.$inject = ['$stateParams', 'companyId', 'PasswordAuthenticationPoliciesService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.password-authentication-policy.edit-policy', {
        url: '/edit-policy/:policyId',
        views: {
            '@company.policies': 'passwordAuthenticationPoliciesViewEdit'
        },
        resolve: { policy: policy }
    });
}

/** @ngInject */
function policy($stateParams, companyId, PasswordAuthenticationPoliciesService) {
    return PasswordAuthenticationPoliciesService.getPasswordPolicyDetails(companyId, $stateParams.policyId);
}

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _passwordAuthenticationPolicy = __webpack_require__(488);

_app.app.component('passwordAuthenticationPolicy', {
    bindings: {
        companyPasswordPolicies: '<',
        createNewPasswordPolicy: '<',
        defaultPolicy: '<'
    },
    controller: _passwordAuthenticationPolicy.Controller,
    templateUrl: __webpack_require__(1703)
});

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eace70de55141ee7d1380f8c3f9b8c6d.html";

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PasswordAuthenticationPoliciesService = function () {
    PasswordAuthenticationPoliciesService.$inject = ['$http'];

    /** @ngInject */
    function PasswordAuthenticationPoliciesService($http) {
        _classCallCheck(this, PasswordAuthenticationPoliciesService);

        this.$http = $http;
    }

    _createClass(PasswordAuthenticationPoliciesService, [{
        key: 'getPasswordPolicyList',
        value: function getPasswordPolicyList(companyId) {
            return this.$http.get('app/rest/companies/' + companyId + '/passwordpolicies').then(function (response) {
                return response.data;
            });
            //Returns: list of PasswordPolicyDTO
        }
    }, {
        key: 'createNewPasswordPolicy',
        value: function createNewPasswordPolicy(companyId) {
            return this.$http.post('app/rest/companies/' + companyId + '/passwordpolicies').then(function (response) {
                return response.data;
            });
            //Returns: CompanyPasswordPolicy
        }
    }, {
        key: 'getPasswordPolicyDetails',
        value: function getPasswordPolicyDetails(companyId, policyId) {
            return this.$http.get('app/rest/companies/' + companyId + '/passwordpolicies/' + policyId).then(function (response) {
                return response.data;
            });
            //Returns: CompanyPasswordPolicy
        }
    }, {
        key: 'editPasswordPolicyDetails',
        value: function editPasswordPolicyDetails(companyId, policyId, policy) {
            return this.$http.put('app/rest/companies/' + companyId + '/passwordpolicies/' + policyId, policy).then(function (response) {
                return response.data;
            });
            //Request body: CompanyPasswordPolicy
        }
    }, {
        key: 'deletePasswordPolicy',
        value: function deletePasswordPolicy(companyId, policyId) {
            return this.$http.delete('app/rest/companies/' + companyId + '/passwordpolicies/' + policyId).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'applyPasswordPolicyToApplication',
        value: function applyPasswordPolicyToApplication(companyId, policyId, applicationId) {
            return this.$http.post('app/rest/companies/' + companyId + '/passwordpolicies/' + policyId + '?action=applytoapp&appid=' + applicationId).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'removePasswordPolicyFromApplication',
        value: function removePasswordPolicyFromApplication(companyId, policyId, applicationId) {
            return this.$http.post('app/rest/companies/' + companyId + '/passwordpolicies/' + policyId + '?action=removefromapp&appid=' + applicationId).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'resetPasswordPolicy',
        value: function resetPasswordPolicy(companyId, policyId) {
            return this.$http.put('app/rest/companies/' + companyId + '/passwordpolicies/' + policyId + '?action=reset').then(function (response) {
                return response.data;
            });
        }
    }]);

    return PasswordAuthenticationPoliciesService;
}();

_app.app.service('PasswordAuthenticationPoliciesService', PasswordAuthenticationPoliciesService);

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

defaultPolicy.$inject = ['AuthenticationAccessPolicyResource', 'companyId', 'companyPasswordPolicies'];
companyPasswordPolicies.$inject = ['companyId', 'PasswordAuthenticationPoliciesService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.password-authentication-policy', {
        url: '/password-authentication-policy',
        component: 'passwordAuthenticationPolicy',
        resolve: { companyPasswordPolicies: companyPasswordPolicies, defaultPolicy: defaultPolicy }
    });
}

/** @ngInject */
function companyPasswordPolicies(companyId, PasswordAuthenticationPoliciesService) {
    return PasswordAuthenticationPoliciesService.getPasswordPolicyList(companyId);
}
/** @ngInject */
function defaultPolicy(AuthenticationAccessPolicyResource, companyId, companyPasswordPolicies) {
    return companyPasswordPolicies.find(function (policy) {
        return policy.passwordPolicyName === 'Default Policy';
    });
}

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _policies = __webpack_require__(489);

_app.app.component('policies', {
    bindings: {
        settings: '<'
    },
    controller: _policies.Controller,
    templateUrl: __webpack_require__(1707)
});

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "369868975c2f5ad6d19ecd5c1fa9d3b0.html";

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PoliciesService =

/** @ngInject */
function PoliciesService($http) {
    _classCallCheck(this, PoliciesService);

    this.$http = $http;
};

PoliciesService.$inject = ['$http'];
PoliciesService.$inject = ['$http'];


_app.app.service('PoliciesService', PoliciesService);

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies', {
        component: 'policies',
        redirectTo: 'company.policies.password-authentication-policy'
    });
}

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _recovery = __webpack_require__(490);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('company.recovery', {
        url: '/recovery',
        templateUrl: __webpack_require__(1713),
        controller: _recovery.Controller
    });
}

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7a30f67680202e06ed795f2e72f45e44.html";

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _administratorAudit = __webpack_require__(491);

_app.app.component('companyReportsAdministratorAudit', {
    bindings: {
        currentCompany: '<',
        logs$: '<'
    },
    controller: _administratorAudit.Controller,
    templateUrl: __webpack_require__(1715)
});

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3ca9213eac008cdaa80ae84ab7306a1a.html";

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _spRoleType = __webpack_require__(57);

var _lazyLoad = __webpack_require__(71);

logs$.$inject = ['companyId', 'StatisticsResource'];
config.$inject = ['$stateProvider'];

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-administrator-audit', {
        url: '/reports/administrator-audit',
        component: 'companyReportsAdministratorAudit',
        resolve: { logs$: logs$ }
    });
}

/** @ngInject */
function logs$(companyId, StatisticsResource) {
    return _spRoleType.roleTypes.reduce(function (byType, t) {
        return _extends({}, byType, _defineProperty({}, t, (0, _lazyLoad.lazyLoad)(function () {
            return StatisticsResource.getCompanyAdminAudits(companyId, t);
        })));
    }, {});
}

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyApplicationUsageReport', {
    bindings: {
        companyApplications: '<',
        computersCustomApplications: '<',
        computersProtectionApplications: '<'
    },
    templateUrl: __webpack_require__(1719)
});

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1b90bb3a1f8ee6318e4ec53008212c3e.html";

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

ApplicationUsageReportService.$inject = ['$resource'];


_app.app.factory('ApplicationUsageReportService', ApplicationUsageReportService);

/** @ngInject */
function ApplicationUsageReportService($resource) {
    var rootUrl = 'app/rest/company/:companyId/report';

    return {
        usageReport: $resource(rootUrl, {}, {
            'getCompanyApplications': {
                method: 'GET',
                url: rootUrl + '/appusage',
                isArray: true,
                params: {
                    companyId: '@companyId'
                }
            },
            'getFilterByTypeIdApplications': {
                method: 'GET',
                url: rootUrl + '/appusagecustom',
                isArray: true,
                params: {
                    companyId: '@companyId',
                    appTypeId: '@appTypeId'
                }
            }
        })

    };
}

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

computersCustomApplications.$inject = ['ApplicationUsageReportService', 'companyId'];
computersProtectionApplications.$inject = ['ApplicationUsageReportService', 'companyId'];
companyApplications.$inject = ['ApplicationUsageReportService', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-application-usage', {
        url: '/reports/appusage',
        component: 'companyApplicationUsageReport',
        resolve: {
            companyApplications: companyApplications,
            computersProtectionApplications: computersProtectionApplications,
            computersCustomApplications: computersCustomApplications
        }
    });
}

/** @ngInject */
function companyApplications(ApplicationUsageReportService, companyId) {
    return ApplicationUsageReportService.usageReport.getCompanyApplications({ companyId: companyId }).$promise;
}
/** @ngInject */
function computersProtectionApplications(ApplicationUsageReportService, companyId) {
    var appTypeId = 9;
    return ApplicationUsageReportService.usageReport.getFilterByTypeIdApplications({ companyId: companyId, appTypeId: appTypeId }).$promise;
}
/** @ngInject */
function computersCustomApplications(ApplicationUsageReportService, companyId) {
    var appTypeId = 2;
    return ApplicationUsageReportService.usageReport.getFilterByTypeIdApplications({ companyId: companyId, appTypeId: appTypeId }).$promise;
}

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _companyLoginReport = __webpack_require__(492);

_app.app.component('companyLoginReport', {
    controller: _companyLoginReport.Controller,
    templateUrl: __webpack_require__(1723)
});

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "798327841eeb612369e3934a56b6fb38.html";

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

CompanyLoginReportService.$inject = ['$resource'];


_app.app.factory('CompanyLoginReportService', CompanyLoginReportService);

/** @ngInject */
function CompanyLoginReportService($resource) {
    var rootUrl = 'app/rest/company/:companyId/report';

    return {
        companyLoginReport: $resource(rootUrl, {}, { 'initialReport': {
                method: 'POST'
            } }),
        companyLoginReportFilter: $resource(rootUrl + '/filter', {}, { 'doFilter': {
                method: 'POST',
                isArray: true
            } })

    };
}

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-main', {
        url: '/reports/main',
        component: 'companyLoginReport'
    });
}

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _computersReport = __webpack_require__(493);

_app.app.component('companyComputersReport', {
    bindings: {
        companyId: '<',
        computersProtectionApplications: '<'
    },
    controller: _computersReport.Controller,
    templateUrl: __webpack_require__(1727)
});

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f5fc5129ebb6dc1c7333d674096eca0e.html";

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

ComputersReportService.$inject = ['$resource'];


_app.app.factory('ComputersReportService', ComputersReportService);

/** @ngInject */
function ComputersReportService($resource) {

    var rootUrl = 'app/rest/company/:companyId/report';

    return {
        computersReport: $resource(rootUrl, {}, { 'getComputersReport': {
                method: 'GET',
                url: rootUrl + '/computers',
                isArray: true,
                params: {
                    companyId: '@companyId',
                    appId: '@appId'
                }
            }
        })

    };
}

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

computersProtectionApplications.$inject = ['ApplicationsResource', 'companyId'];
config.$inject = ['$stateProvider'];

_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-computers', {
        url: '/reports/computers',
        component: 'companyComputersReport',
        resolve: {
            computersProtectionApplications: computersProtectionApplications
        }
    });
}

/** @ngInject */
function computersProtectionApplications(ApplicationsResource, companyId) {
    return ApplicationsResource.getAllComputerProtectionApplicationsForCompany(companyId);
}

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyReportsHeader', {
    templateUrl: __webpack_require__(1731)
});

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1d1bd846789ffee85eeb25a90c647897.html";

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sessionRecordingReport = __webpack_require__(494);

_app.app.component('sessionRecordingReport', {
    controller: _sessionRecordingReport.Controller,
    templateUrl: __webpack_require__(1733)
});

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b033ad204d2ed6edb7ce5aed7db90edd.html";

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SessionRecordingReportService.$inject = ['$resource'];


_app.app.factory('SessionRecordingReportService', SessionRecordingReportService);

/** @ngInject */
function SessionRecordingReportService($resource) {
    var rootUrl = 'app/rest/company/:companyId/report/sessionrecordings';

    return {
        sessionRecordingReport: $resource(rootUrl, {}, { 'initialReport': {
                method: 'POST'
            } }),
        sessionRecordingReportFilter: $resource(rootUrl + '/filter', {}, { 'doFilter': {
                method: 'POST',
                isArray: true
            } })

    };
}

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-session-recording', {
        url: '/reports/sessionrecording',
        component: 'sessionRecordingReport'
    });
}

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharingCenterDeletedReport = __webpack_require__(495);

_app.app.component('sharingCenterDeletedReport', {
    bindings: {
        accounts: '<'
    },
    controller: _sharingCenterDeletedReport.Controller,
    templateUrl: __webpack_require__(1737)
});

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97a367860b283920f69081ab340eba8f.html";

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['companyId', 'SharedAccountsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-sharing-center-deleted', {
        url: '/reports/sharing-center/deleted',
        component: 'sharingCenterDeletedReport',
        resolve: { accounts: accounts }
    });
}

/** @ngInject */
function accounts(companyId, SharedAccountsService) {
    return SharedAccountsService.getDeletedByCompany({ companyId: companyId }).$promise;
}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharingCenterReports = __webpack_require__(496);

_app.app.component('sharingCenterReport', {
  bindings: {
    currentCompany: '<',
    sharedAccounts: '<'
  },
  controller: _sharingCenterReports.Controller,
  templateUrl: __webpack_require__(1740)
});

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5613f8d3c88884aebb348db1c2aadbc0.html";

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

sharedAccounts.$inject = ['companyId', 'SharedAccountsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reports-sharing-center', {
        url: '/reports/sharing-center',
        component: 'sharingCenterReport',
        resolve: { sharedAccounts: sharedAccounts }
    });
}

/** @ngInject */
function sharedAccounts(companyId, SharedAccountsService) {
    return SharedAccountsService.getAllSharedReportByCompany({ companyId: companyId }).$promise;
}

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addNewCompany = __webpack_require__(497);

_app.app.component('companyResellerAddNewCompany', {
    bindings: {
        account: '<',
        administrators: '<',
        companyId: '<'
    },
    controller: _addNewCompany.Controller,
    templateUrl: __webpack_require__(1743)
});

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f1eb4172b352579cbebadaa45914a267.html";

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller.add-new-company', {
        url: '/add-new-company',
        component: 'companyResellerAddNewCompany',
        resolve: {}
    });
}

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _resellerList = __webpack_require__(498);

_app.app.component('companyResellerList', {
    controller: _resellerList.Controller,
    templateUrl: __webpack_require__(1746),
    bindings: {
        companyId: '<',
        companies: '<'
    }
});

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f43e89b963d82e1ca8bbfdf2bdbffcf9.html";

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

companies.$inject = ['ResellerCompanyResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller.list', {
        url: '/list',
        component: 'companyResellerList',
        resolve: {
            companies: companies
        }
    });
}

/** @ngInject */
function companies(ResellerCompanyResource, companyId) {
    return ResellerCompanyResource.getCompanies(companyId);
}

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bindings;

var _app = __webpack_require__(0);

var _newCompany = __webpack_require__(499);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_app.app.component('companyResellerNewCompany', {
    bindings: (_bindings = {
        account: '<',
        administrators: '<',
        appType$: '<',
        appTypes$: '<',
        companyId: '<'
    }, _defineProperty(_bindings, 'companyId', '<'), _defineProperty(_bindings, 'createdCompany', '<'), _bindings),
    controller: _newCompany.Controller,
    templateUrl: __webpack_require__(1749)
});

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ef277c3191fbaa7f4137e8ef5b08faf8.html";

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _administrators = __webpack_require__(104);

createdCompany.$inject = ['$stateParams'];
administrators.$inject = ['$filter', 'account', 'companyId', 'RoleResource'];
config.$inject = ['$stateProvider'];

_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller.new-company', {
        url: '/new-company',
        component: 'companyResellerNewCompany',
        params: { createdCompany: null },
        resolve: {
            administrators: administrators,
            createdCompany: createdCompany
        }
    });
}

/** @ngInject */
function createdCompany($stateParams) {
    return $stateParams.createdCompany;
}

/** @ngInject */
function administrators($filter, account, companyId, RoleResource) {
    return RoleResource.getAllCompanyUsersWithRole(companyId).then(function (users) {
        return users.map(_administrators.userFromDto);
    }).then(function (users) {
        return users.map(function (user) {
            return _extends({}, user, { order: user.order + (account.login === user.saaspassId ? 1 : 0)
            });
        });
    }).then(function (users) {
        return $filter('orderBy')(users, 'order', true);
    });
}

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _resellerCompanyDetail = __webpack_require__(500);

_app.app.component('companyResellerCompanyDetail', {
    bindings: {
        account: '<',
        administrators: '<',
        companyDetails: '<',
        companyId: '<',
        appType$: '<',
        appTypes$: '<'
    },
    controller: _resellerCompanyDetail.Controller,
    templateUrl: __webpack_require__(1752)
});

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4fc2f4d1e744533d83e2b0922309ee21.html";

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _administrators = __webpack_require__(104);

resellerCompanyId.$inject = ['$stateParams'];
companyDetails.$inject = ['ResellerCompanyResource', 'resellerCompanyId', 'companyId'];
config.$inject = ['$stateProvider'];

_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller.company-detail', {
        url: '/company-detail?resellerCompanyId',
        component: 'companyResellerCompanyDetail',
        resolve: {
            companyDetails: companyDetails,
            resellerCompanyId: resellerCompanyId
        }
    });
}

/** @ngInject */
function resellerCompanyId($stateParams) {
    return $stateParams.resellerCompanyId;
}

/** @ngInject */
function companyDetails(ResellerCompanyResource, resellerCompanyId, companyId) {
    return ResellerCompanyResource.getCompanyDetail(companyId, resellerCompanyId);
}

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _reseller = __webpack_require__(501);

_app.app.component('companyReseller', {
    bindings: {
        account: '<',
        appType$: '<',
        appTypes$: '<',
        companyId: '<'
    },
    controller: _reseller.Controller,
    templateUrl: __webpack_require__(1755)
});

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a69b28ae9c47ad176e1cee6e2b6c1f64.html";

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller', {
        url: '/reseller',
        redirectTo: 'company.reseller.list',
        component: 'companyReseller',
        resolve: {}
    });
}

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _resources = __webpack_require__(201);

_app.app.component('companyResources', {
    bindings: {
        companyId: '<'
    },
    controller: _resources.Controller,
    templateUrl: __webpack_require__(1758)
});

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7dcb82038b448a68ac8a22b60737d3f.html";

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _resources = __webpack_require__(201);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('company.resources', {
        url: '/resources',
        component: 'companyResources'
    });
}

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _rolesHelp = __webpack_require__(502);

_app.app.component('companyRolesHelp', {
    bindings: { currentCompany: '<' },
    templateUrl: __webpack_require__(1762),
    controller: _rolesHelp.Controller
});

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8e43156505924ad416005bf75165e270.html";

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.roles-help', {
        url: '/roles-help',
        component: 'companyRolesHelp'
    });
}

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addSaaspassConnect = __webpack_require__(503);

_app.app.component('addSaaspassConnect', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _addSaaspassConnect.Controller,
    templateUrl: __webpack_require__(1765)
});

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b4d59b7592213f900f5f5bccd9d70057.html";

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('confirmDeleteSaaspassConnect', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1767)
});

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "699dcfdb5f4316c1c5d4e264040496f5.html";

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _oidcAccessControlPolicy = __webpack_require__(504);

_app.app.component('companyManageSaaspassConnectAccessControlPolicy', {
    bindings: {
        connectApplication: '<',
        companyId: '<',
        authenticationAccessPolicyList: '<'
    },
    controller: _oidcAccessControlPolicy.Controller,
    templateUrl: __webpack_require__(1769)
});

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "789c831a324436aaa3cf095dc7ab65a0.html";

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

authenticationAccessPolicyList.$inject = ['AuthenticationAccessPolicyResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect.manage.access-control-policy', {
        url: '/access-control-policy',
        component: 'companyManageSaaspassConnectAccessControlPolicy',
        resolve: { authenticationAccessPolicyList: authenticationAccessPolicyList }
    });
}

/** @ngInject */
function authenticationAccessPolicyList(AuthenticationAccessPolicyResource, companyId) {
    var type = 'basic';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId, type);
}

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _developers = __webpack_require__(505);

_app.app.component('companySaaspassConnectManageDevelopers', {
    bindings: {
        companyId: '<',
        connectId: '<'
    },
    controller: _developers.Controller,
    templateUrl: __webpack_require__(1779)
});

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ad8a784ee2a8a9bcdeffc90ae2fbf670.html";

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./hdpi/login_with-saaspass.png": 506,
	"./mdpi/login_with-saaspass.png": 1775,
	"./xhdpi/login_with-saaspass.png": 1776,
	"./xxhdpi/login_with-saaspass.png": 1777,
	"./xxxhdpi/login_with-saaspass.png": 1778
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1774;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "33d9309cb0ddc3da06d11869b401ebd8.png";

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4da0b7cc66184385cec671ac918d8249.png";

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4dfb49bab7865c8d8cfd19010ea2825e.png";

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c54738d1dd6c041c1c7d7e0d9a1cfce3.png";

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4cf2618b6ab2d4c196afd9a504376df7.html";

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SaaspassConnectDevelopersService.$inject = ['$resource'];


_app.app.factory('SaaspassConnectDevelopersService', SaaspassConnectDevelopersService);

/** @ngInject */
function SaaspassConnectDevelopersService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/saaspassconnects/:connectId/credentials';

    return {
        saaspassConnectCredentialsUrl: rootUrl,
        saaspassConnectCredentials: $resource(rootUrl, {}, { 'updateSaaspassConnect': {
                method: 'PUT'
            } })

    };
}

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect.manage.developers', {
        url: '/developers',
        component: 'companySaaspassConnectManageDevelopers'
    });
}

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companySaaspassConnectManage', {
    templateUrl: __webpack_require__(1783)
});

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "478bbf9a6a279e4549f9128c2ff2a633.html";

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

connectId.$inject = ['$stateParams'];
connectApplication.$inject = ['companyId', 'connectId', 'SaaspassConnectOverviewService'];
$breadcrumbs.$inject = ['connectApplication'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect.manage', {
        url: '/saaspassConnect/:connectId/manage',
        redirectTo: 'company.saaspass-connect.manage.overview',
        views: {
            '@company': 'companySaaspassConnectManage'
        },
        resolve: {
            $breadcrumbs: $breadcrumbs,
            connectApplication: connectApplication,
            connectId: connectId
        }
    });
}

/** @ngInject */
function $breadcrumbs(connectApplication) {
    return [{ title: connectApplication.displayName }];
}

/** @ngInject */
function connectApplication(companyId, connectId, SaaspassConnectOverviewService) {
    return SaaspassConnectOverviewService.saaspassConnect.get({ companyId: companyId, connectId: connectId }).$promise;
}

/** @ngInject */
function connectId($stateParams) {
    return $stateParams.connectId;
}

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _overview = __webpack_require__(507);

_app.app.component('companySaaspassConnectManageOverview', {
    bindings: {
        account: '<',
        companyId: '<',
        connectApplication: '<',
        connectId: '<'
    },
    controller: _overview.Controller,
    templateUrl: __webpack_require__(1788)
});

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "305e0fb0eb9d8f48e6db75d65819d3d0.html";

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "46ff78a78e2c02dbfe8bbd74347a1927.html";

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "777be3d46a41a5e42f3a61eb4c6bea26.html";

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SaaspassConnectOverviewService.$inject = ['$resource'];


_app.app.factory('SaaspassConnectOverviewService', SaaspassConnectOverviewService);

/** @ngInject */
function SaaspassConnectOverviewService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/saaspassconnects/:connectId';

    return {

        saaspassConnect: $resource(rootUrl, {}, { 'updateSaaspassConnect': {
                method: 'PUT'
            } }),
        saaspassConnectDelete: $resource(rootUrl + '/delete')

    };
}

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect.manage.overview', {
        url: '/overview',
        component: 'companySaaspassConnectManageOverview'
    });
}

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _app = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

PhotoUploadService.$inject = ['$http'];


/**
 * Service for profile photo upload.
 */
_app.app.factory('PhotoUploadService', PhotoUploadService);

/** @ngInject */
function PhotoUploadService($http) {
    return {
        upload: function upload(file, id, uploadUrl, successAction, errorAction) {
            var fd = new FormData();
            fd.append('file', file);

            $http.post(uploadUrl, fd, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (response) {
                return successAction(response.data);
            }).catch(function (response) {
                return errorAction(response.data);
            });
        }
    };
}

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _saaspassConnect = __webpack_require__(508);

_app.app.component('companySaaspassConnect', {
    bindings: {
        companyId: '<',
        connectApplications: '<'
    },
    controller: _saaspassConnect.Controller,
    templateUrl: __webpack_require__(1793)
});

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee7cd4c7a28320f02c51c70dc9d62040.html";

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SaaspassConnectService.$inject = ['$resource'];


_app.app.factory('SaaspassConnectService', SaaspassConnectService);

/** @ngInject */
function SaaspassConnectService($resource) {
    return $resource('app/rest/admin/company/:companyId/saaspassconnects', {
        companyId: '@companyId'
    }, {
        'applyPolicy': {
            method: 'PUT',
            url: 'app/rest/admin/company/:companyId/saaspassconnects/:id/:policyId',
            params: {
                id: '@id',
                policyId: '@policyId'
            },
            isArray: true
        }
    });
}

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

connectApplications.$inject = ['companyId', 'SaaspassConnectService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect', {
        url: '/saaspassConnect',
        component: 'companySaaspassConnect',
        resolve: { connectApplications: connectApplications }
    });
}

/** @ngInject */
function connectApplications(companyId, SaaspassConnectService) {
    return SaaspassConnectService.query({ companyId: companyId }).$promise;
}

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _configuration = __webpack_require__(509);

_app.app.component('configuration', {
    bindings: {
        settings: '<'
    },
    controller: _configuration.Controller,
    templateUrl: __webpack_require__(1797)
});

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60a104f47b0ac0cb72445ddb38116a1c.html";

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SaaspassVpnService = function () {
    SaaspassVpnService.$inject = ['$http'];

    /** @ngInject */
    function SaaspassVpnService($http) {
        _classCallCheck(this, SaaspassVpnService);

        this.$http = $http;
    }

    _createClass(SaaspassVpnService, [{
        key: 'generateOvpnConfig',
        value: function generateOvpnConfig(companyId, config) {
            return this.$http.post('app/rest/company/' + companyId + '/ovpn-config/', config, { responseType: 'arraybuffer' }).then(function (response) {
                return response.data;
            });
        }
    }]);

    return SaaspassVpnService;
}();

_app.app.service('SaaspassVpnService', SaaspassVpnService);

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

settings.$inject = ['companyId', 'SaaspassVpnService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-vpn.configuration', {
        url: '/configuration',
        component: 'configuration'
        // resolve: {settings},
    });
}

/** @ngInject */
function settings(companyId, SaaspassVpnService) {
    return SaaspassVpnService.get(companyId);
}

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('integration', {
    bindings: {
        settings: '<'
    },
    templateUrl: __webpack_require__(1801)
});

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "70a5239a56512a0c1b74035e1de9992d.html";

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

settings.$inject = ['companyId', 'SaaspassVpnService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-vpn.integration', {
        url: '/integration',
        component: 'integration'
        // resolve: {settings},
    });
}

/** @ngInject */
function settings(companyId, SaaspassVpnService) {
    return SaaspassVpnService.get(companyId);
}

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('saaspassVpn', {
    bindings: {
        settings: '<'
    },
    templateUrl: __webpack_require__(1804)
});

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fff5d38d07661f0b08139c6bfd102076.html";

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-vpn', {
        url: '/saaspassVpn',
        component: 'saaspassVpn',
        redirectTo: 'company.saaspass-vpn.integration'
    });
}

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _chooseSharedFolder = __webpack_require__(510);

_app.app.component('companySharingCenterSharedFoldersChoose', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _chooseSharedFolder.Controller,
    templateUrl: __webpack_require__(1807)
});

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60c932299a5a6afe0ca7f5c5cef635d2.html";

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ChooseSharedFolder', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_sharedFolders) {
        return $uibModal.open({
            component: 'companySharingCenterSharedFoldersChoose',
            resolve: {
                sharedFolders: function sharedFolders() {
                    return _sharedFolders;
                }
            }
        }).result;
    };
}

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageBulk = __webpack_require__(511);

_app.app.component('companySharingCenterManageBulkAccounts', {
       bindings: {
              companyId: '<',
              labels$: '<',
              selectedAccounts: '<'
       },
       controller: _manageBulk.Controller,
       templateUrl: __webpack_require__(1810)
});

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0839a71518a00859d05602c0bfdf5759.html";

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

companyId.$inject = ['$stateParams'];
selectedAccounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.states(['company.sharing-center.shared-passwords.manage-bulk', 'company.sharing-center.shared-authenticators.manage-bulk'], {
        url: '/manage/bulk',
        params: { selectedAccounts: [] },
        views: {
            '@company.sharing-center': 'companySharingCenterManageBulkAccounts'
        },
        resolve: {
            companyId: companyId,
            selectedAccounts: selectedAccounts
        }
    });
}
/** @ngInject */
function selectedAccounts($stateParams) {
    return $stateParams.selectedAccounts;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

PublicServices.$inject = ['$http'];


_app.app.factory('PublicServices', PublicServices);

/** @ngInject */
function PublicServices($http) {

    var url = 'app/rest/public_services/';
    return {
        getAllPublicServicesThatSupportSSO: getAllPublicServicesThatSupportSSO,
        getAllPublicServicesThatSupportSSOFiltered: getAllPublicServicesThatSupportSSOFiltered,
        getAllPublicServicesThatSupportSSOAnd2FAFiltered: getAllPublicServicesThatSupportSSOAnd2FAFiltered
    };

    function getAllPublicServicesThatSupportSSO() {
        return $http.get(url + 'ssosupported').then(function (response) {
            return response.data;
        });
    }

    function getAllPublicServicesThatSupportSSOFiltered() {
        return $http.get(url + 'ssosupportedfiltered').then(function (response) {
            return response.data;
        });
    }

    function getAllPublicServicesThatSupportSSOAnd2FAFiltered() {
        return $http.get(url + 'ssoand2fasupported').then(function (response) {
            return response.data;
        });
    }
}

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _securityScan = __webpack_require__(512);

_app.app.component('companySharingCenterSecurityScan', {
    bindings: {
        accounts: '<'
    },
    controller: _securityScan.Controller,
    templateUrl: __webpack_require__(1814)
});

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c4743813502fcf982fa9f686c5a56e63.html";

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

accounts.$inject = ['$filter', 'companyId', 'SharedAccountsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.security-scan', {
        url: '/security-scan',
        component: 'companySharingCenterSecurityScan',
        resolve: { accounts: accounts }
    });
}

/** @ngInject */
function accounts($filter, companyId, SharedAccountsService) {
    return SharedAccountsService.getAllByCompany({ companyId: companyId }, {}).$promise.then(function (accounts) {
        return $filter('orderBy')(accounts, 'publicService.serviceName');
    }).then(function (accounts) {
        return accounts.map(function (account) {
            return _extends({}, account, { serviceDisplayName: serviceDisplayName(account) });
        });
    });
}

function serviceDisplayName(account) {
    var displayName = '';
    if (account.publicService.slug != 'other' || !account.customServiceName) {
        displayName = account.publicService.serviceName;
    } else if (account.publicService.slug == 'other') {
        displayName = account.customServiceName;
    }
    return displayName;
}

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smartTable = __webpack_require__(2);

var _spAlert = __webpack_require__(4);

var _store = __webpack_require__(19);

modal.$inject = ['$uibModal']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.factory('ComputerAdministrationAccountShare', modal);

/** @ngInject */
function modal($uibModal) {

    return function (account) {
        controller.$inject = ['$rootScope', '$scope', '$state', '$translate', '$uibModalInstance', 'CompanyUser', 'ConfirmDeleteModal', 'SharedAccountsService'];


        return $uibModal.open({
            templateUrl: __webpack_require__(1817),
            controller: controller,
            controllerAs: 'vm'
        }).result;

        /** @ngInject */
        function controller($rootScope, $scope, $state, $translate, $uibModalInstance, CompanyUser, ConfirmDeleteModal, SharedAccountsService) {
            this.cancel = function () {
                return $uibModalInstance.dismiss();
            };
            this.close = function () {
                return $uibModalInstance.close();
            };
            $scope.account = account;
            var companyId = $state.params.companyId;

            $scope.st = new _smartTable.SmartTable();

            $scope.stGroup = new _smartTable.SmartTable();

            $scope.selectedGroup = 0;

            var errorInitGroupsAndUsers = function errorInitGroupsAndUsers(error) {
                //TODO handle error on user populate request
                $scope.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            };

            var errorUnshareGroup = function errorUnshareGroup(error) {
                $scope.spAlert = new _spAlert.SpAlert('danger', error.data.message);
            };

            $scope.unshare = function (groupId) {
                $scope.groupId = groupId;
                ConfirmDeleteModal('groups_users.confirm_shared_email_account_delete').then(function () {
                    return $scope.deleteConfirmed();
                });
            };

            $scope.deleteConfirmed = function () {
                var param = {
                    companyId: companyId,
                    id: account.id,
                    groupId: $scope.groupId
                };
                SharedAccountsService.unshareCompanyServiceAccountsWithGroup(param, {}, function (response) {
                    initGroupsAndUsers();
                    $scope.spAlert = new _spAlert.SpAlert('success', 'shared_accounts.messages.unshare_account');
                }, errorUnshareGroup);
            };

            $scope.selectUser = function (position) {};

            $scope.unselectUser = function (position) {};

            $scope.shareWithSelectedGroup = function () {
                var param = {
                    companyId: companyId,
                    id: account.id,
                    groupId: $scope.selectedGroup
                };
                SharedAccountsService.shareCompanyServiceAccountsWithGroup(param, {}, function (response) {
                    initGroupsAndUsers();
                    $scope.spAlert = new _spAlert.SpAlert('success', 'shared_accounts.messages.share_account');
                }, errorUnshareGroup);
            };

            var initGroupsAndUsers = function initGroupsAndUsers() {
                SharedAccountsService.getSaaspassUsersByCorporateServiceAccountId({ companyId: companyId, id: account.id }, {}, function (response) {
                    $scope.users = response.sharedUsersList;
                    $scope.sharedGroupsList = response.sharedGroupsList;
                    $scope.unsharedGroupsList = response.unsharedGroupsList;
                    $scope.groupSelectionChange(0);
                }, errorInitGroupsAndUsers);
            };

            initGroupsAndUsers();

            $scope.groupSelectionChange = function (selectedGroup) {
                console.log('selection changed: ' + selectedGroup);
                $scope.selectedGroup = selectedGroup;
            };
        }
    };
}

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b2390877167eaed7e5fff62e972e3a01.html";

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _share = __webpack_require__(513);

_app.app.component('companySharingCenterShare', {
    bindings: {
        companyId: '<',
        isNote: '<',
        sharedAccount: '<',
        labels$: '<',
        sharedAccountId: '<',
        users: '<',
        sharedLabels: '<',
        assignedUnassignedFolders: '<'
    },
    controller: _share.Controller,
    templateUrl: __webpack_require__(1819)
});

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f7895fa584f70756717ebb49615f99e8.html";

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

assignedUnassignedFolders.$inject = ['SharedFoldersResource', '$stateParams', 'isNote'];
sharedLabels.$inject = ['SharedAccountsService', '$stateParams', 'isNote'];
users.$inject = ['SharedAccountsService', '$stateParams', 'isNote'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

	$stateProvider.states(['company.sharing-center.shared-passwords.manage.share', 'company.sharing-center.shared-authenticators.manage.share', 'company.sharing-center.shared-notes.manage.share'], {
		url: '/share',
		params: { sharedAccount: {} },
		component: 'companySharingCenterShare',
		resolve: { users: users, sharedLabels: sharedLabels, assignedUnassignedFolders: assignedUnassignedFolders }
	});
}

/** @ngInject */
function users(SharedAccountsService, $stateParams, isNote) {
	if (isNote) {
		return SharedAccountsService.getAllCompanyNotesUsers({
			companyId: $stateParams.companyId,
			id: $stateParams.sharedAccountId
		}, {}).$promise.then(function (sharedUsersList) {
			return sharedUsersList;
		});
	}
	return SharedAccountsService.getSaaspassUsersByCorporateServiceAccountId({
		companyId: $stateParams.companyId,
		id: $stateParams.sharedAccountId
	}, {}).$promise.then(function (_ref) {
		var sharedUsersList = _ref.sharedUsersList;

		return sharedUsersList;
	});
}

/** @ngInject */
function sharedLabels(SharedAccountsService, $stateParams, isNote) {
	if (isNote) {
		return SharedAccountsService.getSharedLabelsByCorporateNoteId({
			companyId: $stateParams.companyId,
			id: $stateParams.sharedAccountId
		}, {}).$promise.then(function (labels) {
			return labels.map(function (label) {
				return updateLabelDTO(label);
			});
		});
	} else {
		return SharedAccountsService.getSharedLabelsByCorporateServiceAccountId({
			companyId: $stateParams.companyId,
			id: $stateParams.sharedAccountId
		}, {}).$promise.then(function (labels) {
			return labels.map(function (label) {
				return updateLabelDTO(label);
			});
		});
	}
}

/** @ngInject */
function assignedUnassignedFolders(SharedFoldersResource, $stateParams, isNote) {
	return SharedFoldersResource.getAssignedUnassignedFoldersForCorporateItemId($stateParams.sharedAccountId, $stateParams.companyId, isNote);
}

function updateLabelDTO(label) {
	var className = '';
	var sref = '';
	if (label.isCustom) {
		className = 'sp_colorBlueLink fa fa-user-circle-o';
		sref = 'company.user-directories.saaspass-users.user-labels({userLabelId:' + label.id.toString() + '})';
	} else {
		if (label.name === 'ALL_USERS') {
			className = 'sp_colorBlueLink fa fa-users';
			sref = 'company.user-directories.saaspass-users.all-users';
		} else if (label.name === 'ADMINISTRATORS') {
			className = 'sp_colorBlueLink fa fa-user-plus';
			sref = 'company.user-directories.saaspass-users.administrators-developers';
		} else if (label.name === 'MOBILE_APP_USERS') {
			className = 'sp_colorBlueLink fa fa-mobile-alt';
			sref = 'company.user-directories.saaspass-users.regular-saaspass-app-users';
		} else if (label.name === 'HARD_TOKEN_USERS') {
			className = 'sp_colorBlueLink fa fa-calculator';
			sref = 'company.user-directories.saaspass-users.hard-token-users';
		} else if (label.name === 'SMS_USERS') {
			className = 'sp_colorBlueLink fa fa-comment';
			sref = 'company.user-directories.saaspass-users.sms-users';
		}
	}
	return _extends({}, label, { className: className, sref: sref });
}

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.factory('ShareAnAdditionalEmailAccount', modal);

/** @ngInject */
function modal($uibModal) {

    return function () {
        controller.$inject = ['$rootScope', '$scope', '$state', 'Alert', '$translate', '$uibModalInstance', 'CompanyUser', 'UserAccounts'];


        return $uibModal.open({
            templateUrl: __webpack_require__(1822),
            controller: controller
        }).result;

        /** @ngInject */
        function controller($rootScope, $scope, $state, Alert, $translate, $uibModalInstance, CompanyUser, UserAccounts) {
            $scope.cancel = function () {
                $uibModalInstance.dismiss();
            };
            $scope.step = "step1";
            var companyId = $state.params.companyId;
            $scope.userDirectoriesHref = $state.href('company.user-directories');

            $scope.checkUserAccountType = function () {
                $scope.showNoUserErrorInstructions = false;
                var username = $scope.username;
                $scope.message = null;
                if ($scope.username) {
                    UserAccounts.getSharedEmailAccountType({
                        companyId: companyId,
                        username: username
                    }, function (data) {
                        if (data.accountType == "INTERNAL_EMAIL") {
                            $scope.step = 'step_INTERNAL_EMAIL';
                            $scope.assignedCompanyUser = data.companyUser;
                        } else if (data.accountType == "SHARED_EMAIL") {
                            $scope.step = 'step_SHARED_EMAIL';
                            $scope.alreadySharedTekst = $translate.instant("sharing_center.company_email_account_is_already_shared", { username: username });
                        } else {
                            $scope.message = $translate.instant("sharing_center.no_company_email_account_found_for") + ": " + username;
                            $scope.showNoUserErrorInstructions = true;
                        }
                    }, function (response) {
                        if (response.data.serviceErrorCode == "ERR_100802") {
                            $scope.message = $translate.instant("sharing_center.no_company_email_account_found_for") + ": " + username;
                            $scope.showNoUserErrorInstructions = true;
                        } else {
                            $scope.message = response.data.message;
                        }
                    });
                }
            };

            $scope.manageAccount = function (username) {
                $state.go('company.sharing-center.shared-accounts.manage', { username: username });
                $uibModalInstance.dismiss();
            };

            $scope.identifyUser = function () {
                $scope.message = null;
                $scope.userIdentifier = $scope.newUserIdentifier;

                if ($scope.userIdentifier == $scope.currentSaaspassId) {
                    $scope.successResult = false;
                    $scope.showVerification = false;

                    $scope.message = 'groups_users.user_is_the_same';
                } else if ($scope.userIdentifier == $scope.currentEmailAddress) {
                    $scope.successResult = false;
                    $scope.showVerification = false;

                    $scope.message = 'groups_users.user_email_is_the_same';
                } else {
                    CompanyUser.identifyCompanyUser({
                        companyId: companyId,
                        uid: encodeURIComponent($scope.userIdentifier)
                    }, function (data) {
                        if (data.id && data.id == $scope.currentCompanyUserId || data.saaspassUser && data.saaspassUser.id == $scope.currentSaaspassId) {
                            $scope.successResult = false;
                            $scope.showVerification = false;

                            $scope.message = 'groups_users.user_is_the_same';
                        } else {
                            $scope.successResult = true;
                            $scope.showVerification = false;
                            $scope.companyUser = data;

                            $scope.message = 'groups_users.user_found';
                        }
                    }, function (response) {
                        $scope.successResult = false;
                        $scope.companyUser = null;

                        $scope.showVerification = $scope.enableVerification && !$scope.successResult && $rootScope.emailPattern.test($scope.userIdentifier);

                        if (response.status == 404) {
                            $scope.message = 'groups_users.user_not_found';
                        } else {
                            $scope.message = response.data.message;
                        }
                    });
                }
            };

            $scope.share = function (saaspassId) {
                var username = $scope.username;
                if ($scope.isSendingRequest) {
                    return;
                }
                $scope.isSendingRequest = true;

                var param = {
                    companyId: companyId
                };
                var dataReq = {
                    username: username,
                    companyUser: $scope.companyUser
                };

                UserAccounts.createSharedUserAccount(param, dataReq, function (data) {
                    $scope.userAccount = data;
                    $scope.username = data.username;
                    $scope.newAccount = data;
                    var key = 'groups_users.added_active_account_SHARED_EMAIL';
                    var variables = { saaspassId: saaspassId };
                    $state.reload($state.current).then(function () {
                        return Alert('success', key, variables);
                    });
                }, function (error) {
                    $scope.isSendingRequest = false;
                });
            };
        }
    };
}

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f1a850447ecb1368e071c262785e8667.html";

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedAccounts = __webpack_require__(514);

_app.app.component('companySharingCenterSharedAccounts', {
    bindings: { accounts: '<' },
    controller: _sharedAccounts.Controller,
    templateUrl: __webpack_require__(1824)
});

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9a8f55d827beaf4b2a6c4adea1ef52c9.html";

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$filter', 'companyId', 'UserAccounts'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-accounts', {
        url: '/shared-accounts',
        component: 'companySharingCenterSharedAccounts',
        resolve: { accounts: accounts }
    });
}

/** @ngInject */
function accounts($filter, companyId, UserAccounts) {
    return UserAccounts.getSharedEmailAccounts({ companyId: companyId }, {}).$promise.then(function (items) {
        return $filter('orderBy')(items, 'publicService.serviceName');
    });
}

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addSharedAuthenticator = __webpack_require__(515);

_app.app.component('companySharingCenterSharedAuthenticatorsAdd', {
    bindings: {
        publicServicesWithSsoAnd2FA$: '<',
        companyId: '<',
        copyAccount: '<'
    },
    controller: _addSharedAuthenticator.Controller,
    templateUrl: __webpack_require__(1828)
});

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1e3dfa9e189d14ceee0a4b8545845e48.html";

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "06b23d3d64b6da877e7f47cd1d92a593.html";

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('AddNewSharedAuthenticatorModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_publicServices) {
        return $uibModal.open({
            component: 'companySharingCenterSharedAuthenticatorsAdd',
            resolve: { publicServices: function publicServices() {
                    return _publicServices;
                } }
        }).result;
    };
}

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

copyAccount.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.add-shared-authenticator', {
        url: '/add-shared-authenticator',
        params: { copyAccount: null },
        views: {
            '@company.sharing-center': 'companySharingCenterSharedAuthenticatorsAdd'
        },
        resolve: {
            copyAccount: copyAccount
        }
    });
}

/** @ngInject */
function copyAccount($stateParams) {
    return $stateParams.copyAccount;
}

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deleteAccounts = __webpack_require__(517);

_app.app.component('companySharingCenterSharedAuthenticatorsDelete', {
    bindings: {
        accounts: '<',
        companyId: '<'
    },
    controller: _deleteAccounts.Controller,
    templateUrl: __webpack_require__(1832)
});

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fffa4bb433a115203ca9322a98220f68.html";

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

companyId.$inject = ['$stateParams'];
accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-authenticators.delete', {
        url: '/delete',
        params: { accounts: [] },
        //component: 'companySharingCenterSharedAuthenticatorsDelete',
        views: {
            '@company.sharing-center': 'companySharingCenterSharedAuthenticatorsDelete'
        },
        resolve: {
            accounts: accounts,
            companyId: companyId
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importSharedAuthenticator = __webpack_require__(518);

_app.app.component('companySharingCenterSharedAuthenticatorsImport', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _importSharedAuthenticator.Controller,
    templateUrl: __webpack_require__(1835)
});

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f231f08ac9d8d09090213edb4d788c06.html";

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

authenticators.$inject = ['$filter', 'Authenticator'];
modal.$inject = ['$uibModal'];


_app.app.service('ImportSharedAuthenticatorsModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function () {
        return $uibModal.open({
            component: 'companySharingCenterSharedAuthenticatorsImport',
            resolve: { authenticators: authenticators }
        }).result;
    };
}

/** @ngInject */
function authenticators($filter, Authenticator) {
    return Authenticator.query().$promise
    // .then((items) => $filter('filter')(items, {ssoEnabled: true}))
    .then(function (items) {
        return $filter('orderBy')(items, 'publicService.serviceName');
    });
}

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('confirmConvert', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1838)
});

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "506473dfe2ecbdc59d9c2bf2cbc5b03f.html";

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ConfirmConvertModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_messageKey) {
        return $uibModal.open({
            component: 'confirmConvert',
            resolve: { messageKey: function messageKey() {
                    return _messageKey;
                } }
        }).result;
    };
}

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageSharedAuthenticator = __webpack_require__(519);

_app.app.component('companySharingCenterSharedAuthenticatorsManage', {
    bindings: {
        publicServicesWithSso$: '<',
        sharedAccount: '<',
        companyId: '<',
        allAccounts: '<'
    },
    //bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: _manageSharedAuthenticator.Controller,
    templateUrl: __webpack_require__(1841)
});

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d62ddeae2bd51d74bb8d43dd8c39c702.html";

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ManageSharedAuthenticatorModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_account) {
        return $uibModal.open({
            component: 'companySharingCenterSharedAuthenticatorsManage',
            resolve: { account: function account() {
                    return _account;
                } }
        }).result;
    };
}

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-authenticators.manage.edit', {
        url: '/edit',
        component: 'companySharingCenterSharedAuthenticatorsManage'

    });
}

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedAuthenticators = __webpack_require__(520);

_app.app.component('companySharingCenterSharedAuthenticators', {
    bindings: {
        companyId: '<',
        accounts: '<',
        allAccounts: '<',
        publicServicesWithSsoAnd2FA$: '<'
    },
    controller: _sharedAuthenticators.Controller,
    templateUrl: __webpack_require__(1845)
});

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3b2049a0220673dcbc94c9cd82d507f2.html";

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

accounts.$inject = ['$filter', 'allAccounts'];
allAccounts.$inject = ['companyId', 'SharedAccountsService'];
companyId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-authenticators', {
        url: '/shared-authenticators',
        component: 'companySharingCenterSharedAuthenticators',
        resolve: { companyId: companyId, allAccounts: allAccounts, accounts: accounts }
    });
}

/** @ngInject */
function allAccounts(companyId, SharedAccountsService) {
    return SharedAccountsService.getAllByCompany({ companyId: companyId }, {});
}

/** @ngInject */
function accounts($filter, allAccounts) {
    return allAccounts.$promise.then(function (items) {
        return items.filter(function (item) {
            return item.enabled2fa;
        });
    }).then(function (items) {
        return $filter('orderBy')(items, 'publicService.serviceName');
    }).then(function (items) {
        return items.map(function (account) {
            return _extends({}, account, { serviceDisplayName: serviceDisplayName(account) });
        });
    });
}

function serviceDisplayName(account) {
    var displayName = '';
    if (account.publicService.slug != 'other' || !account.customServiceName) {
        displayName = account.publicService.serviceName;
    } else if (account.publicService.slug == 'other') {
        displayName = account.customServiceName;
    }
    return displayName;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedCompanyAccount = __webpack_require__(521);

_app.app.component('companySharingCenterSharedAccountsManage', {
    bindings: {
        applicationGroups: '<',
        customGroups: '<',
        sharedAccounts: '<'
    },
    controller: _sharedCompanyAccount.Controller,
    templateUrl: __webpack_require__(1848)
});

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "173871e919bb5455acb29166eab4ab7d.html";

/***/ }),
/* 1849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

username.$inject = ['$stateParams'];
sharedAccounts.$inject = ['$state', 'companyId', 'UserAccounts', 'username'];
customGroups.$inject = ['companyId', 'Groups'];
applicationGroups.$inject = ['companyId', 'Groups'];
$breadcrumbs.$inject = ['username'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-accounts.manage', {
        url: '/manage/:username',
        views: {
            '@company': 'companySharingCenterSharedAccountsManage'
        },
        resolve: {
            $breadcrumbs: $breadcrumbs,
            applicationGroups: applicationGroups,
            customGroups: customGroups,
            sharedAccounts: sharedAccounts,
            username: username
        }
    });
}

/** @ngInject */
function $breadcrumbs(username) {
    return [{ title: username }];
}

/** @ngInject */
function applicationGroups(companyId, Groups) {
    return Groups.getGroupsByType({ companyId: companyId, type: 'APPLICATION' }).$promise;
}

/** @ngInject */
function customGroups(companyId, Groups) {
    return Groups.getGroupsByType({ companyId: companyId, type: 'CUSTOM' }).$promise;
}

/** @ngInject */
function sharedAccounts($state, companyId, UserAccounts, username) {
    return UserAccounts.getSharedEmailAccountsByUsername({ companyId: companyId, username: username }).$promise.then(function (accounts) {
        if (!accounts.length) {
            $state.go('company.sharing-center.shared-accounts');
        }
        return accounts;
    });
}

/** @ngInject */
function username($stateParams) {
    return $stateParams.username;
}

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _createSharedFolder = __webpack_require__(522);

_app.app.component('companySharingCenterSharedFoldersCreate', {
    bindings: {
        companyId: '<',
        sharedFolders: '='
    },
    controller: _createSharedFolder.Controller,
    templateUrl: __webpack_require__(1852)
});

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "db25ee0bdedd372f523ae8893220d6b4.html";

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-folders.create', {
        url: '/create',
        views: {
            '@company': 'companySharingCenterSharedFoldersCreate'
        }
    });
}

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedFolderAddCsa = __webpack_require__(523);

_app.app.component('companySharingCenterSharedFoldersAddCSA', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _sharedFolderAddCsa.Controller,
    templateUrl: __webpack_require__(1855)
});

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8d2b5bd613fbb3bf0f2c5f71b66bddb6.html";

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _store = __webpack_require__(19);

modal.$inject = ['$uibModal'];


_app.app.service('SharedFolderAddCSAModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_isAuthenticator, _sharedFolder, _items) {
        serviceAccounts.$inject = ['SharedAccountsService', '$filter'];

        return $uibModal.open({
            component: 'companySharingCenterSharedFoldersAddCSA',
            resolve: {
                isAuthenticator: function isAuthenticator() {
                    return _isAuthenticator;
                },
                sharedFolder: function sharedFolder() {
                    return _sharedFolder;
                },
                items: function items() {
                    return _items;
                },
                serviceAccounts: serviceAccounts
            }
        }).result;

        /** @ngInject */
        function serviceAccounts(SharedAccountsService, $filter) {
            var ids = getCSAIds();
            return SharedAccountsService.getAllByCompany({ companyId: _store.resolve.companyId }, {}).$promise.then(function (accounts) {
                return $filter('orderBy')(accounts, 'publicService.serviceName');
            }).then(function (accounts) {
                return accounts.map(function (account) {
                    return _extends({}, account, { serviceDisplayName: serviceDisplayName(account) });
                });
            }).then(function (accounts) {
                return accounts.filter(function (account) {
                    var alreadyAdded = ids.includes(account.id);
                    var typeAvailable = _isAuthenticator ? account.enabled2fa : !account.enabled2fa;
                    return !alreadyAdded && typeAvailable;
                });
            });
        }

        function getCSAIds() {
            var ids = [];
            _items.forEach(function (item) {
                if (item.corporateServiceAccount != null) {
                    ids.push(item.corporateServiceAccount.id);
                }
            });
            return ids;
        }

        function serviceDisplayName(account) {
            var displayName = '';
            if (account.publicService.slug != 'other' || !account.customServiceName) {
                displayName = account.publicService.serviceName;
            } else if (account.publicService.slug == 'other') {
                displayName = account.customServiceName;
            }
            return displayName;
        }
    };
}

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedFolderAddNote = __webpack_require__(524);

_app.app.component('companySharingCenterSharedFoldersAddNote', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _sharedFolderAddNote.Controller,
    templateUrl: __webpack_require__(1858)
});

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e1e0933cf7c78f9c1e9a17bdb7ff6757.html";

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _store = __webpack_require__(19);

modal.$inject = ['$uibModal'];


_app.app.service('SharedFolderAddNoteModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_sharedFolder, _items) {
        notes.$inject = ['SharedAccountsService'];

        return $uibModal.open({
            component: 'companySharingCenterSharedFoldersAddNote',
            resolve: {
                sharedFolder: function sharedFolder() {
                    return _sharedFolder;
                },
                items: function items() {
                    return _items;
                },
                notes: notes
            }
        }).result;

        /** @ngInject */
        function notes(SharedAccountsService) {
            var ids = getNoteIds();
            return SharedAccountsService.getAllCompanyNotes({ companyId: _store.resolve.companyId }).$promise.then(function (notes) {
                return notes.filter(function (note) {
                    var alreadyAdded = ids.includes(note.id);
                    return !alreadyAdded;
                });
            });
        }

        function getNoteIds() {
            var ids = [];
            _items.forEach(function (item) {
                if (item.corporateNote != null) {
                    ids.push(item.corporateNote.id);
                }
            });
            return ids;
        }
    };
}

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editSharedFolder = __webpack_require__(525);

_app.app.component('companySharingCenterSharedFoldersManageEdit', {
    bindings: {
        companyId: '<',
        sharedFolder: '<',
        items: '<'
    },
    controller: _editSharedFolder.Controller,
    templateUrl: __webpack_require__(1861)
});

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e8fb28c5ad2cd6fbf6635bf51da262fd.html";

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-folders.manage.edit', {
        url: '/edit',
        component: 'companySharingCenterSharedFoldersManageEdit'
    });
}

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageSharedFolder = __webpack_require__(526);

_app.app.component('companySharingCenterSharedFoldersManage', {
    bindings: {
        sharedFolder: '<',
        items: '<'
    },
    controller: _manageSharedFolder.Controller,
    templateUrl: __webpack_require__(1864)
});

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8ee20ee957177bbbb4fd6be460606ba0.html";

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

items.$inject = ['SharedFoldersResource', 'sharedFolderId', 'companyId', '$filter'];
sharedFolderId.$inject = ['$stateParams'];
sharedFolder.$inject = ['sharedFolders', '$stateParams'];
$breadcrumbs.$inject = ['sharedFolder'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-folders.manage', {
        url: '/manage/:sharedFolderId',
        // params: { sharedFolder: {} },
        redirectTo: 'company.sharing-center.shared-folders.manage.edit',
        views: {
            '@company.sharing-center': 'companySharingCenterSharedFoldersManage'
        },
        resolve: {
            $breadcrumbs: $breadcrumbs,
            sharedFolder: sharedFolder,
            sharedFolderId: sharedFolderId,
            items: items
        }
    });
}

/** @ngInject */
function sharedFolderId($stateParams) {
    return $stateParams.sharedFolderId;
}

/** @ngInject */
function sharedFolder(sharedFolders, $stateParams) {
    return sharedFolders.find(function (sf) {
        return sf.id === $stateParams.sharedFolderId;
    });
}

/** @ngInject */
function items(SharedFoldersResource, sharedFolderId, companyId, $filter) {
    return SharedFoldersResource.getSharedFolderItems(companyId, sharedFolderId).then(function (items) {
        return $filter('orderBy')(items, 'createdOn', true);
    }).then(function (items) {
        return items.map(function (item) {
            item.type = itemType(item);
            var format = function format(date) {
                return new Date(date).toString().slice(4, 24);
            };
            item.createdOnDisplay = format(item.createdOn);
            if (item.corporateServiceAccount != null) {
                item.corporateServiceAccount = _extends({}, item.corporateServiceAccount, { serviceDisplayName: serviceDisplayName(item.corporateServiceAccount) });
            }
            return item;
        });
    });
}

function $breadcrumbs(sharedFolder) {
    if (sharedFolder == null) {
        return;
    }
    var title = {
        // getter to allow dynamic updates
        get title() {
            return sharedFolder.name;
        }
    };
    return [{ stateName: 'company.sharing-center.shared-folders.manage' }, title];
}

function itemType(item) {
    var itemType = '';
    if (item.corporateNote != null) {
        itemType = 'SECURE NOTE';
    } else if (item.corporateServiceAccount.enabledTwoFa) {
        itemType = 'AUTHENTICATOR';
    } else {
        itemType = 'PASSWORD MANAGER';
    }
    return itemType;
}

function serviceDisplayName(item) {
    var displayName = '';
    if (item.publicService.slug != 'other' || !item.customServiceName) {
        displayName = item.publicService.serviceName;
    } else if (item.publicService.slug == 'other') {
        displayName = item.customServiceName;
    }
    return displayName;
}

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _shareSharedFolder = __webpack_require__(527);

_app.app.component('companySharingCenterSharedFoldersManageShare', {
    bindings: {
        companyId: '<',
        sharedFolder: '<',
        sharedFolderId: '<',
        users: '<',
        sharedLabels: '<'
    },
    controller: _shareSharedFolder.Controller,
    templateUrl: __webpack_require__(1867)
});

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f3850297365b027a59fe37f4bb66a607.html";

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

sharedLabels.$inject = ['SharedFoldersResource', '$stateParams'];
users.$inject = ['SharedFoldersResource', '$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
  $stateProvider.state('company.sharing-center.shared-folders.manage.share', {
    url: '/share',
    component: 'companySharingCenterSharedFoldersManageShare',
    resolve: { users: users, sharedLabels: sharedLabels }
  });
}

/** @ngInject */
function users(SharedFoldersResource, $stateParams) {
  return SharedFoldersResource.getSharedUsers($stateParams.companyId, $stateParams.sharedFolderId);
}

/** @ngInject */
function sharedLabels(SharedFoldersResource, $stateParams) {
  return SharedFoldersResource.getSharedLabels($stateParams.companyId, $stateParams.sharedFolderId).then(function (labels) {
    return labels.map(function (label) {
      return updateLabelDTO(label);
    });
  });
}

function updateLabelDTO(label) {
  var className = '';
  var sref = '';
  if (label.isCustom) {
    className = 'sp_colorBlueLink fa fa-user-circle-o';
    sref = 'company.user-directories.saaspass-users.user-labels({userLabelId:' + label.id.toString() + '})';
  } else {
    if (label.name === 'ALL_USERS') {
      className = 'sp_colorBlueLink fa fa-users';
      sref = 'company.user-directories.saaspass-users.all-users';
    } else if (label.name === 'ADMINISTRATORS') {
      className = 'sp_colorBlueLink fa fa-user-plus';
      sref = 'company.user-directories.saaspass-users.administrators-developers';
    } else if (label.name === 'MOBILE_APP_USERS') {
      className = 'sp_colorBlueLink fa fa-mobile-alt';
      sref = 'company.user-directories.saaspass-users.regular-saaspass-app-users';
    } else if (label.name === 'HARD_TOKEN_USERS') {
      className = 'sp_colorBlueLink fa fa-calculator';
      sref = 'company.user-directories.saaspass-users.hard-token-users';
    } else if (label.name === 'SMS_USERS') {
      className = 'sp_colorBlueLink fa fa-comment';
      sref = 'company.user-directories.saaspass-users.sms-users';
    }
  }
  return _extends({}, label, { className: className, sref: sref });
}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SharedFoldersResource = function () {
    SharedFoldersResource.$inject = ['$http'];

    /** @ngInject */
    function SharedFoldersResource($http) {
        _classCallCheck(this, SharedFoldersResource);

        this.$http = $http;
    }

    _createClass(SharedFoldersResource, [{
        key: 'getSharedFolders',
        value: function getSharedFolders(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'createSharedFolder',
        value: function createSharedFolder(companyId, name) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders';
            return this.$http.post(url, name).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'getAssignedUnassignedFoldersForCorporateItemId',
        value: function getAssignedUnassignedFoldersForCorporateItemId(corporateItemId, companyId, isNote) {
            var isNoteParam = isNote ? 'isNote=true' : 'isNote=false';
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/corporateitem/' + corporateItemId + '?' + isNoteParam;
            return this.$http.get(url).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'addCorporateItemToSharedFolders',
        value: function addCorporateItemToSharedFolders(corporateItemId, folderIds, companyId, isNote) {
            var isNoteParam = isNote ? 'isNote=true' : 'isNote=false';
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/corporateitem/' + corporateItemId + '?' + isNoteParam;
            return this.$http.post(url, folderIds).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'removeCorporateItemFromSharedFolders',
        value: function removeCorporateItemFromSharedFolders(corporateItemId, folderIds, companyId, isNote) {
            var isNoteParam = isNote ? 'isNote=true' : 'isNote=false';
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/corporateitem/' + corporateItemId + '?action=remove&' + isNoteParam;
            return this.$http.post(url, folderIds).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'renameSharedFolder',
        value: function renameSharedFolder(companyId, sharedFolderId, newName) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/rename';
            return this.$http.put(url, newName).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'deleteSharedFolder',
        value: function deleteSharedFolder(companyId, sharedFolderId) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId;
            return this.$http.delete(url).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }, {
        key: 'getSharedFolderItems',
        value: function getSharedFolderItems(companyId, sharedFolderId) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/items';
            return this.$http.get(url).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            });
        }
    }, {
        key: 'addCorporateServiceAccounts',
        value: function addCorporateServiceAccounts(companyId, sharedFolderId, csaIds) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/serviceAccounts';
            return this.$http.post(url, csaIds).then(function (_ref9) {
                var data = _ref9.data;
                return data;
            });
        }
    }, {
        key: 'addCorporateNotes',
        value: function addCorporateNotes(companyId, sharedFolderId, noteIds) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/notes';
            return this.$http.post(url, noteIds).then(function (_ref10) {
                var data = _ref10.data;
                return data;
            });
        }
    }, {
        key: 'removeItems',
        value: function removeItems(companyId, sharedFolderId, itemIds) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/items?action=remove';
            return this.$http.post(url, itemIds).then(function (_ref11) {
                var data = _ref11.data;
                return data;
            });
        }
    }, {
        key: 'getSharedLabels',
        value: function getSharedLabels(companyId, sharedFolderId) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/labels';
            return this.$http.get(url).then(function (_ref12) {
                var data = _ref12.data;
                return data;
            });
        }
    }, {
        key: 'updateSharedLabels',
        value: function updateSharedLabels(companyId, sharedFolderId, labelDTOs) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/labels';
            return this.$http.post(url, labelDTOs).then(function (_ref13) {
                var data = _ref13.data;
                return data;
            });
        }
    }, {
        key: 'getSharedUsers',
        value: function getSharedUsers(companyId, sharedFolderId) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/users';
            return this.$http.get(url).then(function (_ref14) {
                var data = _ref14.data;
                return data;
            });
        }
    }, {
        key: 'shareWithSaaspassId',
        value: function shareWithSaaspassId(companyId, sharedFolderId, saaspassId) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/users/share/' + saaspassId;
            return this.$http.post(url).then(function (_ref15) {
                var data = _ref15.data;
                return data;
            });
        }
    }, {
        key: 'unshareWithSaaspassId',
        value: function unshareWithSaaspassId(companyId, sharedFolderId, saaspassId) {
            var url = 'app/rest/v2/company/' + companyId + '/sharedfolders/' + sharedFolderId + '/users/unshare/' + saaspassId;
            return this.$http.post(url).then(function (_ref16) {
                var data = _ref16.data;
                return data;
            });
        }
    }]);

    return SharedFoldersResource;
}();

_app.app.service('SharedFoldersResource', SharedFoldersResource);

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedFolders = __webpack_require__(528);

_app.app.component('companySharingCenterSharedFolders', {
    bindings: {
        sharedFolders: '<'
    },
    controller: _sharedFolders.Controller,
    templateUrl: __webpack_require__(1871)
});

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0bd90632c642de47ed323b2a7f297f73.html";

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

sharedFolders.$inject = ['companyId', 'SharedFoldersResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-folders', {
        url: '/shared-folders',
        component: 'companySharingCenterSharedFolders',
        resolve: { sharedFolders: sharedFolders }
    });
}

/** @ngInject */
function sharedFolders(companyId, SharedFoldersResource) {
    return SharedFoldersResource.getSharedFolders(companyId);
}

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedInnerMenu = __webpack_require__(529);

_app.app.component('companySharingCenterManage', {
    bindings: {
        companyId: '<',
        isNote: '<',
        sharedAccount: '<',
        sharedAccountId: '<'
    },
    controller: _sharedInnerMenu.Controller,
    templateUrl: __webpack_require__(1874)
});

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1f9c219957b401539d6771ccd1867e89.html";

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

isNote.$inject = ['$location', '$stateParams'];
convert2fa.$inject = ['$stateParams'];
sharedAccount.$inject = ['$stateParams', 'SharedAccountsService', 'isNote', 'sharedAccountId'];
sharedAccountId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

	$stateProvider.states(['company.sharing-center.shared-passwords.manage', 'company.sharing-center.shared-authenticators.manage', 'company.sharing-center.shared-notes.manage'], {
		url: '/manage/:sharedAccountId',
		params: { sharedAccount: {}, convert2fa: false, isNote: false },
		//component: 'companySharingCenterShare',
		redirectTo: '.edit',
		views: {
			'@company.sharing-center': 'companySharingCenterManage'
		},
		resolve: { isNote: isNote, sharedAccount: sharedAccount, sharedAccountId: sharedAccountId, convert2fa: convert2fa }
	});
}

/** @ngInject */
function sharedAccountId($stateParams) {
	return $stateParams.sharedAccountId;
}

/** @ngInject */
function sharedAccount($stateParams, SharedAccountsService, isNote, sharedAccountId) {
	if (Object.keys($stateParams.sharedAccount).length != 0) {
		return $stateParams.sharedAccount;
	} else {
		var companyId = $stateParams.companyId;
		var id = sharedAccountId;
		if (isNote) {
			return SharedAccountsService.getNote({ companyId: companyId, id: id }, {}).$promise;
		} else {
			return SharedAccountsService.getOneById({ companyId: companyId, id: id }, {}).$promise;
		}
	}
}

/** @ngInject */
function convert2fa($stateParams) {
	return $stateParams.convert2fa;
}

/** @ngInject */
function isNote($location, $stateParams) {
	var currentUrl = $location.absUrl();;
	return currentUrl.includes('shared-notes') || $stateParams.isNote;
}

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addSharedNote = __webpack_require__(530);

_app.app.component('companySharingCenterSharedNotesAdd', {
	bindings: {
		companyId: '<'
	},
	controller: _addSharedNote.Controller,
	templateUrl: __webpack_require__(1877)
});

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6d0bdfccd4ff8ed485f1246cfc5a59b3.html";

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('AddNewSharedNoteModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function () {
        return $uibModal.open({
            component: 'companySharingCenterSharedNotesAdd'
            // resolve: {publicServices: () => publicServices},
        }).result;
    };
}

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-notes.add', {
        url: '/shared-notes/add',
        views: {
            '@company.sharing-center': 'companySharingCenterSharedNotesAdd'
        }

    });
}

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageSharedNote = __webpack_require__(531);

_app.app.component('companySharingCenterSharedNoteManage', {
	bindings: {
		companyId: '<',
		sharedAccount: '<'
	},
	controller: _manageSharedNote.Controller,
	templateUrl: __webpack_require__(1881)
});

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cb94f35d342ebff75ab1951d244ac006.html";

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ManageSharedNoteModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_note) {
        return $uibModal.open({
            component: 'companySharingCenterSharedNoteManage',
            resolve: { note: function note() {
                    return _note;
                } }
        }).result;
    };
}

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-notes.manage.edit', {
        url: '/edit',
        component: 'companySharingCenterSharedNoteManage'
        // resolve:{theNote}
    });
}

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedNotes = __webpack_require__(532);

_app.app.component('companySharingCenterSharedNotes', {
    bindings: {
        notes: '<'
    },
    controller: _sharedNotes.Controller,
    templateUrl: __webpack_require__(1885)
});

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "313505cf0a429fd89292b13e12ad7fec.html";

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

notes.$inject = ['companyId', 'SharedAccountsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-notes', {
        url: '/shared-notes',
        component: 'companySharingCenterSharedNotes',
        resolve: { notes: notes }
    });
}

/** @ngInject */
function notes(companyId, SharedAccountsService) {
    return SharedAccountsService.getAllCompanyNotes({ companyId: companyId }).$promise;
}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addSharedPassword = __webpack_require__(533);

_app.app.component('companySharingCenterSharedPasswordsAdd', {
    bindings: {
        publicServicesWithSso$: '<',
        companyId: '<',
        copyAccount: '<'
    },
    controller: _addSharedPassword.Controller,
    templateUrl: __webpack_require__(1888)
});

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e23c2a68d911f15844d1723e2eff90f.html";

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('AddNewSharedPasswordModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_publicServices) {
        return $uibModal.open({
            component: 'companySharingCenterSharedPasswordsAdd',
            resolve: { publicServices: function publicServices() {
                    return _publicServices;
                } }
        }).result;
    };
}

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

copyAccount.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.add-shared-password', {
        url: '/add-shared-password',
        params: { copyAccount: null },
        views: {
            '@company.sharing-center': 'companySharingCenterSharedPasswordsAdd'
        },
        resolve: {
            copyAccount: copyAccount
        }
    });
}

/** @ngInject */
function copyAccount($stateParams) {
    return $stateParams.copyAccount;
}

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deleteAccounts = __webpack_require__(534);

_app.app.component('companySharingCenterSharedPasswordsDelete', {
    bindings: {
        accounts: '<',
        companyId: '<'
    },
    controller: _deleteAccounts.Controller,
    templateUrl: __webpack_require__(1892)
});

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "16331adfc6d54ed6c24bd13a203b0833.html";

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

companyId.$inject = ['$stateParams'];
accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-passwords.delete', {
        url: '/delete',
        params: { accounts: [] },
        //component: 'companySharingCenterSharedAuthenticatorsDelete',
        views: {
            '@company.sharing-center': 'companySharingCenterSharedPasswordsDelete'
        },
        resolve: {
            accounts: accounts,
            companyId: companyId
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importCompleted = __webpack_require__(535);

_app.app.component('companySharingCenterImportCompleted', {
       bindings: {
              companyId: '<',
              labels$: '<'
       },
       controller: _importCompleted.Controller,
       templateUrl: __webpack_require__(1895)
});

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5949378db978c2c95f038f49e49f75f3.html";

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.import-csv.import-completed', {
        url: '/completed',
        params: { importResult: null },
        views: {
            '@company.sharing-center': 'companySharingCenterImportCompleted'
        }
    });
}

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importCsv = __webpack_require__(536);

_app.app.component('companySharingCenterImportCsv', {
       bindings: {
              companyId: '<',
              labels$: '<',
              importFileTypes: '<'
       },
       controller: _importCsv.Controller,
       templateUrl: __webpack_require__(1898)
});

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0d3c7efea93a762bbe52cb8b1f26b4fb.html";

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

importFileTypes.$inject = ['PasswordManagers'];
companyId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.import-csv', {
        url: '/import-csv',
        views: {
            '@company.sharing-center': 'companySharingCenterImportCsv'
        },
        resolve: {
            companyId: companyId,
            importFileTypes: importFileTypes
        }
    });
}
/** @ngInject */
function importFileTypes(PasswordManagers) {
    return PasswordManagers.getImportFileTypes();
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importSharedPassword = __webpack_require__(537);

_app.app.component('companySharingCenterSharedPasswordsImport', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _importSharedPassword.Controller,
    templateUrl: __webpack_require__(1901)
});

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b3da0ba0e58477dc308ccb32542afdf7.html";

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

passwordManagers.$inject = ['$filter', 'PasswordManagers'];
modal.$inject = ['$uibModal'];


_app.app.service('ImportSharedPasswordsModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function () {
        return $uibModal.open({
            component: 'companySharingCenterSharedPasswordsImport',
            resolve: { passwordManagers: passwordManagers }
        }).result;
    };
}

/** @ngInject */
function passwordManagers($filter, PasswordManagers) {
    return PasswordManagers.list()
    // .then((items) => $filter('filter')(items, {ssoEnabled: true}))
    .then(function (items) {
        return $filter('orderBy')(items, 'publicService.serviceName');
    });
}

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageSharedPassword = __webpack_require__(538);

_app.app.component('companySharingCenterSharedPasswordsManage', {
       bindings: {
              publicServicesWithSso$: '<',
              sharedAccount: '<',
              companyId: '<',
              allAccounts: '<',
              convert2fa: '<'
       },
       //bindings: {close: '&', dismiss: '&', resolve: '<'},
       controller: _manageSharedPassword.Controller,
       templateUrl: __webpack_require__(1904)
});

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3cb3ac23f9df00353b819cc8962bf41a.html";

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('ManageSharedPasswordModal', modal);

/** @ngInject */
function modal($uibModal) {
    return function (_account) {
        return $uibModal.open({
            component: 'companySharingCenterSharedPasswordsManage',
            resolve: { account: function account() {
                    return _account;
                } }
        }).result;
    };
}

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-passwords.manage.edit', {
        url: '/edit',
        component: 'companySharingCenterSharedPasswordsManage'

    });
}

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharedPasswords = __webpack_require__(539);

_app.app.component('companySharingCenterSharedPasswords', {
    bindings: {
        companyId: '<',
        accounts: '<',
        allAccounts: '<',
        publicServicesWithSso$: '<'
    },
    controller: _sharedPasswords.Controller,
    templateUrl: __webpack_require__(1908)
});

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a7131c6d2327bfb55d325816923a8118.html";

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

allAccounts.$inject = ['companyId', 'SharedAccountsService'];
accounts.$inject = ['$filter', 'allAccounts'];
companyId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-passwords', {
        url: '/shared-passwords',
        component: 'companySharingCenterSharedPasswords',
        resolve: { companyId: companyId, accounts: accounts, allAccounts: allAccounts }
    });
}

/** @ngInject */
function allAccounts(companyId, SharedAccountsService) {
    return SharedAccountsService.getAllByCompany({ companyId: companyId }, {});
}

/** @ngInject */
function accounts($filter, allAccounts) {
    return allAccounts.$promise.then(function (accounts) {
        return accounts.filter(function (account) {
            return !account.enabled2fa;
        });
    }).then(function (accounts) {
        return $filter('orderBy')(accounts, 'publicService.serviceName');
    }).then(function (accounts) {
        return accounts.map(function (account) {
            return _extends({}, account, { serviceDisplayName: serviceDisplayName(account) });
        });
    });
}

function serviceDisplayName(account) {
    var displayName = '';
    if (account.publicService.slug != 'other' || !account.customServiceName) {
        displayName = account.publicService.serviceName;
    } else if (account.publicService.slug == 'other') {
        displayName = account.customServiceName;
    }
    return displayName;
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharingCenter = __webpack_require__(540);

_app.app.component('companySharingCenter', {
    bindings: {
        publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<',
        labels$: '<'
    },
    templateUrl: __webpack_require__(1911),
    controller: _sharingCenter.Controller
});

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "27ec9a270278a1633419d4bcefc7c877.html";

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SharedAccountsService.$inject = ['$resource'];


_app.app.factory('SharedAccountsService', SharedAccountsService);

/** @ngInject */
function SharedAccountsService($resource) {

    return $resource('app/rest/admin/company/:companyId/corporateserviceaccount', {
        companyId: '@companyId'
    }, {
        'createCompanyServiceAccounts': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            params: {
                companyId: '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'updateCompanyServiceAccounts': {
            method: 'PUT',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            params: {
                companyId: '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'uploadCustomIconForCorporateServiceAccount': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:corporateServiceAccountId/photo',
            params: {
                companyId: '@companyId',
                corporateServiceAccountId: '@corporateServiceAccountId'
            },
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined
            }
        },
        'deleteCustomIconForCorporateServiceAccount': {
            method: 'DELETE',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:corporateServiceAccountId/photo',
            params: {
                companyId: '@companyId',
                corporateServiceAccountId: '@corporateServiceAccountId'
            }
        },
        'convertCompanyServiceAccountToAuth': {
            method: 'PUT',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId/convert?to=authenticator',
            params: {
                companyId: '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'convertCompanyServiceAccountToPass': {
            method: 'PUT',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId/convert?to=passwordManager',
            params: {
                companyId: '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'getAllByCompany': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount',
            isArray: true,
            params: {
                companyId: '@companyId'
            }
        },
        'getAllByCompanyAndPublicService': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:publicServiceId',
            isArray: true,
            params: {
                companyId: '@companyId',
                publicServiceId: '@publicServiceId'
            }
        },
        'getOneById': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/item/:id',
            isArray: false,
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'deleteCompanyServiceAccounts': {
            method: 'DELETE',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:id',
            params: {
                id: '@id',
                companyId: '@companyId'
            }
        },
        'deleteBulkCompanyServiceAccounts': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/?action=delete',
            params: {
                companyId: '@companyId'
            }
        },
        'updateServiceAccountLabels': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/labels/:id',
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'updateAndShareServiceAccountsWithLabels': {
            method: 'PUT',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/share/labels?showPassword=:showPassword&showOtp=:showOtp&showNote=:showNote',
            params: {
                companyId: '@companyId',
                showPassword: '@showPassword',
                showOtp: '@showOtp',
                showNote: '@showNote'
            }
        },
        'shareCompanyServiceAccounts': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/share/:saaspassId',
            params: {
                companyId: '@companyId',
                id: '@id',
                saaspassId: 'saaspassId'
            }
        },
        'unshareCompanyServiceAccounts': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unshare/:saaspassId',
            params: {
                companyId: '@companyId',
                id: '@id',
                saaspassId: 'saaspassId'
            }
        },
        'getSaaspassUsersByCorporateServiceAccountId': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/users/:id',
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'getSharedLabelsByCorporateServiceAccountId': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/labels/:id',
            isArray: true,
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'importCompanyServiceAccounts': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/import',
            isArray: true,
            params: {
                companyId: '@companyId',
                showOtp: '@showOtp',
                showPassword: '@showPassword'
            }
        },
        'importCompanyServiceAccountsFromCsv': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/import/csv/:fileType',
            isArray: false,
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined },
            params: {
                companyId: '@companyId',
                type: '@fileType'
            }
        },
        'shareCompanyServiceAccountsWithGroup': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/sharegroup/:groupId',
            params: {
                companyId: '@companyId',
                id: '@id',
                groupId: 'groupId'
            }
        },
        'unshareCompanyServiceAccountsWithGroup': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/unsharegroup/:groupId',
            params: {
                companyId: '@companyId',
                id: '@id',
                groupId: 'groupId'
            }
        },

        'getAllCompanyNotes': {
            method: 'GET',
            isArray: true,
            url: 'app/rest/admin/company/:companyId/corporatenote',
            params: {
                companyId: '@companyId'
            }
        },
        'getNote': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporatenote/:id',
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'createNote': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporatenote',
            params: {
                companyId: '@companyId'
            }
        },
        'updateNote': {
            method: 'PUT',
            url: 'app/rest/admin/company/:companyId/corporatenote/:id',
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'deleteNote': {
            method: 'DELETE',
            url: 'app/rest/admin/company/:companyId/corporatenote/:id',
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'getAllCompanyNotesUsers': {
            method: 'GET',
            isArray: true,
            url: 'app/rest/admin/company/:companyId/corporatenote/:id/users',
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'updateCompanyNoteLabels': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporatenote/labels/:id',
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'getSharedLabelsByCorporateNoteId': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporatenote/labels/:id',
            isArray: true,
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        },
        'shareNoteWithSaaspassUser': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporatenote/:id/share/:saaspassId',
            params: {
                companyId: '@companyId',
                id: '@id',
                saaspassId: '@saaspassId'
            }
        },
        'unshareUserNote': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporatenote/:id/unshare/:saaspassId',
            params: {
                companyId: '@companyId',
                id: '@id',
                saaspassId: 'saaspassId'
            }
        },
        'getAllSharedReportByCompany': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/report',
            isArray: true,
            params: {
                companyId: '@companyId'
            }
        },
        'getDeletedByCompany': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/report/deleted',
            isArray: true,
            params: {
                companyId: '@companyId'
            }
        },
        'exportCompanyServiceAccounts': {
            method: 'POST',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/export/csv',
            params: {
                companyId: '@companyId'
            }
        },
        'getOtp': {
            method: 'GET',
            url: 'app/rest/admin/company/:companyId/corporateserviceaccount/:id/getotp',
            params: {
                companyId: '@companyId',
                id: '@id'
            }
        }
    });
}

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _lazyLoad = __webpack_require__(71);

publicServicesWithSsoAnd2FA$.$inject = ['$filter', 'PublicServices'];
publicServicesWithSso$.$inject = ['$filter', 'PublicServices'];
prefetch.$inject = ['publicServicesWithSso$', 'publicServicesWithSsoAnd2FA$'];
labels$.$inject = ['UserLabelsService', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center', {
        url: '/sharing-center',
        redirectTo: 'company.sharing-center.shared-passwords',
        component: 'companySharingCenter',
        resolve: {
            labels$: labels$,
            prefetch: prefetch,
            publicServicesWithSso$: publicServicesWithSso$,
            publicServicesWithSsoAnd2FA$: publicServicesWithSsoAnd2FA$
        }
    });
}

/** @ngInject */
function prefetch(publicServicesWithSso$, publicServicesWithSsoAnd2FA$) {
    publicServicesWithSso$.get();
    publicServicesWithSsoAnd2FA$.get();
}

/** @ngInject */
function labels$(UserLabelsService, companyId) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return UserLabelsService.getLabelsDefaultsIncluded({
            companyId: companyId
        }, {}).$promise;
    });
}

/** @ngInject */
function publicServicesWithSso$($filter, PublicServices) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return PublicServices.getAllPublicServicesThatSupportSSOFiltered();
    }).map(function (items) {
        var custom = items.find(function (i) {
            return i.slug === 'other';
        });
        custom.serviceName = 'Custom';
        return items;
    }).map(function (items) {
        return $filter('orderBy')(items, 'serviceName');
    });
}

/** @ngInject */
function publicServicesWithSsoAnd2FA$($filter, PublicServices) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return PublicServices.getAllPublicServicesThatSupportSSOAnd2FAFiltered();
    }).map(function (items) {
        var custom = items.find(function (i) {
            return i.slug === 'other';
        });
        custom.serviceName = 'Custom';
        return items;
    }).map(function (items) {
        return $filter('orderBy')(items, 'serviceName');
    });
}

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharingSettings = __webpack_require__(541);

_app.app.component('companySharingCenterSettings', {
    bindings: {
        settingsDetails: '<'
    },
    templateUrl: __webpack_require__(1915),
    controller: _sharingSettings.Controller
});

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "11207a8b9c4efb2bf712b18851181737.html";

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SharingSettingsService.$inject = ['$resource'];


_app.app.factory('SharingSettingsService', SharingSettingsService);

/** @ngInject */
function SharingSettingsService($resource) {

    return $resource('app/rest/admin/company/:companyId/corporateServiceSharingSettings', {
        companyId: '@companyId'
    }, {

        'getSettings': {
            method: 'GET',

            isArray: false
        },
        'saveSettings': {
            method: 'PUT'

        }

    });
}

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

settingsDetails.$inject = ['companyId', 'SharingSettingsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.settings', {
        url: '/settings',
        views: {
            '@company': 'companySharingCenterSettings'
        },
        resolve: {
            settingsDetails: settingsDetails
        }
    });
}

/** @ngInject */
function settingsDetails(companyId, SharingSettingsService) {
    return SharingSettingsService.getSettings({ companyId: companyId }).$promise;
}

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _slackInfo = __webpack_require__(542);

_app.app.component('companySlackInfo', {
    bindings: {
        appType$: '<',
        code: '<',
        companyId: '<',
        state: '<'
    },
    controller: _slackInfo.Controller,
    templateUrl: __webpack_require__(1919)
});

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "799700c90006971203c0593eadcdf98d.html";

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SlackInfoService.$inject = ['$resource'];


_app.app.factory('SlackInfoService', SlackInfoService);

/** @ngInject */
function SlackInfoService($resource) {
    var getSlackAuthorizeUrl = $resource('app/rest/slack/getauthurl/:companyId', {
        companyId: '@companyId'
    }, {});
    var processSlackAuth = $resource('app/rest/slack/processauth/:companyId', {
        companyId: '@companyId'
    }, {});
    return {
        getSlackAuthorizeUrl: getSlackAuthorizeUrl,
        processSlackAuth: processSlackAuth
    };
}

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

state.$inject = ['$stateParams'];
code.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.slack-info', {
        url: '/slackInfo?state&code',
        component: 'companySlackInfo',
        resolve: {
            code: code,
            state: state
        }
    });
}

/** @ngInject */
function code($stateParams) {
    return $stateParams.code;
}

/** @ngInject */
function state($stateParams) {
    return $stateParams.state;
}

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companySmsServicesConfirmTurnOff', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(1923)
});

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "72e853cb2d61f65993b89f0429f9417d.html";

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editSmsSettings = __webpack_require__(543);

_app.app.component('editCorporateSmsSettings', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _editSmsSettings.Controller,
    templateUrl: __webpack_require__(1925)
});

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d36e93fe9d16b1990bc54a190e52e1b0.html";

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _howToAddSmsUser = __webpack_require__(544);

_app.app.component('companySmsServicesHelpHowToAddSmsUser', {
    controller: _howToAddSmsUser.Controller,
    templateUrl: __webpack_require__(1935)
});

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./how-to-add-sms-user-de.html": 1928,
	"./how-to-add-sms-user-en.html": 1929,
	"./how-to-add-sms-user-es.html": 1930,
	"./how-to-add-sms-user-fr.html": 1931,
	"./how-to-add-sms-user-ja.html": 1932,
	"./how-to-add-sms-user-pt.html": 1933,
	"./how-to-add-sms-user-zh.html": 1934
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1927;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bae4650bac5fc9df9aa43985f94e9bae.html";

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "69c69690bc7075f180816d97b8e5cd15.html";

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9bb044d6978bc19d08c0d4053e896a0e.html";

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fe88b72ee41d8d93c6c4b20a2dd56032.html";

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7940a4b330285179b309f7dee09a6451.html";

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9e233d9d913a58f81cc567b4f4785458.html";

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bf54c4771175ecb73e67c2aff484ef72.html";

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dd183d6a895ab492de33ca1e4864e68e.html";

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help.how-to-add-sms-user', {
        url: '/how-to-add-sms-user',
        component: 'companySmsServicesHelpHowToAddSmsUser'
    });
}

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsCredit = __webpack_require__(545);

_app.app.component('companySmsServicesHelpSmsCredit', {
    controller: _smsCredit.Controller,
    templateUrl: __webpack_require__(1946)
});

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./sms-credit-de.html": 1939,
	"./sms-credit-en.html": 1940,
	"./sms-credit-es.html": 1941,
	"./sms-credit-fr.html": 1942,
	"./sms-credit-ja.html": 1943,
	"./sms-credit-pt.html": 1944,
	"./sms-credit-zh.html": 1945
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1938;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5d91d46781caeb8b4e11c8e1b6a66446.html";

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "01fabb41c78826a5a4a4d1f1c0607f7a.html";

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c3d6d981d8469608482cbf9f6af2725d.html";

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9adac77c8ecdd3c127db7ba12f319292.html";

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "022ef3ad5a43b32e84de1d8f2667908b.html";

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a5b610164c6e36f3807c6d43ced4c8cf.html";

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ed9384a0b9e7178a4ac96280345ddbcd.html";

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dd183d6a895ab492de33ca1e4864e68e.html";

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help.sms-credit', {
        url: '/sms-credit',
        component: 'companySmsServicesHelpSmsCredit'
    });
}

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsServicesHelp = __webpack_require__(546);

_app.app.component('companySmsServicesHelp', {
    controller: _smsServicesHelp.Controller,
    templateUrl: __webpack_require__(1949)
});

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a73028b191f7859126dbd08c68c326ca.html";

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help', {
        url: '/help',
        redirectTo: 'company.sms-services.help.what-is-sms-service',
        views: {
            '@company': 'companySmsServicesHelp'
        }
    });
}

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsSettings = __webpack_require__(547);

_app.app.component('companySmsServicesHelpSmsSettings', {
    controller: _smsSettings.Controller,
    templateUrl: __webpack_require__(1960)
});

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./sms-settings-de.html": 1953,
	"./sms-settings-en.html": 1954,
	"./sms-settings-es.html": 1955,
	"./sms-settings-fr.html": 1956,
	"./sms-settings-ja.html": 1957,
	"./sms-settings-pt.html": 1958,
	"./sms-settings-zh.html": 1959
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1952;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7d86ef2bdf65a55be6df4333fd684341.html";

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0b3291f8561bc6597e6e8da6cb1ad5e2.html";

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dc6d2b69ee11f6b9f037cf290df7cb5c.html";

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6c4a2d37e37155ffe54d365e7e39422d.html";

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d935c1353a46c9d143b0296889c1430a.html";

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "46145c4616d504418eab143ffe0a4ab3.html";

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "53aaa28e1cc597c4a010973607e78f0f.html";

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dd183d6a895ab492de33ca1e4864e68e.html";

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help.sms-settings', {
        url: '/sms-settings',
        component: 'companySmsServicesHelpSmsSettings'
    });
}

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _whatIsSmsService = __webpack_require__(548);

_app.app.component('companySmsServicesHelpWhatIsSmsService', {
    controller: _whatIsSmsService.Controller,
    templateUrl: __webpack_require__(1971)
});

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./what-is-sms-service-de.html": 1964,
	"./what-is-sms-service-en.html": 1965,
	"./what-is-sms-service-es.html": 1966,
	"./what-is-sms-service-fr.html": 1967,
	"./what-is-sms-service-ja.html": 1968,
	"./what-is-sms-service-pt.html": 1969,
	"./what-is-sms-service-zh.html": 1970
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1963;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7445eb91b90209dad92ebb7a9a96677b.html";

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0df56d6390f9de1a802388383570949b.html";

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a14da5504e919af65a442c32d5154d05.html";

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc61b5c3769b116cd1a91ead68bef23c.html";

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75f8f35a510189987da6aeb50d102fe6.html";

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c871f8cca82762abff653341aace1033.html";

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4e516983bfd44e6120241d71cee744e9.html";

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dd183d6a895ab492de33ca1e4864e68e.html";

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help.what-is-sms-service', {
        url: '/what-is-sms-service',
        component: 'companySmsServicesHelpWhatIsSmsService'
    });
}

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsPurchaseInvoice = __webpack_require__(549);

_app.app.component('companySmsServicesInvoice', {
    bindings: {
        invoice: '<',
        payment: '<',
        settings: '<'
    },
    controller: _smsPurchaseInvoice.Controller,
    templateUrl: __webpack_require__(1974)
});

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f720777d049401b1f982a344681a456.html";

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

token.$inject = ['$stateParams'];
payment.$inject = ['companyId', 'SmsServices', 'token'];
invoice.$inject = ['companyId', 'SmsServices', 'token'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.invoice', {
        url: '/invoice/:token',
        views: {
            '@': 'companySmsServicesInvoice'
        },
        resolve: {
            invoice: invoice,
            payment: payment,
            token: token
        }
    });
}

/** @ngInject */
function invoice(companyId, SmsServices, token) {
    return SmsServices.invoice(companyId, token);
}

/** @ngInject */
function payment(companyId, SmsServices, token) {
    return SmsServices.expressCheckoutDetails(companyId, token);
}

/** @ngInject */
function token($stateParams) {
    return $stateParams.token;
}

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _paypalCancelled = __webpack_require__(550);

_app.app.component('companySmsServicesPaypalCancelled', {
    controller: _paypalCancelled.Controller,
    templateUrl: __webpack_require__(1978)
});

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d41d8cd98f00b204e9800998ecf8427e.html";

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.paypal-cancelled', {
        url: '/paypal-cancelled?token',
        views: {
            '@company': 'companySmsServicesPaypalCancelled'
        }
    });
}

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _paypalConfirmed = __webpack_require__(551);

_app.app.component('companySmsServicesPaypalConfirmed', {
    bindings: {
        payment: '<',
        settings: '<',
        token: '<'
    },
    controller: _paypalConfirmed.Controller,
    templateUrl: __webpack_require__(1981)
});

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f131fee1ae0b0d2663b4dc1ebfbc3236.html";

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

token.$inject = ['$stateParams'];
payment.$inject = ['companyId', 'SmsServices', 'token'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.paypal-confirmed', {
        url: '/paypal-confirmed?token',
        views: {
            '@company': 'companySmsServicesPaypalConfirmed'
        },
        resolve: {
            payment: payment,
            token: token
        }
    });
}

/** @ngInject */
function payment(companyId, SmsServices, token) {
    return SmsServices.expressCheckoutDetails(companyId, token);
}

/** @ngInject */
function token($stateParams) {
    return $stateParams.token;
}

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsPurchaseHistory = __webpack_require__(552);

_app.app.component('smsPurchaseHistory', {
    bindings: { purchaseHistory: '<' },
    controller: _smsPurchaseHistory.Controller,
    templateUrl: __webpack_require__(1984)
});

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "464325746fb6f97b95546abbf7e9b430.html";

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsPurchase = __webpack_require__(553);

_app.app.component('smsPurchase', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _smsPurchase.Controller,
    templateUrl: __webpack_require__(1986)
});

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8d950c1e8a4c543011e9daf7c55af224.html";

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsServices = __webpack_require__(554);

_app.app.component('companySmsServices', {
    bindings: {
        companyId: '<',
        purchaseHistory: '<',
        settings: '<'
    },
    controller: _smsServices.Controller,
    templateUrl: __webpack_require__(1988)
});

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "70f9f383304fb2a8ba40cf7dd836df0f.html";

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SmsServices = function () {
    SmsServices.$inject = ['$http'];

    /** @ngInject */
    function SmsServices($http) {
        _classCallCheck(this, SmsServices);

        this.$http = $http;
    }

    _createClass(SmsServices, [{
        key: 'smsUsageReport',
        value: function smsUsageReport(companyId, periodFilter, startDate, endDate) {
            var url = 'app/rest/company/' + companyId + '/smsUsageReport';
            var params = { periodFilter: periodFilter, startDate: startDate, endDate: endDate };
            return this.$http.get(url, { params: params }).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'purchaseHistory',
        value: function purchaseHistory(companyId) {
            var url = 'app/rest/company/' + companyId + '/purchaseHistory';
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'invoice',
        value: function invoice(companyId, token) {
            var url = 'app/rest/company/' + companyId + '/invoice';
            var params = { token: token };
            return this.$http.get(url, { params: params }).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'setupExpressCheckout',
        value: function setupExpressCheckout(companyId, packageType) {
            var url = 'app/rest/company/' + companyId + '/setupExpressCheckout';
            var params = { packageType: packageType };
            return this.$http.get(url, { params: params }).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'expressCheckoutDetails',
        value: function expressCheckoutDetails(companyId, token) {
            var url = 'app/rest/company/' + companyId + '/expressCheckoutDetails';
            var params = { token: token };
            return this.$http.get(url, { params: params }).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'finalizeCheckoutPayment',
        value: function finalizeCheckoutPayment(companyId, token, status) {
            var url = 'app/rest/company/' + companyId + '/finalizeCheckoutPayment';
            var params = { token: token, status: status };
            return this.$http.get(url, { params: params }).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }]);

    return SmsServices;
}();

_app.app.service('SmsServices', SmsServices);

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

settings.$inject = ['companyId', 'CorporateSettingsService'];
purchaseHistory.$inject = ['companyId', 'SmsServices'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services', {
        url: '/sms-services',
        component: 'companySmsServices',
        resolve: {
            purchaseHistory: purchaseHistory,
            settings: settings
        }
    });
}

/** @ngInject */
function purchaseHistory(companyId, SmsServices) {
    return SmsServices.purchaseHistory(companyId);
}

/** @ngInject */
function settings(companyId, CorporateSettingsService) {
    return CorporateSettingsService.get(companyId);
}

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsUsageReport = __webpack_require__(555);

_app.app.component('smsUsageReport', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _smsUsageReport.Controller,
    templateUrl: __webpack_require__(1992)
});

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c141b079997c9f3243532a1d9ba1433b.html";

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$state', '$uibModal'];


_app.app.service('SmsUsageReportModal', modal);

/** @ngInject */
function modal($state, $uibModal) {

    return function (_ref) {
        usageReport.$inject = ['SmsServices'];
        var periodFilter = _ref.periodFilter,
            startDate = _ref.startDate,
            endDate = _ref.endDate;


        return $uibModal.open({
            component: 'smsUsageReport',
            resolve: { usageReport: usageReport }
        }).result;

        /** @ngInject */
        function usageReport(SmsServices) {
            var companyId = $state.params.companyId;
            return SmsServices.smsUsageReport(companyId, periodFilter, startDate, endDate);
        }
    };
}

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _softwareLicenseManagementAdd = __webpack_require__(556);

_app.app.component('companySoftwareLicenseManagementAdd', {
    bindings: {
        companyId: '<',
        applications: '<',
        selectedApp: '<'
    },
    controller: _softwareLicenseManagementAdd.Controller,
    templateUrl: __webpack_require__(1995)
});

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5cd6a0663bf0dd6ceb4e86df70415943.html";

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _spUtil = __webpack_require__(73);

selectedApp.$inject = ['applications', '$stateParams'];
applications.$inject = ['companyId', 'SoftwareLicenseManagementService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.software-license-management.add', {
        url: '/add/:appId',
        params: { appId: null },
        component: 'companySoftwareLicenseManagementAdd',
        resolve: {
            applications: applications,
            selectedApp: selectedApp
        }
    });
}

/** @ngInject */
function applications(companyId, SoftwareLicenseManagementService) {
    return SoftwareLicenseManagementService.getAssignableApplications(companyId).then(function (applications) {
        return applications.map(function (app) {
            return _extends({}, app, { protocol: (0, _spUtil.appProtocolDisplayName)(app) });
        });
    });
}

/** @ngInject */
function selectedApp(applications, $stateParams) {
    return applications.find(function (app) {
        return app.id === $stateParams.appId;
    });
}

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _softwareLicenseManagementEdit = __webpack_require__(557);

_app.app.component('companySoftwareLicenseManagementEdit', {
    bindings: {
        companyId: '<',
        softwareLicenseManagementInfos: '<',
        slmi: '<'
    },
    controller: _softwareLicenseManagementEdit.Controller,
    templateUrl: __webpack_require__(1998)
});

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f30b4a5009a1a9923957d4541ca388d5.html";

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

slmi.$inject = ['softwareLicenseManagementInfos', '$stateParams'];
$breadcrumbs.$inject = ['slmi'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.software-license-management.edit', {
        url: '/edit/:slmiId',
        component: 'companySoftwareLicenseManagementEdit',
        resolve: {
            $breadcrumbs: $breadcrumbs,
            slmi: slmi
        }
    });
}

/** @ngInject */
function slmi(softwareLicenseManagementInfos, $stateParams) {
    return softwareLicenseManagementInfos.find(function (slmi) {
        return slmi.id === $stateParams.slmiId;
    });
}

/** @ngInject */
function $breadcrumbs(slmi) {
    if (slmi == null) {
        return;
    }
    var title = {
        // getter to allow dynamic updates
        get title() {
            return slmi.application.applicationName;
        }
    };

    return [title];
}

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _softwareLicenseManagementList = __webpack_require__(558);

_app.app.component('softwareLicenseManagementList', {
    bindings: { softwareLicenseManagementInfos: '<' },
    controller: _softwareLicenseManagementList.Controller,
    templateUrl: __webpack_require__(2001)
});

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8ae71f14f73fa15d135dba14970799da.html";

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.software-license-management.list', {
        url: '/list',
        component: 'softwareLicenseManagementList'
    });
}

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _softwareLicenseManagement = __webpack_require__(559);

_app.app.component('companySoftwareLicenseManagement', {
    controller: _softwareLicenseManagement.Controller,
    templateUrl: __webpack_require__(2004)
});

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f82ce76d703b19e95f033c8d3284c4f2.html";

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SoftwareLicenseManagementService = function () {
    SoftwareLicenseManagementService.$inject = ['$http'];

    /** @ngInject */
    function SoftwareLicenseManagementService($http) {
        _classCallCheck(this, SoftwareLicenseManagementService);

        this.$http = $http;
    }

    _createClass(SoftwareLicenseManagementService, [{
        key: 'getSoftwareLicenseManagementInfos',
        value: function getSoftwareLicenseManagementInfos(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/softwarelicensemanagement';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getAssignableApplications',
        value: function getAssignableApplications(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/softwarelicensemanagement/applications';
            return this.$http.get(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'createSoftwareLicenseManagementInfo',
        value: function createSoftwareLicenseManagementInfo(companyId, slmiDTO) {
            var url = 'app/rest/v2/company/' + companyId + '/softwarelicensemanagement';
            return this.$http.put(url, slmiDTO).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'updateSoftwareLicenseManagementInfo',
        value: function updateSoftwareLicenseManagementInfo(companyId, slmiDTO) {
            var url = 'app/rest/v2/company/' + companyId + '/softwarelicensemanagement';
            return this.$http.post(url, slmiDTO).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'deleteSoftwareLicenseManagementInfo',
        value: function deleteSoftwareLicenseManagementInfo(companyId, slmiId) {
            var url = 'app/rest/v2/company/' + companyId + '/softwarelicensemanagement/' + slmiId;
            return this.$http.delete(url).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }]);

    return SoftwareLicenseManagementService;
}();

_app.app.service('SoftwareLicenseManagementService', SoftwareLicenseManagementService);

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spUtil = __webpack_require__(73);

softwareLicenseManagementInfos.$inject = ['SoftwareLicenseManagementService', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.software-license-management', {
        url: '/software-license-management',
        redirectTo: 'company.software-license-management.list',
        component: 'companySoftwareLicenseManagement',
        resolve: { softwareLicenseManagementInfos: softwareLicenseManagementInfos }
    });
}

/** @ngInject */
function softwareLicenseManagementInfos(SoftwareLicenseManagementService, companyId) {
    return SoftwareLicenseManagementService.getSoftwareLicenseManagementInfos(companyId).then(function (softwareLicenseManagementInfos) {
        softwareLicenseManagementInfos.forEach(function (softwareLicenseManagementInfo) {
            if (softwareLicenseManagementInfo.licenseCost && softwareLicenseManagementInfo.orphanAccounts) {
                softwareLicenseManagementInfo.costSavings = softwareLicenseManagementInfo.licenseCost * softwareLicenseManagementInfo.orphanAccounts;
            }
            var app = softwareLicenseManagementInfo.application;
            app.samlAppLogo = window.env.urls.samlAppLogo(softwareLicenseManagementInfo.application.slug, 'thumb');
            setDisplayNames(app);
            if (app.publicService && app.publicService.serviceName === 'other') {
                app.publicService.serviceName = 'Custom';
            }
        });
        return softwareLicenseManagementInfos;
    });
}

function setDisplayNames(application) {
    application.typeDisplayName = typeDisplayName(application);
    application.protocolDisplayName = (0, _spUtil.appProtocolDisplayName)(application);
}

function typeDisplayName(app) {
    var displayName = app.publicService ? app.publicService.serviceName + ' - ' + app.applicationTypeDisplayName : app.applicationTypeDisplayName;
    return displayName;
}

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _companyList = __webpack_require__(560);

_app.app.component('companySPAdminCompanyList', {
    bindings: { companies: '<' },
    controller: _companyList.Controller,
    templateUrl: __webpack_require__(2008)
});

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d6c18dbcac4de4a344661b8306103205.html";

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.spadmin.companies', {
        url: '/companies',
        component: 'companySPAdminCompanyList',
        resolve: {}
    });
}

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _companyDetails = __webpack_require__(561);

_app.app.component('companySPAdminCompanyDetail', {
    bindings: {
        cmpDetail: '<',
        cmp: '<',
        cmpId: '<'
    },
    controller: _companyDetails.Controller,
    templateUrl: __webpack_require__(2011)
});

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a562c999f8217446897ab98f7429a99c.html";

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

cmpDetail.$inject = ['companyId', 'cmpId', '$http'];
cmpId.$inject = ['$stateParams'];
cmp.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.spadmin.details', {
        url: '/:cmpId',
        component: 'companySPAdminCompanyDetail',
        params: { cmp: {} },
        resolve: { cmp: cmp, cmpId: cmpId, cmpDetail: cmpDetail }
    });
}

/** @ngInject */
function cmpDetail(companyId, cmpId, $http) {
    var url = 'app/rest/v2/company/' + companyId + '/saaspassadmin/company/' + cmpId;
    return $http.get(url).then(function (_ref) {
        var data = _ref.data;
        return data;
    }).then(function (cmpDetail) {
        return cmpDetail;
    });
}

/** @ngInject */
function cmpId($stateParams) {
    return $stateParams.cmpId;
}

/** @ngInject */
function cmp($stateParams) {
    return $stateParams.cmp;
}

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spAdmin = __webpack_require__(562);

_app.app.component('companySPAdmin', {
    bindings: {},
    controller: _spAdmin.Controller,
    templateUrl: __webpack_require__(2014)
});

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a69b28ae9c47ad176e1cee6e2b6c1f64.html";

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.spadmin', {
        redirectTo: 'company.spadmin.companies',
        url: '/spadmin',
        component: 'companySPAdmin',
        resolve: {}
    });
}

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

var _group = __webpack_require__(84);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountsResource = function () {
    AccountsResource.$inject = ['$http'];

    /** @ngInject */
    function AccountsResource($http) {
        _classCallCheck(this, AccountsResource);

        this.$http = $http;
    }

    _createClass(AccountsResource, [{
        key: 'getUserAccount',
        value: function getUserAccount(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'deleteUserAccount',
        value: function deleteUserAccount(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            return this.$http.delete(url).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'deleteUserAccounts',
        value: function deleteUserAccounts(companyId, accountIds) {
            return this.$http({
                method: 'DELETE',
                url: 'app/rest/v2/company/' + companyId + '/accounts',
                data: accountIds,
                headers: { 'Content-Type': 'application/json' }
            }).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'getAllGroupsForUserAccount',
        value: function getAllGroupsForUserAccount(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId + '/groups';
            var params = { type: 'assigned' };
            return this.$http.get(url, { params: params }).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            }).then(function (items) {
                return items.map(function (item) {
                    return _extends({}, item, { group: (0, _group.groupFromDto)(item.group) });
                });
            });
        }
    }, {
        key: 'getAllGroupsUserCanBeAssignedTo',
        value: function getAllGroupsUserCanBeAssignedTo(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId + '/groups';
            var params = { type: 'unassigned' };
            return this.$http.get(url, { params: params }).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'assignUserToGroups',
        value: function assignUserToGroups(companyId, accountId, groupIds) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId + '/groups';
            var params = { action: 'assign' };
            return this.$http.post(url, groupIds, { params: params }).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'removeUserFromGroups',
        value: function removeUserFromGroups(companyId, accountId, groupIds) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId + '/groups';
            var params = { action: 'removeuser' };
            return this.$http.post(url, groupIds, { params: params }).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }, {
        key: 'getProfileAttributes',
        value: function getProfileAttributes(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId + '/profiles';
            return this.$http.get(url).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            }).then(function (data) {
                return _extends({}, data, { profile: data.profile || {} });
            });
        }
    }, {
        key: 'updateProfileAttributes',
        value: function updateProfileAttributes(companyId, accountId, profile) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId + '/profiles';
            return this.$http.put(url, profile).then(function (_ref9) {
                var data = _ref9.data;
                return data;
            });
        }
    }, {
        key: 'updateCustomAttributes',
        value: function updateCustomAttributes(companyId, accountId, attribs) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId + '/customattributes/update';
            return this.$http.put(url, attribs).then(function (_ref10) {
                var data = _ref10.data;
                return data;
            });
        }
    }, {
        key: 'setAsMainProfileOfEmployee',
        value: function setAsMainProfileOfEmployee(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId + '/profiles';
            var params = { action: 'setmainprofile' };
            return this.$http.get(url, { params: params }).then(function (_ref11) {
                var data = _ref11.data;
                return data;
            });
        }
    }, {
        key: 'changeOwner',
        value: function changeOwner(companyId, accountId, newOwner) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            var params = { action: 'changeuser' };
            return this.$http.put(url, newOwner, { params: params }).then(function (_ref12) {
                var data = _ref12.data;
                return data;
            });
        }
    }, {
        key: 'removeAccountOwner',
        value: function removeAccountOwner(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            var params = { action: 'removeuser' };
            return this.$http.put(url, null, { params: params }).then(function (_ref13) {
                var data = _ref13.data;
                return data;
            });
        }
    }, {
        key: 'verifyAccount',
        value: function verifyAccount(companyId, accountId, accountOwner) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            var params = { action: 'verifyuser' };
            return this.$http.put(url, accountOwner, { params: params }).then(function (_ref14) {
                var data = _ref14.data;
                return data;
            });
        }
    }, {
        key: 'assignAccountVerificationEmail',
        value: function assignAccountVerificationEmail(companyId, accountId, emailAddress) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            var params = { action: 'assignverification' };
            return this.$http.put(url, emailAddress, { params: params }).then(function (_ref15) {
                var data = _ref15.data;
                return data;
            });
        }
    }, {
        key: 'removeAccountVerificationEmail',
        value: function removeAccountVerificationEmail(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            var params = { action: 'removeverification' };
            return this.$http.get(url, { params: params }).then(function (_ref16) {
                var data = _ref16.data;
                return data;
            });
        }
    }, {
        key: 'resendVerificationEmail',
        value: function resendVerificationEmail(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            var params = { action: 'resendverification' };
            return this.$http.get(url, { params: params }).then(function (_ref17) {
                var data = _ref17.data;
                return data;
            });
        }
    }, {
        key: 'sendVerificationEmail',
        value: function sendVerificationEmail(companyId, accountId, emailAddress) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            var params = { action: 'sendverification' };
            return this.$http.post(url, emailAddress, { params: params }).then(function (_ref18) {
                var data = _ref18.data;
                return data;
            });
        }
    }, {
        key: 'invalidateVerificationData',
        value: function invalidateVerificationData(companyId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + accountId;
            var params = { action: 'invalidateverification' };
            return this.$http.get(url, { params: params }).then(function (_ref19) {
                var data = _ref19.data;
                return data;
            });
        }
    }, {
        key: 'addNewUserAccount',
        value: function addNewUserAccount(companyId, username) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var params = { username: username };
            return this.$http.post(url, null, { params: params }).then(function (_ref20) {
                var data = _ref20.data;
                return data;
            });
        }
    }, {
        key: 'getAccountsByUsername',
        value: function getAccountsByUsername(companyId, groupId, username) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var params = { group: groupId, username: username };
            return this.$http.get(url, { params: params }).then(function (_ref21) {
                var data = _ref21.data;
                return data;
            });
        }
    }, {
        key: 'resendVerificationEmailForSelectedAccounts',
        value: function resendVerificationEmailForSelectedAccounts(companyId, accountIds, resendactive) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var params = { action: 'resendverification', resendactive: resendactive };
            return this.$http.post(url, accountIds, { params: params }).then(function (_ref22) {
                var data = _ref22.data;
                return data;
            });
        }
    }, {
        key: 'resendVerificationEmailForGroup',
        value: function resendVerificationEmailForGroup(companyId, groupId, resendactive) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var params = { action: 'resendverificationingroup', resendactive: resendactive, groupId: groupId };
            return this.$http.post(url, null, { params: params }).then(function (_ref23) {
                var data = _ref23.data;
                return data;
            });
        }
    }, {
        key: 'resendVerificationEmailForDirectoryAccounts',
        value: function resendVerificationEmailForDirectoryAccounts(companyId, resendactive) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var params = { action: 'resendverificationtoall', resendactive: resendactive };
            return this.$http.post(url, null, { params: params }).then(function (_ref24) {
                var data = _ref24.data;
                return data;
            });
        }
    }, {
        key: 'uploadUsers',
        value: function uploadUsers(companyId, verificationTypes, allowChangeOwner, file) {
            var to = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var formData = new FormData();
            formData.append('file', file);
            var params = { action: 'import', to: to, verificationTypes: verificationTypes, allowChangeOwner: allowChangeOwner };
            var headers = { 'Content-Type': undefined };
            return this.$http.post(url, formData, { params: params, headers: headers }).then(function (_ref25) {
                var data = _ref25.data;
                return data;
            });
        }
    }, {
        key: 'removeUsersFromGroup',
        value: function removeUsersFromGroup(companyId, groupId, accountIds) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var params = { action: 'remove', from: groupId };
            return this.$http.post(url, accountIds, { params: params }).then(function (_ref26) {
                var data = _ref26.data;
                return data;
            });
        }
    }, {
        key: 'copyUsersToGroup',
        value: function copyUsersToGroup(companyId, groupIds, accountIds) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var data = { groups: groupIds, userAccounts: accountIds };
            var params = { action: 'copy' };
            return this.$http.post(url, data, { params: params }).then(function (_ref27) {
                var data = _ref27.data;
                return data;
            });
        }
    }, {
        key: 'moveUsersToGroup',
        value: function moveUsersToGroup(companyId, fromGroupId, toGroupId, accountIds) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts';
            var params = { action: 'move', from: fromGroupId, to: toGroupId };
            return this.$http.post(url, accountIds, { params: params }).then(function (_ref28) {
                var data = _ref28.data;
                return data;
            });
        }
    }, {
        key: 'bulkCopyCompanyUserAccount',
        value: function bulkCopyCompanyUserAccount(companyId, fromUserId, toUser, selectedAccountIds) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + fromUserId + '/bulk';
            var params = { action: 'copy', type: 'account' };
            return this.$http.post(url, { selectedAccountIds: selectedAccountIds, companyUser: toUser }, { params: params }).then(function (_ref29) {
                var data = _ref29.data;
                return data;
            });
        }
    }, {
        key: 'bulkMoveCompanyUserAccount',
        value: function bulkMoveCompanyUserAccount(companyId, fromUserId, toUser, selectedAccountIds) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + fromUserId + '/bulk';
            var params = { action: 'move', type: 'account' };
            return this.$http.post(url, { selectedAccountIds: selectedAccountIds, companyUser: toUser }, { params: params }).then(function (_ref30) {
                var data = _ref30.data;
                return data;
            });
        }
    }, {
        key: 'bulkCopyCompanySharedAccount',
        value: function bulkCopyCompanySharedAccount(companyId, fromUserId, toUser, selectedAccountIds) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + fromUserId + '/bulk';
            var params = { action: 'copy', type: 'shared' };
            return this.$http.post(url, { selectedAccountIds: selectedAccountIds, companyUser: toUser }, { params: params }).then(function (_ref31) {
                var data = _ref31.data;
                return data;
            });
        }
    }, {
        key: 'bulkMoveCompanySharedAccount',
        value: function bulkMoveCompanySharedAccount(companyId, fromUserId, toUser, selectedAccountIds) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + fromUserId + '/bulk';
            var params = { action: 'move', type: 'shared' };
            return this.$http.post(url, { selectedAccountIds: selectedAccountIds, companyUser: toUser }, { params: params }).then(function (_ref32) {
                var data = _ref32.data;
                return data;
            });
        }
    }, {
        key: 'setPasswordForAccount',
        value: function setPasswordForAccount(companyId, appId, accountId, password) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + appId + '/' + accountId + '/setpassword';
            var params = { password: password };
            return this.$http.post(url, null, { params: params }).then(function (_ref33) {
                var data = _ref33.data;
                return data;
            });
        }
    }, {
        key: 'getComputerLoginCodeForAccount',
        value: function getComputerLoginCodeForAccount(companyId, appId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/accounts/' + appId + '/' + accountId + '/getcomputerlogincode';
            return this.$http.get(url).then(function (_ref34) {
                var data = _ref34.data;
                return data;
            });
        }
    }]);

    return AccountsResource;
}();

_app.app.service('AccountsResource', AccountsResource);

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DirectoriesResource = function () {
    DirectoriesResource.$inject = ['$http'];

    /** @ngInject */
    function DirectoriesResource($http) {
        _classCallCheck(this, DirectoriesResource);

        this.$http = $http;
    }

    _createClass(DirectoriesResource, [{
        key: 'getCompanyDirectories',
        value: function getCompanyDirectories(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories';
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'createScimDirectory',
        value: function createScimDirectory(companyId, name, tenantId, isForAppProvisioning) {
            var url = 'app/rest/v2/company/' + companyId + '/directories';
            var type = 'SCIM';
            var params = { name: name, type: type, tenantId: tenantId, isForAppProvisioning: isForAppProvisioning };
            return this.$http.post(url, null, { params: params }).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'createDirectory',
        value: function createDirectory(companyId, name, type, tenantId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories';
            var params = { name: name, type: type, tenantId: tenantId };
            return this.$http.post(url, null, { params: params }).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'getSaaspassCloudDirectoryGroups',
        value: function getSaaspassCloudDirectoryGroups(companyId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/spcloud/groups';
            return this.$http.get(url).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'getDirectory',
        value: function getDirectory(companyId, directoryId, type) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId;
            var params = { type: type };
            return this.$http.get(url, { params: params }).then(function (_ref5) {
                var data = _ref5.data;
                return data;
            });
        }
    }, {
        key: 'updateDirectory',
        value: function updateDirectory(companyId, directory) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directory.id;
            var params = { type: directory.type };
            return this.$http.put(url, directory, { params: params }).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'deleteDirectory',
        value: function deleteDirectory(companyId, directoryId, keepAccounts, type) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId;
            var params = { keepAccounts: keepAccounts, type: type };
            return this.$http.delete(url, { params: params }).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }, {
        key: 'getDirectoryGroups',
        value: function getDirectoryGroups(companyId, directory) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directory.id + '/groups';
            var params = { type: directory.type };
            return this.$http.get(url, { params: params }).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            });
        }
    }, {
        key: 'getDirectoryConnectionDetails',
        value: function getDirectoryConnectionDetails(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId;
            var params = { type: 'details' };
            return this.$http.get(url, { params: params }).then(function (_ref9) {
                var data = _ref9.data;
                return data;
            });
        }
    }, {
        key: 'updateActiveDirectoryActivationCode',
        value: function updateActiveDirectoryActivationCode(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId;
            var params = { action: 'updatecode' };
            return this.$http.put(url, null, { params: params }).then(function (_ref10) {
                var data = _ref10.data;
                return data;
            });
        }
    }, {
        key: 'updateOnPremisesConnectionSettings',
        value: function updateOnPremisesConnectionSettings(companyId, directoryId, dto) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId;
            var params = { action: 'setonpremconnection' };
            return this.$http.put(url, dto, { params: params }).then(function (_ref11) {
                var data = _ref11.data;
                return data;
            });
        }
    }, {
        key: 'deactivateActiveDirectoryAgent',
        value: function deactivateActiveDirectoryAgent(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId;
            var params = { action: 'deactivateagent' };
            return this.$http.put(url, null, { params: params }).then(function (_ref12) {
                var data = _ref12.data;
                return data;
            });
        }
    }, {
        key: 'getDomains',
        value: function getDomains(companyId, directoryId, type) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId + '/domains';
            var params = { type: type };
            return this.$http.get(url, { params: params }).then(function (_ref13) {
                var data = _ref13.data;
                return data;
            });
        }
    }, {
        key: 'createDomain',
        value: function createDomain(companyId, directoryId, domain) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId + '/domains';
            return this.$http.post(url, domain).then(function (_ref14) {
                var data = _ref14.data;
                return data;
            });
        }
    }, {
        key: 'editDomain',
        value: function editDomain(companyId, directoryId, domain) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId + '/domains/' + domain.id;
            return this.$http.put(url, domain).then(function (_ref15) {
                var data = _ref15.data;
                return data;
            });
        }
    }, {
        key: 'deleteDomain',
        value: function deleteDomain(companyId, directoryId, domainId, keepAccounts) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directoryId + '/domains/' + domainId;
            var params = { keepAccounts: keepAccounts };
            return this.$http.delete(url, { params: params }).then(function (_ref16) {
                var data = _ref16.data;
                return data;
            });
        }
    }, {
        key: 'updateAzureDomains',
        value: function updateAzureDomains(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/azuredirectory/' + directoryId + '/updatedomains';
            return this.$http.put(url).then(function (_ref17) {
                var data = _ref17.data;
                return data;
            });
        }
    }, {
        key: 'getAzureTenantParameters',
        value: function getAzureTenantParameters(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/azuredirectory/' + directoryId + '/tenantparameters';
            return this.$http.get(url).then(function (_ref18) {
                var data = _ref18.data;
                return data;
            });
        }
    }, {
        key: 'updateAzureTenantParameters',
        value: function updateAzureTenantParameters(companyId, directoryId, tenantParameters) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/azuredirectory/' + directoryId + '/tenantparameters';
            return this.$http.put(url, tenantParameters).then(function (_ref19) {
                var data = _ref19.data;
                return data;
            });
        }
    }, {
        key: 'testAzureConnection',
        value: function testAzureConnection(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/azuredirectory/' + directoryId + '/connect';
            return this.$http.get(url).then(function (_ref20) {
                var data = _ref20.data;
                return data;
            });
        }
    }, {
        key: 'azureSync',
        value: function azureSync(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/azuredirectory/' + directoryId + '/sync';
            return this.$http.get(url).then(function (_ref21) {
                var data = _ref21.data;
                return data;
            });
        }
    }, {
        key: 'azureProvisioning',
        value: function azureProvisioning(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/azuredirectory/' + directoryId + '/prov';
            return this.$http.get(url).then(function (_ref22) {
                var data = _ref22.data;
                return data;
            });
        }
    }, {
        key: 'getDirectoryStatus',
        value: function getDirectoryStatus(companyId, directory) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/' + directory.id + '/status';
            var params = { type: directory.type };
            return this.$http.get(url, { params: params }).then(function (_ref23) {
                var data = _ref23.data;
                return data;
            });
        }
    }, {
        key: 'getScimConfig',
        value: function getScimConfig(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/scimdirectory/' + directoryId + '/config';
            return this.$http.get(url).then(function (_ref24) {
                var data = _ref24.data;
                return data;
            });
        }
    }, {
        key: 'updateScimConfig',
        value: function updateScimConfig(companyId, directoryId, config) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/scimdirectory/' + directoryId + '/config';
            return this.$http.put(url, config).then(function (_ref25) {
                var data = _ref25.data;
                return data;
            });
        }
    }, {
        key: 'testScimConnection',
        value: function testScimConnection(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/scimdirectory/' + directoryId + '/connect';
            return this.$http.get(url).then(function (_ref26) {
                var data = _ref26.data;
                return data;
            });
        }
    }, {
        key: 'scimSync',
        value: function scimSync(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/scimdirectory/' + directoryId + '/sync';
            return this.$http.get(url).then(function (_ref27) {
                var data = _ref27.data;
                return data;
            });
        }
    }, {
        key: 'scimProvisioning',
        value: function scimProvisioning(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/scimdirectory/' + directoryId + '/prov';
            return this.$http.get(url).then(function (_ref28) {
                var data = _ref28.data;
                return data;
            });
        }
    }, {
        key: 'pauseScimProvisioning',
        value: function pauseScimProvisioning(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/scimdirectory/' + directoryId + '/pauseprov';
            return this.$http.put(url).then(function (_ref29) {
                var data = _ref29.data;
                return data;
            });
        }
    }, {
        key: 'resumeScimProvisioning',
        value: function resumeScimProvisioning(companyId, directoryId) {
            var url = 'app/rest/v2/company/' + companyId + '/directories/scimdirectory/' + directoryId + '/resumeprov';
            return this.$http.put(url).then(function (_ref30) {
                var data = _ref30.data;
                return data;
            });
        }
    }]);

    return DirectoriesResource;
}();

_app.app.service('DirectoriesResource', DirectoriesResource);

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _allAccounts = __webpack_require__(563);

_app.app.component('companyUserDirectoriesDirectoryGroupsAllAccounts', {
    bindings: {
        directoriesDto: '<',
        companyId: '<'
    },
    controller: _allAccounts.Controller,
    templateUrl: __webpack_require__(2019)
});

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6e1540a5ee9a39260d10cfa9ab95c1c0.html";

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.all-accounts', {
        url: '/all-accounts',
        component: 'companyUserDirectoriesDirectoryGroupsAllAccounts'
    });
}

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _copyAccountsToGroups = __webpack_require__(564);

_app.app.component('companyUserDirectoriesDirectoryGroupsAllAccountsCopy', {
    bindings: {
        accounts: '<',
        companyId: '<',
        groups: '<'
    },
    controller: _copyAccountsToGroups.Controller,
    templateUrl: __webpack_require__(2022)
});

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aad1319f077299fd0abc546da02f84ac.html";

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groups.$inject = ['companyId', 'GroupsResource'];
accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.all-accounts.copy', {
        url: '/copy',
        params: { accounts: [] },
        views: {
            '@company.user-directories': 'companyUserDirectoriesDirectoryGroupsAllAccountsCopy'
        },
        resolve: {
            accounts: accounts,
            groups: groups
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/** @ngInject */
function groups(companyId, GroupsResource) {
    return GroupsResource.getAllCustomAndApplication(companyId);
}

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deleteAccounts = __webpack_require__(565);

_app.app.component('companyUserDirectoriesDirectoryGroupsAllAccountsDelete', {
    bindings: {
        accounts: '<',
        companyId: '<',
        selectedAccounts: '<'
    },
    controller: _deleteAccounts.Controller,
    templateUrl: __webpack_require__(2025)
});

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "219f6db6cc8caf4efa18af1f480684c3.html";

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

selectedAccounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.all-accounts.delete', {
        url: '/delete',
        params: { accounts: [] },
        views: {
            '@company.user-directories.directory-groups': 'companyUserDirectoriesDirectoryGroupsAllAccountsDelete'
        },
        resolve: {
            selectedAccounts: selectedAccounts
        }
    });
}

/** @ngInject */
function selectedAccounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _exportAccounts = __webpack_require__(566);

_app.app.component('companyUserDirectoriesDirectoryGroupsAllAccountsExport', {
    bindings: {
        accounts: '<',
        currentCompany: '<'
    },
    controller: _exportAccounts.Controller,
    templateUrl: __webpack_require__(2028)
});

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fbbd14d26c52f08686a16a44765d294b.html";

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.all-accounts.export', {
        url: '/export',
        params: { accounts: [] },
        views: {
            '@company.user-directories.directory-groups': 'companyUserDirectoriesDirectoryGroupsAllAccountsExport'
        },
        resolve: {
            accounts: accounts
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sendVerificationEmails = __webpack_require__(567);

_app.app.component('companyUserDirectoriesDirectoryGroupsAllAccountsVerify', {
    bindings: {
        companyId: '<'
    },
    controller: _sendVerificationEmails.Controller,
    templateUrl: __webpack_require__(2031)
});

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d189c62f2b3d44495e8683ecb02db3d8.html";

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.all-accounts.verify', {
        url: '/verify',
        views: {
            '@company.user-directories.directory-groups': 'companyUserDirectoriesDirectoryGroupsAllAccountsVerify'
        }
    });
}

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('directoryGroupsSideMenu', {
    bindings: {
        directoriesDto: '<'
    },
    templateUrl: __webpack_require__(2034)
});

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8895ad2af06366b00456e5959143d137.html";

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addNewGroup = __webpack_require__(568);

_app.app.component('companyUserDirectoriesDirectoryGroupsDirectoryAddNewGroup', {
    bindings: { companyId: '<' },
    controller: _addNewGroup.Controller,
    templateUrl: __webpack_require__(2036)
});

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b62241ed0ba126708f22167b1d4a8bd.html";

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.add-new-group', {
        url: '/add-new-group',
        views: {
            '@company.user-directories': 'companyUserDirectoriesDirectoryGroupsDirectoryAddNewGroup'
        }
    });
}

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addUser = __webpack_require__(569);

_app.app.component('companyUserDirectoriesDirectoryGroupsDirectoryAddUser', {
    bindings: {
        companyId: '<',
        userAccountEmail: '<'
    },
    controller: _addUser.Controller,
    templateUrl: __webpack_require__(2039)
});

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5ee7c29a4c970e6176849f4ca4028a1f.html";

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

userAccountEmail.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.add-user', {
        url: '/add-user',
        params: { userAccountEmail: null },
        views: {
            '@company.user-directories': 'companyUserDirectoriesDirectoryGroupsDirectoryAddUser'
        },
        resolve: {
            userAccountEmail: userAccountEmail
        }
    });
}

/** @ngInject */
function userAccountEmail($stateParams) {
    return $stateParams.userAccountEmail;
}

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directory = __webpack_require__(570);

_app.app.component('companyUserDirectoriesDirectoryGroupsDirectory', {
    bindings: {
        directoriesDto: '<',
        directory: '<',
        domains: '<'
    },
    controller: _directory.Controller,
    templateUrl: __webpack_require__(2042)
});

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "97306219b84def93cad192f7d92da15d.html";

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _directory = __webpack_require__(203);

componentProvider.$inject = ['directoryId'];
groups.$inject = ['companyId', 'DirectoriesResource', 'directoryId'];
domains.$inject = ['$filter', 'companyId', 'DirectoriesResource', 'directory'];
directoryId.$inject = ['$stateParams'];
directory.$inject = ['directoriesDto', 'directoryId'];
connectionDetails.$inject = ['companyId', 'DirectoriesResource', 'directory'];
$breadcrumbs.$inject = ['directory'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory', {
        url: '/directory/:directoryId',
        params: { directoryId: 'saaspass-cloud-directory' },
        componentProvider: componentProvider,
        resolve: {
            $breadcrumbs: $breadcrumbs,
            connectionDetails: connectionDetails,
            directory: directory,
            directoryId: directoryId,
            domains: domains,
            groups: groups
        }
    });
}

/** @ngInject */
function componentProvider(directoryId) {
    if (directoryId === 'saaspass-cloud-directory') {
        return 'companyUserDirectoriesDirectoryGroupsSaaspassCloudDirectory';
    } else {
        return 'companyUserDirectoriesDirectoryGroupsDirectory';
    }
}

/** @ngInject */
function $breadcrumbs(directory) {
    return [{ title: directory.name }];
}

/** @ngInject */
function connectionDetails(companyId, DirectoriesResource, directory) {
    if (directory.id !== 'saaspass-cloud-directory' && !(0, _directory.isAzure)(directory) && !(0, _directory.isSCIM)(directory)) {
        return DirectoriesResource.getDirectoryConnectionDetails(companyId, directory.id);
    }
}

/** @ngInject */
function directory(directoriesDto, directoryId) {
    return directoriesDto.directories.find(function (_ref) {
        var id = _ref.id;
        return id === directoryId;
    });
}

/** @ngInject */
function directoryId($stateParams) {
    return $stateParams.directoryId;
}

/** @ngInject */
function domains($filter, companyId, DirectoriesResource, directory) {
    if (directory.id !== 'saaspass-cloud-directory') {
        if ((0, _directory.isAzure)(directory)) {
            return DirectoriesResource.getDirectoryGroups(companyId, directory).then(_directory.azureDomainsFromDto);
        } else if ((0, _directory.isSCIM)(directory)) {
            return DirectoriesResource.getDirectoryGroups(companyId, directory).then(_directory.scimDomainsFromDto);
        } else {
            return DirectoriesResource.getDirectoryGroups(companyId, directory).then(function (domains) {
                return $filter('orderBy')(domains, 'isRoot', true);
            }).then(_directory.domainsFromDto).then(function (domains) {
                return (0, _directory.emptyDomainListCheck)(directory, domains);
            });
        }
    }
}

/** @ngInject */
function groups(companyId, DirectoriesResource, directoryId) {
    if (directoryId === 'saaspass-cloud-directory') {
        return DirectoriesResource.getSaaspassCloudDirectoryGroups(companyId);
    } else {
        return [];
    }
}

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importUsers = __webpack_require__(571);

_app.app.component('companyUserDirectoriesDirectoryGroupsDirectoryImportUsers', {
    bindings: { companyId: '<' },
    controller: _importUsers.Controller,
    templateUrl: __webpack_require__(2045)
});

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4ab286e17b4a1053e2b93958c3284926.html";

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.import-users', {
        url: '/import-users',
        views: {
            '@company.user-directories': 'companyUserDirectoriesDirectoryGroupsDirectoryImportUsers'
        }
    });
}

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _uploadResult = __webpack_require__(572);

_app.app.component('companyUserDirectoriesDirectoryGroupsDirectoryImportUsersUploadResult', {
    bindings: { importResult: '<' },
    controller: _uploadResult.Controller,
    templateUrl: __webpack_require__(2048)
});

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "95c7a8214208a4d21a3aac05f652e8dd.html";

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

importResult.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.import-users.upload-result', {
        url: '/upload-result',
        params: { importResult: null },
        views: {
            '@company.user-directories': 'companyUserDirectoriesDirectoryGroupsDirectoryImportUsersUploadResult'
        },
        resolve: {
            importResult: importResult
        }
    });
}

/** @ngInject */
function importResult($stateParams) {
    return $stateParams.importResult;
}

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeGroups = __webpack_require__(573);

_app.app.component('companyUserDirectoriesDirectoryGroupsDirectoryRemoveGroups', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeGroups.Controller,
    templateUrl: __webpack_require__(2051)
});

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a78515fbd53b901c3eec53498bdf04d1.html";

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _saaspassCloudDirectory = __webpack_require__(574);

_app.app.component('companyUserDirectoriesDirectoryGroupsSaaspassCloudDirectory', {
    bindings: {
        companyId: '<',
        directoriesDto: '<',
        groups: '<'
    },
    controller: _saaspassCloudDirectory.Controller,
    templateUrl: __webpack_require__(2053)
});

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5e1645956cc4b58ccd8d91950299fadf.html";

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _userDirectories = __webpack_require__(575);

_app.app.component('companyUserDirectoriesDirectoryGroups', {
    bindings: {
        directoriesDto: '<'
    },
    controller: _userDirectories.Controller,
    templateUrl: __webpack_require__(2055)
});

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c1844525a6919b0fdb8ac1985a03f9c5.html";

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var redirectTo = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(transition) {
        var currentCompany, isOrganizationAdmin, directoryState, allAccountsState;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return transition.injector().getAsync('currentCompany');

                    case 2:
                        currentCompany = _context.sent;
                        isOrganizationAdmin = currentCompany.authoritiesConstants === 'ORGANIZATION_ADMIN';
                        directoryState = 'company.user-directories.directory-groups.directory';
                        allAccountsState = 'company.user-directories.directory-groups.all-accounts';
                        return _context.abrupt('return', isOrganizationAdmin ? directoryState : allAccountsState);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function redirectTo(_x) {
        return _ref.apply(this, arguments);
    };
}();

/** @ngInject */


var _app = __webpack_require__(0);

directoriesDto.$inject = ['companyId', 'DirectoriesResource'];
config.$inject = ['$stateProvider'];

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups', {
        url: '/directory-groups',
        redirectTo: redirectTo,
        component: 'companyUserDirectoriesDirectoryGroups',
        resolve: {
            directoriesDto: directoriesDto
        }
    });
}

function directoriesDto(companyId, DirectoriesResource) {
    return DirectoriesResource.getCompanyDirectories(companyId).then(function (directoriesDto) {
        return _extends({}, directoriesDto, {
            directories: directoriesDto.directories = directoriesDto.directories.filter(function (item) {
                return !item.inUseForAppProvisioning;
            })
        });
    }).then(function (directoriesDto) {
        return _extends({}, directoriesDto, {
            directories: [{
                id: 'saaspass-cloud-directory',
                type: 'saaspass-cloud-directory',
                name: 'SAASPASS Directory & Groups',
                numberOfAccounts: directoriesDto.totalNumberOfAccounts
            }].concat(_toConsumableArray(directoriesDto.directories))
        });
    });
}

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _accountCustomAttributes = __webpack_require__(576);

_app.app.component('companyUserDirectoriesManageAccountCustomAttributes', {
    bindings: {
        accountId: '<',
        companyId: '<',
        profileAttributes: '<'
    },
    controller: _accountCustomAttributes.Controller,
    templateUrl: __webpack_require__(2058)
});

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "102454c34625e8a744a50ed8555b0a6c.html";

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

profileAttributes.$inject = ['accountId', 'AccountsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.custom-attributes', {
        url: '/custom-attributes',
        views: {
            '@company.user-directories.manage-account': 'companyUserDirectoriesManageAccountCustomAttributes'
        },
        resolve: {
            profileAttributes: profileAttributes
        }
    });
}

/** @ngInject */
function profileAttributes(accountId, AccountsResource, companyId) {
    return AccountsResource.getProfileAttributes(companyId, accountId);
}

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _accountDetails = __webpack_require__(577);

_app.app.component('companyUserDirectoriesManageAccountDetails', {
    bindings: {
        account: '<',
        companyId: '<'
    },
    controller: _accountDetails.Controller,
    templateUrl: __webpack_require__(2061)
});

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cbf8d7fe5fcd2db5b2a803f3cf8d61ae.html";

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.details', {
        url: '/details',
        component: 'companyUserDirectoriesManageAccountDetails'
    });
}

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addAccountToGroups = __webpack_require__(578);

_app.app.component('companyUserDirectoriesManageAccountGroupsAppsAddToGroups', {
    bindings: {
        account: '<',
        companyId: '<',
        groups: '<'
    },
    controller: _addAccountToGroups.Controller,
    templateUrl: __webpack_require__(2064)
});

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0706d3aea6131d3bb63508a5ff7df899.html";

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groups.$inject = ['accountId', 'AccountsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.groups-apps.add-to-groups', {
        url: '/add-to-groups',
        views: {
            '@company.user-directories.manage-account': 'companyUserDirectoriesManageAccountGroupsAppsAddToGroups'
        },
        resolve: {
            groups: groups
        }
    });
}

/** @ngInject */
function groups(accountId, AccountsResource, companyId) {
    return AccountsResource.getAllGroupsUserCanBeAssignedTo(companyId, accountId);
}

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _groupsApps = __webpack_require__(579);

_app.app.component('companyUserDirectoriesManageAccountGroupsApps', {
    bindings: {
        accountId: '<',
        companyId: '<',
        groupsAndApps: '<'
    },
    controller: _groupsApps.Controller,
    templateUrl: __webpack_require__(2067)
});

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c402e53ec93870a2af91f148120ea460.html";

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groupsAndApps.$inject = ['accountId', 'AccountsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.groups-apps', {
        url: '/groups-apps',
        component: 'companyUserDirectoriesManageAccountGroupsApps',
        resolve: {
            groupsAndApps: groupsAndApps
        }
    });
}

/** @ngInject */
function groupsAndApps(accountId, AccountsResource, companyId) {
    var isSmart = function isSmart(_ref) {
        var type = _ref.type;
        return !['APPLICATION', 'CUSTOM'].includes(type);
    };
    return AccountsResource.getAllGroupsForUserAccount(companyId, accountId).then(function (pairs) {
        return pairs.sort(function (p1, p2) {
            return isSmart(p2.group) - isSmart(p1.group);
        });
    });
}

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeAccountFromGroup = __webpack_require__(580);

_app.app.component('companyUserDirectoriesManageAccountGroupsAppsRemoveFromGroups', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeAccountFromGroup.Controller,
    templateUrl: __webpack_require__(2070)
});

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fcb03413115e9ce244e34e8ed6315d6b.html";

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('manageAccountTabs', {
    templateUrl: __webpack_require__(2072)
});

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d358583fcb4891c327e2e1946750085a.html";

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageAccount = __webpack_require__(581);

_app.app.component('companyUserDirectoriesManageAccount', {
    bindings: { account: '<' },
    controller: _manageAccount.Controller,
    templateUrl: __webpack_require__(2074)
});

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6981b71e6b07edd7ca001630bb108959.html";

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accountId.$inject = ['$stateParams'];
account.$inject = ['accountId', 'AccountsResource', 'companyId'];
$breadcrumbs.$inject = ['account'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account', {
        url: '/manage-account/:accountId',
        redirectTo: 'company.user-directories.manage-account.details',
        component: 'companyUserDirectoriesManageAccount',
        resolve: {
            $breadcrumbs: $breadcrumbs,
            account: account,
            accountId: accountId
        }
    });
}

/** @ngInject */
function $breadcrumbs(account) {
    return [{
        stateName: 'company.user-directories.directory-groups'
    }, {
        stateName: 'company.user-directories.directory-groups.directory',
        stateParams: { directoryId: (account.directory || {}).id },
        title: (account.directory || {}).name || 'SAASPASS Directory & Groups'
    }, {
        title: account.username
    }];
}

/** @ngInject */
function account(accountId, AccountsResource, companyId) {
    return AccountsResource.getUserAccount(companyId, accountId);
}

/** @ngInject */
function accountId($stateParams) {
    return $stateParams.accountId;
}

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _changeAccountOwner = __webpack_require__(582);

_app.app.component('companyUserDirectoriesManageAccountChangeOwnerConfirm', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _changeAccountOwner.Controller,
    templateUrl: __webpack_require__(2077)
});

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "363d5121d5558a098de820da26d345e4.html";

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageAccountOwner = __webpack_require__(583);

_app.app.component('companyUserDirectoriesManageAccountChangeOwner', {
    bindings: {
        account: '<',
        companyId: '<'
    },
    controller: _manageAccountOwner.Controller,
    templateUrl: __webpack_require__(2079)
});

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "487a67cc538f0c41eada91a3e52f944f.html";

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.change-owner', {
        url: '/change-owner',
        component: 'companyUserDirectoriesManageAccountChangeOwner'
    });
}

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeAccountOwner = __webpack_require__(584);

_app.app.component('companyUserDirectoriesManageAccountRemoveOwner', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeAccountOwner.Controller,
    templateUrl: __webpack_require__(2082)
});

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d583ce4b9bd2c4415c1f6ce91c65d78e.html";

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editProfileAttributes = __webpack_require__(585);

_app.app.component('companyUserDirectoriesManageAccountProfileAttributesEdit', {
    bindings: {
        accountId: '<',
        companyId: '<',
        profileAttributes: '<'
    },
    controller: _editProfileAttributes.Controller,
    templateUrl: __webpack_require__(2084)
});

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fd157cd7fac54ff912271b6eaeeab868.html";

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.profile-attributes.edit', {
        url: '/edit',
        views: {
            '@company.user-directories.manage-account': 'companyUserDirectoriesManageAccountProfileAttributesEdit'
        }
    });
}

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _profileAttributes = __webpack_require__(586);

_app.app.component('companyUserDirectoriesManageAccountProfileAttributes', {
    bindings: {
        account: '<',
        accountId: '<',
        companyId: '<',
        profileAttributes: '<'
    },
    controller: _profileAttributes.Controller,
    templateUrl: __webpack_require__(2087)
});

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f0db612d1cbe53bc4964b246a55714df.html";

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

profileAttributes.$inject = ['accountId', 'AccountsResource', 'companyId'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.profile-attributes', {
        url: '/profile-attributes',
        component: 'companyUserDirectoriesManageAccountProfileAttributes',
        resolve: {
            profileAttributes: profileAttributes
        }
    });
}

/** @ngInject */
function profileAttributes(accountId, AccountsResource, companyId) {
    return AccountsResource.getProfileAttributes(companyId, accountId);
}

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeAccount = __webpack_require__(587);

_app.app.component('companyUserDirectoriesManageAccountRemove', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeAccount.Controller,
    templateUrl: __webpack_require__(2090)
});

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e8bf2714ebf4aa34d6ff4eeb834171ec.html";

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sendVerificationEmail = __webpack_require__(588);

_app.app.component('companyUserDirectoriesManageAccountSendVerificationEmail', {
    bindings: {
        account: '<',
        companyId: '<'
    },
    controller: _sendVerificationEmail.Controller,
    templateUrl: __webpack_require__(2092)
});

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "684d7e9db6e3ec06ff22ed9fa532258b.html";

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.send-verification-email', {
        url: '/send-verification-email',
        component: 'companyUserDirectoriesManageAccountSendVerificationEmail'
    });
}

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _verifyAccountOwner = __webpack_require__(589);

_app.app.component('companyUserDirectoriesManageAccountVerify', {
    bindings: {
        account: '<',
        companyId: '<'
    },
    controller: _verifyAccountOwner.Controller,
    templateUrl: __webpack_require__(2095)
});

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4eba0f50e13c6eb49516503774a796bf.html";

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.verify', {
        url: '/verify',
        component: 'companyUserDirectoriesManageAccountVerify'
    });
}

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addAccountToGroup = __webpack_require__(590);

_app.app.component('companyUserDirectoriesManageGroupAccountsAdd', {
    bindings: {
        companyId: '<',
        group: '<'
    },
    controller: _addAccountToGroup.Controller,
    templateUrl: __webpack_require__(2098)
});

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "403b0182a09d71b06f28caf60bdc2044.html";

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.add', {
        url: '/add',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsAdd'
        }
    });
}

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _bulkVerificationCsv = __webpack_require__(591);

_app.app.component('companyUserDirectoriesManageGroupAccountsBulkVerificationCsv', {
    bindings: {
        connectionDetails: '<',
        companyId: '<',
        groupId: '<'
    },
    controller: _bulkVerificationCsv.Controller,
    templateUrl: __webpack_require__(2101)
});

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "204fddf87b2f1e4661787181bc8c62dd.html";

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.bulk-verification-csv', {
        url: '/bulk-verification-csv',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsBulkVerificationCsv'
        }
    });
}

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _bulkVerificationResult = __webpack_require__(592);

_app.app.component('companyUserDirectoriesManageGroupAccountsBulkVerificationResult', {
    bindings: {
        connectionDetails: '<',
        importedUsers: '<'
    },
    controller: _bulkVerificationResult.Controller,
    templateUrl: __webpack_require__(2104)
});

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2711a97a742361449f39bcaf84379216.html";

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

importedUsers.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.bulk-verification-result', {
        url: '/bulk-verification-result',
        params: { importedUsers: null },
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsBulkVerificationResult'
        },
        resolve: { importedUsers: importedUsers }
    });
}

/** @ngInject */
function importedUsers($stateParams) {
    return $stateParams.importedUsers;
}

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _bulkVerification = __webpack_require__(593);

_app.app.component('companyUserDirectoriesManageGroupAccountsBulkVerification', {
    bindings: {
        companyId: '<',
        group: '<'
    },
    controller: _bulkVerification.Controller,
    templateUrl: __webpack_require__(2115)
});

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bulk-verification-de.html": 2108,
	"./bulk-verification-en.html": 2109,
	"./bulk-verification-es.html": 2110,
	"./bulk-verification-fr.html": 2111,
	"./bulk-verification-ja.html": 2112,
	"./bulk-verification-pt.html": 2113,
	"./bulk-verification-zh.html": 2114
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2107;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8ae79670e1bdaab6f5d3a17f37d408ea.html";

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "00b5d7765ebebbf6d4f0826647b1f232.html";

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "301676eda62c024fa5839d7569797959.html";

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fffb027f523fb1d2948235a586fd4df9.html";

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "113c33ab6fe2b6529ed8d613d01d6743.html";

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8620176189b9ae08b896fc5e67fccc66.html";

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "899f46e00d8d54b17a7cd7c98118b9c1.html";

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3243f0543ee6ae72be893891fd2e8e3e.html";

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.bulk-verification', {
        url: '/bulk-verification',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsBulkVerification'
        }
    });
}

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _copyAccountsToGroups = __webpack_require__(594);

_app.app.component('companyUserDirectoriesManageGroupAccountsCopy', {
    bindings: {
        accounts: '<',
        companyId: '<',
        groups: '<'
    },
    controller: _copyAccountsToGroups.Controller,
    templateUrl: __webpack_require__(2118)
});

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "92d5d6ad4c664e8dc90e3520dc5827f9.html";

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groups.$inject = ['companyId', 'groupId', 'GroupsResource'];
accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.copy', {
        url: '/copy',
        params: { accounts: [] },
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsCopy'
        },
        resolve: {
            accounts: accounts,
            groups: groups
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/** @ngInject */
function groups(companyId, groupId, GroupsResource) {
    return GroupsResource.getAllCustomAndApplication(companyId).then(function (groups) {
        return groups.filter(function (_ref) {
            var id = _ref.id;
            return id !== groupId;
        });
    });
}

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deleteAccounts = __webpack_require__(595);

_app.app.component('companyUserDirectoriesManageGroupAccountsDelete', {
    bindings: {
        accounts: '<',
        companyId: '<',
        selectedAccounts: '<'
    },
    controller: _deleteAccounts.Controller,
    templateUrl: __webpack_require__(2121)
});

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd02f0a22ba79be90b1df7c64b9bc9e0.html";

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

selectedAccounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.delete', {
        url: '/delete',
        params: { accounts: [] },
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsDelete'
        },
        resolve: {
            selectedAccounts: selectedAccounts
        }
    });
}

/** @ngInject */
function selectedAccounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _exportAccounts = __webpack_require__(596);

_app.app.component('companyUserDirectoriesManageGroupAccountsExport', {
    bindings: {
        accounts: '<',
        currentCompany: '<',
        group: '<'
    },
    controller: _exportAccounts.Controller,
    templateUrl: __webpack_require__(2124)
});

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bb1b959dcea28639ded2d64c537a5372.html";

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.export', {
        url: '/export',
        params: { accounts: [] },
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsExport'
        },
        resolve: {
            accounts: accounts
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _groupAccounts = __webpack_require__(597);

_app.app.component('companyUserDirectoriesManageGroupAccounts', {
    bindings: {
        companyId: '<',
        group: '<'
    },
    controller: _groupAccounts.Controller,
    templateUrl: __webpack_require__(2127)
});

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "04c2fd665ba6462fb14fab80ae7af721.html";

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts', {
        url: '/accounts',
        component: 'companyUserDirectoriesManageGroupAccounts'
    });
}

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importAccountsToGroup = __webpack_require__(598);

_app.app.component('companyUserDirectoriesManageGroupAccountsImport', {
    bindings: {
        companyId: '<',
        group: '<'
    },
    controller: _importAccountsToGroup.Controller,
    templateUrl: __webpack_require__(2130)
});

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5b47fda3a5244008d87367990ef19a2a.html";

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.import', {
        url: '/import',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsImport'
        }
    });
}

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importResult = __webpack_require__(599);

_app.app.component('companyUserDirectoriesManageGroupAccountsImportResult', {
    bindings: { importResult: '<' },
    controller: _importResult.Controller,
    templateUrl: __webpack_require__(2133)
});

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "28cd69e778410536d2e898286e2b36d1.html";

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

importResult.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.import.result', {
        url: '/result',
        params: { importResult: null },
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsImportResult'
        },
        resolve: {
            importResult: importResult
        }
    });
}

/** @ngInject */
function importResult($stateParams) {
    return $stateParams.importResult;
}

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _moveAccountsToGroup = __webpack_require__(600);

_app.app.component('companyUserDirectoriesManageGroupAccountsMove', {
    bindings: {
        accounts: '<',
        companyId: '<',
        group: '<',
        groups: '<'
    },
    controller: _moveAccountsToGroup.Controller,
    templateUrl: __webpack_require__(2136)
});

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b33365886c71b9469fd5244626371331.html";

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

groups.$inject = ['companyId', 'groupId', 'GroupsResource'];
accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.move', {
        url: '/move',
        params: { accounts: [] },
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsMove'
        },
        resolve: {
            accounts: accounts,
            groups: groups
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/** @ngInject */
function groups(companyId, groupId, GroupsResource) {
    return GroupsResource.getAllCustomAndApplication(companyId).then(function (groups) {
        return groups.filter(function (_ref) {
            var id = _ref.id;
            return id !== groupId;
        });
    });
}

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeAccountsFromGroup = __webpack_require__(601);

_app.app.component('companyUserDirectoriesManageGroupAccountsRemove', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeAccountsFromGroup.Controller,
    templateUrl: __webpack_require__(2139)
});

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "be3785cc8ab0696304b1682d95eb34de.html";

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sendVerificationEmails = __webpack_require__(602);

_app.app.component('companyUserDirectoriesManageGroupAccountsVerify', {
    bindings: {
        companyId: '<',
        group: '<'
    },
    controller: _sendVerificationEmails.Controller,
    templateUrl: __webpack_require__(2141)
});

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bf541801ef5af9220301670cf884c0c8.html";

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.accounts.verify', {
        url: '/verify',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupAccountsVerify'
        }
    });
}

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _assignGroupToApplication = __webpack_require__(603);

_app.app.component('companyUserDirectoriesManageGroupApplicationsAssign', {
    bindings: {
        applications: '<',
        companyId: '<',
        group: '<'
    },
    controller: _assignGroupToApplication.Controller,
    templateUrl: __webpack_require__(2144)
});

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4bc5c6cbaf22c0296f023524f594bf78.html";

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _spUtil = __webpack_require__(73);

applications.$inject = ['companyId', 'groupId', 'GroupsResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.applications.assign', {
        url: '/assign',
        views: {
            '@company.user-directories.manage-group': 'companyUserDirectoriesManageGroupApplicationsAssign'
        },
        resolve: {
            applications: applications
        }
    });
}

/** @ngInject */
function applications(companyId, groupId, GroupsResource) {
    return GroupsResource.getAssignableApplicationsForGroup(companyId, groupId).then(function (applications) {
        return applications.map(function (app) {
            return _extends({}, app, { protocol: (0, _spUtil.appProtocolDisplayName)(app) });
        });
    });
}

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _groupApplications = __webpack_require__(604);

_app.app.component('companyUserDirectoriesManageGroupApplications', {
    bindings: {
        applications: '<',
        companyId: '<',
        group: '<'
    },
    controller: _groupApplications.Controller,
    templateUrl: __webpack_require__(2147)
});

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f9f89e4920cbc08904b51af45c141bc.html";

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

var _spUtil = __webpack_require__(73);

applications.$inject = ['companyId', 'groupId', 'GroupsResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.applications', {
        url: '/applications',
        component: 'companyUserDirectoriesManageGroupApplications',
        resolve: {
            applications: applications
        }
    });
}

/** @ngInject */
function applications(companyId, groupId, GroupsResource) {
    return GroupsResource.getAssignedApplicationsOfGroup(companyId, groupId).then(function (applications) {
        return applications.map(function (app) {
            return _extends({}, app, { protocol: (0, _spUtil.appProtocolDisplayName)(app) });
        });
    });
}

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _groupCustomAttributes = __webpack_require__(605);

_app.app.component('companyUserDirectoriesManageGroupCustomAttributes', {
    bindings: {
        companyId: '<',
        group: '<',
        customAttributes: '<'
    },
    controller: _groupCustomAttributes.Controller,
    templateUrl: __webpack_require__(2150)
});

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3442c3ba4c576ab5b2cf56de2a6535b5.html";

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

customAttributes.$inject = ['companyId', 'group', 'GroupsResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.custom-attributes', {
        url: '/custom-attributes',
        component: 'companyUserDirectoriesManageGroupCustomAttributes',
        resolve: {
            customAttributes: customAttributes
        }
    });
}

/** @ngInject */
function customAttributes(companyId, group, GroupsResource) {
    return GroupsResource.getCustomAttributes(companyId, group.id);
}

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('manageGroupTabs', {
    templateUrl: __webpack_require__(2153)
});

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "001acdadd3190d9b0099a46b3dd9ba5f.html";

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageGroup = __webpack_require__(606);

_app.app.component('companyUserDirectoriesManageGroup', {
    bindings: { group: '<' },
    controller: _manageGroup.Controller,
    templateUrl: __webpack_require__(2155)
});

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3c6e230922d3e1eb450444b1b70024ab.html";

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _spGroupType = __webpack_require__(132);

groupId.$inject = ['$stateParams'];
group.$inject = ['companyId', 'groupId', 'GroupsResource'];
$breadcrumbs.$inject = ['$q', '$translate', 'group'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group', {
        url: '/manage-group/:groupId',
        redirectTo: 'company.user-directories.manage-group.settings',
        component: 'companyUserDirectoriesManageGroup',
        resolve: {
            $breadcrumbs: $breadcrumbs,
            group: group,
            groupId: groupId
        }
    });
}

/** @ngInject */
function $breadcrumbs($q, $translate, group) {
    return function () {
        if (group.groupName === group.type) {
            return $translate((0, _spGroupType.groupTypeLabel)(group.type));
        } else {
            return $q.resolve(group.groupName);
        }
    }().then(function (title) {
        return [{
            stateName: 'company.user-directories.directory-groups'
        }, {
            stateName: 'company.user-directories.directory-groups.directory',
            stateParams: { directoryId: (group.directory || {}).id },
            title: (group.directory || {}).name || 'SAASPASS Directory & Groups'
        }, {
            title: title
        }];
    });
}

/** @ngInject */
function groupId($stateParams) {
    return $stateParams.groupId;
}

/** @ngInject */
function group(companyId, groupId, GroupsResource) {
    return GroupsResource.getGroupById(companyId, groupId);
}

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeGroup = __webpack_require__(607);

_app.app.component('companyUserDirectoriesManageGroupRemove', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeGroup.Controller,
    templateUrl: __webpack_require__(2158)
});

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "db4ec4927c9ee5a35fea9480a8574da1.html";

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _groupSettings = __webpack_require__(608);

_app.app.component('companyUserDirectoriesManageGroupSettings', {
    bindings: {
        companyId: '<',
        group: '<'
    },
    controller: _groupSettings.Controller,
    templateUrl: __webpack_require__(2160)
});

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d5a271f6a0cc2e180a86b633b8f75484.html";

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-group.settings', {
        url: '/settings',
        component: 'companyUserDirectoriesManageGroupSettings'
    });
}

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyUserDirectoriesManageUserAddAccountAccountAlreadyExists', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2163)
});

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9e60c05dd7999584ecd0c85fa3f93836.html";

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addAccount = __webpack_require__(609);

_app.app.component('companyUserDirectoriesManageUserAddAccount', {
    bindings: {
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<'
    },
    controller: _addAccount.Controller,
    templateUrl: __webpack_require__(2165)
});

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3f481d2c347f41ed7a44c6598351deba.html";

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.add-account', {
        url: '/add-account',
        component: 'companyUserDirectoriesManageUserAddAccount'
    });
}

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _copyAccounts = __webpack_require__(610);

_app.app.component('companyUserDirectoriesManageUserCopyAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<'
    },
    controller: _copyAccounts.Controller,
    templateUrl: __webpack_require__(2168)
});

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "88c5ef059d4b2e42e78519f406ab3f3d.html";

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.copy-accounts', {
        url: '/copy-accounts',
        params: { accounts: [] },
        component: 'companyUserDirectoriesManageUserCopyAccounts',
        resolve: {
            accounts: accounts
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _copySharedAccounts = __webpack_require__(611);

_app.app.component('companyUserDirectoriesManageUserCopySharedAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<'
    },
    controller: _copySharedAccounts.Controller,
    templateUrl: __webpack_require__(2171)
});

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b5327880557f02cfb89cec3b9cb26eb2.html";

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.copy-shared-accounts', {
        url: '/copy-shared-accounts',
        params: { accounts: [] },
        component: 'companyUserDirectoriesManageUserCopySharedAccounts',
        resolve: {
            accounts: accounts
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deleteAccounts = __webpack_require__(612);

_app.app.component('companyUserDirectoriesManageUserDeleteAccounts', {
    bindings: {
        accountsForCompanyUser: '<',
        companyId: '<',
        selectedAccounts: '<'
    },
    controller: _deleteAccounts.Controller,
    templateUrl: __webpack_require__(2174)
});

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "addef2a63ad2646c99284ca9c816d434.html";

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

selectedAccounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.delete-accounts', {
        url: '/delete-accounts',
        params: { accounts: [] },
        component: 'companyUserDirectoriesManageUserDeleteAccounts',
        resolve: {
            selectedAccounts: selectedAccounts
        }
    });
}

/** @ngInject */
function selectedAccounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deleteUser = __webpack_require__(613);

_app.app.component('companyUserDirectoriesManageUserDeleteUser', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _deleteUser.Controller,
    templateUrl: __webpack_require__(2177)
});

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2a74f2d15df298adde086ead79b3e4c2.html";

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _assignHardToken = __webpack_require__(614);

_app.app.component('companyUserDirectoriesManageUserDetailsAssignHardToken', {
    controller: _assignHardToken.Controller,
    templateUrl: __webpack_require__(2179),
    bindings: { close: '&', dismiss: '&', resolve: '<' }
});

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b75f4c52bfc38b5ec116f630af039576.html";

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _confirmAssign = __webpack_require__(615);

_app.app.component('companyUserDirectoriesManageUserDetailsAssignHardTokenConfirmAssign', {
    controller: _confirmAssign.Controller,
    templateUrl: __webpack_require__(2181),
    bindings: { close: '&', dismiss: '&', resolve: '<' }
});

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c742ba785ef6e7b9d64d67612a89a16d.html";

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _backupCodes = __webpack_require__(616);

_app.app.component('companyUserDirectoriesUserBackupCodes', {
    bindings: {
        companyId: '<',
        currentCompany: '<',
        companyUser: '<',
        hardToken: '<',
        userSettings: '<'
    },
    controller: _backupCodes.Controller,
    templateUrl: __webpack_require__(2183)
});

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "58e295869350fd0f64f04f78b68b3a1d.html";

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.details.backup-codes', {
        url: '/backup-codes',
        views: {
            '@company.user-directories.manage-user': 'companyUserDirectoriesUserBackupCodes'
        }

    });
}

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deactivateSms = __webpack_require__(617);

_app.app.component('companyUserDirectoriesManageUserDetailsDeactivateSms', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _deactivateSms.Controller,
    templateUrl: __webpack_require__(2186)
});

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0dff3468d3fa49746cd6ef242b3e4d11.html";

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageUserDetails = __webpack_require__(618);

_app.app.component('companyUserDirectoriesManageUserDetails', {
    bindings: {
        account: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        currentCompany: '<',
        companyUser: '<',
        hardToken: '<',
        userSharedServiceAccounts: '<',
        userSharedNotes: '<',
        devicesForCompanyUser: '<',
        userSettings: '<'
    },
    controller: _manageUserDetails.Controller,
    templateUrl: __webpack_require__(2188)
});

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dcfd4d86419fc20c26e22fb1e21bb077.html";

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

userSettings.$inject = ['companyId', 'UserSettingsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.details', {
        url: '/details',
        component: 'companyUserDirectoriesManageUserDetails',
        resolve: {
            userSettings: userSettings
        }
    });
}

/** @ngInject */
function userSettings(companyId, UserSettingsService) {
    return UserSettingsService.getAdminSettings(companyId);
}

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editDisplayName = __webpack_require__(619);

_app.app.component('companyUserDirectoriesManageUserEditDisplayName', {
    bindings: {
        companyId: '<',
        companyUser: '<',
        displayNames: '<'
    },
    controller: _editDisplayName.Controller,
    templateUrl: __webpack_require__(2191)
});

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eeacd27d381c3a657f1c5a9326d56367.html";

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

displayNames.$inject = ['companyId', 'companyUserId', 'UsersResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.edit-display-name', {
        url: '/edit-display-name',
        component: 'companyUserDirectoriesManageUserEditDisplayName',
        resolve: {
            displayNames: displayNames
        }
    });
}

function displayNames(companyId, companyUserId, UsersResource) {
    return UsersResource.getAllAccountsDisplayNames(companyId, companyUserId);
}

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _generateBackupCodes = __webpack_require__(620);

_app.app.component('companyUserDirectoriesManageUserGenerateBC', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _generateBackupCodes.Controller,
    templateUrl: __webpack_require__(2194)
});

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c4a9d0dc833bcabe3ae5765035cb989a.html";

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _manageUser = __webpack_require__(621);

_app.app.component('companyUserDirectoriesManageUser', {
    bindings: {
        companyUser: '<'
    },
    controller: _manageUser.Controller,
    templateUrl: __webpack_require__(2196)
});

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "22b0b607323f491d9b843a34877791f6.html";

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _account = __webpack_require__(48);

devicesForCompanyUser.$inject = ['companyId', 'companyUser', 'UsersResource'];
userSharedNotes.$inject = ['companyId', 'companyUserId', 'UsersResource'];
userSharedServiceAccounts.$inject = ['companyId', 'companyUserId', 'UsersResource'];
hardTokenLost.$inject = ['$q', '$state', 'companyId', 'companyUserId', 'hardToken'];
hardToken.$inject = ['$stateParams'];
companyUserId.$inject = ['$stateParams'];
companyUser.$inject = ['$stateParams', 'companyId', 'companyUserId', 'hardToken', 'UsersResource'];
accountsForCompanyUser.$inject = ['companyId', 'companyUser', 'UsersResource'];
$breadcrumbs.$inject = ['companyUser'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user', {
        url: '/manage-user/:companyUserId',
        params: { companyUserId: null, hardToken: null },
        redirectTo: 'company.user-directories.manage-user.details',
        component: 'companyUserDirectoriesManageUser',
        resolve: {
            $breadcrumbs: $breadcrumbs,
            accountsForCompanyUser: accountsForCompanyUser,
            companyUser: companyUser,
            companyUserId: companyUserId,
            hardToken: hardToken,
            hardTokenLost: hardTokenLost,
            userSharedServiceAccounts: userSharedServiceAccounts,
            userSharedNotes: userSharedNotes,
            devicesForCompanyUser: devicesForCompanyUser
        }
    });
}

/** @ngInject */
function $breadcrumbs(companyUser) {
    var displayName = companyUser.displayName;
    var saaspassId = companyUser.saaspassUser.saaspassId;
    return [{ stateName: 'company.user-directories.saaspass-users' }, { title: displayName ? saaspassId + ' / ' + displayName : 'SAASPASS ID ' + saaspassId }];
}

/** @ngInject */
function accountsForCompanyUser(companyId, companyUser, UsersResource) {
    // companyUserId does not exist if the user has no accounts. (inactive hard-token)
    if (companyUser.id) {
        return UsersResource.getAllAccountsForCompanyUser(companyId, companyUser.id).then(function (accounts) {
            return accounts.map(function (account) {
                return (0, _account.accountFromDto)(account, companyUser);
            });
        });
    } else {
        return [];
    }
}

/** @ngInject */
function devicesForCompanyUser(companyId, companyUser, UsersResource) {
    // companyUserId does not exist if the user has no accounts. (inactive hard-token)
    if (companyUser.id) {
        return UsersResource.getAllDevicesForCompanyUser(companyId, companyUser.id);
    } else {
        return [];
    }
}

/** @ngInject */
function companyUser($stateParams, companyId, companyUserId, hardToken, UsersResource) {
    // companyUserId does not exist if the user has no accounts. (inactive hard-token)
    if (companyUserId) {
        return UsersResource.getCompanyUser(companyId, companyUserId);
    } else if (hardToken) {
        return UsersResource.getCompanyUserForSaaspassUser(companyId, hardToken.saaspassId);
    }
}

/** @ngInject */
function companyUserId($stateParams) {
    return $stateParams.companyUserId;
}

/** @ngInject */
function hardToken($stateParams) {
    return $stateParams.hardToken;
}

/** @ngInject */
function hardTokenLost($q, $state, companyId, companyUserId, hardToken) {
    if (companyUserId || hardToken) {
        return $q.resolve();
    }

    // when page is reloaded, hardToken parameter is lost. (inactive hard-token)
    $state.go('company.hard-token-management', { companyId: companyId });
    return $q.reject();
}

/** @ngInject */
function userSharedServiceAccounts(companyId, companyUserId, UsersResource) {
    // companyUserId does not exist if the user has no accounts. (inactive hard-token)
    if (companyUserId) {
        return UsersResource.getUserSharedServiceAccounts(companyId, companyUserId);
    } else {
        return [];
    }
}

/** @ngInject */
function userSharedNotes(companyId, companyUserId, UsersResource) {
    // companyUserId does not exist if the user has no accounts. (inactive hard-token)
    if (companyUserId) {
        return UsersResource.getUserSharedNotes(companyId, companyUserId);
    } else {
        return [];
    }
}

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _moveAccounts = __webpack_require__(622);

_app.app.component('companyUserDirectoriesManageUserMoveAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<'
    },
    controller: _moveAccounts.Controller,
    templateUrl: __webpack_require__(2199)
});

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75d79a0b3275a26b5b3c963523d111df.html";

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.move-accounts', {
        url: '/move-accounts',
        params: { accounts: [] },
        component: 'companyUserDirectoriesManageUserMoveAccounts',
        resolve: {
            accounts: accounts
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _moveSharedAccounts = __webpack_require__(623);

_app.app.component('companyUserDirectoriesManageUserMoveSharedAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<',
        companyUser: '<'
    },
    controller: _moveSharedAccounts.Controller,
    templateUrl: __webpack_require__(2202)
});

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eacbb2d61abf2872bb680c30b15182a8.html";

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.move-shared-accounts', {
        url: '/move-shared-accounts',
        params: { accounts: [] },
        component: 'companyUserDirectoriesManageUserMoveSharedAccounts',
        resolve: {
            accounts: accounts
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeAccounts = __webpack_require__(624);

_app.app.component('companyUserDirectoriesManageUserRemoveAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        companyId: '<'
    },
    controller: _removeAccounts.Controller,
    templateUrl: __webpack_require__(2205)
});

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "62e037cd90af63d5725899040f857edf.html";

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.remove-accounts', {
        url: '/remove-accounts',
        params: { accounts: [] },
        component: 'companyUserDirectoriesManageUserRemoveAccounts',
        resolve: {
            accounts: accounts
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsResetPin = __webpack_require__(625);

_app.app.component('companyUserDirectoriesManageUserSmsResetPin', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _smsResetPin.Controller,
    templateUrl: __webpack_require__(2208)
});

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "17811b22bdb24284802e253282cfdbd4.html";

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SmsResetPin = function () {
    SmsResetPin.$inject = ['$http'];

    /** @ngInject */
    function SmsResetPin($http) {
        _classCallCheck(this, SmsResetPin);

        this.$http = $http;
    }

    _createClass(SmsResetPin, [{
        key: 'sendResetPinCode',
        value: function sendResetPinCode(companyId, companyUserId) {
            var url = 'app/rest/companies/' + companyId + '/companyusers/' + companyUserId + '/sendResetPinCode';
            return this.$http.post(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }]);

    return SmsResetPin;
}();

_app.app.service('SmsResetPin', SmsResetPin);

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _unshareSharedAccounts = __webpack_require__(626);

_app.app.component('companyUserDirectoriesManageUserUnshareSharedAccounts', {
    bindings: {
        accounts: '<',
        accountsForCompanyUser: '<',
        userSharedServiceAccounts: '<',
        userSharedNotes: '<',
        companyId: '<',
        companyUser: '<'
    },
    controller: _unshareSharedAccounts.Controller,
    templateUrl: __webpack_require__(2211)
});

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1637af7040c3330b7b4640f0c1acc96f.html";

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

accounts.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.unshare-shared-accounts', {
        url: '/remove-shared-accounts',
        params: { accounts: [] },
        component: 'companyUserDirectoriesManageUserUnshareSharedAccounts',
        resolve: {
            accounts: accounts
        }
    });
}

/** @ngInject */
function accounts($stateParams) {
    return $stateParams.accounts;
}

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _unshareSharedNotes = __webpack_require__(627);

_app.app.component('companyUserDirectoriesManageUserUnshareSharedNotes', {
    bindings: {
        notes: '<',
        accountsForCompanyUser: '<',
        userSharedServiceAccounts: '<',
        userSharedNotes: '<',
        companyId: '<',
        companyUser: '<'
    },
    controller: _unshareSharedNotes.Controller,
    templateUrl: __webpack_require__(2214)
});

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3c0785055fcb39448525600024078789.html";

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

notes.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-user.unshare-shared-notes', {
        url: '/remove-shared-notes',
        params: { notes: [] },
        component: 'companyUserDirectoriesManageUserUnshareSharedNotes',
        resolve: {
            notes: notes
        }
    });
}

/** @ngInject */
function notes($stateParams) {
    return $stateParams.notes;
}

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _administratorsDevelopers = __webpack_require__(628);

_app.app.component('companyUserDirectoriesSaaspassUsersAdministratorsDevelopers', {
    bindings: {
        administrators: '<',
        labels: '<',
        numberOfUsers: '<'
    },
    controller: _administratorsDevelopers.Controller,
    templateUrl: __webpack_require__(2217)
});

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4591d93aaba863b768668476c36411d0.html";

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.administrators-developers', {
        url: '/administrators-developers',
        component: 'companyUserDirectoriesSaaspassUsersAdministratorsDevelopers',
        resolve: {}
    });
}

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _allUsers = __webpack_require__(629);

_app.app.component('companyUserDirectoriesSaaspassUsersAllUsers', {
    bindings: {
        allUsers: '<',
        hardTokens: '<',
        labels: '<',
        numberOfUsers: '<'
    },
    controller: _allUsers.Controller,
    templateUrl: __webpack_require__(2220)
});

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57e5236b70adb430dfe80e85c1c0c539.html";

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.all-users', {
        url: '/all-users',
        component: 'companyUserDirectoriesSaaspassUsersAllUsers',
        resolve: {}
    });
}

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _userSettingsConfirm = __webpack_require__(630);

_app.app.component('companyUserDirectoriesSaaspassUsersUserSettingsConfirm', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _userSettingsConfirm.Controller,
    templateUrl: __webpack_require__(2223)
});

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d5a470ebb9550ecccd5cb50da5bb3aaf.html";

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _userSettings = __webpack_require__(631);

_app.app.component('companyUserDirectoriesSaaspassUsersUserSettings', {
    bindings: { companyId: '<', userSettings: '<' },
    controller: _userSettings.Controller,
    templateUrl: __webpack_require__(2225)
});

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "918982d6c621f011f786b81da27b5499.html";

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSettingsService = function () {
    UserSettingsService.$inject = ["$http"];

    /** @ngInject */
    function UserSettingsService($http) {
        _classCallCheck(this, UserSettingsService);

        this.$http = $http;
    }

    _createClass(UserSettingsService, [{
        key: "getAdminSettings",
        value: function getAdminSettings(companyId) {
            var url = "app/rest/v2/company/" + companyId + "/administratorsettings";
            return this.$http.get(url).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: "setAdminSettings",
        value: function setAdminSettings(companyId, profile) {
            var url = "app/rest/v2/company/" + companyId + "/administratorsettings";
            return this.$http.put(url, profile).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: "applyDisplayNameChanges",
        value: function applyDisplayNameChanges(companyId, typeName) {
            var url = "app/rest/v2/company/" + companyId + "/administratorsettings/setdisplaynames";
            var params = { type: typeName };
            return this.$http.post(url, null, { params: params }).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }]);

    return UserSettingsService;
}();

_app.app.service('UserSettingsService', UserSettingsService);

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

userSettings.$inject = ['companyId', 'UserSettingsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-settings', {
        url: '/user-settings',
        resolve: {
            userSettings: userSettings
        },
        views: {
            '@company.user-directories': 'companyUserDirectoriesSaaspassUsersUserSettings'
        }
    });
}

/** @ngInject */
function userSettings(companyId, UserSettingsService) {
    return UserSettingsService.getAdminSettings(companyId);
}

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _blockedUsers = __webpack_require__(632);

_app.app.component('companyUserDirectoriesSaaspassUsersBlockedUsers', {
    bindings: {
        blockedUsers: '<',
        companyId: '<',
        labels: '<',
        numberOfUsers: '<'
    },
    controller: _blockedUsers.Controller,
    templateUrl: __webpack_require__(2229)
});

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1093aa86edb589b0c0d8d6bac3afad3c.html";

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.blocked-users', {
        url: '/blocked-users',
        component: 'companyUserDirectoriesSaaspassUsersBlockedUsers'
    });
}

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenUsers = __webpack_require__(633);

_app.app.component('companyUserDirectoriesSaaspassUsersHardTokenUsers', {
    bindings: {
        hardTokenUsers: '<',
        hardTokens: '<',
        labels: '<',
        numberOfUsers: '<'
    },
    controller: _hardTokenUsers.Controller,
    templateUrl: __webpack_require__(2232)
});

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec2c0fd329e4e1a7744fe0a126c80159.html";

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.hard-token-users', {
        url: '/hard-token-users',
        component: 'companyUserDirectoriesSaaspassUsersHardTokenUsers',
        resolve: {}
    });
}

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _pausedUsers = __webpack_require__(634);

_app.app.component('companyUserDirectoriesSaaspassUsersPausedUsers', {
    bindings: {
        pausedUsers: '<',
        companyId: '<',
        labels: '<',
        numberOfUsers: '<'
    },
    controller: _pausedUsers.Controller,
    templateUrl: __webpack_require__(2235)
});

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7d7a3e0daec455039d76be8a2ee264ec.html";

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.paused-users', {
        url: '/paused-users',
        component: 'companyUserDirectoriesSaaspassUsersPausedUsers'
    });
}

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyUserDirectoriesSaaspassUsersRegularSaaspassAppUsers', {
    bindings: {
        regularUsers: '<',
        labels: '<',
        numberOfUsers: '<'
    },
    templateUrl: __webpack_require__(2238)
});

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a25f1434cbf2e63332f3c284eed07b96.html";

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.regular-saaspass-app-users', {
        url: '/regular-saaspass-app-users',
        component: 'companyUserDirectoriesSaaspassUsersRegularSaaspassAppUsers'
    });
}

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('companyUserDirectoriesSaaspassUsers', {
    templateUrl: __webpack_require__(2241)
});

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c1844525a6919b0fdb8ac1985a03f9c5.html";

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

labels.$inject = ['companyId', 'UserLabelsService'];
blockedUsers.$inject = ['allUsers'];
pausedUsers.$inject = ['allUsers'];
smsUsers.$inject = ['allUsers'];
hardTokenUsers.$inject = ['allUsers'];
regularUsers.$inject = ['allUsers'];
administrators.$inject = ['allUsers'];
hardTokens.$inject = ['HardTokenService'];
allUsers.$inject = ['companyId', 'UsersResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users', {
        url: '/saaspass-users',
        redirectTo: 'company.user-directories.saaspass-users.all-users',
        component: 'companyUserDirectoriesSaaspassUsers',
        resolve: {
            allUsers: allUsers,
            hardTokens: hardTokens,
            administrators: administrators,
            regularUsers: regularUsers,
            hardTokenUsers: hardTokenUsers,
            smsUsers: smsUsers,
            pausedUsers: pausedUsers,
            blockedUsers: blockedUsers,
            labels: labels,
            numberOfUsers: numberOfUsers
        }
    });
}

/** @ngInject */
function allUsers(companyId, UsersResource) {
    return UsersResource.getAllRegularCompanyUsers(companyId, 'all');
}

/** @ngInject */
function hardTokens(HardTokenService) {
    return HardTokenService.list().then(function (items) {
        return items.map(function (item) {
            return _extends({}, item, { blocked: 'NONE' });
        });
    });
}

/** @ngInject */
function blockedUsers(allUsers) {
    return allUsers.filter(function (user) {
        return user.blocked !== 'NONE';
    });
}

/** @ngInject */
function administrators(allUsers) {
    return allUsers.filter(function (user) {
        return user.roleType != 'END_USER';
    });
}

/** @ngInject */
function pausedUsers(allUsers) {
    return allUsers.filter(function (user) {
        return user.blocked == 'NONE' && user.status == 'PAUSED';
    });
}

/** @ngInject */
function regularUsers(allUsers) {
    return allUsers.filter(function (user) {
        return user.userType == 'REGULAR_USER' && user.blocked === 'NONE';
    });
}

/** @ngInject */
function hardTokenUsers(allUsers) {
    return allUsers.filter(function (user) {
        return user.userType == 'HARD_TOKEN_USER';
    });
}

/** @ngInject */
function smsUsers(allUsers) {
    return allUsers.filter(function (user) {
        return user.userType == 'SMS_USER';
    });
}

/** @ngInject */
function labels(companyId, UserLabelsService) {
    return UserLabelsService.getLabels({ companyId: companyId }).$promise;
}

/** @ngInject */
numberOfUsers.$inject = ['allUsers', 'hardTokens', 'administrators', 'regularUsers', 'hardTokenUsers', 'smsUsers', 'blockedUsers', 'pausedUsers'];
function numberOfUsers(allUsers, hardTokens, administrators, regularUsers, hardTokenUsers, smsUsers, blockedUsers, pausedUsers) {
    var administratorsCount = administrators.length;
    var mobileAppUsersCount = regularUsers.length;
    var hardTokenCount = hardTokens.length;
    var smsUsersCount = smsUsers.length;
    var blockedUsersCount = blockedUsers.length;
    var pausedUsersCount = pausedUsers.length;
    var assignedHardTokenCount = hardTokenUsers.length;
    var allUsersCount = allUsers.length + hardTokenCount - assignedHardTokenCount;
    var numberOfUsers = {
        allUsers: allUsersCount,
        administrators: administratorsCount,
        mobileAppUsers: mobileAppUsersCount,
        hardTokenUsers: hardTokenCount,
        smsUsers: smsUsersCount,
        blockedUsers: blockedUsersCount,
        pausedUsers: pausedUsersCount
    };
    return numberOfUsers;
}

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addSmsUser = __webpack_require__(635);

_app.app.component('companyUserDirectoriesSaaspassUsersSmsUsersAdd', {
    bindings: { companyId: '<' },
    controller: _addSmsUser.Controller,
    templateUrl: __webpack_require__(2244)
});

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "89a7f63487a7c76663c04d8766b2d23f.html";

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.sms-users.add', {
        url: '/add',
        views: {
            '@company.user-directories': 'companyUserDirectoriesSaaspassUsersSmsUsersAdd'
        }
    });
}

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsUsers = __webpack_require__(636);

_app.app.component('companyUserDirectoriesSaaspassUsersSmsUsers', {
    bindings: {
        smsUsers: '<',
        labels: '<',
        numberOfUsers: '<'
    },
    controller: _smsUsers.Controller,
    templateUrl: __webpack_require__(2247)
});

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8271d5ccefd4e904a78f4b1c15a7e184.html";

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.sms-users', {
        url: '/sms-users',
        component: 'companyUserDirectoriesSaaspassUsersSmsUsers',
        resolve: {}
    });
}

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addUsersToLabels = __webpack_require__(637);

_app.app.component('companyUserLabelMembersAdd', {
    bindings: {
        users: '<',
        companyId: '<',
        labels: '<'
    },
    controller: _addUsersToLabels.Controller,
    templateUrl: __webpack_require__(2250)
});

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "48d0cde3138d82e4632f0b197c4ec114.html";

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

labels.$inject = ['$stateParams'];
users.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.add-users-to-labels', {
        url: '/copy',
        params: { users: [], labels: [] },
        views: {
            '@company': 'companyUserLabelMembersAdd'
        },
        resolve: {
            users: users, labels: labels
        }
    });
}

/** @ngInject */
function users($stateParams) {
    return $stateParams.users;
}
/** @ngInject */
function labels($stateParams) {
    return $stateParams.labels;
}

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _copyUsersToLabels = __webpack_require__(638);

_app.app.component('companyUserLabelMembersCopy', {
    bindings: {
        users: '<',
        companyId: '<',
        labels: '<',
        userLabelId: '<'
    },
    controller: _copyUsersToLabels.Controller,
    templateUrl: __webpack_require__(2253)
});

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4db2b384c2b6345d3b78d350c68cbb47.html";

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

userLabelId.$inject = ['$stateParams'];
labels.$inject = ['$stateParams'];
users.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels.copy', {
        url: '/copy',
        params: { users: [], labels: [] },
        views: {
            '@company': 'companyUserLabelMembersCopy'
        },
        resolve: {
            users: users, labels: labels, userLabelId: userLabelId
        }
    });
}

/** @ngInject */
function users($stateParams) {
    return $stateParams.users;
}
/** @ngInject */
function labels($stateParams) {
    return $stateParams.labels;
}

function userLabelId($stateParams) {
    return $stateParams.userLabelId;
}

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _createLabel = __webpack_require__(639);

_app.app.component('companyUserLabelNew', {
    bindings: {
        companyId: '<',
        labels: '='
    },
    controller: _createLabel.Controller,
    templateUrl: __webpack_require__(2256)
});

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0350d4156b364dac5d4a185e37a06483.html";

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.new-label', {
        url: '/new-label',
        //params: {users: [],labels:[]},
        views: {
            '@company': 'companyUserLabelNew'
        }
    });
}

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importUsersToLabel = __webpack_require__(640);

_app.app.component('companyUserLabelMembersImport', {
    bindings: {
        companyUsers: '=',
        regCompanyUsers: '<',
        companyId: '<',
        userLabelId: '<',
        labels: '<'
    },
    controller: _importUsersToLabel.Controller,
    templateUrl: __webpack_require__(2259)
});

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75c094156d31d94e29ff3466623a624b.html";

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

labels.$inject = ['$stateParams'];
regCompanyUsers.$inject = ['companyId', 'UsersResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels.import-users-to-label', {
        url: '/import',
        params: { users: [], labels: [] },
        views: {
            '@company': 'companyUserLabelMembersImport'
        },
        resolve: {
            regCompanyUsers: regCompanyUsers,
            labels: labels
        }
    });
}

/** @ngInject */
function regCompanyUsers(companyId, UsersResource) {
    return UsersResource.getAllRegularCompanyUsers(companyId, 'all');
}

/** @ngInject */
function labels($stateParams) {
    return $stateParams.labels;
}

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deleteLabel = __webpack_require__(641);

_app.app.component('companyUserLabelDelete', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _deleteLabel.Controller,
    templateUrl: __webpack_require__(2262)
});

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c32817f90310d49d586ee5a3a1c815c4.html";

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _labelSettings = __webpack_require__(642);

_app.app.component('companyUserLabelSettings', {
    bindings: {
        companyId: '<',
        labels: '<',
        labelGroup: '<',
        userLabelId: '<',
        numberOfUsers: '<'
    },
    controller: _labelSettings.Controller,
    templateUrl: __webpack_require__(2264)
});

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d57d11f5f7be85401772429094f470c6.html";

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels.label-settings', {
        url: '/settings',
        //params: {label},
        views: {
            '@company.user-directories.saaspass-users': 'companyUserLabelSettings'
        }
    });
}

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _moveUsersToLabel = __webpack_require__(643);

_app.app.component('companyUserLabelMembersMove', {
    bindings: {
        users: '<',
        companyId: '<',
        labels: '<',
        userLabelId: '<'
    },
    controller: _moveUsersToLabel.Controller,
    templateUrl: __webpack_require__(2267)
});

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6a5bade6bc65ebb616960bb9bc57e6e8.html";

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

labels.$inject = ['$stateParams'];
users.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels.move', {
        url: '/move',
        params: { users: [], labels: [] },
        views: {
            '@company': 'companyUserLabelMembersMove'
        },
        resolve: {
            users: users,
            labels: labels
        }
    });
}

/** @ngInject */
function users($stateParams) {
    return $stateParams.users;
}

/** @ngInject */
function labels($stateParams) {
    return $stateParams.labels;
}

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _removeUsersFromLabel = __webpack_require__(644);

_app.app.component('companyUserLabelMembersRemove', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _removeUsersFromLabel.Controller,
    templateUrl: __webpack_require__(2270)
});

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b8b86e7bea11d5fc599d520bb74fa18.html";

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _userLabels = __webpack_require__(645);

_app.app.component('companyUserLabels', {
    bindings: {
        companyId: '<',
        labels: '<',
        companyUsers: '<',
        labelGroup: '<',
        numberOfUsers: '<'
    },
    controller: _userLabels.Controller,
    templateUrl: __webpack_require__(2272)
}); /**
    * 
    */

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "52337dc0df91b7f1846dcf1b28c84eb6.html";

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UserLabelsService.$inject = ['$resource'];


_app.app.factory('UserLabelsService', UserLabelsService);

/** @ngInject */
function UserLabelsService($resource) {
	var rootUrl = 'app/rest/v2/company/:companyId/labelgroups';

	return $resource(rootUrl, {
		companyId: '@companyId'
	}, {

		'getLabels': {
			method: 'GET',

			isArray: true
		},
		'getLabelsDefaultsIncluded': {
			url: rootUrl + '?withDefaults=true',
			method: 'GET',
			isArray: true
		},
		'createLabel': {
			method: 'POST',
			isArray: false
		},
		'getLabel': {
			url: rootUrl + '/:labelId',
			method: 'GET',
			isArray: false,
			params: {
				companyId: '@companyId',
				labelId: '@labelId'
			}
		},
		'renameLabel': {
			url: rootUrl + '/:labelId/rename',
			method: 'PUT',
			params: {
				companyId: '@companyId',
				labelId: '@labelId'
			}
		},

		'deleteLabel': {
			url: rootUrl + '/:labelId',
			method: 'Delete',
			params: {
				companyId: '@companyId',
				labelId: '@labelId'
			}
		},
		'getCompanyUsers': {
			url: rootUrl + '/:labelId/users',
			method: 'GET',
			isArray: true,
			params: {
				companyId: '@companyId',
				labelId: '@labelId'
			}

		},
		'addCompanyUsers': {
			url: rootUrl + '/:labelId/users',
			method: 'POST',
			params: {
				companyId: '@companyId',
				labelId: '@labelId'
			}

		},
		'removeCompanyUsers': {
			url: rootUrl + '/:labelId/users?action=remove',
			method: 'POST',
			params: {
				companyId: '@companyId',
				labelId: '@labelId'
			}

		},
		'copyCompanyUsersToLabels': {
			url: rootUrl + '/:labelId/users?action=copy',
			method: 'POST',
			params: {
				companyId: '@companyId',
				labelId: '@labelId'
			}

		},
		'moveCompanyUsersToLabel': {
			url: rootUrl + '/:labelId/users?action=move&to=:toLabelId',
			method: 'POST',
			params: {
				companyId: '@companyId',
				labelId: '@labelId',
				toLabelId: '@toLabelId'
			}

		},
		'addCompanyUsersToLabels': {
			url: rootUrl + '/users',
			method: 'POST',
			params: {
				companyId: '@companyId'
			}

		}

	});
}

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

userLabelId.$inject = ['$stateParams'];
labelGroup.$inject = ['userLabelId', 'UserLabelsService', 'companyId'];
companyUsers.$inject = ['userLabelId', 'UserLabelsService', 'companyId'];
$breadcrumbs.$inject = ['labelGroup'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-labels', {
        url: '/user-label/:userLabelId',
        params: { userLabelId: null },
        component: 'companyUserLabels',
        resolve: {
            $breadcrumbs: $breadcrumbs,
            companyUsers: companyUsers,
            labelGroup: labelGroup,
            userLabelId: userLabelId
        }
    });
}

/** @ngInject */
function $breadcrumbs(labelGroup) {
    var displayName = labelGroup.labelName;
    return [{ stateName: 'company.user-directories.saaspass-users.user-labels' }, { title: displayName ? 'TEAM: ' + displayName : 'TEAM MANAGMENT' }];
}

/** @ngInject */
function companyUsers(userLabelId, UserLabelsService, companyId) {
    //var labelId=userLabel.id;
    //var userLabelId=$stateParams.userLabelId;
    return UserLabelsService.getCompanyUsers({ 'companyId': companyId, 'labelId': userLabelId }).$promise;
}

/** @ngInject */
function labelGroup(userLabelId, UserLabelsService, companyId) {
    //var labelId=userLabel.id;
    //var userLabelId=$stateParams.userLabelId;
    return UserLabelsService.getLabel({ 'companyId': companyId, 'labelId': userLabelId }).$promise;
}

/** @ngInject */
function userLabelId($stateParams) {
    return $stateParams.userLabelId;
}

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('usersSideMenu', {
    bindings: { labels: '<', numberOfUsers: '<' },
    templateUrl: __webpack_require__(2276)
});

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b5b269a33b7efab08511c73b791c6f1f.html";

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _userDirectories = __webpack_require__(646);

_app.app.component('companyUserDirectories', {
    controller: _userDirectories.Controller,
    templateUrl: __webpack_require__(2278)
});

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "47a1b9f2cc6216a4ab3f5592ed3c910b.html";

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories', {
        url: '/user-directories',
        redirectTo: 'company.user-directories.directory-groups',
        component: 'companyUserDirectories'
    });
}

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

var _hardToken = __webpack_require__(195);

var _account = __webpack_require__(48);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UsersResource = function () {
    UsersResource.$inject = ['$http'];

    /** @ngInject */
    function UsersResource($http) {
        _classCallCheck(this, UsersResource);

        this.$http = $http;
    }

    /**
     * @param {string} companyId
     * @param {('roles' | 'all' | 'sms' | 'regular' | 'hardtoken')} type
     */


    _createClass(UsersResource, [{
        key: 'getAllRegularCompanyUsers',
        value: function getAllRegularCompanyUsers(companyId, type) {
            var url = 'app/rest/v2/company/' + companyId + '/users';
            var params = { type: type };
            return this.$http.get(url, { params: params }).then(function (_ref) {
                var data = _ref.data;
                return data;
            });
        }
    }, {
        key: 'getCompanyUserForSaaspassUser',
        value: function getCompanyUserForSaaspassUser(companyId, searchText) {
            var url = 'app/rest/v2/company/' + companyId + '/users';
            var params = { uid: searchText };
            return this.$http.get(url, { params: params }).then(function (_ref2) {
                var data = _ref2.data;
                return data;
            });
        }
    }, {
        key: 'getCompanyUser',
        value: function getCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId;
            return this.$http.get(url).then(function (_ref3) {
                var data = _ref3.data;
                return data;
            });
        }
    }, {
        key: 'deleteCompanyUser',
        value: function deleteCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId;
            return this.$http.delete(url).then(function (_ref4) {
                var data = _ref4.data;
                return data;
            });
        }
    }, {
        key: 'getCompanyUserHardToken',
        value: function getCompanyUserHardToken(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/hardtoken';
            return this.$http.get(url).then(function (_ref5) {
                var data = _ref5.data;
                return new _hardToken.HardToken(data);
            });
        }
    }, {
        key: 'unblockCompanyUser',
        value: function unblockCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId;
            var params = { action: 'unblock' };
            return this.$http.post(url, null, { params: params }).then(function (_ref6) {
                var data = _ref6.data;
                return data;
            });
        }
    }, {
        key: 'pauseCompanyUser',
        value: function pauseCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId;
            var params = { action: 'pause' };
            return this.$http.post(url, null, { params: params }).then(function (_ref7) {
                var data = _ref7.data;
                return data;
            });
        }
    }, {
        key: 'unpauseCompanyUser',
        value: function unpauseCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId;
            var params = { action: 'unpause' };
            return this.$http.post(url, null, { params: params }).then(function (_ref8) {
                var data = _ref8.data;
                return data;
            });
        }
    }, {
        key: 'activateSmsUsageForCompanyUser',
        value: function activateSmsUsageForCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId;
            var params = { action: 'activatesms' };
            return this.$http.post(url, null, { params: params }).then(function (_ref9) {
                var data = _ref9.data;
                return data;
            });
        }
    }, {
        key: 'deactivateSmsUsageForCompanyUser',
        value: function deactivateSmsUsageForCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId;
            var params = { action: 'deactivatesms' };
            return this.$http.post(url, null, { params: params }).then(function (_ref10) {
                var data = _ref10.data;
                return data;
            });
        }
    }, {
        key: 'editDisplayNameOfEmployee',
        value: function editDisplayNameOfEmployee(companyId, companyUserId, displayname) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId;
            var params = { action: 'edit', displayname: displayname };
            return this.$http.post(url, null, { params: params }).then(function (_ref11) {
                var data = _ref11.data;
                return data;
            });
        }
    }, {
        key: 'getAllAccountsForCompanyUser',
        value: function getAllAccountsForCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/accounts';
            return this.$http.get(url).then(function (_ref12) {
                var data = _ref12.data;
                return data;
            });
        }
    }, {
        key: 'getAllDevicesForCompanyUser',
        value: function getAllDevicesForCompanyUser(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/getdevices';
            return this.$http.get(url).then(function (_ref13) {
                var data = _ref13.data;
                return data;
            });
        }
    }, {
        key: 'getAllAccountsDisplayNames',
        value: function getAllAccountsDisplayNames(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/accounts';
            var params = { type: 'displayname' };
            return this.$http.get(url, { params: params }).then(function (_ref14) {
                var data = _ref14.data;
                return data;
            });
        }
    }, {
        key: 'addNewAccountForUser',
        value: function addNewAccountForUser(companyId, companyUser, username) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUser.id + '/accounts';
            var params = { username: username };
            return this.$http.post(url, null, { params: params }).then(function (_ref15) {
                var data = _ref15.data;
                return data;
            }).then(function (account) {
                return (0, _account.accountFromDto)(account, companyUser);
            });
        }
    }, {
        key: 'addHardtokenUserWithAccount',
        value: function addHardtokenUserWithAccount(companyId, companyUser, username) {
            var url = 'app/rest/v2/company/' + companyId + '/users/hardtoken';
            var params = { action: 'activate', username: username };
            return this.$http.post(url, companyUser, { params: params }).then(function (_ref16) {
                var data = _ref16.data;
                return data;
            });
        }
    }, {
        key: 'changeNotificationEmail',
        value: function changeNotificationEmail(companyId, companyUserId, accountId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/accounts/' + accountId;
            var params = { action: 'changemail' };
            return this.$http.get(url, { params: params }).then(function (_ref17) {
                var data = _ref17.data;
                return data;
            });
        }
    }, {
        key: 'getUserSharedServiceAccounts',
        value: function getUserSharedServiceAccounts(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/shared';
            return this.$http.get(url).then(function (_ref18) {
                var data = _ref18.data;
                return data;
            });
        }
    }, {
        key: 'deleteUserSharedServiceAccounts',
        value: function deleteUserSharedServiceAccounts(companyId, companyUserId, selectedAccountsIds) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/shared';
            return this.$http.post(url, selectedAccountsIds).then(function (_ref19) {
                var data = _ref19.data;
                return data;
            });
        }
    }, {
        key: 'getUserSharedNotes',
        value: function getUserSharedNotes(companyId, companyUserId) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/notes';
            return this.$http.get(url).then(function (_ref20) {
                var data = _ref20.data;
                return data;
            });
        }
    }, {
        key: 'deleteUserSharedNotes',
        value: function deleteUserSharedNotes(companyId, companyUserId, selectedNotesIds) {
            var url = 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/notes';
            return this.$http.post(url, selectedNotesIds).then(function (_ref21) {
                var data = _ref21.data;
                return data;
            });
        }
    }, {
        key: 'getUsersBackupOtps',
        value: function getUsersBackupOtps(companyId, companyUserId) {
            var req = {
                method: 'GET',
                url: 'app/rest/v2/company/' + companyId + '/users/' + companyUserId + '/backupcodes'
                //const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/backupcodes`;
            };return this.$http(req).then(function (_ref22) {
                var data = _ref22.data;
                return data;
            });
        }
    }]);

    return UsersResource;
}();

_app.app.service('UsersResource', UsersResource);

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _whatsNewSidemenu = __webpack_require__(647);

_app.app.component('whatsNewSidemenu', {
    controller: _whatsNewSidemenu.Controller,
    templateUrl: __webpack_require__(2282)
});

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cabb1c2bb21cdf80b4af7ea14eb35c68.html";

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _whatsNew = __webpack_require__(648);

_app.app.component('companyWhatsNew', {
    bindings: {
        updateId: '<'
    },
    controller: _whatsNew.Controller,
    templateUrl: __webpack_require__(2307)
});

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./2018-03-04/whats-new.html": 2285,
	"./2018-04-12/whats-new.html": 2286,
	"./2018-04-24/whats-new.html": 2287,
	"./2018-05-23/whats-new.html": 2288,
	"./2018-05-31/whats-new.html": 2289,
	"./2018-07-04/whats-new.html": 2290,
	"./2018-07-19/whats-new.html": 2291,
	"./2018-11-20/whats-new.html": 2292,
	"./2019-04-04/whats-new.html": 2293,
	"./2020-01-21/whats-new.html": 2294,
	"./2020-07-18/whats-new.html": 2295,
	"./2021-06-10/whats-new.html": 2296,
	"./2021-07-26/whats-new.html": 2297,
	"./2021-08-26/whats-new.html": 2298,
	"./2021-12-07/whats-new.html": 2299,
	"./2022-06-03/whats-new.html": 2300,
	"./2022-09-08/whats-new.html": 2301,
	"./2023-01-01/whats-new.html": 2302,
	"./2023-06-14/whats-new.html": 2303,
	"./2024-10-31/whats-new.html": 2304,
	"./2024-12-12/whats-new.html": 2305,
	"./2026-02-04/whats-new.html": 2306
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2284;

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2bfcbdb4d9cf51a554f106ac2aefb9e5.html";

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "894a76f267b1cd31ea91548f02e9abc7.html";

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9d825fba1bb3fc6b4fc53456fbc47926.html";

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0502008854ff5ba28abbe556b9bc90ce.html";

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2c9ae5830bb17c3467601901956b4a55.html";

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d5402fcc701e8640d8a791b167e2ac9f.html";

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "65783120df614e2457c6b05e51e79fa3.html";

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "be5f3a5db85aa84032997be4ae19a466.html";

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "536abee651a9ad28d402dcc79a3629a7.html";

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "310941cda283bb7dd9833a535dc9b595.html";

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b32529671a0c83c64c8224982690d81d.html";

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ef708efb3bb44233140a157d91e87957.html";

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "85b9764054cf9ec7316f65350ee368f0.html";

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7be0bb8c07ee9c0b6816bbb449e4b5b8.html";

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f595a8699c1563187b586d049bce54cf.html";

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "da4c26031ef0b2d500c367049dd721d8.html";

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e5503bd329b95a91b4a3f4f7fe468080.html";

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e26abc033a4fe7c834894c722c217a41.html";

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8c4a458dbd5c9301132504717a392abd.html";

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b3aa128c2c27b55fc8e8795a9c8ecf2a.html";

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9c1b4e245e0e908e4dcae4ecff18d386.html";

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1e6f3cd1404ac760b16f557ab0a388d8.html";

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6b28efdddf4e48ae5835a28a9e4ac2f7.html";

/***/ }),
/* 2308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _updates = __webpack_require__(139);

updateId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.whats-new', {
        url: '/whats-new/:updateId',
        params: { updateId: _updates.updates[0].id },
        component: 'companyWhatsNew',
        resolve: {
            updateId: updateId
        }
    });
}

/** @ngInject */
function updateId($stateParams) {
    return $stateParams.updateId;
}

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _clientSamlLogin = __webpack_require__(649);

_app.app.component('loginSamlClientSso', {
    controller: _clientSamlLogin.Controller,
    templateUrl: __webpack_require__(204)
});

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.login-saml-client-sso', {
        url: '/loginSaml/client/sso/:tracker',
        component: 'loginSamlClientSso'
    });
}

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _clientSsoSaaspassLogin = __webpack_require__(650);

_app.app.component('clientSsoSaaspassLogin', {
    controller: _clientSsoSaaspassLogin.Controller,
    templateUrl: __webpack_require__(651)
});

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.sso-saaspass', {
        url: '/ssosaaspass/:content',
        component: 'clientSsoSaaspassLogin'
    });
}

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.company-created-success', {
        url: '/companyCreated-success',
        templateUrl: __webpack_require__(2315)
    });
}

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d78b077efadcde6e0c849736124cd104.html";

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.company-registration-success', {
        url: '/companyRegistration-success',
        templateUrl: __webpack_require__(2317)
    });
}

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4c6995c191dc4923d47765f3d401e2cc.html";

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _companyRegistration = __webpack_require__(652);

_app.app.component('companyRegistration', {
    templateUrl: __webpack_require__(2319),
    controller: _companyRegistration.Controller
});

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f9a4b53409e2ebadf655de3f44fc8d3d.html";

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

CompanyRegistration.$inject = ['$resource'];


_app.app.factory('CompanyRegistration', CompanyRegistration);

/** @ngInject */
function CompanyRegistration($resource) {
    return $resource('app/rest/companyRegistration', {}, {});
}

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.company-registration', {
        url: '/companyRegistration',
        component: 'companyRegistration'
    });
}

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _contact = __webpack_require__(653);

_app.app.component('contact', {
    controller: _contact.Controller,
    templateUrl: __webpack_require__(2323)
});

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "92f670198287904a8eaaf47c8707e98b.html";

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

ContactService.$inject = ['$resource'];


_app.app.factory('ContactService', ContactService);

/** @ngInject */
function ContactService($resource) {
    return $resource('app/rest/contact', {}, {});
}

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.contact', {
        url: '/contact',
        component: 'contact'
    });
}

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('customError', {
    bindings: { errorMessage: '<' },
    templateUrl: __webpack_require__(2327)
});

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e19bca8dea1da38305f4f350020c4ef7.html";

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

errorMessage.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.custom-error', {
        url: '/custom_error?error_message',
        component: 'customError',
        resolve: { errorMessage: errorMessage }
    });
}

/** @ngInject */
function errorMessage($stateParams) {
    return $stateParams.error_message;
}

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _dataDeletionForm = __webpack_require__(654);

_app.app.component('dataDeletionForm', {
    templateUrl: __webpack_require__(2330),
    controller: _dataDeletionForm.Controller
});

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f4068ba480893c081d76aba03ccaa20.html";

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

DataDeletionFormService.$inject = ['$resource'];


_app.app.factory('DataDeletionFormService', DataDeletionFormService);

/** @ngInject */
function DataDeletionFormService($resource) {
    return $resource('https://www.setlockone.com/sd/app/rest/datadeletion', {});
}

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.data-deletion-form', {
        url: '/data-deletion',
        component: 'dataDeletionForm'
    });
}

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$urlRouterProvider'];


_app.app.config(config);

/** @ngInject */
function config($urlRouterProvider) {
    $urlRouterProvider.otherwise('/login');
}

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.login-with-domain', {
        url: '/login/:domain?code',
        component: 'login'
    });
}

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _extensionAlert = __webpack_require__(655);

_app.app.component('publicExtensionAlert', {
    controller: _extensionAlert.Controller,
    templateUrl: __webpack_require__(2336)
});

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7db00fd3b7455f12289b56f1806f25f4.html";

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.extension-alert', {
        url: '/extensionalert',
        component: 'publicExtensionAlert'
    });
}

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _googleInfo = __webpack_require__(656);

_app.app.component('googleInfo', {
    templateUrl: __webpack_require__(2339),
    controller: _googleInfo.Controller
});

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a9dffbadf80fda754397e1360fdf5d20.html";

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.google-info', {
        url: '/googleInfo',
        component: 'googleInfo'
    });
}

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('googleMarketplaceConfigurationError', {
    bindings: { errorCode: '<' },
    templateUrl: __webpack_require__(2342)
});

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "09ba532a7de53d7a055ec7514deb63f5.html";

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

errorCode.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.error-market', {
        url: '/errorMarket/:domain?error_code',
        component: 'googleMarketplaceConfigurationError',
        resolve: { errorCode: errorCode }
    });
}

/** @ngInject */
function errorCode($stateParams) {
    return $stateParams.error_code;
}

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _googleMarketplaceConfigurationLogin = __webpack_require__(657);

_app.app.component('googleMarketplaceConfigurationLogin', {
    templateUrl: __webpack_require__(2345),
    controller: _googleMarketplaceConfigurationLogin.Controller
});

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "318f7e6b49e92a49300a5d47ac97c3bd.html";

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.gmarket-login', {
        url: '/gmarketlogin/:domain?code&error_code',
        component: 'googleMarketplaceConfigurationLogin'
    });
}

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _googleMarketplaceLogin = __webpack_require__(658);

_app.app.component('googleMarketplaceLogin', {
    bindings: { domain: '<' },
    controller: _googleMarketplaceLogin.Controller
});

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

domain.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.google-marketplace', {
        url: '/googlemarketplace/:domain',
        component: 'googleMarketplaceLogin',
        resolve: { domain: domain }
    });
}

/** @ngInject */
function domain($stateParams) {
    return $stateParams.domain;
}

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _userAgent = __webpack_require__(13);

var _app = __webpack_require__(0);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$scope', '$rootScope', 'AuthenticationSharedService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.controller('HardTokenLoginController', Controller);

/** @ngInject */
function Controller($scope, $rootScope, AuthenticationSharedService) {
    $scope.username = localStorage.getItem('username-hard-token');
    $scope.rememberMe = !!$scope.username;
    var captcha = $scope.captcha = new _captcha.Captcha();
    $scope.login = function () {
        AuthenticationSharedService.login({
            username: $scope.username,
            password: $scope.password,
            oauthClientId: $rootScope.oauthClientId,
            captchaResponse: captcha.response
        }).then(function () {
            if ($scope.rememberMe) {
                localStorage.setItem('username-hard-token', $scope.username);
            }
        }).finally(function () {
            return captcha.reset();
        });
    };

    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem('username-hard-token');
        }
    };

    $scope.newLoginButton = _userAgent.ua.isAndroid() || _userAgent.ua.isIOS();
}

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

HardTokenLoginService.$inject = ['$resource'];


_app.app.factory('HardTokenLoginService', HardTokenLoginService);
/** @ngInject */
function HardTokenLoginService($resource) {
    // hardtoken/u2floginstart POST
    return $resource('app/rest/hardtoken/u2floginstart', {}, {});
}

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.hard-token-login', {
        url: '/hardtokenlogin?client&code&continue&domain&redirect&type',
        templateUrl: __webpack_require__(2352)
    });
}

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee0091c7367d8e5c82b607f756213096.html";

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _captcha = __webpack_require__(18);

var _spAlert = __webpack_require__(4);

var _u2fApi = __webpack_require__(135);

var _yubicoWebauthn = __webpack_require__(72);

Controller.$inject = ['$scope', '$rootScope', '$window', 'HardTokenLoginService', 'AuthenticationSharedService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.controller('U2fLoginController', Controller);

/** @ngInject */
function Controller($scope, $rootScope, $window, HardTokenLoginService, AuthenticationSharedService) {
    $scope.username = localStorage.getItem('username-fido-u2f');
    $scope.rememberMe = !!$scope.username;

    $scope.message = null;

    $scope.showGuide = false;
    $scope.loginU2F = u2fLoginStart;

    var captcha = $scope.captcha = new _captcha.Captcha({
        isVisible: function isVisible() {
            return localStorage.getItem('loginAttempts') >= 3;
        }
    });

    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem('username-fido-u2f');
        }
    };

    function u2fLoginStart() {

        //console.log('u2fLoginStart');

        var data = {
            username: $scope.username,
            oauthClientId: $rootScope.oauthClientId,
            captchaResponse: captcha.response
        };

        HardTokenLoginService.save(null, data, success, error);

        function success(response) {

            if ($scope.rememberMe) {
                localStorage.setItem('username-fido-u2f', $scope.username);
            }

            console.log('HardTokenLoginService.save() done with: ', { response: response });

            $scope.showGuide = true;

            /* u2f.sign(response.authenticateRequests,
             function(data) {
                 console.log(data);
                 if(data.errorCode) {
                     $rootScope.show_quide = true;
                     const key = `hard_token_login.messages.error.ERROR_${data.errorCode}`;
                     $rootScope.topLevelMessage = new SpAlert('danger', key);
                     return;
                 }
                 $rootScope.show_quide = true;
                 u2fLoginFinish(data);     
             }); */
            var credOpts = (0, _yubicoWebauthn.convertStartAuthResponse)(response);
            $window.navigator.credentials.get(credOpts).then(function (credentials) {
                var finishRegRequest = (0, _yubicoWebauthn.convertFinishAuthRequest)(credentials, response);
                $rootScope.show_quide = true;
                u2fLoginFinish(finishRegRequest);
            });

            //$rootScope.topLevelMessage = new SpAlert('success', 'U2F Login started...');
        }

        function error(error) {
            $rootScope.showGuide = false;
            if (error.status == 412) {
                var key = 'registration.company.messages.invalid_captcha';
                $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', key);
            } else {
                $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', error.data.message);
            }
        }
    }

    function u2fLoginFinish(data) {

        AuthenticationSharedService.login({
            username: $scope.username,
            password: JSON.stringify(data),
            oauthClientId: $rootScope.oauthClientId,
            captchaResponse: captcha.response
        }).finally(function () {
            return captcha.reset();
        });
    }
}

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _userAgent = __webpack_require__(13);

var _app = __webpack_require__(0);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$scope', '$rootScope', 'AuthenticationSharedService']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.controller('LoginControllerUsbToken', Controller);

/** @ngInject */
function Controller($scope, $rootScope, AuthenticationSharedService) {
    $scope.username = localStorage.getItem('username-non-fido-usb');
    $scope.rememberMe = !!$scope.username;
    var captcha = $scope.captcha = new _captcha.Captcha();

    $scope.login = function () {

        AuthenticationSharedService.login({
            username: $scope.username,
            password: $scope.pin,
            oauthClientId: $rootScope.oauthClientId,
            captchaResponse: captcha.response
        }).then(function () {
            if ($scope.rememberMe) {
                localStorage.setItem('username-non-fido-usb', $scope.username);
            }
        }).finally(function () {
            return captcha.reset();
        });
    };

    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem('username-non-fido-usb');
        }
    };

    $scope.newLoginButton = _userAgent.ua.isAndroid() || _userAgent.ua.isIOS();
}

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _hardTokenSync = __webpack_require__(659);

_app.app.component('hardTokenSync', {
    templateUrl: __webpack_require__(2356),
    controller: _hardTokenSync.Controller
});

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "658ee05b737d132b340e1d6c915583e8.html";

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

HardTokenSyncService.$inject = ['$resource'];


_app.app.factory('HardTokenSyncService', HardTokenSyncService);

/** @ngInject */
function HardTokenSyncService($resource) {
    // hardtoken/synchronize POST
    // hardtoken/synchronize/{trackerId} GET
    // hardtoken/synchronize/{trackerId} POST
    return $resource('app/rest/hardtoken/synchronize/:trackerId', {
        trackerId: "@trackerId"
    }, {});
}

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.hard-token-sync', {
        url: '/htsync',
        component: 'hardTokenSync'
    });

    $stateProvider.state('public.hard-token-sync-with-tracker', {
        url: '/htsync/:tracker',
        component: 'hardTokenSync'
    });
}

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _login = __webpack_require__(205);

_app.app.component('loginModal', {
    controller: _login.Controller,
    templateUrl: __webpack_require__(2360)
});

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4668baa21d91d38405b27418ccd1c8e5.html";

/***/ }),
/* 2361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.factory('HardTokenLoginModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function () {
        controller.$inject = ['$uibModalInstance'];


        return $uibModal.open({
            templateUrl: __webpack_require__(2363),
            controller: controller,
            controllerAs: 'vm'
        }).result;

        /** @ngInject */
        function controller($uibModalInstance) {
            this.cancel = function () {
                return $uibModalInstance.dismiss();
            };
            this.ok = function () {
                return $uibModalInstance.close();
            };
        }
    };
}

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ef7ae3f5eebc51936c3c24d5dbda71b5.html";

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _userAgent = __webpack_require__(13);

var _app = __webpack_require__(0);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$rootScope', '$scope', '$state', 'SamlLoginHandler']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.controller('HardTokenSamlLoginController', Controller);

/** @ngInject */
function Controller($rootScope, $scope, $state, SamlLoginHandler) {
    var appKey = $state.params.applicationId;
    var rememberMeKey = 'saml-username-' + appKey + '-hard-token';
    $scope.username = localStorage.getItem(rememberMeKey);
    $scope.rememberMe = !!$scope.username;

    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem(rememberMeKey);
        }
    };

    $rootScope.authenticationError = false;

    var captcha = $scope.captcha = new _captcha.Captcha({
        isVisible: function isVisible() {
            return localStorage.getItem('loginAttempts') >= 3;
        }
    });

    $scope.login = function () {
        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        SamlLoginHandler.login($scope.username, $scope.password, false, false, captcha.response, errorCallback);
        if ($scope.rememberMe) {
            localStorage.setItem(rememberMeKey, $scope.username);
        }
    };

    $scope.newLoginButton = _userAgent.ua.isAndroid() || _userAgent.ua.isIOS();

    // error callback function on login
    var errorCallback = function errorCallback(response) {
        var status = response.status;
        if (status == 412) {
            $rootScope.captchaError = true;
            $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
        } else {
            $rootScope.authenticationError = true;
        }
        captcha.reset();
    };
}

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

HardTokenSamlLoginService.$inject = ['$resource'];


_app.app.factory('HardTokenSamlLoginService', HardTokenSamlLoginService);
/** @ngInject */
function HardTokenSamlLoginService($resource) {
    // hardtoken/u2floginstart POST
    return $resource('app/rest/hardtoken/u2fsamlloginstart/:appKey', {
        appKey: '@appKey'
    }, {});
}

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(3);

var angular = _interopRequireWildcard(_angular);

var _app = __webpack_require__(0);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
_app.app.directive('hardTokenTabs', hardTokenTabs);

/** @ngInject */
function hardTokenTabs() {
    return {
        restrict: 'E',
        transclude: true,
        scope: {},
        controller: ['$scope', '$element', function controller($scope, $element) {
            var panes = $scope.panes = [];

            $scope.select = function (pane) {
                angular.forEach(panes, function (pane) {
                    pane.selected = false;
                });
                pane.selected = true;
            };

            this.addPane = function (pane) {
                if (panes.length == 0) $scope.select(pane);
                panes.push(pane);
            };
        }],
        template: '\n            <div class="tabbable">\n                <ul class="nav nav-tabs ht-tabs">\n                    <li ng-repeat="pane in panes"\n                        ng-class="{active:pane.selected}">\n                        <a href="" ng-click="select(pane)">\n                            {{pane.title}}\n                        </a>\n                    </li>\n                </ul>\n                <div class="tab-content" ng-transclude></div>\n            </div>\n        ',
        replace: true
    };
}

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.directive('pane', pane);

/** @ngInject */
function pane() {
    return {
        require: '^hardTokenTabs',
        restrict: 'E',
        transclude: true,
        scope: { title: '@' },
        link: function link(scope, element, attrs, tabsController) {
            tabsController.addPane(scope);
        },
        template: '\n            <div class="tab-pane animated" \n                 ng-class="{active: selected,fadeIn: selected}" \n                 ng-transclude>\n            </div>',
        replace: true
    };
}

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _captcha = __webpack_require__(18);

var _spAlert = __webpack_require__(4);

var _u2fApi = __webpack_require__(135);

var _yubicoWebauthn = __webpack_require__(72);

Controller.$inject = ['$rootScope', '$scope', '$state', '$window', '$timeout', 'HardTokenSamlLoginService', 'UsbSamlLoginHandler']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.controller('U2fSAMLController', Controller);

/** @ngInject */
function Controller($rootScope, $scope, $state, $window, $timeout, HardTokenSamlLoginService, UsbSamlLoginHandler) {
    var appKey = $state.params.applicationId;
    var rememberMeKey = 'saml-username-' + appKey + '-fido-u2f';
    $scope.username = localStorage.getItem(rememberMeKey);
    $scope.rememberMe = !!$scope.username;

    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem(rememberMeKey);
        }
    };

    $rootScope.authenticationError = false;

    var captcha = $scope.captcha = new _captcha.Captcha({
        isVisible: function isVisible() {
            return localStorage.getItem('loginAttempts') >= 3;
        }
    });

    $scope.login = function () {

        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        $rootScope.topLevelMessage = null;

        var data = {
            username: $scope.username,
            captchaResponse: captcha.response
        };

        HardTokenSamlLoginService.save({ appKey: appKey }, data, success, error);

        function success(response) {

            if ($scope.rememberMe) {
                localStorage.setItem(rememberMeKey, $scope.username);
            }

            //$rootScope.topLevelMessage = new SpAlert('success', 'U2F Login started...');
            $timeout(1000).then(function () {

                $rootScope.showGuide = true;
                /*
                u2f.sign(response.authenticateRequests, 
                function(data){
                    
                    console.log(data);
                    if (!data.errorCode) {
                        $rootScope.showGuide = true;
                        u2fLoginFinish(data);
                        return;
                    }
                     $rootScope.showGuide = false;
                    const key = `hard_token_login.messages.error.ERROR_${data.errorCode}`;
                    $rootScope.topLevelMessage = new SpAlert('danger', key);
                }        
                );*/
                var credOpts = (0, _yubicoWebauthn.convertStartAuthResponse)(response);
                $window.navigator.credentials.get(credOpts).then(function (credentials) {
                    var finishRegRequest = (0, _yubicoWebauthn.convertFinishAuthRequest)(credentials, response);
                    $rootScope.showGuide = true;
                    u2fLoginFinish(finishRegRequest);
                });
            });
        }

        function error(error) {
            $rootScope.showGuide = false;
            if (error.status == 412) {
                var key = 'registration.company.messages.invalid_captcha';
                $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', key);
            } else {
                $rootScope.topLevelMessage = new _spAlert.SpAlert('danger', error.data.message);
            }
            captcha.reset();
        }

        function u2fLoginFinish(data) {
            UsbSamlLoginHandler.login($scope.username, JSON.stringify(data), null, errorCallback);
        }
    };

    // error callback function on login
    var errorCallback = function errorCallback(response) {
        var status = response.status;
        if (status == 412) {
            $rootScope.captchaError = true;
            $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
        } else {
            $rootScope.authenticationError = true;
        }
        captcha.reset();
    };
}

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UsbSamlLoginHandler.$inject = ['$rootScope', '$location', '$state', 'SamlService'];


_app.app.factory('UsbSamlLoginHandler', UsbSamlLoginHandler);

/** @ngInject */
function UsbSamlLoginHandler($rootScope, $location, $state, SamlService) {
    return {
        login: function login(username, authenticationRequests, captchaResponse, errorCallback) {
            $rootScope.authenticationError = false;
            var appKey = $state.params.applicationId;
            SamlService.getSPWebSamlDataUsb.get({
                SAMLTracker: $location.search().SAMLTracker,
                appKey: appKey,
                username: username,
                authenticationRequests: authenticationRequests,
                captchaResponse: captchaResponse
            }, function (data) {

                var form = document.createElement("form");
                form.setAttribute('method', "post");

                var i;
                if (null != data.samlResponse) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "SAMLResponse");
                    i.setAttribute('value', data.samlResponse);
                    form.appendChild(i);
                }

                if (null != data.relayState) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "RelayState");
                    i.setAttribute('value', data.relayState);
                    form.appendChild(i);
                }

                if (null != data.wtrealm) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "wresult");
                    i.setAttribute('value', data.wtrealm);
                    form.appendChild(i);
                }

                if (null != data.wctx) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "wctx");
                    i.setAttribute('value', data.wctx);
                    form.appendChild(i);
                }

                if (null != data.wa) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "wa");
                    i.setAttribute('value', data.wa);
                    form.appendChild(i);
                }

                if (null != data.casLt) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "lt");
                    i.setAttribute('value', data.casLt);
                    form.appendChild(i);
                }

                if (null != data.casExecution) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "execution");
                    i.setAttribute('value', data.casExecution);
                    form.appendChild(i);
                }

                if (null != data.casEventId) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "_eventId");
                    i.setAttribute('value', data.casEventId);
                    form.appendChild(i);
                }

                form.setAttribute('action', data.redirectionLink);
                document.body.appendChild(form);

                localStorage.setItem('loginAttempts', 0);

                form.submit();
            }, function (error) {
                var loginAttempts = +localStorage.getItem('loginAttempts') || 0;
                localStorage.setItem('loginAttempts', loginAttempts + 1);
                errorCallback(error);
            });
        }
    };
}

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _userAgent = __webpack_require__(13);

var _app = __webpack_require__(0);

var _captcha = __webpack_require__(18);

Controller.$inject = ['$rootScope', '$scope', '$state', 'SamlLoginHandler']; // ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.

_app.app.controller('UsbTokenSamlLoginController', Controller);

/** @ngInject */
function Controller($rootScope, $scope, $state, SamlLoginHandler) {
    var appKey = $state.params.applicationId;
    var rememberMeKey = 'saml-username-' + appKey + '-non-fido-usb';
    $scope.username = localStorage.getItem(rememberMeKey);
    $scope.rememberMe = !!$scope.username;

    $scope.rememberMeChanged = function () {
        if (!$scope.rememberMe) {
            localStorage.removeItem(rememberMeKey);
        }
    };

    $rootScope.authenticationError = false;

    var captcha = $scope.captcha = new _captcha.Captcha({
        isVisible: function isVisible() {
            return localStorage.getItem('loginAttempts') >= 3;
        }
    });

    $scope.login = function () {
        $rootScope.captchaError = false;
        $rootScope.authenticationError = false;
        SamlLoginHandler.login($scope.username, $scope.password, false, false, captcha.response, errorCallback);
        if ($scope.rememberMe) {
            localStorage.setItem(rememberMeKey, $scope.username);
        }
    };

    $scope.newLoginButton = _userAgent.ua.isAndroid() || _userAgent.ua.isIOS();

    // error callback function on login
    var errorCallback = function errorCallback(response) {
        var status = response.status;
        if (status == 412) {
            $rootScope.captchaError = true;
            $rootScope.captchaErrorMsg = 'login.messages.error.invalid_captcha';
        } else {
            $rootScope.authenticationError = true;
        }
        captcha.reset();
    };
}

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _loginWebSaml = __webpack_require__(660);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.old-login-with-app-id', {
        url: '/oldLogin/:applicationId?appName&appType&icon&SAMLTracker',
        templateUrl: __webpack_require__(661),
        controller: _loginWebSaml.Controller
    });

    $stateProvider.state('public.login-web-saml', {
        url: '/loginWebSAML/:applicationId?appName&appType&icon&SAMLTracker',
        params: {
            loginWithPassword: false
        },
        templateUrl: __webpack_require__(2372),
        controller: _loginWebSaml.Controller
    });
}

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd7372edc66b9f13d387f6e4420ab4ba.html";

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _login = __webpack_require__(205);

_app.app.component('login', {
    controller: _login.Controller,
    templateUrl: __webpack_require__(651)
});

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.login', {
        url: '/login?client&code&continue&domain&redirect&type&ilenabled&plenabled',
        component: 'login'
    });
}

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _logout = __webpack_require__(662);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.logout', {
        url: '/logout',
        template: '',
        controller: _logout.Controller
    });
}

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _pinReset = __webpack_require__(663);

_app.app.component('pinReset', {
    templateUrl: __webpack_require__(2377),
    controller: _pinReset.Controller
});

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f2f38c286a4a14ab17a162d201aeb01.html";

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

PinReset.$inject = ['$resource'];


_app.app.factory('PinReset', PinReset);

/** @ngInject */
function PinReset($resource) {
    return $resource('app/rest/smsGenerateOtp/resetPin', {}, {});
}

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.pin-reset', {
        url: '/pin_reset',
        component: 'pinReset'
    });
}

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _public = __webpack_require__(664);

_app.app.component('public', {
    controller: _public.Controller,
    templateUrl: __webpack_require__(2381)
});

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7aa5d5c5aa742b828b2ae4a6153acd21.html";

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public', {
        abstract: true,
        url: '',
        component: 'public'
    });
}

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _resetPasswordVerify = __webpack_require__(665);

_app.app.component('resetPasswordVerify', {
    bindings: {
        appData: '<',
        rkey: '<',
        appName: '<',
        username: '<'
    },
    controller: _resetPasswordVerify.Controller,
    templateUrl: __webpack_require__(2384)
});

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6aae58047d2097252e05c9d5d51d2d4e.html";

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResetPasswordVerifyService = function () {
    ResetPasswordVerifyService.$inject = ['$http'];

    /** @ngInject */
    function ResetPasswordVerifyService($http) {
        _classCallCheck(this, ResetPasswordVerifyService);

        this.$http = $http;
    }

    _createClass(ResetPasswordVerifyService, [{
        key: 'resetPassword',
        value: function resetPassword(appKey, resetKey, newPassword) {
            return this.$http.get(' app/rest/loginSAMLWeb/resetappaccountpwd/' + appKey + '?rkey=' + resetKey + '&pwd=' + newPassword).then(function (response) {
                return response.data;
            });
        }
    }]);

    return ResetPasswordVerifyService;
}();

_app.app.service('ResetPasswordVerifyService', ResetPasswordVerifyService);

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

autoRedirect.$inject = ['$stateParams'];
username.$inject = ['$stateParams'];
appName.$inject = ['$stateParams'];
rkey.$inject = ['$stateParams'];
appData.$inject = ['$stateParams', 'SamlService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.reset-password-verify', {
        url: '/resetpwd/:appKey?rkey&appName&username&autoRedirect',
        resolve: { appData: appData, rkey: rkey, appName: appName, username: username, autoRedirect: autoRedirect },
        component: 'resetPasswordVerify'
    });
}

/** @ngInject */
function appData($stateParams, SamlService) {
    return SamlService.getAppAccountFormat.get({ appKey: $stateParams.appKey }).$promise;
}

/** @ngInject */
function rkey($stateParams) {
    return $stateParams.rkey;
}
/** @ngInject */
function autoRedirect($stateParams) {
    return $stateParams.autoRedirect;
}
/** @ngInject */
function username($stateParams) {
    return $stateParams.username;
}
/** @ngInject */
function appName($stateParams) {
    return $stateParams.appName;
}

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _resetPassword = __webpack_require__(666);

_app.app.component('resetPassword', {
    bindings: { appData: '<' },
    controller: _resetPassword.Controller,
    templateUrl: __webpack_require__(2388)
});

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cbe64b5d11c15af770fd3d95a8444a1e.html";

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResetPasswordService = function () {
    ResetPasswordService.$inject = ['$http'];

    /** @ngInject */
    function ResetPasswordService($http) {
        _classCallCheck(this, ResetPasswordService);

        this.$http = $http;
    }

    _createClass(ResetPasswordService, [{
        key: 'sendResetEmail',
        value: function sendResetEmail(appKey, username, resetEmail) {
            return this.$http.get('app/rest/loginSAMLWeb/sendresetpwdemail/' + appKey + '?username=' + username + '&reset_pwd_email=' + resetEmail).then(function (response) {
                return response.data;
            });
        }
    }]);

    return ResetPasswordService;
}();

_app.app.service('ResetPasswordService', ResetPasswordService);

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

appData.$inject = ['$stateParams', 'SamlService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.reset-password', {
        url: '/reset-password/:appKey?SAMLTracker&icon',
        params: {
            appName: null,
            appType: null

        },
        resolve: { appData: appData },
        component: 'resetPassword'
    });
}

/** @ngInject */
function appData($stateParams, SamlService) {
    return SamlService.getAppAccountFormat.get({ appKey: $stateParams.appKey }).$promise;
}

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _saaspassConnectLogin = __webpack_require__(667);

_app.app.component('publicSaaspassConnectLogin', {
    templateUrl: __webpack_require__(2392),
    controller: _saaspassConnectLogin.Controller
});

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "48eaa139711897486a30896720a921cf.html";

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.saaspass-connect-login', {
        url: '/saaspassConnectLogin?continue&client&type&ilenabled&plenabled',
        component: 'publicSaaspassConnectLogin'
    });
}

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _samlIdpLogin = __webpack_require__(668);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.login-saml-with-req-link', {
        url: '/loginSAML/:req/:link',
        templateUrl: __webpack_require__(204),
        controller: _samlIdpLogin.Controller
    });
}

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SamlLoginHandler.$inject = ['$rootScope', '$location', '$state', 'SamlService'];


_app.app.factory('SamlLoginHandler', SamlLoginHandler);

/** @ngInject */
function SamlLoginHandler($rootScope, $location, $state, SamlService) {

    return {
        login: function login(username, password, il, pl, captchaResponse, errorCallback) {
            $rootScope.authenticationError = false;
            var appKey = $state.params.applicationId;
            //            if(!il && pl) {
            //            	SamlService.getSPWebSamlData.save({appKey: appKey,captchaResponse : captchaResponse,},{username: username, password:password}, function(data) {
            //            		proccessLoginResponce(data);
            //            		}, function(error) {       
            //                        processLoginError(error,  errorCallback);
            //                    });
            //            	
            //            } else {
            SamlService.getSPWebSamlData.save({
                SAMLTracker: $location.search().SAMLTracker,
                appKey: appKey,
                captchaResponse: captchaResponse,
                il: il,
                pl: pl
            }, { username: username, password: password }, function (data) {
                proccessLoginResponce(data);
            }, function (error) {
                processLoginError(error, errorCallback);
            });
            //};
        },
        passwordLogin: function passwordLogin(username, password, il, pl, captchaResponse, errorCallback) {
            $rootScope.authenticationError = false;
            var appKey = $state.params.applicationId;
            SamlService.getSPWebSamlData.save({
                SAMLTracker: $location.search().SAMLTracker,
                appKey: appKey,
                captchaResponse: captchaResponse,
                il: il,
                pl: pl
            }, { username: username, password: password }, function (data) {

                var form = document.createElement("form");
                form.setAttribute('method', "post");

                var i;
                if (null != data.samlResponse) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "SAMLResponse");
                    i.setAttribute('value', data.samlResponse);
                    form.appendChild(i);
                }

                if (null != data.relayState) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "RelayState");
                    i.setAttribute('value', data.relayState);
                    form.appendChild(i);
                }

                if (null != data.wtrealm) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "wresult");
                    i.setAttribute('value', data.wtrealm);
                    form.appendChild(i);
                }

                if (null != data.wctx) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "wctx");
                    i.setAttribute('value', data.wctx);
                    form.appendChild(i);
                }

                if (null != data.wa) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "wa");
                    i.setAttribute('value', data.wa);
                    form.appendChild(i);
                }

                if (null != data.casLt) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "lt");
                    i.setAttribute('value', data.casLt);
                    form.appendChild(i);
                }

                if (null != data.casExecution) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "execution");
                    i.setAttribute('value', data.casExecution);
                    form.appendChild(i);
                }

                if (null != data.casEventId) {
                    i = document.createElement("input");
                    i.setAttribute('type', "hidden");
                    i.setAttribute('name', "_eventId");
                    i.setAttribute('value', data.casEventId);
                    form.appendChild(i);
                }
                if (data.saaspassPasswordExpired) {
                    form.setAttribute('action', '/resetpwd/' + data.redirectionLink);
                    document.body.appendChild(form);
                } else {
                    form.setAttribute('action', data.redirectionLink);
                    document.body.appendChild(form);
                }
                localStorage.setItem('loginAttempts', 0);
                form.submit();
            }, function (error) {
                var loginAttempts = +localStorage.getItem('loginAttempts') || 0;
                localStorage.setItem('loginAttempts', loginAttempts + 1);
                errorCallback(error);
            });
        }
    };
}

function proccessLoginResponce(data) {

    var form = document.createElement("form");
    form.setAttribute('method', "post");

    var i;
    if (null != data.samlResponse) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "SAMLResponse");
        i.setAttribute('value', data.samlResponse);
        form.appendChild(i);
    }

    if (null != data.relayState) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "RelayState");
        i.setAttribute('value', data.relayState);
        form.appendChild(i);
    }

    if (null != data.wtrealm) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "wresult");
        i.setAttribute('value', data.wtrealm);
        form.appendChild(i);
    }

    if (null != data.wctx) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "wctx");
        i.setAttribute('value', data.wctx);
        form.appendChild(i);
    }

    if (null != data.wa) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "wa");
        i.setAttribute('value', data.wa);
        form.appendChild(i);
    }

    if (null != data.casLt) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "lt");
        i.setAttribute('value', data.casLt);
        form.appendChild(i);
    }

    if (null != data.casExecution) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "execution");
        i.setAttribute('value', data.casExecution);
        form.appendChild(i);
    }

    if (null != data.casEventId) {
        i = document.createElement("input");
        i.setAttribute('type', "hidden");
        i.setAttribute('name', "_eventId");
        i.setAttribute('value', data.casEventId);
        form.appendChild(i);
    }

    if (data.saaspassPasswordExpired) {
        $state.go('public.reset-password-verify', { appKey: appKey, rkey: data.redirectionLink, appName: $state.params.appName, username: username, autoRedirect: 'page' });
    } else {
        form.setAttribute('action', data.redirectionLink);
        document.body.appendChild(form);
    }
    localStorage.setItem('loginAttempts', 0);
    form.submit();
}

function processLoginError(error, errorCallback) {
    var loginAttempts = +localStorage.getItem('loginAttempts') || 0;
    localStorage.setItem('loginAttempts', loginAttempts + 1);
    errorCallback(error);
}

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _samlLogin = __webpack_require__(669);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.login-saml-with-app-id', {
        url: '/loginSAML/:applicationId',
        templateUrl: __webpack_require__(204),
        controller: _samlLogin.Controller
    });

    $stateProvider.state('public.old-login', {
        url: '/oldLogin',
        templateUrl: __webpack_require__(661),
        controller: _samlLogin.Controller
    });
}

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _samlLogout = __webpack_require__(670);

_app.app.component('samlLogout', {
    templateUrl: __webpack_require__(2398),
    controller: _samlLogout.Controller
});

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c50c8b083a9f8935bf6caee4284e6b0e.html";

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.logout-saml', {
        url: '/logoutSAML',
        component: 'samlLogout'
    });
}

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SamlService.$inject = ['$resource'];


_app.app.factory('SamlService', SamlService);

/** @ngInject */
function SamlService($resource) {

    var getSPWebSamlData = $resource('app/rest/loginSAMLWeb/:appKey', {
        SAMLTracker: '@SAMLTracker',
        appKey: '@appKey',
        il: '@il',
        pl: '@pl'
    }, {}); //body format: {username, password}	

    var getSPWebSamlDataUsb = $resource('app/rest/loginSAMLWeb/usb/:appKey', {
        SAMLTracker: '@SAMLTracker',
        appKey: '@appKey',
        username: '@username',
        authenticationRequests: '@authenticationRequests'
    }, {});

    var getSPSamlData = $resource('app/rest/loginSAML/:appKey', {
        SAMLTracker: '@SAMLTracker',
        appKey: '@appKey'
    }, {});

    var getSamlLoginUrl = $resource('app/rest/loginSAML', {
        applicationId: '@applicationId',
        accountId: '@accountId',
        awsrole: '@awsrole'
    }, {});

    var getIDPSamlLoginUrl = $resource('app/rest/loginSAML/idp/:req/:link', {
        req: '@req',
        link: '@link'
    }, {});

    var getAppAccountFormat = $resource('app/rest/application/logindetails/:appKey', {
        content: '@appKey'
    }, {});

    return {
        getSPSamlData: getSPSamlData,
        getSamlLoginUrl: getSamlLoginUrl,
        getIDPSamlLoginUrl: getIDPSamlLoginUrl,
        getSPWebSamlData: getSPWebSamlData,
        getAppAccountFormat: getAppAccountFormat,
        getSPWebSamlDataUsb: getSPWebSamlDataUsb
    };
}

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('sessionExpired', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2402)
});

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b31c70fa937bc845e4fc45a17bdc5041.html";

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sessionExpired = __webpack_require__(671);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.session-expired', {
        url: '/sessionExpired',
        controller: _sessionExpired.Controller
    });
}

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Service = function () {
    Service.$inject = ['$http'];

    /** @ngInject */
    function Service($http) {
        _classCallCheck(this, Service);

        this.$http = $http;
    }

    _createClass(Service, [{
        key: 'getSmsGatewayList',
        value: function getSmsGatewayList(mobilePhoneNumber) {
            return this.$http.get('app/rest/smsotp/smsgateways/' + mobilePhoneNumber).then(function (response) {
                return response.data;
            });
        }
    }]);

    return Service;
}();

_app.app.service('SmsGatewaysService', Service);

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsUserOtp = __webpack_require__(672);

_app.app.component('smsUserOtp', {
    templateUrl: __webpack_require__(2406),
    controller: _smsUserOtp.Controller
});

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "681d1435fde00c004a96c0ee93425152.html";

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SmsUserOtp.$inject = ['$resource'];


_app.app.factory('SmsUserOtp', SmsUserOtp);

/** @ngInject */
function SmsUserOtp($resource) {
    return $resource('app/rest/smsGenerateOtp/:id', {}, {});
}

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.sms-user-otp', {
        url: '/smsuserotp?client&code&continue&domain&redirect&type',
        component: 'smsUserOtp',
        params: {
            showResetPinSuccessMessage: false
        }
    });
}

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SmsUserActivationCodeGeneration.$inject = ['$resource'];


_app.app.factory('SmsUserActivationCodeGeneration', SmsUserActivationCodeGeneration);

/** @ngInject */
function SmsUserActivationCodeGeneration($resource) {
    return $resource('app/rest/smsUserActivationCodeGeneration', {}, {});
}

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _smsUserRegistration = __webpack_require__(673);

_app.app.component('smsUserRegistration', {
    templateUrl: __webpack_require__(2411),
    controller: _smsUserRegistration.Controller
});

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e7f3b2b3d9531247ab1523db6a7b5d09.html";

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SmsUserRegistration.$inject = ['$resource'];


_app.app.factory('SmsUserRegistration', SmsUserRegistration);

/** @ngInject */
function SmsUserRegistration($resource) {
    return $resource('app/rest/smsUserRegistration', {}, {});
}

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.sms-user-registration', {
        url: '/smsuser_registration',
        component: 'smsUserRegistration'
    });
}

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.directive('spCredentialCheck', spCredentialCheck);

/** @ngInject */
function spCredentialCheck() {
    return {
        require: 'ngModel',
        link: function link(scope, element, attributes, ngModelCtrl) {
            var firstCredential = '#' + attributes.spCredentialCheck;
            element.on('keyup', function () {
                var matched = element.val() === $(firstCredential).val();
                if (!matched) {
                    scope.notMatched = true;
                } else {
                    scope.notMatched = false;
                }
                ngModelCtrl.$setValidity('#' + element, matched);
                scope.$apply();
            });
        }
    };
}

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('subscriptionError', {
    bindings: {},
    templateUrl: __webpack_require__(2416)
});

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c16cb1b670aa7b56bb0854489d5ca4e1.html";

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.subscription-error', {
        url: '/subscription_error',
        component: 'subscriptionError',
        resolve: {}
    });
}

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('subscriptionSuccess', {
    bindings: { errorMessage: '<' },
    templateUrl: __webpack_require__(2419)
});

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "72bf973c9679f986d0cb415a70eee30c.html";

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.subscription-success', {
        url: '/subscription_success',
        component: 'subscriptionSuccess',
        resolve: {}
    });
}

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _companyVerification = __webpack_require__(674);

_app.app.component('companyVerification', {
    controller: _companyVerification.Controller,
    templateUrl: __webpack_require__(2422)
});

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7c229f0940571a68442a15ee3c37c1c8.html";

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.company-verification', {
        url: '/companyVerification?vkey',
        component: 'companyVerification'
    });
}

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _emailVerification = __webpack_require__(675);

_app.app.component('emailVerification', {
    controller: _emailVerification.Controller,
    templateUrl: __webpack_require__(2425)
});

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "136a554c90585959ed9265552a59d84d.html";

/***/ }),
/* 2426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

EmailVerificationDataService.$inject = ['$resource'];


_app.app.factory('EmailVerificationDataService', EmailVerificationDataService);

/** @ngInject */
function EmailVerificationDataService($resource) {
    return $resource('app/rest/emailverificationdata', {}, {});
}

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.email-verification', {
        url: '/verification?vkey',
        component: 'emailVerification'
    });
}

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _fidoRegistration = __webpack_require__(676);

_app.app.component('fidoRegistration', {
   bindings: { vkey: '<' },
   controller: _fidoRegistration.Controller,
   templateUrl: __webpack_require__(2430)
});

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c7812b0891379a8c8ed31fbc3df2ecc5.html";

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

FidoRegistrationDataService.$inject = ['$resource'];


_app.app.factory('FidoRegistrationDataService', FidoRegistrationDataService);

/** @ngInject */
function FidoRegistrationDataService($resource) {
    var url = 'app/rest/userFidoRegistration';
    return $resource(url, {}, {
        'getData': {
            method: 'GET',
            url: url + '?vkey=:vKey',
            params: {
                vKey: '@vKey'
            }
        },
        'startRegistration': {
            method: 'POST',
            url: url + '/:hardTokenId/start?vkey=:vKey',
            params: {
                hardTokenId: '@hardTokenId',
                vKey: '@vKey'
            }
        },
        'finishRegistration': {
            method: 'POST',
            url: url + '/:hardTokenId/finish',
            params: {
                hardTokenId: '@hardTokenId'
            }
        }

    });
}

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

vkey.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.fido-registration', {
        url: '/fidoRegistration?vkey',
        component: 'fidoRegistration',
        resolve: {
            vkey: vkey
        }
    });
}

/** @ngInject */
function vkey($stateParams) {
    return $stateParams.vkey;
}

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _slackVerification = __webpack_require__(677);

_app.app.component('slackVerification', {
    controller: _slackVerification.Controller,
    templateUrl: __webpack_require__(2434)
});

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "46d6757d0745def977c616e087fb6ec1.html";

/***/ }),
/* 2435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SlackVerificationDataService.$inject = ['$resource'];


_app.app.factory('SlackVerificationDataService', SlackVerificationDataService);

/** @ngInject */
function SlackVerificationDataService($resource) {
    return $resource('app/rest/slackverificationdata', {}, {});
}

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.slack-verification', {
        url: '/slackverification?vkey',
        component: 'slackVerification'
    });
}

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$urlRouterProvider'];


_app.app.config(config);

/** @ngInject */
function config($urlRouterProvider) {
    $urlRouterProvider.when('/logoutSAML/', '/logoutSAML');
}

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _accountConfig = __webpack_require__(678);

_app.app.component('accountConfig', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _accountConfig.Controller,
    templateUrl: __webpack_require__(2440)
});

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "088039651cfdcb6e944ce51aba42ef80.html";

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('AccountConfigModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_applicationId, _accountId) {
        config.$inject = ['AccountConfigService'];


        return $uibModal.open({
            component: 'accountConfig',
            resolve: {
                applicationId: function applicationId() {
                    return _applicationId;
                },
                accountId: function accountId() {
                    return _accountId;
                },
                config: config
            }
        }).result;

        /** @ngInject */
        function config(AccountConfigService) {
            return AccountConfigService.get(_applicationId, _accountId);
        }
    };
}

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountConfigService = function () {
    AccountConfigService.$inject = ['$http'];

    /** @ngInject */
    function AccountConfigService($http) {
        _classCallCheck(this, AccountConfigService);

        this.$http = $http;
    }

    _createClass(AccountConfigService, [{
        key: 'get',
        value: function get(applicationId, accountId) {
            return this.$http.get('app/rest/accountConfig/' + applicationId + '/' + accountId).then(function (response) {
                return response.data;
            });
        }
    }, {
        key: 'save',
        value: function save(applicationId, accountId, config) {
            return this.$http.post('app/rest/accountConfig/' + applicationId + '/' + accountId, config).then(function (response) {
                return response.data;
            });
        }
    }]);

    return AccountConfigService;
}();

_app.app.service('AccountConfigService', AccountConfigService);

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _accountPasswordUpdate = __webpack_require__(679);

_app.app.component('accountPasswordUpdate', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _accountPasswordUpdate.Controller,
    templateUrl: __webpack_require__(2444)
});

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0b55d19771aaac350dd7d584002745c0.html";

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

AccountPasswordUpdate.$inject = ['$resource'];


_app.app.factory('AccountPasswordUpdate', AccountPasswordUpdate);

/** @ngInject */
function AccountPasswordUpdate($resource) {
    return $resource('app/rest/accountConfig/updatePassword/', {});
}

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _applications = __webpack_require__(680);

_app.app.component('userApplications', {
    bindings: {
        account: '<',
        applications: '<'
    },
    controller: _applications.Controller,
    templateUrl: __webpack_require__(2448)
});

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "038cc0058ccd12e4362849ec0864999c.gif";

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a3eabd49420f81aed23fe54a5bffd4af.html";

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

ApplicationService.$inject = ['$resource', 'url'];


_app.app.constant('url', 'app/rest/applicationNonBlocked/:id');

_app.app.factory('ApplicationService', ApplicationService);

/** @ngInject */
function ApplicationService($resource, url) {

    return $resource(url, {}, {
        'findAll': {
            method: 'GET',
            isArray: true
        }
    });
}

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

applications.$inject = ['ApplicationService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.applications', {
        url: '/applications',
        views: {
            '': 'userApplications',
            'header@user': 'userApplicationsHeader'
        },
        resolve: { applications: applications }
    });
}

/** @ngInject */
function applications(ApplicationService) {
    return ApplicationService.findAll().$promise;
}

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _header = __webpack_require__(681);

_app.app.component('userApplicationsHeader', {
    bindings: { account: '<' },
    controller: _header.Controller,
    templateUrl: __webpack_require__(2452)
});

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9df0e55dee1e8f36feadd13e3cb688bb.html";

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _loginRoleSelect = __webpack_require__(682);

_app.app.component('loginRoleSelect', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _loginRoleSelect.Controller,
    templateUrl: __webpack_require__(2454)
});

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5b43bf6d082f3aa670c5b886b59df9dd.html";

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

modal.$inject = ['$uibModal'];


_app.app.service('LoginRoleSelectModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (applicationId, accountId) {
        roles.$inject = ['LoginRolesService'];

        return $uibModal.open({
            component: 'loginRoleSelect',
            resolve: { roles: roles }
        }).result;

        /** @ngInject */
        function roles(LoginRolesService) {
            return LoginRolesService.query(applicationId, accountId);
        }
    };
}

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Service = function () {
    Service.$inject = ['$http'];

    /** @ngInject */
    function Service($http) {
        _classCallCheck(this, Service);

        this.$http = $http;
    }

    _createClass(Service, [{
        key: 'query',
        value: function query(applicationId, accountId) {
            return this.$http.get('app/rest/loginroles/' + applicationId + '/account/' + accountId).then(function (response) {
                return response.data;
            });
        }
    }]);

    return Service;
}();

_app.app.service('LoginRolesService', Service);

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _userAgent = __webpack_require__(13);

var _app = __webpack_require__(0);

SharedEpmFactory.$inject = ['EpmAccountResource', '$q'];


_app.app.factory('SharedEpmFactory', SharedEpmFactory);

/** @ngInject */
function SharedEpmFactory(EpmAccountResource, $q) {
    var epmsSSO = function epmsSSO(sharedAccount) {
        var defered = $q.defer();

        if (sharedAccount.ssoSupported) {
            var id = sharedAccount.applicationId;
            var accountId = sharedAccount.companyUserAccountId;

            if (document.getElementById("saaspass-extension-info")) {
                EpmAccountResource.getEpmTracker(id, accountId).then(function (tracker) {
                    return window.postMessage({ action: "loginWithTracker", tracker: tracker, newTab: true }, "*");
                });
                return;
            }

            var hasExtensionInstalled201 = document.getElementById('extension-is-installed-v2.0.1') != null;
            var hasExtensionInstalled210 = document.getElementById('extension-is-installed-v2.1.0') != null;

            if (hasExtensionInstalled201) {
                EpmAccountResource.getEpmTracker(id, accountId).then(function (data) {
                    return { tracker: data, epm: true };
                }).then(function (data) {

                    if (_userAgent.ua.isChrome() || _userAgent.ua.isOpera()) {

                        var extensionId = _userAgent.ua.isChrome() ? window.env.extensionIds.chrome : window.env.extensionIds.opera;

                        chrome.runtime.sendMessage(extensionId, {
                            data: data,
                            message: "loginAuthenticator"
                        }, function (response) {
                            if (!response) {
                                console.log("Error extension");
                                alert("The SAASPASS Extension in not installed or disabled.");
                            } else {
                                console.log("Message sent to extension id: " + window.env.extensionIds.chrome);
                            }
                        });
                    } else if (_userAgent.ua.isSafari() || _userAgent.ua.isFirefox()) {

                        window.postMessage({
                            instructions: data,
                            message: "loginAuthenticator"
                        }, "*");
                    }
                    defered.resolve(data);
                });
            } else if (hasExtensionInstalled210) {

                // new implementation for Chrome, Firefox and Opera is tracker based
                EpmAccountResource.getEpmTracker(id, accountId).then(function (data) {
                    return { tracker: data, epm: true };
                }).then(function (data) {

                    if (_userAgent.ua.isFirefox()) {

                        // Firefox does not support externally_connectable Manifest key
                        window.postMessage({
                            direction: "from-page-script",
                            message: data
                        }, "*");
                    } else {
                        var extensionId = _userAgent.ua.isChrome() ? window.env.extensionIds.chrome : window.env.extensionIds.opera;

                        chrome.runtime.sendMessage(extensionId, {
                            data: data,
                            message: "loginWithTracker"
                        }, function (response) {
                            if (!response) {
                                console.log("SAASPASS extension not responding.");
                                alert("The SAASPASS Extension in not installed or disabled.");
                            } else {
                                console.log("Message sent to extension with id: " + extensionId);
                            }
                        });
                    }

                    defered.resolve(data);
                });
            } else {

                console.error('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + _userAgent.browser.name + '.');
                alert('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + _userAgent.browser.name + '.');
            }
        } else {
            window.location = sharedAccount.publicService.serviceUrl;
            defered.resolve("");
        }
        return defered.promise;
    };

    return {
        epmsSSO: epmsSSO
    };
}

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _connectors = __webpack_require__(683);

_app.app.component('userConnectors', {
    bindings: {
        account: '<',
        connectors: '<'
    },
    controller: _connectors.Controller,
    templateUrl: __webpack_require__(2459)
});

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9e0baf2043eb88f626a0ae261a8c17a4.html";

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

Connector.$inject = ['$resource'];


_app.app.factory('Connector', Connector);

/** @ngInject */
function Connector($resource) {
    return $resource('app/rest/connectors/:id', {}, {
        'query': {
            method: 'GET',
            isArray: true
        },
        'get': {
            method: 'GET'
        }
    });
}

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

connectors.$inject = ['Connector'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.connectors', {
        url: '/connectors',
        component: 'userConnectors',
        resolve: { connectors: connectors }
    });
}

/** @ngInject */
function connectors(Connector) {
    return Connector.query().$promise;
}

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _deviceManagement = __webpack_require__(684);

_app.app.component('userDevices', {
    bindings: {
        account: '<',
        devices: '<'
    },
    controller: _deviceManagement.Controller,
    templateUrl: __webpack_require__(2463)
});

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0cc18f53635480b4dd35cbf24cf7da7f.html";

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

DeviceManagement.$inject = ['$resource'];


_app.app.factory('DeviceManagement', DeviceManagement);

/** @ngInject */
function DeviceManagement($resource) {
    return $resource('app/rest/device_management/:id', {}, {
        'query': {
            method: 'GET',
            isArray: true
        },
        'get': {
            method: 'GET'
        },
        'generateCloneCode': {
            method: 'GET',
            url: 'app/rest/device_management/clonecode'
        }
    });
}

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

devices.$inject = ['DeviceManagement'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.device-management', {
        url: '/device_management',
        component: 'userDevices',
        resolve: { devices: devices }
    });
}

/** @ngInject */
function devices(DeviceManagement) {
    return DeviceManagement.get().$promise;
}

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _add = __webpack_require__(685);

_app.app.component('addUserEmail', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _add.Controller,
    templateUrl: __webpack_require__(2467)
});

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "efa625f7cbc27354dfd6d0d3d9a46416.html";

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _emails = __webpack_require__(686);

_app.app.component('userEmails', {
    bindings: {
        account: '<',
        emails: '<'
    },
    controller: _emails.Controller,
    templateUrl: __webpack_require__(2469)
});

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8c11f8823c9a01511154a4f529792553.html";

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UserEmailsService.$inject = ['$resource'];


_app.app.factory('UserEmailsService', UserEmailsService);

/** @ngInject */
function UserEmailsService($resource) {
    return $resource('app/rest/emails/:id', {
        id: '@id'
    }, {
        'getActiveEmails': {
            method: 'GET',
            url: 'app/rest/emails?status=active',
            isArray: true
        }
    });
}

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

emails.$inject = ['UserEmailsService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.emails', {
        url: '/emails',
        component: 'userEmails',
        resolve: { emails: emails }
    });
}

/** @ngInject */
function emails(UserEmailsService) {
    return UserEmailsService.query().$promise;
}

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('userHeader', {
    templateUrl: __webpack_require__(2473)
});

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bf232938653692fbc0476fda549b63b0.html";

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addNote = __webpack_require__(687);

_app.app.component('userPublicNotesAdd', {
    controller: _addNote.Controller,
    templateUrl: __webpack_require__(2475)
});

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5f4a3ae71c5474a7ea656eb23b89e771.html";

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.notes.add', {
        url: '/add',
        views: {
            '@user': 'userPublicNotesAdd'
        }
    });
}

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editNote = __webpack_require__(688);

_app.app.component('userPublicNotesEdit', {
	bindings: {
		note: '<',
		notes: '<'
	},
	controller: _editNote.Controller,
	templateUrl: __webpack_require__(2478)
});

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "08b1253f693870ea4e66a571d2bf3461.html";

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

noteId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.public.notes.edit', {
        url: '/:noteId/edit',
        resolve: {
            noteId: noteId,
            note: note
        },
        views: {
            '@user': 'userPublicNotesEdit'
        }
    });
}

/** @ngInject */
function noteId($stateParams) {
    return $stateParams.noteId;
}

/** @ngInject */
note.$inject = ['noteId', 'notes'];
function note(noteId, notes) {
    var note = notes.find(function (note) {
        return note.id === noteId;
    });
    return notes.find(function (note) {
        return note.id === noteId;
    });
}

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _notes = __webpack_require__(689);

_app.app.component('userPublicNotes', {
    bindings: { notes: '<' },
    controller: _notes.Controller,
    templateUrl: __webpack_require__(2481)
});

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "78ad8e60362ac1dcf02044a3e2793fc9.html";

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UserNotesService.$inject = ['$resource'];


_app.app.factory('UserNotesService', UserNotesService);

/** @ngInject */
function UserNotesService($resource) {
    return $resource('app/rest/notes/:id', {
        id: '@id'
    }, {
        'query': {
            method: 'GET',
            isArray: true
        },
        'get': {
            method: 'GET'
        }
    });
}

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

notes.$inject = ['$filter', 'UserNotesService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.notes', {
        url: '/notes',
        views: {
            '': 'userPublicNotes',
            'header@user': 'userPublicUserAccountsHeader'
        },
        resolve: { notes: notes }
    });
}

/** @ngInject */
function notes($filter, UserNotesService) {
    return UserNotesService.query().$promise.then(function (items) {
        return $filter('orderBy')(items, '-updatedOn');
    });
}

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addPhoneNumber = __webpack_require__(690);

_app.app.component('addPhoneNumber', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _addPhoneNumber.Controller,
    templateUrl: __webpack_require__(2485)
});

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "380ae9c0b354e825e139d6e2df642fcc.html";

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

onEnter.$inject = ['$state', '$uibModal'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.mobile-numbers.add', {
        url: '/add',
        onEnter: onEnter
    });
}

/** @ngInject */
function onEnter($state, $uibModal) {
    $uibModal.open({ component: 'addPhoneNumber' }).result.then(function () {
        return $state.go('^.list', {}, { reload: '^' });
    }).catch(function () {
        return $state.go('^.list');
    });
}

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('confirmRemoveRecovery', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2488)
});

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "af8656993f27a0bd608d9aab07fca37f.html";

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('confirmTurnOffRecovery', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2490)
});

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c6f45ccd336b9a74cf0eb15315c58817.html";

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('confirmUpdateRecovery', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2492)
});

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8515416b312d36dfa231c6e65cd273ff.html";

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

NewSmsNumber.$inject = ['$resource'];


_app.app.factory('NewSmsNumber', NewSmsNumber);

/** @ngInject */
function NewSmsNumber($resource) {
    return $resource('app/rest/phonenumbers/:id/setSmsNumber', {}, {});
}

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _phoneNumberList = __webpack_require__(691);

_app.app.component('userPhoneNumberList', {
    bindings: {
        account: '<',
        phoneNumbers: '<'
    },
    controller: _phoneNumberList.Controller,
    templateUrl: __webpack_require__(2496)
});

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "02ba1b8ea55f488e2ea1420806b6d268.html";

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e730c5c0392cca97acfd9a86f7979913.html";

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.mobile-numbers.list', {
        url: '',
        component: 'userPhoneNumberList'
    });
}

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SmsNumberGenerateCode.$inject = ['$resource'];


_app.app.factory('SmsNumberGenerateCode', SmsNumberGenerateCode);

/** @ngInject */
function SmsNumberGenerateCode($resource) {
    return $resource('app/rest/phonenumbers/:id/generateCode', {}, {});
}

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

SmsNumber.$inject = ['$resource'];


_app.app.factory('SmsNumber', SmsNumber);

/** @ngInject */
function SmsNumber($resource) {
    return $resource('app/rest/phonenumbers/:id/checkPin', {}, {});
}

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _phoneNumbers = __webpack_require__(692);

_app.app.component('userPhoneNumbers', {
    bindings: { account: '<' },
    controller: _phoneNumbers.Controller,
    templateUrl: __webpack_require__(2501)
});

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b607c02beb8e28e88433ecf2c30b3dee.html";

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

phoneNumbers.$inject = ['UserPhoneNumber'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.mobile-numbers', {
        url: '/mobilenumbers',
        redirectTo: 'user.mobile-numbers.list',
        component: 'userPhoneNumbers',
        resolve: { phoneNumbers: phoneNumbers }
    });
}

/** @ngInject */
function phoneNumbers(UserPhoneNumber) {
    return UserPhoneNumber.query().$promise;
}

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _recoveryReminder = __webpack_require__(693);

_app.app.component('recoveryReminder', {
    controller: _recoveryReminder.Controller,
    templateUrl: __webpack_require__(2506)
});

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc14adbfba337b601610135c8d941efd.html";

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "60115250eda00f7c3efbca12020cd0f2.html";

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "65e7eae050655913df59aa72c38f316a.html";

/***/ }),
/* 2507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _recoverySettings = __webpack_require__(694);

_app.app.component('recoverySettings', {
    bindings: {
        phoneNumbers: '<',
        recoverySettingsData: '<'
    },
    controller: _recoverySettings.Controller,
    templateUrl: __webpack_require__(2509)
});

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "863dc5f8af6548d065bb3c2f6e3b4586.html";

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

RecoverySettingsService.$inject = ['$resource'];


_app.app.factory('RecoverySettingsService', RecoverySettingsService);

/** @ngInject */
function RecoverySettingsService($resource) {
    var updateSettings = $resource('app/rest/recovery/update_recovery', {}, {});
    var removeRecovery = $resource('app/rest/recovery/remove_recovery', {}, {});
    var turnOffRecovery = $resource('app/rest/recovery/turn_off', {}, {});
    var changeRecoveryReminder = $resource('app/rest/recovery/change_recovery_reminder', {}, {});
    var setRecoveryNumber = $resource('app/rest/recovery/userPhoneNumber/:phoneNumberId/setRecoveryNumber', {
        phoneNumberId: '@phoneNumberId'
    }, {});

    return {
        updateSettings: updateSettings,
        removeRecovery: removeRecovery,
        turnOffRecovery: turnOffRecovery,
        changeRecoveryReminder: changeRecoveryReminder,
        setRecoveryNumber: setRecoveryNumber
    };
}

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

recoverySettingsData.$inject = ['DestructiveOperationModal'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.mobile-numbers.recovery-settings', {
        url: '/recovery-settings',
        component: 'recoverySettings',
        resolve: { recoverySettingsData: recoverySettingsData }
    });
}

/** @ngInject */
function recoverySettingsData(DestructiveOperationModal) {
    return DestructiveOperationModal({
        textKey: 'destructive_operation.enter_onetime_password_text',
        http: { method: 'GET', url: 'app/rest/recovery' }
    });
}

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _verify = __webpack_require__(695);

_app.app.component('verifyPhoneNumber', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _verify.Controller,
    templateUrl: __webpack_require__(2513)
});

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "40ea8c91379a10c1869c21479a90109f.html";

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _add = __webpack_require__(696);

_app.app.component('addProfile', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _add.Controller,
    templateUrl: __webpack_require__(2515)
});

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fc3fe238eaa9f87ade8e37425f3ad338.html";

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

activeEmails.$inject = ['UserEmailsService'];
modal.$inject = ['$uibModal'];


_app.app.service('AddProfileModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function () {
        return $uibModal.open({
            component: 'addProfile',
            resolve: { activeEmails: activeEmails }
        }).result;
    };
}

/** @ngInject */
function activeEmails(UserEmailsService) {
    return UserEmailsService.getActiveEmails().$promise;
}

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('profilesInfo', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2518)
});

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "65a57e432612c9fc4cf2e775bfe0ca00.html";

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _basic = __webpack_require__(699);

_app.app.component('userProfileBasic', {
    bindings: { profile: '<' },
    controller: _basic.Controller,
    templateUrl: __webpack_require__(2520)
});

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8e300b15cd48908aeaebb00ea1ad10d9.html";

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles.profile.basic', {
        url: '/basic',
        component: 'userProfileBasic'
    });
}

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _edit = __webpack_require__(700);

_app.app.component('editProfileBasic', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _edit.Controller,
    templateUrl: __webpack_require__(2523)
});

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7ef472c9b2d42e81f2cb63961b0e1bb4.html";

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

maritalStates.$inject = ['$http'];
genders.$inject = ['$http'];
modal.$inject = ['$uibModal'];


_app.app.service('EditProfileBasicModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_profile) {
        return $uibModal.open({
            component: 'editProfileBasic',
            resolve: {
                genders: genders,
                maritalStates: maritalStates,
                profile: function profile() {
                    return _profile;
                }
            }
        }).result;
    };
}

/** @ngInject */
function genders($http) {
    return $http.get('app/rest/genders').then(function (response) {
        return response.data;
    });
}

/** @ngInject */
function maritalStates($http) {
    return $http.get('app/rest/maritalstatuses').then(function (response) {
        return response.data;
    });
}

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _edit = __webpack_require__(701);

_app.app.component('editExtendedProfile', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _edit.Controller,
    templateUrl: __webpack_require__(2526)
});

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3fbaae3dd56e919b474181adad144f87.html";

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

phoneNumbers.$inject = ['UserPhoneNumber'];
modal.$inject = ['$uibModal'];


_app.app.service('EditProfileExtendedModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_profile) {
        return $uibModal.open({
            component: 'editExtendedProfile',
            resolve: {
                phoneNumbers: phoneNumbers,
                profile: function profile() {
                    return _profile;
                }
            }
        }).result;
    };
}

/** @ngInject */
function phoneNumbers(UserPhoneNumber) {
    return UserPhoneNumber.query().$promise;
}

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _extended = __webpack_require__(702);

_app.app.component('userProfileExtended', {
    bindings: { profile: '<' },
    controller: _extended.Controller,
    templateUrl: __webpack_require__(2529)
});

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b363f72b068f41843c15b53ef894c6a.html";

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles.profile.extended', {
        url: '/extended',
        component: 'userProfileExtended'
    });
}

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _delete = __webpack_require__(703);

_app.app.component('deleteProfile', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _delete.Controller,
    templateUrl: __webpack_require__(2532)
});

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eb4a09f7c3d1eb46d00e5e5bd48f4091.html";

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _edit = __webpack_require__(704);

_app.app.component('editMainProfile', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _edit.Controller,
    templateUrl: __webpack_require__(2534)
});

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fc3fe238eaa9f87ade8e37425f3ad338.html";

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

activeEmails.$inject = ['UserEmailsService'];
modal.$inject = ['$uibModal'];


_app.app.service('EditProfileMainModal', modal);

/** @ngInject */
function modal($uibModal) {

    return function (_profile) {
        return $uibModal.open({
            component: 'editMainProfile',
            resolve: {
                activeEmails: activeEmails,
                profile: function profile() {
                    return _profile;
                }
            }
        }).result;
    };
}

/** @ngInject */
function activeEmails(UserEmailsService) {
    return UserEmailsService.getActiveEmails().$promise;
}

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _main = __webpack_require__(705);

_app.app.component('userProfileMain', {
    bindings: {
        profile: '<',
        profiles: '<'
    },
    controller: _main.Controller,
    templateUrl: __webpack_require__(2537)
});

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8dda39e2e090df5bf28dc6b53f6f7e66.html";

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles.profile.main', {
        url: '/main',
        component: 'userProfileMain'
    });
}

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('userProfile', {
    bindings: { profile: '<' },
    templateUrl: __webpack_require__(2540)
});

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ff9258f34237b2118fc18c4434f0b61d.html";

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

profile.$inject = ['$stateParams', 'profiles'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles.profile', {
        url: '/:profileId',
        redirectTo: 'user.profiles.profile.main',
        component: 'userProfile',
        resolve: { profile: profile }
    });
}

/** @ngInject */
function profile($stateParams, profiles) {
    return profiles.find(function (profile) {
        return profile.id === $stateParams.profileId;
    });
}

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _profiles = __webpack_require__(706);

_app.app.component('userProfiles', {
    bindings: { account: '<', profiles: '<' },
    controller: _profiles.Controller,
    templateUrl: __webpack_require__(2543)
});

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8aacd0c2f291fbeaf3cf64f38fd789dc.html";

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

RegistrationProfile.$inject = ['$resource'];


_app.app.factory('RegistrationProfile', RegistrationProfile);

/** @ngInject */
function RegistrationProfile($resource) {
    return $resource('app/rest/registrationprofiles/:id', {}, {
        'copyProfile': {
            method: 'POST',
            url: 'app/rest/registrationprofiles/copy?id=:id',
            params: {
                id: '@id'
            }
        },
        'updateProfile': {
            method: 'PUT'
        },
        'getProfilePhoto': {
            method: 'GET',
            url: 'app/rest/registrationprofiles/:id/profilephoto',
            params: {
                id: '@id'
            }
        },
        'importFacebookProfile': {
            method: 'POST',
            url: 'app/rest/registrationprofiles/import'
        },
        'setDefault': {
            method: 'POST',
            url: 'app/rest/registrationprofiles/:id/setdefault',
            isArray: true,
            params: {
                id: '@id'
            }
        }
    });
}

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

profiles.$inject = ['RegistrationProfile'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.profiles', {
        url: '/profiles',
        component: 'userProfiles',
        resolve: { profiles: profiles }
    });
}

/** @ngInject */
function profiles(RegistrationProfile) {
    return RegistrationProfile.query().$promise;
}

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('socialProfilesInfo', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2547)
});

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "94f9066b0601019b64ddaae2600c7035.html";

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _addPublicUserAccount = __webpack_require__(707);

_app.app.component('publicUserAccountsAdd', {
    bindings: {
        publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<',
        copyAccount: '<',
        type: '<'
    },
    controller: _addPublicUserAccount.Controller,
    templateUrl: __webpack_require__(2549)
});

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bd272354bd3741c31c8b9a2877482e96.html";

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

type.$inject = ['$stateParams'];
copyAccount.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.public.user-accounts.add', {
        url: '/add/:type',
        params: { copyAccount: null },
        views: {
            '@user': 'publicUserAccountsAdd'
        },
        resolve: {
            copyAccount: copyAccount,
            type: type
        }
    });
}

/** @ngInject */
function copyAccount($stateParams) {
    return $stateParams.copyAccount;
}

/** @ngInject */
function type($stateParams) {
    return $stateParams.type;
}

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _userAgent = __webpack_require__(13);

var _app = __webpack_require__(0);

SsoFactory.$inject = ['Authenticator', '$q'];
ExtentionManaging.$inject = ['$window'];
Authenticator.$inject = ['$resource'];


_app.app.factory('Authenticator', Authenticator);

/** @ngInject */
function Authenticator($resource) {
    return $resource('app/rest/authenticators/:id', {
        id: '@id'
    }, {
        'query': {
            method: 'GET',
            isArray: true
        },
        'get': {
            method: 'GET'
        },
        'getInstructions': {
            method: 'GET',
            url: 'app/rest/authenticators/:id/instructions',
            params: {
                id: '@id'
            }
        },
        'getTracker': {
            method: 'GET',
            url: 'app/rest/authenticators/tracker/:id',
            isArray: false,
            params: {
                id: '@id'
            },
            transformResponse: function transformResponse(data, headers) {
                return { tracker: data };
            }
        },
        'create': {
            method: 'POST',
            url: 'app/rest/authenticators/:publicServiceId',
            params: {
                publicServiceId: '@publicServiceId'
            }
        },
        'edit': {
            method: 'PUT',
            url: 'app/rest/authenticators/:publicServiceId',
            params: {
                publicServiceId: '@publicServiceId'
            }
        },
        'exportAll': {
            method: 'GET',
            url: 'app/rest/authenticators/export/csv'
        },
        'uploadCustomIcon': {
            method: 'POST',
            url: 'app/rest/authenticators/:publicUserAccountId/photo',
            params: {
                publicUserAccountId: '@publicUserAccountId'
            },
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined
            }
        },
        'deleteCustomIcon': {
            method: 'DELETE',
            url: 'app/rest/authenticators/:publicUserAccountId/photo',
            params: {
                publicUserAccountId: '@publicUserAccountId'
            }
        }
    });
}

_app.app.factory('ExtentionManaging', ExtentionManaging);

/** @ngInject */
function ExtentionManaging($window) {

    function installExtension() {

        if (_userAgent.ua.isChrome()) {

            var installUrl = 'https://chrome.google.com/webstore/detail/' + window.env.extensionIds.chrome;
            $window.open(installUrl, '_blank');
        } else if (_userAgent.ua.isOpera()) {

            var installUrl = 'https://addons.opera.com/en/extensions/details/saaspass-single-sign-on/';
            $window.open(installUrl, '_blank');
        } else if (_userAgent.ua.isSafari()) {

            var installUrl = 'https://www.saaspass.com/assets/Extensions/SAASPASS.safariextz';
            $window.open(installUrl, '_blank');
        } else if (_userAgent.ua.isFirefox()) {

            var installUrl = 'https://addons.mozilla.org/en-US/firefox/addon/saaspass-single-sign-on/';
            $window.open(installUrl, '_blank');
        } else {
            console.warn('The SAASPASS Extension in not supported in ' + _userAgent.browser.name + '.');
        }
    }

    return {
        installExtension: installExtension
    };
}

_app.app.factory('SsoFactory', SsoFactory);

/** @ngInject */
function SsoFactory(Authenticator, $q) {
    var authenticatorsSSO = function authenticatorsSSO(authenticator) {
        var defered = $q.defer();

        if (authenticator.publicService.ssoSupported) {
            if (authenticator.ssoEnabled) {
                var id = authenticator.id;

                if (document.getElementById("saaspass-extension-info")) {
                    Authenticator.getTracker({ id: id }, function (_ref) {
                        var tracker = _ref.tracker;
                        return window.postMessage({ action: "loginWithTracker", tracker: tracker, newTab: true }, "*");
                    });
                    return;
                }

                var hasExtensionInstalled201 = document.getElementById('extension-is-installed-v2.0.1') != null;
                var hasExtensionInstalled210 = document.getElementById('extension-is-installed-v2.1.0') != null;

                if (hasExtensionInstalled201) {
                    Authenticator.getInstructions({
                        id: id
                    }, function (data) {
                        delete data["$promise"];
                        delete data["$resolved"];

                        if (_userAgent.ua.isChrome() || _userAgent.ua.isOpera()) {

                            var extensionId = _userAgent.ua.isChrome() ? window.env.extensionIds.chrome : window.env.extensionIds.opera;

                            chrome.runtime.sendMessage(extensionId, {
                                data: data,
                                message: "loginAuthenticator"
                            }, function (response) {
                                if (!response) {
                                    console.log("Error extension");
                                    alert("The SAASPASS Extension in not installed or disabled.");
                                } else {
                                    console.log("Message sent to extension id: " + window.env.extensionIds.chrome);
                                }
                            });
                        } else if (_userAgent.ua.isSafari() || _userAgent.ua.isFirefox()) {

                            window.postMessage({
                                instructions: data,
                                message: "loginAuthenticator"
                            }, "*");
                        }

                        defered.resolve(data);
                    });
                } else if (hasExtensionInstalled210) {

                    // new implementation for Chrome, Firefox and Opera is tracker based
                    Authenticator.getTracker({
                        id: id
                    }, function (data) {
                        // console.log(data);
                        delete data["$promise"];
                        delete data["$resolved"];

                        if (_userAgent.ua.isFirefox()) {

                            // Firefox does not support externally_connectable Manifest key
                            window.postMessage({
                                direction: "from-page-script",
                                message: data
                            }, "*");
                        } else {

                            var extensionId = _userAgent.ua.isChrome() ? window.env.extensionIds.chrome : window.env.extensionIds.opera;

                            chrome.runtime.sendMessage(extensionId, {
                                data: data,
                                message: "loginWithTracker"
                            }, function (response) {
                                if (!response) {
                                    console.log("SAASPASS extension not responding.");
                                    alert("The SAASPASS Extension in not installed or disabled.");
                                } else {
                                    console.log("Message sent to extension with id: " + extensionId);
                                }
                            });
                        }
                        defered.resolve(data);
                    });
                } else {
                    console.warn('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + _userAgent.browser.name + '.');
                    alert('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + _userAgent.browser.name + '.');
                }
            }
        } else {
            var isCustom = (authenticator.publicService || {}).slug === 'other';
            var customUrlRequired = !!(authenticator.publicService || {}).urlRequired;
            var serviceUrl = (authenticator.publicService || {}).serviceUrl;
            var customUrl = (authenticator.customLoginUrl || {}).serviceLoginUrl;
            var location = isCustom || customUrlRequired ? customUrl : serviceUrl;
            window.open(location, '_blank');
            defered.resolve("");
        }
        return defered.promise;
    };

    return {
        authenticatorsSSO: authenticatorsSSO
    };
}

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('userPasswordManagerConfirmRemove', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2553)
});

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "475139604486ee564ec6f33db1a55161.html";

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _editPublicUserAccount = __webpack_require__(708);

_app.app.component('publicUserAccountsEdit', {
    bindings: {
        publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<',
        publicUserAccount: '<',
        publicUserAccounts: '<'
    },
    controller: _editPublicUserAccount.Controller,
    templateUrl: __webpack_require__(2555)
});

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6be1ed642c7d945e951ecf92f999bf2a.html";

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

publicUserAccount.$inject = ['publicUserAccountId', 'publicUserAccounts'];
publicUserAccountId.$inject = ['$stateParams'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.public.user-accounts.edit', {
        url: '/:publicUserAccountId/edit',
        params: { publicUserAccount: {} },
        resolve: {
            publicUserAccountId: publicUserAccountId,
            publicUserAccount: publicUserAccount
        },
        views: {
            '@user': 'publicUserAccountsEdit'
        }
    });
}

/** @ngInject */
function publicUserAccountId($stateParams) {
    return $stateParams.publicUserAccountId;
}

/** @ngInject */
function publicUserAccount(publicUserAccountId, publicUserAccounts) {
    return publicUserAccounts.find(function (account) {
        return account.id === publicUserAccountId;
    });
}

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _header = __webpack_require__(709);

_app.app.component('userPublicUserAccountsHeader', {
    bindings: { account: '<' },
    controller: _header.Controller,
    templateUrl: __webpack_require__(2558)
});

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9df0e55dee1e8f36feadd13e3cb688bb.html";

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _importResult = __webpack_require__(710);

_app.app.component('userPasswordManagerImportResult', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    controller: _importResult.Controller,
    templateUrl: __webpack_require__(2560)
});

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fe96918a1e50b49142c93f448bd8cac9.html";

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

onEnter.$inject = ['$state', '$uibModal'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.public.user-accounts.import.result', {
        url: '/result',
        params: { importResult: null },
        onEnter: onEnter
    });
}

/** @ngInject */
function onEnter($state, $uibModal) {
    $uibModal.open({ component: 'userPasswordManagerImportResult' }).result.catch(function () {
        return $state.go('user.public.user-accounts', {}, { reload: true });
    });
}

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _import = __webpack_require__(711);

_app.app.component('userPasswordManagerImport', {
    bindings: {
        account: '<',
        importFileTypes: '<'
    },
    controller: _import.Controller,
    templateUrl: __webpack_require__(2563)
});

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8f1cf456f4d0e608ed69a9920081aef4.html";

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

importFileTypes.$inject = ['PasswordManagers'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.user-accounts.import', {
        url: '/import',
        views: {
            '@user': 'userPasswordManagerImport'
        },
        resolve: { importFileTypes: importFileTypes }
    });
}

/** @ngInject */
function importFileTypes(PasswordManagers) {
    return PasswordManagers.getImportFileTypes();
}

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

PasswordManagers.$inject = ['$http'];


_app.app.service('PasswordManagers', PasswordManagers);

/** @ngInject */
function PasswordManagers($http) {

    return {
        list: list,
        remove: remove,
        importItems: importItems,
        getImportFileTypes: getImportFileTypes,
        getPassword: getPassword,
        getOtp: getOtp,
        getCorporateOtp: getCorporateOtp,
        getCorporatePassword: getCorporatePassword
    };

    function list() {
        return $http.get('app/rest/loginitems').then(function (response) {
            return response.data;
        });
    }

    function remove(id) {
        return $http.delete('app/rest/loginitems/' + id).then(function (response) {
            return response.data;
        });
    }

    function importItems(fileType, file, successAction, errorAction) {
        var fd = new FormData();
        fd.append('file', file);

        var uploadUrl = "app/rest/loginitems/import?fileType=:fileType".replace(":fileType", fileType);

        $http.post(uploadUrl, fd, {
            transformRequest: angular.identity,
            headers: {
                'Content-Type': undefined
            }
        }).then(function (response) {
            return successAction(response.data);
        }).catch(function (response) {
            return errorAction(response.data, response.status);
        });
    }
    function getImportFileTypes() {
        return $http.get('app/rest/loginitems/import').then(function (response) {
            return response.data;
        });
    }
    function getPassword(id) {
        return $http.get('app/rest/loginitems/' + id + '/PASSWORD').then(function (response) {
            return response.data;
        });
    }
    function getOtp(id) {
        return $http.get('app/rest/authenticators/' + id + '/OTP').then(function (response) {
            return response.data;
        });
    }
    function getCorporatePassword(id) {
        return $http.get('app/rest/corporateServices/' + id + '/ALL').then(function (response) {
            return response.data;
        });
    }
    function getCorporateOtp(id) {
        return $http.get('app/rest/corporateServices/' + id + '/OTP').then(function (response) {
            return response.data;
        });
    }
}

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _publicUserAccounts = __webpack_require__(712);

_app.app.component('userPublicUserAccounts', {
    bindings: {
        account: '<',
        passwordManagers: '<',
        authenticators: '<',
        publicUserAccounts: '<',
        publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<'
    },
    controller: _publicUserAccounts.Controller,
    templateUrl: __webpack_require__(2567)
});

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cb2245454a9085df8c28fc3c43ec07a7.html";

/***/ }),
/* 2568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

passwordManagers.$inject = ['$filter', 'PasswordManagers'];
authenticators.$inject = ['$filter', 'Authenticator'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.user-accounts', {
        url: '/user-accounts',
        views: {
            '': 'userPublicUserAccounts',
            'header@user': 'userPublicUserAccountsHeader'
        },
        resolve: { authenticators: authenticators, passwordManagers: passwordManagers, publicUserAccounts: publicUserAccounts }
    });
}

/** @ngInject */
function authenticators($filter, Authenticator) {
    return Authenticator.query().$promise.then(function (items) {
        return $filter('orderBy')(items, 'publicService.serviceName');
    }).then(function (items) {
        return items.map(function (item) {
            return _extends({}, item, { serviceDisplayName: serviceDisplayName(item) });
        });
    });
}

function serviceDisplayName(authenticator) {
    var displayName = '';
    if (authenticator.customAuthenticator) {
        displayName = authenticator.customAuthenticator.customAuthenticatorName;
    } else {
        displayName = authenticator.publicService.serviceName;
    }
    return displayName;
}

/** @ngInject */
function passwordManagers($filter, PasswordManagers) {
    return PasswordManagers.list().then(function (items) {
        return $filter('orderBy')(items, 'publicService.serviceName');
    }).then(function (items) {
        return items.map(function (item) {
            return _extends({}, item, { serviceDisplayName: serviceDisplayName(item) });
        });
    });
}

/** @ngInject */
publicUserAccounts.$inject = ['passwordManagers', 'authenticators'];
function publicUserAccounts(passwordManagers, authenticators) {
    var publicUserAccounts = [];
    Array.prototype.push.apply(publicUserAccounts, authenticators);
    Array.prototype.push.apply(publicUserAccounts, passwordManagers);
    return publicUserAccounts;
}

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('userPublic', {
    templateUrl: __webpack_require__(2571)
});

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3e2d4c791425cfac60a6e5410b2d0c2f.html";

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public', {
        url: '/public',
        redirectTo: 'user.public.user-accounts',
        views: {
            '': 'userPublic'
        }

    });
}

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _sharePublicUserAccount = __webpack_require__(713);

_app.app.component('sharePublicUserAccounts', {
    bindings: {
        account: '<',
        passwordManagers: '<',
        authenticators: '<',
        companies: '<'
    },
    controller: _sharePublicUserAccount.Controller,
    templateUrl: __webpack_require__(2574)
});

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "528757aae4e1b225f27a279aa10d9716.html";

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

companies.$inject = ['$stateParams', 'UsersSharedAccountService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.public.user-accounts.share', {
        url: '/shareaccounts',
        params: { companies: companies },
        views: {
            '@user': 'sharePublicUserAccounts'
        },
        resolve: { companies: companies }
    });
}

/** @ngInject */
function companies($stateParams, UsersSharedAccountService) {
    if (!$stateParams.companies) {
        var coms = UsersSharedAccountService.usersCompanySharedAccounts.getCompaniesToShareWith().$promise;
        return coms;
    }
    return $stateParams.companies;
}

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _statistics = __webpack_require__(714);

_app.app.component('userStatistics', {
    bindings: {
        account: '<',
        logs: '<'
    },
    controller: _statistics.Controller,
    templateUrl: __webpack_require__(2577)
});

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "76a8fcf9deab298c59edd92f6ce5bee5.html";

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

logs.$inject = ['StatisticsResource'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.statistics', {
        url: '/statistics',
        component: 'userStatistics',
        resolve: { logs: logs }
    });
}

/** @ngInject */
function logs(StatisticsResource) {
    return StatisticsResource.getUserOtpStatistics().then(function (_ref) {
        var logs = _ref.logs;
        return logs;
    });
}

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _user = __webpack_require__(715);

_app.app.component('user', {
    bindings: {
        account: '<',
        publicServicesWithSso$: '<',
        publicServicesWithSsoAnd2FA$: '<'
    },
    controller: _user.Controller,
    templateUrl: __webpack_require__(2580)
});

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "964bca1c0bfa0013c4d2c62a103cb76e.html";

/***/ }),
/* 2581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _lazyLoad = __webpack_require__(71);

publicServicesWithSsoAnd2FA$.$inject = ['$filter', 'PublicServices'];
publicServicesWithSso$.$inject = ['$filter', 'PublicServices'];
prefetch.$inject = ['publicServicesWithSso$', 'publicServicesWithSsoAnd2FA$'];
account.$inject = ['Account'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user', {
        url: '',
        redirectTo: 'user.public.user-accounts',
        resolve: { account: account, prefetch: prefetch, publicServicesWithSso$: publicServicesWithSso$, publicServicesWithSsoAnd2FA$: publicServicesWithSsoAnd2FA$ },
        views: {
            '': 'user',
            'header@user': 'userHeader'
        }
    });
}

/** @ngInject */
function account(Account) {
    return Account.get();
}

/** @ngInject */
function prefetch(publicServicesWithSso$, publicServicesWithSsoAnd2FA$) {
    publicServicesWithSso$.get();
    publicServicesWithSsoAnd2FA$.get();
}

/** @ngInject */
function publicServicesWithSso$($filter, PublicServices) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return PublicServices.getAllPublicServicesThatSupportSSOFiltered();
    }).map(function (items) {
        var custom = items.find(function (i) {
            return i.slug === 'other';
        });
        custom.serviceName = 'Custom';
        return items;
    }).map(function (items) {
        return $filter('orderBy')(items, 'serviceName');
    });
}

/** @ngInject */
function publicServicesWithSsoAnd2FA$($filter, PublicServices) {
    return (0, _lazyLoad.lazyLoad)(function () {
        return PublicServices.getAllPublicServicesThatSupportSSOAnd2FAFiltered();
    }).map(function (items) {
        var custom = items.find(function (i) {
            return i.slug === 'other';
        });
        custom.serviceName = 'Custom';
        return items;
    }).map(function (items) {
        return $filter('orderBy')(items, 'serviceName');
    });
}

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _header = __webpack_require__(716);

_app.app.component('userSharedAccountsHeader', {
    bindings: { account: '<' },
    controller: _header.Controller,
    templateUrl: __webpack_require__(2584)
});

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9df0e55dee1e8f36feadd13e3cb688bb.html";

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _userAgent = __webpack_require__(13);

var _app = __webpack_require__(0);

SharedSsoFactory.$inject = ['UsersSharedAccountService', '$q'];


_app.app.factory('SharedSsoFactory', SharedSsoFactory);

/** @ngInject */
function SharedSsoFactory(UsersSharedAccountService, $q) {
    var authenticatorsSSO = function authenticatorsSSO(sharedAccount) {
        var defered = $q.defer();

        if (sharedAccount.publicService.ssoSupported) {
            var id = sharedAccount.id;

            if (document.getElementById("saaspass-extension-info")) {
                UsersSharedAccountService.userSharedAccountSSO.getTracker({ id: id }, function (_ref) {
                    var tracker = _ref.tracker;
                    return window.postMessage({ action: "loginWithTracker", isShared: true, tracker: tracker, newTab: true }, "*");
                });
                return;
            }

            var hasExtensionInstalled201 = document.getElementById('extension-is-installed-v2.0.1') != null;
            var hasExtensionInstalled210 = document.getElementById('extension-is-installed-v2.1.0') != null;

            if (hasExtensionInstalled201) {
                UsersSharedAccountService.userSharedAccountSSO.get({
                    id: id
                }, function (data) {
                    delete data["$promise"];
                    delete data["$resolved"];

                    if (_userAgent.ua.isChrome() || _userAgent.ua.isOpera()) {

                        var extensionId = _userAgent.ua.isChrome() ? window.env.extensionIds.chrome : window.env.extensionIds.opera;

                        chrome.runtime.sendMessage(extensionId, {
                            data: data,
                            message: "loginAuthenticator"
                        }, function (response) {
                            if (!response) {
                                console.log("Error extension");
                                alert("The SAASPASS Extension in not installed or disabled.");
                            } else {
                                console.log("Message sent to extension id: " + window.env.extensionIds.chrome);
                            }
                        });
                    } else if (_userAgent.ua.isSafari() || _userAgent.ua.isFirefox()) {

                        window.postMessage({
                            instructions: data,
                            message: "loginAuthenticator"
                        }, "*");
                    }

                    defered.resolve(data);
                });
            } else if (hasExtensionInstalled210) {

                // new implementation for Chrome, Firefox and Opera is tracker based
                UsersSharedAccountService.userSharedAccountSSO.getTracker({
                    id: id
                }, function (data) {
                    // console.log(data);
                    delete data["$promise"];
                    delete data["$resolved"];

                    if (_userAgent.ua.isFirefox()) {

                        // Firefox does not support externally_connectable Manifest key
                        window.postMessage({
                            direction: "from-page-script",
                            message: data
                        }, "*");
                    } else {
                        var extensionId = _userAgent.ua.isChrome() ? window.env.extensionIds.chrome : window.env.extensionIds.opera;

                        chrome.runtime.sendMessage(extensionId, {
                            data: data,
                            message: "loginWithTracker"
                        }, function (response) {
                            if (!response) {
                                console.log("SAASPASS extension not responding.");
                                alert("The SAASPASS Extension in not installed or disabled.");
                            } else {
                                console.log("Message sent to extension with id: " + extensionId);
                            }
                        });
                    }

                    defered.resolve(data);
                });
            } else {

                console.error('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + _userAgent.browser.name + '.');
                alert('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + _userAgent.browser.name + '.');
            }
        } else {
            window.location = sharedAccount.publicService.serviceUrl;
            defered.resolve("");
        }
        return defered.promise;
    };

    return {
        authenticatorsSSO: authenticatorsSSO
    };
}

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _usersSharedAccounts = __webpack_require__(717);

_app.app.component('userSharedAccounts', {
    bindings: {
        account: '<',
        applications: '<',
        allAccounts: '<',
        sharedAccounts: '<',
        companies: '<'
    },
    controller: _usersSharedAccounts.Controller,
    templateUrl: __webpack_require__(2588)
});

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "038cc0058ccd12e4362849ec0864999c.gif";

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "408e99626e30dda336973576519a7cd8.html";

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

UsersSharedAccountService.$inject = ['$resource'];


_app.app.factory('UsersSharedAccountService', UsersSharedAccountService);

/** @ngInject */
function UsersSharedAccountService($resource) {
    var rootUrl = 'app/rest/corporateServices';
    return {
        usersSharedNotes: $resource('app/rest/shared_notes', {}, {
            'getUsersSharedNotes': {
                method: 'GET',
                isArray: true
            }
        }),
        usersCompanySharedAccounts: $resource(rootUrl, {}, {

            'getCompaniesToShareWith': {
                method: 'GET',
                url: rootUrl + '/companies?canShare=true',
                isArray: true
            },
            'shareAccountsWithCompany': {
                method: 'POST',
                url: rootUrl + '/companies/:companyId?showOtp=:showOtp&showPassword=:showPass',
                params: {
                    companyId: '@companyId',
                    showOtp: '@showOtp',
                    showPass: '@showPass'

                }
            }
        }),
        userSharedAccountSSO: $resource(rootUrl + '/:id', {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'getTracker': {
                method: 'GET',
                url: 'app/rest/corporateServices/tracker/:id',
                isArray: false,
                params: {
                    id: '@id'
                },
                transformResponse: function transformResponse(data, headers) {
                    return {
                        tracker: data,
                        shared: true
                    };
                }
            }
        })
    };
}

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _app = __webpack_require__(0);

allAccounts.$inject = ['applications', 'sharedAccounts'];
companies.$inject = ['UsersSharedAccountService'];
sharedAccounts.$inject = ['$filter', 'UsersSharedAccountService'];
applications.$inject = ['ApplicationService'];
config.$inject = ['$stateProvider'];

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.shared-accounts.accounts', {
        url: '/accounts',
        views: {
            '': 'userSharedAccounts',
            'header@user': 'userSharedAccountsHeader'
        },
        resolve: { applications: applications, sharedAccounts: sharedAccounts, companies: companies, allAccounts: allAccounts }
    });
}

/** @ngInject */
function applications(ApplicationService) {
    return ApplicationService.findAll().$promise.then(function (items) {
        return items.map(function (account) {
            return _extends({}, account, { objType: 'APPLICATION' });
        });
    });
}

/** @ngInject */
function sharedAccounts($filter, UsersSharedAccountService) {
    return UsersSharedAccountService.usersCompanySharedAccounts.query().$promise.then(function (items) {
        return $filter('orderBy')(items, 'publicService.serviceName');
    }).then(function (items) {
        return items.map(function (account) {
            return _extends({}, account, { applicationName: serviceDisplayName(account) });
        });
    }).then(function (items) {
        return items.map(function (account) {
            return _extends({}, account, { objType: 'SHARED_ACCOUNT' });
        });
    }).then(function (items) {
        return items.map(function (account) {
            return _extends({}, account, { companyName: account.company.companyName });
        });
    }).then(function (items) {
        return items.map(function (account) {
            return _extends({}, account, { status: 'ACTIVE' });
        });
    });
}

/** @ngInject */
function allAccounts(applications, sharedAccounts) {
    return [].concat(_toConsumableArray(applications), _toConsumableArray(sharedAccounts));
}

function serviceDisplayName(account) {
    var displayName = '';
    if (account.publicService.slug != 'other' || !account.customServiceName) {
        displayName = account.publicService.serviceName;
    } else if (account.publicService.slug == 'other') {
        displayName = account.customServiceName;
    }
    return displayName;
}

/** @ngInject */
function companies(UsersSharedAccountService) {
    var coms = UsersSharedAccountService.usersCompanySharedAccounts.getCompaniesToShareWith().$promise;
    return coms;
}

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

var _usersSharedNotes = __webpack_require__(718);

_app.app.component('userSharedNotes', {
    bindings: { sharedNotes: '<' },
    controller: _usersSharedNotes.Controller,
    templateUrl: __webpack_require__(2592)
});

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8cc2b4efa63c480d643a894537d4d3ff.html";

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

sharedNotes.$inject = ['UsersSharedAccountService'];
config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.shared-accounts.notes', {
        url: '/notes',
        views: {
            '': 'userSharedNotes',
            'header@user': 'userSharedAccountsHeader'
        },
        resolve: { sharedNotes: sharedNotes }
    });
}

/** @ngInject */
function sharedNotes(UsersSharedAccountService) {
    return UsersSharedAccountService.usersSharedNotes.getUsersSharedNotes().$promise;
}

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('userShared', {
    templateUrl: __webpack_require__(2595)
});

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "56ea20387a5f3d0bbaf8d6123e3d0f08.html";

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

config.$inject = ['$stateProvider'];


_app.app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.shared-accounts', {
        url: '/shared',
        views: {
            '': 'userShared',
            'header@user': 'userSharedAccountsHeader'
        }

    });
}

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(0);

_app.app.component('youAreNotCompanyAdmin', {
    bindings: { close: '&', dismiss: '&', resolve: '<' },
    templateUrl: __webpack_require__(2598)
});

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a1e7f883db7a0784dc1fb0dfb1a2e51e.html";

/***/ }),
/* 2599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[721]);


// WEBPACK FOOTER //
// portal-d37d924269f5c961396c.js